/**
 * Full Taiwan Market Universe Dataset (1,826 Stocks)
 * As of Trading Date: 2026-10-15
 * Generated deterministically matching fct_market_breadth_daily and fct_daily_scanner contract.
 * Covers all 32 official TWSE / TPEx industry sectors with 100% phase distribution parity.
 */

import type { ScannerRecord } from '../types';

export const FULL_UNIVERSE_STOCKS: ScannerRecord[] = [
  {
    "symbol": "2330.TW",
    "name": "台積電",
    "sector": "半導體業",
    "close": 2440.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.67,
    "dog_ma200_bias": 0.139,
    "vr60": 1.3,
    "rs20": 1.03,
    "rs60": 1.01,
    "shares": 314,
    "lots": 0,
    "odd_shares": 314,
    "ntd_at_risk": 39903.12,
    "position_cost": 766160.0,
    "constraint": "WEIGHT",
    "atr14": 63.54,
    "low_20d": 2317.3,
    "ladder_minus1_pullback": 2293.6,
    "ladder_4_base": 2196.0,
    "ladder_5_euphoria": 3172.0
  },
  {
    "symbol": "2454.TW",
    "name": "聯發科",
    "sector": "半導體業",
    "close": 4165.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.13,
    "dog_ma200_bias": 0.35,
    "vr60": 1.02,
    "rs20": 0.91,
    "rs60": 0.89,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 82.32,
    "low_20d": 3988.6,
    "ladder_minus1_pullback": 3915.1,
    "ladder_4_base": 3748.5,
    "ladder_5_euphoria": 5414.5
  },
  {
    "symbol": "2317.TW",
    "name": "鴻海",
    "sector": "電腦及週邊設備業",
    "close": 239.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.75,
    "dog_ma200_bias": 0.006,
    "vr60": 1.02,
    "rs20": 0.96,
    "rs60": 0.94,
    "shares": 2557,
    "lots": 2,
    "odd_shares": 557,
    "ntd_at_risk": 39991.48,
    "position_cost": 612401.5,
    "constraint": "WEIGHT",
    "atr14": 7.82,
    "low_20d": 216.6,
    "ladder_minus1_pullback": 225.1,
    "ladder_4_base": 215.6,
    "ladder_5_euphoria": 311.4
  },
  {
    "symbol": "2308.TW",
    "name": "台達電",
    "sector": "電子零組件業",
    "close": 1630.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.22,
    "dog_ma200_bias": -0.035,
    "vr60": 1.01,
    "rs20": 1.01,
    "rs60": 0.99,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 50.22,
    "low_20d": 1502.0,
    "ladder_minus1_pullback": 1532.2,
    "ladder_4_base": 1467.0,
    "ladder_5_euphoria": 2119.0
  },
  {
    "symbol": "2382.TW",
    "name": "廣達",
    "sector": "電腦及週邊設備業",
    "close": 316.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.43,
    "dog_ma200_bias": -0.005,
    "vr60": 0.73,
    "rs20": 0.95,
    "rs60": 0.93,
    "shares": 2008,
    "lots": 2,
    "odd_shares": 8,
    "ntd_at_risk": 39999.36,
    "position_cost": 635532.0,
    "constraint": "WEIGHT",
    "atr14": 9.96,
    "low_20d": 293.7,
    "ladder_minus1_pullback": 297.5,
    "ladder_4_base": 284.9,
    "ladder_5_euphoria": 411.4
  },
  {
    "symbol": "3231.TW",
    "name": "緯創",
    "sector": "電腦及週邊設備業",
    "close": 176.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.23,
    "dog_ma200_bias": 0.137,
    "vr60": 0.66,
    "rs20": 0.97,
    "rs60": 0.95,
    "shares": 5181,
    "lots": 5,
    "odd_shares": 181,
    "ntd_at_risk": 39997.32,
    "position_cost": 911856.0,
    "constraint": "WEIGHT",
    "atr14": 3.86,
    "low_20d": 162.6,
    "ladder_minus1_pullback": 165.4,
    "ladder_4_base": 158.4,
    "ladder_5_euphoria": 228.8
  },
  {
    "symbol": "2881.TW",
    "name": "富邦金",
    "sector": "金融保險業",
    "close": 159.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.71,
    "dog_ma200_bias": 0.413,
    "vr60": 1.1,
    "rs20": 1.04,
    "rs60": 1.02,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.66,
    "low_20d": 146.4,
    "ladder_minus1_pullback": 149.9,
    "ladder_4_base": 143.6,
    "ladder_5_euphoria": 207.3
  },
  {
    "symbol": "2882.TW",
    "name": "國泰金",
    "sector": "金融保險業",
    "close": 113.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.5,
    "dog_ma200_bias": 0.278,
    "vr60": 0.94,
    "rs20": 1.01,
    "rs60": 0.99,
    "shares": 5988,
    "lots": 5,
    "odd_shares": 988,
    "ntd_at_risk": 39999.84,
    "position_cost": 679638.0,
    "constraint": "WEIGHT",
    "atr14": 3.34,
    "low_20d": 106.2,
    "ladder_minus1_pullback": 106.7,
    "ladder_4_base": 102.2,
    "ladder_5_euphoria": 147.6
  },
  {
    "symbol": "2603.TW",
    "name": "長榮",
    "sector": "航運業",
    "close": 257.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.38,
    "dog_ma200_bias": 0.227,
    "vr60": 2.2,
    "rs20": 1.08,
    "rs60": 1.06,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.52,
    "low_20d": 245.8,
    "ladder_minus1_pullback": 241.6,
    "ladder_4_base": 231.3,
    "ladder_5_euphoria": 334.1
  },
  {
    "symbol": "2609.TW",
    "name": "陽明",
    "sector": "航運業",
    "close": 63.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.13,
    "dog_ma200_bias": 0.166,
    "vr60": 1.22,
    "rs20": 1.07,
    "rs60": 1.05,
    "shares": 10050,
    "lots": 10,
    "odd_shares": 50,
    "ntd_at_risk": 39999.0,
    "position_cost": 636165.0,
    "constraint": "WEIGHT",
    "atr14": 1.99,
    "low_20d": 59.9,
    "ladder_minus1_pullback": 59.5,
    "ladder_4_base": 57.0,
    "ladder_5_euphoria": 82.3
  },
  {
    "symbol": "2615.TW",
    "name": "萬海",
    "sector": "航運業",
    "close": 119.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.1,
    "dog_ma200_bias": 0.375,
    "vr60": 1.23,
    "rs20": 1.05,
    "rs60": 1.03,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.21,
    "low_20d": 107.3,
    "ladder_minus1_pullback": 111.9,
    "ladder_4_base": 107.1,
    "ladder_5_euphoria": 154.7
  },
  {
    "symbol": "2002.TW",
    "name": "中鋼",
    "sector": "鋼鐵工業",
    "close": 19.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.17,
    "dog_ma200_bias": 0.004,
    "vr60": 1.44,
    "rs20": 1.02,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 481250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.6,
    "ladder_minus1_pullback": 18.1,
    "ladder_4_base": 17.3,
    "ladder_5_euphoria": 25.0
  },
  {
    "symbol": "1301.TW",
    "name": "台塑",
    "sector": "塑膠工業",
    "close": 81.7,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.16,
    "dog_ma200_bias": 0.548,
    "vr60": 3.76,
    "rs20": 1.3,
    "rs60": 1.27,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.4,
    "low_20d": 74.8,
    "ladder_minus1_pullback": 76.8,
    "ladder_4_base": 73.5,
    "ladder_5_euphoria": 106.2
  },
  {
    "symbol": "1303.TW",
    "name": "南亞",
    "sector": "塑膠工業",
    "close": 314.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.05,
    "dog_ma200_bias": 1.345,
    "vr60": 1.19,
    "rs20": 1.34,
    "rs60": 1.31,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 8.83,
    "low_20d": 285.5,
    "ladder_minus1_pullback": 295.6,
    "ladder_4_base": 283.1,
    "ladder_5_euphoria": 408.9
  },
  {
    "symbol": "2412.TW",
    "name": "中華電",
    "sector": "通信網路業",
    "close": 152.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.7,
    "dog_ma200_bias": 0.109,
    "vr60": 1.07,
    "rs20": 1.07,
    "rs60": 1.05,
    "shares": 5037,
    "lots": 5,
    "odd_shares": 37,
    "ntd_at_risk": 39993.78,
    "position_cost": 768142.5,
    "constraint": "WEIGHT",
    "atr14": 3.97,
    "low_20d": 138.9,
    "ladder_minus1_pullback": 143.3,
    "ladder_4_base": 137.2,
    "ladder_5_euphoria": 198.2
  },
  {
    "symbol": "3008.TW",
    "name": "大立光",
    "sector": "光電業",
    "close": 6605.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.34,
    "dog_ma200_bias": 0.74,
    "vr60": 1.66,
    "rs20": 1.1,
    "rs60": 1.08,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 134.58,
    "low_20d": 6110.3,
    "ladder_minus1_pullback": 6208.7,
    "ladder_4_base": 5944.5,
    "ladder_5_euphoria": 8586.5
  },
  {
    "symbol": "2357.TW",
    "name": "華碩",
    "sector": "電腦及週邊設備業",
    "close": 975.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.47,
    "dog_ma200_bias": 0.382,
    "vr60": 0.71,
    "rs20": 1.04,
    "rs60": 1.02,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 29.31,
    "low_20d": 926.9,
    "ladder_minus1_pullback": 916.5,
    "ladder_4_base": 877.5,
    "ladder_5_euphoria": 1267.5
  },
  {
    "symbol": "2379.TW",
    "name": "瑞昱",
    "sector": "半導體業",
    "close": 764.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.21,
    "dog_ma200_bias": 0.238,
    "vr60": 0.73,
    "rs20": 1.07,
    "rs60": 1.05,
    "shares": 886,
    "lots": 0,
    "odd_shares": 886,
    "ntd_at_risk": 39976.32,
    "position_cost": 676904.0,
    "constraint": "WEIGHT",
    "atr14": 22.56,
    "low_20d": 716.5,
    "ladder_minus1_pullback": 718.2,
    "ladder_4_base": 687.6,
    "ladder_5_euphoria": 993.2
  },
  {
    "symbol": "3711.TW",
    "name": "日月光投控",
    "sector": "半導體業",
    "close": 673.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.05,
    "dog_ma200_bias": 0.355,
    "vr60": 1.06,
    "rs20": 1.1,
    "rs60": 1.08,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 11.36,
    "low_20d": 638.8,
    "ladder_minus1_pullback": 632.6,
    "ladder_4_base": 605.7,
    "ladder_5_euphoria": 874.9
  },
  {
    "symbol": "6505.TW",
    "name": "台塑化",
    "sector": "油電燃氣業",
    "close": 111.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.28,
    "dog_ma200_bias": 0.785,
    "vr60": 1.99,
    "rs20": 1.35,
    "rs60": 1.32,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.6,
    "low_20d": 105.8,
    "ladder_minus1_pullback": 104.8,
    "ladder_4_base": 100.4,
    "ladder_5_euphoria": 145.0
  },
  {
    "symbol": "2884.TW",
    "name": "玉山金",
    "sector": "金融保險業",
    "close": 48.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.63,
    "dog_ma200_bias": 0.368,
    "vr60": 0.81,
    "rs20": 1.05,
    "rs60": 1.03,
    "shares": 13888,
    "lots": 13,
    "odd_shares": 888,
    "ntd_at_risk": 39997.44,
    "position_cost": 677734.4,
    "constraint": "WEIGHT",
    "atr14": 1.44,
    "low_20d": 45.0,
    "ladder_minus1_pullback": 45.9,
    "ladder_4_base": 43.9,
    "ladder_5_euphoria": 63.4
  },
  {
    "symbol": "2886.TW",
    "name": "兆豐金",
    "sector": "金融保險業",
    "close": 52.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.95,
    "dog_ma200_bias": 0.206,
    "vr60": 0.89,
    "rs20": 1.0,
    "rs60": 0.98,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 1093732.5,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 49.8,
    "ladder_minus1_pullback": 49.3,
    "ladder_4_base": 47.2,
    "ladder_5_euphoria": 68.2
  },
  {
    "symbol": "2891.TW",
    "name": "中信金",
    "sector": "金融保險業",
    "close": 72.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.76,
    "dog_ma200_bias": 0.225,
    "vr60": 1.39,
    "rs20": 1.07,
    "rs60": 1.05,
    "shares": 10101,
    "lots": 10,
    "odd_shares": 101,
    "ntd_at_risk": 39999.96,
    "position_cost": 736362.9,
    "constraint": "WEIGHT",
    "atr14": 1.98,
    "low_20d": 69.7,
    "ladder_minus1_pullback": 68.5,
    "ladder_4_base": 65.6,
    "ladder_5_euphoria": 94.8
  },
  {
    "symbol": "5880.TW",
    "name": "合庫金",
    "sector": "金融保險業",
    "close": 27.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.9,
    "dog_ma200_bias": 0.144,
    "vr60": 1.01,
    "rs20": 1.0,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 687500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.9,
    "ladder_minus1_pullback": 25.8,
    "ladder_4_base": 24.8,
    "ladder_5_euphoria": 35.8
  },
  {
    "symbol": "1101.TW",
    "name": "台泥",
    "sector": "水泥工業",
    "close": 26.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.44,
    "dog_ma200_bias": 0.095,
    "vr60": 1.6,
    "rs20": 1.12,
    "rs60": 1.1,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 670000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.9,
    "ladder_minus1_pullback": 25.2,
    "ladder_4_base": 24.1,
    "ladder_5_euphoria": 34.8
  },
  {
    "symbol": "1102.TW",
    "name": "亞泥",
    "sector": "水泥工業",
    "close": 37.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.81,
    "dog_ma200_bias": 0.08,
    "vr60": 0.95,
    "rs20": 1.08,
    "rs60": 1.06,
    "shares": 16949,
    "lots": 16,
    "odd_shares": 949,
    "ntd_at_risk": 39999.64,
    "position_cost": 641519.65,
    "constraint": "WEIGHT",
    "atr14": 1.18,
    "low_20d": 35.0,
    "ladder_minus1_pullback": 35.6,
    "ladder_4_base": 34.1,
    "ladder_5_euphoria": 49.2
  },
  {
    "symbol": "1216.TW",
    "name": "統一",
    "sector": "食品工業",
    "close": 79.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.68,
    "dog_ma200_bias": 0.068,
    "vr60": 1.32,
    "rs20": 1.07,
    "rs60": 1.05,
    "shares": 16260,
    "lots": 16,
    "odd_shares": 260,
    "ntd_at_risk": 39999.6,
    "position_cost": 1292670.0,
    "constraint": "WEIGHT",
    "atr14": 1.23,
    "low_20d": 72.4,
    "ladder_minus1_pullback": 74.7,
    "ladder_4_base": 71.5,
    "ladder_5_euphoria": 103.4
  },
  {
    "symbol": "2207.TW",
    "name": "和泰車",
    "sector": "汽車工業",
    "close": 546.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.77,
    "dog_ma200_bias": 0.07,
    "vr60": 0.88,
    "rs20": 1.01,
    "rs60": 0.99,
    "shares": 1313,
    "lots": 1,
    "odd_shares": 313,
    "ntd_at_risk": 39993.98,
    "position_cost": 716898.0,
    "constraint": "WEIGHT",
    "atr14": 15.23,
    "low_20d": 522.7,
    "ladder_minus1_pullback": 513.2,
    "ladder_4_base": 491.4,
    "ladder_5_euphoria": 709.8
  },
  {
    "symbol": "2912.TW",
    "name": "統一超",
    "sector": "貿易百貨業",
    "close": 224.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.83,
    "dog_ma200_bias": 0.004,
    "vr60": 1.3,
    "rs20": 1.03,
    "rs60": 1.01,
    "shares": 5361,
    "lots": 5,
    "odd_shares": 361,
    "ntd_at_risk": 39993.06,
    "position_cost": 1200864.0,
    "constraint": "WEIGHT",
    "atr14": 3.73,
    "low_20d": 213.1,
    "ladder_minus1_pullback": 210.6,
    "ladder_4_base": 201.6,
    "ladder_5_euphoria": 291.2
  },
  {
    "symbol": "9910.TW",
    "name": "豐泰",
    "sector": "運動休閒",
    "close": 68.1,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.7,
    "dog_ma200_bias": -0.149,
    "vr60": 0.87,
    "rs20": 1.0,
    "rs60": 0.98,
    "shares": 9615,
    "lots": 9,
    "odd_shares": 615,
    "ntd_at_risk": 19999.2,
    "position_cost": 654781.5,
    "constraint": "WEIGHT",
    "atr14": 1.04,
    "low_20d": 61.4,
    "ladder_minus1_pullback": 64.0,
    "ladder_4_base": 61.3,
    "ladder_5_euphoria": 88.5
  },
  {
    "symbol": "1402.TW",
    "name": "遠東新",
    "sector": "紡織纖維業",
    "close": 29.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.5,
    "dog_ma200_bias": 0.065,
    "vr60": 0.86,
    "rs20": 1.05,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 735000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.9,
    "ladder_minus1_pullback": 27.6,
    "ladder_4_base": 26.5,
    "ladder_5_euphoria": 38.2
  },
  {
    "symbol": "1707.TW",
    "name": "葡萄王",
    "sector": "生技醫療業",
    "close": 87.7,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.71,
    "dog_ma200_bias": -0.173,
    "vr60": 0.53,
    "rs20": 1.01,
    "rs60": 0.99,
    "shares": 3906,
    "lots": 3,
    "odd_shares": 906,
    "ntd_at_risk": 19998.72,
    "position_cost": 342556.2,
    "constraint": "WEIGHT",
    "atr14": 2.56,
    "low_20d": 83.1,
    "ladder_minus1_pullback": 82.4,
    "ladder_4_base": 78.9,
    "ladder_5_euphoria": 114.0
  },
  {
    "symbol": "6415.TW",
    "name": "矽力*-KY",
    "sector": "半導體業",
    "close": 466.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.43,
    "dog_ma200_bias": 0.184,
    "vr60": 1.56,
    "rs20": 1.13,
    "rs60": 1.11,
    "shares": 1632,
    "lots": 1,
    "odd_shares": 632,
    "ntd_at_risk": 39984.0,
    "position_cost": 761328.0,
    "constraint": "WEIGHT",
    "atr14": 12.25,
    "low_20d": 435.4,
    "ladder_minus1_pullback": 438.5,
    "ladder_4_base": 419.9,
    "ladder_5_euphoria": 606.5
  },
  {
    "symbol": "3037.TW",
    "name": "欣興",
    "sector": "電子零組件業",
    "close": 1075.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.11,
    "dog_ma200_bias": 0.438,
    "vr60": 0.75,
    "rs20": 1.11,
    "rs60": 1.09,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 23.26,
    "low_20d": 1022.0,
    "ladder_minus1_pullback": 1010.5,
    "ladder_4_base": 967.5,
    "ladder_5_euphoria": 1397.5
  },
  {
    "symbol": "2376.TW",
    "name": "技嘉",
    "sector": "電腦及週邊設備業",
    "close": 347.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.26,
    "dog_ma200_bias": 0.153,
    "vr60": 0.65,
    "rs20": 1.01,
    "rs60": 0.99,
    "shares": 1998,
    "lots": 1,
    "odd_shares": 998,
    "ntd_at_risk": 39999.96,
    "position_cost": 693306.0,
    "constraint": "WEIGHT",
    "atr14": 10.01,
    "low_20d": 320.1,
    "ladder_minus1_pullback": 326.2,
    "ladder_4_base": 312.3,
    "ladder_5_euphoria": 451.1
  },
  {
    "symbol": "2345.TW",
    "name": "智邦",
    "sector": "通信網路業",
    "close": 1950.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.42,
    "dog_ma200_bias": 0.017,
    "vr60": 1.33,
    "rs20": 1.04,
    "rs60": 1.02,
    "shares": 325,
    "lots": 0,
    "odd_shares": 325,
    "ntd_at_risk": 39923.0,
    "position_cost": 633750.0,
    "constraint": "WEIGHT",
    "atr14": 61.42,
    "low_20d": 1860.0,
    "ladder_minus1_pullback": 1833.0,
    "ladder_4_base": 1755.0,
    "ladder_5_euphoria": 2535.0
  },
  {
    "symbol": "6669.TW",
    "name": "緯穎",
    "sector": "電腦及週邊設備業",
    "close": 1905.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.1,
    "dog_ma200_bias": 0.138,
    "vr60": 0.96,
    "rs20": 0.84,
    "rs60": 0.82,
    "shares": 416,
    "lots": 0,
    "odd_shares": 416,
    "ntd_at_risk": 39985.92,
    "position_cost": 792480.0,
    "constraint": "WEIGHT",
    "atr14": 48.06,
    "low_20d": 1733.2,
    "ladder_minus1_pullback": 1790.7,
    "ladder_4_base": 1714.5,
    "ladder_5_euphoria": 2476.5
  },
  {
    "symbol": "3661.TW",
    "name": "世芯-KY",
    "sector": "半導體業",
    "close": 3705.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.22,
    "dog_ma200_bias": -0.011,
    "vr60": 1.51,
    "rs20": 1.03,
    "rs60": 1.01,
    "shares": 162,
    "lots": 0,
    "odd_shares": 162,
    "ntd_at_risk": 39907.08,
    "position_cost": 600210.0,
    "constraint": "WEIGHT",
    "atr14": 123.17,
    "low_20d": 3551.5,
    "ladder_minus1_pullback": 3482.7,
    "ladder_4_base": 3334.5,
    "ladder_5_euphoria": 4816.5
  },
  {
    "symbol": "3443.TW",
    "name": "創意",
    "sector": "半導體業",
    "close": 7670.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.19,
    "dog_ma200_bias": 0.824,
    "vr60": 0.81,
    "rs20": 1.2,
    "rs60": 1.18,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 137.66,
    "low_20d": 7061.6,
    "ladder_minus1_pullback": 7209.8,
    "ladder_4_base": 6903.0,
    "ladder_5_euphoria": 9971.0
  },
  {
    "symbol": "5274.TWO",
    "name": "信驊",
    "sector": "半導體業",
    "close": 15945.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.26,
    "dog_ma200_bias": 0.197,
    "vr60": 1.74,
    "rs20": 0.89,
    "rs60": 0.87,
    "shares": 38,
    "lots": 0,
    "odd_shares": 38,
    "ntd_at_risk": 39480.48,
    "position_cost": 605910.0,
    "constraint": "WEIGHT",
    "atr14": 519.48,
    "low_20d": 14939.1,
    "ladder_minus1_pullback": 14988.3,
    "ladder_4_base": 14350.5,
    "ladder_5_euphoria": 20728.5
  },
  {
    "symbol": "8069.TWO",
    "name": "元太",
    "sector": "光電業",
    "close": 146.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.08,
    "dog_ma200_bias": -0.16,
    "vr60": 0.9,
    "rs20": 1.01,
    "rs60": 0.99,
    "shares": 2169,
    "lots": 2,
    "odd_shares": 169,
    "ntd_at_risk": 19998.18,
    "position_cost": 317758.5,
    "constraint": "WEIGHT",
    "atr14": 4.61,
    "low_20d": 139.7,
    "ladder_minus1_pullback": 137.7,
    "ladder_4_base": 131.8,
    "ladder_5_euphoria": 190.5
  },
  {
    "symbol": "3293.TWO",
    "name": "鈊象",
    "sector": "數位雲端",
    "close": 811.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.65,
    "dog_ma200_bias": 0.094,
    "vr60": 0.84,
    "rs20": 1.16,
    "rs60": 1.14,
    "shares": 1433,
    "lots": 1,
    "odd_shares": 433,
    "ntd_at_risk": 39980.7,
    "position_cost": 1162163.0,
    "constraint": "WEIGHT",
    "atr14": 13.95,
    "low_20d": 773.6,
    "ladder_minus1_pullback": 762.3,
    "ladder_4_base": 729.9,
    "ladder_5_euphoria": 1054.3
  },
  {
    "symbol": "6488.TWO",
    "name": "環球晶",
    "sector": "半導體業",
    "close": 923.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.08,
    "dog_ma200_bias": 0.22,
    "vr60": 1.27,
    "rs20": 1.03,
    "rs60": 1.01,
    "shares": 978,
    "lots": 0,
    "odd_shares": 978,
    "ntd_at_risk": 39980.64,
    "position_cost": 902694.0,
    "constraint": "WEIGHT",
    "atr14": 20.44,
    "low_20d": 852.0,
    "ladder_minus1_pullback": 867.6,
    "ladder_4_base": 830.7,
    "ladder_5_euphoria": 1199.9
  },
  {
    "symbol": "5483.TWO",
    "name": "中美晶",
    "sector": "半導體業",
    "close": 195.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.08,
    "dog_ma200_bias": 0.272,
    "vr60": 0.54,
    "rs20": 1.11,
    "rs60": 1.09,
    "shares": 3058,
    "lots": 3,
    "odd_shares": 58,
    "ntd_at_risk": 39998.64,
    "position_cost": 597839.0,
    "constraint": "WEIGHT",
    "atr14": 6.54,
    "low_20d": 176.9,
    "ladder_minus1_pullback": 183.8,
    "ladder_4_base": 176.0,
    "ladder_5_euphoria": 254.2
  },
  {
    "symbol": "6446.TWO",
    "name": "藥華藥",
    "sector": "生技醫療業",
    "close": 1205.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.85,
    "dog_ma200_bias": 0.379,
    "vr60": 0.48,
    "rs20": 1.05,
    "rs60": 1.03,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 32.64,
    "low_20d": 1143.9,
    "ladder_minus1_pullback": 1132.7,
    "ladder_4_base": 1084.5,
    "ladder_5_euphoria": 1566.5
  },
  {
    "symbol": "1795.TW",
    "name": "美時",
    "sector": "生技醫療業",
    "close": 180.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.25,
    "dog_ma200_bias": -0.191,
    "vr60": 0.89,
    "rs20": 1.04,
    "rs60": 1.02,
    "shares": 2057,
    "lots": 2,
    "odd_shares": 57,
    "ntd_at_risk": 19994.04,
    "position_cost": 370260.0,
    "constraint": "WEIGHT",
    "atr14": 4.86,
    "low_20d": 165.5,
    "ladder_minus1_pullback": 169.2,
    "ladder_4_base": 162.0,
    "ladder_5_euphoria": 234.0
  },
  {
    "symbol": "2059.TW",
    "name": "川湖",
    "sector": "電機機械業",
    "close": 9720.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.52,
    "dog_ma200_bias": 0.455,
    "vr60": 1.77,
    "rs20": 0.81,
    "rs60": 0.79,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 275.52,
    "low_20d": 9155.3,
    "ladder_minus1_pullback": 9136.8,
    "ladder_4_base": 8748.0,
    "ladder_5_euphoria": 12636.0
  },
  {
    "symbol": "3034.TW",
    "name": "聯詠",
    "sector": "半導體業",
    "close": 565.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.91,
    "dog_ma200_bias": 0.228,
    "vr60": 1.02,
    "rs20": 1.02,
    "rs60": 1.0,
    "shares": 1611,
    "lots": 1,
    "odd_shares": 611,
    "ntd_at_risk": 39985.02,
    "position_cost": 910215.0,
    "constraint": "WEIGHT",
    "atr14": 12.41,
    "low_20d": 538.9,
    "ladder_minus1_pullback": 531.1,
    "ladder_4_base": 508.5,
    "ladder_5_euphoria": 734.5
  },
  {
    "symbol": "2303.TW",
    "name": "聯電",
    "sector": "半導體業",
    "close": 133.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.22,
    "dog_ma200_bias": 0.298,
    "vr60": 0.73,
    "rs20": 0.94,
    "rs60": 0.92,
    "shares": 5305,
    "lots": 5,
    "odd_shares": 305,
    "ntd_at_risk": 39999.7,
    "position_cost": 708217.5,
    "constraint": "WEIGHT",
    "atr14": 3.77,
    "low_20d": 120.7,
    "ladder_minus1_pullback": 125.5,
    "ladder_4_base": 120.2,
    "ladder_5_euphoria": 173.6
  },
  {
    "symbol": "2409.TW",
    "name": "友達",
    "sector": "光電業",
    "close": 34.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.05,
    "dog_ma200_bias": 0.052,
    "vr60": 1.79,
    "rs20": 1.11,
    "rs60": 1.01,
    "shares": 19607,
    "lots": 19,
    "odd_shares": 607,
    "ntd_at_risk": 39998.28,
    "position_cost": 684284.3,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 33.3,
    "ladder_minus1_pullback": 32.8,
    "ladder_4_base": 31.4,
    "ladder_5_euphoria": 45.4
  },
  {
    "symbol": "6770.TW",
    "name": "力積電",
    "sector": "半導體業",
    "close": 66.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.09,
    "dog_ma200_bias": 0.013,
    "vr60": 1.72,
    "rs20": 0.81,
    "rs60": 0.82,
    "shares": 8968,
    "lots": 8,
    "odd_shares": 968,
    "ntd_at_risk": 39997.28,
    "position_cost": 593681.6,
    "constraint": "WEIGHT",
    "atr14": 2.23,
    "low_20d": 63.0,
    "ladder_minus1_pullback": 62.2,
    "ladder_4_base": 59.6,
    "ladder_5_euphoria": 86.1
  },
  {
    "symbol": "3481.TW",
    "name": "群創",
    "sector": "光電業",
    "close": 48.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.05,
    "dog_ma200_bias": 0.077,
    "vr60": 1.83,
    "rs20": 0.91,
    "rs60": 0.91,
    "shares": 19417,
    "lots": 19,
    "odd_shares": 417,
    "ntd_at_risk": 39999.02,
    "position_cost": 937841.1,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 45.2,
    "ladder_minus1_pullback": 45.4,
    "ladder_4_base": 43.5,
    "ladder_5_euphoria": 62.8
  },
  {
    "symbol": "8039.TW",
    "name": "台虹",
    "sector": "電子零組件業",
    "close": 283.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.05,
    "dog_ma200_bias": 0.014,
    "vr60": 1.58,
    "rs20": 0.53,
    "rs60": 0.73,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 8.71,
    "low_20d": 264.0,
    "ladder_minus1_pullback": 266.5,
    "ladder_4_base": 255.2,
    "ladder_5_euphoria": 368.6
  },
  {
    "symbol": "1312.TW",
    "name": "國喬",
    "sector": "塑膠工業",
    "close": 17.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.05,
    "dog_ma200_bias": 0.047,
    "vr60": 1.95,
    "rs20": 1.05,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 426250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.4,
    "ladder_minus1_pullback": 16.0,
    "ladder_4_base": 15.3,
    "ladder_5_euphoria": 22.2
  },
  {
    "symbol": "1326.TW",
    "name": "台化",
    "sector": "塑膠工業",
    "close": 77.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.05,
    "dog_ma200_bias": 0.123,
    "vr60": 1.44,
    "rs20": 1.12,
    "rs60": 1.04,
    "shares": 15503,
    "lots": 15,
    "odd_shares": 503,
    "ntd_at_risk": 39997.74,
    "position_cost": 1193731.0,
    "constraint": "WEIGHT",
    "atr14": 1.29,
    "low_20d": 69.3,
    "ladder_minus1_pullback": 72.4,
    "ladder_4_base": 69.3,
    "ladder_5_euphoria": 100.1
  },
  {
    "symbol": "1802.TW",
    "name": "台玻",
    "sector": "玻璃陶瓷業",
    "close": 62.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.23,
    "dog_ma200_bias": 0.016,
    "vr60": 1.36,
    "rs20": 0.84,
    "rs60": 1.03,
    "shares": 14084,
    "lots": 14,
    "odd_shares": 84,
    "ntd_at_risk": 39998.56,
    "position_cost": 883066.8,
    "constraint": "WEIGHT",
    "atr14": 1.42,
    "low_20d": 59.0,
    "ladder_minus1_pullback": 58.9,
    "ladder_4_base": 56.4,
    "ladder_5_euphoria": 81.5
  },
  {
    "symbol": "2344.TW",
    "name": "華邦電",
    "sector": "半導體業",
    "close": 155.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.33,
    "dog_ma200_bias": 0.029,
    "vr60": 1.4,
    "rs20": 0.81,
    "rs60": 0.73,
    "shares": 4474,
    "lots": 4,
    "odd_shares": 474,
    "ntd_at_risk": 39997.56,
    "position_cost": 693470.0,
    "constraint": "WEIGHT",
    "atr14": 4.47,
    "low_20d": 145.0,
    "ladder_minus1_pullback": 145.7,
    "ladder_4_base": 139.5,
    "ladder_5_euphoria": 201.5
  },
  {
    "symbol": "2408.TW",
    "name": "南亞科",
    "sector": "半導體業",
    "close": 439.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.29,
    "dog_ma200_bias": 0.064,
    "vr60": 1.29,
    "rs20": 1.06,
    "rs60": 0.99,
    "shares": 2100,
    "lots": 2,
    "odd_shares": 100,
    "ntd_at_risk": 39984.0,
    "position_cost": 922950.0,
    "constraint": "WEIGHT",
    "atr14": 9.52,
    "low_20d": 400.8,
    "ladder_minus1_pullback": 413.1,
    "ladder_4_base": 395.6,
    "ladder_5_euphoria": 571.4
  },
  {
    "symbol": "2887.TW",
    "name": "台新新光金",
    "sector": "金融保險業",
    "close": 41.6,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.4,
    "dog_ma200_bias": 0.357,
    "vr60": 1.64,
    "rs20": 1.27,
    "rs60": 1.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.83,
    "low_20d": 38.9,
    "ladder_minus1_pullback": 39.1,
    "ladder_4_base": 37.4,
    "ladder_5_euphoria": 54.1
  },
  {
    "symbol": "1605.TW",
    "name": "華新",
    "sector": "電器電纜業",
    "close": 37.7,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.18,
    "dog_ma200_bias": -0.147,
    "vr60": 0.66,
    "rs20": 0.59,
    "rs60": 0.62,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.97,
    "low_20d": 35.0,
    "ladder_minus1_pullback": 35.4,
    "ladder_4_base": 33.9,
    "ladder_5_euphoria": 49.0
  },
  {
    "symbol": "2890.TW",
    "name": "永豐金",
    "sector": "金融保險業",
    "close": 45.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.86,
    "dog_ma200_bias": 0.061,
    "vr60": 1.35,
    "rs20": 0.93,
    "rs60": 0.84,
    "shares": 19417,
    "lots": 19,
    "odd_shares": 417,
    "ntd_at_risk": 39999.02,
    "position_cost": 885415.2,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 42.2,
    "ladder_minus1_pullback": 42.9,
    "ladder_4_base": 41.0,
    "ladder_5_euphoria": 59.3
  },
  {
    "symbol": "1815.TWO",
    "name": "富喬",
    "sector": "電子零組件業",
    "close": 127.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.33,
    "dog_ma200_bias": 0.048,
    "vr60": 1.41,
    "rs20": 0.93,
    "rs60": 0.8,
    "shares": 5899,
    "lots": 5,
    "odd_shares": 899,
    "ntd_at_risk": 39995.22,
    "position_cost": 752122.5,
    "constraint": "WEIGHT",
    "atr14": 3.39,
    "low_20d": 117.1,
    "ladder_minus1_pullback": 119.8,
    "ladder_4_base": 114.8,
    "ladder_5_euphoria": 165.8
  },
  {
    "symbol": "6278.TW",
    "name": "台表科",
    "sector": "光電業",
    "close": 303.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.78,
    "dog_ma200_bias": -0.095,
    "vr60": 0.76,
    "rs20": 0.49,
    "rs60": 0.46,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 8.81,
    "low_20d": 286.6,
    "ladder_minus1_pullback": 284.8,
    "ladder_4_base": 272.7,
    "ladder_5_euphoria": 393.9
  },
  {
    "symbol": "1314.TW",
    "name": "中石化",
    "sector": "塑膠工業",
    "close": 8.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": 0.061,
    "vr60": 1.62,
    "rs20": 1.08,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 221250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.5,
    "ladder_minus1_pullback": 8.3,
    "ladder_4_base": 8.0,
    "ladder_5_euphoria": 11.5
  },
  {
    "symbol": "2327.TW",
    "name": "國巨*",
    "sector": "電子零組件業",
    "close": 573.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.13,
    "dog_ma200_bias": -0.11,
    "vr60": 1.09,
    "rs20": 0.38,
    "rs60": 0.28,
    "shares": 510,
    "lots": 0,
    "odd_shares": 510,
    "ntd_at_risk": 19961.4,
    "position_cost": 292230.0,
    "constraint": "WEIGHT",
    "atr14": 19.57,
    "low_20d": 518.4,
    "ladder_minus1_pullback": 538.6,
    "ladder_4_base": 515.7,
    "ladder_5_euphoria": 744.9
  },
  {
    "symbol": "1718.TW",
    "name": "中纖",
    "sector": "化學工業",
    "close": 11.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.05,
    "dog_ma200_bias": 0.033,
    "vr60": 2.07,
    "rs20": 1.08,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 295000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.7,
    "ladder_minus1_pullback": 11.1,
    "ladder_4_base": 10.6,
    "ladder_5_euphoria": 15.3
  },
  {
    "symbol": "4939.TWO",
    "name": "亞電",
    "sector": "電子零組件業",
    "close": 75.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.05,
    "dog_ma200_bias": -0.181,
    "vr60": 0.69,
    "rs20": 0.52,
    "rs60": 0.66,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.38,
    "low_20d": 71.4,
    "ladder_minus1_pullback": 71.3,
    "ladder_4_base": 68.2,
    "ladder_5_euphoria": 98.5
  },
  {
    "symbol": "2883.TW",
    "name": "凱基金",
    "sector": "金融保險業",
    "close": 38.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.57,
    "dog_ma200_bias": 0.035,
    "vr60": 1.29,
    "rs20": 1.09,
    "rs60": 1.0,
    "shares": 16260,
    "lots": 16,
    "odd_shares": 260,
    "ntd_at_risk": 39999.6,
    "position_cost": 624384.0,
    "constraint": "WEIGHT",
    "atr14": 1.23,
    "low_20d": 34.6,
    "ladder_minus1_pullback": 36.1,
    "ladder_4_base": 34.6,
    "ladder_5_euphoria": 49.9
  },
  {
    "symbol": "2337.TW",
    "name": "旺宏",
    "sector": "半導體業",
    "close": 104.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.38,
    "dog_ma200_bias": 0.094,
    "vr60": 1.51,
    "rs20": 1.06,
    "rs60": 1.26,
    "shares": 9661,
    "lots": 9,
    "odd_shares": 661,
    "ntd_at_risk": 39996.54,
    "position_cost": 1009574.5,
    "constraint": "WEIGHT",
    "atr14": 2.07,
    "low_20d": 95.1,
    "ladder_minus1_pullback": 98.2,
    "ladder_4_base": 94.0,
    "ladder_5_euphoria": 135.8
  },
  {
    "symbol": "2449.TW",
    "name": "京元電子",
    "sector": "半導體業",
    "close": 272.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.36,
    "dog_ma200_bias": 0.209,
    "vr60": 2.04,
    "rs20": 1.48,
    "rs60": 1.18,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 4.83,
    "low_20d": 245.4,
    "ladder_minus1_pullback": 255.7,
    "ladder_4_base": 244.8,
    "ladder_5_euphoria": 353.6
  },
  {
    "symbol": "2885.TW",
    "name": "元大金",
    "sector": "金融保險業",
    "close": 72.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.95,
    "dog_ma200_bias": 0.015,
    "vr60": 1.22,
    "rs20": 0.77,
    "rs60": 0.88,
    "shares": 12195,
    "lots": 12,
    "odd_shares": 195,
    "ntd_at_risk": 39999.6,
    "position_cost": 886576.5,
    "constraint": "WEIGHT",
    "atr14": 1.64,
    "low_20d": 69.7,
    "ladder_minus1_pullback": 68.3,
    "ladder_4_base": 65.4,
    "ladder_5_euphoria": 94.5
  },
  {
    "symbol": "2478.TW",
    "name": "大毅",
    "sector": "電子零組件業",
    "close": 142.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.45,
    "dog_ma200_bias": 0.088,
    "vr60": 1.65,
    "rs20": 1.1,
    "rs60": 0.91,
    "shares": 6269,
    "lots": 6,
    "odd_shares": 269,
    "ntd_at_risk": 39996.22,
    "position_cost": 890198.0,
    "constraint": "WEIGHT",
    "atr14": 3.19,
    "low_20d": 130.3,
    "ladder_minus1_pullback": 133.5,
    "ladder_4_base": 127.8,
    "ladder_5_euphoria": 184.6
  },
  {
    "symbol": "6209.TW",
    "name": "今國光",
    "sector": "光電業",
    "close": 93.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.57,
    "dog_ma200_bias": 0.172,
    "vr60": 1.55,
    "rs20": 1.21,
    "rs60": 1.22,
    "shares": 13071,
    "lots": 13,
    "odd_shares": 71,
    "ntd_at_risk": 39997.26,
    "position_cost": 1215603.0,
    "constraint": "WEIGHT",
    "atr14": 1.53,
    "low_20d": 84.6,
    "ladder_minus1_pullback": 87.4,
    "ladder_4_base": 83.7,
    "ladder_5_euphoria": 120.9
  },
  {
    "symbol": "1714.TW",
    "name": "和桐",
    "sector": "化學工業",
    "close": 18.9,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.05,
    "dog_ma200_bias": -0.181,
    "vr60": 0.7,
    "rs20": 0.59,
    "rs60": 0.59,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 17.7,
    "ladder_minus1_pullback": 17.8,
    "ladder_4_base": 17.0,
    "ladder_5_euphoria": 24.6
  },
  {
    "symbol": "6217.TWO",
    "name": "中探針",
    "sector": "電子零組件業",
    "close": 195.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.05,
    "dog_ma200_bias": -0.181,
    "vr60": 0.85,
    "rs20": 0.46,
    "rs60": 0.35,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.23,
    "low_20d": 180.5,
    "ladder_minus1_pullback": 183.3,
    "ladder_4_base": 175.5,
    "ladder_5_euphoria": 253.5
  },
  {
    "symbol": "2355.TW",
    "name": "敬鵬",
    "sector": "電子零組件業",
    "close": 53.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.56,
    "dog_ma200_bias": -0.012,
    "vr60": 1.43,
    "rs20": 1.08,
    "rs60": 0.89,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 1116648.8,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 50.9,
    "ladder_minus1_pullback": 50.4,
    "ladder_4_base": 48.2,
    "ladder_5_euphoria": 69.7
  },
  {
    "symbol": "6147.TWO",
    "name": "頎邦",
    "sector": "半導體業",
    "close": 214.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.35,
    "dog_ma200_bias": 0.053,
    "vr60": 1.67,
    "rs20": 0.79,
    "rs60": 0.8,
    "shares": 3110,
    "lots": 3,
    "odd_shares": 110,
    "ntd_at_risk": 39994.6,
    "position_cost": 667095.0,
    "constraint": "WEIGHT",
    "atr14": 6.43,
    "low_20d": 196.9,
    "ladder_minus1_pullback": 201.6,
    "ladder_4_base": 193.1,
    "ladder_5_euphoria": 278.9
  },
  {
    "symbol": "3090.TW",
    "name": "日電貿",
    "sector": "電子零組件業",
    "close": 171.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": -0.226,
    "vr60": 0.67,
    "rs20": 0.37,
    "rs60": 0.47,
    "shares": 2512,
    "lots": 2,
    "odd_shares": 512,
    "ntd_at_risk": 19995.52,
    "position_cost": 430808.0,
    "constraint": "WEIGHT",
    "atr14": 3.98,
    "low_20d": 161.2,
    "ladder_minus1_pullback": 161.2,
    "ladder_4_base": 154.3,
    "ladder_5_euphoria": 223.0
  },
  {
    "symbol": "2892.TW",
    "name": "第一金",
    "sector": "金融保險業",
    "close": 41.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.82,
    "dog_ma200_bias": -0.009,
    "vr60": 2.01,
    "rs20": 0.99,
    "rs60": 0.71,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 693305.6,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 39.2,
    "ladder_minus1_pullback": 39.1,
    "ladder_4_base": 37.4,
    "ladder_5_euphoria": 54.1
  },
  {
    "symbol": "2340.TW",
    "name": "台亞",
    "sector": "半導體業",
    "close": 47.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.05,
    "dog_ma200_bias": 0.032,
    "vr60": 1.42,
    "rs20": 0.81,
    "rs60": 0.85,
    "shares": 12987,
    "lots": 12,
    "odd_shares": 987,
    "ntd_at_risk": 39999.96,
    "position_cost": 612986.4,
    "constraint": "WEIGHT",
    "atr14": 1.54,
    "low_20d": 45.2,
    "ladder_minus1_pullback": 44.4,
    "ladder_4_base": 42.5,
    "ladder_5_euphoria": 61.4
  },
  {
    "symbol": "6116.TW",
    "name": "彩晶",
    "sector": "光電業",
    "close": 14.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.18,
    "dog_ma200_bias": 0.134,
    "vr60": 1.19,
    "rs20": 1.12,
    "rs60": 1.17,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 365000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.0,
    "ladder_minus1_pullback": 13.7,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 19.0
  },
  {
    "symbol": "2324.TW",
    "name": "仁寶",
    "sector": "電腦及週邊設備業",
    "close": 36.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.29,
    "dog_ma200_bias": -0.011,
    "vr60": 2.08,
    "rs20": 0.78,
    "rs60": 0.88,
    "shares": 19417,
    "lots": 19,
    "odd_shares": 417,
    "ntd_at_risk": 39999.02,
    "position_cost": 699012.0,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 32.7,
    "ladder_minus1_pullback": 33.8,
    "ladder_4_base": 32.4,
    "ladder_5_euphoria": 46.8
  },
  {
    "symbol": "2834.TW",
    "name": "臺企銀",
    "sector": "金融保險業",
    "close": 17.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.6,
    "dog_ma200_bias": 0.031,
    "vr60": 2.09,
    "rs20": 0.97,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 441250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.0,
    "ladder_minus1_pullback": 16.6,
    "ladder_4_base": 15.9,
    "ladder_5_euphoria": 22.9
  },
  {
    "symbol": "8042.TWO",
    "name": "金山電",
    "sector": "電子零組件業",
    "close": 148.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.05,
    "dog_ma200_bias": -0.195,
    "vr60": 0.94,
    "rs20": 0.59,
    "rs60": 0.27,
    "shares": 2314,
    "lots": 2,
    "odd_shares": 314,
    "ntd_at_risk": 19992.96,
    "position_cost": 342472.0,
    "constraint": "WEIGHT",
    "atr14": 4.32,
    "low_20d": 138.3,
    "ladder_minus1_pullback": 139.1,
    "ladder_4_base": 133.2,
    "ladder_5_euphoria": 192.4
  },
  {
    "symbol": "6182.TWO",
    "name": "合晶",
    "sector": "半導體業",
    "close": 110.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.05,
    "dog_ma200_bias": 0.059,
    "vr60": 1.51,
    "rs20": 1.04,
    "rs60": 0.92,
    "shares": 5277,
    "lots": 5,
    "odd_shares": 277,
    "ntd_at_risk": 39999.66,
    "position_cost": 580470.0,
    "constraint": "WEIGHT",
    "atr14": 3.79,
    "low_20d": 102.2,
    "ladder_minus1_pullback": 103.4,
    "ladder_4_base": 99.0,
    "ladder_5_euphoria": 143.0
  },
  {
    "symbol": "6456.TW",
    "name": "GIS-KY",
    "sector": "光電業",
    "close": 88.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.17,
    "dog_ma200_bias": 0.057,
    "vr60": 1.86,
    "rs20": 0.88,
    "rs60": 0.72,
    "shares": 12903,
    "lots": 12,
    "odd_shares": 903,
    "ntd_at_risk": 39999.3,
    "position_cost": 1144496.1,
    "constraint": "WEIGHT",
    "atr14": 1.55,
    "low_20d": 84.0,
    "ladder_minus1_pullback": 83.4,
    "ladder_4_base": 79.8,
    "ladder_5_euphoria": 115.3
  },
  {
    "symbol": "8150.TW",
    "name": "南茂",
    "sector": "半導體業",
    "close": 105.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.05,
    "dog_ma200_bias": 0.035,
    "vr60": 1.93,
    "rs20": 0.82,
    "rs60": 0.97,
    "shares": 9803,
    "lots": 9,
    "odd_shares": 803,
    "ntd_at_risk": 39996.24,
    "position_cost": 1034216.5,
    "constraint": "WEIGHT",
    "atr14": 2.04,
    "low_20d": 100.1,
    "ladder_minus1_pullback": 99.2,
    "ladder_4_base": 95.0,
    "ladder_5_euphoria": 137.2
  },
  {
    "symbol": "6269.TW",
    "name": "台郡",
    "sector": "電子零組件業",
    "close": 74.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.95,
    "dog_ma200_bias": 0.026,
    "vr60": 1.83,
    "rs20": 1.0,
    "rs60": 0.98,
    "shares": 10256,
    "lots": 10,
    "odd_shares": 256,
    "ntd_at_risk": 39998.4,
    "position_cost": 765097.6,
    "constraint": "WEIGHT",
    "atr14": 1.95,
    "low_20d": 67.8,
    "ladder_minus1_pullback": 70.1,
    "ladder_4_base": 67.1,
    "ladder_5_euphoria": 97.0
  },
  {
    "symbol": "2313.TW",
    "name": "華通",
    "sector": "電子零組件業",
    "close": 228.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.05,
    "dog_ma200_bias": 0.068,
    "vr60": 1.52,
    "rs20": 1.13,
    "rs60": 1.02,
    "shares": 3597,
    "lots": 3,
    "odd_shares": 597,
    "ntd_at_risk": 39998.64,
    "position_cost": 820116.0,
    "constraint": "WEIGHT",
    "atr14": 5.56,
    "low_20d": 214.6,
    "ladder_minus1_pullback": 214.3,
    "ladder_4_base": 205.2,
    "ladder_5_euphoria": 296.4
  },
  {
    "symbol": "2801.TW",
    "name": "彰銀",
    "sector": "金融保險業",
    "close": 29.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.92,
    "dog_ma200_bias": -0.016,
    "vr60": 1.38,
    "rs20": 0.77,
    "rs60": 1.03,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 633691.85,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 27.7,
    "ladder_minus1_pullback": 27.4,
    "ladder_4_base": 26.2,
    "ladder_5_euphoria": 37.9
  },
  {
    "symbol": "1409.TW",
    "name": "新纖",
    "sector": "紡織纖維業",
    "close": 25.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.07,
    "dog_ma200_bias": 0.032,
    "vr60": 2.09,
    "rs20": 0.97,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 637500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.2,
    "ladder_minus1_pullback": 24.0,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.1
  },
  {
    "symbol": "4938.TW",
    "name": "和碩",
    "sector": "電腦及週邊設備業",
    "close": 98.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.62,
    "dog_ma200_bias": 0.15,
    "vr60": 1.16,
    "rs20": 1.09,
    "rs60": 1.21,
    "shares": 12345,
    "lots": 12,
    "odd_shares": 345,
    "ntd_at_risk": 39997.8,
    "position_cost": 1211044.5,
    "constraint": "WEIGHT",
    "atr14": 1.62,
    "low_20d": 90.6,
    "ladder_minus1_pullback": 92.2,
    "ladder_4_base": 88.3,
    "ladder_5_euphoria": 127.5
  },
  {
    "symbol": "6239.TW",
    "name": "力成",
    "sector": "半導體業",
    "close": 270.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.09,
    "dog_ma200_bias": 0.067,
    "vr60": 1.5,
    "rs20": 0.8,
    "rs60": 0.83,
    "shares": 4750,
    "lots": 4,
    "odd_shares": 750,
    "ntd_at_risk": 39995.0,
    "position_cost": 1284875.0,
    "constraint": "WEIGHT",
    "atr14": 4.21,
    "low_20d": 255.1,
    "ladder_minus1_pullback": 254.3,
    "ladder_4_base": 243.5,
    "ladder_5_euphoria": 351.7
  },
  {
    "symbol": "2484.TW",
    "name": "希華",
    "sector": "電子零組件業",
    "close": 84.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": -0.12,
    "vr60": 0.98,
    "rs20": 0.56,
    "rs60": 0.32,
    "shares": 7246,
    "lots": 7,
    "odd_shares": 246,
    "ntd_at_risk": 19998.96,
    "position_cost": 615185.4,
    "constraint": "WEIGHT",
    "atr14": 1.38,
    "low_20d": 78.5,
    "ladder_minus1_pullback": 79.8,
    "ladder_4_base": 76.4,
    "ladder_5_euphoria": 110.4
  },
  {
    "symbol": "4958.TW",
    "name": "臻鼎-KY",
    "sector": "電子零組件業",
    "close": 519.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.05,
    "dog_ma200_bias": -0.191,
    "vr60": 0.87,
    "rs20": 0.57,
    "rs60": 0.37,
    "shares": 909,
    "lots": 0,
    "odd_shares": 909,
    "ntd_at_risk": 19979.82,
    "position_cost": 471771.0,
    "constraint": "WEIGHT",
    "atr14": 10.99,
    "low_20d": 481.1,
    "ladder_minus1_pullback": 487.9,
    "ladder_4_base": 467.1,
    "ladder_5_euphoria": 674.7
  },
  {
    "symbol": "5314.TWO",
    "name": "世紀*",
    "sector": "其他業",
    "close": 24.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.09,
    "dog_ma200_bias": 0.053,
    "vr60": 1.27,
    "rs20": 0.99,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 620000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.4,
    "ladder_minus1_pullback": 23.3,
    "ladder_4_base": 22.3,
    "ladder_5_euphoria": 32.2
  },
  {
    "symbol": "2312.TW",
    "name": "金寶",
    "sector": "其他電子業",
    "close": 31.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.19,
    "dog_ma200_bias": 0.125,
    "vr60": 1.24,
    "rs20": 0.98,
    "rs60": 1.16,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 759024.0,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 29.2,
    "ladder_minus1_pullback": 29.6,
    "ladder_4_base": 28.4,
    "ladder_5_euphoria": 41.0
  },
  {
    "symbol": "6668.TW",
    "name": "中揚光",
    "sector": "光電業",
    "close": 62.1,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.13,
    "dog_ma200_bias": -0.225,
    "vr60": 0.92,
    "rs20": 0.37,
    "rs60": 0.44,
    "shares": 10101,
    "lots": 10,
    "odd_shares": 101,
    "ntd_at_risk": 19999.98,
    "position_cost": 627272.1,
    "constraint": "WEIGHT",
    "atr14": 0.99,
    "low_20d": 58.4,
    "ladder_minus1_pullback": 58.4,
    "ladder_4_base": 55.9,
    "ladder_5_euphoria": 80.7
  },
  {
    "symbol": "2880.TW",
    "name": "華南金",
    "sector": "金融保險業",
    "close": 49.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.71,
    "dog_ma200_bias": 0.065,
    "vr60": 1.57,
    "rs20": 1.09,
    "rs60": 1.3,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1241250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 46.6,
    "ladder_minus1_pullback": 46.7,
    "ladder_4_base": 44.7,
    "ladder_5_euphoria": 64.5
  },
  {
    "symbol": "2301.TW",
    "name": "光寶科",
    "sector": "電腦及週邊設備業",
    "close": 268.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.19,
    "dog_ma200_bias": 0.007,
    "vr60": 2.08,
    "rs20": 1.13,
    "rs60": 0.73,
    "shares": 3252,
    "lots": 3,
    "odd_shares": 252,
    "ntd_at_risk": 39999.6,
    "position_cost": 871536.0,
    "constraint": "WEIGHT",
    "atr14": 6.15,
    "low_20d": 254.1,
    "ladder_minus1_pullback": 251.9,
    "ladder_4_base": 241.2,
    "ladder_5_euphoria": 348.4
  },
  {
    "symbol": "3264.TWO",
    "name": "欣銓",
    "sector": "半導體業",
    "close": 268.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.71,
    "dog_ma200_bias": 0.044,
    "vr60": 1.53,
    "rs20": 1.07,
    "rs60": 0.94,
    "shares": 2528,
    "lots": 2,
    "odd_shares": 528,
    "ntd_at_risk": 39992.96,
    "position_cost": 677504.0,
    "constraint": "WEIGHT",
    "atr14": 7.91,
    "low_20d": 241.6,
    "ladder_minus1_pullback": 251.9,
    "ladder_4_base": 241.2,
    "ladder_5_euphoria": 348.4
  },
  {
    "symbol": "9904.TW",
    "name": "寶成",
    "sector": "運動休閒",
    "close": 26.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.95,
    "dog_ma200_bias": 0.075,
    "vr60": 1.33,
    "rs20": 0.99,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 656250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.6,
    "ladder_minus1_pullback": 24.7,
    "ladder_4_base": 23.6,
    "ladder_5_euphoria": 34.1
  },
  {
    "symbol": "6127.TWO",
    "name": "九豪",
    "sector": "電子零組件業",
    "close": 62.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.05,
    "dog_ma200_bias": -0.017,
    "vr60": 1.26,
    "rs20": 1.06,
    "rs60": 0.83,
    "shares": 18867,
    "lots": 18,
    "odd_shares": 867,
    "ntd_at_risk": 39998.04,
    "position_cost": 1175414.1,
    "constraint": "WEIGHT",
    "atr14": 1.06,
    "low_20d": 56.8,
    "ladder_minus1_pullback": 58.6,
    "ladder_4_base": 56.1,
    "ladder_5_euphoria": 81.0
  },
  {
    "symbol": "2618.TW",
    "name": "長榮航",
    "sector": "航運業",
    "close": 43.45,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.92,
    "dog_ma200_bias": -0.211,
    "vr60": 0.91,
    "rs20": 0.44,
    "rs60": 0.43,
    "shares": 8620,
    "lots": 8,
    "odd_shares": 620,
    "ntd_at_risk": 19998.4,
    "position_cost": 374539.0,
    "constraint": "WEIGHT",
    "atr14": 1.16,
    "low_20d": 40.7,
    "ladder_minus1_pullback": 40.8,
    "ladder_4_base": 39.1,
    "ladder_5_euphoria": 56.5
  },
  {
    "symbol": "5347.TWO",
    "name": "世界",
    "sector": "半導體業",
    "close": 161.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.11,
    "dog_ma200_bias": 0.017,
    "vr60": 1.89,
    "rs20": 0.98,
    "rs60": 0.89,
    "shares": 3868,
    "lots": 3,
    "odd_shares": 868,
    "ntd_at_risk": 39995.12,
    "position_cost": 624682.0,
    "constraint": "WEIGHT",
    "atr14": 5.17,
    "low_20d": 152.2,
    "ladder_minus1_pullback": 151.8,
    "ladder_4_base": 145.3,
    "ladder_5_euphoria": 210.0
  },
  {
    "symbol": "2426.TW",
    "name": "鼎元",
    "sector": "光電業",
    "close": 90.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.05,
    "dog_ma200_bias": 0.02,
    "vr60": 1.78,
    "rs20": 0.85,
    "rs60": 0.74,
    "shares": 9090,
    "lots": 9,
    "odd_shares": 90,
    "ntd_at_risk": 39996.0,
    "position_cost": 824463.0,
    "constraint": "WEIGHT",
    "atr14": 2.2,
    "low_20d": 82.3,
    "ladder_minus1_pullback": 85.3,
    "ladder_4_base": 81.6,
    "ladder_5_euphoria": 117.9
  },
  {
    "symbol": "2610.TW",
    "name": "華航",
    "sector": "航運業",
    "close": 20.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.75,
    "dog_ma200_bias": 0.054,
    "vr60": 1.65,
    "rs20": 0.9,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 513750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.6,
    "ladder_minus1_pullback": 19.3,
    "ladder_4_base": 18.5,
    "ladder_5_euphoria": 26.7
  },
  {
    "symbol": "2812.TW",
    "name": "台中銀",
    "sector": "金融保險業",
    "close": 18.7,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.6,
    "dog_ma200_bias": -0.054,
    "vr60": 1.53,
    "rs20": 0.56,
    "rs60": 0.8,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 17.1,
    "ladder_minus1_pullback": 17.6,
    "ladder_4_base": 16.8,
    "ladder_5_euphoria": 24.3
  },
  {
    "symbol": "2353.TW",
    "name": "宏碁",
    "sector": "電腦及週邊設備業",
    "close": 31.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.4,
    "dog_ma200_bias": 0.072,
    "vr60": 1.64,
    "rs20": 0.8,
    "rs60": 1.0,
    "shares": 18348,
    "lots": 18,
    "odd_shares": 348,
    "ntd_at_risk": 39998.64,
    "position_cost": 581631.6,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 29.4,
    "ladder_minus1_pullback": 29.8,
    "ladder_4_base": 28.5,
    "ladder_5_euphoria": 41.2
  },
  {
    "symbol": "2375.TW",
    "name": "凱美",
    "sector": "電子零組件業",
    "close": 131.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.09,
    "dog_ma200_bias": -0.199,
    "vr60": 1.05,
    "rs20": 0.38,
    "rs60": 0.21,
    "shares": 2724,
    "lots": 2,
    "odd_shares": 724,
    "ntd_at_risk": 19994.16,
    "position_cost": 356844.0,
    "constraint": "WEIGHT",
    "atr14": 3.67,
    "low_20d": 118.4,
    "ladder_minus1_pullback": 123.1,
    "ladder_4_base": 117.9,
    "ladder_5_euphoria": 170.3
  },
  {
    "symbol": "3624.TWO",
    "name": "光頡",
    "sector": "電子零組件業",
    "close": 151.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.05,
    "dog_ma200_bias": 0.161,
    "vr60": 1.24,
    "rs20": 1.09,
    "rs60": 0.93,
    "shares": 4301,
    "lots": 4,
    "odd_shares": 301,
    "ntd_at_risk": 39999.3,
    "position_cost": 651601.5,
    "constraint": "WEIGHT",
    "atr14": 4.65,
    "low_20d": 142.4,
    "ladder_minus1_pullback": 142.4,
    "ladder_4_base": 136.3,
    "ladder_5_euphoria": 197.0
  },
  {
    "symbol": "3045.TW",
    "name": "台灣大",
    "sector": "通信網路業",
    "close": 131.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.69,
    "dog_ma200_bias": -0.124,
    "vr60": 0.91,
    "rs20": 0.6,
    "rs60": 0.6,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 4.21,
    "low_20d": 122.4,
    "ladder_minus1_pullback": 123.1,
    "ladder_4_base": 117.9,
    "ladder_5_euphoria": 170.3
  },
  {
    "symbol": "1528.TW",
    "name": "恩德",
    "sector": "電機機械業",
    "close": 23.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.05,
    "dog_ma200_bias": 0.171,
    "vr60": 1.43,
    "rs20": 1.27,
    "rs60": 1.1,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 591250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.2,
    "ladder_minus1_pullback": 22.2,
    "ladder_4_base": 21.3,
    "ladder_5_euphoria": 30.7
  },
  {
    "symbol": "4977.TW",
    "name": "眾達-KY",
    "sector": "通信網路業",
    "close": 188.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.44,
    "dog_ma200_bias": 0.075,
    "vr60": 1.17,
    "rs20": 1.01,
    "rs60": 1.22,
    "shares": 3906,
    "lots": 3,
    "odd_shares": 906,
    "ntd_at_risk": 39997.44,
    "position_cost": 734328.0,
    "constraint": "WEIGHT",
    "atr14": 5.12,
    "low_20d": 179.6,
    "ladder_minus1_pullback": 176.7,
    "ladder_4_base": 169.2,
    "ladder_5_euphoria": 244.4
  },
  {
    "symbol": "5871.TW",
    "name": "中租-KY",
    "sector": "其他業",
    "close": 108.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.43,
    "dog_ma200_bias": -0.017,
    "vr60": 1.7,
    "rs20": 0.9,
    "rs60": 0.98,
    "shares": 6688,
    "lots": 6,
    "odd_shares": 688,
    "ntd_at_risk": 39994.24,
    "position_cost": 725648.0,
    "constraint": "WEIGHT",
    "atr14": 2.99,
    "low_20d": 100.9,
    "ladder_minus1_pullback": 102.0,
    "ladder_4_base": 97.7,
    "ladder_5_euphoria": 141.1
  },
  {
    "symbol": "3105.TWO",
    "name": "穩懋",
    "sector": "半導體業",
    "close": 502.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": -0.181,
    "vr60": 0.93,
    "rs20": 0.23,
    "rs60": 0.29,
    "shares": 1116,
    "lots": 1,
    "odd_shares": 116,
    "ntd_at_risk": 19998.72,
    "position_cost": 560232.0,
    "constraint": "WEIGHT",
    "atr14": 8.96,
    "low_20d": 455.7,
    "ladder_minus1_pullback": 471.9,
    "ladder_4_base": 451.8,
    "ladder_5_euphoria": 652.6
  },
  {
    "symbol": "4904.TW",
    "name": "遠傳",
    "sector": "通信網路業",
    "close": 113.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.95,
    "dog_ma200_bias": 0.052,
    "vr60": 1.67,
    "rs20": 1.06,
    "rs60": 0.99,
    "shares": 5154,
    "lots": 5,
    "odd_shares": 154,
    "ntd_at_risk": 39995.04,
    "position_cost": 582402.0,
    "constraint": "WEIGHT",
    "atr14": 3.88,
    "low_20d": 103.2,
    "ladder_minus1_pullback": 106.2,
    "ladder_4_base": 101.7,
    "ladder_5_euphoria": 146.9
  },
  {
    "symbol": "1710.TW",
    "name": "東聯",
    "sector": "化學工業",
    "close": 18.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.05,
    "dog_ma200_bias": -0.19,
    "vr60": 0.94,
    "rs20": 0.52,
    "rs60": 0.51,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 16.9,
    "ladder_minus1_pullback": 16.9,
    "ladder_4_base": 16.2,
    "ladder_5_euphoria": 23.4
  },
  {
    "symbol": "2356.TW",
    "name": "英業達",
    "sector": "電腦及週邊設備業",
    "close": 57.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.95,
    "dog_ma200_bias": 0.142,
    "vr60": 1.26,
    "rs20": 1.3,
    "rs60": 1.21,
    "shares": 19047,
    "lots": 19,
    "odd_shares": 47,
    "ntd_at_risk": 39998.7,
    "position_cost": 1097107.2,
    "constraint": "WEIGHT",
    "atr14": 1.05,
    "low_20d": 54.3,
    "ladder_minus1_pullback": 54.1,
    "ladder_4_base": 51.8,
    "ladder_5_euphoria": 74.9
  },
  {
    "symbol": "8086.TWO",
    "name": "宏捷科",
    "sector": "半導體業",
    "close": 130.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.43,
    "dog_ma200_bias": 0.137,
    "vr60": 1.16,
    "rs20": 1.34,
    "rs60": 1.07,
    "shares": 9174,
    "lots": 9,
    "odd_shares": 174,
    "ntd_at_risk": 39998.64,
    "position_cost": 1192620.0,
    "constraint": "WEIGHT",
    "atr14": 2.18,
    "low_20d": 123.4,
    "ladder_minus1_pullback": 122.2,
    "ladder_4_base": 117.0,
    "ladder_5_euphoria": 169.0
  },
  {
    "symbol": "2481.TW",
    "name": "強茂",
    "sector": "半導體業",
    "close": 155.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.12,
    "dog_ma200_bias": 0.071,
    "vr60": 1.25,
    "rs20": 0.8,
    "rs60": 0.75,
    "shares": 6389,
    "lots": 6,
    "odd_shares": 389,
    "ntd_at_risk": 39995.14,
    "position_cost": 993489.5,
    "constraint": "WEIGHT",
    "atr14": 3.13,
    "low_20d": 144.9,
    "ladder_minus1_pullback": 146.2,
    "ladder_4_base": 140.0,
    "ladder_5_euphoria": 202.2
  },
  {
    "symbol": "4903.TWO",
    "name": "聯光通",
    "sector": "通信網路業",
    "close": 52.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.08,
    "dog_ma200_bias": -0.004,
    "vr60": 1.49,
    "rs20": 1.03,
    "rs60": 0.82,
    "shares": 11627,
    "lots": 11,
    "odd_shares": 627,
    "ntd_at_risk": 39996.88,
    "position_cost": 613905.6,
    "constraint": "WEIGHT",
    "atr14": 1.72,
    "low_20d": 48.6,
    "ladder_minus1_pullback": 49.6,
    "ladder_4_base": 47.5,
    "ladder_5_euphoria": 68.6
  },
  {
    "symbol": "6108.TW",
    "name": "競國",
    "sector": "電子零組件業",
    "close": 29.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.26,
    "dog_ma200_bias": 0.173,
    "vr60": 1.59,
    "rs20": 1.29,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 730000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.0,
    "ladder_minus1_pullback": 27.4,
    "ladder_4_base": 26.3,
    "ladder_5_euphoria": 38.0
  },
  {
    "symbol": "2305.TW",
    "name": "全友",
    "sector": "電腦及週邊設備業",
    "close": 57.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.05,
    "dog_ma200_bias": 0.044,
    "vr60": 1.7,
    "rs20": 0.8,
    "rs60": 0.81,
    "shares": 10752,
    "lots": 10,
    "odd_shares": 752,
    "ntd_at_risk": 39997.44,
    "position_cost": 621465.6,
    "constraint": "WEIGHT",
    "atr14": 1.86,
    "low_20d": 54.1,
    "ladder_minus1_pullback": 54.3,
    "ladder_4_base": 52.0,
    "ladder_5_euphoria": 75.1
  },
  {
    "symbol": "3026.TW",
    "name": "禾伸堂",
    "sector": "電子零組件業",
    "close": 811.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.18,
    "dog_ma200_bias": 0.033,
    "vr60": 1.65,
    "rs20": 0.82,
    "rs60": 1.03,
    "shares": 739,
    "lots": 0,
    "odd_shares": 739,
    "ntd_at_risk": 39965.12,
    "position_cost": 599329.0,
    "constraint": "WEIGHT",
    "atr14": 27.04,
    "low_20d": 772.3,
    "ladder_minus1_pullback": 762.3,
    "ladder_4_base": 729.9,
    "ladder_5_euphoria": 1054.3
  },
  {
    "symbol": "6257.TW",
    "name": "矽格",
    "sector": "半導體業",
    "close": 258.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.36,
    "dog_ma200_bias": 0.079,
    "vr60": 1.45,
    "rs20": 1.24,
    "rs60": 1.14,
    "shares": 2430,
    "lots": 2,
    "odd_shares": 430,
    "ntd_at_risk": 39997.8,
    "position_cost": 626940.0,
    "constraint": "WEIGHT",
    "atr14": 8.23,
    "low_20d": 232.9,
    "ladder_minus1_pullback": 242.5,
    "ladder_4_base": 232.2,
    "ladder_5_euphoria": 335.4
  },
  {
    "symbol": "2323.TW",
    "name": "中環",
    "sector": "光電業",
    "close": 11.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.56,
    "dog_ma200_bias": 0.064,
    "vr60": 1.71,
    "rs20": 1.08,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 295000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.0,
    "ladder_minus1_pullback": 11.1,
    "ladder_4_base": 10.6,
    "ladder_5_euphoria": 15.3
  },
  {
    "symbol": "8043.TWO",
    "name": "蜜望實",
    "sector": "電子零組件業",
    "close": 140.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.05,
    "dog_ma200_bias": -0.015,
    "vr60": 1.78,
    "rs20": 0.98,
    "rs60": 0.93,
    "shares": 4376,
    "lots": 4,
    "odd_shares": 376,
    "ntd_at_risk": 39996.64,
    "position_cost": 614828.0,
    "constraint": "WEIGHT",
    "atr14": 4.57,
    "low_20d": 129.1,
    "ladder_minus1_pullback": 132.1,
    "ladder_4_base": 126.5,
    "ladder_5_euphoria": 182.7
  },
  {
    "symbol": "6153.TW",
    "name": "嘉聯益",
    "sector": "電子零組件業",
    "close": 18.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.05,
    "dog_ma200_bias": 0.057,
    "vr60": 1.57,
    "rs20": 1.01,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 451250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.5,
    "ladder_minus1_pullback": 17.0,
    "ladder_4_base": 16.2,
    "ladder_5_euphoria": 23.5
  },
  {
    "symbol": "2368.TW",
    "name": "金像電",
    "sector": "電子零組件業",
    "close": 1190.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.6,
    "dog_ma200_bias": 0.043,
    "vr60": 1.46,
    "rs20": 1.13,
    "rs60": 0.87,
    "shares": 534,
    "lots": 0,
    "odd_shares": 534,
    "ntd_at_risk": 39943.2,
    "position_cost": 635460.0,
    "constraint": "WEIGHT",
    "atr14": 37.4,
    "low_20d": 1141.8,
    "ladder_minus1_pullback": 1118.6,
    "ladder_4_base": 1071.0,
    "ladder_5_euphoria": 1547.0
  },
  {
    "symbol": "6274.TWO",
    "name": "台燿",
    "sector": "電子零組件業",
    "close": 1625.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.16,
    "dog_ma200_bias": 0.157,
    "vr60": 1.46,
    "rs20": 1.07,
    "rs60": 0.93,
    "shares": 591,
    "lots": 0,
    "odd_shares": 591,
    "ntd_at_risk": 39975.24,
    "position_cost": 960375.0,
    "constraint": "WEIGHT",
    "atr14": 33.82,
    "low_20d": 1544.6,
    "ladder_minus1_pullback": 1527.5,
    "ladder_4_base": 1462.5,
    "ladder_5_euphoria": 2112.5
  },
  {
    "symbol": "2468.TW",
    "name": "華經",
    "sector": "資訊服務業",
    "close": 46.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.35,
    "dog_ma200_bias": -0.014,
    "vr60": 1.6,
    "rs20": 0.94,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1162500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 43.6,
    "ladder_minus1_pullback": 43.7,
    "ladder_4_base": 41.9,
    "ladder_5_euphoria": 60.5
  },
  {
    "symbol": "2105.TW",
    "name": "正新",
    "sector": "橡膠工業",
    "close": 31.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.83,
    "dog_ma200_bias": 0.041,
    "vr60": 1.48,
    "rs20": 1.04,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 795000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.6,
    "ladder_minus1_pullback": 29.9,
    "ladder_4_base": 28.6,
    "ladder_5_euphoria": 41.3
  },
  {
    "symbol": "4927.TW",
    "name": "泰鼎-KY",
    "sector": "電子零組件業",
    "close": 56.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.23,
    "dog_ma200_bias": 0.006,
    "vr60": 2.18,
    "rs20": 0.45,
    "rs60": 0.58,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.85,
    "low_20d": 52.2,
    "ladder_minus1_pullback": 52.6,
    "ladder_4_base": 50.4,
    "ladder_5_euphoria": 72.8
  },
  {
    "symbol": "5876.TW",
    "name": "上海商銀",
    "sector": "金融保險業",
    "close": 53.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.95,
    "dog_ma200_bias": -0.223,
    "vr60": 0.86,
    "rs20": 0.31,
    "rs60": 0.27,
    "shares": 6329,
    "lots": 6,
    "odd_shares": 329,
    "ntd_at_risk": 19999.64,
    "position_cost": 337968.6,
    "constraint": "WEIGHT",
    "atr14": 1.58,
    "low_20d": 48.3,
    "ladder_minus1_pullback": 50.2,
    "ladder_4_base": 48.1,
    "ladder_5_euphoria": 69.4
  },
  {
    "symbol": "3576.TW",
    "name": "聯合再生",
    "sector": "光電業",
    "close": 17.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.07,
    "dog_ma200_bias": 0.009,
    "vr60": 1.55,
    "rs20": 1.0,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 448750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.0,
    "ladder_minus1_pullback": 16.9,
    "ladder_4_base": 16.2,
    "ladder_5_euphoria": 23.3
  },
  {
    "symbol": "6834.TW",
    "name": "天二科技",
    "sector": "電子零組件業",
    "close": 146.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.05,
    "dog_ma200_bias": 0.067,
    "vr60": 1.34,
    "rs20": 0.88,
    "rs60": 0.9,
    "shares": 6389,
    "lots": 6,
    "odd_shares": 389,
    "ntd_at_risk": 39995.14,
    "position_cost": 935988.5,
    "constraint": "WEIGHT",
    "atr14": 3.13,
    "low_20d": 131.9,
    "ladder_minus1_pullback": 137.7,
    "ladder_4_base": 131.8,
    "ladder_5_euphoria": 190.5
  },
  {
    "symbol": "3406.TW",
    "name": "玉晶光",
    "sector": "光電業",
    "close": 1115.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.68,
    "dog_ma200_bias": -0.156,
    "vr60": 0.87,
    "rs20": 0.47,
    "rs60": 0.53,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 32.39,
    "low_20d": 1038.5,
    "ladder_minus1_pullback": 1048.1,
    "ladder_4_base": 1003.5,
    "ladder_5_euphoria": 1449.5
  },
  {
    "symbol": "3189.TW",
    "name": "景碩",
    "sector": "半導體業",
    "close": 979.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.3,
    "dog_ma200_bias": 0.03,
    "vr60": 1.48,
    "rs20": 0.76,
    "rs60": 1.03,
    "shares": 1296,
    "lots": 1,
    "odd_shares": 296,
    "ntd_at_risk": 39994.56,
    "position_cost": 1268784.0,
    "constraint": "WEIGHT",
    "atr14": 15.43,
    "low_20d": 930.7,
    "ladder_minus1_pullback": 920.3,
    "ladder_4_base": 881.1,
    "ladder_5_euphoria": 1272.7
  },
  {
    "symbol": "2489.TW",
    "name": "瑞軒",
    "sector": "光電業",
    "close": 38.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.05,
    "dog_ma200_bias": 0.031,
    "vr60": 2.07,
    "rs20": 0.84,
    "rs60": 0.82,
    "shares": 18518,
    "lots": 18,
    "odd_shares": 518,
    "ntd_at_risk": 39998.88,
    "position_cost": 718498.4,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 36.5,
    "ladder_minus1_pullback": 36.5,
    "ladder_4_base": 34.9,
    "ladder_5_euphoria": 50.4
  },
  {
    "symbol": "3374.TWO",
    "name": "精材",
    "sector": "半導體業",
    "close": 452.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.09,
    "dog_ma200_bias": -0.271,
    "vr60": 0.87,
    "rs20": 0.55,
    "rs60": 0.42,
    "shares": 817,
    "lots": 0,
    "odd_shares": 817,
    "ntd_at_risk": 19983.82,
    "position_cost": 369692.5,
    "constraint": "WEIGHT",
    "atr14": 12.23,
    "low_20d": 424.1,
    "ladder_minus1_pullback": 425.3,
    "ladder_4_base": 407.2,
    "ladder_5_euphoria": 588.2
  },
  {
    "symbol": "3605.TW",
    "name": "宏致",
    "sector": "電子零組件業",
    "close": 175.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.05,
    "dog_ma200_bias": 0.034,
    "vr60": 1.96,
    "rs20": 0.92,
    "rs60": 1.01,
    "shares": 5141,
    "lots": 5,
    "odd_shares": 141,
    "ntd_at_risk": 39996.98,
    "position_cost": 899675.0,
    "constraint": "WEIGHT",
    "atr14": 3.89,
    "low_20d": 163.5,
    "ladder_minus1_pullback": 164.5,
    "ladder_4_base": 157.5,
    "ladder_5_euphoria": 227.5
  },
  {
    "symbol": "3702.TW",
    "name": "大聯大",
    "sector": "電子通路業",
    "close": 115.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.43,
    "dog_ma200_bias": -0.007,
    "vr60": 1.99,
    "rs20": 0.53,
    "rs60": 0.59,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.86,
    "low_20d": 104.9,
    "ladder_minus1_pullback": 108.6,
    "ladder_4_base": 104.0,
    "ladder_5_euphoria": 150.2
  },
  {
    "symbol": "1569.TWO",
    "name": "濱川",
    "sector": "電腦及週邊設備業",
    "close": 79.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.15,
    "dog_ma200_bias": -0.001,
    "vr60": 1.7,
    "rs20": 0.78,
    "rs60": 0.88,
    "shares": 8771,
    "lots": 8,
    "odd_shares": 771,
    "ntd_at_risk": 39995.76,
    "position_cost": 697294.5,
    "constraint": "WEIGHT",
    "atr14": 2.28,
    "low_20d": 75.0,
    "ladder_minus1_pullback": 74.7,
    "ladder_4_base": 71.5,
    "ladder_5_euphoria": 103.4
  },
  {
    "symbol": "3035.TW",
    "name": "智原",
    "sector": "半導體業",
    "close": 197.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.05,
    "dog_ma200_bias": 0.152,
    "vr60": 1.22,
    "rs20": 1.35,
    "rs60": 1.17,
    "shares": 6079,
    "lots": 6,
    "odd_shares": 79,
    "ntd_at_risk": 39999.82,
    "position_cost": 1200602.5,
    "constraint": "WEIGHT",
    "atr14": 3.29,
    "low_20d": 188.8,
    "ladder_minus1_pullback": 185.6,
    "ladder_4_base": 177.8,
    "ladder_5_euphoria": 256.8
  },
  {
    "symbol": "3706.TW",
    "name": "神達",
    "sector": "電腦及週邊設備業",
    "close": 81.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.05,
    "dog_ma200_bias": -0.008,
    "vr60": 2.08,
    "rs20": 0.91,
    "rs60": 0.98,
    "shares": 11695,
    "lots": 11,
    "odd_shares": 695,
    "ntd_at_risk": 39996.9,
    "position_cost": 953142.5,
    "constraint": "WEIGHT",
    "atr14": 1.71,
    "low_20d": 74.8,
    "ladder_minus1_pullback": 76.6,
    "ladder_4_base": 73.4,
    "ladder_5_euphoria": 106.0
  },
  {
    "symbol": "8046.TW",
    "name": "南電",
    "sector": "電子零組件業",
    "close": 1345.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.38,
    "dog_ma200_bias": 0.014,
    "vr60": 2.05,
    "rs20": 1.05,
    "rs60": 0.77,
    "shares": 583,
    "lots": 0,
    "odd_shares": 583,
    "ntd_at_risk": 39982.14,
    "position_cost": 784135.0,
    "constraint": "WEIGHT",
    "atr14": 34.29,
    "low_20d": 1237.2,
    "ladder_minus1_pullback": 1264.3,
    "ladder_4_base": 1210.5,
    "ladder_5_euphoria": 1748.5
  },
  {
    "symbol": "5351.TWO",
    "name": "鈺創",
    "sector": "半導體業",
    "close": 102.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.22,
    "dog_ma200_bias": -0.188,
    "vr60": 0.88,
    "rs20": 0.22,
    "rs60": 0.23,
    "shares": 3105,
    "lots": 3,
    "odd_shares": 105,
    "ntd_at_risk": 19996.2,
    "position_cost": 316710.0,
    "constraint": "WEIGHT",
    "atr14": 3.22,
    "low_20d": 97.4,
    "ladder_minus1_pullback": 95.9,
    "ladder_4_base": 91.8,
    "ladder_5_euphoria": 132.6
  },
  {
    "symbol": "4720.TW",
    "name": "德淵",
    "sector": "化學工業",
    "close": 25.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.25,
    "dog_ma200_bias": 0.027,
    "vr60": 1.61,
    "rs20": 0.99,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 637500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.3,
    "ladder_minus1_pullback": 24.0,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.1
  },
  {
    "symbol": "3287.TWO",
    "name": "廣寰科",
    "sector": "電腦及週邊設備業",
    "close": 58.7,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.52,
    "dog_ma200_bias": -0.221,
    "vr60": 0.93,
    "rs20": 0.27,
    "rs60": 0.55,
    "shares": 7751,
    "lots": 7,
    "odd_shares": 751,
    "ntd_at_risk": 19997.58,
    "position_cost": 454983.7,
    "constraint": "WEIGHT",
    "atr14": 1.29,
    "low_20d": 54.9,
    "ladder_minus1_pullback": 55.2,
    "ladder_4_base": 52.8,
    "ladder_5_euphoria": 76.3
  },
  {
    "symbol": "2542.TW",
    "name": "興富發",
    "sector": "建材營造業",
    "close": 39.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.09,
    "dog_ma200_bias": 0.01,
    "vr60": 1.5,
    "rs20": 1.08,
    "rs60": 0.89,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 696455.65,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 37.4,
    "ladder_minus1_pullback": 37.0,
    "ladder_4_base": 35.4,
    "ladder_5_euphoria": 51.2
  },
  {
    "symbol": "2889.TW",
    "name": "國票金",
    "sector": "金融保險業",
    "close": 16.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.25,
    "dog_ma200_bias": 0.051,
    "vr60": 1.47,
    "rs20": 1.08,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 420000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.4,
    "ladder_minus1_pullback": 15.8,
    "ladder_4_base": 15.1,
    "ladder_5_euphoria": 21.8
  },
  {
    "symbol": "2030.TW",
    "name": "彰源",
    "sector": "鋼鐵工業",
    "close": 28.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.45,
    "dog_ma200_bias": 0.047,
    "vr60": 2.08,
    "rs20": 0.98,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 706250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.8,
    "ladder_minus1_pullback": 26.6,
    "ladder_4_base": 25.4,
    "ladder_5_euphoria": 36.7
  },
  {
    "symbol": "1709.TW",
    "name": "和益",
    "sector": "化學工業",
    "close": 58.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.07,
    "dog_ma200_bias": 0.147,
    "vr60": 1.46,
    "rs20": 0.96,
    "rs60": 1.09,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 1212338.4,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 54.1,
    "ladder_minus1_pullback": 55.3,
    "ladder_4_base": 52.9,
    "ladder_5_euphoria": 76.4
  },
  {
    "symbol": "1717.TW",
    "name": "長興",
    "sector": "化學工業",
    "close": 71.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.1,
    "dog_ma200_bias": 0.077,
    "vr60": 1.9,
    "rs20": 1.06,
    "rs60": 0.9,
    "shares": 12987,
    "lots": 12,
    "odd_shares": 987,
    "ntd_at_risk": 39999.96,
    "position_cost": 932466.6,
    "constraint": "WEIGHT",
    "atr14": 1.54,
    "low_20d": 64.7,
    "ladder_minus1_pullback": 67.5,
    "ladder_4_base": 64.6,
    "ladder_5_euphoria": 93.3
  },
  {
    "symbol": "1310.TW",
    "name": "台苯",
    "sector": "塑膠工業",
    "close": 9.87,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": 0.147,
    "vr60": 1.4,
    "rs20": 1.02,
    "rs60": 1.15,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 246750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 9.3,
    "ladder_4_base": 8.9,
    "ladder_5_euphoria": 12.8
  },
  {
    "symbol": "1711.TW",
    "name": "永光",
    "sector": "化學工業",
    "close": 43.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.05,
    "dog_ma200_bias": 0.042,
    "vr60": 1.96,
    "rs20": 0.81,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1077500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 40.2,
    "ladder_minus1_pullback": 40.5,
    "ladder_4_base": 38.8,
    "ladder_5_euphoria": 56.0
  },
  {
    "symbol": "6282.TW",
    "name": "康舒",
    "sector": "電子零組件業",
    "close": 42.9,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.09,
    "dog_ma200_bias": -0.196,
    "vr60": 0.93,
    "rs20": 0.34,
    "rs60": 0.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.39,
    "low_20d": 40.9,
    "ladder_minus1_pullback": 40.3,
    "ladder_4_base": 38.6,
    "ladder_5_euphoria": 55.8
  },
  {
    "symbol": "4919.TW",
    "name": "新唐",
    "sector": "半導體業",
    "close": 138.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.08,
    "dog_ma200_bias": 0.098,
    "vr60": 1.14,
    "rs20": 1.23,
    "rs60": 1.06,
    "shares": 6250,
    "lots": 6,
    "odd_shares": 250,
    "ntd_at_risk": 40000.0,
    "position_cost": 865625.0,
    "constraint": "WEIGHT",
    "atr14": 3.2,
    "low_20d": 128.6,
    "ladder_minus1_pullback": 130.2,
    "ladder_4_base": 124.7,
    "ladder_5_euphoria": 180.1
  },
  {
    "symbol": "3042.TW",
    "name": "晶技",
    "sector": "電子零組件業",
    "close": 189.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.23,
    "dog_ma200_bias": 0.057,
    "vr60": 2.03,
    "rs20": 1.1,
    "rs60": 0.96,
    "shares": 4395,
    "lots": 4,
    "odd_shares": 395,
    "ntd_at_risk": 39994.5,
    "position_cost": 832852.5,
    "constraint": "WEIGHT",
    "atr14": 4.55,
    "low_20d": 172.5,
    "ladder_minus1_pullback": 178.1,
    "ladder_4_base": 170.6,
    "ladder_5_euphoria": 246.3
  },
  {
    "symbol": "2492.TW",
    "name": "華新科",
    "sector": "電子零組件業",
    "close": 405.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.16,
    "dog_ma200_bias": -0.014,
    "vr60": 1.32,
    "rs20": 0.83,
    "rs60": 0.81,
    "shares": 2055,
    "lots": 2,
    "odd_shares": 55,
    "ntd_at_risk": 39990.3,
    "position_cost": 833302.5,
    "constraint": "WEIGHT",
    "atr14": 9.73,
    "low_20d": 365.7,
    "ladder_minus1_pullback": 381.2,
    "ladder_4_base": 364.9,
    "ladder_5_euphoria": 527.1
  },
  {
    "symbol": "3167.TW",
    "name": "大量",
    "sector": "電機機械業",
    "close": 960.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.05,
    "dog_ma200_bias": -0.107,
    "vr60": 0.78,
    "rs20": 0.41,
    "rs60": 0.41,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 18.6,
    "low_20d": 865.2,
    "ladder_minus1_pullback": 902.4,
    "ladder_4_base": 864.0,
    "ladder_5_euphoria": 1248.0
  },
  {
    "symbol": "2027.TW",
    "name": "大成鋼",
    "sector": "鋼鐵工業",
    "close": 49.3,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.05,
    "dog_ma200_bias": 0.362,
    "vr60": 1.94,
    "rs20": 1.27,
    "rs60": 1.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.28,
    "low_20d": 46.8,
    "ladder_minus1_pullback": 46.3,
    "ladder_4_base": 44.4,
    "ladder_5_euphoria": 64.1
  },
  {
    "symbol": "3149.TW",
    "name": "正達",
    "sector": "光電業",
    "close": 71.2,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.05,
    "dog_ma200_bias": 0.309,
    "vr60": 2.29,
    "rs20": 1.36,
    "rs60": 1.17,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.56,
    "low_20d": 64.3,
    "ladder_minus1_pullback": 66.9,
    "ladder_4_base": 64.1,
    "ladder_5_euphoria": 92.6
  },
  {
    "symbol": "2377.TW",
    "name": "微星",
    "sector": "電腦及週邊設備業",
    "close": 158.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.4,
    "dog_ma200_bias": 0.036,
    "vr60": 1.4,
    "rs20": 1.14,
    "rs60": 0.8,
    "shares": 4773,
    "lots": 4,
    "odd_shares": 773,
    "ntd_at_risk": 39997.74,
    "position_cost": 754134.0,
    "constraint": "WEIGHT",
    "atr14": 4.19,
    "low_20d": 151.5,
    "ladder_minus1_pullback": 148.5,
    "ladder_4_base": 142.2,
    "ladder_5_euphoria": 205.4
  },
  {
    "symbol": "6548.TWO",
    "name": "長科*",
    "sector": "半導體業",
    "close": 82.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.65,
    "dog_ma200_bias": 0.009,
    "vr60": 1.39,
    "rs20": 1.03,
    "rs60": 0.81,
    "shares": 15873,
    "lots": 15,
    "odd_shares": 873,
    "ntd_at_risk": 39999.96,
    "position_cost": 1304760.6,
    "constraint": "WEIGHT",
    "atr14": 1.26,
    "low_20d": 74.5,
    "ladder_minus1_pullback": 77.3,
    "ladder_4_base": 74.0,
    "ladder_5_euphoria": 106.9
  },
  {
    "symbol": "2371.TW",
    "name": "大同",
    "sector": "電機機械業",
    "close": 29.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.05,
    "dog_ma200_bias": 0.015,
    "vr60": 2.04,
    "rs20": 1.07,
    "rs60": 0.8,
    "shares": 21276,
    "lots": 21,
    "odd_shares": 276,
    "ntd_at_risk": 39998.88,
    "position_cost": 619131.6,
    "constraint": "WEIGHT",
    "atr14": 0.94,
    "low_20d": 26.7,
    "ladder_minus1_pullback": 27.4,
    "ladder_4_base": 26.2,
    "ladder_5_euphoria": 37.8
  },
  {
    "symbol": "6226.TW",
    "name": "光鼎",
    "sector": "光電業",
    "close": 40.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.05,
    "dog_ma200_bias": -0.008,
    "vr60": 1.81,
    "rs20": 0.9,
    "rs60": 1.04,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 826781.8,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 37.5,
    "ladder_minus1_pullback": 37.7,
    "ladder_4_base": 36.1,
    "ladder_5_euphoria": 52.1
  },
  {
    "symbol": "3016.TW",
    "name": "嘉晶",
    "sector": "半導體業",
    "close": 156.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.11,
    "dog_ma200_bias": 0.062,
    "vr60": 2.06,
    "rs20": 1.07,
    "rs60": 0.8,
    "shares": 4938,
    "lots": 4,
    "odd_shares": 938,
    "ntd_at_risk": 39997.8,
    "position_cost": 772797.0,
    "constraint": "WEIGHT",
    "atr14": 4.05,
    "low_20d": 145.3,
    "ladder_minus1_pullback": 147.1,
    "ladder_4_base": 140.8,
    "ladder_5_euphoria": 203.5
  },
  {
    "symbol": "3036.TW",
    "name": "文曄",
    "sector": "電子通路業",
    "close": 208.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.05,
    "dog_ma200_bias": 0.009,
    "vr60": 1.84,
    "rs20": 0.89,
    "rs60": 0.85,
    "shares": 5571,
    "lots": 5,
    "odd_shares": 571,
    "ntd_at_risk": 39999.78,
    "position_cost": 1158768.0,
    "constraint": "WEIGHT",
    "atr14": 3.59,
    "low_20d": 197.5,
    "ladder_minus1_pullback": 195.5,
    "ladder_4_base": 187.2,
    "ladder_5_euphoria": 270.4
  },
  {
    "symbol": "6532.TWO",
    "name": "瑞耘",
    "sector": "半導體業",
    "close": 119.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.05,
    "dog_ma200_bias": 0.006,
    "vr60": 1.63,
    "rs20": 0.83,
    "rs60": 0.89,
    "shares": 9009,
    "lots": 9,
    "odd_shares": 9,
    "ntd_at_risk": 39999.96,
    "position_cost": 1076575.5,
    "constraint": "WEIGHT",
    "atr14": 2.22,
    "low_20d": 110.5,
    "ladder_minus1_pullback": 112.3,
    "ladder_4_base": 107.5,
    "ladder_5_euphoria": 155.3
  },
  {
    "symbol": "4979.TWO",
    "name": "華星光",
    "sector": "通信網路業",
    "close": 542.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.09,
    "dog_ma200_bias": 0.073,
    "vr60": 1.83,
    "rs20": 0.8,
    "rs60": 0.92,
    "shares": 1629,
    "lots": 1,
    "odd_shares": 629,
    "ntd_at_risk": 39975.66,
    "position_cost": 882918.0,
    "constraint": "WEIGHT",
    "atr14": 12.27,
    "low_20d": 492.8,
    "ladder_minus1_pullback": 509.5,
    "ladder_4_base": 487.8,
    "ladder_5_euphoria": 704.6
  },
  {
    "symbol": "5904.TWO",
    "name": "寶雅*",
    "sector": "居家生活",
    "close": 73.1,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.82,
    "dog_ma200_bias": -0.118,
    "vr60": 0.68,
    "rs20": 0.53,
    "rs60": 0.54,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.74,
    "low_20d": 68.9,
    "ladder_minus1_pullback": 68.7,
    "ladder_4_base": 65.8,
    "ladder_5_euphoria": 95.0
  },
  {
    "symbol": "2845.TW",
    "name": "遠東銀",
    "sector": "金融保險業",
    "close": 13.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.95,
    "dog_ma200_bias": 0.044,
    "vr60": 1.25,
    "rs20": 0.92,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 331250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.0,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 11.9,
    "ladder_5_euphoria": 17.2
  },
  {
    "symbol": "3707.TWO",
    "name": "漢磊",
    "sector": "半導體業",
    "close": 77.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.05,
    "dog_ma200_bias": -0.01,
    "vr60": 1.89,
    "rs20": 0.75,
    "rs60": 0.89,
    "shares": 8333,
    "lots": 8,
    "odd_shares": 333,
    "ntd_at_risk": 39998.4,
    "position_cost": 641641.0,
    "constraint": "WEIGHT",
    "atr14": 2.4,
    "low_20d": 73.4,
    "ladder_minus1_pullback": 72.4,
    "ladder_4_base": 69.3,
    "ladder_5_euphoria": 100.1
  },
  {
    "symbol": "2464.TW",
    "name": "盟立",
    "sector": "其他電子業",
    "close": 176.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.13,
    "dog_ma200_bias": 0.073,
    "vr60": 1.57,
    "rs20": 1.12,
    "rs60": 1.01,
    "shares": 4158,
    "lots": 4,
    "odd_shares": 158,
    "ntd_at_risk": 39999.96,
    "position_cost": 731808.0,
    "constraint": "WEIGHT",
    "atr14": 4.81,
    "low_20d": 164.6,
    "ladder_minus1_pullback": 165.4,
    "ladder_4_base": 158.4,
    "ladder_5_euphoria": 228.8
  },
  {
    "symbol": "6179.TWO",
    "name": "亞通",
    "sector": "其他業",
    "close": 36.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.05,
    "dog_ma200_bias": 0.028,
    "vr60": 1.38,
    "rs20": 1.14,
    "rs60": 0.81,
    "shares": 18348,
    "lots": 18,
    "odd_shares": 348,
    "ntd_at_risk": 39998.64,
    "position_cost": 666949.8,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 32.9,
    "ladder_minus1_pullback": 34.2,
    "ladder_4_base": 32.7,
    "ladder_5_euphoria": 47.3
  },
  {
    "symbol": "3450.TW",
    "name": "聯鈞",
    "sector": "半導體業",
    "close": 467.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.25,
    "dog_ma200_bias": 0.045,
    "vr60": 2.02,
    "rs20": 0.79,
    "rs60": 0.9,
    "shares": 1792,
    "lots": 1,
    "odd_shares": 792,
    "ntd_at_risk": 39997.44,
    "position_cost": 837760.0,
    "constraint": "WEIGHT",
    "atr14": 11.16,
    "low_20d": 432.5,
    "ladder_minus1_pullback": 439.4,
    "ladder_4_base": 420.8,
    "ladder_5_euphoria": 607.8
  },
  {
    "symbol": "2104.TW",
    "name": "國際中橡",
    "sector": "橡膠工業",
    "close": 11.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.64,
    "dog_ma200_bias": 0.034,
    "vr60": 1.85,
    "rs20": 1.12,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 298750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.2,
    "ladder_minus1_pullback": 11.2,
    "ladder_4_base": 10.8,
    "ladder_5_euphoria": 15.5
  },
  {
    "symbol": "1434.TW",
    "name": "福懋",
    "sector": "紡織纖維業",
    "close": 20.1,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.39,
    "dog_ma200_bias": -0.062,
    "vr60": 2.09,
    "rs20": 0.46,
    "rs60": 0.77,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 18.8,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.1
  },
  {
    "symbol": "4906.TW",
    "name": "正文",
    "sector": "通信網路業",
    "close": 40.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.21,
    "dog_ma200_bias": 0.108,
    "vr60": 1.35,
    "rs20": 1.32,
    "rs60": 1.28,
    "shares": 20000,
    "lots": 20,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 816000.0,
    "constraint": "WEIGHT",
    "atr14": 1.0,
    "low_20d": 38.9,
    "ladder_minus1_pullback": 38.4,
    "ladder_4_base": 36.7,
    "ladder_5_euphoria": 53.0
  },
  {
    "symbol": "1785.TWO",
    "name": "光洋科",
    "sector": "其他電子業",
    "close": 98.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.06,
    "dog_ma200_bias": 0.073,
    "vr60": 1.99,
    "rs20": 0.75,
    "rs60": 0.9,
    "shares": 6097,
    "lots": 6,
    "odd_shares": 97,
    "ntd_at_risk": 39996.32,
    "position_cost": 601164.2,
    "constraint": "WEIGHT",
    "atr14": 3.28,
    "low_20d": 92.2,
    "ladder_minus1_pullback": 92.7,
    "ladder_4_base": 88.7,
    "ladder_5_euphoria": 128.2
  },
  {
    "symbol": "3498.TWO",
    "name": "陽程",
    "sector": "其他電子業",
    "close": 231.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.09,
    "dog_ma200_bias": 0.073,
    "vr60": 1.64,
    "rs20": 1.06,
    "rs60": 1.3,
    "shares": 2976,
    "lots": 2,
    "odd_shares": 976,
    "ntd_at_risk": 39997.44,
    "position_cost": 687456.0,
    "constraint": "WEIGHT",
    "atr14": 6.72,
    "low_20d": 211.5,
    "ladder_minus1_pullback": 217.1,
    "ladder_4_base": 207.9,
    "ladder_5_euphoria": 300.3
  },
  {
    "symbol": "5309.TWO",
    "name": "系統電",
    "sector": "電子零組件業",
    "close": 67.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": 0.125,
    "vr60": 1.35,
    "rs20": 1.33,
    "rs60": 1.24,
    "shares": 13157,
    "lots": 13,
    "odd_shares": 157,
    "ntd_at_risk": 39997.28,
    "position_cost": 890728.9,
    "constraint": "WEIGHT",
    "atr14": 1.52,
    "low_20d": 64.1,
    "ladder_minus1_pullback": 63.6,
    "ladder_4_base": 60.9,
    "ladder_5_euphoria": 88.0
  },
  {
    "symbol": "1313.TW",
    "name": "聯成",
    "sector": "塑膠工業",
    "close": 12.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.18,
    "dog_ma200_bias": 0.027,
    "vr60": 1.37,
    "rs20": 0.8,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 322500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.2,
    "ladder_minus1_pullback": 12.1,
    "ladder_4_base": 11.6,
    "ladder_5_euphoria": 16.8
  },
  {
    "symbol": "3006.TW",
    "name": "晶豪科",
    "sector": "半導體業",
    "close": 229.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.22,
    "dog_ma200_bias": 0.115,
    "vr60": 1.2,
    "rs20": 1.02,
    "rs60": 1.19,
    "shares": 2824,
    "lots": 2,
    "odd_shares": 824,
    "ntd_at_risk": 39987.84,
    "position_cost": 646696.0,
    "constraint": "WEIGHT",
    "atr14": 7.08,
    "low_20d": 214.1,
    "ladder_minus1_pullback": 215.3,
    "ladder_4_base": 206.1,
    "ladder_5_euphoria": 297.7
  },
  {
    "symbol": "2402.TW",
    "name": "毅嘉",
    "sector": "電子零組件業",
    "close": 63.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.48,
    "dog_ma200_bias": 0.059,
    "vr60": 1.71,
    "rs20": 1.05,
    "rs60": 0.76,
    "shares": 9615,
    "lots": 9,
    "odd_shares": 615,
    "ntd_at_risk": 39998.4,
    "position_cost": 606706.5,
    "constraint": "WEIGHT",
    "atr14": 2.08,
    "low_20d": 59.0,
    "ladder_minus1_pullback": 59.3,
    "ladder_4_base": 56.8,
    "ladder_5_euphoria": 82.0
  },
  {
    "symbol": "1304.TW",
    "name": "台聚",
    "sector": "塑膠工業",
    "close": 13.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.1,
    "dog_ma200_bias": 0.066,
    "vr60": 2.01,
    "rs20": 1.08,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 330000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.4,
    "ladder_minus1_pullback": 12.4,
    "ladder_4_base": 11.9,
    "ladder_5_euphoria": 17.2
  },
  {
    "symbol": "6199.TWO",
    "name": "天品",
    "sector": "其他業",
    "close": 142.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.67,
    "dog_ma200_bias": -0.011,
    "vr60": 1.8,
    "rs20": 0.82,
    "rs60": 0.75,
    "shares": 4484,
    "lots": 4,
    "odd_shares": 484,
    "ntd_at_risk": 39997.28,
    "position_cost": 636728.0,
    "constraint": "WEIGHT",
    "atr14": 4.46,
    "low_20d": 131.2,
    "ladder_minus1_pullback": 133.5,
    "ladder_4_base": 127.8,
    "ladder_5_euphoria": 184.6
  },
  {
    "symbol": "2441.TW",
    "name": "超豐",
    "sector": "半導體業",
    "close": 118.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.09,
    "dog_ma200_bias": -0.222,
    "vr60": 0.76,
    "rs20": 0.3,
    "rs60": 0.27,
    "shares": 2469,
    "lots": 2,
    "odd_shares": 469,
    "ntd_at_risk": 19998.9,
    "position_cost": 292576.5,
    "constraint": "WEIGHT",
    "atr14": 4.05,
    "low_20d": 106.7,
    "ladder_minus1_pullback": 111.4,
    "ladder_4_base": 106.7,
    "ladder_5_euphoria": 154.1
  },
  {
    "symbol": "8111.TWO",
    "name": "立碁",
    "sector": "光電業",
    "close": 82.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.07,
    "dog_ma200_bias": 0.075,
    "vr60": 1.47,
    "rs20": 1.04,
    "rs60": 0.7,
    "shares": 7067,
    "lots": 7,
    "odd_shares": 67,
    "ntd_at_risk": 39999.22,
    "position_cost": 579494.0,
    "constraint": "WEIGHT",
    "atr14": 2.83,
    "low_20d": 77.8,
    "ladder_minus1_pullback": 77.1,
    "ladder_4_base": 73.8,
    "ladder_5_euphoria": 106.6
  },
  {
    "symbol": "6531.TW",
    "name": "愛普*",
    "sector": "半導體業",
    "close": 831.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.05,
    "dog_ma200_bias": 0.045,
    "vr60": 1.82,
    "rs20": 0.77,
    "rs60": 0.74,
    "shares": 762,
    "lots": 0,
    "odd_shares": 762,
    "ntd_at_risk": 39989.76,
    "position_cost": 633222.0,
    "constraint": "WEIGHT",
    "atr14": 26.24,
    "low_20d": 757.8,
    "ladder_minus1_pullback": 781.1,
    "ladder_4_base": 747.9,
    "ladder_5_euphoria": 1080.3
  },
  {
    "symbol": "3717.TW",
    "name": "聯嘉投控",
    "sector": "汽車工業",
    "close": 28.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.05,
    "dog_ma200_bias": 0.011,
    "vr60": 1.56,
    "rs20": 0.95,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 710000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.2,
    "ladder_minus1_pullback": 26.7,
    "ladder_4_base": 25.6,
    "ladder_5_euphoria": 36.9
  },
  {
    "symbol": "2455.TW",
    "name": "全新",
    "sector": "通信網路業",
    "close": 483.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.12,
    "dog_ma200_bias": -0.153,
    "vr60": 0.79,
    "rs20": 0.25,
    "rs60": 0.52,
    "shares": 1119,
    "lots": 1,
    "odd_shares": 119,
    "ntd_at_risk": 19985.34,
    "position_cost": 541036.5,
    "constraint": "WEIGHT",
    "atr14": 8.93,
    "low_20d": 437.9,
    "ladder_minus1_pullback": 454.5,
    "ladder_4_base": 435.2,
    "ladder_5_euphoria": 628.6
  },
  {
    "symbol": "8112.TW",
    "name": "至上",
    "sector": "電子通路業",
    "close": 83.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.2,
    "dog_ma200_bias": 0.041,
    "vr60": 1.4,
    "rs20": 0.8,
    "rs60": 0.75,
    "shares": 10050,
    "lots": 10,
    "odd_shares": 50,
    "ntd_at_risk": 39999.0,
    "position_cost": 841185.0,
    "constraint": "WEIGHT",
    "atr14": 1.99,
    "low_20d": 79.9,
    "ladder_minus1_pullback": 78.7,
    "ladder_4_base": 75.3,
    "ladder_5_euphoria": 108.8
  },
  {
    "symbol": "6213.TW",
    "name": "聯茂",
    "sector": "電子零組件業",
    "close": 799.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.35,
    "dog_ma200_bias": 0.055,
    "vr60": 1.75,
    "rs20": 0.92,
    "rs60": 0.89,
    "shares": 998,
    "lots": 0,
    "odd_shares": 998,
    "ntd_at_risk": 39999.84,
    "position_cost": 797402.0,
    "constraint": "WEIGHT",
    "atr14": 20.04,
    "low_20d": 736.8,
    "ladder_minus1_pullback": 751.1,
    "ladder_4_base": 719.1,
    "ladder_5_euphoria": 1038.7
  },
  {
    "symbol": "6290.TWO",
    "name": "良維",
    "sector": "電子零組件業",
    "close": 275.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.05,
    "dog_ma200_bias": 0.027,
    "vr60": 1.68,
    "rs20": 1.02,
    "rs60": 0.78,
    "shares": 2277,
    "lots": 2,
    "odd_shares": 277,
    "ntd_at_risk": 39984.12,
    "position_cost": 627313.5,
    "constraint": "WEIGHT",
    "atr14": 8.78,
    "low_20d": 254.1,
    "ladder_minus1_pullback": 259.0,
    "ladder_4_base": 248.0,
    "ladder_5_euphoria": 358.2
  },
  {
    "symbol": "5230.TWO",
    "name": "雷笛克光學",
    "sector": "光電業",
    "close": 27.3,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": 0.229,
    "vr60": 2.35,
    "rs20": 1.46,
    "rs60": 1.13,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 24.7,
    "ladder_minus1_pullback": 25.7,
    "ladder_4_base": 24.6,
    "ladder_5_euphoria": 35.5
  },
  {
    "symbol": "9945.TW",
    "name": "潤泰新",
    "sector": "其他業",
    "close": 29.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.55,
    "dog_ma200_bias": -0.01,
    "vr60": 1.37,
    "rs20": 0.6,
    "rs60": 0.47,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 27.5,
    "ladder_minus1_pullback": 27.7,
    "ladder_4_base": 26.6,
    "ladder_5_euphoria": 38.4
  },
  {
    "symbol": "6285.TW",
    "name": "啟碁",
    "sector": "通信網路業",
    "close": 241.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.06,
    "dog_ma200_bias": 0.031,
    "vr60": 1.72,
    "rs20": 0.81,
    "rs60": 0.81,
    "shares": 3091,
    "lots": 3,
    "odd_shares": 91,
    "ntd_at_risk": 39997.54,
    "position_cost": 744931.0,
    "constraint": "WEIGHT",
    "atr14": 6.47,
    "low_20d": 231.0,
    "ladder_minus1_pullback": 226.5,
    "ladder_4_base": 216.9,
    "ladder_5_euphoria": 313.3
  },
  {
    "symbol": "3094.TW",
    "name": "聯傑",
    "sector": "半導體業",
    "close": 58.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.05,
    "dog_ma200_bias": 0.122,
    "vr60": 1.12,
    "rs20": 1.03,
    "rs60": 1.13,
    "shares": 10204,
    "lots": 10,
    "odd_shares": 204,
    "ntd_at_risk": 39999.68,
    "position_cost": 599995.2,
    "constraint": "WEIGHT",
    "atr14": 1.96,
    "low_20d": 56.2,
    "ladder_minus1_pullback": 55.3,
    "ladder_4_base": 52.9,
    "ladder_5_euphoria": 76.4
  },
  {
    "symbol": "2634.TW",
    "name": "漢翔",
    "sector": "航運業",
    "close": 60.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.18,
    "dog_ma200_bias": 0.071,
    "vr60": 1.36,
    "rs20": 1.27,
    "rs60": 1.08,
    "shares": 11049,
    "lots": 11,
    "odd_shares": 49,
    "ntd_at_risk": 39997.38,
    "position_cost": 670674.3,
    "constraint": "WEIGHT",
    "atr14": 1.81,
    "low_20d": 57.8,
    "ladder_minus1_pullback": 57.1,
    "ladder_4_base": 54.6,
    "ladder_5_euphoria": 78.9
  },
  {
    "symbol": "2633.TW",
    "name": "台灣高鐵",
    "sector": "航運業",
    "close": 26.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.95,
    "dog_ma200_bias": 0.031,
    "vr60": 1.61,
    "rs20": 0.77,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 655000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.6,
    "ladder_minus1_pullback": 24.6,
    "ladder_4_base": 23.6,
    "ladder_5_euphoria": 34.1
  },
  {
    "symbol": "3714.TW",
    "name": "富采",
    "sector": "光電業",
    "close": 61.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.26,
    "dog_ma200_bias": 0.001,
    "vr60": 1.95,
    "rs20": 0.54,
    "rs60": 0.74,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.03,
    "low_20d": 57.9,
    "ladder_minus1_pullback": 57.8,
    "ladder_4_base": 55.4,
    "ladder_5_euphoria": 80.0
  },
  {
    "symbol": "1609.TW",
    "name": "大亞",
    "sector": "電器電纜業",
    "close": 39.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.67,
    "dog_ma200_bias": 0.038,
    "vr60": 1.24,
    "rs20": 0.89,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 977500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 35.7,
    "ladder_minus1_pullback": 36.8,
    "ladder_4_base": 35.2,
    "ladder_5_euphoria": 50.8
  },
  {
    "symbol": "6191.TW",
    "name": "精成科",
    "sector": "電子零組件業",
    "close": 90.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.24,
    "dog_ma200_bias": 0.079,
    "vr60": 2.04,
    "rs20": 0.78,
    "rs60": 1.03,
    "shares": 7299,
    "lots": 7,
    "odd_shares": 299,
    "ntd_at_risk": 39998.52,
    "position_cost": 656910.0,
    "constraint": "WEIGHT",
    "atr14": 2.74,
    "low_20d": 82.8,
    "ladder_minus1_pullback": 84.6,
    "ladder_4_base": 81.0,
    "ladder_5_euphoria": 117.0
  },
  {
    "symbol": "2367.TW",
    "name": "燿華",
    "sector": "電子零組件業",
    "close": 44.65,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.14,
    "dog_ma200_bias": -0.274,
    "vr60": 0.83,
    "rs20": 0.51,
    "rs60": 0.46,
    "shares": 6666,
    "lots": 6,
    "odd_shares": 666,
    "ntd_at_risk": 19998.0,
    "position_cost": 297636.9,
    "constraint": "WEIGHT",
    "atr14": 1.5,
    "low_20d": 41.2,
    "ladder_minus1_pullback": 42.0,
    "ladder_4_base": 40.2,
    "ladder_5_euphoria": 58.0
  },
  {
    "symbol": "5425.TWO",
    "name": "台半",
    "sector": "半導體業",
    "close": 92.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.05,
    "dog_ma200_bias": 0.045,
    "vr60": 1.58,
    "rs20": 1.15,
    "rs60": 0.83,
    "shares": 8130,
    "lots": 8,
    "odd_shares": 130,
    "ntd_at_risk": 39999.6,
    "position_cost": 752025.0,
    "constraint": "WEIGHT",
    "atr14": 2.46,
    "low_20d": 88.2,
    "ladder_minus1_pullback": 86.9,
    "ladder_4_base": 83.2,
    "ladder_5_euphoria": 120.2
  },
  {
    "symbol": "3013.TW",
    "name": "晟銘電",
    "sector": "電腦及週邊設備業",
    "close": 94.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.07,
    "dog_ma200_bias": 0.067,
    "vr60": 2.02,
    "rs20": 0.9,
    "rs60": 0.94,
    "shares": 7843,
    "lots": 7,
    "odd_shares": 843,
    "ntd_at_risk": 39999.3,
    "position_cost": 742732.1,
    "constraint": "WEIGHT",
    "atr14": 2.55,
    "low_20d": 90.3,
    "ladder_minus1_pullback": 89.0,
    "ladder_4_base": 85.2,
    "ladder_5_euphoria": 123.1
  },
  {
    "symbol": "3673.TW",
    "name": "TPK-KY",
    "sector": "光電業",
    "close": 69.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.09,
    "dog_ma200_bias": 0.046,
    "vr60": 1.69,
    "rs20": 1.01,
    "rs60": 0.82,
    "shares": 8695,
    "lots": 8,
    "odd_shares": 695,
    "ntd_at_risk": 39997.0,
    "position_cost": 607780.5,
    "constraint": "WEIGHT",
    "atr14": 2.3,
    "low_20d": 66.7,
    "ladder_minus1_pullback": 65.7,
    "ladder_4_base": 62.9,
    "ladder_5_euphoria": 90.9
  },
  {
    "symbol": "6148.TWO",
    "name": "驊宏資",
    "sector": "資訊服務業",
    "close": 38.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.42,
    "dog_ma200_bias": -0.002,
    "vr60": 1.68,
    "rs20": 0.96,
    "rs60": 0.95,
    "shares": 23529,
    "lots": 23,
    "odd_shares": 529,
    "ntd_at_risk": 39999.3,
    "position_cost": 897631.35,
    "constraint": "WEIGHT",
    "atr14": 0.85,
    "low_20d": 34.7,
    "ladder_minus1_pullback": 35.9,
    "ladder_4_base": 34.3,
    "ladder_5_euphoria": 49.6
  },
  {
    "symbol": "3715.TW",
    "name": "定穎投控",
    "sector": "電子零組件業",
    "close": 131.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.05,
    "dog_ma200_bias": 0.002,
    "vr60": 1.2,
    "rs20": 0.76,
    "rs60": 0.8,
    "shares": 6134,
    "lots": 6,
    "odd_shares": 134,
    "ntd_at_risk": 39993.68,
    "position_cost": 806621.0,
    "constraint": "WEIGHT",
    "atr14": 3.26,
    "low_20d": 126.1,
    "ladder_minus1_pullback": 123.6,
    "ladder_4_base": 118.4,
    "ladder_5_euphoria": 171.0
  },
  {
    "symbol": "1597.TW",
    "name": "直得",
    "sector": "電機機械業",
    "close": 144.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.05,
    "dog_ma200_bias": 0.047,
    "vr60": 1.69,
    "rs20": 0.96,
    "rs60": 0.99,
    "shares": 4048,
    "lots": 4,
    "odd_shares": 48,
    "ntd_at_risk": 39994.24,
    "position_cost": 584936.0,
    "constraint": "WEIGHT",
    "atr14": 4.94,
    "low_20d": 138.1,
    "ladder_minus1_pullback": 135.8,
    "ladder_4_base": 130.1,
    "ladder_5_euphoria": 187.8
  },
  {
    "symbol": "6005.TW",
    "name": "群益證",
    "sector": "金融保險業",
    "close": 32.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.29,
    "dog_ma200_bias": 0.005,
    "vr60": 1.51,
    "rs20": 0.86,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 806250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.4,
    "ladder_minus1_pullback": 30.3,
    "ladder_4_base": 29.0,
    "ladder_5_euphoria": 41.9
  },
  {
    "symbol": "2383.TW",
    "name": "台光電",
    "sector": "電子零組件業",
    "close": 5120.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.4,
    "dog_ma200_bias": 0.053,
    "vr60": 1.3,
    "rs20": 1.07,
    "rs60": 0.85,
    "shares": 125,
    "lots": 0,
    "odd_shares": 125,
    "ntd_at_risk": 39900.0,
    "position_cost": 640000.0,
    "constraint": "WEIGHT",
    "atr14": 159.6,
    "low_20d": 4860.0,
    "ladder_minus1_pullback": 4812.8,
    "ladder_4_base": 4608.0,
    "ladder_5_euphoria": 6656.0
  },
  {
    "symbol": "3236.TWO",
    "name": "千如",
    "sector": "電子零組件業",
    "close": 55.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": 0.057,
    "vr60": 2.0,
    "rs20": 0.76,
    "rs60": 0.77,
    "shares": 19607,
    "lots": 19,
    "odd_shares": 607,
    "ntd_at_risk": 39998.28,
    "position_cost": 1078385.0,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 50.9,
    "ladder_minus1_pullback": 51.7,
    "ladder_4_base": 49.5,
    "ladder_5_euphoria": 71.5
  },
  {
    "symbol": "3005.TW",
    "name": "神基",
    "sector": "電腦及週邊設備業",
    "close": 121.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.6,
    "dog_ma200_bias": -0.01,
    "vr60": 1.23,
    "rs20": 0.99,
    "rs60": 0.95,
    "shares": 10582,
    "lots": 10,
    "odd_shares": 582,
    "ntd_at_risk": 39999.96,
    "position_cost": 1280422.0,
    "constraint": "WEIGHT",
    "atr14": 1.89,
    "low_20d": 109.1,
    "ladder_minus1_pullback": 113.7,
    "ladder_4_base": 108.9,
    "ladder_5_euphoria": 157.3
  },
  {
    "symbol": "2472.TW",
    "name": "立隆電",
    "sector": "電子零組件業",
    "close": 227.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": -0.015,
    "vr60": 1.87,
    "rs20": 0.91,
    "rs60": 0.78,
    "shares": 3571,
    "lots": 3,
    "odd_shares": 571,
    "ntd_at_risk": 39995.2,
    "position_cost": 810617.0,
    "constraint": "WEIGHT",
    "atr14": 5.6,
    "low_20d": 209.6,
    "ladder_minus1_pullback": 213.4,
    "ladder_4_base": 204.3,
    "ladder_5_euphoria": 295.1
  },
  {
    "symbol": "1440.TW",
    "name": "南紡",
    "sector": "紡織纖維業",
    "close": 14.1,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.64,
    "dog_ma200_bias": 0.223,
    "vr60": 2.46,
    "rs20": 1.17,
    "rs60": 1.28,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 12.9,
    "ladder_minus1_pullback": 13.3,
    "ladder_4_base": 12.7,
    "ladder_5_euphoria": 18.3
  },
  {
    "symbol": "6438.TW",
    "name": "迅得",
    "sector": "其他電子業",
    "close": 180.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.22,
    "dog_ma200_bias": -0.133,
    "vr60": 0.98,
    "rs20": 0.33,
    "rs60": 0.4,
    "shares": 2949,
    "lots": 2,
    "odd_shares": 949,
    "ntd_at_risk": 19994.22,
    "position_cost": 530820.0,
    "constraint": "WEIGHT",
    "atr14": 3.39,
    "low_20d": 172.5,
    "ladder_minus1_pullback": 169.2,
    "ladder_4_base": 162.0,
    "ladder_5_euphoria": 234.0
  },
  {
    "symbol": "2369.TW",
    "name": "菱生",
    "sector": "半導體業",
    "close": 29.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.32,
    "dog_ma200_bias": 0.012,
    "vr60": 1.47,
    "rs20": 0.81,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 743750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.3,
    "ladder_minus1_pullback": 28.0,
    "ladder_4_base": 26.8,
    "ladder_5_euphoria": 38.7
  },
  {
    "symbol": "6620.TWO",
    "name": "漢達",
    "sector": "生技醫療業",
    "close": 130.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": 0.002,
    "vr60": 1.47,
    "rs20": 0.77,
    "rs60": 1.03,
    "shares": 8849,
    "lots": 8,
    "odd_shares": 849,
    "ntd_at_risk": 39997.48,
    "position_cost": 1154794.5,
    "constraint": "WEIGHT",
    "atr14": 2.26,
    "low_20d": 123.6,
    "ladder_minus1_pullback": 122.7,
    "ladder_4_base": 117.5,
    "ladder_5_euphoria": 169.7
  },
  {
    "symbol": "2605.TW",
    "name": "新興",
    "sector": "航運業",
    "close": 36.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.05,
    "dog_ma200_bias": 0.068,
    "vr60": 2.02,
    "rs20": 1.0,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 900000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 33.0,
    "ladder_minus1_pullback": 33.8,
    "ladder_4_base": 32.4,
    "ladder_5_euphoria": 46.8
  },
  {
    "symbol": "1305.TW",
    "name": "華夏",
    "sector": "塑膠工業",
    "close": 13.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.17,
    "dog_ma200_bias": 0.03,
    "vr60": 2.08,
    "rs20": 1.13,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 328750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.2,
    "ladder_minus1_pullback": 12.4,
    "ladder_4_base": 11.8,
    "ladder_5_euphoria": 17.1
  },
  {
    "symbol": "1504.TW",
    "name": "東元",
    "sector": "電機機械業",
    "close": 69.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.19,
    "dog_ma200_bias": 0.059,
    "vr60": 1.49,
    "rs20": 0.92,
    "rs60": 0.75,
    "shares": 13157,
    "lots": 13,
    "odd_shares": 157,
    "ntd_at_risk": 39997.28,
    "position_cost": 910464.4,
    "constraint": "WEIGHT",
    "atr14": 1.52,
    "low_20d": 64.1,
    "ladder_minus1_pullback": 65.0,
    "ladder_4_base": 62.3,
    "ladder_5_euphoria": 90.0
  },
  {
    "symbol": "3518.TW",
    "name": "柏騰",
    "sector": "其他電子業",
    "close": 41.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.05,
    "dog_ma200_bias": 0.018,
    "vr60": 1.88,
    "rs20": 0.94,
    "rs60": 1.0,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 668547.05,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 38.6,
    "ladder_minus1_pullback": 39.0,
    "ladder_4_base": 37.3,
    "ladder_5_euphoria": 53.9
  },
  {
    "symbol": "3311.TW",
    "name": "閎暉",
    "sector": "通信網路業",
    "close": 50.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.06,
    "dog_ma200_bias": 0.01,
    "vr60": 1.84,
    "rs20": 1.07,
    "rs60": 1.02,
    "shares": 17094,
    "lots": 17,
    "odd_shares": 94,
    "ntd_at_risk": 39999.96,
    "position_cost": 866665.8,
    "constraint": "WEIGHT",
    "atr14": 1.17,
    "low_20d": 48.1,
    "ladder_minus1_pullback": 47.7,
    "ladder_4_base": 45.6,
    "ladder_5_euphoria": 65.9
  },
  {
    "symbol": "8028.TW",
    "name": "昇陽半導體",
    "sector": "半導體業",
    "close": 256.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.16,
    "dog_ma200_bias": -0.024,
    "vr60": 2.17,
    "rs20": 0.6,
    "rs60": 0.5,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 7.36,
    "low_20d": 232.1,
    "ladder_minus1_pullback": 240.6,
    "ladder_4_base": 230.4,
    "ladder_5_euphoria": 332.8
  },
  {
    "symbol": "2515.TW",
    "name": "中工",
    "sector": "建材營造業",
    "close": 11.85,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": 0.221,
    "vr60": 2.25,
    "rs20": 1.47,
    "rs60": 1.4,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 11.0,
    "ladder_minus1_pullback": 11.1,
    "ladder_4_base": 10.7,
    "ladder_5_euphoria": 15.4
  },
  {
    "symbol": "2347.TW",
    "name": "聯強",
    "sector": "電子通路業",
    "close": 102.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.62,
    "dog_ma200_bias": 0.147,
    "vr60": 1.16,
    "rs20": 1.06,
    "rs60": 1.17,
    "shares": 9174,
    "lots": 9,
    "odd_shares": 174,
    "ntd_at_risk": 39998.64,
    "position_cost": 940335.0,
    "constraint": "WEIGHT",
    "atr14": 2.18,
    "low_20d": 93.5,
    "ladder_minus1_pullback": 96.3,
    "ladder_4_base": 92.2,
    "ladder_5_euphoria": 133.2
  },
  {
    "symbol": "6234.TWO",
    "name": "高僑",
    "sector": "光電業",
    "close": 44.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.32,
    "dog_ma200_bias": 0.04,
    "vr60": 1.99,
    "rs20": 0.83,
    "rs60": 0.97,
    "shares": 18181,
    "lots": 18,
    "odd_shares": 181,
    "ntd_at_risk": 39998.2,
    "position_cost": 810872.6,
    "constraint": "WEIGHT",
    "atr14": 1.1,
    "low_20d": 40.5,
    "ladder_minus1_pullback": 41.9,
    "ladder_4_base": 40.1,
    "ladder_5_euphoria": 58.0
  },
  {
    "symbol": "6163.TWO",
    "name": "華電網",
    "sector": "資訊服務業",
    "close": 43.85,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.05,
    "dog_ma200_bias": -0.099,
    "vr60": 0.8,
    "rs20": 0.47,
    "rs60": 0.65,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.31,
    "low_20d": 39.9,
    "ladder_minus1_pullback": 41.2,
    "ladder_4_base": 39.5,
    "ladder_5_euphoria": 57.0
  },
  {
    "symbol": "2332.TW",
    "name": "友訊",
    "sector": "通信網路業",
    "close": 20.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.08,
    "dog_ma200_bias": 0.013,
    "vr60": 2.06,
    "rs20": 0.76,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 506250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.9,
    "ladder_minus1_pullback": 19.0,
    "ladder_4_base": 18.2,
    "ladder_5_euphoria": 26.3
  },
  {
    "symbol": "2498.TW",
    "name": "宏達電",
    "sector": "通信網路業",
    "close": 39.85,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.08,
    "dog_ma200_bias": -0.065,
    "vr60": 0.64,
    "rs20": 0.65,
    "rs60": 0.52,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.9,
    "low_20d": 36.7,
    "ladder_minus1_pullback": 37.5,
    "ladder_4_base": 35.9,
    "ladder_5_euphoria": 51.8
  },
  {
    "symbol": "6933.TW",
    "name": "AMAX-KY",
    "sector": "電腦及週邊設備業",
    "close": 410.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.33,
    "dog_ma200_bias": -0.236,
    "vr60": 0.92,
    "rs20": 0.28,
    "rs60": 0.52,
    "shares": 1328,
    "lots": 1,
    "odd_shares": 328,
    "ntd_at_risk": 19999.68,
    "position_cost": 545144.0,
    "constraint": "WEIGHT",
    "atr14": 7.53,
    "low_20d": 393.2,
    "ladder_minus1_pullback": 385.9,
    "ladder_4_base": 369.4,
    "ladder_5_euphoria": 533.6
  },
  {
    "symbol": "1727.TW",
    "name": "中華化",
    "sector": "化學工業",
    "close": 96.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.05,
    "dog_ma200_bias": 0.058,
    "vr60": 1.54,
    "rs20": 0.96,
    "rs60": 0.83,
    "shares": 7782,
    "lots": 7,
    "odd_shares": 782,
    "ntd_at_risk": 39999.48,
    "position_cost": 747850.2,
    "constraint": "WEIGHT",
    "atr14": 2.57,
    "low_20d": 90.6,
    "ladder_minus1_pullback": 90.3,
    "ladder_4_base": 86.5,
    "ladder_5_euphoria": 124.9
  },
  {
    "symbol": "6168.TW",
    "name": "宏齊",
    "sector": "光電業",
    "close": 34.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.06,
    "dog_ma200_bias": 0.006,
    "vr60": 1.66,
    "rs20": 0.95,
    "rs60": 0.73,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 719568.2,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 31.5,
    "ladder_minus1_pullback": 32.8,
    "ladder_4_base": 31.4,
    "ladder_5_euphoria": 45.4
  },
  {
    "symbol": "8299.TWO",
    "name": "群聯",
    "sector": "半導體業",
    "close": 1830.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.32,
    "dog_ma200_bias": 0.078,
    "vr60": 1.62,
    "rs20": 1.09,
    "rs60": 1.02,
    "shares": 700,
    "lots": 0,
    "odd_shares": 700,
    "ntd_at_risk": 39970.0,
    "position_cost": 1281000.0,
    "constraint": "WEIGHT",
    "atr14": 28.55,
    "low_20d": 1737.0,
    "ladder_minus1_pullback": 1720.2,
    "ladder_4_base": 1647.0,
    "ladder_5_euphoria": 2379.0
  },
  {
    "symbol": "8422.TW",
    "name": "可寧衛*",
    "sector": "綠能環保",
    "close": 25.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.33,
    "dog_ma200_bias": 0.017,
    "vr60": 1.57,
    "rs20": 0.98,
    "rs60": 0.78,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 627500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.6,
    "ladder_minus1_pullback": 23.6,
    "ladder_4_base": 22.6,
    "ladder_5_euphoria": 32.6
  },
  {
    "symbol": "2363.TW",
    "name": "矽統",
    "sector": "半導體業",
    "close": 53.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.2,
    "dog_ma200_bias": -0.005,
    "vr60": 1.43,
    "rs20": 1.12,
    "rs60": 0.9,
    "shares": 13245,
    "lots": 13,
    "odd_shares": 245,
    "ntd_at_risk": 39999.9,
    "position_cost": 712581.0,
    "constraint": "WEIGHT",
    "atr14": 1.51,
    "low_20d": 50.4,
    "ladder_minus1_pullback": 50.6,
    "ladder_4_base": 48.4,
    "ladder_5_euphoria": 69.9
  },
  {
    "symbol": "9933.TW",
    "name": "中鼎",
    "sector": "其他業",
    "close": 42.4,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.24,
    "dog_ma200_bias": -0.142,
    "vr60": 0.65,
    "rs20": 0.42,
    "rs60": 0.48,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 39.9,
    "ladder_minus1_pullback": 39.9,
    "ladder_4_base": 38.2,
    "ladder_5_euphoria": 55.1
  },
  {
    "symbol": "2354.TW",
    "name": "鴻準",
    "sector": "其他電子業",
    "close": 62.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.2,
    "dog_ma200_bias": 0.063,
    "vr60": 1.65,
    "rs20": 1.01,
    "rs60": 0.94,
    "shares": 14925,
    "lots": 14,
    "odd_shares": 925,
    "ntd_at_risk": 39999.0,
    "position_cost": 926842.5,
    "constraint": "WEIGHT",
    "atr14": 1.34,
    "low_20d": 57.9,
    "ladder_minus1_pullback": 58.4,
    "ladder_4_base": 55.9,
    "ladder_5_euphoria": 80.7
  },
  {
    "symbol": "6547.TWO",
    "name": "高端疫苗",
    "sector": "生技醫療業",
    "close": 51.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.15,
    "dog_ma200_bias": 0.091,
    "vr60": 1.54,
    "rs20": 1.34,
    "rs60": 1.16,
    "shares": 11695,
    "lots": 11,
    "odd_shares": 695,
    "ntd_at_risk": 39996.9,
    "position_cost": 605801.0,
    "constraint": "WEIGHT",
    "atr14": 1.71,
    "low_20d": 48.0,
    "ladder_minus1_pullback": 48.7,
    "ladder_4_base": 46.6,
    "ladder_5_euphoria": 67.3
  },
  {
    "symbol": "3532.TW",
    "name": "台勝科",
    "sector": "半導體業",
    "close": 400.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.06,
    "dog_ma200_bias": 0.029,
    "vr60": 1.35,
    "rs20": 1.07,
    "rs60": 0.76,
    "shares": 1850,
    "lots": 1,
    "odd_shares": 850,
    "ntd_at_risk": 39997.0,
    "position_cost": 740000.0,
    "constraint": "WEIGHT",
    "atr14": 10.81,
    "low_20d": 371.3,
    "ladder_minus1_pullback": 376.0,
    "ladder_4_base": 360.0,
    "ladder_5_euphoria": 520.0
  },
  {
    "symbol": "2352.TW",
    "name": "佳世達",
    "sector": "電腦及週邊設備業",
    "close": 29.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.3,
    "dog_ma200_bias": 0.052,
    "vr60": 1.64,
    "rs20": 1.12,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 725000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.8,
    "ladder_minus1_pullback": 27.3,
    "ladder_4_base": 26.1,
    "ladder_5_euphoria": 37.7
  },
  {
    "symbol": "2646.TW",
    "name": "星宇航空",
    "sector": "航運業",
    "close": 20.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.67,
    "dog_ma200_bias": 0.044,
    "vr60": 1.25,
    "rs20": 0.76,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 505000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.3,
    "ladder_minus1_pullback": 19.0,
    "ladder_4_base": 18.2,
    "ladder_5_euphoria": 26.3
  },
  {
    "symbol": "8996.TW",
    "name": "高力",
    "sector": "電機機械業",
    "close": 1520.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": 0.075,
    "vr60": 1.8,
    "rs20": 1.06,
    "rs60": 0.84,
    "shares": 561,
    "lots": 0,
    "odd_shares": 561,
    "ntd_at_risk": 39965.64,
    "position_cost": 852720.0,
    "constraint": "WEIGHT",
    "atr14": 35.62,
    "low_20d": 1390.2,
    "ladder_minus1_pullback": 1428.8,
    "ladder_4_base": 1368.0,
    "ladder_5_euphoria": 1976.0
  },
  {
    "symbol": "6152.TW",
    "name": "百一",
    "sector": "通信網路業",
    "close": 17.7,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.05,
    "dog_ma200_bias": 0.004,
    "vr60": 1.51,
    "rs20": 0.65,
    "rs60": 0.45,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 16.8,
    "ladder_minus1_pullback": 16.6,
    "ladder_4_base": 15.9,
    "ladder_5_euphoria": 23.0
  },
  {
    "symbol": "5864.TWO",
    "name": "致和證",
    "sector": "金融保險業",
    "close": 38.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.05,
    "dog_ma200_bias": 0.017,
    "vr60": 1.76,
    "rs20": 1.02,
    "rs60": 0.92,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 799978.4,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 34.9,
    "ladder_minus1_pullback": 36.5,
    "ladder_4_base": 34.9,
    "ladder_5_euphoria": 50.4
  },
  {
    "symbol": "2851.TW",
    "name": "中再保",
    "sector": "金融保險業",
    "close": 53.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.95,
    "dog_ma200_bias": 0.028,
    "vr60": 1.64,
    "rs20": 0.75,
    "rs60": 0.89,
    "shares": 21505,
    "lots": 21,
    "odd_shares": 505,
    "ntd_at_risk": 39999.3,
    "position_cost": 1144066.0,
    "constraint": "WEIGHT",
    "atr14": 0.93,
    "low_20d": 50.5,
    "ladder_minus1_pullback": 50.0,
    "ladder_4_base": 47.9,
    "ladder_5_euphoria": 69.2
  },
  {
    "symbol": "3260.TWO",
    "name": "威剛",
    "sector": "半導體業",
    "close": 350.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": -0.079,
    "vr60": 1.78,
    "rs20": 0.5,
    "rs60": 0.79,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 7.93,
    "low_20d": 323.9,
    "ladder_minus1_pullback": 329.0,
    "ladder_4_base": 315.0,
    "ladder_5_euphoria": 455.0
  },
  {
    "symbol": "3033.TW",
    "name": "威健",
    "sector": "電子通路業",
    "close": 42.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.05,
    "dog_ma200_bias": 0.061,
    "vr60": 1.81,
    "rs20": 1.07,
    "rs60": 1.02,
    "shares": 16806,
    "lots": 16,
    "odd_shares": 806,
    "ntd_at_risk": 39998.28,
    "position_cost": 717616.2,
    "constraint": "WEIGHT",
    "atr14": 1.19,
    "low_20d": 38.8,
    "ladder_minus1_pullback": 40.1,
    "ladder_4_base": 38.4,
    "ladder_5_euphoria": 55.5
  },
  {
    "symbol": "4763.TW",
    "name": "材料*-KY",
    "sector": "化學工業",
    "close": 46.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.18,
    "dog_ma200_bias": -0.069,
    "vr60": 1.39,
    "rs20": 0.45,
    "rs60": 0.52,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.55,
    "low_20d": 43.8,
    "ladder_minus1_pullback": 43.7,
    "ladder_4_base": 41.9,
    "ladder_5_euphoria": 60.5
  },
  {
    "symbol": "2208.TW",
    "name": "台船",
    "sector": "航運業",
    "close": 18.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.05,
    "dog_ma200_bias": 0.158,
    "vr60": 1.21,
    "rs20": 1.11,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 450000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.3,
    "ladder_minus1_pullback": 16.9,
    "ladder_4_base": 16.2,
    "ladder_5_euphoria": 23.4
  },
  {
    "symbol": "8050.TWO",
    "name": "廣積",
    "sector": "電腦及週邊設備業",
    "close": 65.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.26,
    "dog_ma200_bias": 0.021,
    "vr60": 1.71,
    "rs20": 1.15,
    "rs60": 0.78,
    "shares": 19417,
    "lots": 19,
    "odd_shares": 417,
    "ntd_at_risk": 39999.02,
    "position_cost": 1265988.4,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 60.1,
    "ladder_minus1_pullback": 61.3,
    "ladder_4_base": 58.7,
    "ladder_5_euphoria": 84.8
  },
  {
    "symbol": "2855.TW",
    "name": "統一證",
    "sector": "金融保險業",
    "close": 59.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.33,
    "dog_ma200_bias": 0.048,
    "vr60": 1.96,
    "rs20": 1.01,
    "rs60": 1.0,
    "shares": 20000,
    "lots": 20,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1182000.0,
    "constraint": "WEIGHT",
    "atr14": 1.0,
    "low_20d": 53.9,
    "ladder_minus1_pullback": 55.6,
    "ladder_4_base": 53.2,
    "ladder_5_euphoria": 76.8
  },
  {
    "symbol": "2103.TW",
    "name": "台橡",
    "sector": "橡膠工業",
    "close": 28.6,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.05,
    "dog_ma200_bias": -0.004,
    "vr60": 1.38,
    "rs20": 0.53,
    "rs60": 0.64,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 26.2,
    "ladder_minus1_pullback": 26.9,
    "ladder_4_base": 25.7,
    "ladder_5_euphoria": 37.2
  },
  {
    "symbol": "6443.TW",
    "name": "元晶",
    "sector": "光電業",
    "close": 25.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": -0.019,
    "vr60": 1.35,
    "rs20": 0.95,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 641250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.1,
    "ladder_minus1_pullback": 24.1,
    "ladder_4_base": 23.1,
    "ladder_5_euphoria": 33.3
  },
  {
    "symbol": "6155.TW",
    "name": "鈞寶",
    "sector": "電子零組件業",
    "close": 71.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.34,
    "dog_ma200_bias": 0.058,
    "vr60": 1.71,
    "rs20": 1.09,
    "rs60": 0.73,
    "shares": 12345,
    "lots": 12,
    "odd_shares": 345,
    "ntd_at_risk": 39997.8,
    "position_cost": 876495.0,
    "constraint": "WEIGHT",
    "atr14": 1.62,
    "low_20d": 65.2,
    "ladder_minus1_pullback": 66.7,
    "ladder_4_base": 63.9,
    "ladder_5_euphoria": 92.3
  },
  {
    "symbol": "8110.TW",
    "name": "華東",
    "sector": "半導體業",
    "close": 45.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.17,
    "dog_ma200_bias": 0.033,
    "vr60": 1.24,
    "rs20": 0.83,
    "rs60": 1.0,
    "shares": 13698,
    "lots": 13,
    "odd_shares": 698,
    "ntd_at_risk": 39998.16,
    "position_cost": 626683.5,
    "constraint": "WEIGHT",
    "atr14": 1.46,
    "low_20d": 41.3,
    "ladder_minus1_pullback": 43.0,
    "ladder_4_base": 41.2,
    "ladder_5_euphoria": 59.5
  },
  {
    "symbol": "2360.TW",
    "name": "致茂",
    "sector": "其他電子業",
    "close": 2025.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.05,
    "dog_ma200_bias": 0.069,
    "vr60": 1.63,
    "rs20": 0.77,
    "rs60": 0.73,
    "shares": 439,
    "lots": 0,
    "odd_shares": 439,
    "ntd_at_risk": 39966.56,
    "position_cost": 888975.0,
    "constraint": "WEIGHT",
    "atr14": 45.52,
    "low_20d": 1868.9,
    "ladder_minus1_pullback": 1903.5,
    "ladder_4_base": 1822.5,
    "ladder_5_euphoria": 2632.5
  },
  {
    "symbol": "2101.TW",
    "name": "南港",
    "sector": "橡膠工業",
    "close": 30.25,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.82,
    "dog_ma200_bias": 0.365,
    "vr60": 2.5,
    "rs20": 1.35,
    "rs60": 1.11,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 29.0,
    "ladder_minus1_pullback": 28.4,
    "ladder_4_base": 27.2,
    "ladder_5_euphoria": 39.3
  },
  {
    "symbol": "3017.TW",
    "name": "奇鋐",
    "sector": "電腦及週邊設備業",
    "close": 3085.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.21,
    "dog_ma200_bias": 0.011,
    "vr60": 2.07,
    "rs20": 0.98,
    "rs60": 0.96,
    "shares": 302,
    "lots": 0,
    "odd_shares": 302,
    "ntd_at_risk": 39984.8,
    "position_cost": 931670.0,
    "constraint": "WEIGHT",
    "atr14": 66.2,
    "low_20d": 2834.3,
    "ladder_minus1_pullback": 2899.9,
    "ladder_4_base": 2776.5,
    "ladder_5_euphoria": 4010.5
  },
  {
    "symbol": "4976.TW",
    "name": "佳凌",
    "sector": "光電業",
    "close": 39.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.27,
    "dog_ma200_bias": 0.051,
    "vr60": 1.56,
    "rs20": 0.78,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 986250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 37.4,
    "ladder_minus1_pullback": 37.1,
    "ladder_4_base": 35.5,
    "ladder_5_euphoria": 51.3
  },
  {
    "symbol": "2838.TW",
    "name": "聯邦銀",
    "sector": "金融保險業",
    "close": 20.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.6,
    "dog_ma200_bias": 0.004,
    "vr60": 1.95,
    "rs20": 0.91,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 512500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.6,
    "ladder_minus1_pullback": 19.3,
    "ladder_4_base": 18.4,
    "ladder_5_euphoria": 26.7
  },
  {
    "symbol": "6885.TW",
    "name": "全福生技",
    "sector": "生技醫療業",
    "close": 33.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.44,
    "dog_ma200_bias": 0.013,
    "vr60": 1.88,
    "rs20": 0.81,
    "rs60": 1.05,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 592916.5,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 30.4,
    "ladder_minus1_pullback": 31.5,
    "ladder_4_base": 30.2,
    "ladder_5_euphoria": 43.6
  },
  {
    "symbol": "4989.TW",
    "name": "榮科",
    "sector": "電子零組件業",
    "close": 65.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": 0.052,
    "vr60": 1.65,
    "rs20": 1.14,
    "rs60": 0.72,
    "shares": 10000,
    "lots": 10,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 652000.0,
    "constraint": "WEIGHT",
    "atr14": 2.0,
    "low_20d": 62.2,
    "ladder_minus1_pullback": 61.3,
    "ladder_4_base": 58.7,
    "ladder_5_euphoria": 84.8
  },
  {
    "symbol": "1229.TW",
    "name": "聯華",
    "sector": "食品工業",
    "close": 41.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.14,
    "dog_ma200_bias": 0.112,
    "vr60": 1.55,
    "rs20": 1.09,
    "rs60": 1.21,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1035000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 38.9,
    "ladder_minus1_pullback": 38.9,
    "ladder_4_base": 37.3,
    "ladder_5_euphoria": 53.8
  },
  {
    "symbol": "2254.TW",
    "name": "巨鎧精密-創",
    "sector": "汽車工業",
    "close": 94.3,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.83,
    "dog_ma200_bias": -0.066,
    "vr60": 0.74,
    "rs20": 0.57,
    "rs60": 0.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.95,
    "low_20d": 89.0,
    "ladder_minus1_pullback": 88.6,
    "ladder_4_base": 84.9,
    "ladder_5_euphoria": 122.6
  },
  {
    "symbol": "2897.TW",
    "name": "王道銀行",
    "sector": "金融保險業",
    "close": 10.85,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.33,
    "dog_ma200_bias": -0.231,
    "vr60": 1.1,
    "rs20": 0.4,
    "rs60": 0.31,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 135625.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.1,
    "ladder_minus1_pullback": 10.2,
    "ladder_4_base": 9.8,
    "ladder_5_euphoria": 14.1
  },
  {
    "symbol": "2820.TW",
    "name": "華票",
    "sector": "金融保險業",
    "close": 16.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.67,
    "dog_ma200_bias": -0.14,
    "vr60": 0.84,
    "rs20": 0.53,
    "rs60": 0.38,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 15.4,
    "ladder_minus1_pullback": 15.8,
    "ladder_4_base": 15.1,
    "ladder_5_euphoria": 21.8
  },
  {
    "symbol": "2351.TW",
    "name": "順德",
    "sector": "半導體業",
    "close": 205.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.61,
    "dog_ma200_bias": 0.042,
    "vr60": 1.92,
    "rs20": 1.04,
    "rs60": 0.73,
    "shares": 2844,
    "lots": 2,
    "odd_shares": 844,
    "ntd_at_risk": 39986.64,
    "position_cost": 583020.0,
    "constraint": "WEIGHT",
    "atr14": 7.03,
    "low_20d": 191.7,
    "ladder_minus1_pullback": 192.7,
    "ladder_4_base": 184.5,
    "ladder_5_euphoria": 266.5
  },
  {
    "symbol": "3044.TW",
    "name": "健鼎",
    "sector": "電子零組件業",
    "close": 586.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.62,
    "dog_ma200_bias": 0.079,
    "vr60": 1.48,
    "rs20": 1.2,
    "rs60": 1.2,
    "shares": 1956,
    "lots": 1,
    "odd_shares": 956,
    "ntd_at_risk": 39980.64,
    "position_cost": 1146216.0,
    "constraint": "WEIGHT",
    "atr14": 10.22,
    "low_20d": 544.0,
    "ladder_minus1_pullback": 550.8,
    "ladder_4_base": 527.4,
    "ladder_5_euphoria": 761.8
  },
  {
    "symbol": "6949.TW",
    "name": "沛爾生醫*-創",
    "sector": "生技醫療業",
    "close": 39.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.24,
    "dog_ma200_bias": 0.012,
    "vr60": 1.3,
    "rs20": 0.75,
    "rs60": 0.81,
    "shares": 18181,
    "lots": 18,
    "odd_shares": 181,
    "ntd_at_risk": 39998.2,
    "position_cost": 709059.0,
    "constraint": "WEIGHT",
    "atr14": 1.1,
    "low_20d": 35.2,
    "ladder_minus1_pullback": 36.7,
    "ladder_4_base": 35.1,
    "ladder_5_euphoria": 50.7
  },
  {
    "symbol": "1309.TW",
    "name": "台達化",
    "sector": "塑膠工業",
    "close": 14.35,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.17,
    "dog_ma200_bias": 0.252,
    "vr60": 1.87,
    "rs20": 1.2,
    "rs60": 1.17,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 13.6,
    "ladder_minus1_pullback": 13.5,
    "ladder_4_base": 12.9,
    "ladder_5_euphoria": 18.7
  },
  {
    "symbol": "3354.TWO",
    "name": "律勝",
    "sector": "電子零組件業",
    "close": 38.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.95,
    "dog_ma200_bias": 0.035,
    "vr60": 1.57,
    "rs20": 0.76,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 950000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.3,
    "ladder_minus1_pullback": 35.7,
    "ladder_4_base": 34.2,
    "ladder_5_euphoria": 49.4
  },
  {
    "symbol": "2316.TW",
    "name": "楠梓電",
    "sector": "電子零組件業",
    "close": 162.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.05,
    "dog_ma200_bias": -0.263,
    "vr60": 0.92,
    "rs20": 0.33,
    "rs60": 0.32,
    "shares": 1897,
    "lots": 1,
    "odd_shares": 897,
    "ntd_at_risk": 19994.38,
    "position_cost": 308262.5,
    "constraint": "WEIGHT",
    "atr14": 5.27,
    "low_20d": 149.6,
    "ladder_minus1_pullback": 152.8,
    "ladder_4_base": 146.2,
    "ladder_5_euphoria": 211.2
  },
  {
    "symbol": "2485.TW",
    "name": "兆赫",
    "sector": "通信網路業",
    "close": 38.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.24,
    "dog_ma200_bias": 0.019,
    "vr60": 1.28,
    "rs20": 1.11,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 966250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.9,
    "ladder_minus1_pullback": 36.3,
    "ladder_4_base": 34.8,
    "ladder_5_euphoria": 50.2
  },
  {
    "symbol": "2606.TW",
    "name": "裕民",
    "sector": "航運業",
    "close": 76.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.12,
    "dog_ma200_bias": -0.063,
    "vr60": 0.8,
    "rs20": 0.36,
    "rs60": 0.48,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.23,
    "low_20d": 72.9,
    "ladder_minus1_pullback": 71.4,
    "ladder_4_base": 68.4,
    "ladder_5_euphoria": 98.8
  },
  {
    "symbol": "5498.TWO",
    "name": "凱崴",
    "sector": "電子零組件業",
    "close": 54.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.76,
    "dog_ma200_bias": -0.006,
    "vr60": 1.47,
    "rs20": 0.95,
    "rs60": 0.72,
    "shares": 11695,
    "lots": 11,
    "odd_shares": 695,
    "ntd_at_risk": 39996.9,
    "position_cost": 636208.0,
    "constraint": "WEIGHT",
    "atr14": 1.71,
    "low_20d": 51.6,
    "ladder_minus1_pullback": 51.1,
    "ladder_4_base": 49.0,
    "ladder_5_euphoria": 70.7
  },
  {
    "symbol": "6139.TW",
    "name": "亞翔",
    "sector": "其他電子業",
    "close": 690.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.5,
    "dog_ma200_bias": -0.139,
    "vr60": 0.75,
    "rs20": 0.47,
    "rs60": 0.38,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 13.23,
    "low_20d": 638.0,
    "ladder_minus1_pullback": 648.6,
    "ladder_4_base": 621.0,
    "ladder_5_euphoria": 897.0
  },
  {
    "symbol": "6016.TWO",
    "name": "康和證",
    "sector": "金融保險業",
    "close": 23.3,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.14,
    "dog_ma200_bias": 0.23,
    "vr60": 1.85,
    "rs20": 1.37,
    "rs60": 1.31,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 21.3,
    "ladder_minus1_pullback": 21.9,
    "ladder_4_base": 21.0,
    "ladder_5_euphoria": 30.3
  },
  {
    "symbol": "3455.TWO",
    "name": "由田",
    "sector": "光電業",
    "close": 269.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.29,
    "dog_ma200_bias": -0.009,
    "vr60": 1.47,
    "rs20": 1.13,
    "rs60": 0.82,
    "shares": 3086,
    "lots": 3,
    "odd_shares": 86,
    "ntd_at_risk": 39994.56,
    "position_cost": 830134.0,
    "constraint": "WEIGHT",
    "atr14": 6.48,
    "low_20d": 255.8,
    "ladder_minus1_pullback": 252.9,
    "ladder_4_base": 242.1,
    "ladder_5_euphoria": 349.7
  },
  {
    "symbol": "3048.TW",
    "name": "益登",
    "sector": "電子通路業",
    "close": 54.7,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.06,
    "dog_ma200_bias": -0.113,
    "vr60": 0.88,
    "rs20": 0.42,
    "rs60": 0.47,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.82,
    "low_20d": 51.8,
    "ladder_minus1_pullback": 51.4,
    "ladder_4_base": 49.2,
    "ladder_5_euphoria": 71.1
  },
  {
    "symbol": "2385.TW",
    "name": "群光",
    "sector": "電子零組件業",
    "close": 105.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.5,
    "dog_ma200_bias": 0.062,
    "vr60": 1.97,
    "rs20": 1.14,
    "rs60": 0.75,
    "shares": 5494,
    "lots": 5,
    "odd_shares": 494,
    "ntd_at_risk": 39996.32,
    "position_cost": 579617.0,
    "constraint": "WEIGHT",
    "atr14": 3.64,
    "low_20d": 95.8,
    "ladder_minus1_pullback": 99.2,
    "ladder_4_base": 95.0,
    "ladder_5_euphoria": 137.2
  },
  {
    "symbol": "3663.TWO",
    "name": "鑫科",
    "sector": "其他電子業",
    "close": 68.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.66,
    "dog_ma200_bias": 0.098,
    "vr60": 1.62,
    "rs20": 1.03,
    "rs60": 1.03,
    "shares": 9523,
    "lots": 9,
    "odd_shares": 523,
    "ntd_at_risk": 39996.6,
    "position_cost": 652325.5,
    "constraint": "WEIGHT",
    "atr14": 2.1,
    "low_20d": 65.0,
    "ladder_minus1_pullback": 64.4,
    "ladder_4_base": 61.6,
    "ladder_5_euphoria": 89.0
  },
  {
    "symbol": "6207.TWO",
    "name": "雷科",
    "sector": "電子零組件業",
    "close": 130.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.05,
    "dog_ma200_bias": 0.076,
    "vr60": 2.07,
    "rs20": 0.87,
    "rs60": 0.94,
    "shares": 8403,
    "lots": 8,
    "odd_shares": 403,
    "ntd_at_risk": 39998.28,
    "position_cost": 1092390.0,
    "constraint": "WEIGHT",
    "atr14": 2.38,
    "low_20d": 122.4,
    "ladder_minus1_pullback": 122.2,
    "ladder_4_base": 117.0,
    "ladder_5_euphoria": 169.0
  },
  {
    "symbol": "2399.TW",
    "name": "映泰",
    "sector": "電腦及週邊設備業",
    "close": 45.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.09,
    "dog_ma200_bias": 0.119,
    "vr60": 1.4,
    "rs20": 1.05,
    "rs60": 1.05,
    "shares": 15625,
    "lots": 15,
    "odd_shares": 625,
    "ntd_at_risk": 40000.0,
    "position_cost": 713281.25,
    "constraint": "WEIGHT",
    "atr14": 1.28,
    "low_20d": 43.4,
    "ladder_minus1_pullback": 42.9,
    "ladder_4_base": 41.1,
    "ladder_5_euphoria": 59.3
  },
  {
    "symbol": "6919.TW",
    "name": "康霈*",
    "sector": "生技醫療業",
    "close": 75.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.06,
    "dog_ma200_bias": 0.062,
    "vr60": 1.55,
    "rs20": 0.8,
    "rs60": 0.9,
    "shares": 8888,
    "lots": 8,
    "odd_shares": 888,
    "ntd_at_risk": 39996.0,
    "position_cost": 669266.4,
    "constraint": "WEIGHT",
    "atr14": 2.25,
    "low_20d": 71.2,
    "ladder_minus1_pullback": 70.8,
    "ladder_4_base": 67.8,
    "ladder_5_euphoria": 97.9
  },
  {
    "symbol": "2049.TW",
    "name": "上銀",
    "sector": "電機機械業",
    "close": 311.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.05,
    "dog_ma200_bias": 0.039,
    "vr60": 1.69,
    "rs20": 1.02,
    "rs60": 0.89,
    "shares": 3430,
    "lots": 3,
    "odd_shares": 430,
    "ntd_at_risk": 39993.8,
    "position_cost": 1066730.0,
    "constraint": "WEIGHT",
    "atr14": 5.83,
    "low_20d": 298.0,
    "ladder_minus1_pullback": 292.3,
    "ladder_4_base": 279.9,
    "ladder_5_euphoria": 404.3
  },
  {
    "symbol": "1905.TW",
    "name": "華紙",
    "sector": "造紙工業",
    "close": 13.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.33,
    "dog_ma200_bias": 0.075,
    "vr60": 1.62,
    "rs20": 1.03,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 327500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.4,
    "ladder_minus1_pullback": 12.3,
    "ladder_4_base": 11.8,
    "ladder_5_euphoria": 17.0
  },
  {
    "symbol": "5340.TWO",
    "name": "建榮",
    "sector": "電子零組件業",
    "close": 90.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.33,
    "dog_ma200_bias": 0.095,
    "vr60": 1.47,
    "rs20": 1.28,
    "rs60": 1.22,
    "shares": 13245,
    "lots": 13,
    "odd_shares": 245,
    "ntd_at_risk": 39999.9,
    "position_cost": 1201321.5,
    "constraint": "WEIGHT",
    "atr14": 1.51,
    "low_20d": 84.7,
    "ladder_minus1_pullback": 85.3,
    "ladder_4_base": 81.6,
    "ladder_5_euphoria": 117.9
  },
  {
    "symbol": "3535.TW",
    "name": "晶彩科",
    "sector": "光電業",
    "close": 94.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.52,
    "dog_ma200_bias": -0.143,
    "vr60": 0.77,
    "rs20": 0.52,
    "rs60": 0.43,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.37,
    "low_20d": 87.8,
    "ladder_minus1_pullback": 88.8,
    "ladder_4_base": 85.0,
    "ladder_5_euphoria": 122.9
  },
  {
    "symbol": "2486.TW",
    "name": "一詮",
    "sector": "光電業",
    "close": 212.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.35,
    "dog_ma200_bias": 0.046,
    "vr60": 1.84,
    "rs20": 1.07,
    "rs60": 0.73,
    "shares": 4608,
    "lots": 4,
    "odd_shares": 608,
    "ntd_at_risk": 39997.44,
    "position_cost": 976896.0,
    "constraint": "WEIGHT",
    "atr14": 4.34,
    "low_20d": 202.3,
    "ladder_minus1_pullback": 199.3,
    "ladder_4_base": 190.8,
    "ladder_5_euphoria": 275.6
  },
  {
    "symbol": "6715.TW",
    "name": "嘉基",
    "sector": "電子零組件業",
    "close": 533.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.38,
    "dog_ma200_bias": 0.019,
    "vr60": 1.73,
    "rs20": 0.54,
    "rs60": 0.63,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 15.8,
    "low_20d": 498.2,
    "ladder_minus1_pullback": 501.0,
    "ladder_4_base": 479.7,
    "ladder_5_euphoria": 692.9
  },
  {
    "symbol": "8131.TW",
    "name": "福懋科",
    "sector": "半導體業",
    "close": 63.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.28,
    "dog_ma200_bias": 0.049,
    "vr60": 1.69,
    "rs20": 1.07,
    "rs60": 0.83,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 868959.0,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 58.2,
    "ladder_minus1_pullback": 59.2,
    "ladder_4_base": 56.7,
    "ladder_5_euphoria": 81.9
  },
  {
    "symbol": "3580.TWO",
    "name": "友威科",
    "sector": "其他電子業",
    "close": 110.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.05,
    "dog_ma200_bias": 0.07,
    "vr60": 1.68,
    "rs20": 1.01,
    "rs60": 0.73,
    "shares": 7272,
    "lots": 7,
    "odd_shares": 272,
    "ntd_at_risk": 39996.0,
    "position_cost": 803556.0,
    "constraint": "WEIGHT",
    "atr14": 2.75,
    "low_20d": 103.2,
    "ladder_minus1_pullback": 103.9,
    "ladder_4_base": 99.5,
    "ladder_5_euphoria": 143.7
  },
  {
    "symbol": "1308.TW",
    "name": "亞聚",
    "sector": "塑膠工業",
    "close": 14.65,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.27,
    "dog_ma200_bias": -0.003,
    "vr60": 1.89,
    "rs20": 0.52,
    "rs60": 0.68,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 13.2,
    "ladder_minus1_pullback": 13.8,
    "ladder_4_base": 13.2,
    "ladder_5_euphoria": 19.0
  },
  {
    "symbol": "8227.TWO",
    "name": "巨有科技",
    "sector": "半導體業",
    "close": 282.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.05,
    "dog_ma200_bias": 0.078,
    "vr60": 1.81,
    "rs20": 0.91,
    "rs60": 0.96,
    "shares": 4405,
    "lots": 4,
    "odd_shares": 405,
    "ntd_at_risk": 39997.4,
    "position_cost": 1244412.5,
    "constraint": "WEIGHT",
    "atr14": 4.54,
    "low_20d": 270.6,
    "ladder_minus1_pullback": 265.6,
    "ladder_4_base": 254.2,
    "ladder_5_euphoria": 367.2
  },
  {
    "symbol": "9914.TW",
    "name": "美利達",
    "sector": "運動休閒",
    "close": 68.6,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.46,
    "dog_ma200_bias": 0.017,
    "vr60": 1.69,
    "rs20": 0.4,
    "rs60": 0.54,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.12,
    "low_20d": 65.4,
    "ladder_minus1_pullback": 64.5,
    "ladder_4_base": 61.7,
    "ladder_5_euphoria": 89.2
  },
  {
    "symbol": "3062.TW",
    "name": "建漢",
    "sector": "通信網路業",
    "close": 21.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.05,
    "dog_ma200_bias": 0.032,
    "vr60": 1.72,
    "rs20": 0.98,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 540000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.8,
    "ladder_minus1_pullback": 20.3,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 28.1
  },
  {
    "symbol": "4960.TW",
    "name": "誠美材",
    "sector": "光電業",
    "close": 23.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.57,
    "dog_ma200_bias": 0.019,
    "vr60": 1.9,
    "rs20": 0.99,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 592500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.7,
    "ladder_minus1_pullback": 22.3,
    "ladder_4_base": 21.3,
    "ladder_5_euphoria": 30.8
  },
  {
    "symbol": "6446.TW",
    "name": "藥華藥",
    "sector": "生技醫療業",
    "close": 1205.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.42,
    "dog_ma200_bias": -0.218,
    "vr60": 0.66,
    "rs20": 0.24,
    "rs60": 0.33,
    "shares": 407,
    "lots": 0,
    "odd_shares": 407,
    "ntd_at_risk": 19975.56,
    "position_cost": 490435.0,
    "constraint": "WEIGHT",
    "atr14": 24.54,
    "low_20d": 1141.9,
    "ladder_minus1_pullback": 1132.7,
    "ladder_4_base": 1084.5,
    "ladder_5_euphoria": 1566.5
  },
  {
    "symbol": "6449.TW",
    "name": "鈺邦",
    "sector": "電子零組件業",
    "close": 243.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.05,
    "dog_ma200_bias": -0.008,
    "vr60": 2.05,
    "rs20": 0.81,
    "rs60": 0.81,
    "shares": 3752,
    "lots": 3,
    "odd_shares": 752,
    "ntd_at_risk": 39996.32,
    "position_cost": 911736.0,
    "constraint": "WEIGHT",
    "atr14": 5.33,
    "low_20d": 229.1,
    "ladder_minus1_pullback": 228.4,
    "ladder_4_base": 218.7,
    "ladder_5_euphoria": 315.9
  },
  {
    "symbol": "3114.TWO",
    "name": "好德",
    "sector": "電子零組件業",
    "close": 40.85,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.29,
    "dog_ma200_bias": -0.034,
    "vr60": 1.49,
    "rs20": 0.57,
    "rs60": 0.62,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.21,
    "low_20d": 39.0,
    "ladder_minus1_pullback": 38.4,
    "ladder_4_base": 36.8,
    "ladder_5_euphoria": 53.1
  },
  {
    "symbol": "8064.TWO",
    "name": "東捷",
    "sector": "光電業",
    "close": 116.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.36,
    "dog_ma200_bias": 0.319,
    "vr60": 1.92,
    "rs20": 1.26,
    "rs60": 1.38,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.38,
    "low_20d": 108.5,
    "ladder_minus1_pullback": 109.5,
    "ladder_4_base": 104.9,
    "ladder_5_euphoria": 151.5
  },
  {
    "symbol": "8358.TWO",
    "name": "金居",
    "sector": "電子零組件業",
    "close": 461.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.34,
    "dog_ma200_bias": 0.065,
    "vr60": 1.78,
    "rs20": 1.02,
    "rs60": 0.76,
    "shares": 1308,
    "lots": 1,
    "odd_shares": 308,
    "ntd_at_risk": 39998.64,
    "position_cost": 603642.0,
    "constraint": "WEIGHT",
    "atr14": 15.29,
    "low_20d": 436.4,
    "ladder_minus1_pullback": 433.8,
    "ladder_4_base": 415.4,
    "ladder_5_euphoria": 600.0
  },
  {
    "symbol": "3665.TW",
    "name": "貿聯-KY",
    "sector": "其他電子業",
    "close": 2015.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.05,
    "dog_ma200_bias": 0.178,
    "vr60": 1.2,
    "rs20": 1.02,
    "rs60": 0.96,
    "shares": 605,
    "lots": 0,
    "odd_shares": 605,
    "ntd_at_risk": 39954.2,
    "position_cost": 1219075.0,
    "constraint": "WEIGHT",
    "atr14": 33.02,
    "low_20d": 1911.8,
    "ladder_minus1_pullback": 1894.1,
    "ladder_4_base": 1813.5,
    "ladder_5_euphoria": 2619.5
  },
  {
    "symbol": "2033.TW",
    "name": "佳大",
    "sector": "鋼鐵工業",
    "close": 54.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.95,
    "dog_ma200_bias": 0.036,
    "vr60": 2.06,
    "rs20": 0.84,
    "rs60": 0.84,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 1121619.2,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 52.2,
    "ladder_minus1_pullback": 51.1,
    "ladder_4_base": 49.0,
    "ladder_5_euphoria": 70.7
  },
  {
    "symbol": "5521.TW",
    "name": "工信",
    "sector": "建材營造業",
    "close": 11.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.95,
    "dog_ma200_bias": -0.247,
    "vr60": 0.94,
    "rs20": 0.37,
    "rs60": 0.19,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 143750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.9,
    "ladder_minus1_pullback": 10.8,
    "ladder_4_base": 10.3,
    "ladder_5_euphoria": 15.0
  },
  {
    "symbol": "5243.TW",
    "name": "乙盛-KY",
    "sector": "光電業",
    "close": 92.3,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.05,
    "dog_ma200_bias": -0.06,
    "vr60": 1.83,
    "rs20": 0.54,
    "rs60": 0.7,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.53,
    "low_20d": 84.8,
    "ladder_minus1_pullback": 86.8,
    "ladder_4_base": 83.1,
    "ladder_5_euphoria": 120.0
  },
  {
    "symbol": "2302.TW",
    "name": "麗正",
    "sector": "半導體業",
    "close": 44.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.12,
    "dog_ma200_bias": 0.055,
    "vr60": 1.93,
    "rs20": 0.78,
    "rs60": 0.74,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 743303.6,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 40.2,
    "ladder_minus1_pullback": 41.9,
    "ladder_4_base": 40.1,
    "ladder_5_euphoria": 58.0
  },
  {
    "symbol": "1513.TW",
    "name": "中興電",
    "sector": "電機機械業",
    "close": 165.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.33,
    "dog_ma200_bias": 0.067,
    "vr60": 1.37,
    "rs20": 0.88,
    "rs60": 0.86,
    "shares": 4889,
    "lots": 4,
    "odd_shares": 889,
    "ntd_at_risk": 39992.02,
    "position_cost": 806685.0,
    "constraint": "WEIGHT",
    "atr14": 4.09,
    "low_20d": 155.9,
    "ladder_minus1_pullback": 155.1,
    "ladder_4_base": 148.5,
    "ladder_5_euphoria": 214.5
  },
  {
    "symbol": "4908.TWO",
    "name": "前鼎",
    "sector": "通信網路業",
    "close": 217.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.42,
    "dog_ma200_bias": 0.006,
    "vr60": 1.98,
    "rs20": 0.96,
    "rs60": 0.92,
    "shares": 2936,
    "lots": 2,
    "odd_shares": 936,
    "ntd_at_risk": 39988.32,
    "position_cost": 637112.0,
    "constraint": "WEIGHT",
    "atr14": 6.81,
    "low_20d": 200.9,
    "ladder_minus1_pullback": 204.0,
    "ladder_4_base": 195.3,
    "ladder_5_euphoria": 282.1
  },
  {
    "symbol": "4931.TWO",
    "name": "新盛力",
    "sector": "電腦及週邊設備業",
    "close": 213.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.17,
    "dog_ma200_bias": -0.02,
    "vr60": 1.85,
    "rs20": 0.61,
    "rs60": 0.57,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 6.75,
    "low_20d": 197.8,
    "ladder_minus1_pullback": 200.2,
    "ladder_4_base": 191.7,
    "ladder_5_euphoria": 276.9
  },
  {
    "symbol": "6187.TWO",
    "name": "萬潤",
    "sector": "半導體業",
    "close": 1390.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.05,
    "dog_ma200_bias": 0.042,
    "vr60": 1.93,
    "rs20": 1.03,
    "rs60": 0.8,
    "shares": 802,
    "lots": 0,
    "odd_shares": 802,
    "ntd_at_risk": 39987.72,
    "position_cost": 1114780.0,
    "constraint": "WEIGHT",
    "atr14": 24.93,
    "low_20d": 1326.6,
    "ladder_minus1_pullback": 1306.6,
    "ladder_4_base": 1251.0,
    "ladder_5_euphoria": 1807.0
  },
  {
    "symbol": "6221.TWO",
    "name": "晉泰",
    "sector": "資訊服務業",
    "close": 33.9,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.11,
    "dog_ma200_bias": -0.114,
    "vr60": 0.63,
    "rs20": 0.35,
    "rs60": 0.39,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.01,
    "low_20d": 31.6,
    "ladder_minus1_pullback": 31.9,
    "ladder_4_base": 30.5,
    "ladder_5_euphoria": 44.1
  },
  {
    "symbol": "4707.TWO",
    "name": "磐亞",
    "sector": "化學工業",
    "close": 29.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.14,
    "dog_ma200_bias": 0.011,
    "vr60": 1.36,
    "rs20": 1.03,
    "rs60": 0.88,
    "shares": 19417,
    "lots": 19,
    "odd_shares": 417,
    "ntd_at_risk": 39999.02,
    "position_cost": 575714.05,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 28.0,
    "ladder_minus1_pullback": 27.9,
    "ladder_4_base": 26.7,
    "ladder_5_euphoria": 38.5
  },
  {
    "symbol": "1325.TW",
    "name": "恆大",
    "sector": "塑膠工業",
    "close": 28.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.05,
    "dog_ma200_bias": 0.11,
    "vr60": 1.13,
    "rs20": 1.1,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 716250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.5,
    "ladder_minus1_pullback": 26.9,
    "ladder_4_base": 25.8,
    "ladder_5_euphoria": 37.2
  },
  {
    "symbol": "2241.TW",
    "name": "艾姆勒",
    "sector": "汽車工業",
    "close": 46.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.06,
    "dog_ma200_bias": 0.136,
    "vr60": 1.47,
    "rs20": 1.21,
    "rs60": 1.3,
    "shares": 14705,
    "lots": 14,
    "odd_shares": 705,
    "ntd_at_risk": 39997.6,
    "position_cost": 686723.5,
    "constraint": "WEIGHT",
    "atr14": 1.36,
    "low_20d": 42.3,
    "ladder_minus1_pullback": 43.9,
    "ladder_4_base": 42.0,
    "ladder_5_euphoria": 60.7
  },
  {
    "symbol": "2329.TW",
    "name": "華泰",
    "sector": "半導體業",
    "close": 42.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.15,
    "dog_ma200_bias": 0.035,
    "vr60": 1.64,
    "rs20": 0.81,
    "rs60": 0.81,
    "shares": 14598,
    "lots": 14,
    "odd_shares": 598,
    "ntd_at_risk": 39998.52,
    "position_cost": 624064.5,
    "constraint": "WEIGHT",
    "atr14": 1.37,
    "low_20d": 38.7,
    "ladder_minus1_pullback": 40.2,
    "ladder_4_base": 38.5,
    "ladder_5_euphoria": 55.6
  },
  {
    "symbol": "4991.TWO",
    "name": "環宇-KY",
    "sector": "半導體業",
    "close": 441.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.1,
    "dog_ma200_bias": 0.114,
    "vr60": 1.08,
    "rs20": 1.09,
    "rs60": 0.9,
    "shares": 2624,
    "lots": 2,
    "odd_shares": 624,
    "ntd_at_risk": 39989.76,
    "position_cost": 1158496.0,
    "constraint": "WEIGHT",
    "atr14": 7.62,
    "low_20d": 405.7,
    "ladder_minus1_pullback": 415.0,
    "ladder_4_base": 397.4,
    "ladder_5_euphoria": 574.0
  },
  {
    "symbol": "2395.TW",
    "name": "研華",
    "sector": "電腦及週邊設備業",
    "close": 698.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.47,
    "dog_ma200_bias": -0.006,
    "vr60": 1.93,
    "rs20": 1.14,
    "rs60": 0.88,
    "shares": 1858,
    "lots": 1,
    "odd_shares": 858,
    "ntd_at_risk": 39984.16,
    "position_cost": 1296884.0,
    "constraint": "WEIGHT",
    "atr14": 10.76,
    "low_20d": 629.1,
    "ladder_minus1_pullback": 656.1,
    "ladder_4_base": 628.2,
    "ladder_5_euphoria": 907.4
  },
  {
    "symbol": "3081.TWO",
    "name": "聯亞",
    "sector": "通信網路業",
    "close": 2640.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.15,
    "dog_ma200_bias": 0.029,
    "vr60": 1.82,
    "rs20": 0.92,
    "rs60": 0.99,
    "shares": 268,
    "lots": 0,
    "odd_shares": 268,
    "ntd_at_risk": 39883.76,
    "position_cost": 707520.0,
    "constraint": "WEIGHT",
    "atr14": 74.41,
    "low_20d": 2512.0,
    "ladder_minus1_pullback": 2481.6,
    "ladder_4_base": 2376.0,
    "ladder_5_euphoria": 3432.0
  },
  {
    "symbol": "1319.TW",
    "name": "東陽",
    "sector": "汽車工業",
    "close": 83.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.56,
    "dog_ma200_bias": 0.029,
    "vr60": 1.27,
    "rs20": 0.76,
    "rs60": 0.97,
    "shares": 12048,
    "lots": 12,
    "odd_shares": 48,
    "ntd_at_risk": 39999.36,
    "position_cost": 1003598.4,
    "constraint": "WEIGHT",
    "atr14": 1.66,
    "low_20d": 76.3,
    "ladder_minus1_pullback": 78.3,
    "ladder_4_base": 75.0,
    "ladder_5_euphoria": 108.3
  },
  {
    "symbol": "2014.TW",
    "name": "中鴻",
    "sector": "鋼鐵工業",
    "close": 16.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": 0.095,
    "vr60": 1.21,
    "rs20": 1.17,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 421250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.4,
    "ladder_minus1_pullback": 15.8,
    "ladder_4_base": 15.2,
    "ladder_5_euphoria": 21.9
  },
  {
    "symbol": "3211.TWO",
    "name": "順達",
    "sector": "電腦及週邊設備業",
    "close": 349.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.42,
    "dog_ma200_bias": 0.026,
    "vr60": 1.87,
    "rs20": 1.06,
    "rs60": 0.89,
    "shares": 1680,
    "lots": 1,
    "odd_shares": 680,
    "ntd_at_risk": 39984.0,
    "position_cost": 586320.0,
    "constraint": "WEIGHT",
    "atr14": 11.9,
    "low_20d": 321.7,
    "ladder_minus1_pullback": 328.1,
    "ladder_4_base": 314.1,
    "ladder_5_euphoria": 453.7
  },
  {
    "symbol": "1519.TW",
    "name": "華城",
    "sector": "電機機械業",
    "close": 649.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.06,
    "dog_ma200_bias": -0.009,
    "vr60": 1.3,
    "rs20": 1.06,
    "rs60": 0.99,
    "shares": 946,
    "lots": 0,
    "odd_shares": 946,
    "ntd_at_risk": 39959.04,
    "position_cost": 613954.0,
    "constraint": "WEIGHT",
    "atr14": 21.12,
    "low_20d": 596.6,
    "ladder_minus1_pullback": 610.1,
    "ladder_4_base": 584.1,
    "ladder_5_euphoria": 843.7
  },
  {
    "symbol": "6742.TW",
    "name": "澤米",
    "sector": "光電業",
    "close": 60.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.05,
    "dog_ma200_bias": 0.104,
    "vr60": 1.54,
    "rs20": 0.97,
    "rs60": 1.19,
    "shares": 13698,
    "lots": 13,
    "odd_shares": 698,
    "ntd_at_risk": 39998.16,
    "position_cost": 832838.4,
    "constraint": "WEIGHT",
    "atr14": 1.46,
    "low_20d": 54.9,
    "ladder_minus1_pullback": 57.2,
    "ladder_4_base": 54.7,
    "ladder_5_euphoria": 79.0
  },
  {
    "symbol": "8213.TW",
    "name": "志超",
    "sector": "電子零組件業",
    "close": 39.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.13,
    "dog_ma200_bias": 0.126,
    "vr60": 1.64,
    "rs20": 0.99,
    "rs60": 1.23,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 975000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 35.9,
    "ladder_minus1_pullback": 36.7,
    "ladder_4_base": 35.1,
    "ladder_5_euphoria": 50.7
  },
  {
    "symbol": "6015.TWO",
    "name": "宏遠證",
    "sector": "金融保險業",
    "close": 17.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.05,
    "dog_ma200_bias": 0.055,
    "vr60": 1.47,
    "rs20": 1.15,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 447500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.7,
    "ladder_minus1_pullback": 16.8,
    "ladder_4_base": 16.1,
    "ladder_5_euphoria": 23.3
  },
  {
    "symbol": "1608.TW",
    "name": "華榮",
    "sector": "電器電纜業",
    "close": 36.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.09,
    "dog_ma200_bias": -0.045,
    "vr60": 2.04,
    "rs20": 0.55,
    "rs60": 0.8,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 34.5,
    "ladder_minus1_pullback": 33.8,
    "ladder_4_base": 32.4,
    "ladder_5_euphoria": 46.8
  },
  {
    "symbol": "1477.TW",
    "name": "聚陽",
    "sector": "紡織纖維業",
    "close": 208.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.44,
    "dog_ma200_bias": -0.056,
    "vr60": 2.03,
    "rs20": 0.61,
    "rs60": 0.57,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 4.56,
    "low_20d": 192.5,
    "ladder_minus1_pullback": 196.0,
    "ladder_4_base": 187.7,
    "ladder_5_euphoria": 271.1
  },
  {
    "symbol": "2374.TW",
    "name": "佳能",
    "sector": "光電業",
    "close": 63.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": 0.043,
    "vr60": 1.35,
    "rs20": 0.81,
    "rs60": 0.77,
    "shares": 13071,
    "lots": 13,
    "odd_shares": 71,
    "ntd_at_risk": 39997.26,
    "position_cost": 830008.5,
    "constraint": "WEIGHT",
    "atr14": 1.53,
    "low_20d": 57.3,
    "ladder_minus1_pullback": 59.7,
    "ladder_4_base": 57.1,
    "ladder_5_euphoria": 82.5
  },
  {
    "symbol": "3265.TWO",
    "name": "台星科",
    "sector": "半導體業",
    "close": 278.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.66,
    "dog_ma200_bias": 0.221,
    "vr60": 1.66,
    "rs20": 1.27,
    "rs60": 1.2,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.77,
    "low_20d": 250.7,
    "ladder_minus1_pullback": 261.3,
    "ladder_4_base": 250.2,
    "ladder_5_euphoria": 361.4
  },
  {
    "symbol": "2328.TW",
    "name": "廣宇",
    "sector": "電子零組件業",
    "close": 47.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.1,
    "dog_ma200_bias": 0.099,
    "vr60": 1.47,
    "rs20": 1.07,
    "rs60": 1.01,
    "shares": 14598,
    "lots": 14,
    "odd_shares": 598,
    "ntd_at_risk": 39998.52,
    "position_cost": 698514.3,
    "constraint": "WEIGHT",
    "atr14": 1.37,
    "low_20d": 44.6,
    "ladder_minus1_pullback": 45.0,
    "ladder_4_base": 43.1,
    "ladder_5_euphoria": 62.2
  },
  {
    "symbol": "8261.TW",
    "name": "富鼎",
    "sector": "半導體業",
    "close": 160.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.23,
    "dog_ma200_bias": 0.066,
    "vr60": 2.09,
    "rs20": 1.02,
    "rs60": 0.73,
    "shares": 3642,
    "lots": 3,
    "odd_shares": 642,
    "ntd_at_risk": 39989.16,
    "position_cost": 582720.0,
    "constraint": "WEIGHT",
    "atr14": 5.49,
    "low_20d": 147.6,
    "ladder_minus1_pullback": 150.4,
    "ladder_4_base": 144.0,
    "ladder_5_euphoria": 208.0
  },
  {
    "symbol": "2349.TW",
    "name": "錸德",
    "sector": "光電業",
    "close": 10.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.05,
    "dog_ma200_bias": 0.176,
    "vr60": 1.52,
    "rs20": 1.32,
    "rs60": 1.3,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 267500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.1,
    "ladder_minus1_pullback": 10.1,
    "ladder_4_base": 9.6,
    "ladder_5_euphoria": 13.9
  },
  {
    "symbol": "2401.TW",
    "name": "凌陽",
    "sector": "半導體業",
    "close": 24.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.21,
    "dog_ma200_bias": 0.067,
    "vr60": 1.31,
    "rs20": 1.1,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 615000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.6,
    "ladder_minus1_pullback": 23.1,
    "ladder_4_base": 22.1,
    "ladder_5_euphoria": 32.0
  },
  {
    "symbol": "6244.TWO",
    "name": "茂迪",
    "sector": "光電業",
    "close": 21.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.2,
    "dog_ma200_bias": 0.322,
    "vr60": 2.43,
    "rs20": 1.42,
    "rs60": 1.34,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 20.6,
    "ladder_minus1_pullback": 20.2,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 27.9
  },
  {
    "symbol": "5328.TWO",
    "name": "華容",
    "sector": "電子零組件業",
    "close": 55.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.05,
    "dog_ma200_bias": 0.038,
    "vr60": 1.44,
    "rs20": 0.92,
    "rs60": 0.86,
    "shares": 15384,
    "lots": 15,
    "odd_shares": 384,
    "ntd_at_risk": 39998.4,
    "position_cost": 846120.0,
    "constraint": "WEIGHT",
    "atr14": 1.3,
    "low_20d": 50.6,
    "ladder_minus1_pullback": 51.7,
    "ladder_4_base": 49.5,
    "ladder_5_euphoria": 71.5
  },
  {
    "symbol": "3049.TW",
    "name": "精金",
    "sector": "光電業",
    "close": 11.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": 0.043,
    "vr60": 1.99,
    "rs20": 0.79,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 292500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.0,
    "ladder_minus1_pullback": 11.0,
    "ladder_4_base": 10.5,
    "ladder_5_euphoria": 15.2
  },
  {
    "symbol": "2451.TW",
    "name": "創見",
    "sector": "半導體業",
    "close": 269.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.2,
    "dog_ma200_bias": 0.008,
    "vr60": 2.04,
    "rs20": 0.9,
    "rs60": 1.03,
    "shares": 2309,
    "lots": 2,
    "odd_shares": 309,
    "ntd_at_risk": 39991.88,
    "position_cost": 621121.0,
    "constraint": "WEIGHT",
    "atr14": 8.66,
    "low_20d": 247.5,
    "ladder_minus1_pullback": 252.9,
    "ladder_4_base": 242.1,
    "ladder_5_euphoria": 349.7
  },
  {
    "symbol": "4167.TWO",
    "name": "松瑞藥",
    "sector": "生技醫療業",
    "close": 21.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.18,
    "dog_ma200_bias": 0.013,
    "vr60": 1.2,
    "rs20": 1.06,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 543750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.8,
    "ladder_minus1_pullback": 20.4,
    "ladder_4_base": 19.6,
    "ladder_5_euphoria": 28.3
  },
  {
    "symbol": "2439.TW",
    "name": "美律",
    "sector": "通信網路業",
    "close": 80.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.47,
    "dog_ma200_bias": 0.148,
    "vr60": 1.33,
    "rs20": 1.22,
    "rs60": 1.04,
    "shares": 7092,
    "lots": 7,
    "odd_shares": 92,
    "ntd_at_risk": 39998.88,
    "position_cost": 573742.8,
    "constraint": "WEIGHT",
    "atr14": 2.82,
    "low_20d": 76.7,
    "ladder_minus1_pullback": 76.0,
    "ladder_4_base": 72.8,
    "ladder_5_euphoria": 105.2
  },
  {
    "symbol": "2429.TW",
    "name": "銘旺科",
    "sector": "光電業",
    "close": 38.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.95,
    "dog_ma200_bias": -0.014,
    "vr60": 1.68,
    "rs20": 0.84,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 955000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.2,
    "ladder_minus1_pullback": 35.9,
    "ladder_4_base": 34.4,
    "ladder_5_euphoria": 49.7
  },
  {
    "symbol": "3362.TWO",
    "name": "先進光",
    "sector": "光電業",
    "close": 177.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.21,
    "dog_ma200_bias": 0.001,
    "vr60": 1.44,
    "rs20": 1.08,
    "rs60": 0.82,
    "shares": 5115,
    "lots": 5,
    "odd_shares": 115,
    "ntd_at_risk": 39999.3,
    "position_cost": 905355.0,
    "constraint": "WEIGHT",
    "atr14": 3.91,
    "low_20d": 161.3,
    "ladder_minus1_pullback": 166.4,
    "ladder_4_base": 159.3,
    "ladder_5_euphoria": 230.1
  },
  {
    "symbol": "2903.TW",
    "name": "遠百",
    "sector": "貿易百貨業",
    "close": 22.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.95,
    "dog_ma200_bias": 0.038,
    "vr60": 1.71,
    "rs20": 0.94,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 560000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.2,
    "ladder_minus1_pullback": 21.1,
    "ladder_4_base": 20.2,
    "ladder_5_euphoria": 29.1
  },
  {
    "symbol": "1907.TW",
    "name": "永豐餘",
    "sector": "造紙工業",
    "close": 29.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.64,
    "dog_ma200_bias": 0.048,
    "vr60": 1.24,
    "rs20": 0.79,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 738750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.8,
    "ladder_minus1_pullback": 27.8,
    "ladder_4_base": 26.6,
    "ladder_5_euphoria": 38.4
  },
  {
    "symbol": "1476.TW",
    "name": "儒鴻",
    "sector": "紡織纖維業",
    "close": 324.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.92,
    "dog_ma200_bias": 0.026,
    "vr60": 1.31,
    "rs20": 1.09,
    "rs60": 0.85,
    "shares": 2350,
    "lots": 2,
    "odd_shares": 350,
    "ntd_at_risk": 39997.0,
    "position_cost": 761400.0,
    "constraint": "WEIGHT",
    "atr14": 8.51,
    "low_20d": 297.8,
    "ladder_minus1_pullback": 304.6,
    "ladder_4_base": 291.6,
    "ladder_5_euphoria": 421.2
  },
  {
    "symbol": "1455.TW",
    "name": "集盛",
    "sector": "紡織纖維業",
    "close": 9.99,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.13,
    "dog_ma200_bias": -0.02,
    "vr60": 2.06,
    "rs20": 0.83,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 249750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.2,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 13.0
  },
  {
    "symbol": "8431.TWO",
    "name": "匯鑽科",
    "sector": "其他電子業",
    "close": 68.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.82,
    "dog_ma200_bias": 0.076,
    "vr60": 1.44,
    "rs20": 1.01,
    "rs60": 1.27,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 1133288.0,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 63.0,
    "ladder_minus1_pullback": 63.9,
    "ladder_4_base": 61.2,
    "ladder_5_euphoria": 88.4
  },
  {
    "symbol": "1444.TW",
    "name": "力麗",
    "sector": "紡織纖維業",
    "close": 6.92,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.18,
    "dog_ma200_bias": 0.007,
    "vr60": 1.79,
    "rs20": 0.85,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 173000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 6.4,
    "ladder_minus1_pullback": 6.5,
    "ladder_4_base": 6.2,
    "ladder_5_euphoria": 9.0
  },
  {
    "symbol": "3533.TW",
    "name": "嘉澤",
    "sector": "電子零組件業",
    "close": 1815.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.28,
    "dog_ma200_bias": 0.07,
    "vr60": 1.35,
    "rs20": 0.91,
    "rs60": 0.81,
    "shares": 425,
    "lots": 0,
    "odd_shares": 425,
    "ntd_at_risk": 39984.0,
    "position_cost": 771375.0,
    "constraint": "WEIGHT",
    "atr14": 47.04,
    "low_20d": 1701.5,
    "ladder_minus1_pullback": 1706.1,
    "ladder_4_base": 1633.5,
    "ladder_5_euphoria": 2359.5
  },
  {
    "symbol": "8033.TW",
    "name": "雷虎",
    "sector": "其他業",
    "close": 158.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.06,
    "dog_ma200_bias": 0.05,
    "vr60": 1.41,
    "rs20": 1.01,
    "rs60": 0.95,
    "shares": 5333,
    "lots": 5,
    "odd_shares": 333,
    "ntd_at_risk": 39997.5,
    "position_cost": 842614.0,
    "constraint": "WEIGHT",
    "atr14": 3.75,
    "low_20d": 150.4,
    "ladder_minus1_pullback": 148.5,
    "ladder_4_base": 142.2,
    "ladder_5_euphoria": 205.4
  },
  {
    "symbol": "3019.TW",
    "name": "亞光",
    "sector": "光電業",
    "close": 133.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.17,
    "dog_ma200_bias": -0.08,
    "vr60": 1.73,
    "rs20": 0.45,
    "rs60": 0.53,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.83,
    "low_20d": 120.2,
    "ladder_minus1_pullback": 125.0,
    "ladder_4_base": 119.7,
    "ladder_5_euphoria": 172.9
  },
  {
    "symbol": "3685.TWO",
    "name": "元創精密",
    "sector": "電機機械業",
    "close": 37.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.7,
    "dog_ma200_bias": -0.019,
    "vr60": 1.83,
    "rs20": 1.08,
    "rs60": 1.05,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 818473.35,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 35.2,
    "ladder_minus1_pullback": 35.4,
    "ladder_4_base": 33.9,
    "ladder_5_euphoria": 48.9
  },
  {
    "symbol": "2501.TW",
    "name": "國建",
    "sector": "建材營造業",
    "close": 20.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.75,
    "dog_ma200_bias": 0.022,
    "vr60": 1.32,
    "rs20": 0.78,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 516250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.8,
    "ladder_minus1_pullback": 19.4,
    "ladder_4_base": 18.6,
    "ladder_5_euphoria": 26.8
  },
  {
    "symbol": "2201.TW",
    "name": "裕隆",
    "sector": "汽車工業",
    "close": 29.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.13,
    "dog_ma200_bias": 0.053,
    "vr60": 1.29,
    "rs20": 0.88,
    "rs60": 1.01,
    "shares": 20202,
    "lots": 20,
    "odd_shares": 202,
    "ntd_at_risk": 39999.96,
    "position_cost": 587878.2,
    "constraint": "WEIGHT",
    "atr14": 0.99,
    "low_20d": 27.2,
    "ladder_minus1_pullback": 27.4,
    "ladder_4_base": 26.2,
    "ladder_5_euphoria": 37.8
  },
  {
    "symbol": "8103.TW",
    "name": "瀚荃",
    "sector": "電子零組件業",
    "close": 103.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.18,
    "dog_ma200_bias": -0.006,
    "vr60": 1.9,
    "rs20": 1.05,
    "rs60": 0.75,
    "shares": 7067,
    "lots": 7,
    "odd_shares": 67,
    "ntd_at_risk": 39999.22,
    "position_cost": 731434.5,
    "constraint": "WEIGHT",
    "atr14": 2.83,
    "low_20d": 97.5,
    "ladder_minus1_pullback": 97.3,
    "ladder_4_base": 93.2,
    "ladder_5_euphoria": 134.6
  },
  {
    "symbol": "6122.TWO",
    "name": "擎邦",
    "sector": "電機機械業",
    "close": 63.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.25,
    "dog_ma200_bias": 0.079,
    "vr60": 1.33,
    "rs20": 0.96,
    "rs60": 0.7,
    "shares": 12578,
    "lots": 12,
    "odd_shares": 578,
    "ntd_at_risk": 39998.04,
    "position_cost": 792414.0,
    "constraint": "WEIGHT",
    "atr14": 1.59,
    "low_20d": 60.0,
    "ladder_minus1_pullback": 59.2,
    "ladder_4_base": 56.7,
    "ladder_5_euphoria": 81.9
  },
  {
    "symbol": "2493.TW",
    "name": "揚博",
    "sector": "電子零組件業",
    "close": 194.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.05,
    "dog_ma200_bias": 0.045,
    "vr60": 1.6,
    "rs20": 1.04,
    "rs60": 0.92,
    "shares": 3906,
    "lots": 3,
    "odd_shares": 906,
    "ntd_at_risk": 39997.44,
    "position_cost": 759717.0,
    "constraint": "WEIGHT",
    "atr14": 5.12,
    "low_20d": 183.3,
    "ladder_minus1_pullback": 182.8,
    "ladder_4_base": 175.1,
    "ladder_5_euphoria": 252.9
  },
  {
    "symbol": "8070.TW",
    "name": "長華*",
    "sector": "電子通路業",
    "close": 51.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.67,
    "dog_ma200_bias": -0.005,
    "vr60": 1.57,
    "rs20": 1.02,
    "rs60": 1.0,
    "shares": 16949,
    "lots": 16,
    "odd_shares": 949,
    "ntd_at_risk": 39999.64,
    "position_cost": 872873.5,
    "constraint": "WEIGHT",
    "atr14": 1.18,
    "low_20d": 48.2,
    "ladder_minus1_pullback": 48.4,
    "ladder_4_base": 46.4,
    "ladder_5_euphoria": 67.0
  },
  {
    "symbol": "2913.TW",
    "name": "農林",
    "sector": "貿易百貨業",
    "close": 11.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.6,
    "dog_ma200_bias": -0.011,
    "vr60": 1.29,
    "rs20": 1.05,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 283750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.3,
    "ladder_minus1_pullback": 10.7,
    "ladder_4_base": 10.2,
    "ladder_5_euphoria": 14.8
  },
  {
    "symbol": "3701.TW",
    "name": "大眾控",
    "sector": "電腦及週邊設備業",
    "close": 60.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.32,
    "dog_ma200_bias": 0.106,
    "vr60": 1.63,
    "rs20": 1.08,
    "rs60": 0.96,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 1239141.8,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 57.5,
    "ladder_minus1_pullback": 56.5,
    "ladder_4_base": 54.1,
    "ladder_5_euphoria": 78.1
  },
  {
    "symbol": "6271.TW",
    "name": "同欣電",
    "sector": "半導體業",
    "close": 229.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.18,
    "dog_ma200_bias": 0.008,
    "vr60": 1.28,
    "rs20": 0.97,
    "rs60": 0.91,
    "shares": 3120,
    "lots": 3,
    "odd_shares": 120,
    "ntd_at_risk": 39998.4,
    "position_cost": 714480.0,
    "constraint": "WEIGHT",
    "atr14": 6.41,
    "low_20d": 215.3,
    "ladder_minus1_pullback": 215.3,
    "ladder_4_base": 206.1,
    "ladder_5_euphoria": 297.7
  },
  {
    "symbol": "6141.TW",
    "name": "柏承",
    "sector": "電子零組件業",
    "close": 52.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.15,
    "dog_ma200_bias": 0.041,
    "vr60": 1.9,
    "rs20": 1.03,
    "rs60": 1.0,
    "shares": 18518,
    "lots": 18,
    "odd_shares": 518,
    "ntd_at_risk": 39998.88,
    "position_cost": 964787.8,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 48.5,
    "ladder_minus1_pullback": 49.0,
    "ladder_4_base": 46.9,
    "ladder_5_euphoria": 67.7
  },
  {
    "symbol": "4716.TWO",
    "name": "大立",
    "sector": "化學工業",
    "close": 18.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.23,
    "dog_ma200_bias": 0.139,
    "vr60": 1.23,
    "rs20": 1.16,
    "rs60": 1.1,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 470000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.2,
    "ladder_minus1_pullback": 17.7,
    "ladder_4_base": 16.9,
    "ladder_5_euphoria": 24.4
  },
  {
    "symbol": "1722.TW",
    "name": "台肥",
    "sector": "化學工業",
    "close": 42.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.31,
    "dog_ma200_bias": 0.055,
    "vr60": 1.47,
    "rs20": 0.77,
    "rs60": 1.01,
    "shares": 16000,
    "lots": 16,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 673600.0,
    "constraint": "WEIGHT",
    "atr14": 1.25,
    "low_20d": 40.3,
    "ladder_minus1_pullback": 39.6,
    "ladder_4_base": 37.9,
    "ladder_5_euphoria": 54.7
  },
  {
    "symbol": "2601.TW",
    "name": "益航",
    "sector": "航運業",
    "close": 6.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.12,
    "dog_ma200_bias": 0.075,
    "vr60": 1.65,
    "rs20": 0.8,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 150000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 5.5,
    "ladder_minus1_pullback": 5.6,
    "ladder_4_base": 5.4,
    "ladder_5_euphoria": 7.8
  },
  {
    "symbol": "4916.TW",
    "name": "事欣科",
    "sector": "電腦及週邊設備業",
    "close": 97.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.21,
    "dog_ma200_bias": 0.039,
    "vr60": 1.68,
    "rs20": 1.14,
    "rs60": 1.05,
    "shares": 10526,
    "lots": 10,
    "odd_shares": 526,
    "ntd_at_risk": 39998.8,
    "position_cost": 1027337.6,
    "constraint": "WEIGHT",
    "atr14": 1.9,
    "low_20d": 89.7,
    "ladder_minus1_pullback": 91.7,
    "ladder_4_base": 87.8,
    "ladder_5_euphoria": 126.9
  },
  {
    "symbol": "1909.TW",
    "name": "榮成",
    "sector": "造紙工業",
    "close": 10.35,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.17,
    "dog_ma200_bias": 0.367,
    "vr60": 1.73,
    "rs20": 1.45,
    "rs60": 1.3,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.7,
    "ladder_minus1_pullback": 9.7,
    "ladder_4_base": 9.3,
    "ladder_5_euphoria": 13.5
  },
  {
    "symbol": "6517.TWO",
    "name": "保勝光學",
    "sector": "光電業",
    "close": 70.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.89,
    "rs20": 1.13,
    "rs60": 0.97,
    "shares": 18867,
    "lots": 18,
    "odd_shares": 867,
    "ntd_at_risk": 39998.04,
    "position_cost": 1320690.0,
    "constraint": "WEIGHT",
    "atr14": 1.06,
    "low_20d": 65.2,
    "ladder_minus1_pullback": 65.8,
    "ladder_4_base": 63.0,
    "ladder_5_euphoria": 91.0
  },
  {
    "symbol": "1708.TW",
    "name": "東鹼",
    "sector": "化學工業",
    "close": 52.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.13,
    "dog_ma200_bias": 0.062,
    "vr60": 1.09,
    "rs20": 1.05,
    "rs60": 0.92,
    "shares": 21978,
    "lots": 21,
    "odd_shares": 978,
    "ntd_at_risk": 39999.96,
    "position_cost": 1160438.4,
    "constraint": "WEIGHT",
    "atr14": 0.91,
    "low_20d": 50.7,
    "ladder_minus1_pullback": 49.6,
    "ladder_4_base": 47.5,
    "ladder_5_euphoria": 68.6
  },
  {
    "symbol": "2206.TW",
    "name": "三陽工業",
    "sector": "汽車工業",
    "close": 65.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.67,
    "dog_ma200_bias": -0.014,
    "vr60": 1.91,
    "rs20": 0.95,
    "rs60": 0.92,
    "shares": 17543,
    "lots": 17,
    "odd_shares": 543,
    "ntd_at_risk": 39998.04,
    "position_cost": 1145557.9,
    "constraint": "WEIGHT",
    "atr14": 1.14,
    "low_20d": 62.3,
    "ladder_minus1_pullback": 61.4,
    "ladder_4_base": 58.8,
    "ladder_5_euphoria": 84.9
  },
  {
    "symbol": "2458.TW",
    "name": "義隆",
    "sector": "半導體業",
    "close": 135.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.8,
    "dog_ma200_bias": 0.03,
    "vr60": 1.57,
    "rs20": 1.03,
    "rs60": 0.73,
    "shares": 6024,
    "lots": 6,
    "odd_shares": 24,
    "ntd_at_risk": 39999.36,
    "position_cost": 816252.0,
    "constraint": "WEIGHT",
    "atr14": 3.32,
    "low_20d": 123.3,
    "ladder_minus1_pullback": 127.4,
    "ladder_4_base": 122.0,
    "ladder_5_euphoria": 176.2
  },
  {
    "symbol": "2006.TW",
    "name": "東和鋼鐵",
    "sector": "鋼鐵工業",
    "close": 90.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.22,
    "dog_ma200_bias": 0.124,
    "vr60": 1.42,
    "rs20": 1.06,
    "rs60": 1.02,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 1242749.3,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 85.8,
    "ladder_minus1_pullback": 84.7,
    "ladder_4_base": 81.1,
    "ladder_5_euphoria": 117.1
  },
  {
    "symbol": "3014.TW",
    "name": "聯陽",
    "sector": "半導體業",
    "close": 146.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.88,
    "dog_ma200_bias": 0.121,
    "vr60": 1.17,
    "rs20": 1.27,
    "rs60": 1.11,
    "shares": 3937,
    "lots": 3,
    "odd_shares": 937,
    "ntd_at_risk": 39999.92,
    "position_cost": 576770.5,
    "constraint": "WEIGHT",
    "atr14": 5.08,
    "low_20d": 133.4,
    "ladder_minus1_pullback": 137.7,
    "ladder_4_base": 131.8,
    "ladder_5_euphoria": 190.5
  },
  {
    "symbol": "5475.TWO",
    "name": "德宏",
    "sector": "電子零組件業",
    "close": 193.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.31,
    "dog_ma200_bias": 0.019,
    "vr60": 1.77,
    "rs20": 1.08,
    "rs60": 0.94,
    "shares": 3992,
    "lots": 3,
    "odd_shares": 992,
    "ntd_at_risk": 39999.84,
    "position_cost": 770456.0,
    "constraint": "WEIGHT",
    "atr14": 5.01,
    "low_20d": 175.8,
    "ladder_minus1_pullback": 181.4,
    "ladder_4_base": 173.7,
    "ladder_5_euphoria": 250.9
  },
  {
    "symbol": "2342.TW",
    "name": "茂矽",
    "sector": "半導體業",
    "close": 42.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.11,
    "dog_ma200_bias": -0.013,
    "vr60": 1.83,
    "rs20": 1.04,
    "rs60": 1.0,
    "shares": 14814,
    "lots": 14,
    "odd_shares": 814,
    "ntd_at_risk": 39997.8,
    "position_cost": 622188.0,
    "constraint": "WEIGHT",
    "atr14": 1.35,
    "low_20d": 38.8,
    "ladder_minus1_pullback": 39.5,
    "ladder_4_base": 37.8,
    "ladder_5_euphoria": 54.6
  },
  {
    "symbol": "2406.TW",
    "name": "國碩",
    "sector": "光電業",
    "close": 28.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.17,
    "dog_ma200_bias": -0.014,
    "vr60": 1.28,
    "rs20": 0.92,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 722500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.4,
    "ladder_minus1_pullback": 27.2,
    "ladder_4_base": 26.0,
    "ladder_5_euphoria": 37.6
  },
  {
    "symbol": "8096.TWO",
    "name": "擎亞",
    "sector": "電子通路業",
    "close": 84.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.05,
    "dog_ma200_bias": 0.041,
    "vr60": 1.48,
    "rs20": 1.05,
    "rs60": 0.96,
    "shares": 8403,
    "lots": 8,
    "odd_shares": 403,
    "ntd_at_risk": 39998.28,
    "position_cost": 710053.5,
    "constraint": "WEIGHT",
    "atr14": 2.38,
    "low_20d": 80.3,
    "ladder_minus1_pullback": 79.4,
    "ladder_4_base": 76.0,
    "ladder_5_euphoria": 109.9
  },
  {
    "symbol": "6120.TW",
    "name": "達運",
    "sector": "光電業",
    "close": 13.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.29,
    "dog_ma200_bias": -0.008,
    "vr60": 1.84,
    "rs20": 1.03,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 331250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.3,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 11.9,
    "ladder_5_euphoria": 17.2
  },
  {
    "symbol": "2338.TW",
    "name": "光罩",
    "sector": "半導體業",
    "close": 44.55,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.05,
    "dog_ma200_bias": 0.371,
    "vr60": 2.12,
    "rs20": 1.42,
    "rs60": 1.35,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.26,
    "low_20d": 40.2,
    "ladder_minus1_pullback": 41.9,
    "ladder_4_base": 40.1,
    "ladder_5_euphoria": 57.9
  },
  {
    "symbol": "6538.TWO",
    "name": "倉和",
    "sector": "電子零組件業",
    "close": 302.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.05,
    "dog_ma200_bias": -0.007,
    "vr60": 1.9,
    "rs20": 0.86,
    "rs60": 1.01,
    "shares": 2336,
    "lots": 2,
    "odd_shares": 336,
    "ntd_at_risk": 39992.32,
    "position_cost": 705472.0,
    "constraint": "WEIGHT",
    "atr14": 8.56,
    "low_20d": 282.8,
    "ladder_minus1_pullback": 283.9,
    "ladder_4_base": 271.8,
    "ladder_5_euphoria": 392.6
  },
  {
    "symbol": "2436.TW",
    "name": "偉詮電",
    "sector": "半導體業",
    "close": 70.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.37,
    "dog_ma200_bias": 0.153,
    "vr60": 1.07,
    "rs20": 1.27,
    "rs60": 1.01,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 1166620.0,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 65.4,
    "ladder_minus1_pullback": 65.8,
    "ladder_4_base": 63.0,
    "ladder_5_euphoria": 91.0
  },
  {
    "symbol": "2061.TWO",
    "name": "風青",
    "sector": "電器電纜業",
    "close": 61.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": -0.014,
    "vr60": 1.84,
    "rs20": 0.98,
    "rs60": 0.73,
    "shares": 21052,
    "lots": 21,
    "odd_shares": 52,
    "ntd_at_risk": 39998.8,
    "position_cost": 1290487.6,
    "constraint": "WEIGHT",
    "atr14": 0.95,
    "low_20d": 57.2,
    "ladder_minus1_pullback": 57.6,
    "ladder_4_base": 55.2,
    "ladder_5_euphoria": 79.7
  },
  {
    "symbol": "3564.TWO",
    "name": "其陽",
    "sector": "通信網路業",
    "close": 71.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.07,
    "dog_ma200_bias": 0.026,
    "vr60": 1.52,
    "rs20": 0.95,
    "rs60": 0.9,
    "shares": 18348,
    "lots": 18,
    "odd_shares": 348,
    "ntd_at_risk": 39998.64,
    "position_cost": 1308212.4,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 67.2,
    "ladder_minus1_pullback": 67.0,
    "ladder_4_base": 64.2,
    "ladder_5_euphoria": 92.7
  },
  {
    "symbol": "1904.TW",
    "name": "正隆",
    "sector": "造紙工業",
    "close": 25.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.27,
    "dog_ma200_bias": 0.017,
    "vr60": 1.43,
    "rs20": 0.79,
    "rs60": 0.9,
    "shares": 23809,
    "lots": 23,
    "odd_shares": 809,
    "ntd_at_risk": 39999.12,
    "position_cost": 609510.4,
    "constraint": "WEIGHT",
    "atr14": 0.84,
    "low_20d": 23.6,
    "ladder_minus1_pullback": 24.1,
    "ladder_4_base": 23.0,
    "ladder_5_euphoria": 33.3
  },
  {
    "symbol": "9921.TW",
    "name": "巨大",
    "sector": "運動休閒",
    "close": 93.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.31,
    "dog_ma200_bias": 0.052,
    "vr60": 1.41,
    "rs20": 0.95,
    "rs60": 0.72,
    "shares": 6451,
    "lots": 6,
    "odd_shares": 451,
    "ntd_at_risk": 39996.2,
    "position_cost": 602523.4,
    "constraint": "WEIGHT",
    "atr14": 3.1,
    "low_20d": 84.3,
    "ladder_minus1_pullback": 87.8,
    "ladder_4_base": 84.1,
    "ladder_5_euphoria": 121.4
  },
  {
    "symbol": "8027.TWO",
    "name": "鈦昇",
    "sector": "電機機械業",
    "close": 185.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.1,
    "dog_ma200_bias": 0.066,
    "vr60": 1.42,
    "rs20": 0.94,
    "rs60": 0.83,
    "shares": 3669,
    "lots": 3,
    "odd_shares": 669,
    "ntd_at_risk": 39992.1,
    "position_cost": 678765.0,
    "constraint": "WEIGHT",
    "atr14": 5.45,
    "low_20d": 174.5,
    "ladder_minus1_pullback": 173.9,
    "ladder_4_base": 166.5,
    "ladder_5_euphoria": 240.5
  },
  {
    "symbol": "4915.TW",
    "name": "致伸",
    "sector": "電子零組件業",
    "close": 63.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.1,
    "dog_ma200_bias": -0.005,
    "vr60": 2.04,
    "rs20": 1.09,
    "rs60": 0.89,
    "shares": 14285,
    "lots": 14,
    "odd_shares": 285,
    "ntd_at_risk": 39998.0,
    "position_cost": 905669.0,
    "constraint": "WEIGHT",
    "atr14": 1.4,
    "low_20d": 57.6,
    "ladder_minus1_pullback": 59.6,
    "ladder_4_base": 57.1,
    "ladder_5_euphoria": 82.4
  },
  {
    "symbol": "5608.TW",
    "name": "四維航",
    "sector": "航運業",
    "close": 16.65,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.05,
    "dog_ma200_bias": -0.072,
    "vr60": 0.86,
    "rs20": 0.45,
    "rs60": 0.46,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 15.3,
    "ladder_minus1_pullback": 15.7,
    "ladder_4_base": 15.0,
    "ladder_5_euphoria": 21.6
  },
  {
    "symbol": "3376.TW",
    "name": "新日興",
    "sector": "電子零組件業",
    "close": 176.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.25,
    "dog_ma200_bias": 0.022,
    "vr60": 1.85,
    "rs20": 0.86,
    "rs60": 0.73,
    "shares": 6968,
    "lots": 6,
    "odd_shares": 968,
    "ntd_at_risk": 39996.32,
    "position_cost": 1229852.0,
    "constraint": "WEIGHT",
    "atr14": 2.87,
    "low_20d": 162.5,
    "ladder_minus1_pullback": 165.9,
    "ladder_4_base": 158.8,
    "ladder_5_euphoria": 229.5
  },
  {
    "symbol": "9958.TW",
    "name": "世紀鋼",
    "sector": "鋼鐵工業",
    "close": 88.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.21,
    "dog_ma200_bias": 0.017,
    "vr60": 1.65,
    "rs20": 1.11,
    "rs60": 0.76,
    "shares": 7692,
    "lots": 7,
    "odd_shares": 692,
    "ntd_at_risk": 39998.4,
    "position_cost": 680742.0,
    "constraint": "WEIGHT",
    "atr14": 2.6,
    "low_20d": 83.2,
    "ladder_minus1_pullback": 83.2,
    "ladder_4_base": 79.7,
    "ladder_5_euphoria": 115.0
  },
  {
    "symbol": "6706.TW",
    "name": "惠特",
    "sector": "光電業",
    "close": 143.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.15,
    "dog_ma200_bias": 0.06,
    "vr60": 2.08,
    "rs20": 1.13,
    "rs60": 0.72,
    "shares": 4535,
    "lots": 4,
    "odd_shares": 535,
    "ntd_at_risk": 39998.7,
    "position_cost": 650772.5,
    "constraint": "WEIGHT",
    "atr14": 4.41,
    "low_20d": 135.4,
    "ladder_minus1_pullback": 134.9,
    "ladder_4_base": 129.2,
    "ladder_5_euphoria": 186.6
  },
  {
    "symbol": "1210.TW",
    "name": "大成",
    "sector": "食品工業",
    "close": 51.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.95,
    "dog_ma200_bias": 0.116,
    "vr60": 1.22,
    "rs20": 1.29,
    "rs60": 1.03,
    "shares": 18348,
    "lots": 18,
    "odd_shares": 348,
    "ntd_at_risk": 39998.64,
    "position_cost": 950426.4,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 48.5,
    "ladder_minus1_pullback": 48.7,
    "ladder_4_base": 46.6,
    "ladder_5_euphoria": 67.3
  },
  {
    "symbol": "2520.TW",
    "name": "冠德",
    "sector": "建材營造業",
    "close": 37.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.58,
    "dog_ma200_bias": 0.035,
    "vr60": 1.21,
    "rs20": 0.83,
    "rs60": 0.9,
    "shares": 19047,
    "lots": 19,
    "odd_shares": 47,
    "ntd_at_risk": 39998.7,
    "position_cost": 719024.25,
    "constraint": "WEIGHT",
    "atr14": 1.05,
    "low_20d": 35.4,
    "ladder_minus1_pullback": 35.5,
    "ladder_4_base": 34.0,
    "ladder_5_euphoria": 49.1
  },
  {
    "symbol": "2392.TW",
    "name": "正崴",
    "sector": "電子零組件業",
    "close": 39.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.12,
    "dog_ma200_bias": 0.01,
    "vr60": 1.76,
    "rs20": 0.94,
    "rs60": 0.91,
    "shares": 17857,
    "lots": 17,
    "odd_shares": 857,
    "ntd_at_risk": 39999.68,
    "position_cost": 709815.75,
    "constraint": "WEIGHT",
    "atr14": 1.12,
    "low_20d": 36.8,
    "ladder_minus1_pullback": 37.4,
    "ladder_4_base": 35.8,
    "ladder_5_euphoria": 51.7
  },
  {
    "symbol": "8289.TWO",
    "name": "泰藝",
    "sector": "電子零組件業",
    "close": 53.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.05,
    "dog_ma200_bias": 0.029,
    "vr60": 1.9,
    "rs20": 0.83,
    "rs60": 1.02,
    "shares": 12345,
    "lots": 12,
    "odd_shares": 345,
    "ntd_at_risk": 39997.8,
    "position_cost": 654285.0,
    "constraint": "WEIGHT",
    "atr14": 1.62,
    "low_20d": 49.2,
    "ladder_minus1_pullback": 49.8,
    "ladder_4_base": 47.7,
    "ladder_5_euphoria": 68.9
  },
  {
    "symbol": "5388.TW",
    "name": "中磊",
    "sector": "通信網路業",
    "close": 74.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.67,
    "dog_ma200_bias": 0.151,
    "vr60": 1.2,
    "rs20": 0.95,
    "rs60": 1.06,
    "shares": 12422,
    "lots": 12,
    "odd_shares": 422,
    "ntd_at_risk": 39998.84,
    "position_cost": 929165.6,
    "constraint": "WEIGHT",
    "atr14": 1.61,
    "low_20d": 67.5,
    "ladder_minus1_pullback": 70.3,
    "ladder_4_base": 67.3,
    "ladder_5_euphoria": 97.2
  },
  {
    "symbol": "8926.TW",
    "name": "台汽電",
    "sector": "油電燃氣業",
    "close": 58.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.43,
    "dog_ma200_bias": 0.088,
    "vr60": 1.26,
    "rs20": 1.29,
    "rs60": 1.25,
    "shares": 12422,
    "lots": 12,
    "odd_shares": 422,
    "ntd_at_risk": 39998.84,
    "position_cost": 730413.6,
    "constraint": "WEIGHT",
    "atr14": 1.61,
    "low_20d": 55.0,
    "ladder_minus1_pullback": 55.3,
    "ladder_4_base": 52.9,
    "ladder_5_euphoria": 76.4
  },
  {
    "symbol": "6197.TW",
    "name": "佳必琪",
    "sector": "電子零組件業",
    "close": 355.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.16,
    "dog_ma200_bias": -0.067,
    "vr60": 0.6,
    "rs20": 0.53,
    "rs60": 0.65,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 11.37,
    "low_20d": 337.4,
    "ladder_minus1_pullback": 333.7,
    "ladder_4_base": 319.5,
    "ladder_5_euphoria": 461.5
  },
  {
    "symbol": "4967.TW",
    "name": "十銓",
    "sector": "半導體業",
    "close": 254.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.27,
    "dog_ma200_bias": 0.053,
    "vr60": 1.29,
    "rs20": 0.96,
    "rs60": 0.78,
    "shares": 4587,
    "lots": 4,
    "odd_shares": 587,
    "ntd_at_risk": 39998.64,
    "position_cost": 1167391.5,
    "constraint": "WEIGHT",
    "atr14": 4.36,
    "low_20d": 230.1,
    "ladder_minus1_pullback": 239.2,
    "ladder_4_base": 229.1,
    "ladder_5_euphoria": 330.9
  },
  {
    "symbol": "8932.TWO",
    "name": "智通*",
    "sector": "數位雲端",
    "close": 91.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.33,
    "dog_ma200_bias": 0.119,
    "vr60": 1.09,
    "rs20": 1.35,
    "rs60": 1.18,
    "shares": 7220,
    "lots": 7,
    "odd_shares": 220,
    "ntd_at_risk": 39998.8,
    "position_cost": 661352.0,
    "constraint": "WEIGHT",
    "atr14": 2.77,
    "low_20d": 82.5,
    "ladder_minus1_pullback": 86.1,
    "ladder_4_base": 82.4,
    "ladder_5_euphoria": 119.1
  },
  {
    "symbol": "3324.TWO",
    "name": "雙鴻",
    "sector": "其他電子業",
    "close": 1410.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.15,
    "dog_ma200_bias": -0.263,
    "vr60": 1.06,
    "rs20": 0.56,
    "rs60": 0.37,
    "shares": 239,
    "lots": 0,
    "odd_shares": 239,
    "ntd_at_risk": 19985.18,
    "position_cost": 336990.0,
    "constraint": "WEIGHT",
    "atr14": 41.81,
    "low_20d": 1333.6,
    "ladder_minus1_pullback": 1325.4,
    "ladder_4_base": 1269.0,
    "ladder_5_euphoria": 1833.0
  },
  {
    "symbol": "1809.TW",
    "name": "中釉",
    "sector": "玻璃陶瓷業",
    "close": 41.1,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.33,
    "dog_ma200_bias": -0.213,
    "vr60": 1.09,
    "rs20": 0.23,
    "rs60": 0.22,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 513750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 37.3,
    "ladder_minus1_pullback": 38.6,
    "ladder_4_base": 37.0,
    "ladder_5_euphoria": 53.4
  },
  {
    "symbol": "3030.TW",
    "name": "德律",
    "sector": "其他電子業",
    "close": 285.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": 0.062,
    "vr60": 1.27,
    "rs20": 0.98,
    "rs60": 0.85,
    "shares": 2998,
    "lots": 2,
    "odd_shares": 998,
    "ntd_at_risk": 39993.32,
    "position_cost": 854430.0,
    "constraint": "WEIGHT",
    "atr14": 6.67,
    "low_20d": 272.5,
    "ladder_minus1_pullback": 267.9,
    "ladder_4_base": 256.5,
    "ladder_5_euphoria": 370.5
  },
  {
    "symbol": "4576.TW",
    "name": "大銀微系統",
    "sector": "電機機械業",
    "close": 205.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.05,
    "dog_ma200_bias": 0.076,
    "vr60": 1.41,
    "rs20": 0.85,
    "rs60": 0.81,
    "shares": 5633,
    "lots": 5,
    "odd_shares": 633,
    "ntd_at_risk": 39994.3,
    "position_cost": 1157581.5,
    "constraint": "WEIGHT",
    "atr14": 3.55,
    "low_20d": 186.8,
    "ladder_minus1_pullback": 193.2,
    "ladder_4_base": 185.0,
    "ladder_5_euphoria": 267.2
  },
  {
    "symbol": "4540.TW",
    "name": "全球傳動",
    "sector": "電機機械業",
    "close": 58.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.2,
    "dog_ma200_bias": -0.136,
    "vr60": 0.97,
    "rs20": 0.49,
    "rs60": 0.3,
    "shares": 5681,
    "lots": 5,
    "odd_shares": 681,
    "ntd_at_risk": 19997.12,
    "position_cost": 329498.0,
    "constraint": "WEIGHT",
    "atr14": 1.76,
    "low_20d": 53.6,
    "ladder_minus1_pullback": 54.5,
    "ladder_4_base": 52.2,
    "ladder_5_euphoria": 75.4
  },
  {
    "symbol": "5285.TW",
    "name": "界霖",
    "sector": "半導體業",
    "close": 88.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.05,
    "dog_ma200_bias": -0.013,
    "vr60": 1.38,
    "rs20": 1.06,
    "rs60": 0.9,
    "shares": 6711,
    "lots": 6,
    "odd_shares": 711,
    "ntd_at_risk": 39997.56,
    "position_cost": 596607.9,
    "constraint": "WEIGHT",
    "atr14": 2.98,
    "low_20d": 83.6,
    "ladder_minus1_pullback": 83.6,
    "ladder_4_base": 80.0,
    "ladder_5_euphoria": 115.6
  },
  {
    "symbol": "2388.TW",
    "name": "威盛",
    "sector": "半導體業",
    "close": 65.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.13,
    "dog_ma200_bias": -0.004,
    "vr60": 1.35,
    "rs20": 0.94,
    "rs60": 0.84,
    "shares": 13513,
    "lots": 13,
    "odd_shares": 513,
    "ntd_at_risk": 39998.48,
    "position_cost": 885101.5,
    "constraint": "WEIGHT",
    "atr14": 1.48,
    "low_20d": 59.0,
    "ladder_minus1_pullback": 61.6,
    "ladder_4_base": 59.0,
    "ladder_5_euphoria": 85.2
  },
  {
    "symbol": "6218.TWO",
    "name": "豪勉",
    "sector": "通信網路業",
    "close": 51.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.11,
    "dog_ma200_bias": 0.034,
    "vr60": 2.07,
    "rs20": 0.83,
    "rs60": 0.81,
    "shares": 20408,
    "lots": 20,
    "odd_shares": 408,
    "ntd_at_risk": 39999.68,
    "position_cost": 1053052.8,
    "constraint": "WEIGHT",
    "atr14": 0.98,
    "low_20d": 48.8,
    "ladder_minus1_pullback": 48.5,
    "ladder_4_base": 46.4,
    "ladder_5_euphoria": 67.1
  },
  {
    "symbol": "3363.TWO",
    "name": "上詮",
    "sector": "通信網路業",
    "close": 520.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.33,
    "dog_ma200_bias": 0.007,
    "vr60": 1.31,
    "rs20": 0.81,
    "rs60": 0.94,
    "shares": 1855,
    "lots": 1,
    "odd_shares": 855,
    "ntd_at_risk": 39993.8,
    "position_cost": 964600.0,
    "constraint": "WEIGHT",
    "atr14": 10.78,
    "low_20d": 492.9,
    "ladder_minus1_pullback": 488.8,
    "ladder_4_base": 468.0,
    "ladder_5_euphoria": 676.0
  },
  {
    "symbol": "2637.TW",
    "name": "慧洋-KY",
    "sector": "航運業",
    "close": 101.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.14,
    "dog_ma200_bias": 0.063,
    "vr60": 1.83,
    "rs20": 0.77,
    "rs60": 0.99,
    "shares": 6329,
    "lots": 6,
    "odd_shares": 329,
    "ntd_at_risk": 39999.28,
    "position_cost": 639229.0,
    "constraint": "WEIGHT",
    "atr14": 3.16,
    "low_20d": 92.1,
    "ladder_minus1_pullback": 94.9,
    "ladder_4_base": 90.9,
    "ladder_5_euphoria": 131.3
  },
  {
    "symbol": "5202.TWO",
    "name": "力新",
    "sector": "資訊服務業",
    "close": 14.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.05,
    "dog_ma200_bias": 0.013,
    "vr60": 1.28,
    "rs20": 0.85,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 351250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 13.2,
    "ladder_4_base": 12.6,
    "ladder_5_euphoria": 18.3
  },
  {
    "symbol": "4956.TW",
    "name": "光鋐",
    "sector": "光電業",
    "close": 38.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.05,
    "dog_ma200_bias": 0.122,
    "vr60": 1.46,
    "rs20": 1.05,
    "rs60": 1.3,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 950000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 34.6,
    "ladder_minus1_pullback": 35.7,
    "ladder_4_base": 34.2,
    "ladder_5_euphoria": 49.4
  },
  {
    "symbol": "6190.TWO",
    "name": "萬泰科",
    "sector": "通信網路業",
    "close": 71.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": -0.017,
    "vr60": 1.56,
    "rs20": 0.93,
    "rs60": 0.96,
    "shares": 12578,
    "lots": 12,
    "odd_shares": 578,
    "ntd_at_risk": 39998.04,
    "position_cost": 899327.0,
    "constraint": "WEIGHT",
    "atr14": 1.59,
    "low_20d": 66.9,
    "ladder_minus1_pullback": 67.2,
    "ladder_4_base": 64.4,
    "ladder_5_euphoria": 93.0
  },
  {
    "symbol": "3163.TWO",
    "name": "波若威",
    "sector": "通信網路業",
    "close": 604.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.32,
    "dog_ma200_bias": -0.055,
    "vr60": 1.72,
    "rs20": 0.68,
    "rs60": 0.5,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 9.93,
    "low_20d": 573.1,
    "ladder_minus1_pullback": 567.8,
    "ladder_4_base": 543.6,
    "ladder_5_euphoria": 785.2
  },
  {
    "symbol": "6533.TW",
    "name": "晶心科",
    "sector": "半導體業",
    "close": 294.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.05,
    "dog_ma200_bias": 0.063,
    "vr60": 2.08,
    "rs20": 0.8,
    "rs60": 0.99,
    "shares": 2044,
    "lots": 2,
    "odd_shares": 44,
    "ntd_at_risk": 39980.64,
    "position_cost": 601958.0,
    "constraint": "WEIGHT",
    "atr14": 9.78,
    "low_20d": 271.4,
    "ladder_minus1_pullback": 276.8,
    "ladder_4_base": 265.1,
    "ladder_5_euphoria": 382.9
  },
  {
    "symbol": "6021.TWO",
    "name": "美好證",
    "sector": "金融保險業",
    "close": 56.1,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.43,
    "dog_ma200_bias": -0.213,
    "vr60": 0.93,
    "rs20": 0.46,
    "rs60": 0.4,
    "shares": 5617,
    "lots": 5,
    "odd_shares": 617,
    "ntd_at_risk": 19996.52,
    "position_cost": 315113.7,
    "constraint": "WEIGHT",
    "atr14": 1.78,
    "low_20d": 51.9,
    "ladder_minus1_pullback": 52.7,
    "ladder_4_base": 50.5,
    "ladder_5_euphoria": 72.9
  },
  {
    "symbol": "7788.TW",
    "name": "松川精密",
    "sector": "電子零組件業",
    "close": 283.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.06,
    "dog_ma200_bias": 0.158,
    "vr60": 1.06,
    "rs20": 0.98,
    "rs60": 1.26,
    "shares": 3205,
    "lots": 3,
    "odd_shares": 205,
    "ntd_at_risk": 39998.4,
    "position_cost": 907015.0,
    "constraint": "WEIGHT",
    "atr14": 6.24,
    "low_20d": 261.2,
    "ladder_minus1_pullback": 266.0,
    "ladder_4_base": 254.7,
    "ladder_5_euphoria": 367.9
  },
  {
    "symbol": "5009.TWO",
    "name": "榮剛",
    "sector": "鋼鐵工業",
    "close": 33.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.05,
    "dog_ma200_bias": 0.024,
    "vr60": 1.32,
    "rs20": 1.11,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 841250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 32.2,
    "ladder_minus1_pullback": 31.6,
    "ladder_4_base": 30.3,
    "ladder_5_euphoria": 43.7
  },
  {
    "symbol": "6901.TW",
    "name": "鑽石投資",
    "sector": "其他業",
    "close": 17.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.42,
    "dog_ma200_bias": 0.1,
    "vr60": 1.08,
    "rs20": 1.13,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 435000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.6,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.7,
    "ladder_5_euphoria": 22.6
  },
  {
    "symbol": "3718.TWO",
    "name": "中光電投控",
    "sector": "光電業",
    "close": 60.3,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.05,
    "dog_ma200_bias": -0.12,
    "vr60": 0.89,
    "rs20": 0.44,
    "rs60": 0.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.85,
    "low_20d": 56.8,
    "ladder_minus1_pullback": 56.7,
    "ladder_4_base": 54.3,
    "ladder_5_euphoria": 78.4
  },
  {
    "symbol": "6174.TWO",
    "name": "安碁",
    "sector": "電子零組件業",
    "close": 52.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.36,
    "rs20": 0.84,
    "rs60": 0.77,
    "shares": 19230,
    "lots": 19,
    "odd_shares": 230,
    "ntd_at_risk": 39998.4,
    "position_cost": 1015344.0,
    "constraint": "WEIGHT",
    "atr14": 1.04,
    "low_20d": 48.8,
    "ladder_minus1_pullback": 49.6,
    "ladder_4_base": 47.5,
    "ladder_5_euphoria": 68.6
  },
  {
    "symbol": "4114.TWO",
    "name": "健喬",
    "sector": "生技醫療業",
    "close": 30.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.8,
    "dog_ma200_bias": 0.008,
    "vr60": 2.0,
    "rs20": 0.76,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 753750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.2,
    "ladder_minus1_pullback": 28.3,
    "ladder_4_base": 27.1,
    "ladder_5_euphoria": 39.2
  },
  {
    "symbol": "2421.TW",
    "name": "建準",
    "sector": "電子零組件業",
    "close": 164.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.33,
    "dog_ma200_bias": 0.005,
    "vr60": 1.47,
    "rs20": 0.91,
    "rs60": 0.89,
    "shares": 6097,
    "lots": 6,
    "odd_shares": 97,
    "ntd_at_risk": 39996.32,
    "position_cost": 999908.0,
    "constraint": "WEIGHT",
    "atr14": 3.28,
    "low_20d": 150.5,
    "ladder_minus1_pullback": 154.2,
    "ladder_4_base": 147.6,
    "ladder_5_euphoria": 213.2
  },
  {
    "symbol": "2467.TW",
    "name": "志聖",
    "sector": "電子零組件業",
    "close": 506.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.08,
    "dog_ma200_bias": 0.067,
    "vr60": 1.22,
    "rs20": 1.0,
    "rs60": 0.98,
    "shares": 1218,
    "lots": 1,
    "odd_shares": 218,
    "ntd_at_risk": 39974.76,
    "position_cost": 616308.0,
    "constraint": "WEIGHT",
    "atr14": 16.41,
    "low_20d": 456.4,
    "ladder_minus1_pullback": 475.6,
    "ladder_4_base": 455.4,
    "ladder_5_euphoria": 657.8
  },
  {
    "symbol": "6451.TW",
    "name": "訊芯-KY",
    "sector": "半導體業",
    "close": 360.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.11,
    "dog_ma200_bias": 0.008,
    "vr60": 1.77,
    "rs20": 0.62,
    "rs60": 0.73,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 9.56,
    "low_20d": 327.6,
    "ladder_minus1_pullback": 338.9,
    "ladder_4_base": 324.4,
    "ladder_5_euphoria": 468.7
  },
  {
    "symbol": "3031.TW",
    "name": "佰鴻",
    "sector": "光電業",
    "close": 30.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.07,
    "dog_ma200_bias": 0.079,
    "vr60": 1.9,
    "rs20": 0.89,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 767500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.7,
    "ladder_minus1_pullback": 28.9,
    "ladder_4_base": 27.6,
    "ladder_5_euphoria": 39.9
  },
  {
    "symbol": "6261.TWO",
    "name": "久元",
    "sector": "半導體業",
    "close": 78.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.07,
    "dog_ma200_bias": -0.193,
    "vr60": 1.06,
    "rs20": 0.4,
    "rs60": 0.32,
    "shares": 4405,
    "lots": 4,
    "odd_shares": 405,
    "ntd_at_risk": 19998.7,
    "position_cost": 345352.0,
    "constraint": "WEIGHT",
    "atr14": 2.27,
    "low_20d": 74.7,
    "ladder_minus1_pullback": 73.7,
    "ladder_4_base": 70.6,
    "ladder_5_euphoria": 101.9
  },
  {
    "symbol": "6727.TWO",
    "name": "亞泰金屬",
    "sector": "電子零組件業",
    "close": 515.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.06,
    "dog_ma200_bias": 0.012,
    "vr60": 1.4,
    "rs20": 1.11,
    "rs60": 0.97,
    "shares": 1164,
    "lots": 1,
    "odd_shares": 164,
    "ntd_at_risk": 39971.76,
    "position_cost": 599460.0,
    "constraint": "WEIGHT",
    "atr14": 17.17,
    "low_20d": 486.3,
    "ladder_minus1_pullback": 484.1,
    "ladder_4_base": 463.5,
    "ladder_5_euphoria": 669.5
  },
  {
    "symbol": "3504.TW",
    "name": "揚明光",
    "sector": "光電業",
    "close": 80.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.32,
    "dog_ma200_bias": 0.067,
    "vr60": 1.64,
    "rs20": 1.16,
    "rs60": 1.21,
    "shares": 11428,
    "lots": 11,
    "odd_shares": 428,
    "ntd_at_risk": 39998.0,
    "position_cost": 917668.4,
    "constraint": "WEIGHT",
    "atr14": 1.75,
    "low_20d": 75.8,
    "ladder_minus1_pullback": 75.5,
    "ladder_4_base": 72.3,
    "ladder_5_euphoria": 104.4
  },
  {
    "symbol": "2009.TW",
    "name": "第一銅",
    "sector": "鋼鐵工業",
    "close": 39.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": 0.08,
    "vr60": 2.08,
    "rs20": 0.79,
    "rs60": 0.93,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 659140.3,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 37.6,
    "ladder_minus1_pullback": 37.2,
    "ladder_4_base": 35.6,
    "ladder_5_euphoria": 51.4
  },
  {
    "symbol": "3550.TW",
    "name": "聯穎",
    "sector": "電子零組件業",
    "close": 23.15,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.05,
    "dog_ma200_bias": -0.232,
    "vr60": 1.02,
    "rs20": 0.57,
    "rs60": 0.2,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 289375.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.9,
    "ladder_minus1_pullback": 21.8,
    "ladder_4_base": 20.8,
    "ladder_5_euphoria": 30.1
  },
  {
    "symbol": "2645.TW",
    "name": "長榮航太",
    "sector": "航運業",
    "close": 169.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.18,
    "dog_ma200_bias": -0.241,
    "vr60": 1.03,
    "rs20": 0.52,
    "rs60": 0.31,
    "shares": 1811,
    "lots": 1,
    "odd_shares": 811,
    "ntd_at_risk": 19993.44,
    "position_cost": 306964.5,
    "constraint": "WEIGHT",
    "atr14": 5.52,
    "low_20d": 160.3,
    "ladder_minus1_pullback": 159.3,
    "ladder_4_base": 152.6,
    "ladder_5_euphoria": 220.3
  },
  {
    "symbol": "2034.TW",
    "name": "允強",
    "sector": "鋼鐵工業",
    "close": 23.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.2,
    "dog_ma200_bias": 0.065,
    "vr60": 1.36,
    "rs20": 0.99,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 580000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.0,
    "ladder_minus1_pullback": 21.8,
    "ladder_4_base": 20.9,
    "ladder_5_euphoria": 30.2
  },
  {
    "symbol": "5443.TWO",
    "name": "均豪",
    "sector": "半導體業",
    "close": 104.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.12,
    "dog_ma200_bias": -0.01,
    "vr60": 2.12,
    "rs20": 0.41,
    "rs60": 0.7,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.17,
    "low_20d": 100.1,
    "ladder_minus1_pullback": 98.2,
    "ladder_4_base": 94.0,
    "ladder_5_euphoria": 135.8
  },
  {
    "symbol": "2444.TW",
    "name": "兆勁",
    "sector": "通信網路業",
    "close": 14.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.3,
    "dog_ma200_bias": -0.179,
    "vr60": 0.9,
    "rs20": 0.28,
    "rs60": 0.55,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 180000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.3,
    "ladder_minus1_pullback": 13.5,
    "ladder_4_base": 13.0,
    "ladder_5_euphoria": 18.7
  },
  {
    "symbol": "4556.TWO",
    "name": "旭然",
    "sector": "其他業",
    "close": 123.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.12,
    "dog_ma200_bias": 0.029,
    "vr60": 1.48,
    "rs20": 0.95,
    "rs60": 0.73,
    "shares": 9803,
    "lots": 9,
    "odd_shares": 803,
    "ntd_at_risk": 39996.24,
    "position_cost": 1205769.0,
    "constraint": "WEIGHT",
    "atr14": 2.04,
    "low_20d": 114.0,
    "ladder_minus1_pullback": 115.6,
    "ladder_4_base": 110.7,
    "ladder_5_euphoria": 159.9
  },
  {
    "symbol": "6442.TW",
    "name": "光聖",
    "sector": "通信網路業",
    "close": 1540.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.5,
    "dog_ma200_bias": 0.003,
    "vr60": 1.4,
    "rs20": 0.96,
    "rs60": 0.7,
    "shares": 636,
    "lots": 0,
    "odd_shares": 636,
    "ntd_at_risk": 39978.96,
    "position_cost": 979440.0,
    "constraint": "WEIGHT",
    "atr14": 31.43,
    "low_20d": 1474.5,
    "ladder_minus1_pullback": 1447.6,
    "ladder_4_base": 1386.0,
    "ladder_5_euphoria": 2002.0
  },
  {
    "symbol": "4961.TW",
    "name": "天鈺",
    "sector": "半導體業",
    "close": 186.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.93,
    "dog_ma200_bias": 0.072,
    "vr60": 1.38,
    "rs20": 0.8,
    "rs60": 0.95,
    "shares": 4264,
    "lots": 4,
    "odd_shares": 264,
    "ntd_at_risk": 39996.32,
    "position_cost": 795236.0,
    "constraint": "WEIGHT",
    "atr14": 4.69,
    "low_20d": 171.8,
    "ladder_minus1_pullback": 175.3,
    "ladder_4_base": 167.8,
    "ladder_5_euphoria": 242.5
  },
  {
    "symbol": "8210.TW",
    "name": "勤誠",
    "sector": "電腦及週邊設備業",
    "close": 833.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.24,
    "dog_ma200_bias": 0.072,
    "vr60": 1.96,
    "rs20": 0.88,
    "rs60": 0.71,
    "shares": 1139,
    "lots": 1,
    "odd_shares": 139,
    "ntd_at_risk": 39978.9,
    "position_cost": 948787.0,
    "constraint": "WEIGHT",
    "atr14": 17.55,
    "low_20d": 757.2,
    "ladder_minus1_pullback": 783.0,
    "ladder_4_base": 749.7,
    "ladder_5_euphoria": 1082.9
  },
  {
    "symbol": "2504.TW",
    "name": "國產",
    "sector": "建材營造業",
    "close": 31.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.33,
    "dog_ma200_bias": 0.039,
    "vr60": 2.03,
    "rs20": 1.06,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 790000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.2,
    "ladder_minus1_pullback": 29.7,
    "ladder_4_base": 28.4,
    "ladder_5_euphoria": 41.1
  },
  {
    "symbol": "2359.TW",
    "name": "所羅門",
    "sector": "其他電子業",
    "close": 120.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.05,
    "dog_ma200_bias": 0.066,
    "vr60": 2.06,
    "rs20": 0.9,
    "rs60": 1.03,
    "shares": 5333,
    "lots": 5,
    "odd_shares": 333,
    "ntd_at_risk": 39997.5,
    "position_cost": 639960.0,
    "constraint": "WEIGHT",
    "atr14": 3.75,
    "low_20d": 111.4,
    "ladder_minus1_pullback": 112.8,
    "ladder_4_base": 108.0,
    "ladder_5_euphoria": 156.0
  },
  {
    "symbol": "2023.TW",
    "name": "燁輝",
    "sector": "鋼鐵工業",
    "close": 14.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.83,
    "dog_ma200_bias": 0.02,
    "vr60": 1.29,
    "rs20": 0.87,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 365000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.4,
    "ladder_minus1_pullback": 13.7,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 19.0
  },
  {
    "symbol": "6156.TWO",
    "name": "松上",
    "sector": "電子零組件業",
    "close": 25.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.21,
    "dog_ma200_bias": -0.004,
    "vr60": 2.05,
    "rs20": 1.07,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 637500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.3,
    "ladder_minus1_pullback": 24.0,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.1
  },
  {
    "symbol": "4739.TW",
    "name": "康普",
    "sector": "化學工業",
    "close": 84.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.1,
    "dog_ma200_bias": 0.045,
    "vr60": 1.36,
    "rs20": 1.14,
    "rs60": 0.94,
    "shares": 10050,
    "lots": 10,
    "odd_shares": 50,
    "ntd_at_risk": 39999.0,
    "position_cost": 849225.0,
    "constraint": "WEIGHT",
    "atr14": 1.99,
    "low_20d": 79.0,
    "ladder_minus1_pullback": 79.4,
    "ladder_4_base": 76.0,
    "ladder_5_euphoria": 109.9
  },
  {
    "symbol": "5469.TW",
    "name": "瀚宇博",
    "sector": "電子零組件業",
    "close": 81.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.63,
    "dog_ma200_bias": 0.073,
    "vr60": 1.91,
    "rs20": 0.84,
    "rs60": 0.91,
    "shares": 10309,
    "lots": 10,
    "odd_shares": 309,
    "ntd_at_risk": 39998.92,
    "position_cost": 842245.3,
    "constraint": "WEIGHT",
    "atr14": 1.94,
    "low_20d": 74.0,
    "ladder_minus1_pullback": 76.8,
    "ladder_4_base": 73.5,
    "ladder_5_euphoria": 106.2
  },
  {
    "symbol": "3029.TW",
    "name": "零壹",
    "sector": "資訊服務業",
    "close": 119.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.17,
    "dog_ma200_bias": -0.248,
    "vr60": 0.79,
    "rs20": 0.48,
    "rs60": 0.23,
    "shares": 3745,
    "lots": 3,
    "odd_shares": 745,
    "ntd_at_risk": 19998.3,
    "position_cost": 447527.5,
    "constraint": "WEIGHT",
    "atr14": 2.67,
    "low_20d": 113.3,
    "ladder_minus1_pullback": 112.3,
    "ladder_4_base": 107.5,
    "ladder_5_euphoria": 155.3
  },
  {
    "symbol": "6196.TW",
    "name": "帆宣",
    "sector": "其他電子業",
    "close": 613.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.29,
    "dog_ma200_bias": 0.075,
    "vr60": 2.05,
    "rs20": 0.91,
    "rs60": 1.05,
    "shares": 2018,
    "lots": 2,
    "odd_shares": 18,
    "ntd_at_risk": 39996.76,
    "position_cost": 1237034.0,
    "constraint": "WEIGHT",
    "atr14": 9.91,
    "low_20d": 579.9,
    "ladder_minus1_pullback": 576.2,
    "ladder_4_base": 551.7,
    "ladder_5_euphoria": 796.9
  },
  {
    "symbol": "3653.TW",
    "name": "健策",
    "sector": "電子零組件業",
    "close": 6765.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.26,
    "dog_ma200_bias": 0.077,
    "vr60": 1.23,
    "rs20": 0.99,
    "rs60": 1.02,
    "shares": 151,
    "lots": 0,
    "odd_shares": 151,
    "ntd_at_risk": 39927.42,
    "position_cost": 1021515.0,
    "constraint": "WEIGHT",
    "atr14": 132.21,
    "low_20d": 6191.0,
    "ladder_minus1_pullback": 6359.1,
    "ladder_4_base": 6088.5,
    "ladder_5_euphoria": 8794.5
  },
  {
    "symbol": "2393.TW",
    "name": "億光",
    "sector": "光電業",
    "close": 68.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.9,
    "dog_ma200_bias": 0.176,
    "vr60": 1.18,
    "rs20": 1.18,
    "rs60": 1.27,
    "shares": 9478,
    "lots": 9,
    "odd_shares": 478,
    "ntd_at_risk": 39997.16,
    "position_cost": 648295.2,
    "constraint": "WEIGHT",
    "atr14": 2.11,
    "low_20d": 63.3,
    "ladder_minus1_pullback": 64.3,
    "ladder_4_base": 61.6,
    "ladder_5_euphoria": 88.9
  },
  {
    "symbol": "4526.TW",
    "name": "東台",
    "sector": "電機機械業",
    "close": 32.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.42,
    "dog_ma200_bias": 0.077,
    "vr60": 1.5,
    "rs20": 1.05,
    "rs60": 1.29,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 822500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.2,
    "ladder_minus1_pullback": 30.9,
    "ladder_4_base": 29.6,
    "ladder_5_euphoria": 42.8
  },
  {
    "symbol": "2915.TW",
    "name": "潤泰全",
    "sector": "貿易百貨業",
    "close": 58.9,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.8,
    "dog_ma200_bias": -0.063,
    "vr60": 2.1,
    "rs20": 0.43,
    "rs60": 0.7,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.97,
    "low_20d": 56.1,
    "ladder_minus1_pullback": 55.4,
    "ladder_4_base": 53.0,
    "ladder_5_euphoria": 76.6
  },
  {
    "symbol": "9907.TW",
    "name": "統一實",
    "sector": "其他業",
    "close": 15.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.95,
    "dog_ma200_bias": 0.069,
    "vr60": 1.6,
    "rs20": 0.86,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 375000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.1,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.5
  },
  {
    "symbol": "6416.TW",
    "name": "瑞祺電通",
    "sector": "通信網路業",
    "close": 121.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.65,
    "dog_ma200_bias": -0.013,
    "vr60": 1.43,
    "rs20": 0.79,
    "rs60": 0.7,
    "shares": 8298,
    "lots": 8,
    "odd_shares": 298,
    "ntd_at_risk": 39996.36,
    "position_cost": 1004058.0,
    "constraint": "WEIGHT",
    "atr14": 2.41,
    "low_20d": 114.0,
    "ladder_minus1_pullback": 113.7,
    "ladder_4_base": 108.9,
    "ladder_5_euphoria": 157.3
  },
  {
    "symbol": "3209.TW",
    "name": "全科",
    "sector": "電子通路業",
    "close": 47.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.35,
    "dog_ma200_bias": 0.106,
    "vr60": 1.49,
    "rs20": 1.34,
    "rs60": 1.25,
    "shares": 17241,
    "lots": 17,
    "odd_shares": 241,
    "ntd_at_risk": 39999.12,
    "position_cost": 817223.4,
    "constraint": "WEIGHT",
    "atr14": 1.16,
    "low_20d": 45.2,
    "ladder_minus1_pullback": 44.6,
    "ladder_4_base": 42.7,
    "ladder_5_euphoria": 61.6
  },
  {
    "symbol": "1416.TW",
    "name": "廣豐",
    "sector": "其他業",
    "close": 13.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.95,
    "dog_ma200_bias": 0.029,
    "vr60": 1.54,
    "rs20": 0.97,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 331250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.3,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 11.9,
    "ladder_5_euphoria": 17.2
  },
  {
    "symbol": "3234.TWO",
    "name": "光環",
    "sector": "通信網路業",
    "close": 168.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.18,
    "dog_ma200_bias": 0.118,
    "vr60": 1.57,
    "rs20": 1.21,
    "rs60": 1.17,
    "shares": 4008,
    "lots": 4,
    "odd_shares": 8,
    "ntd_at_risk": 39999.84,
    "position_cost": 673344.0,
    "constraint": "WEIGHT",
    "atr14": 4.99,
    "low_20d": 157.7,
    "ladder_minus1_pullback": 157.9,
    "ladder_4_base": 151.2,
    "ladder_5_euphoria": 218.4
  },
  {
    "symbol": "1721.TW",
    "name": "國慶科技",
    "sector": "化學工業",
    "close": 25.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.25,
    "dog_ma200_bias": 0.08,
    "vr60": 1.09,
    "rs20": 1.29,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 635000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.3,
    "ladder_minus1_pullback": 23.9,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.0
  },
  {
    "symbol": "3693.TWO",
    "name": "營邦",
    "sector": "電腦及週邊設備業",
    "close": 705.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.05,
    "dog_ma200_bias": 0.244,
    "vr60": 2.55,
    "rs20": 1.18,
    "rs60": 1.16,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 21.58,
    "low_20d": 664.4,
    "ladder_minus1_pullback": 662.7,
    "ladder_4_base": 634.5,
    "ladder_5_euphoria": 916.5
  },
  {
    "symbol": "5210.TWO",
    "name": "寶碩",
    "sector": "資訊服務業",
    "close": 32.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.05,
    "dog_ma200_bias": 0.148,
    "vr60": 1.38,
    "rs20": 1.31,
    "rs60": 0.94,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 786734.4,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 30.8,
    "ladder_minus1_pullback": 30.7,
    "ladder_4_base": 29.4,
    "ladder_5_euphoria": 42.4
  },
  {
    "symbol": "3490.TWO",
    "name": "單井",
    "sector": "光電業",
    "close": 42.3,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.35,
    "dog_ma200_bias": -0.021,
    "vr60": 1.85,
    "rs20": 0.57,
    "rs60": 0.46,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.06,
    "low_20d": 40.5,
    "ladder_minus1_pullback": 39.8,
    "ladder_4_base": 38.1,
    "ladder_5_euphoria": 55.0
  },
  {
    "symbol": "6925.TWO",
    "name": "意藍",
    "sector": "數位雲端",
    "close": 82.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.95,
    "dog_ma200_bias": -0.004,
    "vr60": 2.0,
    "rs20": 0.81,
    "rs60": 0.74,
    "shares": 8333,
    "lots": 8,
    "odd_shares": 333,
    "ntd_at_risk": 39998.4,
    "position_cost": 685805.9,
    "constraint": "WEIGHT",
    "atr14": 2.4,
    "low_20d": 75.9,
    "ladder_minus1_pullback": 77.4,
    "ladder_4_base": 74.1,
    "ladder_5_euphoria": 107.0
  },
  {
    "symbol": "3543.TW",
    "name": "州巧",
    "sector": "光電業",
    "close": 50.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.2,
    "dog_ma200_bias": 0.001,
    "vr60": 1.37,
    "rs20": 1.03,
    "rs60": 0.95,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 1049983.2,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 48.0,
    "ladder_minus1_pullback": 47.4,
    "ladder_4_base": 45.4,
    "ladder_5_euphoria": 65.5
  },
  {
    "symbol": "6830.TW",
    "name": "汎銓",
    "sector": "其他電子業",
    "close": 488.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.35,
    "dog_ma200_bias": 0.053,
    "vr60": 1.44,
    "rs20": 0.86,
    "rs60": 0.78,
    "shares": 2089,
    "lots": 2,
    "odd_shares": 89,
    "ntd_at_risk": 39983.46,
    "position_cost": 1019432.0,
    "constraint": "WEIGHT",
    "atr14": 9.57,
    "low_20d": 446.8,
    "ladder_minus1_pullback": 458.7,
    "ladder_4_base": 439.2,
    "ladder_5_euphoria": 634.4
  },
  {
    "symbol": "2495.TW",
    "name": "普安",
    "sector": "電腦及週邊設備業",
    "close": 33.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.13,
    "dog_ma200_bias": 0.066,
    "vr60": 1.39,
    "rs20": 1.29,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 847500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.9,
    "ladder_minus1_pullback": 31.9,
    "ladder_4_base": 30.5,
    "ladder_5_euphoria": 44.1
  },
  {
    "symbol": "1536.TW",
    "name": "和大",
    "sector": "汽車工業",
    "close": 44.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.14,
    "dog_ma200_bias": 0.103,
    "vr60": 1.31,
    "rs20": 1.07,
    "rs60": 1.16,
    "shares": 13071,
    "lots": 13,
    "odd_shares": 71,
    "ntd_at_risk": 39997.26,
    "position_cost": 579045.3,
    "constraint": "WEIGHT",
    "atr14": 1.53,
    "low_20d": 40.7,
    "ladder_minus1_pullback": 41.6,
    "ladder_4_base": 39.9,
    "ladder_5_euphoria": 57.6
  },
  {
    "symbol": "6265.TWO",
    "name": "方土昶",
    "sector": "電子通路業",
    "close": 45.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.05,
    "dog_ma200_bias": 0.04,
    "vr60": 1.38,
    "rs20": 0.76,
    "rs60": 0.76,
    "shares": 18518,
    "lots": 18,
    "odd_shares": 518,
    "ntd_at_risk": 39998.88,
    "position_cost": 833310.0,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 42.9,
    "ladder_minus1_pullback": 42.3,
    "ladder_4_base": 40.5,
    "ladder_5_euphoria": 58.5
  },
  {
    "symbol": "6672.TW",
    "name": "騰輝電子-KY",
    "sector": "電子零組件業",
    "close": 570.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.44,
    "dog_ma200_bias": 0.009,
    "vr60": 1.27,
    "rs20": 1.09,
    "rs60": 0.81,
    "shares": 2239,
    "lots": 2,
    "odd_shares": 239,
    "ntd_at_risk": 39988.54,
    "position_cost": 1276230.0,
    "constraint": "WEIGHT",
    "atr14": 8.93,
    "low_20d": 537.7,
    "ladder_minus1_pullback": 535.8,
    "ladder_4_base": 513.0,
    "ladder_5_euphoria": 741.0
  },
  {
    "symbol": "4142.TW",
    "name": "國光生",
    "sector": "生技醫療業",
    "close": 18.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.29,
    "dog_ma200_bias": 0.02,
    "vr60": 1.64,
    "rs20": 1.01,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 460000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.6,
    "ladder_minus1_pullback": 17.3,
    "ladder_4_base": 16.6,
    "ladder_5_euphoria": 23.9
  },
  {
    "symbol": "3059.TW",
    "name": "華晶科",
    "sector": "光電業",
    "close": 37.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.16,
    "dog_ma200_bias": -0.182,
    "vr60": 0.73,
    "rs20": 0.55,
    "rs60": 0.32,
    "shares": 9708,
    "lots": 9,
    "odd_shares": 708,
    "ntd_at_risk": 19998.48,
    "position_cost": 367933.2,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 35.3,
    "ladder_minus1_pullback": 35.6,
    "ladder_4_base": 34.1,
    "ladder_5_euphoria": 49.3
  },
  {
    "symbol": "1615.TW",
    "name": "大山",
    "sector": "電器電纜業",
    "close": 50.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.1,
    "dog_ma200_bias": 0.006,
    "vr60": 1.62,
    "rs20": 0.84,
    "rs60": 0.79,
    "shares": 17391,
    "lots": 17,
    "odd_shares": 391,
    "ntd_at_risk": 39999.3,
    "position_cost": 881723.7,
    "constraint": "WEIGHT",
    "atr14": 1.15,
    "low_20d": 48.5,
    "ladder_minus1_pullback": 47.7,
    "ladder_4_base": 45.6,
    "ladder_5_euphoria": 65.9
  },
  {
    "symbol": "3380.TW",
    "name": "明泰",
    "sector": "通信網路業",
    "close": 31.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.55,
    "dog_ma200_bias": -0.014,
    "vr60": 1.88,
    "rs20": 1.02,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 785000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.3,
    "ladder_minus1_pullback": 29.5,
    "ladder_4_base": 28.3,
    "ladder_5_euphoria": 40.8
  },
  {
    "symbol": "2331.TW",
    "name": "精英",
    "sector": "電腦及週邊設備業",
    "close": 18.25,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.05,
    "dog_ma200_bias": -0.218,
    "vr60": 0.89,
    "rs20": 0.59,
    "rs60": 0.4,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 228125.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.9,
    "ladder_minus1_pullback": 17.2,
    "ladder_4_base": 16.4,
    "ladder_5_euphoria": 23.7
  },
  {
    "symbol": "2457.TW",
    "name": "飛宏",
    "sector": "電子零組件業",
    "close": 21.7,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.16,
    "dog_ma200_bias": -0.082,
    "vr60": 0.89,
    "rs20": 0.45,
    "rs60": 0.54,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 20.0,
    "ladder_minus1_pullback": 20.4,
    "ladder_4_base": 19.5,
    "ladder_5_euphoria": 28.2
  },
  {
    "symbol": "8105.TW",
    "name": "凌巨",
    "sector": "光電業",
    "close": 14.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.38,
    "dog_ma200_bias": 0.067,
    "vr60": 1.63,
    "rs20": 1.1,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 363750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.2,
    "ladder_minus1_pullback": 13.7,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 18.9
  },
  {
    "symbol": "3357.TWO",
    "name": "臺慶科",
    "sector": "電子零組件業",
    "close": 210.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.11,
    "dog_ma200_bias": -0.012,
    "vr60": 2.01,
    "rs20": 1.04,
    "rs60": 0.88,
    "shares": 3539,
    "lots": 3,
    "odd_shares": 539,
    "ntd_at_risk": 39990.7,
    "position_cost": 744959.5,
    "constraint": "WEIGHT",
    "atr14": 5.65,
    "low_20d": 192.5,
    "ladder_minus1_pullback": 197.9,
    "ladder_4_base": 189.5,
    "ladder_5_euphoria": 273.7
  },
  {
    "symbol": "6716.TWO",
    "name": "應廣",
    "sector": "半導體業",
    "close": 95.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.07,
    "dog_ma200_bias": 0.168,
    "vr60": 1.53,
    "rs20": 1.22,
    "rs60": 1.15,
    "shares": 6644,
    "lots": 6,
    "odd_shares": 644,
    "ntd_at_risk": 39996.88,
    "position_cost": 633837.6,
    "constraint": "WEIGHT",
    "atr14": 3.01,
    "low_20d": 89.1,
    "ladder_minus1_pullback": 89.7,
    "ladder_4_base": 85.9,
    "ladder_5_euphoria": 124.0
  },
  {
    "symbol": "2474.TW",
    "name": "可成",
    "sector": "其他電子業",
    "close": 195.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.75,
    "dog_ma200_bias": -0.068,
    "vr60": 1.98,
    "rs20": 0.46,
    "rs60": 0.79,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.77,
    "low_20d": 178.6,
    "ladder_minus1_pullback": 183.3,
    "ladder_4_base": 175.5,
    "ladder_5_euphoria": 253.5
  },
  {
    "symbol": "2413.TW",
    "name": "環科",
    "sector": "電子零組件業",
    "close": 50.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.13,
    "dog_ma200_bias": 0.061,
    "vr60": 1.31,
    "rs20": 0.92,
    "rs60": 1.05,
    "shares": 22988,
    "lots": 22,
    "odd_shares": 988,
    "ntd_at_risk": 39999.12,
    "position_cost": 1170089.2,
    "constraint": "WEIGHT",
    "atr14": 0.87,
    "low_20d": 47.7,
    "ladder_minus1_pullback": 47.8,
    "ladder_4_base": 45.8,
    "ladder_5_euphoria": 66.2
  },
  {
    "symbol": "3645.TW",
    "name": "達邁",
    "sector": "電子零組件業",
    "close": 72.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.24,
    "dog_ma200_bias": 0.112,
    "vr60": 1.65,
    "rs20": 1.2,
    "rs60": 1.23,
    "shares": 9708,
    "lots": 9,
    "odd_shares": 708,
    "ntd_at_risk": 39996.96,
    "position_cost": 700917.6,
    "constraint": "WEIGHT",
    "atr14": 2.06,
    "low_20d": 65.6,
    "ladder_minus1_pullback": 67.9,
    "ladder_4_base": 65.0,
    "ladder_5_euphoria": 93.9
  },
  {
    "symbol": "6133.TW",
    "name": "金橋",
    "sector": "電子零組件業",
    "close": 24.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": -0.164,
    "vr60": 0.92,
    "rs20": 0.62,
    "rs60": 0.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 23.0,
    "ladder_minus1_pullback": 23.3,
    "ladder_4_base": 22.3,
    "ladder_5_euphoria": 32.2
  },
  {
    "symbol": "9949.TWO",
    "name": "琉園",
    "sector": "文化創意業",
    "close": 24.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.14,
    "dog_ma200_bias": 0.019,
    "vr60": 1.56,
    "rs20": 0.88,
    "rs60": 0.8,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 605000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.0,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.8,
    "ladder_5_euphoria": 31.5
  },
  {
    "symbol": "6202.TW",
    "name": "盛群",
    "sector": "半導體業",
    "close": 55.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.31,
    "dog_ma200_bias": 0.115,
    "vr60": 1.57,
    "rs20": 1.26,
    "rs60": 1.15,
    "shares": 12121,
    "lots": 12,
    "odd_shares": 121,
    "ntd_at_risk": 39999.3,
    "position_cost": 667867.1,
    "constraint": "WEIGHT",
    "atr14": 1.65,
    "low_20d": 49.8,
    "ladder_minus1_pullback": 51.8,
    "ladder_4_base": 49.6,
    "ladder_5_euphoria": 71.6
  },
  {
    "symbol": "3597.TWO",
    "name": "映興",
    "sector": "電子零組件業",
    "close": 48.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": 0.032,
    "vr60": 1.58,
    "rs20": 0.92,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1202500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 43.9,
    "ladder_minus1_pullback": 45.2,
    "ladder_4_base": 43.3,
    "ladder_5_euphoria": 62.5
  },
  {
    "symbol": "5289.TWO",
    "name": "宜鼎",
    "sector": "電腦及週邊設備業",
    "close": 1115.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.5,
    "dog_ma200_bias": 0.039,
    "vr60": 1.88,
    "rs20": 1.13,
    "rs60": 1.02,
    "shares": 1073,
    "lots": 1,
    "odd_shares": 73,
    "ntd_at_risk": 39979.98,
    "position_cost": 1196395.0,
    "constraint": "WEIGHT",
    "atr14": 18.63,
    "low_20d": 1053.7,
    "ladder_minus1_pullback": 1048.1,
    "ladder_4_base": 1003.5,
    "ladder_5_euphoria": 1449.5
  },
  {
    "symbol": "6176.TW",
    "name": "瑞儀",
    "sector": "光電業",
    "close": 91.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.33,
    "dog_ma200_bias": 0.128,
    "vr60": 1.11,
    "rs20": 1.06,
    "rs60": 1.11,
    "shares": 10101,
    "lots": 10,
    "odd_shares": 101,
    "ntd_at_risk": 39999.96,
    "position_cost": 919191.0,
    "constraint": "WEIGHT",
    "atr14": 1.98,
    "low_20d": 85.2,
    "ladder_minus1_pullback": 85.5,
    "ladder_4_base": 81.9,
    "ladder_5_euphoria": 118.3
  },
  {
    "symbol": "4722.TW",
    "name": "國精化",
    "sector": "化學工業",
    "close": 202.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.2,
    "dog_ma200_bias": 0.101,
    "vr60": 1.3,
    "rs20": 1.1,
    "rs60": 1.09,
    "shares": 4444,
    "lots": 4,
    "odd_shares": 444,
    "ntd_at_risk": 39996.0,
    "position_cost": 899910.0,
    "constraint": "WEIGHT",
    "atr14": 4.5,
    "low_20d": 186.4,
    "ladder_minus1_pullback": 190.3,
    "ladder_4_base": 182.2,
    "ladder_5_euphoria": 263.2
  },
  {
    "symbol": "2405.TW",
    "name": "輔信",
    "sector": "電腦及週邊設備業",
    "close": 14.8,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.05,
    "dog_ma200_bias": -0.17,
    "vr60": 0.67,
    "rs20": 0.31,
    "rs60": 0.23,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 185000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.7,
    "ladder_minus1_pullback": 13.9,
    "ladder_4_base": 13.3,
    "ladder_5_euphoria": 19.2
  },
  {
    "symbol": "6877.TWO",
    "name": "鏵友益",
    "sector": "其他電子業",
    "close": 148.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.29,
    "dog_ma200_bias": 0.049,
    "vr60": 1.23,
    "rs20": 1.11,
    "rs60": 0.82,
    "shares": 5102,
    "lots": 5,
    "odd_shares": 102,
    "ntd_at_risk": 39999.68,
    "position_cost": 757647.0,
    "constraint": "WEIGHT",
    "atr14": 3.92,
    "low_20d": 139.7,
    "ladder_minus1_pullback": 139.6,
    "ladder_4_base": 133.7,
    "ladder_5_euphoria": 193.1
  },
  {
    "symbol": "4123.TWO",
    "name": "晟德",
    "sector": "生技醫療業",
    "close": 30.95,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.3,
    "dog_ma200_bias": -0.237,
    "vr60": 0.99,
    "rs20": 0.57,
    "rs60": 0.51,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 386875.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.9,
    "ladder_minus1_pullback": 29.1,
    "ladder_4_base": 27.9,
    "ladder_5_euphoria": 40.2
  },
  {
    "symbol": "2641.TWO",
    "name": "正德",
    "sector": "航運業",
    "close": 17.15,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.14,
    "dog_ma200_bias": 0.343,
    "vr60": 1.9,
    "rs20": 1.25,
    "rs60": 1.27,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 15.5,
    "ladder_minus1_pullback": 16.1,
    "ladder_4_base": 15.4,
    "ladder_5_euphoria": 22.3
  },
  {
    "symbol": "7777.TWO",
    "name": "能率亞洲",
    "sector": "其他業",
    "close": 34.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.05,
    "dog_ma200_bias": -0.01,
    "vr60": 1.98,
    "rs20": 0.8,
    "rs60": 1.04,
    "shares": 18018,
    "lots": 18,
    "odd_shares": 18,
    "ntd_at_risk": 39999.96,
    "position_cost": 627026.4,
    "constraint": "WEIGHT",
    "atr14": 1.11,
    "low_20d": 33.0,
    "ladder_minus1_pullback": 32.7,
    "ladder_4_base": 31.3,
    "ladder_5_euphoria": 45.2
  },
  {
    "symbol": "3680.TWO",
    "name": "家登",
    "sector": "半導體業",
    "close": 513.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.32,
    "dog_ma200_bias": 0.113,
    "vr60": 1.55,
    "rs20": 1.06,
    "rs60": 1.07,
    "shares": 1154,
    "lots": 1,
    "odd_shares": 154,
    "ntd_at_risk": 39997.64,
    "position_cost": 592002.0,
    "constraint": "WEIGHT",
    "atr14": 17.33,
    "low_20d": 484.0,
    "ladder_minus1_pullback": 482.2,
    "ladder_4_base": 461.7,
    "ladder_5_euphoria": 666.9
  },
  {
    "symbol": "2905.TW",
    "name": "三商",
    "sector": "貿易百貨業",
    "close": 17.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.71,
    "dog_ma200_bias": 0.137,
    "vr60": 1.16,
    "rs20": 1.03,
    "rs60": 1.23,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 446250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.1,
    "ladder_minus1_pullback": 16.8,
    "ladder_4_base": 16.1,
    "ladder_5_euphoria": 23.2
  },
  {
    "symbol": "8044.TWO",
    "name": "網家",
    "sector": "數位雲端",
    "close": 25.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.5,
    "dog_ma200_bias": 0.054,
    "vr60": 1.88,
    "rs20": 1.1,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 643750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.3,
    "ladder_minus1_pullback": 24.2,
    "ladder_4_base": 23.2,
    "ladder_5_euphoria": 33.5
  },
  {
    "symbol": "4551.TW",
    "name": "智伸科",
    "sector": "汽車工業",
    "close": 164.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.11,
    "dog_ma200_bias": 0.032,
    "vr60": 1.34,
    "rs20": 0.87,
    "rs60": 0.88,
    "shares": 6944,
    "lots": 6,
    "odd_shares": 944,
    "ntd_at_risk": 39997.44,
    "position_cost": 1138816.0,
    "constraint": "WEIGHT",
    "atr14": 2.88,
    "low_20d": 151.2,
    "ladder_minus1_pullback": 154.2,
    "ladder_4_base": 147.6,
    "ladder_5_euphoria": 213.2
  },
  {
    "symbol": "8271.TW",
    "name": "宇瞻",
    "sector": "半導體業",
    "close": 183.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.33,
    "dog_ma200_bias": 0.076,
    "vr60": 1.56,
    "rs20": 1.3,
    "rs60": 0.91,
    "shares": 3984,
    "lots": 3,
    "odd_shares": 984,
    "ntd_at_risk": 39999.36,
    "position_cost": 731064.0,
    "constraint": "WEIGHT",
    "atr14": 5.02,
    "low_20d": 175.6,
    "ladder_minus1_pullback": 172.5,
    "ladder_4_base": 165.2,
    "ladder_5_euphoria": 238.6
  },
  {
    "symbol": "6026.TWO",
    "name": "福邦證",
    "sector": "金融保險業",
    "close": 15.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.67,
    "dog_ma200_bias": -0.001,
    "vr60": 1.95,
    "rs20": 1.08,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 390000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.3,
    "ladder_minus1_pullback": 14.7,
    "ladder_4_base": 14.0,
    "ladder_5_euphoria": 20.3
  },
  {
    "symbol": "6526.TW",
    "name": "達發",
    "sector": "半導體業",
    "close": 779.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.54,
    "dog_ma200_bias": -0.136,
    "vr60": 0.92,
    "rs20": 0.55,
    "rs60": 0.45,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 20.72,
    "low_20d": 745.9,
    "ladder_minus1_pullback": 732.3,
    "ladder_4_base": 701.1,
    "ladder_5_euphoria": 1012.7
  },
  {
    "symbol": "2465.TW",
    "name": "麗臺",
    "sector": "電腦及週邊設備業",
    "close": 83.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.28,
    "dog_ma200_bias": 0.062,
    "vr60": 1.65,
    "rs20": 1.0,
    "rs60": 0.74,
    "shares": 14705,
    "lots": 14,
    "odd_shares": 705,
    "ntd_at_risk": 39997.6,
    "position_cost": 1230808.5,
    "constraint": "WEIGHT",
    "atr14": 1.36,
    "low_20d": 76.8,
    "ladder_minus1_pullback": 78.7,
    "ladder_4_base": 75.3,
    "ladder_5_euphoria": 108.8
  },
  {
    "symbol": "4542.TWO",
    "name": "科嶠",
    "sector": "電子零組件業",
    "close": 325.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.05,
    "dog_ma200_bias": -0.077,
    "vr60": 1.64,
    "rs20": 0.61,
    "rs60": 0.51,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 6.56,
    "low_20d": 299.2,
    "ladder_minus1_pullback": 306.0,
    "ladder_4_base": 292.9,
    "ladder_5_euphoria": 423.2
  },
  {
    "symbol": "2476.TW",
    "name": "鉅祥",
    "sector": "電子零組件業",
    "close": 122.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.5,
    "dog_ma200_bias": 0.13,
    "vr60": 1.26,
    "rs20": 1.02,
    "rs60": 1.26,
    "shares": 7434,
    "lots": 7,
    "odd_shares": 434,
    "ntd_at_risk": 39994.92,
    "position_cost": 906948.0,
    "constraint": "WEIGHT",
    "atr14": 2.69,
    "low_20d": 111.9,
    "ladder_minus1_pullback": 114.7,
    "ladder_4_base": 109.8,
    "ladder_5_euphoria": 158.6
  },
  {
    "symbol": "3010.TW",
    "name": "華立",
    "sector": "電子通路業",
    "close": 138.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.5,
    "dog_ma200_bias": -0.095,
    "vr60": 0.84,
    "rs20": 0.4,
    "rs60": 0.49,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.04,
    "low_20d": 131.8,
    "ladder_minus1_pullback": 129.7,
    "ladder_4_base": 124.2,
    "ladder_5_euphoria": 179.4
  },
  {
    "symbol": "3221.TWO",
    "name": "台嘉碩",
    "sector": "通信網路業",
    "close": 51.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": -0.004,
    "vr60": 1.72,
    "rs20": 1.14,
    "rs60": 1.0,
    "shares": 15503,
    "lots": 15,
    "odd_shares": 503,
    "ntd_at_risk": 39997.74,
    "position_cost": 793753.6,
    "constraint": "WEIGHT",
    "atr14": 1.29,
    "low_20d": 48.4,
    "ladder_minus1_pullback": 48.1,
    "ladder_4_base": 46.1,
    "ladder_5_euphoria": 66.6
  },
  {
    "symbol": "6166.TW",
    "name": "凌華",
    "sector": "電腦及週邊設備業",
    "close": 110.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.29,
    "dog_ma200_bias": 0.045,
    "vr60": 1.81,
    "rs20": 0.86,
    "rs60": 0.84,
    "shares": 8097,
    "lots": 8,
    "odd_shares": 97,
    "ntd_at_risk": 39999.18,
    "position_cost": 890670.0,
    "constraint": "WEIGHT",
    "atr14": 2.47,
    "low_20d": 100.2,
    "ladder_minus1_pullback": 103.4,
    "ladder_4_base": 99.0,
    "ladder_5_euphoria": 143.0
  },
  {
    "symbol": "3162.TWO",
    "name": "精確",
    "sector": "電機機械業",
    "close": 76.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.26,
    "dog_ma200_bias": -0.018,
    "vr60": 1.9,
    "rs20": 1.06,
    "rs60": 0.7,
    "shares": 9389,
    "lots": 9,
    "odd_shares": 389,
    "ntd_at_risk": 39997.14,
    "position_cost": 717319.6,
    "constraint": "WEIGHT",
    "atr14": 2.13,
    "low_20d": 69.3,
    "ladder_minus1_pullback": 71.8,
    "ladder_4_base": 68.8,
    "ladder_5_euphoria": 99.3
  },
  {
    "symbol": "5460.TWO",
    "name": "同協",
    "sector": "電子零組件業",
    "close": 20.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.05,
    "dog_ma200_bias": 0.071,
    "vr60": 1.78,
    "rs20": 0.99,
    "rs60": 0.7,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 515000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.8,
    "ladder_minus1_pullback": 19.4,
    "ladder_4_base": 18.5,
    "ladder_5_euphoria": 26.8
  },
  {
    "symbol": "1810.TW",
    "name": "和成",
    "sector": "玻璃陶瓷業",
    "close": 23.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.05,
    "dog_ma200_bias": 0.005,
    "vr60": 1.92,
    "rs20": 0.87,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 577500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.3,
    "ladder_minus1_pullback": 21.7,
    "ladder_4_base": 20.8,
    "ladder_5_euphoria": 30.0
  },
  {
    "symbol": "1560.TW",
    "name": "中砂",
    "sector": "電機機械業",
    "close": 903.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.23,
    "dog_ma200_bias": 0.044,
    "vr60": 1.58,
    "rs20": 0.9,
    "rs60": 0.82,
    "shares": 642,
    "lots": 0,
    "odd_shares": 642,
    "ntd_at_risk": 39970.92,
    "position_cost": 579726.0,
    "constraint": "WEIGHT",
    "atr14": 31.13,
    "low_20d": 833.2,
    "ladder_minus1_pullback": 848.8,
    "ladder_4_base": 812.7,
    "ladder_5_euphoria": 1173.9
  },
  {
    "symbol": "2404.TW",
    "name": "漢唐",
    "sector": "其他電子業",
    "close": 1105.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.57,
    "dog_ma200_bias": 0.005,
    "vr60": 1.62,
    "rs20": 1.02,
    "rs60": 0.99,
    "shares": 1138,
    "lots": 1,
    "odd_shares": 138,
    "ntd_at_risk": 39966.56,
    "position_cost": 1257490.0,
    "constraint": "WEIGHT",
    "atr14": 17.56,
    "low_20d": 999.1,
    "ladder_minus1_pullback": 1038.7,
    "ladder_4_base": 994.5,
    "ladder_5_euphoria": 1436.5
  },
  {
    "symbol": "3583.TW",
    "name": "辛耘",
    "sector": "半導體業",
    "close": 653.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.15,
    "dog_ma200_bias": 0.02,
    "vr60": 1.29,
    "rs20": 0.95,
    "rs60": 0.93,
    "shares": 1974,
    "lots": 1,
    "odd_shares": 974,
    "ntd_at_risk": 39993.24,
    "position_cost": 1289022.0,
    "constraint": "WEIGHT",
    "atr14": 10.13,
    "low_20d": 603.0,
    "ladder_minus1_pullback": 613.8,
    "ladder_4_base": 587.7,
    "ladder_5_euphoria": 848.9
  },
  {
    "symbol": "3704.TW",
    "name": "合勤控",
    "sector": "通信網路業",
    "close": 39.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.06,
    "dog_ma200_bias": 0.064,
    "vr60": 1.54,
    "rs20": 1.01,
    "rs60": 0.91,
    "shares": 20000,
    "lots": 20,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 794000.0,
    "constraint": "WEIGHT",
    "atr14": 1.0,
    "low_20d": 36.3,
    "ladder_minus1_pullback": 37.3,
    "ladder_4_base": 35.7,
    "ladder_5_euphoria": 51.6
  },
  {
    "symbol": "4566.TW",
    "name": "時碩工業",
    "sector": "電機機械業",
    "close": 74.4,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.33,
    "dog_ma200_bias": -0.05,
    "vr60": 1.4,
    "rs20": 0.42,
    "rs60": 0.8,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.98,
    "low_20d": 69.9,
    "ladder_minus1_pullback": 69.9,
    "ladder_4_base": 67.0,
    "ladder_5_euphoria": 96.7
  },
  {
    "symbol": "1514.TW",
    "name": "亞力",
    "sector": "電機機械業",
    "close": 100.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.25,
    "dog_ma200_bias": 0.352,
    "vr60": 1.86,
    "rs20": 1.4,
    "rs60": 1.41,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.18,
    "low_20d": 96.3,
    "ladder_minus1_pullback": 94.5,
    "ladder_4_base": 90.5,
    "ladder_5_euphoria": 130.7
  },
  {
    "symbol": "2539.TW",
    "name": "櫻花建",
    "sector": "建材營造業",
    "close": 33.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.18,
    "dog_ma200_bias": -0.005,
    "vr60": 1.89,
    "rs20": 1.11,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 847500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.5,
    "ladder_minus1_pullback": 31.9,
    "ladder_4_base": 30.5,
    "ladder_5_euphoria": 44.1
  },
  {
    "symbol": "2611.TW",
    "name": "志信",
    "sector": "航運業",
    "close": 16.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.5,
    "dog_ma200_bias": 0.06,
    "vr60": 1.74,
    "rs20": 1.01,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 410000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.8,
    "ladder_minus1_pullback": 15.4,
    "ladder_4_base": 14.8,
    "ladder_5_euphoria": 21.3
  },
  {
    "symbol": "3041.TW",
    "name": "揚智",
    "sector": "半導體業",
    "close": 24.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.11,
    "dog_ma200_bias": 0.052,
    "vr60": 1.79,
    "rs20": 1.15,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 608750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.5,
    "ladder_minus1_pullback": 22.9,
    "ladder_4_base": 21.9,
    "ladder_5_euphoria": 31.7
  },
  {
    "symbol": "8054.TWO",
    "name": "安國",
    "sector": "半導體業",
    "close": 74.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.15,
    "dog_ma200_bias": 0.11,
    "vr60": 1.28,
    "rs20": 0.96,
    "rs60": 1.18,
    "shares": 11560,
    "lots": 11,
    "odd_shares": 560,
    "ntd_at_risk": 39997.6,
    "position_cost": 856596.0,
    "constraint": "WEIGHT",
    "atr14": 1.73,
    "low_20d": 67.9,
    "ladder_minus1_pullback": 69.7,
    "ladder_4_base": 66.7,
    "ladder_5_euphoria": 96.3
  },
  {
    "symbol": "6121.TWO",
    "name": "新普",
    "sector": "電腦及週邊設備業",
    "close": 366.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.63,
    "dog_ma200_bias": 0.037,
    "vr60": 1.37,
    "rs20": 1.04,
    "rs60": 0.78,
    "shares": 2134,
    "lots": 2,
    "odd_shares": 134,
    "ntd_at_risk": 39991.16,
    "position_cost": 782111.0,
    "constraint": "WEIGHT",
    "atr14": 9.37,
    "low_20d": 350.7,
    "ladder_minus1_pullback": 344.5,
    "ladder_4_base": 329.9,
    "ladder_5_euphoria": 476.4
  },
  {
    "symbol": "2428.TW",
    "name": "興勤",
    "sector": "電子零組件業",
    "close": 266.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.08,
    "dog_ma200_bias": 0.124,
    "vr60": 1.52,
    "rs20": 1.31,
    "rs60": 1.17,
    "shares": 2949,
    "lots": 2,
    "odd_shares": 949,
    "ntd_at_risk": 39988.44,
    "position_cost": 784434.0,
    "constraint": "WEIGHT",
    "atr14": 6.78,
    "low_20d": 248.3,
    "ladder_minus1_pullback": 250.0,
    "ladder_4_base": 239.4,
    "ladder_5_euphoria": 345.8
  },
  {
    "symbol": "4934.TW",
    "name": "太極",
    "sector": "光電業",
    "close": 16.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.21,
    "dog_ma200_bias": 0.031,
    "vr60": 1.96,
    "rs20": 1.09,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 406250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.3,
    "ladder_minus1_pullback": 15.3,
    "ladder_4_base": 14.6,
    "ladder_5_euphoria": 21.1
  },
  {
    "symbol": "9941.TW",
    "name": "裕融",
    "sector": "其他業",
    "close": 78.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.57,
    "dog_ma200_bias": -0.002,
    "vr60": 1.29,
    "rs20": 0.8,
    "rs60": 0.79,
    "shares": 12903,
    "lots": 12,
    "odd_shares": 903,
    "ntd_at_risk": 39999.3,
    "position_cost": 1007724.3,
    "constraint": "WEIGHT",
    "atr14": 1.55,
    "low_20d": 71.4,
    "ladder_minus1_pullback": 73.4,
    "ladder_4_base": 70.3,
    "ladder_5_euphoria": 101.5
  },
  {
    "symbol": "6789.TW",
    "name": "采鈺",
    "sector": "半導體業",
    "close": 440.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.3,
    "dog_ma200_bias": 0.061,
    "vr60": 1.89,
    "rs20": 0.82,
    "rs60": 0.94,
    "shares": 1885,
    "lots": 1,
    "odd_shares": 885,
    "ntd_at_risk": 39999.7,
    "position_cost": 829400.0,
    "constraint": "WEIGHT",
    "atr14": 10.61,
    "low_20d": 402.6,
    "ladder_minus1_pullback": 413.6,
    "ladder_4_base": 396.0,
    "ladder_5_euphoria": 572.0
  },
  {
    "symbol": "6831.TW",
    "name": "邁科",
    "sector": "電腦及週邊設備業",
    "close": 428.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.05,
    "dog_ma200_bias": 0.014,
    "vr60": 1.28,
    "rs20": 0.89,
    "rs60": 0.96,
    "shares": 2355,
    "lots": 2,
    "odd_shares": 355,
    "ntd_at_risk": 39987.9,
    "position_cost": 1009117.5,
    "constraint": "WEIGHT",
    "atr14": 8.49,
    "low_20d": 392.5,
    "ladder_minus1_pullback": 402.8,
    "ladder_4_base": 385.7,
    "ladder_5_euphoria": 557.1
  },
  {
    "symbol": "7769.TW",
    "name": "鴻勁",
    "sector": "半導體業",
    "close": 5225.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.05,
    "dog_ma200_bias": 0.011,
    "vr60": 1.91,
    "rs20": 0.88,
    "rs60": 0.79,
    "shares": 172,
    "lots": 0,
    "odd_shares": 172,
    "ntd_at_risk": 39969.36,
    "position_cost": 898700.0,
    "constraint": "WEIGHT",
    "atr14": 116.19,
    "low_20d": 4905.7,
    "ladder_minus1_pullback": 4911.5,
    "ladder_4_base": 4702.5,
    "ladder_5_euphoria": 6792.5
  },
  {
    "symbol": "3002.TW",
    "name": "歐格",
    "sector": "電腦及週邊設備業",
    "close": 19.35,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.33,
    "dog_ma200_bias": -0.159,
    "vr60": 0.9,
    "rs20": 0.46,
    "rs60": 0.65,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 17.8,
    "ladder_minus1_pullback": 18.2,
    "ladder_4_base": 17.4,
    "ladder_5_euphoria": 25.2
  },
  {
    "symbol": "1808.TW",
    "name": "潤隆",
    "sector": "建材營造業",
    "close": 34.6,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.08,
    "dog_ma200_bias": -0.175,
    "vr60": 1.07,
    "rs20": 0.23,
    "rs60": 0.51,
    "shares": 12048,
    "lots": 12,
    "odd_shares": 48,
    "ntd_at_risk": 19999.68,
    "position_cost": 416860.8,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 32.3,
    "ladder_minus1_pullback": 32.5,
    "ladder_4_base": 31.1,
    "ladder_5_euphoria": 45.0
  },
  {
    "symbol": "4714.TWO",
    "name": "永捷",
    "sector": "化學工業",
    "close": 12.15,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.25,
    "dog_ma200_bias": 0.353,
    "vr60": 1.98,
    "rs20": 1.25,
    "rs60": 1.12,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 11.6,
    "ladder_minus1_pullback": 11.4,
    "ladder_4_base": 10.9,
    "ladder_5_euphoria": 15.8
  },
  {
    "symbol": "4105.TWO",
    "name": "東洋",
    "sector": "生技醫療業",
    "close": 82.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.64,
    "dog_ma200_bias": -0.006,
    "vr60": 1.38,
    "rs20": 0.91,
    "rs60": 0.9,
    "shares": 7968,
    "lots": 7,
    "odd_shares": 968,
    "ntd_at_risk": 39999.36,
    "position_cost": 654969.6,
    "constraint": "WEIGHT",
    "atr14": 2.51,
    "low_20d": 76.9,
    "ladder_minus1_pullback": 77.3,
    "ladder_4_base": 74.0,
    "ladder_5_euphoria": 106.9
  },
  {
    "symbol": "4973.TWO",
    "name": "廣穎",
    "sector": "半導體業",
    "close": 140.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.08,
    "dog_ma200_bias": -0.117,
    "vr60": 0.86,
    "rs20": 0.33,
    "rs60": 0.44,
    "shares": 4000,
    "lots": 4,
    "odd_shares": 0,
    "ntd_at_risk": 20000.0,
    "position_cost": 562000.0,
    "constraint": "WEIGHT",
    "atr14": 2.5,
    "low_20d": 132.7,
    "ladder_minus1_pullback": 132.1,
    "ladder_4_base": 126.5,
    "ladder_5_euphoria": 182.7
  },
  {
    "symbol": "5392.TWO",
    "name": "能率",
    "sector": "光電業",
    "close": 37.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.06,
    "dog_ma200_bias": 0.029,
    "vr60": 1.77,
    "rs20": 0.82,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 925000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 35.3,
    "ladder_minus1_pullback": 34.8,
    "ladder_4_base": 33.3,
    "ladder_5_euphoria": 48.1
  },
  {
    "symbol": "4157.TWO",
    "name": "太景*-KY",
    "sector": "生技醫療業",
    "close": 8.8,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.16,
    "dog_ma200_bias": -0.279,
    "vr60": 0.77,
    "rs20": 0.5,
    "rs60": 0.24,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 110000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.1,
    "ladder_minus1_pullback": 8.3,
    "ladder_4_base": 7.9,
    "ladder_5_euphoria": 11.4
  },
  {
    "symbol": "1227.TW",
    "name": "佳格",
    "sector": "食品工業",
    "close": 28.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.71,
    "dog_ma200_bias": 0.278,
    "vr60": 2.36,
    "rs20": 1.18,
    "rs60": 1.32,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.87,
    "low_20d": 25.8,
    "ladder_minus1_pullback": 26.8,
    "ladder_4_base": 25.7,
    "ladder_5_euphoria": 37.1
  },
  {
    "symbol": "5439.TWO",
    "name": "高技",
    "sector": "電子零組件業",
    "close": 232.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.23,
    "dog_ma200_bias": 0.02,
    "vr60": 2.07,
    "rs20": 0.9,
    "rs60": 0.71,
    "shares": 5617,
    "lots": 5,
    "odd_shares": 617,
    "ntd_at_risk": 39993.04,
    "position_cost": 1305952.5,
    "constraint": "WEIGHT",
    "atr14": 3.56,
    "low_20d": 221.5,
    "ladder_minus1_pullback": 218.5,
    "ladder_4_base": 209.2,
    "ladder_5_euphoria": 302.2
  },
  {
    "symbol": "8936.TWO",
    "name": "國統",
    "sector": "其他業",
    "close": 51.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.14,
    "dog_ma200_bias": 0.084,
    "vr60": 1.27,
    "rs20": 0.96,
    "rs60": 1.03,
    "shares": 14814,
    "lots": 14,
    "odd_shares": 814,
    "ntd_at_risk": 39997.8,
    "position_cost": 765883.8,
    "constraint": "WEIGHT",
    "atr14": 1.35,
    "low_20d": 46.7,
    "ladder_minus1_pullback": 48.6,
    "ladder_4_base": 46.5,
    "ladder_5_euphoria": 67.2
  },
  {
    "symbol": "6962.TW",
    "name": "奕力-KY",
    "sector": "半導體業",
    "close": 31.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.27,
    "dog_ma200_bias": 0.063,
    "vr60": 1.37,
    "rs20": 1.02,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 788750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.2,
    "ladder_minus1_pullback": 29.7,
    "ladder_4_base": 28.4,
    "ladder_5_euphoria": 41.0
  },
  {
    "symbol": "6214.TW",
    "name": "精誠",
    "sector": "資訊服務業",
    "close": 197.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.43,
    "dog_ma200_bias": 0.005,
    "vr60": 1.82,
    "rs20": 0.89,
    "rs60": 0.75,
    "shares": 3527,
    "lots": 3,
    "odd_shares": 527,
    "ntd_at_risk": 39996.18,
    "position_cost": 694819.0,
    "constraint": "WEIGHT",
    "atr14": 5.67,
    "low_20d": 177.4,
    "ladder_minus1_pullback": 185.2,
    "ladder_4_base": 177.3,
    "ladder_5_euphoria": 256.1
  },
  {
    "symbol": "3219.TWO",
    "name": "倚強科",
    "sector": "其他電子業",
    "close": 117.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.5,
    "dog_ma200_bias": 0.018,
    "vr60": 1.73,
    "rs20": 0.82,
    "rs60": 0.99,
    "shares": 5291,
    "lots": 5,
    "odd_shares": 291,
    "ntd_at_risk": 39999.96,
    "position_cost": 619047.0,
    "constraint": "WEIGHT",
    "atr14": 3.78,
    "low_20d": 105.9,
    "ladder_minus1_pullback": 110.0,
    "ladder_4_base": 105.3,
    "ladder_5_euphoria": 152.1
  },
  {
    "symbol": "2365.TW",
    "name": "昆盈",
    "sector": "電腦及週邊設備業",
    "close": 26.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.35,
    "dog_ma200_bias": 0.01,
    "vr60": 1.46,
    "rs20": 1.04,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 663750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.8,
    "ladder_minus1_pullback": 25.0,
    "ladder_4_base": 23.9,
    "ladder_5_euphoria": 34.5
  },
  {
    "symbol": "6509.TWO",
    "name": "聚和",
    "sector": "化學工業",
    "close": 50.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.6,
    "dog_ma200_bias": 0.014,
    "vr60": 2.0,
    "rs20": 1.15,
    "rs60": 0.82,
    "shares": 13422,
    "lots": 13,
    "odd_shares": 422,
    "ntd_at_risk": 39997.56,
    "position_cost": 683179.8,
    "constraint": "WEIGHT",
    "atr14": 1.49,
    "low_20d": 48.5,
    "ladder_minus1_pullback": 47.8,
    "ladder_4_base": 45.8,
    "ladder_5_euphoria": 66.2
  },
  {
    "symbol": "3703.TW",
    "name": "欣陸",
    "sector": "建材營造業",
    "close": 20.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.75,
    "dog_ma200_bias": 0.07,
    "vr60": 1.52,
    "rs20": 0.83,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 510000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.9,
    "ladder_minus1_pullback": 19.2,
    "ladder_4_base": 18.4,
    "ladder_5_euphoria": 26.5
  },
  {
    "symbol": "2607.TW",
    "name": "榮運",
    "sector": "航運業",
    "close": 58.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.05,
    "dog_ma200_bias": 0.072,
    "vr60": 1.56,
    "rs20": 0.84,
    "rs60": 0.95,
    "shares": 9900,
    "lots": 9,
    "odd_shares": 900,
    "ntd_at_risk": 39996.0,
    "position_cost": 574200.0,
    "constraint": "WEIGHT",
    "atr14": 2.02,
    "low_20d": 55.5,
    "ladder_minus1_pullback": 54.5,
    "ladder_4_base": 52.2,
    "ladder_5_euphoria": 75.4
  },
  {
    "symbol": "1503.TW",
    "name": "士電",
    "sector": "電機機械業",
    "close": 197.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.17,
    "dog_ma200_bias": 0.076,
    "vr60": 1.49,
    "rs20": 1.19,
    "rs60": 0.97,
    "shares": 4597,
    "lots": 4,
    "odd_shares": 597,
    "ntd_at_risk": 39993.9,
    "position_cost": 905609.0,
    "constraint": "WEIGHT",
    "atr14": 4.35,
    "low_20d": 183.8,
    "ladder_minus1_pullback": 185.2,
    "ladder_4_base": 177.3,
    "ladder_5_euphoria": 256.1
  },
  {
    "symbol": "3060.TW",
    "name": "銘異",
    "sector": "電腦及週邊設備業",
    "close": 27.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.28,
    "dog_ma200_bias": 0.017,
    "vr60": 1.79,
    "rs20": 0.76,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 683750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.9,
    "ladder_minus1_pullback": 25.7,
    "ladder_4_base": 24.6,
    "ladder_5_euphoria": 35.6
  },
  {
    "symbol": "6782.TW",
    "name": "視陽",
    "sector": "生技醫療業",
    "close": 251.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.42,
    "dog_ma200_bias": 0.006,
    "vr60": 1.68,
    "rs20": 0.77,
    "rs60": 1.05,
    "shares": 3246,
    "lots": 3,
    "odd_shares": 246,
    "ntd_at_risk": 39990.72,
    "position_cost": 814746.0,
    "constraint": "WEIGHT",
    "atr14": 6.16,
    "low_20d": 238.9,
    "ladder_minus1_pullback": 235.9,
    "ladder_4_base": 225.9,
    "ladder_5_euphoria": 326.3
  },
  {
    "symbol": "6146.TWO",
    "name": "耕興",
    "sector": "其他電子業",
    "close": 207.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.68,
    "dog_ma200_bias": 0.046,
    "vr60": 1.79,
    "rs20": 0.76,
    "rs60": 0.94,
    "shares": 3179,
    "lots": 3,
    "odd_shares": 179,
    "ntd_at_risk": 39991.82,
    "position_cost": 659642.5,
    "constraint": "WEIGHT",
    "atr14": 6.29,
    "low_20d": 187.8,
    "ladder_minus1_pullback": 195.0,
    "ladder_4_base": 186.8,
    "ladder_5_euphoria": 269.8
  },
  {
    "symbol": "4426.TW",
    "name": "利勤",
    "sector": "紡織纖維業",
    "close": 8.62,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.81,
    "dog_ma200_bias": 0.022,
    "vr60": 1.54,
    "rs20": 0.97,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 215500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.8,
    "ladder_minus1_pullback": 8.1,
    "ladder_4_base": 7.8,
    "ladder_5_euphoria": 11.2
  },
  {
    "symbol": "3227.TWO",
    "name": "原相",
    "sector": "半導體業",
    "close": 187.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.73,
    "dog_ma200_bias": -0.005,
    "vr60": 1.83,
    "rs20": 1.0,
    "rs60": 0.81,
    "shares": 4761,
    "lots": 4,
    "odd_shares": 761,
    "ntd_at_risk": 39992.4,
    "position_cost": 892687.5,
    "constraint": "WEIGHT",
    "atr14": 4.2,
    "low_20d": 172.7,
    "ladder_minus1_pullback": 176.2,
    "ladder_4_base": 168.8,
    "ladder_5_euphoria": 243.8
  },
  {
    "symbol": "1316.TW",
    "name": "上曜",
    "sector": "建材營造業",
    "close": 10.4,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.25,
    "dog_ma200_bias": -0.014,
    "vr60": 1.9,
    "rs20": 0.49,
    "rs60": 0.66,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.7,
    "ladder_minus1_pullback": 9.8,
    "ladder_4_base": 9.4,
    "ladder_5_euphoria": 13.5
  },
  {
    "symbol": "3529.TWO",
    "name": "力旺",
    "sector": "半導體業",
    "close": 2655.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.05,
    "dog_ma200_bias": 0.063,
    "vr60": 1.29,
    "rs20": 1.04,
    "rs60": 0.74,
    "shares": 222,
    "lots": 0,
    "odd_shares": 222,
    "ntd_at_risk": 39955.56,
    "position_cost": 589410.0,
    "constraint": "WEIGHT",
    "atr14": 89.99,
    "low_20d": 2533.4,
    "ladder_minus1_pullback": 2495.7,
    "ladder_4_base": 2389.5,
    "ladder_5_euphoria": 3451.5
  },
  {
    "symbol": "4924.TWO",
    "name": "欣厚-KY",
    "sector": "綠能環保",
    "close": 20.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.95,
    "dog_ma200_bias": -0.009,
    "vr60": 1.3,
    "rs20": 0.83,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 503750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.7,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.2
  },
  {
    "symbol": "3413.TW",
    "name": "京鼎",
    "sector": "半導體業",
    "close": 278.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.07,
    "dog_ma200_bias": 0.006,
    "vr60": 1.67,
    "rs20": 0.83,
    "rs60": 0.95,
    "shares": 2706,
    "lots": 2,
    "odd_shares": 706,
    "ntd_at_risk": 39994.68,
    "position_cost": 752268.0,
    "constraint": "WEIGHT",
    "atr14": 7.39,
    "low_20d": 252.8,
    "ladder_minus1_pullback": 261.3,
    "ladder_4_base": 250.2,
    "ladder_5_euphoria": 361.4
  },
  {
    "symbol": "8021.TW",
    "name": "尖點",
    "sector": "其他電子業",
    "close": 506.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.42,
    "dog_ma200_bias": 0.01,
    "vr60": 1.24,
    "rs20": 0.95,
    "rs60": 0.77,
    "shares": 1841,
    "lots": 1,
    "odd_shares": 841,
    "ntd_at_risk": 39986.52,
    "position_cost": 931546.0,
    "constraint": "WEIGHT",
    "atr14": 10.86,
    "low_20d": 476.1,
    "ladder_minus1_pullback": 475.6,
    "ladder_4_base": 455.4,
    "ladder_5_euphoria": 657.8
  },
  {
    "symbol": "6426.TW",
    "name": "統新",
    "sector": "通信網路業",
    "close": 320.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.05,
    "dog_ma200_bias": 0.073,
    "vr60": 1.5,
    "rs20": 0.75,
    "rs60": 0.94,
    "shares": 3490,
    "lots": 3,
    "odd_shares": 490,
    "ntd_at_risk": 39995.4,
    "position_cost": 1118545.0,
    "constraint": "WEIGHT",
    "atr14": 5.73,
    "low_20d": 292.0,
    "ladder_minus1_pullback": 301.3,
    "ladder_4_base": 288.4,
    "ladder_5_euphoria": 416.7
  },
  {
    "symbol": "3023.TW",
    "name": "信邦",
    "sector": "電子零組件業",
    "close": 321.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.61,
    "dog_ma200_bias": -0.117,
    "vr60": 1.03,
    "rs20": 0.47,
    "rs60": 0.24,
    "shares": 894,
    "lots": 0,
    "odd_shares": 894,
    "ntd_at_risk": 19989.84,
    "position_cost": 287421.0,
    "constraint": "WEIGHT",
    "atr14": 11.18,
    "low_20d": 304.6,
    "ladder_minus1_pullback": 302.2,
    "ladder_4_base": 289.4,
    "ladder_5_euphoria": 417.9
  },
  {
    "symbol": "2010.TW",
    "name": "春源",
    "sector": "鋼鐵工業",
    "close": 22.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.95,
    "dog_ma200_bias": 0.031,
    "vr60": 1.85,
    "rs20": 0.79,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 571250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.1,
    "ladder_minus1_pullback": 21.5,
    "ladder_4_base": 20.6,
    "ladder_5_euphoria": 29.7
  },
  {
    "symbol": "4743.TWO",
    "name": "合一",
    "sector": "生技醫療業",
    "close": 48.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.75,
    "dog_ma200_bias": 0.003,
    "vr60": 2.09,
    "rs20": 0.87,
    "rs60": 0.86,
    "shares": 20000,
    "lots": 20,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 962000.0,
    "constraint": "WEIGHT",
    "atr14": 1.0,
    "low_20d": 45.8,
    "ladder_minus1_pullback": 45.2,
    "ladder_4_base": 43.3,
    "ladder_5_euphoria": 62.5
  },
  {
    "symbol": "2204.TW",
    "name": "中華",
    "sector": "汽車工業",
    "close": 52.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.5,
    "dog_ma200_bias": -0.01,
    "vr60": 1.36,
    "rs20": 0.77,
    "rs60": 0.8,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 840320.9,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 47.2,
    "ladder_minus1_pullback": 49.0,
    "ladder_4_base": 46.9,
    "ladder_5_euphoria": 67.7
  },
  {
    "symbol": "1447.TW",
    "name": "力鵬",
    "sector": "紡織纖維業",
    "close": 6.55,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.67,
    "dog_ma200_bias": 0.0,
    "vr60": 1.58,
    "rs20": 0.66,
    "rs60": 0.48,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 5.9,
    "ladder_minus1_pullback": 6.2,
    "ladder_4_base": 5.9,
    "ladder_5_euphoria": 8.5
  },
  {
    "symbol": "2727.TW",
    "name": "王品",
    "sector": "觀光餐旅",
    "close": 246.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.75,
    "dog_ma200_bias": 0.066,
    "vr60": 1.56,
    "rs20": 1.22,
    "rs60": 0.97,
    "shares": 2427,
    "lots": 2,
    "odd_shares": 427,
    "ntd_at_risk": 39996.96,
    "position_cost": 597042.0,
    "constraint": "WEIGHT",
    "atr14": 8.24,
    "low_20d": 226.3,
    "ladder_minus1_pullback": 231.2,
    "ladder_4_base": 221.4,
    "ladder_5_euphoria": 319.8
  },
  {
    "symbol": "9939.TW",
    "name": "宏全",
    "sector": "其他業",
    "close": 128.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.67,
    "dog_ma200_bias": 0.016,
    "vr60": 1.59,
    "rs20": 1.0,
    "rs60": 1.01,
    "shares": 8130,
    "lots": 8,
    "odd_shares": 130,
    "ntd_at_risk": 39999.6,
    "position_cost": 1044705.0,
    "constraint": "WEIGHT",
    "atr14": 2.46,
    "low_20d": 116.9,
    "ladder_minus1_pullback": 120.8,
    "ladder_4_base": 115.7,
    "ladder_5_euphoria": 167.1
  },
  {
    "symbol": "2816.TW",
    "name": "旺旺保",
    "sector": "金融保險業",
    "close": 45.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.85,
    "dog_ma200_bias": -0.011,
    "vr60": 1.93,
    "rs20": 0.82,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1131250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 41.0,
    "ladder_minus1_pullback": 42.5,
    "ladder_4_base": 40.7,
    "ladder_5_euphoria": 58.8
  },
  {
    "symbol": "4147.TWO",
    "name": "中裕",
    "sector": "生技醫療業",
    "close": 59.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.05,
    "dog_ma200_bias": 0.076,
    "vr60": 1.44,
    "rs20": 0.9,
    "rs60": 1.0,
    "shares": 13071,
    "lots": 13,
    "odd_shares": 71,
    "ntd_at_risk": 39997.26,
    "position_cost": 777724.5,
    "constraint": "WEIGHT",
    "atr14": 1.53,
    "low_20d": 54.3,
    "ladder_minus1_pullback": 55.9,
    "ladder_4_base": 53.6,
    "ladder_5_euphoria": 77.4
  },
  {
    "symbol": "6603.TWO",
    "name": "富強鑫",
    "sector": "電機機械業",
    "close": 27.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": -0.136,
    "vr60": 0.94,
    "rs20": 0.52,
    "rs60": 0.22,
    "shares": 11494,
    "lots": 11,
    "odd_shares": 494,
    "ntd_at_risk": 19999.56,
    "position_cost": 316085.0,
    "constraint": "WEIGHT",
    "atr14": 0.87,
    "low_20d": 26.4,
    "ladder_minus1_pullback": 25.8,
    "ladder_4_base": 24.8,
    "ladder_5_euphoria": 35.8
  },
  {
    "symbol": "6617.TWO",
    "name": "共信-KY",
    "sector": "生技醫療業",
    "close": 120.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.42,
    "dog_ma200_bias": -0.014,
    "vr60": 2.05,
    "rs20": 0.81,
    "rs60": 0.85,
    "shares": 4901,
    "lots": 4,
    "odd_shares": 901,
    "ntd_at_risk": 39992.16,
    "position_cost": 590570.5,
    "constraint": "WEIGHT",
    "atr14": 4.08,
    "low_20d": 111.6,
    "ladder_minus1_pullback": 113.3,
    "ladder_4_base": 108.5,
    "ladder_5_euphoria": 156.7
  },
  {
    "symbol": "9919.TW",
    "name": "康那香",
    "sector": "其他業",
    "close": 15.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.2,
    "dog_ma200_bias": 0.131,
    "vr60": 1.53,
    "rs20": 1.22,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 385000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.0,
    "ladder_minus1_pullback": 14.5,
    "ladder_4_base": 13.9,
    "ladder_5_euphoria": 20.0
  },
  {
    "symbol": "6175.TWO",
    "name": "立敦",
    "sector": "電子零組件業",
    "close": 73.6,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.05,
    "dog_ma200_bias": 0.256,
    "vr60": 1.96,
    "rs20": 1.16,
    "rs60": 1.34,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.27,
    "low_20d": 67.5,
    "ladder_minus1_pullback": 69.2,
    "ladder_4_base": 66.2,
    "ladder_5_euphoria": 95.7
  },
  {
    "symbol": "3317.TWO",
    "name": "尼克森",
    "sector": "半導體業",
    "close": 63.8,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.12,
    "dog_ma200_bias": -0.105,
    "vr60": 0.71,
    "rs20": 0.57,
    "rs60": 0.22,
    "shares": 6578,
    "lots": 6,
    "odd_shares": 578,
    "ntd_at_risk": 19997.12,
    "position_cost": 419676.4,
    "constraint": "WEIGHT",
    "atr14": 1.52,
    "low_20d": 59.6,
    "ladder_minus1_pullback": 60.0,
    "ladder_4_base": 57.4,
    "ladder_5_euphoria": 82.9
  },
  {
    "symbol": "3028.TW",
    "name": "增你強",
    "sector": "電子通路業",
    "close": 62.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.67,
    "dog_ma200_bias": 0.066,
    "vr60": 1.21,
    "rs20": 1.08,
    "rs60": 1.18,
    "shares": 9950,
    "lots": 9,
    "odd_shares": 950,
    "ntd_at_risk": 39999.0,
    "position_cost": 617895.0,
    "constraint": "WEIGHT",
    "atr14": 2.01,
    "low_20d": 55.9,
    "ladder_minus1_pullback": 58.4,
    "ladder_4_base": 55.9,
    "ladder_5_euphoria": 80.7
  },
  {
    "symbol": "6469.TWO",
    "name": "大樹",
    "sector": "生技醫療業",
    "close": 68.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.26,
    "dog_ma200_bias": 0.048,
    "vr60": 1.89,
    "rs20": 0.98,
    "rs60": 0.9,
    "shares": 16949,
    "lots": 16,
    "odd_shares": 949,
    "ntd_at_risk": 39999.64,
    "position_cost": 1155921.8,
    "constraint": "WEIGHT",
    "atr14": 1.18,
    "low_20d": 64.0,
    "ladder_minus1_pullback": 64.1,
    "ladder_4_base": 61.4,
    "ladder_5_euphoria": 88.7
  },
  {
    "symbol": "4770.TW",
    "name": "上品",
    "sector": "化學工業",
    "close": 273.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": 0.078,
    "vr60": 1.8,
    "rs20": 0.89,
    "rs60": 0.88,
    "shares": 2372,
    "lots": 2,
    "odd_shares": 372,
    "ntd_at_risk": 39991.92,
    "position_cost": 647556.0,
    "constraint": "WEIGHT",
    "atr14": 8.43,
    "low_20d": 250.2,
    "ladder_minus1_pullback": 256.6,
    "ladder_4_base": 245.7,
    "ladder_5_euphoria": 354.9
  },
  {
    "symbol": "6117.TW",
    "name": "迎廣",
    "sector": "電腦及週邊設備業",
    "close": 69.6,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.12,
    "dog_ma200_bias": -0.01,
    "vr60": 1.39,
    "rs20": 0.63,
    "rs60": 0.54,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.75,
    "low_20d": 65.7,
    "ladder_minus1_pullback": 65.4,
    "ladder_4_base": 62.6,
    "ladder_5_euphoria": 90.5
  },
  {
    "symbol": "2543.TW",
    "name": "皇昌",
    "sector": "建材營造業",
    "close": 38.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.55,
    "rs20": 1.09,
    "rs60": 0.9,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 791731.2,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 35.1,
    "ladder_minus1_pullback": 36.1,
    "ladder_4_base": 34.6,
    "ladder_5_euphoria": 49.9
  },
  {
    "symbol": "7610.TW",
    "name": "聯友金屬-創",
    "sector": "綠能環保",
    "close": 1455.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.25,
    "dog_ma200_bias": 0.079,
    "vr60": 1.25,
    "rs20": 1.01,
    "rs60": 0.75,
    "shares": 645,
    "lots": 0,
    "odd_shares": 645,
    "ntd_at_risk": 39977.1,
    "position_cost": 938475.0,
    "constraint": "WEIGHT",
    "atr14": 30.99,
    "low_20d": 1316.1,
    "ladder_minus1_pullback": 1367.7,
    "ladder_4_base": 1309.5,
    "ladder_5_euphoria": 1891.5
  },
  {
    "symbol": "2480.TW",
    "name": "敦陽科",
    "sector": "資訊服務業",
    "close": 190.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.54,
    "dog_ma200_bias": 0.065,
    "vr60": 1.97,
    "rs20": 1.1,
    "rs60": 0.73,
    "shares": 3129,
    "lots": 3,
    "odd_shares": 129,
    "ntd_at_risk": 39988.62,
    "position_cost": 594510.0,
    "constraint": "WEIGHT",
    "atr14": 6.39,
    "low_20d": 173.3,
    "ladder_minus1_pullback": 178.6,
    "ladder_4_base": 171.0,
    "ladder_5_euphoria": 247.0
  },
  {
    "symbol": "5471.TW",
    "name": "松翰",
    "sector": "半導體業",
    "close": 49.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.25,
    "dog_ma200_bias": -0.131,
    "vr60": 0.68,
    "rs20": 0.64,
    "rs60": 0.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.56,
    "low_20d": 45.1,
    "ladder_minus1_pullback": 46.1,
    "ladder_4_base": 44.1,
    "ladder_5_euphoria": 63.7
  },
  {
    "symbol": "2491.TW",
    "name": "吉祥全",
    "sector": "光電業",
    "close": 34.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.05,
    "dog_ma200_bias": 0.002,
    "vr60": 1.78,
    "rs20": 0.91,
    "rs60": 0.78,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 855000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 31.5,
    "ladder_minus1_pullback": 32.1,
    "ladder_4_base": 30.8,
    "ladder_5_euphoria": 44.5
  },
  {
    "symbol": "5465.TWO",
    "name": "富驊",
    "sector": "電腦及週邊設備業",
    "close": 35.65,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.07,
    "dog_ma200_bias": -0.197,
    "vr60": 1.01,
    "rs20": 0.38,
    "rs60": 0.5,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 445625.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 33.4,
    "ladder_minus1_pullback": 33.5,
    "ladder_4_base": 32.1,
    "ladder_5_euphoria": 46.3
  },
  {
    "symbol": "7780.TW",
    "name": "大研生醫*",
    "sector": "食品工業",
    "close": 16.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.4,
    "dog_ma200_bias": -0.008,
    "vr60": 1.65,
    "rs20": 1.01,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 401250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.2,
    "ladder_minus1_pullback": 15.1,
    "ladder_4_base": 14.4,
    "ladder_5_euphoria": 20.9
  },
  {
    "symbol": "3689.TWO",
    "name": "湧德",
    "sector": "電子零組件業",
    "close": 117.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.33,
    "dog_ma200_bias": 0.021,
    "vr60": 1.7,
    "rs20": 0.75,
    "rs60": 0.73,
    "shares": 5434,
    "lots": 5,
    "odd_shares": 434,
    "ntd_at_risk": 39994.24,
    "position_cost": 638495.0,
    "constraint": "WEIGHT",
    "atr14": 3.68,
    "low_20d": 107.6,
    "ladder_minus1_pullback": 110.4,
    "ladder_4_base": 105.8,
    "ladder_5_euphoria": 152.8
  },
  {
    "symbol": "6112.TW",
    "name": "邁達特",
    "sector": "資訊服務業",
    "close": 45.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": -0.171,
    "vr60": 0.93,
    "rs20": 0.32,
    "rs60": 0.37,
    "shares": 11627,
    "lots": 11,
    "odd_shares": 627,
    "ntd_at_risk": 19998.44,
    "position_cost": 529028.5,
    "constraint": "WEIGHT",
    "atr14": 0.86,
    "low_20d": 41.3,
    "ladder_minus1_pullback": 42.8,
    "ladder_4_base": 41.0,
    "ladder_5_euphoria": 59.1
  },
  {
    "symbol": "3675.TWO",
    "name": "德微",
    "sector": "半導體業",
    "close": 294.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.05,
    "dog_ma200_bias": 0.141,
    "vr60": 1.62,
    "rs20": 1.1,
    "rs60": 0.92,
    "shares": 2116,
    "lots": 2,
    "odd_shares": 116,
    "ntd_at_risk": 39992.4,
    "position_cost": 622104.0,
    "constraint": "WEIGHT",
    "atr14": 9.45,
    "low_20d": 269.0,
    "ladder_minus1_pullback": 276.4,
    "ladder_4_base": 264.6,
    "ladder_5_euphoria": 382.2
  },
  {
    "symbol": "2483.TW",
    "name": "百容",
    "sector": "電子零組件業",
    "close": 35.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.05,
    "dog_ma200_bias": 0.002,
    "vr60": 1.61,
    "rs20": 0.97,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 887500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 32.9,
    "ladder_minus1_pullback": 33.4,
    "ladder_4_base": 31.9,
    "ladder_5_euphoria": 46.1
  },
  {
    "symbol": "3592.TW",
    "name": "瑞鼎",
    "sector": "半導體業",
    "close": 246.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.55,
    "dog_ma200_bias": 0.027,
    "vr60": 1.79,
    "rs20": 1.04,
    "rs60": 0.74,
    "shares": 4366,
    "lots": 4,
    "odd_shares": 366,
    "ntd_at_risk": 39992.56,
    "position_cost": 1076219.0,
    "constraint": "WEIGHT",
    "atr14": 4.58,
    "low_20d": 230.5,
    "ladder_minus1_pullback": 231.7,
    "ladder_4_base": 221.8,
    "ladder_5_euphoria": 320.4
  },
  {
    "symbol": "2836.TW",
    "name": "高雄銀",
    "sector": "金融保險業",
    "close": 12.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.95,
    "dog_ma200_bias": 0.056,
    "vr60": 1.4,
    "rs20": 0.89,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 302500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.2,
    "ladder_minus1_pullback": 11.4,
    "ladder_4_base": 10.9,
    "ladder_5_euphoria": 15.7
  },
  {
    "symbol": "6177.TW",
    "name": "達麗",
    "sector": "建材營造業",
    "close": 45.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.27,
    "dog_ma200_bias": 0.076,
    "vr60": 1.46,
    "rs20": 0.96,
    "rs60": 0.95,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 807959.35,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 42.0,
    "ladder_minus1_pullback": 42.9,
    "ladder_4_base": 41.1,
    "ladder_5_euphoria": 59.3
  },
  {
    "symbol": "6223.TWO",
    "name": "旺矽",
    "sector": "半導體業",
    "close": 5300.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": -0.272,
    "vr60": 0.72,
    "rs20": 0.26,
    "rs60": 0.45,
    "shares": 89,
    "lots": 0,
    "odd_shares": 89,
    "ntd_at_risk": 19813.18,
    "position_cost": 471700.0,
    "constraint": "WEIGHT",
    "atr14": 111.31,
    "low_20d": 5014.3,
    "ladder_minus1_pullback": 4982.0,
    "ladder_4_base": 4770.0,
    "ladder_5_euphoria": 6890.0
  },
  {
    "symbol": "3141.TWO",
    "name": "晶宏",
    "sector": "半導體業",
    "close": 73.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.43,
    "dog_ma200_bias": -0.009,
    "vr60": 1.75,
    "rs20": 0.83,
    "rs60": 1.03,
    "shares": 11049,
    "lots": 11,
    "odd_shares": 49,
    "ntd_at_risk": 39997.38,
    "position_cost": 809891.7,
    "constraint": "WEIGHT",
    "atr14": 1.81,
    "low_20d": 66.9,
    "ladder_minus1_pullback": 68.9,
    "ladder_4_base": 66.0,
    "ladder_5_euphoria": 95.3
  },
  {
    "symbol": "6805.TW",
    "name": "富世達",
    "sector": "電子零組件業",
    "close": 2115.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.59,
    "dog_ma200_bias": -0.145,
    "vr60": 0.76,
    "rs20": 0.57,
    "rs60": 0.6,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 46.83,
    "low_20d": 1969.4,
    "ladder_minus1_pullback": 1988.1,
    "ladder_4_base": 1903.5,
    "ladder_5_euphoria": 2749.5
  },
  {
    "symbol": "1712.TW",
    "name": "興農",
    "sector": "化學工業",
    "close": 40.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.71,
    "dog_ma200_bias": -0.009,
    "vr60": 1.57,
    "rs20": 1.12,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1015000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.8,
    "ladder_minus1_pullback": 38.2,
    "ladder_4_base": 36.5,
    "ladder_5_euphoria": 52.8
  },
  {
    "symbol": "1611.TW",
    "name": "中電",
    "sector": "電器電纜業",
    "close": 11.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.5,
    "dog_ma200_bias": 0.131,
    "vr60": 1.51,
    "rs20": 1.13,
    "rs60": 1.16,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 282500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.2,
    "ladder_minus1_pullback": 10.6,
    "ladder_4_base": 10.2,
    "ladder_5_euphoria": 14.7
  },
  {
    "symbol": "6472.TW",
    "name": "保瑞",
    "sector": "生技醫療業",
    "close": 424.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.1,
    "dog_ma200_bias": -0.066,
    "vr60": 0.65,
    "rs20": 0.47,
    "rs60": 0.54,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 11.98,
    "low_20d": 404.1,
    "ladder_minus1_pullback": 398.6,
    "ladder_4_base": 381.6,
    "ladder_5_euphoria": 551.2
  },
  {
    "symbol": "3537.TWO",
    "name": "堡達",
    "sector": "電子零組件業",
    "close": 56.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.1,
    "dog_ma200_bias": -0.015,
    "vr60": 2.04,
    "rs20": 1.09,
    "rs60": 0.87,
    "shares": 16528,
    "lots": 16,
    "odd_shares": 528,
    "ntd_at_risk": 39997.76,
    "position_cost": 932179.2,
    "constraint": "WEIGHT",
    "atr14": 1.21,
    "low_20d": 53.8,
    "ladder_minus1_pullback": 53.0,
    "ladder_4_base": 50.8,
    "ladder_5_euphoria": 73.3
  },
  {
    "symbol": "1215.TW",
    "name": "卜蜂",
    "sector": "食品工業",
    "close": 106.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.4,
    "dog_ma200_bias": 0.031,
    "vr60": 2.03,
    "rs20": 0.82,
    "rs60": 0.9,
    "shares": 6451,
    "lots": 6,
    "odd_shares": 451,
    "ntd_at_risk": 39996.2,
    "position_cost": 687031.5,
    "constraint": "WEIGHT",
    "atr14": 3.1,
    "low_20d": 97.3,
    "ladder_minus1_pullback": 100.1,
    "ladder_4_base": 95.9,
    "ladder_5_euphoria": 138.5
  },
  {
    "symbol": "1617.TW",
    "name": "榮星",
    "sector": "電器電纜業",
    "close": 22.35,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.24,
    "dog_ma200_bias": -0.007,
    "vr60": 1.42,
    "rs20": 0.54,
    "rs60": 0.66,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 20.8,
    "ladder_minus1_pullback": 21.0,
    "ladder_4_base": 20.1,
    "ladder_5_euphoria": 29.1
  },
  {
    "symbol": "1789.TW",
    "name": "神隆",
    "sector": "生技醫療業",
    "close": 19.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.25,
    "dog_ma200_bias": 0.03,
    "vr60": 1.55,
    "rs20": 1.14,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 495000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.7,
    "ladder_minus1_pullback": 18.6,
    "ladder_4_base": 17.8,
    "ladder_5_euphoria": 25.7
  },
  {
    "symbol": "4764.TW",
    "name": "雙鍵",
    "sector": "化學工業",
    "close": 183.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.11,
    "dog_ma200_bias": 0.056,
    "vr60": 1.45,
    "rs20": 1.14,
    "rs60": 1.04,
    "shares": 3333,
    "lots": 3,
    "odd_shares": 333,
    "ntd_at_risk": 39996.0,
    "position_cost": 609939.0,
    "constraint": "WEIGHT",
    "atr14": 6.0,
    "low_20d": 167.1,
    "ladder_minus1_pullback": 172.0,
    "ladder_4_base": 164.7,
    "ladder_5_euphoria": 237.9
  },
  {
    "symbol": "4971.TWO",
    "name": "IET-KY",
    "sector": "半導體業",
    "close": 507.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.19,
    "dog_ma200_bias": -0.137,
    "vr60": 0.65,
    "rs20": 0.44,
    "rs60": 0.6,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 15.43,
    "low_20d": 478.8,
    "ladder_minus1_pullback": 476.6,
    "ladder_4_base": 456.3,
    "ladder_5_euphoria": 659.1
  },
  {
    "symbol": "4306.TW",
    "name": "炎洲",
    "sector": "塑膠工業",
    "close": 14.55,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.5,
    "dog_ma200_bias": 0.33,
    "vr60": 1.9,
    "rs20": 1.4,
    "rs60": 1.4,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 13.6,
    "ladder_minus1_pullback": 13.7,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 18.9
  },
  {
    "symbol": "2106.TW",
    "name": "建大",
    "sector": "橡膠工業",
    "close": 17.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.71,
    "dog_ma200_bias": 0.074,
    "vr60": 1.77,
    "rs20": 0.83,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 430000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.2,
    "ladder_minus1_pullback": 16.2,
    "ladder_4_base": 15.5,
    "ladder_5_euphoria": 22.4
  },
  {
    "symbol": "6861.TW",
    "name": "睿生光電",
    "sector": "生技醫療業",
    "close": 249.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": -0.051,
    "vr60": 1.61,
    "rs20": 0.64,
    "rs60": 0.79,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.44,
    "low_20d": 227.3,
    "ladder_minus1_pullback": 234.5,
    "ladder_4_base": 224.6,
    "ladder_5_euphoria": 324.4
  },
  {
    "symbol": "2108.TW",
    "name": "南帝",
    "sector": "橡膠工業",
    "close": 29.55,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.08,
    "dog_ma200_bias": -0.108,
    "vr60": 0.88,
    "rs20": 0.48,
    "rs60": 0.3,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 369375.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.4,
    "ladder_minus1_pullback": 27.8,
    "ladder_4_base": 26.6,
    "ladder_5_euphoria": 38.4
  },
  {
    "symbol": "8081.TW",
    "name": "致新",
    "sector": "半導體業",
    "close": 262.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.5,
    "dog_ma200_bias": 0.015,
    "vr60": 1.63,
    "rs20": 0.98,
    "rs60": 0.93,
    "shares": 3984,
    "lots": 3,
    "odd_shares": 984,
    "ntd_at_risk": 39999.36,
    "position_cost": 1045800.0,
    "constraint": "WEIGHT",
    "atr14": 5.02,
    "low_20d": 242.2,
    "ladder_minus1_pullback": 246.8,
    "ladder_4_base": 236.2,
    "ladder_5_euphoria": 341.2
  },
  {
    "symbol": "4760.TWO",
    "name": "勤凱",
    "sector": "其他電子業",
    "close": 368.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.13,
    "dog_ma200_bias": 0.022,
    "vr60": 1.87,
    "rs20": 1.09,
    "rs60": 0.8,
    "shares": 1990,
    "lots": 1,
    "odd_shares": 990,
    "ntd_at_risk": 39999.0,
    "position_cost": 733315.0,
    "constraint": "WEIGHT",
    "atr14": 10.05,
    "low_20d": 346.5,
    "ladder_minus1_pullback": 346.4,
    "ladder_4_base": 331.7,
    "ladder_5_euphoria": 479.1
  },
  {
    "symbol": "1201.TW",
    "name": "味全",
    "sector": "食品工業",
    "close": 11.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.5,
    "dog_ma200_bias": 0.162,
    "vr60": 1.53,
    "rs20": 1.16,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 287500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.5,
    "ladder_minus1_pullback": 10.8,
    "ladder_4_base": 10.3,
    "ladder_5_euphoria": 15.0
  },
  {
    "symbol": "3339.TWO",
    "name": "泰谷",
    "sector": "光電業",
    "close": 42.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.05,
    "dog_ma200_bias": -0.005,
    "vr60": 1.8,
    "rs20": 0.83,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1067500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 39.2,
    "ladder_minus1_pullback": 40.1,
    "ladder_4_base": 38.4,
    "ladder_5_euphoria": 55.5
  },
  {
    "symbol": "4416.TWO",
    "name": "三圓",
    "sector": "建材營造業",
    "close": 12.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.06,
    "dog_ma200_bias": -0.004,
    "vr60": 1.46,
    "rs20": 0.85,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 305000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.3,
    "ladder_minus1_pullback": 11.5,
    "ladder_4_base": 11.0,
    "ladder_5_euphoria": 15.9
  },
  {
    "symbol": "1321.TW",
    "name": "大洋",
    "sector": "塑膠工業",
    "close": 36.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.53,
    "dog_ma200_bias": -0.011,
    "vr60": 1.57,
    "rs20": 0.66,
    "rs60": 0.46,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.91,
    "low_20d": 33.8,
    "ladder_minus1_pullback": 33.8,
    "ladder_4_base": 32.4,
    "ladder_5_euphoria": 46.8
  },
  {
    "symbol": "6188.TWO",
    "name": "廣明",
    "sector": "電腦及週邊設備業",
    "close": 62.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.25,
    "dog_ma200_bias": 0.072,
    "vr60": 1.57,
    "rs20": 1.25,
    "rs60": 1.25,
    "shares": 17543,
    "lots": 17,
    "odd_shares": 543,
    "ntd_at_risk": 39998.04,
    "position_cost": 1101700.4,
    "constraint": "WEIGHT",
    "atr14": 1.14,
    "low_20d": 58.3,
    "ladder_minus1_pullback": 59.0,
    "ladder_4_base": 56.5,
    "ladder_5_euphoria": 81.6
  },
  {
    "symbol": "4532.TW",
    "name": "瑞智",
    "sector": "電機機械業",
    "close": 24.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.43,
    "dog_ma200_bias": 0.054,
    "vr60": 1.71,
    "rs20": 0.85,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 602500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.0,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.7,
    "ladder_5_euphoria": 31.3
  },
  {
    "symbol": "3055.TW",
    "name": "蔚華科",
    "sector": "電子通路業",
    "close": 147.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.5,
    "dog_ma200_bias": 0.06,
    "vr60": 1.46,
    "rs20": 1.02,
    "rs60": 1.02,
    "shares": 6289,
    "lots": 6,
    "odd_shares": 289,
    "ntd_at_risk": 39998.04,
    "position_cost": 924483.0,
    "constraint": "WEIGHT",
    "atr14": 3.18,
    "low_20d": 139.2,
    "ladder_minus1_pullback": 138.2,
    "ladder_4_base": 132.3,
    "ladder_5_euphoria": 191.1
  },
  {
    "symbol": "3312.TW",
    "name": "弘憶股",
    "sector": "電子通路業",
    "close": 48.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.23,
    "dog_ma200_bias": -0.21,
    "vr60": 1.08,
    "rs20": 0.59,
    "rs60": 0.3,
    "shares": 6134,
    "lots": 6,
    "odd_shares": 134,
    "ntd_at_risk": 19996.84,
    "position_cost": 296272.2,
    "constraint": "WEIGHT",
    "atr14": 1.63,
    "low_20d": 46.3,
    "ladder_minus1_pullback": 45.4,
    "ladder_4_base": 43.5,
    "ladder_5_euphoria": 62.8
  },
  {
    "symbol": "3147.TWO",
    "name": "大綜",
    "sector": "資訊服務業",
    "close": 294.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.32,
    "dog_ma200_bias": -0.198,
    "vr60": 0.69,
    "rs20": 0.52,
    "rs60": 0.62,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 9.94,
    "low_20d": 280.4,
    "ladder_minus1_pullback": 276.4,
    "ladder_4_base": 264.6,
    "ladder_5_euphoria": 382.2
  },
  {
    "symbol": "3305.TW",
    "name": "昇貿",
    "sector": "其他電子業",
    "close": 103.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.12,
    "dog_ma200_bias": 0.067,
    "vr60": 1.95,
    "rs20": 1.11,
    "rs60": 0.95,
    "shares": 7874,
    "lots": 7,
    "odd_shares": 874,
    "ntd_at_risk": 39999.92,
    "position_cost": 811022.0,
    "constraint": "WEIGHT",
    "atr14": 2.54,
    "low_20d": 97.9,
    "ladder_minus1_pullback": 96.8,
    "ladder_4_base": 92.7,
    "ladder_5_euphoria": 133.9
  },
  {
    "symbol": "8016.TW",
    "name": "矽創",
    "sector": "半導體業",
    "close": 298.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.57,
    "dog_ma200_bias": 0.045,
    "vr60": 1.88,
    "rs20": 0.97,
    "rs60": 0.91,
    "shares": 3424,
    "lots": 3,
    "odd_shares": 424,
    "ntd_at_risk": 39992.32,
    "position_cost": 1020352.0,
    "constraint": "WEIGHT",
    "atr14": 5.84,
    "low_20d": 272.3,
    "ladder_minus1_pullback": 280.1,
    "ladder_4_base": 268.2,
    "ladder_5_euphoria": 387.4
  },
  {
    "symbol": "3040.TW",
    "name": "遠見",
    "sector": "其他業",
    "close": 30.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": 0.058,
    "vr60": 2.07,
    "rs20": 0.87,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 750000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.6,
    "ladder_minus1_pullback": 28.2,
    "ladder_4_base": 27.0,
    "ladder_5_euphoria": 39.0
  },
  {
    "symbol": "5515.TW",
    "name": "建國",
    "sector": "建材營造業",
    "close": 51.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.38,
    "dog_ma200_bias": 0.142,
    "vr60": 1.16,
    "rs20": 1.02,
    "rs60": 1.11,
    "shares": 13698,
    "lots": 13,
    "odd_shares": 698,
    "ntd_at_risk": 39998.16,
    "position_cost": 710926.2,
    "constraint": "WEIGHT",
    "atr14": 1.46,
    "low_20d": 49.4,
    "ladder_minus1_pullback": 48.8,
    "ladder_4_base": 46.7,
    "ladder_5_euphoria": 67.5
  },
  {
    "symbol": "8182.TWO",
    "name": "加高",
    "sector": "電子零組件業",
    "close": 39.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.05,
    "dog_ma200_bias": 0.018,
    "vr60": 1.59,
    "rs20": 0.97,
    "rs60": 0.75,
    "shares": 24691,
    "lots": 24,
    "odd_shares": 691,
    "ntd_at_risk": 39999.42,
    "position_cost": 980232.7,
    "constraint": "WEIGHT",
    "atr14": 0.81,
    "low_20d": 37.9,
    "ladder_minus1_pullback": 37.3,
    "ladder_4_base": 35.7,
    "ladder_5_euphoria": 51.6
  },
  {
    "symbol": "2534.TW",
    "name": "宏盛",
    "sector": "建材營造業",
    "close": 16.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.2,
    "dog_ma200_bias": 0.038,
    "vr60": 1.43,
    "rs20": 0.88,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 410000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.0,
    "ladder_minus1_pullback": 15.4,
    "ladder_4_base": 14.8,
    "ladder_5_euphoria": 21.3
  },
  {
    "symbol": "3441.TWO",
    "name": "聯一光",
    "sector": "光電業",
    "close": 225.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.65,
    "dog_ma200_bias": -0.005,
    "vr60": 1.34,
    "rs20": 0.88,
    "rs60": 0.72,
    "shares": 5797,
    "lots": 5,
    "odd_shares": 797,
    "ntd_at_risk": 39999.3,
    "position_cost": 1307223.5,
    "constraint": "WEIGHT",
    "atr14": 3.45,
    "low_20d": 205.2,
    "ladder_minus1_pullback": 212.0,
    "ladder_4_base": 203.0,
    "ladder_5_euphoria": 293.2
  },
  {
    "symbol": "2020.TW",
    "name": "美亞",
    "sector": "鋼鐵工業",
    "close": 24.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.86,
    "dog_ma200_bias": 0.073,
    "vr60": 1.75,
    "rs20": 1.01,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 600000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.0,
    "ladder_minus1_pullback": 22.6,
    "ladder_4_base": 21.6,
    "ladder_5_euphoria": 31.2
  },
  {
    "symbol": "8040.TWO",
    "name": "九暘",
    "sector": "半導體業",
    "close": 81.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.15,
    "dog_ma200_bias": 0.129,
    "vr60": 1.26,
    "rs20": 1.26,
    "rs60": 1.03,
    "shares": 13071,
    "lots": 13,
    "odd_shares": 71,
    "ntd_at_risk": 39997.26,
    "position_cost": 1060058.1,
    "constraint": "WEIGHT",
    "atr14": 1.53,
    "low_20d": 74.9,
    "ladder_minus1_pullback": 76.2,
    "ladder_4_base": 73.0,
    "ladder_5_euphoria": 105.4
  },
  {
    "symbol": "3483.TWO",
    "name": "力致",
    "sector": "電腦及週邊設備業",
    "close": 86.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.39,
    "dog_ma200_bias": 0.002,
    "vr60": 1.37,
    "rs20": 0.78,
    "rs60": 0.88,
    "shares": 10810,
    "lots": 10,
    "odd_shares": 810,
    "ntd_at_risk": 39997.0,
    "position_cost": 932903.0,
    "constraint": "WEIGHT",
    "atr14": 1.85,
    "low_20d": 80.2,
    "ladder_minus1_pullback": 81.1,
    "ladder_4_base": 77.7,
    "ladder_5_euphoria": 112.2
  },
  {
    "symbol": "1307.TW",
    "name": "三芳",
    "sector": "塑膠工業",
    "close": 31.25,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.09,
    "dog_ma200_bias": -0.205,
    "vr60": 0.89,
    "rs20": 0.24,
    "rs60": 0.26,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 390625.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.6,
    "ladder_minus1_pullback": 29.4,
    "ladder_4_base": 28.1,
    "ladder_5_euphoria": 40.6
  },
  {
    "symbol": "6515.TW",
    "name": "穎崴",
    "sector": "半導體業",
    "close": 5055.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": 0.013,
    "vr60": 1.52,
    "rs20": 0.84,
    "rs60": 0.96,
    "shares": 140,
    "lots": 0,
    "odd_shares": 140,
    "ntd_at_risk": 39802.0,
    "position_cost": 707700.0,
    "constraint": "WEIGHT",
    "atr14": 142.15,
    "low_20d": 4709.8,
    "ladder_minus1_pullback": 4751.7,
    "ladder_4_base": 4549.5,
    "ladder_5_euphoria": 6571.5
  },
  {
    "symbol": "2548.TW",
    "name": "華固",
    "sector": "建材營造業",
    "close": 91.2,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": -0.185,
    "vr60": 1.1,
    "rs20": 0.53,
    "rs60": 0.54,
    "shares": 6493,
    "lots": 6,
    "odd_shares": 493,
    "ntd_at_risk": 19998.44,
    "position_cost": 592161.6,
    "constraint": "WEIGHT",
    "atr14": 1.54,
    "low_20d": 82.3,
    "ladder_minus1_pullback": 85.7,
    "ladder_4_base": 82.1,
    "ladder_5_euphoria": 118.6
  },
  {
    "symbol": "8464.TW",
    "name": "億豐",
    "sector": "居家生活",
    "close": 373.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.65,
    "dog_ma200_bias": 0.047,
    "vr60": 1.6,
    "rs20": 1.11,
    "rs60": 0.91,
    "shares": 2173,
    "lots": 2,
    "odd_shares": 173,
    "ntd_at_risk": 39983.2,
    "position_cost": 810529.0,
    "constraint": "WEIGHT",
    "atr14": 9.2,
    "low_20d": 337.8,
    "ladder_minus1_pullback": 350.6,
    "ladder_4_base": 335.7,
    "ladder_5_euphoria": 484.9
  },
  {
    "symbol": "6150.TWO",
    "name": "撼訊",
    "sector": "電腦及週邊設備業",
    "close": 71.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.5,
    "dog_ma200_bias": 0.042,
    "vr60": 2.06,
    "rs20": 1.02,
    "rs60": 0.81,
    "shares": 14184,
    "lots": 14,
    "odd_shares": 184,
    "ntd_at_risk": 39998.88,
    "position_cost": 1008482.4,
    "constraint": "WEIGHT",
    "atr14": 1.41,
    "low_20d": 68.2,
    "ladder_minus1_pullback": 66.8,
    "ladder_4_base": 64.0,
    "ladder_5_euphoria": 92.4
  },
  {
    "symbol": "4966.TWO",
    "name": "譜瑞-KY",
    "sector": "半導體業",
    "close": 538.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.29,
    "dog_ma200_bias": 0.072,
    "vr60": 2.05,
    "rs20": 0.9,
    "rs60": 0.89,
    "shares": 1624,
    "lots": 1,
    "odd_shares": 624,
    "ntd_at_risk": 39982.88,
    "position_cost": 873712.0,
    "constraint": "WEIGHT",
    "atr14": 12.31,
    "low_20d": 504.4,
    "ladder_minus1_pullback": 505.7,
    "ladder_4_base": 484.2,
    "ladder_5_euphoria": 699.4
  },
  {
    "symbol": "1563.TW",
    "name": "巧新",
    "sector": "汽車工業",
    "close": 84.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.32,
    "dog_ma200_bias": 0.008,
    "vr60": 2.02,
    "rs20": 1.08,
    "rs60": 0.83,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 1162749.9,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 79.8,
    "ladder_minus1_pullback": 79.2,
    "ladder_4_base": 75.9,
    "ladder_5_euphoria": 109.6
  },
  {
    "symbol": "7711.TW",
    "name": "永擎",
    "sector": "電腦及週邊設備業",
    "close": 568.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.35,
    "dog_ma200_bias": 0.341,
    "vr60": 2.05,
    "rs20": 1.17,
    "rs60": 1.41,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 13.03,
    "low_20d": 537.4,
    "ladder_minus1_pullback": 533.9,
    "ladder_4_base": 511.2,
    "ladder_5_euphoria": 738.4
  },
  {
    "symbol": "7795.TW",
    "name": "長廣",
    "sector": "電子零組件業",
    "close": 486.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.18,
    "dog_ma200_bias": -0.187,
    "vr60": 1.08,
    "rs20": 0.27,
    "rs60": 0.53,
    "shares": 782,
    "lots": 0,
    "odd_shares": 782,
    "ntd_at_risk": 19987.92,
    "position_cost": 380443.0,
    "constraint": "WEIGHT",
    "atr14": 12.78,
    "low_20d": 448.3,
    "ladder_minus1_pullback": 457.3,
    "ladder_4_base": 437.9,
    "ladder_5_euphoria": 632.5
  },
  {
    "symbol": "6525.TW",
    "name": "捷敏-KY",
    "sector": "半導體業",
    "close": 128.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.09,
    "dog_ma200_bias": -0.019,
    "vr60": 1.26,
    "rs20": 1.02,
    "rs60": 0.97,
    "shares": 4987,
    "lots": 4,
    "odd_shares": 987,
    "ntd_at_risk": 39995.74,
    "position_cost": 640829.5,
    "constraint": "WEIGHT",
    "atr14": 4.01,
    "low_20d": 115.8,
    "ladder_minus1_pullback": 120.8,
    "ladder_4_base": 115.7,
    "ladder_5_euphoria": 167.1
  },
  {
    "symbol": "4174.TWO",
    "name": "浩鼎",
    "sector": "生技醫療業",
    "close": 59.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.69,
    "dog_ma200_bias": -0.124,
    "vr60": 0.84,
    "rs20": 0.24,
    "rs60": 0.38,
    "shares": 9090,
    "lots": 9,
    "odd_shares": 90,
    "ntd_at_risk": 19998.0,
    "position_cost": 544491.0,
    "constraint": "WEIGHT",
    "atr14": 1.1,
    "low_20d": 54.4,
    "ladder_minus1_pullback": 56.3,
    "ladder_4_base": 53.9,
    "ladder_5_euphoria": 77.9
  },
  {
    "symbol": "2614.TW",
    "name": "東森",
    "sector": "其他業",
    "close": 15.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.33,
    "dog_ma200_bias": 0.078,
    "vr60": 1.9,
    "rs20": 1.01,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 376250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.3,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.6
  },
  {
    "symbol": "3356.TW",
    "name": "奇偶",
    "sector": "光電業",
    "close": 72.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.18,
    "dog_ma200_bias": 0.329,
    "vr60": 1.75,
    "rs20": 1.31,
    "rs60": 1.22,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.77,
    "low_20d": 66.5,
    "ladder_minus1_pullback": 68.1,
    "ladder_4_base": 65.2,
    "ladder_5_euphoria": 94.2
  },
  {
    "symbol": "1590.TW",
    "name": "亞德客-KY",
    "sector": "電機機械業",
    "close": 1155.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.17,
    "dog_ma200_bias": -0.015,
    "vr60": 1.91,
    "rs20": 0.97,
    "rs60": 0.9,
    "shares": 881,
    "lots": 0,
    "odd_shares": 881,
    "ntd_at_risk": 39979.78,
    "position_cost": 1017555.0,
    "constraint": "WEIGHT",
    "atr14": 22.69,
    "low_20d": 1055.6,
    "ladder_minus1_pullback": 1085.7,
    "ladder_4_base": 1039.5,
    "ladder_5_euphoria": 1501.5
  },
  {
    "symbol": "5228.TWO",
    "name": "鈺鎧",
    "sector": "電子零組件業",
    "close": 56.1,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.06,
    "dog_ma200_bias": -0.239,
    "vr60": 0.77,
    "rs20": 0.36,
    "rs60": 0.41,
    "shares": 8403,
    "lots": 8,
    "odd_shares": 403,
    "ntd_at_risk": 19999.14,
    "position_cost": 471408.3,
    "constraint": "WEIGHT",
    "atr14": 1.19,
    "low_20d": 52.7,
    "ladder_minus1_pullback": 52.7,
    "ladder_4_base": 50.5,
    "ladder_5_euphoria": 72.9
  },
  {
    "symbol": "7799.TW",
    "name": "禾榮科",
    "sector": "生技醫療業",
    "close": 447.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.21,
    "dog_ma200_bias": -0.277,
    "vr60": 0.95,
    "rs20": 0.41,
    "rs60": 0.42,
    "shares": 1043,
    "lots": 1,
    "odd_shares": 43,
    "ntd_at_risk": 19983.88,
    "position_cost": 466221.0,
    "constraint": "WEIGHT",
    "atr14": 9.58,
    "low_20d": 414.0,
    "ladder_minus1_pullback": 420.2,
    "ladder_4_base": 402.3,
    "ladder_5_euphoria": 581.1
  },
  {
    "symbol": "6753.TW",
    "name": "龍德造船",
    "sector": "航運業",
    "close": 122.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.12,
    "dog_ma200_bias": 0.056,
    "vr60": 1.73,
    "rs20": 1.03,
    "rs60": 0.73,
    "shares": 10869,
    "lots": 10,
    "odd_shares": 869,
    "ntd_at_risk": 39997.92,
    "position_cost": 1326018.0,
    "constraint": "WEIGHT",
    "atr14": 1.84,
    "low_20d": 112.1,
    "ladder_minus1_pullback": 114.7,
    "ladder_4_base": 109.8,
    "ladder_5_euphoria": 158.6
  },
  {
    "symbol": "8383.TWO",
    "name": "千附",
    "sector": "半導體業",
    "close": 67.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.31,
    "dog_ma200_bias": 0.073,
    "vr60": 1.3,
    "rs20": 1.06,
    "rs60": 0.81,
    "shares": 9615,
    "lots": 9,
    "odd_shares": 615,
    "ntd_at_risk": 39998.4,
    "position_cost": 647089.5,
    "constraint": "WEIGHT",
    "atr14": 2.08,
    "low_20d": 62.4,
    "ladder_minus1_pullback": 63.3,
    "ladder_4_base": 60.6,
    "ladder_5_euphoria": 87.5
  },
  {
    "symbol": "2424.TW",
    "name": "隴華",
    "sector": "通信網路業",
    "close": 14.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.95,
    "dog_ma200_bias": -0.011,
    "vr60": 1.89,
    "rs20": 0.93,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 355000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.4,
    "ladder_minus1_pullback": 13.3,
    "ladder_4_base": 12.8,
    "ladder_5_euphoria": 18.5
  },
  {
    "symbol": "3596.TW",
    "name": "智易",
    "sector": "通信網路業",
    "close": 158.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.17,
    "dog_ma200_bias": 0.046,
    "vr60": 1.63,
    "rs20": 0.96,
    "rs60": 0.75,
    "shares": 4987,
    "lots": 4,
    "odd_shares": 987,
    "ntd_at_risk": 39995.74,
    "position_cost": 790439.5,
    "constraint": "WEIGHT",
    "atr14": 4.01,
    "low_20d": 144.0,
    "ladder_minus1_pullback": 149.0,
    "ladder_4_base": 142.7,
    "ladder_5_euphoria": 206.1
  },
  {
    "symbol": "2530.TW",
    "name": "華建",
    "sector": "建材營造業",
    "close": 20.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.23,
    "dog_ma200_bias": 0.019,
    "vr60": 1.92,
    "rs20": 0.97,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 520000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.8,
    "ladder_minus1_pullback": 19.6,
    "ladder_4_base": 18.7,
    "ladder_5_euphoria": 27.0
  },
  {
    "symbol": "8240.TWO",
    "name": "華宏",
    "sector": "光電業",
    "close": 50.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.05,
    "dog_ma200_bias": -0.006,
    "vr60": 1.81,
    "rs20": 1.12,
    "rs60": 0.98,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 884950.0,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 45.7,
    "ladder_minus1_pullback": 47.0,
    "ladder_4_base": 45.0,
    "ladder_5_euphoria": 65.0
  },
  {
    "symbol": "3290.TWO",
    "name": "東浦",
    "sector": "電子零組件業",
    "close": 50.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.053,
    "vr60": 1.54,
    "rs20": 1.13,
    "rs60": 0.89,
    "shares": 13333,
    "lots": 13,
    "odd_shares": 333,
    "ntd_at_risk": 39999.0,
    "position_cost": 666650.0,
    "constraint": "WEIGHT",
    "atr14": 1.5,
    "low_20d": 47.5,
    "ladder_minus1_pullback": 47.0,
    "ladder_4_base": 45.0,
    "ladder_5_euphoria": 65.0
  },
  {
    "symbol": "4128.TWO",
    "name": "中天",
    "sector": "生技醫療業",
    "close": 15.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.4,
    "dog_ma200_bias": 0.036,
    "vr60": 1.31,
    "rs20": 0.75,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 377500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.5,
    "ladder_minus1_pullback": 14.2,
    "ladder_4_base": 13.6,
    "ladder_5_euphoria": 19.6
  },
  {
    "symbol": "8437.TWO",
    "name": "大地-KY",
    "sector": "其他業",
    "close": 13.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.95,
    "dog_ma200_bias": 0.034,
    "vr60": 2.05,
    "rs20": 0.87,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 338750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.4,
    "ladder_minus1_pullback": 12.7,
    "ladder_4_base": 12.2,
    "ladder_5_euphoria": 17.6
  },
  {
    "symbol": "2505.TW",
    "name": "國揚",
    "sector": "建材營造業",
    "close": 18.05,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.89,
    "dog_ma200_bias": 0.168,
    "vr60": 1.26,
    "rs20": 1.12,
    "rs60": 1.16,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 451250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.7,
    "ladder_minus1_pullback": 17.0,
    "ladder_4_base": 16.2,
    "ladder_5_euphoria": 23.5
  },
  {
    "symbol": "8121.TWO",
    "name": "越峰",
    "sector": "電子零組件業",
    "close": 31.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.25,
    "dog_ma200_bias": 0.031,
    "vr60": 1.34,
    "rs20": 0.84,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 777500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.0,
    "ladder_minus1_pullback": 29.2,
    "ladder_4_base": 28.0,
    "ladder_5_euphoria": 40.4
  },
  {
    "symbol": "2419.TW",
    "name": "仲琦",
    "sector": "通信網路業",
    "close": 27.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.1,
    "dog_ma200_bias": -0.001,
    "vr60": 1.36,
    "rs20": 1.07,
    "rs60": 1.0,
    "shares": 21978,
    "lots": 21,
    "odd_shares": 978,
    "ntd_at_risk": 39999.96,
    "position_cost": 595603.8,
    "constraint": "WEIGHT",
    "atr14": 0.91,
    "low_20d": 24.9,
    "ladder_minus1_pullback": 25.5,
    "ladder_4_base": 24.4,
    "ladder_5_euphoria": 35.2
  },
  {
    "symbol": "6937.TW",
    "name": "天虹",
    "sector": "半導體業",
    "close": 269.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.42,
    "dog_ma200_bias": 0.162,
    "vr60": 1.61,
    "rs20": 1.35,
    "rs60": 1.08,
    "shares": 2717,
    "lots": 2,
    "odd_shares": 717,
    "ntd_at_risk": 39994.24,
    "position_cost": 732231.5,
    "constraint": "WEIGHT",
    "atr14": 7.36,
    "low_20d": 252.7,
    "ladder_minus1_pullback": 253.3,
    "ladder_4_base": 242.6,
    "ladder_5_euphoria": 350.4
  },
  {
    "symbol": "4533.TWO",
    "name": "協易機",
    "sector": "電機機械業",
    "close": 25.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": 0.035,
    "vr60": 1.46,
    "rs20": 0.78,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 645000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.0,
    "ladder_minus1_pullback": 24.3,
    "ladder_4_base": 23.2,
    "ladder_5_euphoria": 33.5
  },
  {
    "symbol": "6693.TWO",
    "name": "廣閎科",
    "sector": "半導體業",
    "close": 180.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.4,
    "dog_ma200_bias": 0.053,
    "vr60": 1.64,
    "rs20": 0.88,
    "rs60": 0.74,
    "shares": 4073,
    "lots": 4,
    "odd_shares": 73,
    "ntd_at_risk": 39996.86,
    "position_cost": 733140.0,
    "constraint": "WEIGHT",
    "atr14": 4.91,
    "low_20d": 165.1,
    "ladder_minus1_pullback": 169.2,
    "ladder_4_base": 162.0,
    "ladder_5_euphoria": 234.0
  },
  {
    "symbol": "1586.TWO",
    "name": "和勤",
    "sector": "電機機械業",
    "close": 18.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.36,
    "dog_ma200_bias": -0.162,
    "vr60": 0.7,
    "rs20": 0.45,
    "rs60": 0.51,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 230000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.2,
    "ladder_minus1_pullback": 17.3,
    "ladder_4_base": 16.6,
    "ladder_5_euphoria": 23.9
  },
  {
    "symbol": "3066.TWO",
    "name": "李洲",
    "sector": "光電業",
    "close": 25.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.13,
    "dog_ma200_bias": 0.025,
    "vr60": 1.75,
    "rs20": 0.87,
    "rs60": 0.9,
    "shares": 23529,
    "lots": 23,
    "odd_shares": 529,
    "ntd_at_risk": 39999.3,
    "position_cost": 597636.6,
    "constraint": "WEIGHT",
    "atr14": 0.85,
    "low_20d": 23.3,
    "ladder_minus1_pullback": 23.9,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.0
  },
  {
    "symbol": "5269.TW",
    "name": "祥碩",
    "sector": "半導體業",
    "close": 1495.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.5,
    "dog_ma200_bias": -0.023,
    "vr60": 1.63,
    "rs20": 0.51,
    "rs60": 0.6,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 26.47,
    "low_20d": 1388.2,
    "ladder_minus1_pullback": 1405.3,
    "ladder_4_base": 1345.5,
    "ladder_5_euphoria": 1943.5
  },
  {
    "symbol": "6125.TWO",
    "name": "廣運",
    "sector": "電機機械業",
    "close": 48.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.05,
    "dog_ma200_bias": 0.09,
    "vr60": 1.18,
    "rs20": 1.25,
    "rs60": 1.07,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1200000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 44.9,
    "ladder_minus1_pullback": 45.1,
    "ladder_4_base": 43.2,
    "ladder_5_euphoria": 62.4
  },
  {
    "symbol": "8163.TW",
    "name": "達方",
    "sector": "電腦及週邊設備業",
    "close": 28.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.12,
    "dog_ma200_bias": 0.064,
    "vr60": 1.32,
    "rs20": 1.04,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 722500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.0,
    "ladder_minus1_pullback": 27.2,
    "ladder_4_base": 26.0,
    "ladder_5_euphoria": 37.6
  },
  {
    "symbol": "6414.TW",
    "name": "樺漢",
    "sector": "電腦及週邊設備業",
    "close": 395.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.62,
    "dog_ma200_bias": 0.116,
    "vr60": 1.27,
    "rs20": 1.07,
    "rs60": 1.12,
    "shares": 2695,
    "lots": 2,
    "odd_shares": 695,
    "ntd_at_risk": 39993.8,
    "position_cost": 1065872.5,
    "constraint": "WEIGHT",
    "atr14": 7.42,
    "low_20d": 363.2,
    "ladder_minus1_pullback": 371.8,
    "ladder_4_base": 355.9,
    "ladder_5_euphoria": 514.1
  },
  {
    "symbol": "4749.TWO",
    "name": "新應材",
    "sector": "半導體業",
    "close": 724.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.8,
    "dog_ma200_bias": -0.002,
    "vr60": 1.75,
    "rs20": 1.09,
    "rs60": 1.0,
    "shares": 1277,
    "lots": 1,
    "odd_shares": 277,
    "ntd_at_risk": 39970.1,
    "position_cost": 924548.0,
    "constraint": "WEIGHT",
    "atr14": 15.65,
    "low_20d": 692.4,
    "ladder_minus1_pullback": 680.6,
    "ladder_4_base": 651.6,
    "ladder_5_euphoria": 941.2
  },
  {
    "symbol": "8215.TW",
    "name": "明基材",
    "sector": "光電業",
    "close": 27.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.21,
    "dog_ma200_bias": -0.006,
    "vr60": 1.68,
    "rs20": 0.86,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 690000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.9,
    "ladder_minus1_pullback": 25.9,
    "ladder_4_base": 24.8,
    "ladder_5_euphoria": 35.9
  },
  {
    "symbol": "6757.TW",
    "name": "台灣虎航",
    "sector": "航運業",
    "close": 53.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.43,
    "dog_ma200_bias": 0.069,
    "vr60": 1.1,
    "rs20": 0.96,
    "rs60": 1.1,
    "shares": 19230,
    "lots": 19,
    "odd_shares": 230,
    "ntd_at_risk": 39998.4,
    "position_cost": 1026882.0,
    "constraint": "WEIGHT",
    "atr14": 1.04,
    "low_20d": 49.2,
    "ladder_minus1_pullback": 50.2,
    "ladder_4_base": 48.1,
    "ladder_5_euphoria": 69.4
  },
  {
    "symbol": "2547.TW",
    "name": "日勝生",
    "sector": "建材營造業",
    "close": 9.86,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.12,
    "dog_ma200_bias": -0.017,
    "vr60": 1.72,
    "rs20": 0.91,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 246500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 9.3,
    "ladder_4_base": 8.9,
    "ladder_5_euphoria": 12.8
  },
  {
    "symbol": "3617.TW",
    "name": "碩天",
    "sector": "其他電子業",
    "close": 261.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.56,
    "dog_ma200_bias": 0.071,
    "vr60": 1.7,
    "rs20": 0.97,
    "rs60": 1.05,
    "shares": 2869,
    "lots": 2,
    "odd_shares": 869,
    "ntd_at_risk": 39993.86,
    "position_cost": 748809.0,
    "constraint": "WEIGHT",
    "atr14": 6.97,
    "low_20d": 245.8,
    "ladder_minus1_pullback": 245.3,
    "ladder_4_base": 234.9,
    "ladder_5_euphoria": 339.3
  },
  {
    "symbol": "6245.TWO",
    "name": "立端",
    "sector": "通信網路業",
    "close": 87.7,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.1,
    "dog_ma200_bias": -0.033,
    "vr60": 2.0,
    "rs20": 0.53,
    "rs60": 0.53,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.02,
    "low_20d": 82.9,
    "ladder_minus1_pullback": 82.4,
    "ladder_4_base": 78.9,
    "ladder_5_euphoria": 114.0
  },
  {
    "symbol": "3022.TW",
    "name": "威強電",
    "sector": "電腦及週邊設備業",
    "close": 88.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.5,
    "dog_ma200_bias": 0.053,
    "vr60": 1.46,
    "rs20": 0.94,
    "rs60": 0.88,
    "shares": 8000,
    "lots": 8,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 709600.0,
    "constraint": "WEIGHT",
    "atr14": 2.5,
    "low_20d": 84.7,
    "ladder_minus1_pullback": 83.4,
    "ladder_4_base": 79.8,
    "ladder_5_euphoria": 115.3
  },
  {
    "symbol": "2442.TW",
    "name": "新美齊",
    "sector": "建材營造業",
    "close": 13.75,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.05,
    "dog_ma200_bias": 0.108,
    "vr60": 1.35,
    "rs20": 1.22,
    "rs60": 1.24,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 343750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 12.9,
    "ladder_4_base": 12.4,
    "ladder_5_euphoria": 17.9
  },
  {
    "symbol": "2617.TW",
    "name": "台航",
    "sector": "航運業",
    "close": 32.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.25,
    "dog_ma200_bias": 0.061,
    "vr60": 1.75,
    "rs20": 0.82,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 808750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.5,
    "ladder_minus1_pullback": 30.4,
    "ladder_4_base": 29.1,
    "ladder_5_euphoria": 42.1
  },
  {
    "symbol": "6530.TWO",
    "name": "創威",
    "sector": "通信網路業",
    "close": 95.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.44,
    "dog_ma200_bias": -0.138,
    "vr60": 0.66,
    "rs20": 0.63,
    "rs60": 0.58,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.9,
    "low_20d": 89.8,
    "ladder_minus1_pullback": 89.8,
    "ladder_4_base": 86.0,
    "ladder_5_euphoria": 124.2
  },
  {
    "symbol": "6683.TWO",
    "name": "雍智科技",
    "sector": "半導體業",
    "close": 1295.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.31,
    "dog_ma200_bias": 0.077,
    "vr60": 1.86,
    "rs20": 0.94,
    "rs60": 0.83,
    "shares": 575,
    "lots": 0,
    "odd_shares": 575,
    "ntd_at_risk": 39974.0,
    "position_cost": 744625.0,
    "constraint": "WEIGHT",
    "atr14": 34.76,
    "low_20d": 1221.7,
    "ladder_minus1_pullback": 1217.3,
    "ladder_4_base": 1165.5,
    "ladder_5_euphoria": 1683.5
  },
  {
    "symbol": "3694.TW",
    "name": "海華",
    "sector": "通信網路業",
    "close": 48.2,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.05,
    "dog_ma200_bias": -0.241,
    "vr60": 0.87,
    "rs20": 0.23,
    "rs60": 0.32,
    "shares": 6410,
    "lots": 6,
    "odd_shares": 410,
    "ntd_at_risk": 19999.2,
    "position_cost": 308962.0,
    "constraint": "WEIGHT",
    "atr14": 1.56,
    "low_20d": 44.3,
    "ladder_minus1_pullback": 45.3,
    "ladder_4_base": 43.4,
    "ladder_5_euphoria": 62.7
  },
  {
    "symbol": "3491.TWO",
    "name": "昇達科",
    "sector": "通信網路業",
    "close": 1325.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.1,
    "dog_ma200_bias": 0.001,
    "vr60": 2.02,
    "rs20": 0.89,
    "rs60": 0.86,
    "shares": 822,
    "lots": 0,
    "odd_shares": 822,
    "ntd_at_risk": 39998.52,
    "position_cost": 1089150.0,
    "constraint": "WEIGHT",
    "atr14": 24.33,
    "low_20d": 1209.7,
    "ladder_minus1_pullback": 1245.5,
    "ladder_4_base": 1192.5,
    "ladder_5_euphoria": 1722.5
  },
  {
    "symbol": "9938.TW",
    "name": "百和",
    "sector": "其他業",
    "close": 39.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.11,
    "dog_ma200_bias": 0.025,
    "vr60": 1.24,
    "rs20": 1.14,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 978750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 35.7,
    "ladder_minus1_pullback": 36.8,
    "ladder_4_base": 35.2,
    "ladder_5_euphoria": 50.9
  },
  {
    "symbol": "6189.TW",
    "name": "豐藝",
    "sector": "電子通路業",
    "close": 50.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.67,
    "dog_ma200_bias": 0.05,
    "vr60": 1.67,
    "rs20": 1.08,
    "rs60": 0.99,
    "shares": 21978,
    "lots": 21,
    "odd_shares": 978,
    "ntd_at_risk": 39999.96,
    "position_cost": 1098900.0,
    "constraint": "WEIGHT",
    "atr14": 0.91,
    "low_20d": 45.4,
    "ladder_minus1_pullback": 47.0,
    "ladder_4_base": 45.0,
    "ladder_5_euphoria": 65.0
  },
  {
    "symbol": "6903.TWO",
    "name": "巨漢",
    "sector": "其他電子業",
    "close": 334.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.61,
    "dog_ma200_bias": -0.054,
    "vr60": 1.79,
    "rs20": 0.46,
    "rs60": 0.68,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 11.01,
    "low_20d": 320.1,
    "ladder_minus1_pullback": 314.4,
    "ladder_4_base": 301.1,
    "ladder_5_euphoria": 434.9
  },
  {
    "symbol": "3135.TW",
    "name": "凌航",
    "sector": "半導體業",
    "close": 143.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.2,
    "dog_ma200_bias": 0.045,
    "vr60": 1.95,
    "rs20": 0.96,
    "rs60": 0.83,
    "shares": 5882,
    "lots": 5,
    "odd_shares": 882,
    "ntd_at_risk": 39997.6,
    "position_cost": 841126.0,
    "constraint": "WEIGHT",
    "atr14": 3.4,
    "low_20d": 131.6,
    "ladder_minus1_pullback": 134.4,
    "ladder_4_base": 128.7,
    "ladder_5_euphoria": 185.9
  },
  {
    "symbol": "3591.TW",
    "name": "艾笛森",
    "sector": "光電業",
    "close": 26.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.1,
    "dog_ma200_bias": 0.169,
    "vr60": 1.36,
    "rs20": 1.09,
    "rs60": 1.25,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 666250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.4,
    "ladder_minus1_pullback": 25.1,
    "ladder_4_base": 24.0,
    "ladder_5_euphoria": 34.6
  },
  {
    "symbol": "3545.TW",
    "name": "敦泰",
    "sector": "半導體業",
    "close": 49.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.36,
    "dog_ma200_bias": 0.029,
    "vr60": 1.63,
    "rs20": 0.99,
    "rs60": 0.88,
    "shares": 17857,
    "lots": 17,
    "odd_shares": 857,
    "ntd_at_risk": 39999.68,
    "position_cost": 887492.9,
    "constraint": "WEIGHT",
    "atr14": 1.12,
    "low_20d": 46.6,
    "ladder_minus1_pullback": 46.7,
    "ladder_4_base": 44.7,
    "ladder_5_euphoria": 64.6
  },
  {
    "symbol": "2362.TW",
    "name": "藍天",
    "sector": "電腦及週邊設備業",
    "close": 48.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.12,
    "dog_ma200_bias": 0.077,
    "vr60": 1.15,
    "rs20": 0.98,
    "rs60": 1.16,
    "shares": 19607,
    "lots": 19,
    "odd_shares": 607,
    "ntd_at_risk": 39998.28,
    "position_cost": 945057.4,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 44.8,
    "ladder_minus1_pullback": 45.3,
    "ladder_4_base": 43.4,
    "ladder_5_euphoria": 62.7
  },
  {
    "symbol": "6909.TW",
    "name": "創控",
    "sector": "半導體業",
    "close": 45.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.37,
    "dog_ma200_bias": 0.001,
    "vr60": 1.37,
    "rs20": 0.89,
    "rs60": 0.95,
    "shares": 13422,
    "lots": 13,
    "odd_shares": 422,
    "ntd_at_risk": 39997.56,
    "position_cost": 612714.3,
    "constraint": "WEIGHT",
    "atr14": 1.49,
    "low_20d": 41.5,
    "ladder_minus1_pullback": 42.9,
    "ladder_4_base": 41.1,
    "ladder_5_euphoria": 59.3
  },
  {
    "symbol": "5434.TW",
    "name": "崇越",
    "sector": "電子通路業",
    "close": 576.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.29,
    "dog_ma200_bias": -0.183,
    "vr60": 0.68,
    "rs20": 0.58,
    "rs60": 0.6,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 19.53,
    "low_20d": 524.2,
    "ladder_minus1_pullback": 541.4,
    "ladder_4_base": 518.4,
    "ladder_5_euphoria": 748.8
  },
  {
    "symbol": "3229.TW",
    "name": "晟鈦",
    "sector": "電子零組件業",
    "close": 50.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.05,
    "dog_ma200_bias": 0.118,
    "vr60": 1.34,
    "rs20": 1.03,
    "rs60": 0.96,
    "shares": 12578,
    "lots": 12,
    "odd_shares": 578,
    "ntd_at_risk": 39998.04,
    "position_cost": 628900.0,
    "constraint": "WEIGHT",
    "atr14": 1.59,
    "low_20d": 46.3,
    "ladder_minus1_pullback": 47.0,
    "ladder_4_base": 45.0,
    "ladder_5_euphoria": 65.0
  },
  {
    "symbol": "1231.TW",
    "name": "聯華食",
    "sector": "食品工業",
    "close": 76.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": 0.16,
    "vr60": 1.06,
    "rs20": 0.97,
    "rs60": 1.13,
    "shares": 8474,
    "lots": 8,
    "odd_shares": 474,
    "ntd_at_risk": 39997.28,
    "position_cost": 649108.4,
    "constraint": "WEIGHT",
    "atr14": 2.36,
    "low_20d": 70.4,
    "ladder_minus1_pullback": 72.0,
    "ladder_4_base": 68.9,
    "ladder_5_euphoria": 99.6
  },
  {
    "symbol": "5386.TWO",
    "name": "青雲",
    "sector": "電腦及週邊設備業",
    "close": 248.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.33,
    "dog_ma200_bias": -0.004,
    "vr60": 1.77,
    "rs20": 0.77,
    "rs60": 0.9,
    "shares": 3401,
    "lots": 3,
    "odd_shares": 401,
    "ntd_at_risk": 39995.76,
    "position_cost": 843448.0,
    "constraint": "WEIGHT",
    "atr14": 5.88,
    "low_20d": 232.9,
    "ladder_minus1_pullback": 233.1,
    "ladder_4_base": 223.2,
    "ladder_5_euphoria": 322.4
  },
  {
    "symbol": "3563.TW",
    "name": "牧德",
    "sector": "光電業",
    "close": 692.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.23,
    "dog_ma200_bias": -0.014,
    "vr60": 1.43,
    "rs20": 0.82,
    "rs60": 1.04,
    "shares": 1295,
    "lots": 1,
    "odd_shares": 295,
    "ntd_at_risk": 39989.6,
    "position_cost": 896140.0,
    "constraint": "WEIGHT",
    "atr14": 15.44,
    "low_20d": 645.0,
    "ladder_minus1_pullback": 650.5,
    "ladder_4_base": 622.8,
    "ladder_5_euphoria": 899.6
  },
  {
    "symbol": "6873.TW",
    "name": "泓德能源",
    "sector": "綠能環保",
    "close": 65.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.68,
    "dog_ma200_bias": 0.04,
    "vr60": 1.71,
    "rs20": 0.76,
    "rs60": 0.95,
    "shares": 10256,
    "lots": 10,
    "odd_shares": 256,
    "ntd_at_risk": 39998.4,
    "position_cost": 674844.8,
    "constraint": "WEIGHT",
    "atr14": 1.95,
    "low_20d": 62.3,
    "ladder_minus1_pullback": 61.9,
    "ladder_4_base": 59.2,
    "ladder_5_euphoria": 85.5
  },
  {
    "symbol": "3631.TWO",
    "name": "晟楠",
    "sector": "電子零組件業",
    "close": 46.9,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.27,
    "dog_ma200_bias": -0.107,
    "vr60": 0.7,
    "rs20": 0.33,
    "rs60": 0.51,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.64,
    "low_20d": 42.4,
    "ladder_minus1_pullback": 44.1,
    "ladder_4_base": 42.2,
    "ladder_5_euphoria": 61.0
  },
  {
    "symbol": "2527.TW",
    "name": "宏璟",
    "sector": "建材營造業",
    "close": 49.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.38,
    "dog_ma200_bias": 0.079,
    "vr60": 1.98,
    "rs20": 0.82,
    "rs60": 0.99,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 1080428.3,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 45.5,
    "ladder_minus1_pullback": 46.7,
    "ladder_4_base": 44.7,
    "ladder_5_euphoria": 64.6
  },
  {
    "symbol": "2032.TW",
    "name": "新鋼",
    "sector": "鋼鐵工業",
    "close": 18.15,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.78,
    "dog_ma200_bias": -0.116,
    "vr60": 0.88,
    "rs20": 0.59,
    "rs60": 0.41,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 16.9,
    "ladder_minus1_pullback": 17.1,
    "ladder_4_base": 16.3,
    "ladder_5_euphoria": 23.6
  },
  {
    "symbol": "3056.TW",
    "name": "富華新",
    "sector": "建材營造業",
    "close": 13.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.25,
    "dog_ma200_bias": 0.046,
    "vr60": 1.44,
    "rs20": 1.04,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 340000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 12.8,
    "ladder_4_base": 12.2,
    "ladder_5_euphoria": 17.7
  },
  {
    "symbol": "6023.TWO",
    "name": "元大期",
    "sector": "金融保險業",
    "close": 82.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": 0.025,
    "vr60": 1.73,
    "rs20": 0.84,
    "rs60": 0.83,
    "shares": 12048,
    "lots": 12,
    "odd_shares": 48,
    "ntd_at_risk": 39999.36,
    "position_cost": 996369.6,
    "constraint": "WEIGHT",
    "atr14": 1.66,
    "low_20d": 74.8,
    "ladder_minus1_pullback": 77.7,
    "ladder_4_base": 74.4,
    "ladder_5_euphoria": 107.5
  },
  {
    "symbol": "9940.TW",
    "name": "信義",
    "sector": "其他業",
    "close": 20.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.4,
    "dog_ma200_bias": 0.073,
    "vr60": 1.17,
    "rs20": 1.29,
    "rs60": 1.1,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 500000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.9,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 26.0
  },
  {
    "symbol": "1723.TW",
    "name": "中碳",
    "sector": "化學工業",
    "close": 86.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.63,
    "dog_ma200_bias": 0.022,
    "vr60": 1.33,
    "rs20": 0.79,
    "rs60": 0.87,
    "shares": 14598,
    "lots": 14,
    "odd_shares": 598,
    "ntd_at_risk": 39998.52,
    "position_cost": 1262727.0,
    "constraint": "WEIGHT",
    "atr14": 1.37,
    "low_20d": 79.4,
    "ladder_minus1_pullback": 81.3,
    "ladder_4_base": 77.9,
    "ladder_5_euphoria": 112.5
  },
  {
    "symbol": "6284.TWO",
    "name": "佳邦",
    "sector": "電子零組件業",
    "close": 76.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.1,
    "dog_ma200_bias": 0.041,
    "vr60": 1.24,
    "rs20": 1.06,
    "rs60": 0.88,
    "shares": 9523,
    "lots": 9,
    "odd_shares": 523,
    "ntd_at_risk": 39996.6,
    "position_cost": 725652.6,
    "constraint": "WEIGHT",
    "atr14": 2.1,
    "low_20d": 68.7,
    "ladder_minus1_pullback": 71.6,
    "ladder_4_base": 68.6,
    "ladder_5_euphoria": 99.1
  },
  {
    "symbol": "5534.TW",
    "name": "長虹",
    "sector": "建材營造業",
    "close": 70.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.89,
    "dog_ma200_bias": -0.008,
    "vr60": 1.63,
    "rs20": 0.8,
    "rs60": 0.91,
    "shares": 8771,
    "lots": 8,
    "odd_shares": 771,
    "ntd_at_risk": 39995.76,
    "position_cost": 620986.8,
    "constraint": "WEIGHT",
    "atr14": 2.28,
    "low_20d": 64.0,
    "ladder_minus1_pullback": 66.6,
    "ladder_4_base": 63.7,
    "ladder_5_euphoria": 92.0
  },
  {
    "symbol": "1524.TW",
    "name": "耿鼎",
    "sector": "汽車工業",
    "close": 27.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.82,
    "dog_ma200_bias": 0.063,
    "vr60": 2.01,
    "rs20": 1.06,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 683750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.5,
    "ladder_minus1_pullback": 25.7,
    "ladder_4_base": 24.6,
    "ladder_5_euphoria": 35.6
  },
  {
    "symbol": "2015.TW",
    "name": "豐興",
    "sector": "鋼鐵工業",
    "close": 66.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.79,
    "dog_ma200_bias": 0.123,
    "vr60": 1.27,
    "rs20": 0.97,
    "rs60": 1.11,
    "shares": 9302,
    "lots": 9,
    "odd_shares": 302,
    "ntd_at_risk": 39998.6,
    "position_cost": 614862.2,
    "constraint": "WEIGHT",
    "atr14": 2.15,
    "low_20d": 60.5,
    "ladder_minus1_pullback": 62.1,
    "ladder_4_base": 59.5,
    "ladder_5_euphoria": 85.9
  },
  {
    "symbol": "6592.TW",
    "name": "和潤企業",
    "sector": "其他業",
    "close": 57.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.56,
    "dog_ma200_bias": 0.003,
    "vr60": 1.92,
    "rs20": 1.07,
    "rs60": 0.83,
    "shares": 21978,
    "lots": 21,
    "odd_shares": 978,
    "ntd_at_risk": 39999.96,
    "position_cost": 1270328.4,
    "constraint": "WEIGHT",
    "atr14": 0.91,
    "low_20d": 55.4,
    "ladder_minus1_pullback": 54.3,
    "ladder_4_base": 52.0,
    "ladder_5_euphoria": 75.1
  },
  {
    "symbol": "3485.TWO",
    "name": "敘豐",
    "sector": "電子零組件業",
    "close": 248.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.95,
    "dog_ma200_bias": 0.039,
    "vr60": 1.87,
    "rs20": 1.05,
    "rs60": 0.94,
    "shares": 4464,
    "lots": 4,
    "odd_shares": 464,
    "ntd_at_risk": 39997.44,
    "position_cost": 1107072.0,
    "constraint": "WEIGHT",
    "atr14": 4.48,
    "low_20d": 227.1,
    "ladder_minus1_pullback": 233.1,
    "ladder_4_base": 223.2,
    "ladder_5_euphoria": 322.4
  },
  {
    "symbol": "4949.TW",
    "name": "有成精密",
    "sector": "光電業",
    "close": 78.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.22,
    "dog_ma200_bias": -0.262,
    "vr60": 0.71,
    "rs20": 0.39,
    "rs60": 0.27,
    "shares": 7246,
    "lots": 7,
    "odd_shares": 246,
    "ntd_at_risk": 19998.96,
    "position_cost": 567361.8,
    "constraint": "WEIGHT",
    "atr14": 1.38,
    "low_20d": 73.2,
    "ladder_minus1_pullback": 73.6,
    "ladder_4_base": 70.5,
    "ladder_5_euphoria": 101.8
  },
  {
    "symbol": "1515.TW",
    "name": "力山",
    "sector": "電機機械業",
    "close": 28.75,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.47,
    "dog_ma200_bias": 0.237,
    "vr60": 2.48,
    "rs20": 1.29,
    "rs60": 1.17,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 26.5,
    "ladder_minus1_pullback": 27.0,
    "ladder_4_base": 25.9,
    "ladder_5_euphoria": 37.4
  },
  {
    "symbol": "2031.TW",
    "name": "新光鋼",
    "sector": "鋼鐵工業",
    "close": 46.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.6,
    "dog_ma200_bias": 0.059,
    "vr60": 1.72,
    "rs20": 0.8,
    "rs60": 0.7,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1173750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 43.5,
    "ladder_minus1_pullback": 44.1,
    "ladder_4_base": 42.3,
    "ladder_5_euphoria": 61.0
  },
  {
    "symbol": "6719.TW",
    "name": "力智",
    "sector": "半導體業",
    "close": 179.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.18,
    "dog_ma200_bias": -0.108,
    "vr60": 0.84,
    "rs20": 0.41,
    "rs60": 0.48,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.38,
    "low_20d": 165.2,
    "ladder_minus1_pullback": 168.3,
    "ladder_4_base": 161.1,
    "ladder_5_euphoria": 232.7
  },
  {
    "symbol": "2537.TW",
    "name": "聯上發",
    "sector": "建材營造業",
    "close": 10.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": -0.005,
    "vr60": 1.79,
    "rs20": 0.85,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 272500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.9,
    "ladder_minus1_pullback": 10.2,
    "ladder_4_base": 9.8,
    "ladder_5_euphoria": 14.2
  },
  {
    "symbol": "3088.TWO",
    "name": "艾訊",
    "sector": "電腦及週邊設備業",
    "close": 123.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.44,
    "dog_ma200_bias": -0.038,
    "vr60": 1.63,
    "rs20": 0.5,
    "rs60": 0.69,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.6,
    "low_20d": 111.8,
    "ladder_minus1_pullback": 116.1,
    "ladder_4_base": 111.2,
    "ladder_5_euphoria": 160.6
  },
  {
    "symbol": "5512.TWO",
    "name": "力麒",
    "sector": "建材營造業",
    "close": 7.58,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.2,
    "dog_ma200_bias": 0.11,
    "vr60": 1.52,
    "rs20": 1.14,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 189500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.0,
    "ladder_minus1_pullback": 7.1,
    "ladder_4_base": 6.8,
    "ladder_5_euphoria": 9.9
  },
  {
    "symbol": "3372.TWO",
    "name": "典範",
    "sector": "半導體業",
    "close": 15.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.06,
    "dog_ma200_bias": 0.035,
    "vr60": 1.43,
    "rs20": 0.87,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 385000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.0,
    "ladder_minus1_pullback": 14.5,
    "ladder_4_base": 13.9,
    "ladder_5_euphoria": 20.0
  },
  {
    "symbol": "6491.TW",
    "name": "晶碩",
    "sector": "生技醫療業",
    "close": 404.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.09,
    "dog_ma200_bias": 0.051,
    "vr60": 1.86,
    "rs20": 1.09,
    "rs60": 0.93,
    "shares": 3034,
    "lots": 3,
    "odd_shares": 34,
    "ntd_at_risk": 39988.12,
    "position_cost": 1227253.0,
    "constraint": "WEIGHT",
    "atr14": 6.59,
    "low_20d": 368.3,
    "ladder_minus1_pullback": 380.2,
    "ladder_4_base": 364.1,
    "ladder_5_euphoria": 525.9
  },
  {
    "symbol": "6667.TWO",
    "name": "信紘科",
    "sector": "其他電子業",
    "close": 270.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.52,
    "dog_ma200_bias": 0.055,
    "vr60": 1.6,
    "rs20": 1.03,
    "rs60": 0.76,
    "shares": 2503,
    "lots": 2,
    "odd_shares": 503,
    "ntd_at_risk": 39997.94,
    "position_cost": 675810.0,
    "constraint": "WEIGHT",
    "atr14": 7.99,
    "low_20d": 257.8,
    "ladder_minus1_pullback": 253.8,
    "ladder_4_base": 243.0,
    "ladder_5_euphoria": 351.0
  },
  {
    "symbol": "2425.TW",
    "name": "承啟",
    "sector": "電腦及週邊設備業",
    "close": 34.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.67,
    "dog_ma200_bias": 0.001,
    "vr60": 1.56,
    "rs20": 0.89,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 870000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 33.0,
    "ladder_minus1_pullback": 32.7,
    "ladder_4_base": 31.3,
    "ladder_5_euphoria": 45.2
  },
  {
    "symbol": "3630.TWO",
    "name": "新鉅科",
    "sector": "光電業",
    "close": 27.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.05,
    "dog_ma200_bias": 0.05,
    "vr60": 1.84,
    "rs20": 0.81,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 677500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.8,
    "ladder_minus1_pullback": 25.5,
    "ladder_4_base": 24.4,
    "ladder_5_euphoria": 35.2
  },
  {
    "symbol": "6510.TWO",
    "name": "精測",
    "sector": "半導體業",
    "close": 2905.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.05,
    "dog_ma200_bias": -0.019,
    "vr60": 1.28,
    "rs20": 0.81,
    "rs60": 1.02,
    "shares": 457,
    "lots": 0,
    "odd_shares": 457,
    "ntd_at_risk": 39996.64,
    "position_cost": 1327585.0,
    "constraint": "WEIGHT",
    "atr14": 43.76,
    "low_20d": 2741.1,
    "ladder_minus1_pullback": 2730.7,
    "ladder_4_base": 2614.5,
    "ladder_5_euphoria": 3776.5
  },
  {
    "symbol": "4303.TWO",
    "name": "信立",
    "sector": "塑膠工業",
    "close": 31.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.17,
    "dog_ma200_bias": 0.024,
    "vr60": 1.26,
    "rs20": 0.84,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 782500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.0,
    "ladder_minus1_pullback": 29.4,
    "ladder_4_base": 28.2,
    "ladder_5_euphoria": 40.7
  },
  {
    "symbol": "5410.TWO",
    "name": "國眾",
    "sector": "資訊服務業",
    "close": 32.65,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.4,
    "dog_ma200_bias": 0.188,
    "vr60": 1.98,
    "rs20": 1.49,
    "rs60": 1.31,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.86,
    "low_20d": 30.4,
    "ladder_minus1_pullback": 30.7,
    "ladder_4_base": 29.4,
    "ladder_5_euphoria": 42.4
  },
  {
    "symbol": "2540.TW",
    "name": "愛山林",
    "sector": "建材營造業",
    "close": 49.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.05,
    "dog_ma200_bias": 0.145,
    "vr60": 1.41,
    "rs20": 1.33,
    "rs60": 1.23,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 1186728.0,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 45.1,
    "ladder_minus1_pullback": 46.3,
    "ladder_4_base": 44.3,
    "ladder_5_euphoria": 64.0
  },
  {
    "symbol": "7792.TWO",
    "name": "安葆",
    "sector": "其他電子業",
    "close": 367.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": 0.044,
    "vr60": 1.6,
    "rs20": 0.83,
    "rs60": 0.93,
    "shares": 2028,
    "lots": 2,
    "odd_shares": 28,
    "ntd_at_risk": 39992.16,
    "position_cost": 745290.0,
    "constraint": "WEIGHT",
    "atr14": 9.86,
    "low_20d": 331.5,
    "ladder_minus1_pullback": 345.4,
    "ladder_4_base": 330.8,
    "ladder_5_euphoria": 477.8
  },
  {
    "symbol": "3479.TWO",
    "name": "安勤",
    "sector": "電腦及週邊設備業",
    "close": 131.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.18,
    "dog_ma200_bias": 0.06,
    "vr60": 1.46,
    "rs20": 0.76,
    "rs60": 0.91,
    "shares": 4962,
    "lots": 4,
    "odd_shares": 962,
    "ntd_at_risk": 39993.72,
    "position_cost": 650022.0,
    "constraint": "WEIGHT",
    "atr14": 4.03,
    "low_20d": 124.1,
    "ladder_minus1_pullback": 123.1,
    "ladder_4_base": 117.9,
    "ladder_5_euphoria": 170.3
  },
  {
    "symbol": "4541.TWO",
    "name": "晟田",
    "sector": "其他業",
    "close": 57.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.14,
    "dog_ma200_bias": 0.032,
    "vr60": 1.41,
    "rs20": 0.82,
    "rs60": 0.71,
    "shares": 21052,
    "lots": 21,
    "odd_shares": 52,
    "ntd_at_risk": 39998.8,
    "position_cost": 1199964.0,
    "constraint": "WEIGHT",
    "atr14": 0.95,
    "low_20d": 52.2,
    "ladder_minus1_pullback": 53.6,
    "ladder_4_base": 51.3,
    "ladder_5_euphoria": 74.1
  },
  {
    "symbol": "2850.TW",
    "name": "新產",
    "sector": "金融保險業",
    "close": 173.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.83,
    "dog_ma200_bias": 0.089,
    "vr60": 1.05,
    "rs20": 1.01,
    "rs60": 1.3,
    "shares": 3642,
    "lots": 3,
    "odd_shares": 642,
    "ntd_at_risk": 39989.16,
    "position_cost": 630066.0,
    "constraint": "WEIGHT",
    "atr14": 5.49,
    "low_20d": 159.4,
    "ladder_minus1_pullback": 162.6,
    "ladder_4_base": 155.7,
    "ladder_5_euphoria": 224.9
  },
  {
    "symbol": "1218.TW",
    "name": "泰山",
    "sector": "食品工業",
    "close": 14.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.4,
    "dog_ma200_bias": 0.058,
    "vr60": 1.52,
    "rs20": 0.91,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 363750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.3,
    "ladder_minus1_pullback": 13.7,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 18.9
  },
  {
    "symbol": "6869.TW",
    "name": "雲豹能源",
    "sector": "綠能環保",
    "close": 71.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.65,
    "dog_ma200_bias": 0.032,
    "vr60": 1.86,
    "rs20": 0.78,
    "rs60": 0.73,
    "shares": 17543,
    "lots": 17,
    "odd_shares": 543,
    "ntd_at_risk": 39998.04,
    "position_cost": 1247307.3,
    "constraint": "WEIGHT",
    "atr14": 1.14,
    "low_20d": 65.2,
    "ladder_minus1_pullback": 66.8,
    "ladder_4_base": 64.0,
    "ladder_5_euphoria": 92.4
  },
  {
    "symbol": "6126.TWO",
    "name": "信音",
    "sector": "電子零組件業",
    "close": 29.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.33,
    "dog_ma200_bias": 0.008,
    "vr60": 1.95,
    "rs20": 1.12,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 747500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.1,
    "ladder_minus1_pullback": 28.1,
    "ladder_4_base": 26.9,
    "ladder_5_euphoria": 38.9
  },
  {
    "symbol": "3338.TW",
    "name": "泰碩",
    "sector": "電子零組件業",
    "close": 66.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.21,
    "dog_ma200_bias": 0.076,
    "vr60": 1.45,
    "rs20": 0.99,
    "rs60": 0.77,
    "shares": 16000,
    "lots": 16,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1065600.0,
    "constraint": "WEIGHT",
    "atr14": 1.25,
    "low_20d": 60.4,
    "ladder_minus1_pullback": 62.6,
    "ladder_4_base": 59.9,
    "ladder_5_euphoria": 86.6
  },
  {
    "symbol": "1104.TW",
    "name": "環泥",
    "sector": "水泥工業",
    "close": 26.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.05,
    "dog_ma200_bias": 0.073,
    "vr60": 1.72,
    "rs20": 0.85,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 672500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.7,
    "ladder_minus1_pullback": 25.3,
    "ladder_4_base": 24.2,
    "ladder_5_euphoria": 35.0
  },
  {
    "symbol": "3540.TWO",
    "name": "曜越",
    "sector": "電腦及週邊設備業",
    "close": 25.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.41,
    "dog_ma200_bias": -0.009,
    "vr60": 1.27,
    "rs20": 0.87,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 625000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.1,
    "ladder_minus1_pullback": 23.5,
    "ladder_4_base": 22.5,
    "ladder_5_euphoria": 32.5
  },
  {
    "symbol": "8436.TWO",
    "name": "大江",
    "sector": "生技醫療業",
    "close": 100.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.05,
    "dog_ma200_bias": 0.06,
    "vr60": 2.06,
    "rs20": 1.1,
    "rs60": 0.98,
    "shares": 7194,
    "lots": 7,
    "odd_shares": 194,
    "ntd_at_risk": 39998.64,
    "position_cost": 719400.0,
    "constraint": "WEIGHT",
    "atr14": 2.78,
    "low_20d": 93.3,
    "ladder_minus1_pullback": 94.0,
    "ladder_4_base": 90.0,
    "ladder_5_euphoria": 130.0
  },
  {
    "symbol": "6781.TW",
    "name": "AES-KY",
    "sector": "電子零組件業",
    "close": 926.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.11,
    "dog_ma200_bias": 0.037,
    "vr60": 1.82,
    "rs20": 1.14,
    "rs60": 0.9,
    "shares": 682,
    "lots": 0,
    "odd_shares": 682,
    "ntd_at_risk": 39951.56,
    "position_cost": 631532.0,
    "constraint": "WEIGHT",
    "atr14": 29.29,
    "low_20d": 886.9,
    "ladder_minus1_pullback": 870.4,
    "ladder_4_base": 833.4,
    "ladder_5_euphoria": 1203.8
  },
  {
    "symbol": "1595.TWO",
    "name": "川寶",
    "sector": "半導體業",
    "close": 71.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.3,
    "dog_ma200_bias": 0.152,
    "vr60": 1.5,
    "rs20": 1.33,
    "rs60": 1.08,
    "shares": 12269,
    "lots": 12,
    "odd_shares": 269,
    "ntd_at_risk": 39996.94,
    "position_cost": 879687.3,
    "constraint": "WEIGHT",
    "atr14": 1.63,
    "low_20d": 66.5,
    "ladder_minus1_pullback": 67.4,
    "ladder_4_base": 64.5,
    "ladder_5_euphoria": 93.2
  },
  {
    "symbol": "6829.TWO",
    "name": "千附精密",
    "sector": "半導體業",
    "close": 190.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.05,
    "dog_ma200_bias": 0.026,
    "vr60": 1.73,
    "rs20": 0.76,
    "rs60": 0.74,
    "shares": 3623,
    "lots": 3,
    "odd_shares": 623,
    "ntd_at_risk": 39997.92,
    "position_cost": 688370.0,
    "constraint": "WEIGHT",
    "atr14": 5.52,
    "low_20d": 178.4,
    "ladder_minus1_pullback": 178.6,
    "ladder_4_base": 171.0,
    "ladder_5_euphoria": 247.0
  },
  {
    "symbol": "8454.TW",
    "name": "富邦媒",
    "sector": "數位雲端",
    "close": 250.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.41,
    "dog_ma200_bias": 0.068,
    "vr60": 1.43,
    "rs20": 1.35,
    "rs60": 1.17,
    "shares": 2587,
    "lots": 2,
    "odd_shares": 587,
    "ntd_at_risk": 39995.02,
    "position_cost": 646750.0,
    "constraint": "WEIGHT",
    "atr14": 7.73,
    "low_20d": 236.9,
    "ladder_minus1_pullback": 235.0,
    "ladder_4_base": 225.0,
    "ladder_5_euphoria": 325.0
  },
  {
    "symbol": "5013.TWO",
    "name": "強新",
    "sector": "鋼鐵工業",
    "close": 39.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.07,
    "dog_ma200_bias": 0.003,
    "vr60": 1.48,
    "rs20": 1.13,
    "rs60": 0.88,
    "shares": 20000,
    "lots": 20,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 796000.0,
    "constraint": "WEIGHT",
    "atr14": 1.0,
    "low_20d": 36.2,
    "ladder_minus1_pullback": 37.4,
    "ladder_4_base": 35.8,
    "ladder_5_euphoria": 51.7
  },
  {
    "symbol": "5905.TWO",
    "name": "南仁湖",
    "sector": "觀光餐旅",
    "close": 7.22,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.2,
    "dog_ma200_bias": -0.019,
    "vr60": 1.95,
    "rs20": 0.85,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 180500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 6.6,
    "ladder_minus1_pullback": 6.8,
    "ladder_4_base": 6.5,
    "ladder_5_euphoria": 9.4
  },
  {
    "symbol": "3047.TW",
    "name": "訊舟",
    "sector": "通信網路業",
    "close": 14.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.05,
    "dog_ma200_bias": 0.047,
    "vr60": 1.94,
    "rs20": 0.78,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 357500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.7,
    "ladder_minus1_pullback": 13.4,
    "ladder_4_base": 12.9,
    "ladder_5_euphoria": 18.6
  },
  {
    "symbol": "3705.TW",
    "name": "永信",
    "sector": "生技醫療業",
    "close": 61.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.67,
    "dog_ma200_bias": 0.117,
    "vr60": 1.26,
    "rs20": 1.31,
    "rs60": 1.01,
    "shares": 11627,
    "lots": 11,
    "odd_shares": 627,
    "ntd_at_risk": 39996.88,
    "position_cost": 709247.0,
    "constraint": "WEIGHT",
    "atr14": 1.72,
    "low_20d": 57.9,
    "ladder_minus1_pullback": 57.3,
    "ladder_4_base": 54.9,
    "ladder_5_euphoria": 79.3
  },
  {
    "symbol": "2211.TW",
    "name": "長榮鋼",
    "sector": "鋼鐵工業",
    "close": 79.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.2,
    "dog_ma200_bias": 0.075,
    "vr60": 1.81,
    "rs20": 1.11,
    "rs60": 0.87,
    "shares": 9433,
    "lots": 9,
    "odd_shares": 433,
    "ntd_at_risk": 39995.92,
    "position_cost": 748036.9,
    "constraint": "WEIGHT",
    "atr14": 2.12,
    "low_20d": 74.4,
    "ladder_minus1_pullback": 74.5,
    "ladder_4_base": 71.4,
    "ladder_5_euphoria": 103.1
  },
  {
    "symbol": "5522.TW",
    "name": "遠雄",
    "sector": "建材營造業",
    "close": 61.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.05,
    "dog_ma200_bias": -0.0,
    "vr60": 1.86,
    "rs20": 1.1,
    "rs60": 0.77,
    "shares": 12121,
    "lots": 12,
    "odd_shares": 121,
    "ntd_at_risk": 39999.3,
    "position_cost": 745441.5,
    "constraint": "WEIGHT",
    "atr14": 1.65,
    "low_20d": 58.9,
    "ladder_minus1_pullback": 57.8,
    "ladder_4_base": 55.4,
    "ladder_5_euphoria": 80.0
  },
  {
    "symbol": "8155.TWO",
    "name": "博智",
    "sector": "電子零組件業",
    "close": 304.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.22,
    "dog_ma200_bias": 0.0,
    "vr60": 1.42,
    "rs20": 1.0,
    "rs60": 0.75,
    "shares": 2383,
    "lots": 2,
    "odd_shares": 383,
    "ntd_at_risk": 39986.74,
    "position_cost": 724432.0,
    "constraint": "WEIGHT",
    "atr14": 8.39,
    "low_20d": 276.0,
    "ladder_minus1_pullback": 285.8,
    "ladder_4_base": 273.6,
    "ladder_5_euphoria": 395.2
  },
  {
    "symbol": "9802.TW",
    "name": "鈺齊-KY",
    "sector": "運動休閒",
    "close": 66.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.67,
    "dog_ma200_bias": -0.261,
    "vr60": 1.06,
    "rs20": 0.47,
    "rs60": 0.43,
    "shares": 6410,
    "lots": 6,
    "odd_shares": 410,
    "ntd_at_risk": 19999.2,
    "position_cost": 426265.0,
    "constraint": "WEIGHT",
    "atr14": 1.56,
    "low_20d": 62.5,
    "ladder_minus1_pullback": 62.5,
    "ladder_4_base": 59.9,
    "ladder_5_euphoria": 86.5
  },
  {
    "symbol": "9925.TW",
    "name": "新保",
    "sector": "其他業",
    "close": 39.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.8,
    "dog_ma200_bias": 0.056,
    "vr60": 1.69,
    "rs20": 0.77,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 990000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 35.8,
    "ladder_minus1_pullback": 37.2,
    "ladder_4_base": 35.6,
    "ladder_5_euphoria": 51.5
  },
  {
    "symbol": "2069.TW",
    "name": "運錩",
    "sector": "鋼鐵工業",
    "close": 23.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.25,
    "dog_ma200_bias": 0.042,
    "vr60": 1.64,
    "rs20": 1.14,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 596250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.6,
    "ladder_minus1_pullback": 22.4,
    "ladder_4_base": 21.5,
    "ladder_5_euphoria": 31.0
  },
  {
    "symbol": "6691.TW",
    "name": "洋基工程",
    "sector": "其他電子業",
    "close": 701.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.05,
    "dog_ma200_bias": 0.164,
    "vr60": 1.34,
    "rs20": 1.34,
    "rs60": 1.27,
    "shares": 914,
    "lots": 0,
    "odd_shares": 914,
    "ntd_at_risk": 39960.08,
    "position_cost": 640714.0,
    "constraint": "WEIGHT",
    "atr14": 21.86,
    "low_20d": 653.8,
    "ladder_minus1_pullback": 658.9,
    "ladder_4_base": 630.9,
    "ladder_5_euphoria": 911.3
  },
  {
    "symbol": "3322.TWO",
    "name": "建舜電",
    "sector": "電子零組件業",
    "close": 10.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.05,
    "dog_ma200_bias": 0.008,
    "vr60": 1.4,
    "rs20": 0.98,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 257500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.6,
    "ladder_minus1_pullback": 9.7,
    "ladder_4_base": 9.3,
    "ladder_5_euphoria": 13.4
  },
  {
    "symbol": "1582.TW",
    "name": "信錦",
    "sector": "電子零組件業",
    "close": 70.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.08,
    "dog_ma200_bias": 0.34,
    "vr60": 2.08,
    "rs20": 1.34,
    "rs60": 1.28,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.4,
    "low_20d": 65.6,
    "ladder_minus1_pullback": 65.8,
    "ladder_4_base": 63.0,
    "ladder_5_euphoria": 91.0
  },
  {
    "symbol": "5452.TWO",
    "name": "佶優",
    "sector": "其他電子業",
    "close": 28.15,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.15,
    "dog_ma200_bias": 0.142,
    "vr60": 1.15,
    "rs20": 1.34,
    "rs60": 1.18,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 703750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.5,
    "ladder_minus1_pullback": 26.5,
    "ladder_4_base": 25.3,
    "ladder_5_euphoria": 36.6
  },
  {
    "symbol": "1736.TW",
    "name": "喬山",
    "sector": "運動休閒",
    "close": 122.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.5,
    "dog_ma200_bias": 0.026,
    "vr60": 1.82,
    "rs20": 0.75,
    "rs60": 0.77,
    "shares": 5012,
    "lots": 5,
    "odd_shares": 12,
    "ntd_at_risk": 39995.76,
    "position_cost": 613970.0,
    "constraint": "WEIGHT",
    "atr14": 3.99,
    "low_20d": 112.0,
    "ladder_minus1_pullback": 115.1,
    "ladder_4_base": 110.2,
    "ladder_5_euphoria": 159.2
  },
  {
    "symbol": "3615.TWO",
    "name": "安可",
    "sector": "光電業",
    "close": 39.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.3,
    "dog_ma200_bias": 0.038,
    "vr60": 1.49,
    "rs20": 1.0,
    "rs60": 0.79,
    "shares": 20202,
    "lots": 20,
    "odd_shares": 202,
    "ntd_at_risk": 39999.96,
    "position_cost": 795958.8,
    "constraint": "WEIGHT",
    "atr14": 0.99,
    "low_20d": 36.8,
    "ladder_minus1_pullback": 37.0,
    "ladder_4_base": 35.5,
    "ladder_5_euphoria": 51.2
  },
  {
    "symbol": "4746.TW",
    "name": "台耀",
    "sector": "生技醫療業",
    "close": 47.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.46,
    "dog_ma200_bias": 0.035,
    "vr60": 1.41,
    "rs20": 0.94,
    "rs60": 0.91,
    "shares": 12269,
    "lots": 12,
    "odd_shares": 269,
    "ntd_at_risk": 39996.94,
    "position_cost": 586458.2,
    "constraint": "WEIGHT",
    "atr14": 1.63,
    "low_20d": 44.7,
    "ladder_minus1_pullback": 44.9,
    "ladder_4_base": 43.0,
    "ladder_5_euphoria": 62.1
  },
  {
    "symbol": "6104.TWO",
    "name": "創惟",
    "sector": "半導體業",
    "close": 85.9,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.07,
    "dog_ma200_bias": -0.043,
    "vr60": 1.75,
    "rs20": 0.47,
    "rs60": 0.7,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.17,
    "low_20d": 77.7,
    "ladder_minus1_pullback": 80.7,
    "ladder_4_base": 77.3,
    "ladder_5_euphoria": 111.7
  },
  {
    "symbol": "2258.TW",
    "name": "鴻華先進-創",
    "sector": "汽車工業",
    "close": 30.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.94,
    "dog_ma200_bias": 0.065,
    "vr60": 1.45,
    "rs20": 0.82,
    "rs60": 0.75,
    "shares": 18867,
    "lots": 18,
    "odd_shares": 867,
    "ntd_at_risk": 39998.04,
    "position_cost": 582990.3,
    "constraint": "WEIGHT",
    "atr14": 1.06,
    "low_20d": 27.9,
    "ladder_minus1_pullback": 29.0,
    "ladder_4_base": 27.8,
    "ladder_5_euphoria": 40.2
  },
  {
    "symbol": "6409.TW",
    "name": "旭隼",
    "sector": "其他電子業",
    "close": 896.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.52,
    "dog_ma200_bias": 0.295,
    "vr60": 1.83,
    "rs20": 1.18,
    "rs60": 1.19,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 30.87,
    "low_20d": 819.7,
    "ladder_minus1_pullback": 842.2,
    "ladder_4_base": 806.4,
    "ladder_5_euphoria": 1164.8
  },
  {
    "symbol": "6605.TW",
    "name": "帝寶",
    "sector": "汽車工業",
    "close": 137.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.67,
    "dog_ma200_bias": 0.023,
    "vr60": 1.54,
    "rs20": 0.81,
    "rs60": 1.04,
    "shares": 6711,
    "lots": 6,
    "odd_shares": 711,
    "ntd_at_risk": 39997.56,
    "position_cost": 922762.5,
    "constraint": "WEIGHT",
    "atr14": 2.98,
    "low_20d": 124.1,
    "ladder_minus1_pullback": 129.2,
    "ladder_4_base": 123.8,
    "ladder_5_euphoria": 178.8
  },
  {
    "symbol": "8415.TWO",
    "name": "大國鋼",
    "sector": "鋼鐵工業",
    "close": 37.15,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.35,
    "dog_ma200_bias": -0.065,
    "vr60": 2.03,
    "rs20": 0.46,
    "rs60": 0.62,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 34.0,
    "ladder_minus1_pullback": 34.9,
    "ladder_4_base": 33.4,
    "ladder_5_euphoria": 48.3
  },
  {
    "symbol": "6215.TW",
    "name": "和椿",
    "sector": "其他電子業",
    "close": 90.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.27,
    "dog_ma200_bias": 0.065,
    "vr60": 1.67,
    "rs20": 1.04,
    "rs60": 0.97,
    "shares": 9132,
    "lots": 9,
    "odd_shares": 132,
    "ntd_at_risk": 39998.16,
    "position_cost": 826446.0,
    "constraint": "WEIGHT",
    "atr14": 2.19,
    "low_20d": 86.0,
    "ladder_minus1_pullback": 85.1,
    "ladder_4_base": 81.5,
    "ladder_5_euphoria": 117.7
  },
  {
    "symbol": "6640.TWO",
    "name": "均華",
    "sector": "半導體業",
    "close": 1015.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.58,
    "dog_ma200_bias": 0.01,
    "vr60": 1.71,
    "rs20": 0.98,
    "rs60": 0.84,
    "shares": 1097,
    "lots": 1,
    "odd_shares": 97,
    "ntd_at_risk": 39974.68,
    "position_cost": 1113455.0,
    "constraint": "WEIGHT",
    "atr14": 18.22,
    "low_20d": 920.6,
    "ladder_minus1_pullback": 954.1,
    "ladder_4_base": 913.5,
    "ladder_5_euphoria": 1319.5
  },
  {
    "symbol": "2630.TW",
    "name": "亞航",
    "sector": "航運業",
    "close": 44.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": 0.318,
    "vr60": 1.66,
    "rs20": 1.43,
    "rs60": 1.27,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 41.6,
    "ladder_minus1_pullback": 41.4,
    "ladder_4_base": 39.6,
    "ladder_5_euphoria": 57.2
  },
  {
    "symbol": "4164.TW",
    "name": "承業醫",
    "sector": "生技醫療業",
    "close": 27.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.12,
    "dog_ma200_bias": 0.025,
    "vr60": 1.5,
    "rs20": 0.89,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 697500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.4,
    "ladder_minus1_pullback": 26.2,
    "ladder_4_base": 25.1,
    "ladder_5_euphoria": 36.3
  },
  {
    "symbol": "6477.TW",
    "name": "安集",
    "sector": "光電業",
    "close": 32.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.27,
    "dog_ma200_bias": 0.073,
    "vr60": 1.43,
    "rs20": 0.76,
    "rs60": 0.74,
    "shares": 19417,
    "lots": 19,
    "odd_shares": 417,
    "ntd_at_risk": 39999.02,
    "position_cost": 627169.1,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 30.3,
    "ladder_minus1_pullback": 30.4,
    "ladder_4_base": 29.1,
    "ladder_5_euphoria": 42.0
  },
  {
    "symbol": "3230.TWO",
    "name": "錦明",
    "sector": "光電業",
    "close": 26.3,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.5,
    "dog_ma200_bias": 0.007,
    "vr60": 2.17,
    "rs20": 0.47,
    "rs60": 0.65,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 24.5,
    "ladder_minus1_pullback": 24.7,
    "ladder_4_base": 23.7,
    "ladder_5_euphoria": 34.2
  },
  {
    "symbol": "6205.TW",
    "name": "詮欣",
    "sector": "電子零組件業",
    "close": 66.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.3,
    "dog_ma200_bias": -0.003,
    "vr60": 1.9,
    "rs20": 0.89,
    "rs60": 0.94,
    "shares": 10416,
    "lots": 10,
    "odd_shares": 416,
    "ntd_at_risk": 39997.44,
    "position_cost": 689539.2,
    "constraint": "WEIGHT",
    "atr14": 1.92,
    "low_20d": 59.9,
    "ladder_minus1_pullback": 62.2,
    "ladder_4_base": 59.6,
    "ladder_5_euphoria": 86.1
  },
  {
    "symbol": "6907.TWO",
    "name": "雅特力-KY",
    "sector": "半導體業",
    "close": 169.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": 0.118,
    "vr60": 1.49,
    "rs20": 1.31,
    "rs60": 1.05,
    "shares": 3745,
    "lots": 3,
    "odd_shares": 745,
    "ntd_at_risk": 39996.6,
    "position_cost": 632905.0,
    "constraint": "WEIGHT",
    "atr14": 5.34,
    "low_20d": 155.1,
    "ladder_minus1_pullback": 158.9,
    "ladder_4_base": 152.1,
    "ladder_5_euphoria": 219.7
  },
  {
    "symbol": "4772.TWO",
    "name": "台特化",
    "sector": "化學工業",
    "close": 260.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.2,
    "dog_ma200_bias": 0.094,
    "vr60": 1.43,
    "rs20": 1.01,
    "rs60": 0.97,
    "shares": 4535,
    "lots": 4,
    "odd_shares": 535,
    "ntd_at_risk": 39998.7,
    "position_cost": 1181367.5,
    "constraint": "WEIGHT",
    "atr14": 4.41,
    "low_20d": 248.1,
    "ladder_minus1_pullback": 244.9,
    "ladder_4_base": 234.5,
    "ladder_5_euphoria": 338.7
  },
  {
    "symbol": "3051.TW",
    "name": "力特",
    "sector": "光電業",
    "close": 21.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.23,
    "dog_ma200_bias": 0.157,
    "vr60": 1.25,
    "rs20": 1.2,
    "rs60": 1.13,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 530000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.4,
    "ladder_minus1_pullback": 19.9,
    "ladder_4_base": 19.1,
    "ladder_5_euphoria": 27.6
  },
  {
    "symbol": "6695.TW",
    "name": "芯鼎",
    "sector": "半導體業",
    "close": 48.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.35,
    "dog_ma200_bias": 0.065,
    "vr60": 1.26,
    "rs20": 0.81,
    "rs60": 0.78,
    "shares": 13157,
    "lots": 13,
    "odd_shares": 157,
    "ntd_at_risk": 39997.28,
    "position_cost": 636798.8,
    "constraint": "WEIGHT",
    "atr14": 1.52,
    "low_20d": 44.3,
    "ladder_minus1_pullback": 45.5,
    "ladder_4_base": 43.6,
    "ladder_5_euphoria": 62.9
  },
  {
    "symbol": "5536.TWO",
    "name": "聖暉*",
    "sector": "其他電子業",
    "close": 870.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.37,
    "dog_ma200_bias": -0.223,
    "vr60": 0.78,
    "rs20": 0.31,
    "rs60": 0.42,
    "shares": 502,
    "lots": 0,
    "odd_shares": 502,
    "ntd_at_risk": 19979.6,
    "position_cost": 436740.0,
    "constraint": "WEIGHT",
    "atr14": 19.9,
    "low_20d": 831.5,
    "ladder_minus1_pullback": 817.8,
    "ladder_4_base": 783.0,
    "ladder_5_euphoria": 1131.0
  },
  {
    "symbol": "6435.TWO",
    "name": "大中",
    "sector": "半導體業",
    "close": 229.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.45,
    "dog_ma200_bias": 0.024,
    "vr60": 1.98,
    "rs20": 0.9,
    "rs60": 0.91,
    "shares": 2928,
    "lots": 2,
    "odd_shares": 928,
    "ntd_at_risk": 39996.48,
    "position_cost": 670512.0,
    "constraint": "WEIGHT",
    "atr14": 6.83,
    "low_20d": 211.8,
    "ladder_minus1_pullback": 215.3,
    "ladder_4_base": 206.1,
    "ladder_5_euphoria": 297.7
  },
  {
    "symbol": "3691.TWO",
    "name": "碩禾",
    "sector": "光電業",
    "close": 97.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.17,
    "dog_ma200_bias": 0.176,
    "vr60": 1.3,
    "rs20": 1.02,
    "rs60": 0.91,
    "shares": 7547,
    "lots": 7,
    "odd_shares": 547,
    "ntd_at_risk": 39999.1,
    "position_cost": 735832.5,
    "constraint": "WEIGHT",
    "atr14": 2.65,
    "low_20d": 89.1,
    "ladder_minus1_pullback": 91.6,
    "ladder_4_base": 87.8,
    "ladder_5_euphoria": 126.8
  },
  {
    "symbol": "3709.TWO",
    "name": "鑫聯大投控",
    "sector": "電腦及週邊設備業",
    "close": 65.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.35,
    "dog_ma200_bias": 0.147,
    "vr60": 1.45,
    "rs20": 1.33,
    "rs60": 1.18,
    "shares": 13986,
    "lots": 13,
    "odd_shares": 986,
    "ntd_at_risk": 39999.96,
    "position_cost": 914684.4,
    "constraint": "WEIGHT",
    "atr14": 1.43,
    "low_20d": 59.6,
    "ladder_minus1_pullback": 61.5,
    "ladder_4_base": 58.9,
    "ladder_5_euphoria": 85.0
  },
  {
    "symbol": "3587.TWO",
    "name": "閎康",
    "sector": "其他電子業",
    "close": 226.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.05,
    "dog_ma200_bias": -0.012,
    "vr60": 1.35,
    "rs20": 0.79,
    "rs60": 0.72,
    "shares": 2945,
    "lots": 2,
    "odd_shares": 945,
    "ntd_at_risk": 39993.1,
    "position_cost": 665570.0,
    "constraint": "WEIGHT",
    "atr14": 6.79,
    "low_20d": 204.6,
    "ladder_minus1_pullback": 212.4,
    "ladder_4_base": 203.4,
    "ladder_5_euphoria": 293.8
  },
  {
    "symbol": "5234.TW",
    "name": "達興材料",
    "sector": "光電業",
    "close": 289.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.2,
    "dog_ma200_bias": 0.356,
    "vr60": 2.15,
    "rs20": 1.16,
    "rs60": 1.24,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.13,
    "low_20d": 274.2,
    "ladder_minus1_pullback": 271.7,
    "ladder_4_base": 260.1,
    "ladder_5_euphoria": 375.7
  },
  {
    "symbol": "5531.TW",
    "name": "鄉林",
    "sector": "建材營造業",
    "close": 6.74,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.95,
    "dog_ma200_bias": -0.012,
    "vr60": 1.44,
    "rs20": 0.81,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 168500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 6.3,
    "ladder_minus1_pullback": 6.3,
    "ladder_4_base": 6.1,
    "ladder_5_euphoria": 8.8
  },
  {
    "symbol": "6405.TW",
    "name": "悅城",
    "sector": "光電業",
    "close": 39.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.23,
    "dog_ma200_bias": 0.069,
    "vr60": 1.48,
    "rs20": 0.85,
    "rs60": 0.8,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 847821.0,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 36.8,
    "ladder_minus1_pullback": 36.7,
    "ladder_4_base": 35.1,
    "ladder_5_euphoria": 50.7
  },
  {
    "symbol": "3289.TWO",
    "name": "宜特",
    "sector": "其他電子業",
    "close": 134.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.29,
    "dog_ma200_bias": 0.135,
    "vr60": 1.13,
    "rs20": 1.29,
    "rs60": 0.91,
    "shares": 4728,
    "lots": 4,
    "odd_shares": 728,
    "ntd_at_risk": 39998.88,
    "position_cost": 635916.0,
    "constraint": "WEIGHT",
    "atr14": 4.23,
    "low_20d": 128.8,
    "ladder_minus1_pullback": 126.4,
    "ladder_4_base": 121.0,
    "ladder_5_euphoria": 174.8
  },
  {
    "symbol": "4510.TWO",
    "name": "高鋒",
    "sector": "電機機械業",
    "close": 40.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.24,
    "dog_ma200_bias": 0.14,
    "vr60": 1.57,
    "rs20": 1.08,
    "rs60": 1.09,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 851028.05,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 38.8,
    "ladder_minus1_pullback": 38.4,
    "ladder_4_base": 36.8,
    "ladder_5_euphoria": 53.1
  },
  {
    "symbol": "6206.TW",
    "name": "飛捷",
    "sector": "電腦及週邊設備業",
    "close": 135.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.8,
    "dog_ma200_bias": -0.105,
    "vr60": 0.89,
    "rs20": 0.31,
    "rs60": 0.34,
    "shares": 2336,
    "lots": 2,
    "odd_shares": 336,
    "ntd_at_risk": 19996.16,
    "position_cost": 315360.0,
    "constraint": "WEIGHT",
    "atr14": 4.28,
    "low_20d": 125.8,
    "ladder_minus1_pullback": 126.9,
    "ladder_4_base": 121.5,
    "ladder_5_euphoria": 175.5
  },
  {
    "symbol": "8076.TWO",
    "name": "伍豐",
    "sector": "電腦及週邊設備業",
    "close": 20.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.11,
    "dog_ma200_bias": 0.144,
    "vr60": 1.16,
    "rs20": 1.19,
    "rs60": 1.15,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 512500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.6,
    "ladder_minus1_pullback": 19.3,
    "ladder_4_base": 18.4,
    "ladder_5_euphoria": 26.7
  },
  {
    "symbol": "9934.TW",
    "name": "成霖",
    "sector": "居家生活",
    "close": 9.82,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.71,
    "dog_ma200_bias": 0.044,
    "vr60": 1.71,
    "rs20": 0.96,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 245500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.4,
    "ladder_minus1_pullback": 9.2,
    "ladder_4_base": 8.8,
    "ladder_5_euphoria": 12.8
  },
  {
    "symbol": "5321.TWO",
    "name": "美而快",
    "sector": "數位雲端",
    "close": 62.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.47,
    "dog_ma200_bias": 0.011,
    "vr60": 1.51,
    "rs20": 0.97,
    "rs60": 0.98,
    "shares": 12121,
    "lots": 12,
    "odd_shares": 121,
    "ntd_at_risk": 39999.3,
    "position_cost": 756350.4,
    "constraint": "WEIGHT",
    "atr14": 1.65,
    "low_20d": 58.5,
    "ladder_minus1_pullback": 58.7,
    "ladder_4_base": 56.2,
    "ladder_5_euphoria": 81.1
  },
  {
    "symbol": "4721.TWO",
    "name": "美琪瑪",
    "sector": "化學工業",
    "close": 76.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.05,
    "dog_ma200_bias": 0.024,
    "vr60": 1.53,
    "rs20": 0.85,
    "rs60": 0.81,
    "shares": 10526,
    "lots": 10,
    "odd_shares": 526,
    "ntd_at_risk": 39998.8,
    "position_cost": 809449.4,
    "constraint": "WEIGHT",
    "atr14": 1.9,
    "low_20d": 69.4,
    "ladder_minus1_pullback": 72.3,
    "ladder_4_base": 69.2,
    "ladder_5_euphoria": 100.0
  },
  {
    "symbol": "6944.TW",
    "name": "兆聯實業",
    "sector": "綠能環保",
    "close": 788.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.17,
    "dog_ma200_bias": 0.06,
    "vr60": 1.54,
    "rs20": 1.29,
    "rs60": 1.04,
    "shares": 834,
    "lots": 0,
    "odd_shares": 834,
    "ntd_at_risk": 39998.64,
    "position_cost": 657192.0,
    "constraint": "WEIGHT",
    "atr14": 23.98,
    "low_20d": 742.2,
    "ladder_minus1_pullback": 740.7,
    "ladder_4_base": 709.2,
    "ladder_5_euphoria": 1024.4
  },
  {
    "symbol": "6994.TW",
    "name": "富威電力",
    "sector": "綠能環保",
    "close": 27.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.05,
    "dog_ma200_bias": 0.116,
    "vr60": 1.05,
    "rs20": 1.32,
    "rs60": 1.28,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 680000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.1,
    "ladder_minus1_pullback": 25.6,
    "ladder_4_base": 24.5,
    "ladder_5_euphoria": 35.4
  },
  {
    "symbol": "4534.TWO",
    "name": "慶騰",
    "sector": "電機機械業",
    "close": 28.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.05,
    "dog_ma200_bias": 0.028,
    "vr60": 1.21,
    "rs20": 0.92,
    "rs60": 0.8,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 712500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.7,
    "ladder_minus1_pullback": 26.8,
    "ladder_4_base": 25.7,
    "ladder_5_euphoria": 37.1
  },
  {
    "symbol": "6225.TW",
    "name": "天瀚",
    "sector": "光電業",
    "close": 84.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.29,
    "dog_ma200_bias": 0.088,
    "vr60": 1.05,
    "rs20": 1.1,
    "rs60": 1.06,
    "shares": 10869,
    "lots": 10,
    "odd_shares": 869,
    "ntd_at_risk": 39997.92,
    "position_cost": 919517.4,
    "constraint": "WEIGHT",
    "atr14": 1.84,
    "low_20d": 78.5,
    "ladder_minus1_pullback": 79.5,
    "ladder_4_base": 76.1,
    "ladder_5_euphoria": 110.0
  },
  {
    "symbol": "5457.TWO",
    "name": "宣德",
    "sector": "電子零組件業",
    "close": 22.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.2,
    "dog_ma200_bias": 0.036,
    "vr60": 1.56,
    "rs20": 0.82,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 571250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.6,
    "ladder_minus1_pullback": 21.5,
    "ladder_4_base": 20.6,
    "ladder_5_euphoria": 29.7
  },
  {
    "symbol": "6412.TW",
    "name": "群電",
    "sector": "電子零組件業",
    "close": 74.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.6,
    "dog_ma200_bias": 0.019,
    "vr60": 1.54,
    "rs20": 0.86,
    "rs60": 0.85,
    "shares": 11904,
    "lots": 11,
    "odd_shares": 904,
    "ntd_at_risk": 39997.44,
    "position_cost": 883276.8,
    "constraint": "WEIGHT",
    "atr14": 1.68,
    "low_20d": 68.2,
    "ladder_minus1_pullback": 69.7,
    "ladder_4_base": 66.8,
    "ladder_5_euphoria": 96.5
  },
  {
    "symbol": "1773.TW",
    "name": "勝一",
    "sector": "化學工業",
    "close": 169.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.44,
    "dog_ma200_bias": 0.004,
    "vr60": 1.89,
    "rs20": 1.11,
    "rs60": 0.98,
    "shares": 5420,
    "lots": 5,
    "odd_shares": 420,
    "ntd_at_risk": 39999.6,
    "position_cost": 918690.0,
    "constraint": "WEIGHT",
    "atr14": 3.69,
    "low_20d": 153.2,
    "ladder_minus1_pullback": 159.3,
    "ladder_4_base": 152.6,
    "ladder_5_euphoria": 220.3
  },
  {
    "symbol": "6224.TW",
    "name": "聚鼎",
    "sector": "電子零組件業",
    "close": 73.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.46,
    "rs20": 1.05,
    "rs60": 0.98,
    "shares": 14388,
    "lots": 14,
    "odd_shares": 388,
    "ntd_at_risk": 39998.64,
    "position_cost": 1056079.2,
    "constraint": "WEIGHT",
    "atr14": 1.39,
    "low_20d": 66.9,
    "ladder_minus1_pullback": 69.0,
    "ladder_4_base": 66.1,
    "ladder_5_euphoria": 95.4
  },
  {
    "symbol": "1522.TW",
    "name": "堤維西",
    "sector": "汽車工業",
    "close": 26.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.5,
    "dog_ma200_bias": 0.021,
    "vr60": 1.97,
    "rs20": 0.82,
    "rs60": 0.8,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 671250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.7,
    "ladder_minus1_pullback": 25.2,
    "ladder_4_base": 24.2,
    "ladder_5_euphoria": 34.9
  },
  {
    "symbol": "2612.TW",
    "name": "中航",
    "sector": "航運業",
    "close": 60.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.38,
    "dog_ma200_bias": 0.044,
    "vr60": 1.76,
    "rs20": 0.86,
    "rs60": 0.92,
    "shares": 18867,
    "lots": 18,
    "odd_shares": 867,
    "ntd_at_risk": 39998.04,
    "position_cost": 1147113.6,
    "constraint": "WEIGHT",
    "atr14": 1.06,
    "low_20d": 56.6,
    "ladder_minus1_pullback": 57.2,
    "ladder_4_base": 54.7,
    "ladder_5_euphoria": 79.0
  },
  {
    "symbol": "4755.TW",
    "name": "三福化",
    "sector": "化學工業",
    "close": 123.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.08,
    "dog_ma200_bias": -0.001,
    "vr60": 1.22,
    "rs20": 0.77,
    "rs60": 0.89,
    "shares": 4962,
    "lots": 4,
    "odd_shares": 962,
    "ntd_at_risk": 39993.72,
    "position_cost": 610326.0,
    "constraint": "WEIGHT",
    "atr14": 4.03,
    "low_20d": 113.0,
    "ladder_minus1_pullback": 115.6,
    "ladder_4_base": 110.7,
    "ladder_5_euphoria": 159.9
  },
  {
    "symbol": "6743.TW",
    "name": "安普新",
    "sector": "其他電子業",
    "close": 32.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.95,
    "dog_ma200_bias": -0.001,
    "vr60": 1.29,
    "rs20": 0.86,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 812500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.6,
    "ladder_minus1_pullback": 30.5,
    "ladder_4_base": 29.2,
    "ladder_5_euphoria": 42.2
  },
  {
    "symbol": "2417.TW",
    "name": "圓剛",
    "sector": "電腦及週邊設備業",
    "close": 37.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.17,
    "dog_ma200_bias": 0.147,
    "vr60": 1.19,
    "rs20": 1.01,
    "rs60": 1.1,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 770821.0,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 35.1,
    "ladder_minus1_pullback": 34.8,
    "ladder_4_base": 33.3,
    "ladder_5_euphoria": 48.1
  },
  {
    "symbol": "3024.TW",
    "name": "憶聲",
    "sector": "光電業",
    "close": 13.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.05,
    "dog_ma200_bias": 0.014,
    "vr60": 1.48,
    "rs20": 1.07,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 341250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.8,
    "ladder_minus1_pullback": 12.8,
    "ladder_4_base": 12.3,
    "ladder_5_euphoria": 17.7
  },
  {
    "symbol": "5291.TWO",
    "name": "邑昇",
    "sector": "電子零組件業",
    "close": 57.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.1,
    "dog_ma200_bias": 0.026,
    "vr60": 1.91,
    "rs20": 0.88,
    "rs60": 1.0,
    "shares": 12903,
    "lots": 12,
    "odd_shares": 903,
    "ntd_at_risk": 39999.3,
    "position_cost": 741922.5,
    "constraint": "WEIGHT",
    "atr14": 1.55,
    "low_20d": 54.0,
    "ladder_minus1_pullback": 54.0,
    "ladder_4_base": 51.8,
    "ladder_5_euphoria": 74.8
  },
  {
    "symbol": "2511.TW",
    "name": "太子",
    "sector": "建材營造業",
    "close": 8.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.5,
    "dog_ma200_bias": 0.174,
    "vr60": 1.08,
    "rs20": 1.26,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 205000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.7,
    "ladder_minus1_pullback": 7.7,
    "ladder_4_base": 7.4,
    "ladder_5_euphoria": 10.7
  },
  {
    "symbol": "6913.TWO",
    "name": "鴻呈",
    "sector": "電子零組件業",
    "close": 135.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.25,
    "dog_ma200_bias": 0.116,
    "vr60": 1.17,
    "rs20": 1.29,
    "rs60": 1.23,
    "shares": 8771,
    "lots": 8,
    "odd_shares": 771,
    "ntd_at_risk": 39995.76,
    "position_cost": 1184085.0,
    "constraint": "WEIGHT",
    "atr14": 2.28,
    "low_20d": 123.7,
    "ladder_minus1_pullback": 126.9,
    "ladder_4_base": 121.5,
    "ladder_5_euphoria": 175.5
  },
  {
    "symbol": "4768.TWO",
    "name": "晶呈科技",
    "sector": "化學工業",
    "close": 345.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.16,
    "dog_ma200_bias": 0.003,
    "vr60": 1.41,
    "rs20": 0.67,
    "rs60": 0.54,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 8.15,
    "low_20d": 325.5,
    "ladder_minus1_pullback": 324.3,
    "ladder_4_base": 310.5,
    "ladder_5_euphoria": 448.5
  },
  {
    "symbol": "3294.TWO",
    "name": "英濟",
    "sector": "電子零組件業",
    "close": 30.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.07,
    "dog_ma200_bias": -0.2,
    "vr60": 0.98,
    "rs20": 0.21,
    "rs60": 0.35,
    "shares": 11627,
    "lots": 11,
    "odd_shares": 627,
    "ntd_at_risk": 19998.44,
    "position_cost": 348810.0,
    "constraint": "WEIGHT",
    "atr14": 0.86,
    "low_20d": 28.4,
    "ladder_minus1_pullback": 28.2,
    "ladder_4_base": 27.0,
    "ladder_5_euphoria": 39.0
  },
  {
    "symbol": "3032.TW",
    "name": "偉訓",
    "sector": "電子零組件業",
    "close": 73.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.2,
    "dog_ma200_bias": 0.284,
    "vr60": 2.58,
    "rs20": 1.32,
    "rs60": 1.34,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.33,
    "low_20d": 67.3,
    "ladder_minus1_pullback": 69.1,
    "ladder_4_base": 66.2,
    "ladder_5_euphoria": 95.5
  },
  {
    "symbol": "5381.TWO",
    "name": "光譜",
    "sector": "電機機械業",
    "close": 21.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.05,
    "dog_ma200_bias": 0.012,
    "vr60": 1.77,
    "rs20": 0.77,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 525000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.1,
    "ladder_minus1_pullback": 19.7,
    "ladder_4_base": 18.9,
    "ladder_5_euphoria": 27.3
  },
  {
    "symbol": "8074.TWO",
    "name": "鉅橡",
    "sector": "電子零組件業",
    "close": 53.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.05,
    "dog_ma200_bias": 0.032,
    "vr60": 1.43,
    "rs20": 1.01,
    "rs60": 0.77,
    "shares": 21052,
    "lots": 21,
    "odd_shares": 52,
    "ntd_at_risk": 39998.8,
    "position_cost": 1119966.4,
    "constraint": "WEIGHT",
    "atr14": 0.95,
    "low_20d": 48.0,
    "ladder_minus1_pullback": 50.0,
    "ladder_4_base": 47.9,
    "ladder_5_euphoria": 69.2
  },
  {
    "symbol": "1529.TW",
    "name": "樂事綠能",
    "sector": "電機機械業",
    "close": 15.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.14,
    "dog_ma200_bias": 0.069,
    "vr60": 1.98,
    "rs20": 0.84,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 376250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.1,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.6
  },
  {
    "symbol": "3581.TWO",
    "name": "博磊",
    "sector": "半導體業",
    "close": 100.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.08,
    "dog_ma200_bias": -0.111,
    "vr60": 0.71,
    "rs20": 0.36,
    "rs60": 0.45,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.66,
    "low_20d": 90.4,
    "ladder_minus1_pullback": 94.0,
    "ladder_4_base": 90.0,
    "ladder_5_euphoria": 130.0
  },
  {
    "symbol": "4923.TWO",
    "name": "力士",
    "sector": "半導體業",
    "close": 49.6,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.06,
    "dog_ma200_bias": -0.258,
    "vr60": 1.01,
    "rs20": 0.2,
    "rs60": 0.2,
    "shares": 8620,
    "lots": 8,
    "odd_shares": 620,
    "ntd_at_risk": 19998.4,
    "position_cost": 427552.0,
    "constraint": "WEIGHT",
    "atr14": 1.16,
    "low_20d": 47.5,
    "ladder_minus1_pullback": 46.6,
    "ladder_4_base": 44.6,
    "ladder_5_euphoria": 64.5
  },
  {
    "symbol": "6235.TW",
    "name": "華孚",
    "sector": "電腦及週邊設備業",
    "close": 35.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.14,
    "dog_ma200_bias": 0.028,
    "vr60": 1.74,
    "rs20": 0.9,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 887500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 32.7,
    "ladder_minus1_pullback": 33.4,
    "ladder_4_base": 31.9,
    "ladder_5_euphoria": 46.1
  },
  {
    "symbol": "2731.TW",
    "name": "雄獅",
    "sector": "觀光餐旅",
    "close": 143.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.67,
    "dog_ma200_bias": -0.004,
    "vr60": 1.28,
    "rs20": 1.0,
    "rs60": 1.03,
    "shares": 4395,
    "lots": 4,
    "odd_shares": 395,
    "ntd_at_risk": 39994.5,
    "position_cost": 630682.5,
    "constraint": "WEIGHT",
    "atr14": 4.55,
    "low_20d": 134.0,
    "ladder_minus1_pullback": 134.9,
    "ladder_4_base": 129.2,
    "ladder_5_euphoria": 186.6
  },
  {
    "symbol": "5464.TWO",
    "name": "霖宏",
    "sector": "電子零組件業",
    "close": 73.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.05,
    "dog_ma200_bias": 0.08,
    "vr60": 1.76,
    "rs20": 0.77,
    "rs60": 0.93,
    "shares": 14388,
    "lots": 14,
    "odd_shares": 388,
    "ntd_at_risk": 39998.64,
    "position_cost": 1061834.4,
    "constraint": "WEIGHT",
    "atr14": 1.39,
    "low_20d": 69.7,
    "ladder_minus1_pullback": 69.4,
    "ladder_4_base": 66.4,
    "ladder_5_euphoria": 95.9
  },
  {
    "symbol": "8147.TWO",
    "name": "正淩",
    "sector": "電子零組件業",
    "close": 132.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.05,
    "dog_ma200_bias": 0.05,
    "vr60": 1.91,
    "rs20": 0.8,
    "rs60": 0.78,
    "shares": 5988,
    "lots": 5,
    "odd_shares": 988,
    "ntd_at_risk": 39999.84,
    "position_cost": 790416.0,
    "constraint": "WEIGHT",
    "atr14": 3.34,
    "low_20d": 120.0,
    "ladder_minus1_pullback": 124.1,
    "ladder_4_base": 118.8,
    "ladder_5_euphoria": 171.6
  },
  {
    "symbol": "2723.TW",
    "name": "美食-KY",
    "sector": "觀光餐旅",
    "close": 82.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.77,
    "dog_ma200_bias": 0.078,
    "vr60": 1.91,
    "rs20": 1.05,
    "rs60": 0.98,
    "shares": 7782,
    "lots": 7,
    "odd_shares": 782,
    "ntd_at_risk": 39999.48,
    "position_cost": 644349.6,
    "constraint": "WEIGHT",
    "atr14": 2.57,
    "low_20d": 77.6,
    "ladder_minus1_pullback": 77.8,
    "ladder_4_base": 74.5,
    "ladder_5_euphoria": 107.6
  },
  {
    "symbol": "6670.TW",
    "name": "復盛應用",
    "sector": "運動休閒",
    "close": 274.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.63,
    "dog_ma200_bias": -0.139,
    "vr60": 0.67,
    "rs20": 0.54,
    "rs60": 0.48,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 8.28,
    "low_20d": 255.9,
    "ladder_minus1_pullback": 257.6,
    "ladder_4_base": 246.6,
    "ladder_5_euphoria": 356.2
  },
  {
    "symbol": "2025.TW",
    "name": "千興",
    "sector": "鋼鐵工業",
    "close": 13.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.33,
    "dog_ma200_bias": -0.007,
    "vr60": 2.01,
    "rs20": 0.94,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 340000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.8,
    "ladder_minus1_pullback": 12.8,
    "ladder_4_base": 12.2,
    "ladder_5_euphoria": 17.7
  },
  {
    "symbol": "6277.TW",
    "name": "宏正",
    "sector": "電腦及週邊設備業",
    "close": 83.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.95,
    "dog_ma200_bias": 0.009,
    "vr60": 1.83,
    "rs20": 0.83,
    "rs60": 0.77,
    "shares": 8888,
    "lots": 8,
    "odd_shares": 888,
    "ntd_at_risk": 39996.0,
    "position_cost": 737704.0,
    "constraint": "WEIGHT",
    "atr14": 2.25,
    "low_20d": 75.1,
    "ladder_minus1_pullback": 78.0,
    "ladder_4_base": 74.7,
    "ladder_5_euphoria": 107.9
  },
  {
    "symbol": "6590.TWO",
    "name": "普鴻",
    "sector": "資訊服務業",
    "close": 72.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.05,
    "dog_ma200_bias": 0.015,
    "vr60": 1.86,
    "rs20": 0.86,
    "rs60": 0.99,
    "shares": 13605,
    "lots": 13,
    "odd_shares": 605,
    "ntd_at_risk": 39998.7,
    "position_cost": 979560.0,
    "constraint": "WEIGHT",
    "atr14": 1.47,
    "low_20d": 67.4,
    "ladder_minus1_pullback": 67.7,
    "ladder_4_base": 64.8,
    "ladder_5_euphoria": 93.6
  },
  {
    "symbol": "2233.TW",
    "name": "宇隆",
    "sector": "汽車工業",
    "close": 154.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.05,
    "dog_ma200_bias": 0.011,
    "vr60": 1.8,
    "rs20": 0.42,
    "rs60": 0.5,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.59,
    "low_20d": 146.6,
    "ladder_minus1_pullback": 144.8,
    "ladder_4_base": 138.6,
    "ladder_5_euphoria": 200.2
  },
  {
    "symbol": "3323.TWO",
    "name": "加百裕",
    "sector": "電腦及週邊設備業",
    "close": 29.05,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.06,
    "dog_ma200_bias": -0.054,
    "vr60": 1.63,
    "rs20": 0.4,
    "rs60": 0.67,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 26.2,
    "ladder_minus1_pullback": 27.3,
    "ladder_4_base": 26.1,
    "ladder_5_euphoria": 37.8
  },
  {
    "symbol": "4564.TW",
    "name": "元翎",
    "sector": "電機機械業",
    "close": 15.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": -0.001,
    "vr60": 1.22,
    "rs20": 1.09,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 392500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.1,
    "ladder_minus1_pullback": 14.8,
    "ladder_4_base": 14.1,
    "ladder_5_euphoria": 20.4
  },
  {
    "symbol": "7856.TWO",
    "name": "漢測",
    "sector": "半導體業",
    "close": 3300.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.05,
    "dog_ma200_bias": 0.004,
    "vr60": 1.85,
    "rs20": 1.01,
    "rs60": 0.89,
    "shares": 372,
    "lots": 0,
    "odd_shares": 372,
    "ntd_at_risk": 39960.24,
    "position_cost": 1227600.0,
    "constraint": "WEIGHT",
    "atr14": 53.71,
    "low_20d": 3111.0,
    "ladder_minus1_pullback": 3102.0,
    "ladder_4_base": 2970.0,
    "ladder_5_euphoria": 4290.0
  },
  {
    "symbol": "6462.TWO",
    "name": "神盾",
    "sector": "半導體業",
    "close": 95.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.16,
    "dog_ma200_bias": 0.019,
    "vr60": 1.67,
    "rs20": 0.95,
    "rs60": 0.89,
    "shares": 6644,
    "lots": 6,
    "odd_shares": 644,
    "ntd_at_risk": 39996.88,
    "position_cost": 633837.6,
    "constraint": "WEIGHT",
    "atr14": 3.01,
    "low_20d": 88.2,
    "ladder_minus1_pullback": 89.7,
    "ladder_4_base": 85.9,
    "ladder_5_euphoria": 124.0
  },
  {
    "symbol": "2427.TW",
    "name": "三商電",
    "sector": "資訊服務業",
    "close": 22.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.5,
    "dog_ma200_bias": 0.041,
    "vr60": 1.49,
    "rs20": 1.01,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 555000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.8,
    "ladder_minus1_pullback": 20.9,
    "ladder_4_base": 20.0,
    "ladder_5_euphoria": 28.9
  },
  {
    "symbol": "3078.TWO",
    "name": "僑威",
    "sector": "電子零組件業",
    "close": 47.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.62,
    "dog_ma200_bias": 0.032,
    "vr60": 1.26,
    "rs20": 1.08,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1185000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 44.5,
    "ladder_minus1_pullback": 44.6,
    "ladder_4_base": 42.7,
    "ladder_5_euphoria": 61.6
  },
  {
    "symbol": "8091.TWO",
    "name": "翔名",
    "sector": "半導體業",
    "close": 210.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.22,
    "dog_ma200_bias": 0.067,
    "vr60": 1.38,
    "rs20": 0.94,
    "rs60": 0.73,
    "shares": 3976,
    "lots": 3,
    "odd_shares": 976,
    "ntd_at_risk": 39998.56,
    "position_cost": 836948.0,
    "constraint": "WEIGHT",
    "atr14": 5.03,
    "low_20d": 196.2,
    "ladder_minus1_pullback": 197.9,
    "ladder_4_base": 189.5,
    "ladder_5_euphoria": 273.7
  },
  {
    "symbol": "1732.TW",
    "name": "毛寶",
    "sector": "化學工業",
    "close": 26.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.05,
    "dog_ma200_bias": 0.037,
    "vr60": 1.95,
    "rs20": 1.01,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 663750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.4,
    "ladder_minus1_pullback": 25.0,
    "ladder_4_base": 23.9,
    "ladder_5_euphoria": 34.5
  },
  {
    "symbol": "6588.TWO",
    "name": "東典光電",
    "sector": "通信網路業",
    "close": 94.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.05,
    "dog_ma200_bias": 0.05,
    "vr60": 1.43,
    "rs20": 0.9,
    "rs60": 0.91,
    "shares": 10526,
    "lots": 10,
    "odd_shares": 526,
    "ntd_at_risk": 39998.8,
    "position_cost": 994707.0,
    "constraint": "WEIGHT",
    "atr14": 1.9,
    "low_20d": 90.5,
    "ladder_minus1_pullback": 88.8,
    "ladder_4_base": 85.0,
    "ladder_5_euphoria": 122.9
  },
  {
    "symbol": "3594.TWO",
    "name": "磐儀",
    "sector": "電腦及週邊設備業",
    "close": 45.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.19,
    "dog_ma200_bias": -0.013,
    "vr60": 2.04,
    "rs20": 0.83,
    "rs60": 0.87,
    "shares": 12658,
    "lots": 12,
    "odd_shares": 658,
    "ntd_at_risk": 39999.28,
    "position_cost": 581635.1,
    "constraint": "WEIGHT",
    "atr14": 1.58,
    "low_20d": 42.4,
    "ladder_minus1_pullback": 43.2,
    "ladder_4_base": 41.4,
    "ladder_5_euphoria": 59.7
  },
  {
    "symbol": "6243.TW",
    "name": "迅杰",
    "sector": "半導體業",
    "close": 36.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.15,
    "dog_ma200_bias": 0.069,
    "vr60": 1.27,
    "rs20": 1.07,
    "rs60": 0.72,
    "shares": 24691,
    "lots": 24,
    "odd_shares": 691,
    "ntd_at_risk": 39999.42,
    "position_cost": 909863.35,
    "constraint": "WEIGHT",
    "atr14": 0.81,
    "low_20d": 34.9,
    "ladder_minus1_pullback": 34.6,
    "ladder_4_base": 33.2,
    "ladder_5_euphoria": 47.9
  },
  {
    "symbol": "6425.TWO",
    "name": "易發",
    "sector": "電機機械業",
    "close": 73.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.4,
    "dog_ma200_bias": 0.036,
    "vr60": 2.04,
    "rs20": 0.92,
    "rs60": 0.83,
    "shares": 12121,
    "lots": 12,
    "odd_shares": 121,
    "ntd_at_risk": 39999.3,
    "position_cost": 890893.5,
    "constraint": "WEIGHT",
    "atr14": 1.65,
    "low_20d": 69.3,
    "ladder_minus1_pullback": 69.1,
    "ladder_4_base": 66.2,
    "ladder_5_euphoria": 95.5
  },
  {
    "symbol": "3176.TWO",
    "name": "基亞",
    "sector": "生技醫療業",
    "close": 34.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.2,
    "dog_ma200_bias": 0.051,
    "vr60": 1.94,
    "rs20": 0.86,
    "rs60": 0.71,
    "shares": 20202,
    "lots": 20,
    "odd_shares": 202,
    "ntd_at_risk": 39999.96,
    "position_cost": 702019.5,
    "constraint": "WEIGHT",
    "atr14": 0.99,
    "low_20d": 33.3,
    "ladder_minus1_pullback": 32.7,
    "ladder_4_base": 31.3,
    "ladder_5_euphoria": 45.2
  },
  {
    "symbol": "4513.TWO",
    "name": "福裕",
    "sector": "電機機械業",
    "close": 15.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.14,
    "dog_ma200_bias": -0.013,
    "vr60": 1.47,
    "rs20": 1.13,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 395000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.8,
    "ladder_minus1_pullback": 14.9,
    "ladder_4_base": 14.2,
    "ladder_5_euphoria": 20.5
  },
  {
    "symbol": "5607.TW",
    "name": "遠雄港",
    "sector": "航運業",
    "close": 53.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.38,
    "dog_ma200_bias": -0.01,
    "vr60": 1.85,
    "rs20": 0.96,
    "rs60": 0.77,
    "shares": 10810,
    "lots": 10,
    "odd_shares": 810,
    "ntd_at_risk": 39997.0,
    "position_cost": 572930.0,
    "constraint": "WEIGHT",
    "atr14": 1.85,
    "low_20d": 50.8,
    "ladder_minus1_pullback": 49.8,
    "ladder_4_base": 47.7,
    "ladder_5_euphoria": 68.9
  },
  {
    "symbol": "3437.TW",
    "name": "榮創",
    "sector": "光電業",
    "close": 19.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.27,
    "dog_ma200_bias": 0.033,
    "vr60": 1.42,
    "rs20": 1.0,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 493750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.4,
    "ladder_minus1_pullback": 18.6,
    "ladder_4_base": 17.8,
    "ladder_5_euphoria": 25.7
  },
  {
    "symbol": "6227.TWO",
    "name": "茂綸",
    "sector": "電子通路業",
    "close": 125.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.43,
    "dog_ma200_bias": -0.005,
    "vr60": 1.67,
    "rs20": 0.44,
    "rs60": 0.67,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 4.18,
    "low_20d": 119.0,
    "ladder_minus1_pullback": 117.5,
    "ladder_4_base": 112.5,
    "ladder_5_euphoria": 162.5
  },
  {
    "symbol": "2236.TW",
    "name": "百達-KY",
    "sector": "汽車工業",
    "close": 80.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.59,
    "dog_ma200_bias": 0.115,
    "vr60": 1.45,
    "rs20": 1.3,
    "rs60": 0.97,
    "shares": 7812,
    "lots": 7,
    "odd_shares": 812,
    "ntd_at_risk": 39997.44,
    "position_cost": 625741.2,
    "constraint": "WEIGHT",
    "atr14": 2.56,
    "low_20d": 76.4,
    "ladder_minus1_pullback": 75.3,
    "ladder_4_base": 72.1,
    "ladder_5_euphoria": 104.1
  },
  {
    "symbol": "6550.TW",
    "name": "北極星藥業-KY",
    "sector": "生技醫療業",
    "close": 15.9,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.2,
    "dog_ma200_bias": -0.175,
    "vr60": 0.74,
    "rs20": 0.42,
    "rs60": 0.41,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 14.7,
    "ladder_minus1_pullback": 14.9,
    "ladder_4_base": 14.3,
    "ladder_5_euphoria": 20.7
  },
  {
    "symbol": "6134.TWO",
    "name": "萬旭",
    "sector": "電子零組件業",
    "close": 25.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.1,
    "dog_ma200_bias": 0.08,
    "vr60": 1.6,
    "rs20": 0.89,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 646250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.6,
    "ladder_minus1_pullback": 24.3,
    "ladder_4_base": 23.3,
    "ladder_5_euphoria": 33.6
  },
  {
    "symbol": "8099.TWO",
    "name": "大世科",
    "sector": "資訊服務業",
    "close": 64.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.75,
    "dog_ma200_bias": -0.061,
    "vr60": 0.71,
    "rs20": 0.43,
    "rs60": 0.62,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.49,
    "low_20d": 60.6,
    "ladder_minus1_pullback": 60.9,
    "ladder_4_base": 58.3,
    "ladder_5_euphoria": 84.2
  },
  {
    "symbol": "3416.TW",
    "name": "融程電",
    "sector": "電腦及週邊設備業",
    "close": 183.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.89,
    "dog_ma200_bias": 0.266,
    "vr60": 2.33,
    "rs20": 1.36,
    "rs60": 1.3,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 4.28,
    "low_20d": 169.1,
    "ladder_minus1_pullback": 172.0,
    "ladder_4_base": 164.7,
    "ladder_5_euphoria": 237.9
  },
  {
    "symbol": "3138.TW",
    "name": "耀登",
    "sector": "通信網路業",
    "close": 97.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.05,
    "dog_ma200_bias": 0.057,
    "vr60": 2.03,
    "rs20": 0.85,
    "rs60": 1.04,
    "shares": 9259,
    "lots": 9,
    "odd_shares": 259,
    "ntd_at_risk": 39998.88,
    "position_cost": 899974.8,
    "constraint": "WEIGHT",
    "atr14": 2.16,
    "low_20d": 92.7,
    "ladder_minus1_pullback": 91.4,
    "ladder_4_base": 87.5,
    "ladder_5_euphoria": 126.4
  },
  {
    "symbol": "6664.TWO",
    "name": "群翊",
    "sector": "電子零組件業",
    "close": 345.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": 0.114,
    "vr60": 1.29,
    "rs20": 1.24,
    "rs60": 1.29,
    "shares": 1694,
    "lots": 1,
    "odd_shares": 694,
    "ntd_at_risk": 39978.4,
    "position_cost": 584430.0,
    "constraint": "WEIGHT",
    "atr14": 11.8,
    "low_20d": 315.4,
    "ladder_minus1_pullback": 324.3,
    "ladder_4_base": 310.5,
    "ladder_5_euphoria": 448.5
  },
  {
    "symbol": "6811.TWO",
    "name": "宏碁資訊",
    "sector": "數位雲端",
    "close": 274.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.06,
    "dog_ma200_bias": 0.131,
    "vr60": 1.36,
    "rs20": 1.35,
    "rs60": 1.02,
    "shares": 2836,
    "lots": 2,
    "odd_shares": 836,
    "ntd_at_risk": 39987.6,
    "position_cost": 777064.0,
    "constraint": "WEIGHT",
    "atr14": 7.05,
    "low_20d": 256.6,
    "ladder_minus1_pullback": 257.6,
    "ladder_4_base": 246.6,
    "ladder_5_euphoria": 356.2
  },
  {
    "symbol": "2538.TW",
    "name": "基泰",
    "sector": "建材營造業",
    "close": 8.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.06,
    "dog_ma200_bias": 0.096,
    "vr60": 1.18,
    "rs20": 1.29,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 217500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.1,
    "ladder_minus1_pullback": 8.2,
    "ladder_4_base": 7.8,
    "ladder_5_euphoria": 11.3
  },
  {
    "symbol": "1612.TW",
    "name": "宏泰",
    "sector": "電器電纜業",
    "close": 34.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.13,
    "dog_ma200_bias": 0.062,
    "vr60": 1.82,
    "rs20": 0.86,
    "rs60": 0.89,
    "shares": 24390,
    "lots": 24,
    "odd_shares": 390,
    "ntd_at_risk": 39999.6,
    "position_cost": 829260.0,
    "constraint": "WEIGHT",
    "atr14": 0.82,
    "low_20d": 30.8,
    "ladder_minus1_pullback": 32.0,
    "ladder_4_base": 30.6,
    "ladder_5_euphoria": 44.2
  },
  {
    "symbol": "6643.TWO",
    "name": "M31",
    "sector": "半導體業",
    "close": 441.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.05,
    "dog_ma200_bias": 0.036,
    "vr60": 2.03,
    "rs20": 0.81,
    "rs60": 0.71,
    "shares": 2183,
    "lots": 2,
    "odd_shares": 183,
    "ntd_at_risk": 39992.56,
    "position_cost": 962703.0,
    "constraint": "WEIGHT",
    "atr14": 9.16,
    "low_20d": 409.3,
    "ladder_minus1_pullback": 414.5,
    "ladder_4_base": 396.9,
    "ladder_5_euphoria": 573.3
  },
  {
    "symbol": "8071.TWO",
    "name": "能率網通",
    "sector": "電子零組件業",
    "close": 20.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.13,
    "dog_ma200_bias": 0.016,
    "vr60": 1.32,
    "rs20": 0.9,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 513750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.5,
    "ladder_minus1_pullback": 19.3,
    "ladder_4_base": 18.5,
    "ladder_5_euphoria": 26.7
  },
  {
    "symbol": "2420.TW",
    "name": "新巨",
    "sector": "電子零組件業",
    "close": 54.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.18,
    "dog_ma200_bias": 0.003,
    "vr60": 1.93,
    "rs20": 0.79,
    "rs60": 0.84,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 880643.4,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 50.3,
    "ladder_minus1_pullback": 51.3,
    "ladder_4_base": 49.1,
    "ladder_5_euphoria": 71.0
  },
  {
    "symbol": "8473.TW",
    "name": "山林水",
    "sector": "綠能環保",
    "close": 38.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.44,
    "dog_ma200_bias": 0.072,
    "vr60": 1.86,
    "rs20": 1.04,
    "rs60": 0.98,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 864009.95,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 35.4,
    "ladder_minus1_pullback": 36.1,
    "ladder_4_base": 34.6,
    "ladder_5_euphoria": 50.0
  },
  {
    "symbol": "1742.TWO",
    "name": "台蠟",
    "sector": "化學工業",
    "close": 19.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.47,
    "dog_ma200_bias": -0.003,
    "vr60": 1.94,
    "rs20": 1.03,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 483750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.9,
    "ladder_minus1_pullback": 18.2,
    "ladder_4_base": 17.4,
    "ladder_5_euphoria": 25.2
  },
  {
    "symbol": "6136.TW",
    "name": "富爾特",
    "sector": "通信網路業",
    "close": 26.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.27,
    "dog_ma200_bias": 0.071,
    "vr60": 1.74,
    "rs20": 0.87,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 672500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.6,
    "ladder_minus1_pullback": 25.3,
    "ladder_4_base": 24.2,
    "ladder_5_euphoria": 35.0
  },
  {
    "symbol": "3131.TWO",
    "name": "弘塑",
    "sector": "半導體業",
    "close": 2140.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.07,
    "dog_ma200_bias": -0.176,
    "vr60": 0.69,
    "rs20": 0.22,
    "rs60": 0.47,
    "shares": 217,
    "lots": 0,
    "odd_shares": 217,
    "ntd_at_risk": 19968.34,
    "position_cost": 464380.0,
    "constraint": "WEIGHT",
    "atr14": 46.01,
    "low_20d": 2022.3,
    "ladder_minus1_pullback": 2011.6,
    "ladder_4_base": 1926.0,
    "ladder_5_euphoria": 2782.0
  },
  {
    "symbol": "6138.TWO",
    "name": "茂達",
    "sector": "半導體業",
    "close": 255.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.05,
    "dog_ma200_bias": 0.062,
    "vr60": 1.57,
    "rs20": 1.1,
    "rs60": 1.0,
    "shares": 3210,
    "lots": 3,
    "odd_shares": 210,
    "ntd_at_risk": 39996.6,
    "position_cost": 818550.0,
    "constraint": "WEIGHT",
    "atr14": 6.23,
    "low_20d": 243.4,
    "ladder_minus1_pullback": 239.7,
    "ladder_4_base": 229.5,
    "ladder_5_euphoria": 331.5
  },
  {
    "symbol": "9917.TW",
    "name": "中保科",
    "sector": "其他業",
    "close": 108.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.95,
    "dog_ma200_bias": 0.225,
    "vr60": 2.25,
    "rs20": 1.36,
    "rs60": 1.1,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.22,
    "low_20d": 98.0,
    "ladder_minus1_pullback": 101.5,
    "ladder_4_base": 97.2,
    "ladder_5_euphoria": 140.4
  },
  {
    "symbol": "6237.TWO",
    "name": "驊訊",
    "sector": "半導體業",
    "close": 32.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.25,
    "dog_ma200_bias": 0.018,
    "vr60": 1.47,
    "rs20": 0.77,
    "rs60": 0.89,
    "shares": 23529,
    "lots": 23,
    "odd_shares": 529,
    "ntd_at_risk": 39999.3,
    "position_cost": 767045.4,
    "constraint": "WEIGHT",
    "atr14": 0.85,
    "low_20d": 29.6,
    "ladder_minus1_pullback": 30.6,
    "ladder_4_base": 29.3,
    "ladder_5_euphoria": 42.4
  },
  {
    "symbol": "5426.TWO",
    "name": "振發",
    "sector": "電腦及週邊設備業",
    "close": 27.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.05,
    "dog_ma200_bias": -0.005,
    "vr60": 1.65,
    "rs20": 0.84,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 683750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.7,
    "ladder_minus1_pullback": 25.7,
    "ladder_4_base": 24.6,
    "ladder_5_euphoria": 35.6
  },
  {
    "symbol": "6231.TWO",
    "name": "系微",
    "sector": "資訊服務業",
    "close": 234.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.23,
    "dog_ma200_bias": 0.053,
    "vr60": 1.55,
    "rs20": 0.93,
    "rs60": 0.91,
    "shares": 4608,
    "lots": 4,
    "odd_shares": 608,
    "ntd_at_risk": 39997.44,
    "position_cost": 1080576.0,
    "constraint": "WEIGHT",
    "atr14": 4.34,
    "low_20d": 211.9,
    "ladder_minus1_pullback": 220.4,
    "ladder_4_base": 211.1,
    "ladder_5_euphoria": 304.9
  },
  {
    "symbol": "7855.TW",
    "name": "和運租車",
    "sector": "其他業",
    "close": 41.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.13,
    "dog_ma200_bias": 0.03,
    "vr60": 1.4,
    "rs20": 0.87,
    "rs60": 0.84,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 934793.6,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 39.2,
    "ladder_minus1_pullback": 39.1,
    "ladder_4_base": 37.4,
    "ladder_5_euphoria": 54.1
  },
  {
    "symbol": "3058.TW",
    "name": "立德",
    "sector": "電子零組件業",
    "close": 8.29,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.05,
    "dog_ma200_bias": -0.256,
    "vr60": 0.69,
    "rs20": 0.43,
    "rs60": 0.2,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 103625.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.7,
    "ladder_minus1_pullback": 7.8,
    "ladder_4_base": 7.5,
    "ladder_5_euphoria": 10.8
  },
  {
    "symbol": "3050.TW",
    "name": "鈺德",
    "sector": "光電業",
    "close": 11.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.5,
    "dog_ma200_bias": -0.011,
    "vr60": 1.65,
    "rs20": 1.06,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 286250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.3,
    "ladder_minus1_pullback": 10.8,
    "ladder_4_base": 10.3,
    "ladder_5_euphoria": 14.9
  },
  {
    "symbol": "3021.TW",
    "name": "鴻名",
    "sector": "電子零組件業",
    "close": 25.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.27,
    "dog_ma200_bias": -0.007,
    "vr60": 1.7,
    "rs20": 0.95,
    "rs60": 0.93,
    "shares": 22727,
    "lots": 22,
    "odd_shares": 727,
    "ntd_at_risk": 39999.52,
    "position_cost": 579538.5,
    "constraint": "WEIGHT",
    "atr14": 0.88,
    "low_20d": 23.7,
    "ladder_minus1_pullback": 24.0,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.1
  },
  {
    "symbol": "4109.TWO",
    "name": "加捷生醫",
    "sector": "生技醫療業",
    "close": 11.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.5,
    "dog_ma200_bias": -0.0,
    "vr60": 1.75,
    "rs20": 1.04,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 280000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.5,
    "ladder_minus1_pullback": 10.5,
    "ladder_4_base": 10.1,
    "ladder_5_euphoria": 14.6
  },
  {
    "symbol": "1568.TW",
    "name": "倉佑",
    "sector": "汽車工業",
    "close": 30.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.13,
    "dog_ma200_bias": -0.013,
    "vr60": 1.9,
    "rs20": 0.88,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 750000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.0,
    "ladder_minus1_pullback": 28.2,
    "ladder_4_base": 27.0,
    "ladder_5_euphoria": 39.0
  },
  {
    "symbol": "1532.TW",
    "name": "勤美",
    "sector": "電機機械業",
    "close": 21.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.33,
    "dog_ma200_bias": -0.011,
    "vr60": 1.8,
    "rs20": 0.92,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 540000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.7,
    "ladder_minus1_pullback": 20.3,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 28.1
  },
  {
    "symbol": "5222.TW",
    "name": "全訊",
    "sector": "半導體業",
    "close": 97.8,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.35,
    "dog_ma200_bias": -0.048,
    "vr60": 1.83,
    "rs20": 0.41,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.16,
    "low_20d": 88.0,
    "ladder_minus1_pullback": 91.9,
    "ladder_4_base": 88.0,
    "ladder_5_euphoria": 127.1
  },
  {
    "symbol": "5258.TW",
    "name": "虹堡",
    "sector": "電腦及週邊設備業",
    "close": 45.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.19,
    "dog_ma200_bias": -0.169,
    "vr60": 1.1,
    "rs20": 0.38,
    "rs60": 0.23,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 566250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 42.4,
    "ladder_minus1_pullback": 42.6,
    "ladder_4_base": 40.8,
    "ladder_5_euphoria": 58.9
  },
  {
    "symbol": "6432.TWO",
    "name": "今展科",
    "sector": "電子零組件業",
    "close": 60.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.05,
    "dog_ma200_bias": 0.062,
    "vr60": 1.38,
    "rs20": 0.9,
    "rs60": 0.97,
    "shares": 11235,
    "lots": 11,
    "odd_shares": 235,
    "ntd_at_risk": 39996.6,
    "position_cost": 683088.0,
    "constraint": "WEIGHT",
    "atr14": 1.78,
    "low_20d": 57.9,
    "ladder_minus1_pullback": 57.2,
    "ladder_4_base": 54.7,
    "ladder_5_euphoria": 79.0
  },
  {
    "symbol": "5353.TWO",
    "name": "台林",
    "sector": "通信網路業",
    "close": 27.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.23,
    "dog_ma200_bias": -0.127,
    "vr60": 0.7,
    "rs20": 0.22,
    "rs60": 0.53,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 342500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.4,
    "ladder_minus1_pullback": 25.8,
    "ladder_4_base": 24.7,
    "ladder_5_euphoria": 35.6
  },
  {
    "symbol": "5488.TWO",
    "name": "松普",
    "sector": "電子零組件業",
    "close": 11.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.33,
    "dog_ma200_bias": 0.067,
    "vr60": 1.94,
    "rs20": 0.76,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 290000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.6,
    "ladder_minus1_pullback": 10.9,
    "ladder_4_base": 10.4,
    "ladder_5_euphoria": 15.1
  },
  {
    "symbol": "6788.TWO",
    "name": "華景電",
    "sector": "半導體業",
    "close": 358.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.39,
    "dog_ma200_bias": -0.009,
    "vr60": 1.61,
    "rs20": 0.76,
    "rs60": 0.77,
    "shares": 2430,
    "lots": 2,
    "odd_shares": 430,
    "ntd_at_risk": 39997.8,
    "position_cost": 871155.0,
    "constraint": "WEIGHT",
    "atr14": 8.23,
    "low_20d": 326.5,
    "ladder_minus1_pullback": 337.0,
    "ladder_4_base": 322.7,
    "ladder_5_euphoria": 466.1
  },
  {
    "symbol": "8088.TWO",
    "name": "品安",
    "sector": "半導體業",
    "close": 42.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.05,
    "dog_ma200_bias": 0.125,
    "vr60": 1.17,
    "rs20": 1.16,
    "rs60": 1.0,
    "shares": 21276,
    "lots": 21,
    "odd_shares": 276,
    "ntd_at_risk": 39998.88,
    "position_cost": 893592.0,
    "constraint": "WEIGHT",
    "atr14": 0.94,
    "low_20d": 38.5,
    "ladder_minus1_pullback": 39.5,
    "ladder_4_base": 37.8,
    "ladder_5_euphoria": 54.6
  },
  {
    "symbol": "2390.TW",
    "name": "云辰",
    "sector": "其他電子業",
    "close": 9.98,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.06,
    "dog_ma200_bias": 0.028,
    "vr60": 1.86,
    "rs20": 0.81,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 249500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.3,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 13.0
  },
  {
    "symbol": "1336.TWO",
    "name": "台翰",
    "sector": "電子零組件業",
    "close": 18.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.45,
    "dog_ma200_bias": -0.277,
    "vr60": 0.91,
    "rs20": 0.47,
    "rs60": 0.2,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 230000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.4,
    "ladder_minus1_pullback": 17.3,
    "ladder_4_base": 16.6,
    "ladder_5_euphoria": 23.9
  },
  {
    "symbol": "4129.TWO",
    "name": "聯合",
    "sector": "生技醫療業",
    "close": 77.1,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.05,
    "dog_ma200_bias": -0.16,
    "vr60": 0.88,
    "rs20": 0.52,
    "rs60": 0.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.32,
    "low_20d": 73.5,
    "ladder_minus1_pullback": 72.5,
    "ladder_4_base": 69.4,
    "ladder_5_euphoria": 100.2
  },
  {
    "symbol": "6180.TWO",
    "name": "橘子",
    "sector": "文化創意業",
    "close": 40.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.64,
    "dog_ma200_bias": 0.139,
    "vr60": 1.06,
    "rs20": 1.11,
    "rs60": 1.01,
    "shares": 21276,
    "lots": 21,
    "odd_shares": 276,
    "ntd_at_risk": 39998.88,
    "position_cost": 856359.0,
    "constraint": "WEIGHT",
    "atr14": 0.94,
    "low_20d": 37.8,
    "ladder_minus1_pullback": 37.8,
    "ladder_4_base": 36.2,
    "ladder_5_euphoria": 52.3
  },
  {
    "symbol": "2348.TW",
    "name": "海悅",
    "sector": "其他業",
    "close": 69.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.29,
    "dog_ma200_bias": 0.065,
    "vr60": 1.79,
    "rs20": 1.1,
    "rs60": 0.71,
    "shares": 9259,
    "lots": 9,
    "odd_shares": 259,
    "ntd_at_risk": 39998.88,
    "position_cost": 646278.2,
    "constraint": "WEIGHT",
    "atr14": 2.16,
    "low_20d": 66.1,
    "ladder_minus1_pullback": 65.6,
    "ladder_4_base": 62.8,
    "ladder_5_euphoria": 90.7
  },
  {
    "symbol": "3551.TWO",
    "name": "世禾",
    "sector": "綠能環保",
    "close": 188.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.4,
    "dog_ma200_bias": 0.067,
    "vr60": 1.78,
    "rs20": 0.84,
    "rs60": 0.83,
    "shares": 3824,
    "lots": 3,
    "odd_shares": 824,
    "ntd_at_risk": 39999.04,
    "position_cost": 718912.0,
    "constraint": "WEIGHT",
    "atr14": 5.23,
    "low_20d": 179.6,
    "ladder_minus1_pullback": 176.7,
    "ladder_4_base": 169.2,
    "ladder_5_euphoria": 244.4
  },
  {
    "symbol": "6279.TWO",
    "name": "胡連",
    "sector": "電子零組件業",
    "close": 115.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.2,
    "dog_ma200_bias": -0.063,
    "vr60": 0.63,
    "rs20": 0.41,
    "rs60": 0.65,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.87,
    "low_20d": 109.2,
    "ladder_minus1_pullback": 108.6,
    "ladder_4_base": 104.0,
    "ladder_5_euphoria": 150.2
  },
  {
    "symbol": "9927.TW",
    "name": "泰銘",
    "sector": "其他業",
    "close": 60.1,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.2,
    "dog_ma200_bias": -0.027,
    "vr60": 1.47,
    "rs20": 0.58,
    "rs60": 0.61,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.26,
    "low_20d": 56.1,
    "ladder_minus1_pullback": 56.5,
    "ladder_4_base": 54.1,
    "ladder_5_euphoria": 78.1
  },
  {
    "symbol": "6541.TW",
    "name": "泰福-KY",
    "sector": "生技醫療業",
    "close": 30.45,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.12,
    "dog_ma200_bias": -0.276,
    "vr60": 0.76,
    "rs20": 0.41,
    "rs60": 0.3,
    "shares": 11363,
    "lots": 11,
    "odd_shares": 363,
    "ntd_at_risk": 19998.88,
    "position_cost": 346003.35,
    "constraint": "WEIGHT",
    "atr14": 0.88,
    "low_20d": 28.2,
    "ladder_minus1_pullback": 28.6,
    "ladder_4_base": 27.4,
    "ladder_5_euphoria": 39.6
  },
  {
    "symbol": "6504.TW",
    "name": "南六",
    "sector": "其他業",
    "close": 39.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": -0.004,
    "vr60": 1.51,
    "rs20": 0.89,
    "rs60": 0.92,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 659140.3,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 37.6,
    "ladder_minus1_pullback": 37.2,
    "ladder_4_base": 35.6,
    "ladder_5_euphoria": 51.4
  },
  {
    "symbol": "6291.TWO",
    "name": "沛亨",
    "sector": "半導體業",
    "close": 409.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.51,
    "dog_ma200_bias": 0.004,
    "vr60": 2.08,
    "rs20": 0.95,
    "rs60": 0.98,
    "shares": 2515,
    "lots": 2,
    "odd_shares": 515,
    "ntd_at_risk": 39988.5,
    "position_cost": 1029892.5,
    "constraint": "WEIGHT",
    "atr14": 7.95,
    "low_20d": 384.0,
    "ladder_minus1_pullback": 384.9,
    "ladder_4_base": 368.6,
    "ladder_5_euphoria": 532.4
  },
  {
    "symbol": "6658.TW",
    "name": "聯策",
    "sector": "其他電子業",
    "close": 188.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.2,
    "dog_ma200_bias": -0.112,
    "vr60": 0.91,
    "rs20": 0.61,
    "rs60": 0.64,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.93,
    "low_20d": 170.3,
    "ladder_minus1_pullback": 177.2,
    "ladder_4_base": 169.7,
    "ladder_5_euphoria": 245.1
  },
  {
    "symbol": "7734.TWO",
    "name": "印能科技",
    "sector": "半導體業",
    "close": 2430.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.064,
    "vr60": 1.38,
    "rs20": 1.06,
    "rs60": 0.96,
    "shares": 297,
    "lots": 0,
    "odd_shares": 297,
    "ntd_at_risk": 39952.44,
    "position_cost": 721710.0,
    "constraint": "WEIGHT",
    "atr14": 67.26,
    "low_20d": 2263.5,
    "ladder_minus1_pullback": 2284.2,
    "ladder_4_base": 2187.0,
    "ladder_5_euphoria": 3159.0
  },
  {
    "symbol": "3217.TWO",
    "name": "優群",
    "sector": "電子零組件業",
    "close": 127.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.6,
    "dog_ma200_bias": 0.07,
    "vr60": 1.79,
    "rs20": 0.79,
    "rs60": 0.83,
    "shares": 7547,
    "lots": 7,
    "odd_shares": 547,
    "ntd_at_risk": 39999.1,
    "position_cost": 958469.0,
    "constraint": "WEIGHT",
    "atr14": 2.65,
    "low_20d": 116.3,
    "ladder_minus1_pullback": 119.4,
    "ladder_4_base": 114.3,
    "ladder_5_euphoria": 165.1
  },
  {
    "symbol": "1459.TW",
    "name": "聯發",
    "sector": "紡織纖維業",
    "close": 18.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.6,
    "dog_ma200_bias": 0.076,
    "vr60": 1.75,
    "rs20": 1.0,
    "rs60": 0.78,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 453750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.1,
    "ladder_minus1_pullback": 17.1,
    "ladder_4_base": 16.3,
    "ladder_5_euphoria": 23.6
  },
  {
    "symbol": "6204.TWO",
    "name": "艾華",
    "sector": "電子零組件業",
    "close": 110.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.14,
    "dog_ma200_bias": 0.004,
    "vr60": 1.34,
    "rs20": 1.14,
    "rs60": 1.02,
    "shares": 6535,
    "lots": 6,
    "odd_shares": 535,
    "ntd_at_risk": 39994.2,
    "position_cost": 722117.5,
    "constraint": "WEIGHT",
    "atr14": 3.06,
    "low_20d": 105.9,
    "ladder_minus1_pullback": 103.9,
    "ladder_4_base": 99.5,
    "ladder_5_euphoria": 143.7
  },
  {
    "symbol": "2852.TW",
    "name": "第一保",
    "sector": "金融保險業",
    "close": 28.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.33,
    "dog_ma200_bias": 0.013,
    "vr60": 1.69,
    "rs20": 0.83,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 702500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.0,
    "ladder_minus1_pullback": 26.4,
    "ladder_4_base": 25.3,
    "ladder_5_euphoria": 36.5
  },
  {
    "symbol": "1103.TW",
    "name": "嘉泥",
    "sector": "水泥工業",
    "close": 13.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.33,
    "dog_ma200_bias": 0.034,
    "vr60": 1.92,
    "rs20": 1.1,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 331250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.1,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 11.9,
    "ladder_5_euphoria": 17.2
  },
  {
    "symbol": "6185.TWO",
    "name": "幃翔",
    "sector": "電子零組件業",
    "close": 13.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.33,
    "dog_ma200_bias": 0.051,
    "vr60": 1.67,
    "rs20": 0.8,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 326250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.0,
    "ladder_minus1_pullback": 12.3,
    "ladder_4_base": 11.7,
    "ladder_5_euphoria": 17.0
  },
  {
    "symbol": "2516.TW",
    "name": "新建",
    "sector": "建材營造業",
    "close": 15.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.5,
    "dog_ma200_bias": 0.177,
    "vr60": 1.14,
    "rs20": 1.32,
    "rs60": 1.27,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 385000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.6,
    "ladder_minus1_pullback": 14.5,
    "ladder_4_base": 13.9,
    "ladder_5_euphoria": 20.0
  },
  {
    "symbol": "1584.TWO",
    "name": "精剛",
    "sector": "其他業",
    "close": 17.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.25,
    "dog_ma200_bias": 0.098,
    "vr60": 1.38,
    "rs20": 1.33,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 446250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.7,
    "ladder_minus1_pullback": 16.8,
    "ladder_4_base": 16.1,
    "ladder_5_euphoria": 23.2
  },
  {
    "symbol": "8084.TWO",
    "name": "巨虹",
    "sector": "電子通路業",
    "close": 13.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.1,
    "dog_ma200_bias": 0.012,
    "vr60": 1.99,
    "rs20": 1.04,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 336250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.8,
    "ladder_minus1_pullback": 12.6,
    "ladder_4_base": 12.1,
    "ladder_5_euphoria": 17.5
  },
  {
    "symbol": "2072.TW",
    "name": "世紀風電",
    "sector": "綠能環保",
    "close": 127.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.22,
    "dog_ma200_bias": 0.068,
    "vr60": 1.57,
    "rs20": 0.91,
    "rs60": 0.86,
    "shares": 8474,
    "lots": 8,
    "odd_shares": 474,
    "ntd_at_risk": 39997.28,
    "position_cost": 1080435.0,
    "constraint": "WEIGHT",
    "atr14": 2.36,
    "low_20d": 115.5,
    "ladder_minus1_pullback": 119.8,
    "ladder_4_base": 114.8,
    "ladder_5_euphoria": 165.8
  },
  {
    "symbol": "3268.TWO",
    "name": "海德威",
    "sector": "半導體業",
    "close": 26.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.5,
    "dog_ma200_bias": 0.073,
    "vr60": 2.0,
    "rs20": 1.12,
    "rs60": 0.8,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 586493.1,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 24.5,
    "ladder_minus1_pullback": 24.5,
    "ladder_4_base": 23.5,
    "ladder_5_euphoria": 33.9
  },
  {
    "symbol": "8011.TW",
    "name": "台通",
    "sector": "通信網路業",
    "close": 16.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.22,
    "dog_ma200_bias": 0.058,
    "vr60": 1.3,
    "rs20": 0.82,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 403750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.2,
    "ladder_minus1_pullback": 15.2,
    "ladder_4_base": 14.5,
    "ladder_5_euphoria": 21.0
  },
  {
    "symbol": "3515.TW",
    "name": "華擎",
    "sector": "電腦及週邊設備業",
    "close": 221.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.2,
    "dog_ma200_bias": 0.041,
    "vr60": 1.44,
    "rs20": 0.98,
    "rs60": 0.78,
    "shares": 2932,
    "lots": 2,
    "odd_shares": 932,
    "ntd_at_risk": 39992.48,
    "position_cost": 649438.0,
    "constraint": "WEIGHT",
    "atr14": 6.82,
    "low_20d": 204.0,
    "ladder_minus1_pullback": 208.2,
    "ladder_4_base": 199.3,
    "ladder_5_euphoria": 287.9
  },
  {
    "symbol": "6186.TWO",
    "name": "新潤",
    "sector": "建材營造業",
    "close": 29.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.29,
    "dog_ma200_bias": 0.003,
    "vr60": 1.82,
    "rs20": 0.89,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 725000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.3,
    "ladder_minus1_pullback": 27.3,
    "ladder_4_base": 26.1,
    "ladder_5_euphoria": 37.7
  },
  {
    "symbol": "2461.TW",
    "name": "光群雷",
    "sector": "其他電子業",
    "close": 16.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.67,
    "dog_ma200_bias": 0.028,
    "vr60": 1.65,
    "rs20": 0.99,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 420000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.3,
    "ladder_minus1_pullback": 15.8,
    "ladder_4_base": 15.1,
    "ladder_5_euphoria": 21.8
  },
  {
    "symbol": "3623.TWO",
    "name": "富晶通",
    "sector": "光電業",
    "close": 25.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.13,
    "dog_ma200_bias": 0.017,
    "vr60": 1.97,
    "rs20": 0.95,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 637500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.1,
    "ladder_minus1_pullback": 24.0,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.1
  },
  {
    "symbol": "3588.TW",
    "name": "通嘉",
    "sector": "半導體業",
    "close": 50.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.15,
    "dog_ma200_bias": -0.001,
    "vr60": 1.23,
    "rs20": 1.06,
    "rs60": 0.71,
    "shares": 14084,
    "lots": 14,
    "odd_shares": 84,
    "ntd_at_risk": 39998.56,
    "position_cost": 707016.8,
    "constraint": "WEIGHT",
    "atr14": 1.42,
    "low_20d": 47.0,
    "ladder_minus1_pullback": 47.2,
    "ladder_4_base": 45.2,
    "ladder_5_euphoria": 65.3
  },
  {
    "symbol": "2109.TW",
    "name": "華豐",
    "sector": "橡膠工業",
    "close": 14.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": 0.092,
    "vr60": 1.3,
    "rs20": 1.25,
    "rs60": 1.3,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 356250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.6,
    "ladder_minus1_pullback": 13.4,
    "ladder_4_base": 12.8,
    "ladder_5_euphoria": 18.5
  },
  {
    "symbol": "3071.TWO",
    "name": "協禧",
    "sector": "電腦及週邊設備業",
    "close": 21.95,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.5,
    "dog_ma200_bias": -0.144,
    "vr60": 0.68,
    "rs20": 0.57,
    "rs60": 0.54,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 274375.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.1,
    "ladder_minus1_pullback": 20.6,
    "ladder_4_base": 19.8,
    "ladder_5_euphoria": 28.5
  },
  {
    "symbol": "6712.TWO",
    "name": "長聖",
    "sector": "生技醫療業",
    "close": 155.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.29,
    "dog_ma200_bias": 0.029,
    "vr60": 1.49,
    "rs20": 0.93,
    "rs60": 0.79,
    "shares": 3752,
    "lots": 3,
    "odd_shares": 752,
    "ntd_at_risk": 39996.32,
    "position_cost": 581560.0,
    "constraint": "WEIGHT",
    "atr14": 5.33,
    "low_20d": 148.3,
    "ladder_minus1_pullback": 145.7,
    "ladder_4_base": 139.5,
    "ladder_5_euphoria": 201.5
  },
  {
    "symbol": "4571.TW",
    "name": "鈞興-KY",
    "sector": "電機機械業",
    "close": 161.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.88,
    "dog_ma200_bias": 0.02,
    "vr60": 1.24,
    "rs20": 1.04,
    "rs60": 0.83,
    "shares": 6230,
    "lots": 6,
    "odd_shares": 230,
    "ntd_at_risk": 39996.6,
    "position_cost": 1003030.0,
    "constraint": "WEIGHT",
    "atr14": 3.21,
    "low_20d": 152.1,
    "ladder_minus1_pullback": 151.3,
    "ladder_4_base": 144.9,
    "ladder_5_euphoria": 209.3
  },
  {
    "symbol": "5011.TWO",
    "name": "久陽",
    "sector": "鋼鐵工業",
    "close": 21.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.56,
    "dog_ma200_bias": 0.011,
    "vr60": 1.75,
    "rs20": 1.05,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 532500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.6,
    "ladder_minus1_pullback": 20.0,
    "ladder_4_base": 19.2,
    "ladder_5_euphoria": 27.7
  },
  {
    "symbol": "7751.TWO",
    "name": "竑騰",
    "sector": "半導體業",
    "close": 1560.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.39,
    "dog_ma200_bias": 0.033,
    "vr60": 1.99,
    "rs20": 1.06,
    "rs60": 0.88,
    "shares": 445,
    "lots": 0,
    "odd_shares": 445,
    "ntd_at_risk": 39978.8,
    "position_cost": 694200.0,
    "constraint": "WEIGHT",
    "atr14": 44.92,
    "low_20d": 1454.9,
    "ladder_minus1_pullback": 1466.4,
    "ladder_4_base": 1404.0,
    "ladder_5_euphoria": 2028.0
  },
  {
    "symbol": "4912.TW",
    "name": "聯德控股-KY",
    "sector": "電子零組件業",
    "close": 101.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.14,
    "dog_ma200_bias": 0.025,
    "vr60": 1.94,
    "rs20": 0.77,
    "rs60": 1.05,
    "shares": 7246,
    "lots": 7,
    "odd_shares": 246,
    "ntd_at_risk": 39997.92,
    "position_cost": 735469.0,
    "constraint": "WEIGHT",
    "atr14": 2.76,
    "low_20d": 94.1,
    "ladder_minus1_pullback": 95.4,
    "ladder_4_base": 91.4,
    "ladder_5_euphoria": 132.0
  },
  {
    "symbol": "3349.TWO",
    "name": "寶德",
    "sector": "電腦及週邊設備業",
    "close": 18.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.67,
    "dog_ma200_bias": 0.032,
    "vr60": 1.56,
    "rs20": 1.04,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 471250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.2,
    "ladder_minus1_pullback": 17.7,
    "ladder_4_base": 17.0,
    "ladder_5_euphoria": 24.5
  },
  {
    "symbol": "5432.TWO",
    "name": "新門",
    "sector": "綠能環保",
    "close": 196.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.41,
    "dog_ma200_bias": 0.032,
    "vr60": 1.77,
    "rs20": 0.77,
    "rs60": 0.8,
    "shares": 3086,
    "lots": 3,
    "odd_shares": 86,
    "ntd_at_risk": 39994.56,
    "position_cost": 604856.0,
    "constraint": "WEIGHT",
    "atr14": 6.48,
    "low_20d": 182.0,
    "ladder_minus1_pullback": 184.2,
    "ladder_4_base": 176.4,
    "ladder_5_euphoria": 254.8
  },
  {
    "symbol": "1517.TW",
    "name": "利奇",
    "sector": "電機機械業",
    "close": 10.3,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.25,
    "dog_ma200_bias": -0.144,
    "vr60": 0.71,
    "rs20": 0.59,
    "rs60": 0.51,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.5,
    "ladder_minus1_pullback": 9.7,
    "ladder_4_base": 9.3,
    "ladder_5_euphoria": 13.4
  },
  {
    "symbol": "2022.TW",
    "name": "聚亨",
    "sector": "鋼鐵工業",
    "close": 7.05,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.56,
    "dog_ma200_bias": 0.111,
    "vr60": 1.42,
    "rs20": 0.97,
    "rs60": 1.11,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 176250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 6.5,
    "ladder_minus1_pullback": 6.6,
    "ladder_4_base": 6.3,
    "ladder_5_euphoria": 9.2
  },
  {
    "symbol": "2460.TW",
    "name": "建通",
    "sector": "電子零組件業",
    "close": 31.35,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.42,
    "dog_ma200_bias": -0.18,
    "vr60": 0.89,
    "rs20": 0.46,
    "rs60": 0.6,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 28.9,
    "ladder_minus1_pullback": 29.5,
    "ladder_4_base": 28.2,
    "ladder_5_euphoria": 40.8
  },
  {
    "symbol": "5227.TWO",
    "name": "立凱-KY",
    "sector": "電子零組件業",
    "close": 26.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.42,
    "dog_ma200_bias": -0.009,
    "vr60": 1.9,
    "rs20": 1.13,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 668750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.5,
    "ladder_minus1_pullback": 25.1,
    "ladder_4_base": 24.1,
    "ladder_5_euphoria": 34.8
  },
  {
    "symbol": "8201.TW",
    "name": "無敵",
    "sector": "其他電子業",
    "close": 14.95,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.14,
    "dog_ma200_bias": -0.256,
    "vr60": 0.84,
    "rs20": 0.38,
    "rs60": 0.25,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 186875.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.2,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.4
  },
  {
    "symbol": "6485.TWO",
    "name": "點序",
    "sector": "半導體業",
    "close": 75.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.05,
    "dog_ma200_bias": 0.051,
    "vr60": 1.38,
    "rs20": 0.93,
    "rs60": 0.79,
    "shares": 10101,
    "lots": 10,
    "odd_shares": 101,
    "ntd_at_risk": 39999.96,
    "position_cost": 757575.0,
    "constraint": "WEIGHT",
    "atr14": 1.98,
    "low_20d": 69.4,
    "ladder_minus1_pullback": 70.5,
    "ladder_4_base": 67.5,
    "ladder_5_euphoria": 97.5
  },
  {
    "symbol": "8104.TW",
    "name": "錸寶",
    "sector": "光電業",
    "close": 29.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.21,
    "dog_ma200_bias": 0.049,
    "vr60": 2.02,
    "rs20": 1.07,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 743750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.0,
    "ladder_minus1_pullback": 28.0,
    "ladder_4_base": 26.8,
    "ladder_5_euphoria": 38.7
  },
  {
    "symbol": "6164.TW",
    "name": "華興",
    "sector": "光電業",
    "close": 12.6,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.25,
    "dog_ma200_bias": -0.258,
    "vr60": 0.7,
    "rs20": 0.38,
    "rs60": 0.31,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 157500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.5,
    "ladder_minus1_pullback": 11.8,
    "ladder_4_base": 11.3,
    "ladder_5_euphoria": 16.4
  },
  {
    "symbol": "4104.TW",
    "name": "佳醫",
    "sector": "生技醫療業",
    "close": 73.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.25,
    "dog_ma200_bias": 0.106,
    "vr60": 1.52,
    "rs20": 1.15,
    "rs60": 1.28,
    "shares": 11235,
    "lots": 11,
    "odd_shares": 235,
    "ntd_at_risk": 39996.6,
    "position_cost": 830266.5,
    "constraint": "WEIGHT",
    "atr14": 1.78,
    "low_20d": 70.9,
    "ladder_minus1_pullback": 69.5,
    "ladder_4_base": 66.5,
    "ladder_5_euphoria": 96.1
  },
  {
    "symbol": "6589.TW",
    "name": "台康生技",
    "sector": "生技醫療業",
    "close": 49.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.57,
    "dog_ma200_bias": 0.105,
    "vr60": 1.28,
    "rs20": 1.26,
    "rs60": 1.26,
    "shares": 14814,
    "lots": 14,
    "odd_shares": 814,
    "ntd_at_risk": 39997.8,
    "position_cost": 738477.9,
    "constraint": "WEIGHT",
    "atr14": 1.35,
    "low_20d": 46.4,
    "ladder_minus1_pullback": 46.9,
    "ladder_4_base": 44.9,
    "ladder_5_euphoria": 64.8
  },
  {
    "symbol": "2707.TW",
    "name": "晶華",
    "sector": "觀光餐旅",
    "close": 178.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.8,
    "dog_ma200_bias": 0.037,
    "vr60": 1.79,
    "rs20": 0.81,
    "rs60": 1.0,
    "shares": 4454,
    "lots": 4,
    "odd_shares": 454,
    "ntd_at_risk": 39996.92,
    "position_cost": 795039.0,
    "constraint": "WEIGHT",
    "atr14": 4.49,
    "low_20d": 165.9,
    "ladder_minus1_pullback": 167.8,
    "ladder_4_base": 160.7,
    "ladder_5_euphoria": 232.1
  },
  {
    "symbol": "4968.TW",
    "name": "立積",
    "sector": "半導體業",
    "close": 91.8,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.47,
    "dog_ma200_bias": 0.216,
    "vr60": 2.31,
    "rs20": 1.3,
    "rs60": 1.21,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.93,
    "low_20d": 83.4,
    "ladder_minus1_pullback": 86.3,
    "ladder_4_base": 82.6,
    "ladder_5_euphoria": 119.3
  },
  {
    "symbol": "6411.TWO",
    "name": "晶焱",
    "sector": "半導體業",
    "close": 75.4,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.38,
    "dog_ma200_bias": 0.269,
    "vr60": 2.23,
    "rs20": 1.19,
    "rs60": 1.15,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.55,
    "low_20d": 69.8,
    "ladder_minus1_pullback": 70.9,
    "ladder_4_base": 67.9,
    "ladder_5_euphoria": 98.0
  },
  {
    "symbol": "2038.TW",
    "name": "海光",
    "sector": "鋼鐵工業",
    "close": 12.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.18,
    "dog_ma200_bias": 0.042,
    "vr60": 1.43,
    "rs20": 0.93,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 310000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.2,
    "ladder_minus1_pullback": 11.7,
    "ladder_4_base": 11.2,
    "ladder_5_euphoria": 16.1
  },
  {
    "symbol": "2636.TW",
    "name": "台驊控股",
    "sector": "航運業",
    "close": 72.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.4,
    "dog_ma200_bias": 0.034,
    "vr60": 1.21,
    "rs20": 1.1,
    "rs60": 0.78,
    "shares": 11173,
    "lots": 11,
    "odd_shares": 173,
    "ntd_at_risk": 39999.34,
    "position_cost": 810042.5,
    "constraint": "WEIGHT",
    "atr14": 1.79,
    "low_20d": 68.2,
    "ladder_minus1_pullback": 68.1,
    "ladder_4_base": 65.2,
    "ladder_5_euphoria": 94.2
  },
  {
    "symbol": "7806.TWO",
    "name": "精華生醫",
    "sector": "食品工業",
    "close": 56.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.27,
    "dog_ma200_bias": 0.131,
    "vr60": 1.34,
    "rs20": 1.11,
    "rs60": 0.93,
    "shares": 14598,
    "lots": 14,
    "odd_shares": 598,
    "ntd_at_risk": 39998.52,
    "position_cost": 818947.8,
    "constraint": "WEIGHT",
    "atr14": 1.37,
    "low_20d": 53.3,
    "ladder_minus1_pullback": 52.7,
    "ladder_4_base": 50.5,
    "ladder_5_euphoria": 72.9
  },
  {
    "symbol": "2528.TW",
    "name": "皇普",
    "sector": "建材營造業",
    "close": 18.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.17,
    "dog_ma200_bias": 0.3,
    "vr60": 1.84,
    "rs20": 1.34,
    "rs60": 1.32,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 17.4,
    "ladder_minus1_pullback": 17.4,
    "ladder_4_base": 16.7,
    "ladder_5_euphoria": 24.1
  },
  {
    "symbol": "5284.TW",
    "name": "jpp-KY",
    "sector": "其他業",
    "close": 269.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.15,
    "dog_ma200_bias": 0.063,
    "vr60": 1.24,
    "rs20": 0.81,
    "rs60": 0.93,
    "shares": 3115,
    "lots": 3,
    "odd_shares": 115,
    "ntd_at_risk": 39996.6,
    "position_cost": 837935.0,
    "constraint": "WEIGHT",
    "atr14": 6.42,
    "low_20d": 247.9,
    "ladder_minus1_pullback": 252.9,
    "ladder_4_base": 242.1,
    "ladder_5_euphoria": 349.7
  },
  {
    "symbol": "7717.TWO",
    "name": "萊德光電-KY",
    "sector": "通信網路業",
    "close": 474.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.57,
    "dog_ma200_bias": -0.016,
    "vr60": 1.97,
    "rs20": 1.02,
    "rs60": 0.99,
    "shares": 2262,
    "lots": 2,
    "odd_shares": 262,
    "ntd_at_risk": 39992.16,
    "position_cost": 1072188.0,
    "constraint": "WEIGHT",
    "atr14": 8.84,
    "low_20d": 432.9,
    "ladder_minus1_pullback": 445.6,
    "ladder_4_base": 426.6,
    "ladder_5_euphoria": 616.2
  },
  {
    "symbol": "2608.TW",
    "name": "嘉里大榮",
    "sector": "航運業",
    "close": 28.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.8,
    "dog_ma200_bias": 0.01,
    "vr60": 2.03,
    "rs20": 0.77,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 723750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.9,
    "ladder_minus1_pullback": 27.2,
    "ladder_4_base": 26.1,
    "ladder_5_euphoria": 37.6
  },
  {
    "symbol": "3093.TWO",
    "name": "港建*",
    "sector": "其他電子業",
    "close": 38.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.07,
    "dog_ma200_bias": -0.002,
    "vr60": 1.8,
    "rs20": 0.99,
    "rs60": 0.94,
    "shares": 20408,
    "lots": 20,
    "odd_shares": 408,
    "ntd_at_risk": 39999.68,
    "position_cost": 783667.2,
    "constraint": "WEIGHT",
    "atr14": 0.98,
    "low_20d": 36.6,
    "ladder_minus1_pullback": 36.1,
    "ladder_4_base": 34.6,
    "ladder_5_euphoria": 49.9
  },
  {
    "symbol": "2536.TW",
    "name": "宏普",
    "sector": "建材營造業",
    "close": 18.2,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.17,
    "dog_ma200_bias": -0.173,
    "vr60": 1.0,
    "rs20": 0.27,
    "rs60": 0.35,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 227500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.8,
    "ladder_minus1_pullback": 17.1,
    "ladder_4_base": 16.4,
    "ladder_5_euphoria": 23.7
  },
  {
    "symbol": "3528.TW",
    "name": "安馳",
    "sector": "電子通路業",
    "close": 82.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.37,
    "dog_ma200_bias": 0.073,
    "vr60": 1.28,
    "rs20": 0.87,
    "rs60": 0.83,
    "shares": 13333,
    "lots": 13,
    "odd_shares": 333,
    "ntd_at_risk": 39999.0,
    "position_cost": 1103972.4,
    "constraint": "WEIGHT",
    "atr14": 1.5,
    "low_20d": 75.7,
    "ladder_minus1_pullback": 77.8,
    "ladder_4_base": 74.5,
    "ladder_5_euphoria": 107.6
  },
  {
    "symbol": "8234.TWO",
    "name": "新漢",
    "sector": "電腦及週邊設備業",
    "close": 62.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.12,
    "dog_ma200_bias": 0.018,
    "vr60": 1.26,
    "rs20": 0.92,
    "rs60": 0.89,
    "shares": 10000,
    "lots": 10,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 623000.0,
    "constraint": "WEIGHT",
    "atr14": 2.0,
    "low_20d": 57.5,
    "ladder_minus1_pullback": 58.6,
    "ladder_4_base": 56.1,
    "ladder_5_euphoria": 81.0
  },
  {
    "symbol": "6604.TWO",
    "name": "儒億",
    "sector": "電機機械業",
    "close": 24.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.33,
    "dog_ma200_bias": 0.009,
    "vr60": 1.32,
    "rs20": 1.03,
    "rs60": 0.8,
    "shares": 23809,
    "lots": 23,
    "odd_shares": 809,
    "ntd_at_risk": 39999.12,
    "position_cost": 585701.4,
    "constraint": "WEIGHT",
    "atr14": 0.84,
    "low_20d": 22.2,
    "ladder_minus1_pullback": 23.1,
    "ladder_4_base": 22.1,
    "ladder_5_euphoria": 32.0
  },
  {
    "symbol": "2243.TW",
    "name": "宏旭-KY",
    "sector": "汽車工業",
    "close": 58.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.32,
    "dog_ma200_bias": 0.123,
    "vr60": 1.36,
    "rs20": 1.23,
    "rs60": 1.14,
    "shares": 11235,
    "lots": 11,
    "odd_shares": 235,
    "ntd_at_risk": 39996.6,
    "position_cost": 651630.0,
    "constraint": "WEIGHT",
    "atr14": 1.78,
    "low_20d": 53.0,
    "ladder_minus1_pullback": 54.5,
    "ladder_4_base": 52.2,
    "ladder_5_euphoria": 75.4
  },
  {
    "symbol": "3057.TW",
    "name": "喬鼎",
    "sector": "電腦及週邊設備業",
    "close": 14.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.6,
    "dog_ma200_bias": 0.073,
    "vr60": 1.49,
    "rs20": 1.2,
    "rs60": 1.29,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 362500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.5,
    "ladder_minus1_pullback": 13.6,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 18.9
  },
  {
    "symbol": "6129.TWO",
    "name": "普誠",
    "sector": "半導體業",
    "close": 13.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.33,
    "dog_ma200_bias": 0.028,
    "vr60": 1.82,
    "rs20": 1.12,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 341250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 12.8,
    "ladder_4_base": 12.3,
    "ladder_5_euphoria": 17.7
  },
  {
    "symbol": "6584.TWO",
    "name": "南俊國際",
    "sector": "電子零組件業",
    "close": 486.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.22,
    "dog_ma200_bias": -0.051,
    "vr60": 1.85,
    "rs20": 0.51,
    "rs60": 0.63,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 10.74,
    "low_20d": 445.3,
    "ladder_minus1_pullback": 457.3,
    "ladder_4_base": 437.9,
    "ladder_5_euphoria": 632.5
  },
  {
    "symbol": "3388.TWO",
    "name": "崇越電",
    "sector": "電子零組件業",
    "close": 82.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.13,
    "dog_ma200_bias": 0.015,
    "vr60": 1.32,
    "rs20": 0.98,
    "rs60": 0.88,
    "shares": 10256,
    "lots": 10,
    "odd_shares": 256,
    "ntd_at_risk": 39998.4,
    "position_cost": 849196.8,
    "constraint": "WEIGHT",
    "atr14": 1.95,
    "low_20d": 77.5,
    "ladder_minus1_pullback": 77.8,
    "ladder_4_base": 74.5,
    "ladder_5_euphoria": 107.6
  },
  {
    "symbol": "3402.TWO",
    "name": "漢科",
    "sector": "其他電子業",
    "close": 131.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.29,
    "dog_ma200_bias": -0.166,
    "vr60": 0.87,
    "rs20": 0.27,
    "rs60": 0.41,
    "shares": 2512,
    "lots": 2,
    "odd_shares": 512,
    "ntd_at_risk": 19995.52,
    "position_cost": 330328.0,
    "constraint": "WEIGHT",
    "atr14": 3.98,
    "low_20d": 123.1,
    "ladder_minus1_pullback": 123.6,
    "ladder_4_base": 118.4,
    "ladder_5_euphoria": 171.0
  },
  {
    "symbol": "2466.TW",
    "name": "冠西電",
    "sector": "光電業",
    "close": 192.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.5,
    "dog_ma200_bias": 0.078,
    "vr60": 1.2,
    "rs20": 0.76,
    "rs60": 0.92,
    "shares": 4705,
    "lots": 4,
    "odd_shares": 705,
    "ntd_at_risk": 39992.5,
    "position_cost": 905712.5,
    "constraint": "WEIGHT",
    "atr14": 4.25,
    "low_20d": 175.5,
    "ladder_minus1_pullback": 180.9,
    "ladder_4_base": 173.2,
    "ladder_5_euphoria": 250.2
  },
  {
    "symbol": "1217.TW",
    "name": "愛之味",
    "sector": "食品工業",
    "close": 9.92,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.37,
    "dog_ma200_bias": -0.259,
    "vr60": 1.03,
    "rs20": 0.52,
    "rs60": 0.55,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 124000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.5,
    "ladder_minus1_pullback": 9.3,
    "ladder_4_base": 8.9,
    "ladder_5_euphoria": 12.9
  },
  {
    "symbol": "8390.TWO",
    "name": "金益鼎",
    "sector": "綠能環保",
    "close": 89.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.4,
    "dog_ma200_bias": 0.1,
    "vr60": 1.39,
    "rs20": 1.21,
    "rs60": 0.9,
    "shares": 11627,
    "lots": 11,
    "odd_shares": 627,
    "ntd_at_risk": 39996.88,
    "position_cost": 1045267.3,
    "constraint": "WEIGHT",
    "atr14": 1.72,
    "low_20d": 82.4,
    "ladder_minus1_pullback": 84.5,
    "ladder_4_base": 80.9,
    "ladder_5_euphoria": 116.9
  },
  {
    "symbol": "8114.TW",
    "name": "振樺電",
    "sector": "電腦及週邊設備業",
    "close": 178.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": 0.084,
    "vr60": 1.22,
    "rs20": 1.27,
    "rs60": 1.02,
    "shares": 4987,
    "lots": 4,
    "odd_shares": 987,
    "ntd_at_risk": 39995.74,
    "position_cost": 890179.5,
    "constraint": "WEIGHT",
    "atr14": 4.01,
    "low_20d": 167.9,
    "ladder_minus1_pullback": 167.8,
    "ladder_4_base": 160.7,
    "ladder_5_euphoria": 232.1
  },
  {
    "symbol": "4414.TW",
    "name": "如興",
    "sector": "紡織纖維業",
    "close": 8.05,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.18,
    "dog_ma200_bias": 0.121,
    "vr60": 1.24,
    "rs20": 0.95,
    "rs60": 1.17,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 201250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.5,
    "ladder_minus1_pullback": 7.6,
    "ladder_4_base": 7.2,
    "ladder_5_euphoria": 10.5
  },
  {
    "symbol": "3003.TW",
    "name": "健和興",
    "sector": "電子零組件業",
    "close": 56.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.25,
    "dog_ma200_bias": 0.014,
    "vr60": 1.85,
    "rs20": 1.0,
    "rs60": 0.71,
    "shares": 18518,
    "lots": 18,
    "odd_shares": 518,
    "ntd_at_risk": 39998.88,
    "position_cost": 1040711.6,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 52.3,
    "ladder_minus1_pullback": 52.8,
    "ladder_4_base": 50.6,
    "ladder_5_euphoria": 73.1
  },
  {
    "symbol": "8255.TWO",
    "name": "朋程",
    "sector": "電機機械業",
    "close": 140.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": -0.002,
    "vr60": 1.5,
    "rs20": 0.89,
    "rs60": 0.94,
    "shares": 8333,
    "lots": 8,
    "odd_shares": 333,
    "ntd_at_risk": 39998.4,
    "position_cost": 1166620.0,
    "constraint": "WEIGHT",
    "atr14": 2.4,
    "low_20d": 132.4,
    "ladder_minus1_pullback": 131.6,
    "ladder_4_base": 126.0,
    "ladder_5_euphoria": 182.0
  },
  {
    "symbol": "3346.TW",
    "name": "麗清",
    "sector": "汽車工業",
    "close": 21.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.46,
    "dog_ma200_bias": 0.072,
    "vr60": 1.92,
    "rs20": 1.01,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 537500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.7,
    "ladder_minus1_pullback": 20.2,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 27.9
  },
  {
    "symbol": "8404.TW",
    "name": "百和興業-KY",
    "sector": "其他業",
    "close": 13.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.05,
    "dog_ma200_bias": 0.043,
    "vr60": 2.0,
    "rs20": 0.96,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 332500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.7,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 12.0,
    "ladder_5_euphoria": 17.3
  },
  {
    "symbol": "5519.TW",
    "name": "隆大",
    "sector": "建材營造業",
    "close": 24.35,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.2,
    "dog_ma200_bias": 0.154,
    "vr60": 1.3,
    "rs20": 1.25,
    "rs60": 1.23,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 608750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.0,
    "ladder_minus1_pullback": 22.9,
    "ladder_4_base": 21.9,
    "ladder_5_euphoria": 31.7
  },
  {
    "symbol": "7822.TW",
    "name": "倍利科",
    "sector": "半導體業",
    "close": 820.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.05,
    "dog_ma200_bias": 0.096,
    "vr60": 1.48,
    "rs20": 1.08,
    "rs60": 1.11,
    "shares": 1184,
    "lots": 1,
    "odd_shares": 184,
    "ntd_at_risk": 39995.52,
    "position_cost": 970880.0,
    "constraint": "WEIGHT",
    "atr14": 16.89,
    "low_20d": 757.4,
    "ladder_minus1_pullback": 770.8,
    "ladder_4_base": 738.0,
    "ladder_5_euphoria": 1066.0
  },
  {
    "symbol": "6756.TW",
    "name": "威鋒電子",
    "sector": "半導體業",
    "close": 100.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.92,
    "dog_ma200_bias": 0.001,
    "vr60": 1.82,
    "rs20": 1.07,
    "rs60": 1.01,
    "shares": 11764,
    "lots": 11,
    "odd_shares": 764,
    "ntd_at_risk": 39997.6,
    "position_cost": 1176400.0,
    "constraint": "WEIGHT",
    "atr14": 1.7,
    "low_20d": 92.2,
    "ladder_minus1_pullback": 94.0,
    "ladder_4_base": 90.0,
    "ladder_5_euphoria": 130.0
  },
  {
    "symbol": "3297.TWO",
    "name": "杭特",
    "sector": "光電業",
    "close": 30.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.07,
    "dog_ma200_bias": 0.015,
    "vr60": 2.07,
    "rs20": 0.86,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 757500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.4,
    "ladder_minus1_pullback": 28.5,
    "ladder_4_base": 27.3,
    "ladder_5_euphoria": 39.4
  },
  {
    "symbol": "9911.TW",
    "name": "櫻花",
    "sector": "居家生活",
    "close": 81.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": 0.078,
    "vr60": 1.76,
    "rs20": 1.09,
    "rs60": 0.9,
    "shares": 13986,
    "lots": 13,
    "odd_shares": 986,
    "ntd_at_risk": 39999.96,
    "position_cost": 1134264.6,
    "constraint": "WEIGHT",
    "atr14": 1.43,
    "low_20d": 74.2,
    "ladder_minus1_pullback": 76.2,
    "ladder_4_base": 73.0,
    "ladder_5_euphoria": 105.4
  },
  {
    "symbol": "6165.TW",
    "name": "浪凡",
    "sector": "數位雲端",
    "close": 47.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.06,
    "dog_ma200_bias": 0.019,
    "vr60": 1.74,
    "rs20": 1.1,
    "rs60": 0.96,
    "shares": 13888,
    "lots": 13,
    "odd_shares": 888,
    "ntd_at_risk": 39997.44,
    "position_cost": 653430.4,
    "constraint": "WEIGHT",
    "atr14": 1.44,
    "low_20d": 44.0,
    "ladder_minus1_pullback": 44.2,
    "ladder_4_base": 42.3,
    "ladder_5_euphoria": 61.2
  },
  {
    "symbol": "1340.TW",
    "name": "勝悅-KY",
    "sector": "塑膠工業",
    "close": 5.02,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.08,
    "dog_ma200_bias": 0.051,
    "vr60": 1.48,
    "rs20": 0.76,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 125500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 4.7,
    "ladder_minus1_pullback": 4.7,
    "ladder_4_base": 4.5,
    "ladder_5_euphoria": 6.5
  },
  {
    "symbol": "2453.TW",
    "name": "凌群",
    "sector": "資訊服務業",
    "close": 52.4,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.1,
    "dog_ma200_bias": -0.13,
    "vr60": 0.68,
    "rs20": 0.46,
    "rs60": 0.68,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.88,
    "low_20d": 49.5,
    "ladder_minus1_pullback": 49.3,
    "ladder_4_base": 47.2,
    "ladder_5_euphoria": 68.1
  },
  {
    "symbol": "3556.TWO",
    "name": "禾瑞亞",
    "sector": "半導體業",
    "close": 61.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.38,
    "dog_ma200_bias": 0.002,
    "vr60": 1.47,
    "rs20": 0.79,
    "rs60": 0.97,
    "shares": 10752,
    "lots": 10,
    "odd_shares": 752,
    "ntd_at_risk": 39997.44,
    "position_cost": 661248.0,
    "constraint": "WEIGHT",
    "atr14": 1.86,
    "low_20d": 58.1,
    "ladder_minus1_pullback": 57.8,
    "ladder_4_base": 55.4,
    "ladder_5_euphoria": 80.0
  },
  {
    "symbol": "1337.TW",
    "name": "再生-KY",
    "sector": "塑膠工業",
    "close": 4.43,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.05,
    "dog_ma200_bias": 0.058,
    "vr60": 2.02,
    "rs20": 0.93,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 110750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 4.2,
    "ladder_minus1_pullback": 4.2,
    "ladder_4_base": 4.0,
    "ladder_5_euphoria": 5.8
  },
  {
    "symbol": "9946.TW",
    "name": "三發地產",
    "sector": "建材營造業",
    "close": 16.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.6,
    "dog_ma200_bias": 0.118,
    "vr60": 1.35,
    "rs20": 1.03,
    "rs60": 1.27,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 416250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.2,
    "ladder_minus1_pullback": 15.7,
    "ladder_4_base": 15.0,
    "ladder_5_euphoria": 21.6
  },
  {
    "symbol": "1232.TW",
    "name": "大統益",
    "sector": "食品工業",
    "close": 156.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.43,
    "dog_ma200_bias": 0.053,
    "vr60": 1.67,
    "rs20": 1.06,
    "rs60": 0.75,
    "shares": 6006,
    "lots": 6,
    "odd_shares": 6,
    "ntd_at_risk": 39999.96,
    "position_cost": 939939.0,
    "constraint": "WEIGHT",
    "atr14": 3.33,
    "low_20d": 142.2,
    "ladder_minus1_pullback": 147.1,
    "ladder_4_base": 140.8,
    "ladder_5_euphoria": 203.5
  },
  {
    "symbol": "3712.TW",
    "name": "永崴投控",
    "sector": "電腦及週邊設備業",
    "close": 20.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.6,
    "dog_ma200_bias": 0.165,
    "vr60": 1.54,
    "rs20": 1.33,
    "rs60": 1.17,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 502500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.2,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.1
  },
  {
    "symbol": "5278.TWO",
    "name": "尚凡*",
    "sector": "數位雲端",
    "close": 23.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.2,
    "dog_ma200_bias": -0.007,
    "vr60": 1.85,
    "rs20": 0.93,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 588750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.0,
    "ladder_minus1_pullback": 22.1,
    "ladder_4_base": 21.2,
    "ladder_5_euphoria": 30.6
  },
  {
    "symbol": "1449.TW",
    "name": "佳和",
    "sector": "紡織纖維業",
    "close": 12.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.5,
    "dog_ma200_bias": 0.032,
    "vr60": 1.2,
    "rs20": 1.12,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 315000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.6,
    "ladder_minus1_pullback": 11.8,
    "ladder_4_base": 11.3,
    "ladder_5_euphoria": 16.4
  },
  {
    "symbol": "2613.TW",
    "name": "中櫃",
    "sector": "航運業",
    "close": 22.35,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.31,
    "dog_ma200_bias": 0.131,
    "vr60": 1.1,
    "rs20": 1.14,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 558750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.4,
    "ladder_minus1_pullback": 21.0,
    "ladder_4_base": 20.1,
    "ladder_5_euphoria": 29.1
  },
  {
    "symbol": "5533.TW",
    "name": "皇鼎",
    "sector": "建材營造業",
    "close": 13.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.33,
    "dog_ma200_bias": 0.032,
    "vr60": 1.79,
    "rs20": 0.87,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 346250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 13.0,
    "ladder_4_base": 12.5,
    "ladder_5_euphoria": 18.0
  },
  {
    "symbol": "1752.TW",
    "name": "南光",
    "sector": "生技醫療業",
    "close": 31.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.17,
    "dog_ma200_bias": 0.011,
    "vr60": 2.0,
    "rs20": 0.88,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 782500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.1,
    "ladder_minus1_pullback": 29.4,
    "ladder_4_base": 28.2,
    "ladder_5_euphoria": 40.7
  },
  {
    "symbol": "1702.TW",
    "name": "南僑",
    "sector": "食品工業",
    "close": 33.75,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.64,
    "dog_ma200_bias": -0.052,
    "vr60": 1.59,
    "rs20": 0.55,
    "rs60": 0.49,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.85,
    "low_20d": 32.4,
    "ladder_minus1_pullback": 31.7,
    "ladder_4_base": 30.4,
    "ladder_5_euphoria": 43.9
  },
  {
    "symbol": "5547.TWO",
    "name": "久舜",
    "sector": "建材營造業",
    "close": 20.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.33,
    "dog_ma200_bias": 0.007,
    "vr60": 1.21,
    "rs20": 1.0,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 503750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.7,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.2
  },
  {
    "symbol": "3303.TWO",
    "name": "岱稜",
    "sector": "其他電子業",
    "close": 52.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.6,
    "dog_ma200_bias": -0.243,
    "vr60": 0.81,
    "rs20": 0.33,
    "rs60": 0.23,
    "shares": 6250,
    "lots": 6,
    "odd_shares": 250,
    "ntd_at_risk": 20000.0,
    "position_cost": 325000.0,
    "constraint": "WEIGHT",
    "atr14": 1.6,
    "low_20d": 48.4,
    "ladder_minus1_pullback": 48.9,
    "ladder_4_base": 46.8,
    "ladder_5_euphoria": 67.6
  },
  {
    "symbol": "3552.TWO",
    "name": "同致",
    "sector": "其他電子業",
    "close": 40.15,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": 0.094,
    "vr60": 1.2,
    "rs20": 0.98,
    "rs60": 1.15,
    "shares": 18018,
    "lots": 18,
    "odd_shares": 18,
    "ntd_at_risk": 39999.96,
    "position_cost": 723422.7,
    "constraint": "WEIGHT",
    "atr14": 1.11,
    "low_20d": 36.8,
    "ladder_minus1_pullback": 37.7,
    "ladder_4_base": 36.1,
    "ladder_5_euphoria": 52.2
  },
  {
    "symbol": "4953.TWO",
    "name": "緯致",
    "sector": "資訊服務業",
    "close": 115.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.67,
    "dog_ma200_bias": 0.014,
    "vr60": 1.6,
    "rs20": 0.8,
    "rs60": 0.86,
    "shares": 5025,
    "lots": 5,
    "odd_shares": 25,
    "ntd_at_risk": 39999.0,
    "position_cost": 580387.5,
    "constraint": "WEIGHT",
    "atr14": 3.98,
    "low_20d": 105.5,
    "ladder_minus1_pullback": 108.6,
    "ladder_4_base": 104.0,
    "ladder_5_euphoria": 150.2
  },
  {
    "symbol": "4577.TWO",
    "name": "達航科技",
    "sector": "其他電子業",
    "close": 88.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.3,
    "rs20": 0.77,
    "rs60": 0.85,
    "shares": 7326,
    "lots": 7,
    "odd_shares": 326,
    "ntd_at_risk": 39999.96,
    "position_cost": 644688.0,
    "constraint": "WEIGHT",
    "atr14": 2.73,
    "low_20d": 80.0,
    "ladder_minus1_pullback": 82.7,
    "ladder_4_base": 79.2,
    "ladder_5_euphoria": 114.4
  },
  {
    "symbol": "1618.TW",
    "name": "合機",
    "sector": "電器電纜業",
    "close": 38.75,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.45,
    "dog_ma200_bias": -0.248,
    "vr60": 0.92,
    "rs20": 0.44,
    "rs60": 0.49,
    "shares": 7692,
    "lots": 7,
    "odd_shares": 692,
    "ntd_at_risk": 19999.2,
    "position_cost": 298065.0,
    "constraint": "WEIGHT",
    "atr14": 1.3,
    "low_20d": 35.8,
    "ladder_minus1_pullback": 36.4,
    "ladder_4_base": 34.9,
    "ladder_5_euphoria": 50.4
  },
  {
    "symbol": "5508.TWO",
    "name": "永信建",
    "sector": "建材營造業",
    "close": 53.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.13,
    "dog_ma200_bias": 0.134,
    "vr60": 1.24,
    "rs20": 1.28,
    "rs60": 1.19,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 40000.0,
    "position_cost": 663750.0,
    "constraint": "WEIGHT",
    "atr14": 1.6,
    "low_20d": 48.5,
    "ladder_minus1_pullback": 49.9,
    "ladder_4_base": 47.8,
    "ladder_5_euphoria": 69.0
  },
  {
    "symbol": "8476.TW",
    "name": "台境*",
    "sector": "綠能環保",
    "close": 20.8,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.05,
    "dog_ma200_bias": 0.314,
    "vr60": 2.13,
    "rs20": 1.49,
    "rs60": 1.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 19.4,
    "ladder_minus1_pullback": 19.6,
    "ladder_4_base": 18.7,
    "ladder_5_euphoria": 27.0
  },
  {
    "symbol": "8171.TWO",
    "name": "天宇",
    "sector": "綠能環保",
    "close": 21.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.09,
    "dog_ma200_bias": -0.007,
    "vr60": 1.93,
    "rs20": 1.12,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 532500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.6,
    "ladder_minus1_pullback": 20.0,
    "ladder_4_base": 19.2,
    "ladder_5_euphoria": 27.7
  },
  {
    "symbol": "2849.TW",
    "name": "安泰銀",
    "sector": "金融保險業",
    "close": 15.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.86,
    "dog_ma200_bias": 0.026,
    "vr60": 1.82,
    "rs20": 1.03,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 396250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.9,
    "ladder_minus1_pullback": 14.9,
    "ladder_4_base": 14.3,
    "ladder_5_euphoria": 20.6
  },
  {
    "symbol": "3577.TWO",
    "name": "泓格",
    "sector": "電腦及週邊設備業",
    "close": 92.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.003,
    "vr60": 1.4,
    "rs20": 1.09,
    "rs60": 0.92,
    "shares": 7490,
    "lots": 7,
    "odd_shares": 490,
    "ntd_at_risk": 39996.6,
    "position_cost": 692825.0,
    "constraint": "WEIGHT",
    "atr14": 2.67,
    "low_20d": 84.2,
    "ladder_minus1_pullback": 86.9,
    "ladder_4_base": 83.2,
    "ladder_5_euphoria": 120.2
  },
  {
    "symbol": "3609.TWO",
    "name": "三一東林",
    "sector": "電子零組件業",
    "close": 25.2,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.36,
    "dog_ma200_bias": -0.072,
    "vr60": 0.74,
    "rs20": 0.54,
    "rs60": 0.58,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 23.3,
    "ladder_minus1_pullback": 23.7,
    "ladder_4_base": 22.7,
    "ladder_5_euphoria": 32.8
  },
  {
    "symbol": "1506.TW",
    "name": "正道",
    "sector": "電機機械業",
    "close": 9.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.6,
    "dog_ma200_bias": 0.059,
    "vr60": 1.99,
    "rs20": 0.93,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 240000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.2,
    "ladder_minus1_pullback": 9.0,
    "ladder_4_base": 8.6,
    "ladder_5_euphoria": 12.5
  },
  {
    "symbol": "8438.TW",
    "name": "昶昕",
    "sector": "綠能環保",
    "close": 73.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.17,
    "dog_ma200_bias": 0.028,
    "vr60": 1.52,
    "rs20": 0.93,
    "rs60": 0.76,
    "shares": 11627,
    "lots": 11,
    "odd_shares": 627,
    "ntd_at_risk": 39996.88,
    "position_cost": 851096.4,
    "constraint": "WEIGHT",
    "atr14": 1.72,
    "low_20d": 69.1,
    "ladder_minus1_pullback": 68.8,
    "ladder_4_base": 65.9,
    "ladder_5_euphoria": 95.2
  },
  {
    "symbol": "3321.TW",
    "name": "同泰",
    "sector": "電子零組件業",
    "close": 16.4,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.08,
    "dog_ma200_bias": -0.092,
    "vr60": 0.81,
    "rs20": 0.34,
    "rs60": 0.39,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 15.4,
    "ladder_minus1_pullback": 15.4,
    "ladder_4_base": 14.8,
    "ladder_5_euphoria": 21.3
  },
  {
    "symbol": "6890.TW",
    "name": "來億-KY",
    "sector": "運動休閒",
    "close": 152.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.86,
    "dog_ma200_bias": 0.062,
    "vr60": 1.92,
    "rs20": 0.88,
    "rs60": 0.93,
    "shares": 4629,
    "lots": 4,
    "odd_shares": 629,
    "ntd_at_risk": 39994.56,
    "position_cost": 705922.5,
    "constraint": "WEIGHT",
    "atr14": 4.32,
    "low_20d": 139.4,
    "ladder_minus1_pullback": 143.3,
    "ladder_4_base": 137.2,
    "ladder_5_euphoria": 198.2
  },
  {
    "symbol": "1464.TW",
    "name": "得力",
    "sector": "紡織纖維業",
    "close": 9.95,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.37,
    "dog_ma200_bias": -0.001,
    "vr60": 1.78,
    "rs20": 0.54,
    "rs60": 0.59,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 12.9
  },
  {
    "symbol": "2387.TW",
    "name": "精元",
    "sector": "電腦及週邊設備業",
    "close": 36.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.95,
    "dog_ma200_bias": 0.035,
    "vr60": 2.08,
    "rs20": 0.9,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 906250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 33.1,
    "ladder_minus1_pullback": 34.1,
    "ladder_4_base": 32.6,
    "ladder_5_euphoria": 47.1
  },
  {
    "symbol": "2908.TW",
    "name": "特力",
    "sector": "貿易百貨業",
    "close": 22.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.33,
    "dog_ma200_bias": 0.158,
    "vr60": 1.4,
    "rs20": 1.26,
    "rs60": 1.07,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 550000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.1,
    "ladder_minus1_pullback": 20.7,
    "ladder_4_base": 19.8,
    "ladder_5_euphoria": 28.6
  },
  {
    "symbol": "3015.TW",
    "name": "全漢",
    "sector": "電子零組件業",
    "close": 51.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.05,
    "dog_ma200_bias": 0.154,
    "vr60": 1.38,
    "rs20": 1.04,
    "rs60": 1.17,
    "shares": 12195,
    "lots": 12,
    "odd_shares": 195,
    "ntd_at_risk": 39999.6,
    "position_cost": 625603.5,
    "constraint": "WEIGHT",
    "atr14": 1.64,
    "low_20d": 46.8,
    "ladder_minus1_pullback": 48.2,
    "ladder_4_base": 46.2,
    "ladder_5_euphoria": 66.7
  },
  {
    "symbol": "6947.TW",
    "name": "台鎔科技",
    "sector": "綠能環保",
    "close": 66.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": 0.069,
    "vr60": 1.61,
    "rs20": 1.18,
    "rs60": 1.09,
    "shares": 8771,
    "lots": 8,
    "odd_shares": 771,
    "ntd_at_risk": 39995.76,
    "position_cost": 585902.8,
    "constraint": "WEIGHT",
    "atr14": 2.28,
    "low_20d": 62.8,
    "ladder_minus1_pullback": 62.8,
    "ladder_4_base": 60.1,
    "ladder_5_euphoria": 86.8
  },
  {
    "symbol": "6140.TWO",
    "name": "訊達",
    "sector": "資訊服務業",
    "close": 20.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.47,
    "dog_ma200_bias": 0.039,
    "vr60": 1.62,
    "rs20": 0.97,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 503750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.1,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.2
  },
  {
    "symbol": "6763.TWO",
    "name": "綠界科技*",
    "sector": "數位雲端",
    "close": 41.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.36,
    "dog_ma200_bias": -0.002,
    "vr60": 2.06,
    "rs20": 0.78,
    "rs60": 0.74,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 849461.6,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 38.9,
    "ladder_minus1_pullback": 38.7,
    "ladder_4_base": 37.1,
    "ladder_5_euphoria": 53.6
  },
  {
    "symbol": "4766.TW",
    "name": "南寶",
    "sector": "化學工業",
    "close": 361.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.5,
    "dog_ma200_bias": 0.061,
    "vr60": 1.89,
    "rs20": 0.9,
    "rs60": 0.87,
    "shares": 2865,
    "lots": 2,
    "odd_shares": 865,
    "ntd_at_risk": 39995.4,
    "position_cost": 1034265.0,
    "constraint": "WEIGHT",
    "atr14": 6.98,
    "low_20d": 338.9,
    "ladder_minus1_pullback": 339.3,
    "ladder_4_base": 324.9,
    "ladder_5_euphoria": 469.3
  },
  {
    "symbol": "3325.TWO",
    "name": "旭品",
    "sector": "電腦及週邊設備業",
    "close": 11.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.86,
    "dog_ma200_bias": 0.046,
    "vr60": 1.28,
    "rs20": 1.08,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 281250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.5,
    "ladder_minus1_pullback": 10.6,
    "ladder_4_base": 10.1,
    "ladder_5_euphoria": 14.6
  },
  {
    "symbol": "5206.TWO",
    "name": "坤悅",
    "sector": "建材營造業",
    "close": 22.9,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.4,
    "dog_ma200_bias": 0.361,
    "vr60": 2.24,
    "rs20": 1.15,
    "rs60": 1.15,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 21.4,
    "ladder_minus1_pullback": 21.5,
    "ladder_4_base": 20.6,
    "ladder_5_euphoria": 29.8
  },
  {
    "symbol": "6945.TWO",
    "name": "圓祥生技",
    "sector": "生技醫療業",
    "close": 122.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.27,
    "dog_ma200_bias": 0.033,
    "vr60": 1.55,
    "rs20": 0.98,
    "rs60": 0.77,
    "shares": 5494,
    "lots": 5,
    "odd_shares": 494,
    "ntd_at_risk": 39996.32,
    "position_cost": 670268.0,
    "constraint": "WEIGHT",
    "atr14": 3.64,
    "low_20d": 114.3,
    "ladder_minus1_pullback": 114.7,
    "ladder_4_base": 109.8,
    "ladder_5_euphoria": 158.6
  },
  {
    "symbol": "2397.TW",
    "name": "友通",
    "sector": "電腦及週邊設備業",
    "close": 64.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.25,
    "dog_ma200_bias": 0.048,
    "vr60": 1.48,
    "rs20": 0.98,
    "rs60": 1.02,
    "shares": 13513,
    "lots": 13,
    "odd_shares": 513,
    "ntd_at_risk": 39998.48,
    "position_cost": 870237.2,
    "constraint": "WEIGHT",
    "atr14": 1.48,
    "low_20d": 61.0,
    "ladder_minus1_pullback": 60.5,
    "ladder_4_base": 58.0,
    "ladder_5_euphoria": 83.7
  },
  {
    "symbol": "6216.TW",
    "name": "居易",
    "sector": "通信網路業",
    "close": 19.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.05,
    "dog_ma200_bias": 0.01,
    "vr60": 2.05,
    "rs20": 0.92,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 478750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.3,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.2,
    "ladder_5_euphoria": 24.9
  },
  {
    "symbol": "8222.TW",
    "name": "寶一",
    "sector": "電機機械業",
    "close": 34.45,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.25,
    "dog_ma200_bias": 0.101,
    "vr60": 1.1,
    "rs20": 0.95,
    "rs60": 1.29,
    "shares": 17391,
    "lots": 17,
    "odd_shares": 391,
    "ntd_at_risk": 39999.3,
    "position_cost": 599119.95,
    "constraint": "WEIGHT",
    "atr14": 1.15,
    "low_20d": 31.6,
    "ladder_minus1_pullback": 32.4,
    "ladder_4_base": 31.0,
    "ladder_5_euphoria": 44.8
  },
  {
    "symbol": "2597.TW",
    "name": "潤弘",
    "sector": "建材營造業",
    "close": 163.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.25,
    "dog_ma200_bias": -0.207,
    "vr60": 0.71,
    "rs20": 0.32,
    "rs60": 0.32,
    "shares": 2028,
    "lots": 2,
    "odd_shares": 28,
    "ntd_at_risk": 19996.08,
    "position_cost": 331578.0,
    "constraint": "WEIGHT",
    "atr14": 4.93,
    "low_20d": 155.8,
    "ladder_minus1_pullback": 153.7,
    "ladder_4_base": 147.2,
    "ladder_5_euphoria": 212.6
  },
  {
    "symbol": "3467.TWO",
    "name": "台灣精材",
    "sector": "半導體業",
    "close": 61.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.31,
    "dog_ma200_bias": -0.27,
    "vr60": 0.97,
    "rs20": 0.53,
    "rs60": 0.31,
    "shares": 5952,
    "lots": 5,
    "odd_shares": 952,
    "ntd_at_risk": 19998.72,
    "position_cost": 368428.8,
    "constraint": "WEIGHT",
    "atr14": 1.68,
    "low_20d": 56.6,
    "ladder_minus1_pullback": 58.2,
    "ladder_4_base": 55.7,
    "ladder_5_euphoria": 80.5
  },
  {
    "symbol": "3526.TWO",
    "name": "凡甲",
    "sector": "電子零組件業",
    "close": 268.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.45,
    "dog_ma200_bias": 0.067,
    "vr60": 1.41,
    "rs20": 1.03,
    "rs60": 0.84,
    "shares": 3960,
    "lots": 3,
    "odd_shares": 960,
    "ntd_at_risk": 39996.0,
    "position_cost": 1063260.0,
    "constraint": "WEIGHT",
    "atr14": 5.05,
    "low_20d": 241.9,
    "ladder_minus1_pullback": 252.4,
    "ladder_4_base": 241.7,
    "ladder_5_euphoria": 349.1
  },
  {
    "symbol": "5490.TWO",
    "name": "同亨",
    "sector": "電腦及週邊設備業",
    "close": 25.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.5,
    "dog_ma200_bias": 0.012,
    "vr60": 1.54,
    "rs20": 0.9,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 625000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.6,
    "ladder_minus1_pullback": 23.5,
    "ladder_4_base": 22.5,
    "ladder_5_euphoria": 32.5
  },
  {
    "symbol": "8421.TWO",
    "name": "旭源",
    "sector": "其他業",
    "close": 13.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.62,
    "dog_ma200_bias": 0.046,
    "vr60": 1.63,
    "rs20": 0.83,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 343750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.2,
    "ladder_minus1_pullback": 12.9,
    "ladder_4_base": 12.4,
    "ladder_5_euphoria": 17.9
  },
  {
    "symbol": "3373.TWO",
    "name": "熱映",
    "sector": "其他電子業",
    "close": 16.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.25,
    "dog_ma200_bias": 0.072,
    "vr60": 1.96,
    "rs20": 0.81,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 421250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.3,
    "ladder_minus1_pullback": 15.8,
    "ladder_4_base": 15.2,
    "ladder_5_euphoria": 21.9
  },
  {
    "symbol": "4909.TWO",
    "name": "新復興",
    "sector": "通信網路業",
    "close": 35.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.047,
    "vr60": 1.32,
    "rs20": 0.78,
    "rs60": 0.71,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 589976.4,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 32.2,
    "ladder_minus1_pullback": 33.3,
    "ladder_4_base": 31.9,
    "ladder_5_euphoria": 46.0
  },
  {
    "symbol": "2380.TW",
    "name": "虹光",
    "sector": "電腦及週邊設備業",
    "close": 17.15,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.95,
    "dog_ma200_bias": 0.147,
    "vr60": 1.34,
    "rs20": 1.12,
    "rs60": 1.3,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 428750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.2,
    "ladder_minus1_pullback": 16.1,
    "ladder_4_base": 15.4,
    "ladder_5_euphoria": 22.3
  },
  {
    "symbol": "2107.TW",
    "name": "厚生",
    "sector": "橡膠工業",
    "close": 28.75,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.67,
    "dog_ma200_bias": 0.07,
    "vr60": 1.44,
    "rs20": 1.12,
    "rs60": 1.08,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 718750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.5,
    "ladder_minus1_pullback": 27.0,
    "ladder_4_base": 25.9,
    "ladder_5_euphoria": 37.4
  },
  {
    "symbol": "6233.TWO",
    "name": "旺玖",
    "sector": "半導體業",
    "close": 24.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.4,
    "dog_ma200_bias": 0.059,
    "vr60": 1.74,
    "rs20": 0.92,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 623750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.5,
    "ladder_minus1_pullback": 23.5,
    "ladder_4_base": 22.5,
    "ladder_5_euphoria": 32.4
  },
  {
    "symbol": "5213.TWO",
    "name": "亞昕",
    "sector": "建材營造業",
    "close": 19.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.05,
    "dog_ma200_bias": 0.031,
    "vr60": 1.7,
    "rs20": 0.93,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 498750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.8,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 25.9
  },
  {
    "symbol": "6465.TWO",
    "name": "威潤",
    "sector": "通信網路業",
    "close": 42.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.49,
    "dog_ma200_bias": -0.001,
    "vr60": 1.74,
    "rs20": 0.98,
    "rs60": 1.0,
    "shares": 23529,
    "lots": 23,
    "odd_shares": 529,
    "ntd_at_risk": 39999.3,
    "position_cost": 1003511.85,
    "constraint": "WEIGHT",
    "atr14": 0.85,
    "low_20d": 39.5,
    "ladder_minus1_pullback": 40.1,
    "ladder_4_base": 38.4,
    "ladder_5_euphoria": 55.4
  },
  {
    "symbol": "7712.TWO",
    "name": "博盛半導體",
    "sector": "半導體業",
    "close": 154.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.12,
    "dog_ma200_bias": 0.088,
    "vr60": 1.35,
    "rs20": 1.11,
    "rs60": 1.12,
    "shares": 7168,
    "lots": 7,
    "odd_shares": 168,
    "ntd_at_risk": 39997.44,
    "position_cost": 1103872.0,
    "constraint": "WEIGHT",
    "atr14": 2.79,
    "low_20d": 141.4,
    "ladder_minus1_pullback": 144.8,
    "ladder_4_base": 138.6,
    "ladder_5_euphoria": 200.2
  },
  {
    "symbol": "3046.TW",
    "name": "建碁",
    "sector": "電腦及週邊設備業",
    "close": 51.1,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.22,
    "dog_ma200_bias": -0.043,
    "vr60": 2.18,
    "rs20": 0.6,
    "rs60": 0.7,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.83,
    "low_20d": 46.6,
    "ladder_minus1_pullback": 48.0,
    "ladder_4_base": 46.0,
    "ladder_5_euphoria": 66.4
  },
  {
    "symbol": "3708.TW",
    "name": "上緯投控",
    "sector": "綠能環保",
    "close": 93.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.05,
    "dog_ma200_bias": 0.028,
    "vr60": 1.82,
    "rs20": 0.81,
    "rs60": 0.96,
    "shares": 7547,
    "lots": 7,
    "odd_shares": 547,
    "ntd_at_risk": 39999.1,
    "position_cost": 707908.6,
    "constraint": "WEIGHT",
    "atr14": 2.65,
    "low_20d": 88.0,
    "ladder_minus1_pullback": 88.2,
    "ladder_4_base": 84.4,
    "ladder_5_euphoria": 121.9
  },
  {
    "symbol": "8411.TW",
    "name": "福貞-KY",
    "sector": "其他業",
    "close": 11.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.95,
    "dog_ma200_bias": 0.078,
    "vr60": 2.09,
    "rs20": 1.06,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 286250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.9,
    "ladder_minus1_pullback": 10.8,
    "ladder_4_base": 10.3,
    "ladder_5_euphoria": 14.9
  },
  {
    "symbol": "2535.TW",
    "name": "達欣工",
    "sector": "建材營造業",
    "close": 89.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.5,
    "dog_ma200_bias": -0.266,
    "vr60": 1.05,
    "rs20": 0.24,
    "rs60": 0.35,
    "shares": 3267,
    "lots": 3,
    "odd_shares": 267,
    "ntd_at_risk": 19994.04,
    "position_cost": 291743.1,
    "constraint": "WEIGHT",
    "atr14": 3.06,
    "low_20d": 81.8,
    "ladder_minus1_pullback": 83.9,
    "ladder_4_base": 80.4,
    "ladder_5_euphoria": 116.1
  },
  {
    "symbol": "4178.TW",
    "name": "永笙-KY",
    "sector": "生技醫療業",
    "close": 17.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.24,
    "dog_ma200_bias": 0.076,
    "vr60": 1.27,
    "rs20": 1.0,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 432500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.7,
    "ladder_minus1_pullback": 16.3,
    "ladder_4_base": 15.6,
    "ladder_5_euphoria": 22.5
  },
  {
    "symbol": "1471.TW",
    "name": "首利",
    "sector": "電子零組件業",
    "close": 9.14,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.06,
    "dog_ma200_bias": 0.011,
    "vr60": 1.25,
    "rs20": 0.89,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 228500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.5,
    "ladder_minus1_pullback": 8.6,
    "ladder_4_base": 8.2,
    "ladder_5_euphoria": 11.9
  },
  {
    "symbol": "6419.TWO",
    "name": "京晨科",
    "sector": "光電業",
    "close": 149.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.07,
    "dog_ma200_bias": -0.196,
    "vr60": 0.88,
    "rs20": 0.39,
    "rs60": 0.45,
    "shares": 2433,
    "lots": 2,
    "odd_shares": 433,
    "ntd_at_risk": 19999.26,
    "position_cost": 363733.5,
    "constraint": "WEIGHT",
    "atr14": 4.11,
    "low_20d": 135.4,
    "ladder_minus1_pullback": 140.5,
    "ladder_4_base": 134.6,
    "ladder_5_euphoria": 194.3
  },
  {
    "symbol": "8068.TWO",
    "name": "全達",
    "sector": "電子通路業",
    "close": 18.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.36,
    "dog_ma200_bias": 0.076,
    "vr60": 1.92,
    "rs20": 0.87,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 456250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.7,
    "ladder_minus1_pullback": 17.2,
    "ladder_4_base": 16.4,
    "ladder_5_euphoria": 23.7
  },
  {
    "symbol": "6024.TW",
    "name": "群益期",
    "sector": "金融保險業",
    "close": 58.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.2,
    "dog_ma200_bias": 0.072,
    "vr60": 1.87,
    "rs20": 1.04,
    "rs60": 0.9,
    "shares": 10416,
    "lots": 10,
    "odd_shares": 416,
    "ntd_at_risk": 39997.44,
    "position_cost": 609336.0,
    "constraint": "WEIGHT",
    "atr14": 1.92,
    "low_20d": 56.0,
    "ladder_minus1_pullback": 55.0,
    "ladder_4_base": 52.6,
    "ladder_5_euphoria": 76.0
  },
  {
    "symbol": "3710.TWO",
    "name": "連展投控",
    "sector": "電子零組件業",
    "close": 8.21,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.76,
    "dog_ma200_bias": -0.014,
    "vr60": 1.63,
    "rs20": 0.82,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 205250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.9,
    "ladder_minus1_pullback": 7.7,
    "ladder_4_base": 7.4,
    "ladder_5_euphoria": 10.7
  },
  {
    "symbol": "6761.TWO",
    "name": "穩得",
    "sector": "電子零組件業",
    "close": 151.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.36,
    "dog_ma200_bias": 0.079,
    "vr60": 1.93,
    "rs20": 1.0,
    "rs60": 0.8,
    "shares": 4914,
    "lots": 4,
    "odd_shares": 914,
    "ntd_at_risk": 39999.96,
    "position_cost": 742014.0,
    "constraint": "WEIGHT",
    "atr14": 4.07,
    "low_20d": 140.2,
    "ladder_minus1_pullback": 141.9,
    "ladder_4_base": 135.9,
    "ladder_5_euphoria": 196.3
  },
  {
    "symbol": "9955.TW",
    "name": "佳龍",
    "sector": "綠能環保",
    "close": 22.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.05,
    "dog_ma200_bias": -0.012,
    "vr60": 1.66,
    "rs20": 1.09,
    "rs60": 0.8,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 567500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.6,
    "ladder_minus1_pullback": 21.3,
    "ladder_4_base": 20.4,
    "ladder_5_euphoria": 29.5
  },
  {
    "symbol": "1737.TW",
    "name": "臺鹽",
    "sector": "食品工業",
    "close": 30.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.95,
    "dog_ma200_bias": -0.007,
    "vr60": 1.45,
    "rs20": 1.09,
    "rs60": 0.7,
    "shares": 19047,
    "lots": 19,
    "odd_shares": 47,
    "ntd_at_risk": 39998.7,
    "position_cost": 576171.75,
    "constraint": "WEIGHT",
    "atr14": 1.05,
    "low_20d": 28.8,
    "ladder_minus1_pullback": 28.4,
    "ladder_4_base": 27.2,
    "ladder_5_euphoria": 39.3
  },
  {
    "symbol": "1786.TW",
    "name": "科妍",
    "sector": "生技醫療業",
    "close": 40.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.05,
    "dog_ma200_bias": -0.009,
    "vr60": 1.36,
    "rs20": 0.99,
    "rs60": 0.75,
    "shares": 14285,
    "lots": 14,
    "odd_shares": 285,
    "ntd_at_risk": 39998.0,
    "position_cost": 574971.25,
    "constraint": "WEIGHT",
    "atr14": 1.4,
    "low_20d": 36.6,
    "ladder_minus1_pullback": 37.8,
    "ladder_4_base": 36.2,
    "ladder_5_euphoria": 52.3
  },
  {
    "symbol": "1460.TW",
    "name": "宏遠",
    "sector": "紡織纖維業",
    "close": 6.14,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.5,
    "dog_ma200_bias": 0.025,
    "vr60": 1.93,
    "rs20": 0.85,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 153500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 5.7,
    "ladder_minus1_pullback": 5.8,
    "ladder_4_base": 5.5,
    "ladder_5_euphoria": 8.0
  },
  {
    "symbol": "5324.TWO",
    "name": "士開",
    "sector": "建材營造業",
    "close": 12.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.95,
    "dog_ma200_bias": 0.028,
    "vr60": 1.92,
    "rs20": 1.09,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 312500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.6,
    "ladder_minus1_pullback": 11.8,
    "ladder_4_base": 11.2,
    "ladder_5_euphoria": 16.2
  },
  {
    "symbol": "1442.TW",
    "name": "名軒",
    "sector": "建材營造業",
    "close": 26.75,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.05,
    "dog_ma200_bias": 0.07,
    "vr60": 1.14,
    "rs20": 1.32,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 668750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.6,
    "ladder_minus1_pullback": 25.1,
    "ladder_4_base": 24.1,
    "ladder_5_euphoria": 34.8
  },
  {
    "symbol": "3360.TWO",
    "name": "尚立",
    "sector": "電子通路業",
    "close": 14.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.95,
    "dog_ma200_bias": 0.03,
    "vr60": 2.09,
    "rs20": 1.06,
    "rs60": 0.78,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 361250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.3,
    "ladder_minus1_pullback": 13.6,
    "ladder_4_base": 13.0,
    "ladder_5_euphoria": 18.8
  },
  {
    "symbol": "1616.TW",
    "name": "億泰",
    "sector": "電器電纜業",
    "close": 18.3,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": -0.138,
    "vr60": 0.82,
    "rs20": 0.37,
    "rs60": 0.61,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 16.6,
    "ladder_minus1_pullback": 17.2,
    "ladder_4_base": 16.5,
    "ladder_5_euphoria": 23.8
  },
  {
    "symbol": "2017.TW",
    "name": "官田鋼",
    "sector": "鋼鐵工業",
    "close": 8.94,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.5,
    "dog_ma200_bias": 0.015,
    "vr60": 1.78,
    "rs20": 1.05,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 223500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.5,
    "ladder_minus1_pullback": 8.4,
    "ladder_4_base": 8.0,
    "ladder_5_euphoria": 11.6
  },
  {
    "symbol": "6220.TWO",
    "name": "岳豐",
    "sector": "電子零組件業",
    "close": 25.05,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.95,
    "dog_ma200_bias": -0.063,
    "vr60": 1.66,
    "rs20": 0.51,
    "rs60": 0.71,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 23.9,
    "ladder_minus1_pullback": 23.5,
    "ladder_4_base": 22.5,
    "ladder_5_euphoria": 32.6
  },
  {
    "symbol": "6546.TWO",
    "name": "正基",
    "sector": "通信網路業",
    "close": 59.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.05,
    "dog_ma200_bias": 0.124,
    "vr60": 1.28,
    "rs20": 1.23,
    "rs60": 1.09,
    "shares": 14598,
    "lots": 14,
    "odd_shares": 598,
    "ntd_at_risk": 39998.52,
    "position_cost": 864201.6,
    "constraint": "WEIGHT",
    "atr14": 1.37,
    "low_20d": 53.7,
    "ladder_minus1_pullback": 55.6,
    "ladder_4_base": 53.3,
    "ladder_5_euphoria": 77.0
  },
  {
    "symbol": "6768.TW",
    "name": "志強-KY",
    "sector": "運動休閒",
    "close": 64.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.95,
    "dog_ma200_bias": -0.005,
    "vr60": 1.98,
    "rs20": 0.75,
    "rs60": 1.02,
    "shares": 15873,
    "lots": 15,
    "odd_shares": 873,
    "ntd_at_risk": 39999.96,
    "position_cost": 1023808.5,
    "constraint": "WEIGHT",
    "atr14": 1.26,
    "low_20d": 61.2,
    "ladder_minus1_pullback": 60.6,
    "ladder_4_base": 58.1,
    "ladder_5_euphoria": 83.9
  },
  {
    "symbol": "2364.TW",
    "name": "倫飛",
    "sector": "電腦及週邊設備業",
    "close": 62.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.38,
    "dog_ma200_bias": 0.114,
    "vr60": 1.46,
    "rs20": 1.33,
    "rs60": 1.17,
    "shares": 14814,
    "lots": 14,
    "odd_shares": 814,
    "ntd_at_risk": 39997.8,
    "position_cost": 925875.0,
    "constraint": "WEIGHT",
    "atr14": 1.35,
    "low_20d": 56.3,
    "ladder_minus1_pullback": 58.8,
    "ladder_4_base": 56.2,
    "ladder_5_euphoria": 81.2
  },
  {
    "symbol": "3025.TW",
    "name": "星通",
    "sector": "通信網路業",
    "close": 55.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.36,
    "dog_ma200_bias": -0.273,
    "vr60": 1.06,
    "rs20": 0.45,
    "rs60": 0.53,
    "shares": 7142,
    "lots": 7,
    "odd_shares": 142,
    "ntd_at_risk": 19997.6,
    "position_cost": 392810.0,
    "constraint": "WEIGHT",
    "atr14": 1.4,
    "low_20d": 50.9,
    "ladder_minus1_pullback": 51.7,
    "ladder_4_base": 49.5,
    "ladder_5_euphoria": 71.5
  },
  {
    "symbol": "1720.TW",
    "name": "生達",
    "sector": "生技醫療業",
    "close": 57.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.67,
    "dog_ma200_bias": 0.072,
    "vr60": 1.97,
    "rs20": 0.88,
    "rs60": 0.79,
    "shares": 11428,
    "lots": 11,
    "odd_shares": 428,
    "ntd_at_risk": 39998.0,
    "position_cost": 661681.2,
    "constraint": "WEIGHT",
    "atr14": 1.75,
    "low_20d": 55.1,
    "ladder_minus1_pullback": 54.4,
    "ladder_4_base": 52.1,
    "ladder_5_euphoria": 75.3
  },
  {
    "symbol": "6579.TW",
    "name": "研揚",
    "sector": "電腦及週邊設備業",
    "close": 146.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.17,
    "dog_ma200_bias": 0.072,
    "vr60": 1.44,
    "rs20": 1.11,
    "rs60": 1.21,
    "shares": 4842,
    "lots": 4,
    "odd_shares": 842,
    "ntd_at_risk": 39994.92,
    "position_cost": 709353.0,
    "constraint": "WEIGHT",
    "atr14": 4.13,
    "low_20d": 135.5,
    "ladder_minus1_pullback": 137.7,
    "ladder_4_base": 131.8,
    "ladder_5_euphoria": 190.5
  },
  {
    "symbol": "4771.TW",
    "name": "望隼",
    "sector": "生技醫療業",
    "close": 204.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.54,
    "dog_ma200_bias": 0.055,
    "vr60": 1.86,
    "rs20": 0.99,
    "rs60": 0.77,
    "shares": 6230,
    "lots": 6,
    "odd_shares": 230,
    "ntd_at_risk": 39996.6,
    "position_cost": 1274035.0,
    "constraint": "WEIGHT",
    "atr14": 3.21,
    "low_20d": 185.2,
    "ladder_minus1_pullback": 192.2,
    "ladder_4_base": 184.1,
    "ladder_5_euphoria": 265.9
  },
  {
    "symbol": "5302.TWO",
    "name": "太欣",
    "sector": "半導體業",
    "close": 9.48,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.11,
    "dog_ma200_bias": 0.014,
    "vr60": 1.82,
    "rs20": 0.82,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 237000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 8.9,
    "ladder_4_base": 8.5,
    "ladder_5_euphoria": 12.3
  },
  {
    "symbol": "2221.TWO",
    "name": "大甲",
    "sector": "其他業",
    "close": 126.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.5,
    "dog_ma200_bias": 0.141,
    "vr60": 1.55,
    "rs20": 0.95,
    "rs60": 0.94,
    "shares": 8849,
    "lots": 8,
    "odd_shares": 849,
    "ntd_at_risk": 39997.48,
    "position_cost": 1119398.5,
    "constraint": "WEIGHT",
    "atr14": 2.26,
    "low_20d": 121.2,
    "ladder_minus1_pullback": 118.9,
    "ladder_4_base": 113.9,
    "ladder_5_euphoria": 164.5
  },
  {
    "symbol": "6854.TW",
    "name": "錼創科技-KY創",
    "sector": "半導體業",
    "close": 90.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.33,
    "dog_ma200_bias": -0.01,
    "vr60": 1.6,
    "rs20": 0.84,
    "rs60": 0.8,
    "shares": 12121,
    "lots": 12,
    "odd_shares": 121,
    "ntd_at_risk": 39999.3,
    "position_cost": 1093314.2,
    "constraint": "WEIGHT",
    "atr14": 1.65,
    "low_20d": 84.8,
    "ladder_minus1_pullback": 84.8,
    "ladder_4_base": 81.2,
    "ladder_5_euphoria": 117.3
  },
  {
    "symbol": "3011.TW",
    "name": "今皓",
    "sector": "電子零組件業",
    "close": 9.93,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.06,
    "dog_ma200_bias": -0.001,
    "vr60": 1.22,
    "rs20": 0.79,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 248250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.3,
    "ladder_minus1_pullback": 9.3,
    "ladder_4_base": 8.9,
    "ladder_5_euphoria": 12.9
  },
  {
    "symbol": "1108.TW",
    "name": "幸福",
    "sector": "水泥工業",
    "close": 11.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.33,
    "dog_ma200_bias": 0.046,
    "vr60": 1.95,
    "rs20": 1.13,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 276250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.2,
    "ladder_minus1_pullback": 10.4,
    "ladder_4_base": 9.9,
    "ladder_5_euphoria": 14.4
  },
  {
    "symbol": "2102.TW",
    "name": "泰豐",
    "sector": "橡膠工業",
    "close": 16.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.4,
    "dog_ma200_bias": 0.051,
    "vr60": 1.31,
    "rs20": 1.09,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 403750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.9,
    "ladder_minus1_pullback": 15.2,
    "ladder_4_base": 14.5,
    "ladder_5_euphoria": 21.0
  },
  {
    "symbol": "8374.TW",
    "name": "羅昇",
    "sector": "電機機械業",
    "close": 71.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": 0.046,
    "vr60": 2.01,
    "rs20": 0.98,
    "rs60": 1.04,
    "shares": 16260,
    "lots": 16,
    "odd_shares": 260,
    "ntd_at_risk": 39999.6,
    "position_cost": 1156086.0,
    "constraint": "WEIGHT",
    "atr14": 1.23,
    "low_20d": 67.1,
    "ladder_minus1_pullback": 66.8,
    "ladder_4_base": 64.0,
    "ladder_5_euphoria": 92.4
  },
  {
    "symbol": "6292.TWO",
    "name": "迅德",
    "sector": "電子零組件業",
    "close": 66.4,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.16,
    "dog_ma200_bias": 0.01,
    "vr60": 1.93,
    "rs20": 0.49,
    "rs60": 0.61,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.22,
    "low_20d": 62.4,
    "ladder_minus1_pullback": 62.4,
    "ladder_4_base": 59.8,
    "ladder_5_euphoria": 86.3
  },
  {
    "symbol": "8049.TWO",
    "name": "晶采",
    "sector": "光電業",
    "close": 24.2,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.33,
    "dog_ma200_bias": -0.111,
    "vr60": 0.92,
    "rs20": 0.4,
    "rs60": 0.5,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 22.1,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.8,
    "ladder_5_euphoria": 31.5
  },
  {
    "symbol": "6799.TW",
    "name": "來頡",
    "sector": "半導體業",
    "close": 84.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.5,
    "dog_ma200_bias": 0.07,
    "vr60": 1.89,
    "rs20": 0.88,
    "rs60": 0.76,
    "shares": 9090,
    "lots": 9,
    "odd_shares": 90,
    "ntd_at_risk": 39996.0,
    "position_cost": 768105.0,
    "constraint": "WEIGHT",
    "atr14": 2.2,
    "low_20d": 77.8,
    "ladder_minus1_pullback": 79.4,
    "ladder_4_base": 76.0,
    "ladder_5_euphoria": 109.9
  },
  {
    "symbol": "3607.TW",
    "name": "谷崧",
    "sector": "電子零組件業",
    "close": 13.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.2,
    "dog_ma200_bias": -0.013,
    "vr60": 1.9,
    "rs20": 0.9,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 348750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 13.1,
    "ladder_4_base": 12.6,
    "ladder_5_euphoria": 18.1
  },
  {
    "symbol": "2314.TW",
    "name": "台揚",
    "sector": "通信網路業",
    "close": 10.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.5,
    "dog_ma200_bias": -0.014,
    "vr60": 2.06,
    "rs20": 0.86,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 257500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.5,
    "ladder_minus1_pullback": 9.7,
    "ladder_4_base": 9.3,
    "ladder_5_euphoria": 13.4
  },
  {
    "symbol": "6266.TWO",
    "name": "泰詠",
    "sector": "電子零組件業",
    "close": 25.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.5,
    "dog_ma200_bias": 0.029,
    "vr60": 2.04,
    "rs20": 0.99,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 628750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.8,
    "ladder_minus1_pullback": 23.6,
    "ladder_4_base": 22.6,
    "ladder_5_euphoria": 32.7
  },
  {
    "symbol": "7750.TW",
    "name": "新代",
    "sector": "電機機械業",
    "close": 1800.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.5,
    "dog_ma200_bias": 0.119,
    "vr60": 1.14,
    "rs20": 1.26,
    "rs60": 0.99,
    "shares": 645,
    "lots": 0,
    "odd_shares": 645,
    "ntd_at_risk": 39990.0,
    "position_cost": 1161000.0,
    "constraint": "WEIGHT",
    "atr14": 31.0,
    "low_20d": 1668.5,
    "ladder_minus1_pullback": 1692.0,
    "ladder_4_base": 1620.0,
    "ladder_5_euphoria": 2340.0
  },
  {
    "symbol": "6492.TWO",
    "name": "生華科",
    "sector": "生技醫療業",
    "close": 33.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.33,
    "dog_ma200_bias": 0.044,
    "vr60": 2.02,
    "rs20": 1.04,
    "rs60": 0.74,
    "shares": 18518,
    "lots": 18,
    "odd_shares": 518,
    "ntd_at_risk": 39998.88,
    "position_cost": 616649.4,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 31.4,
    "ladder_minus1_pullback": 31.3,
    "ladder_4_base": 30.0,
    "ladder_5_euphoria": 43.3
  },
  {
    "symbol": "5530.TWO",
    "name": "龍巖",
    "sector": "其他業",
    "close": 48.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.37,
    "dog_ma200_bias": -0.013,
    "vr60": 1.71,
    "rs20": 0.85,
    "rs60": 0.86,
    "shares": 12048,
    "lots": 12,
    "odd_shares": 48,
    "ntd_at_risk": 39999.36,
    "position_cost": 578304.0,
    "constraint": "WEIGHT",
    "atr14": 1.66,
    "low_20d": 45.8,
    "ladder_minus1_pullback": 45.1,
    "ladder_4_base": 43.2,
    "ladder_5_euphoria": 62.4
  },
  {
    "symbol": "4736.TW",
    "name": "泰博",
    "sector": "生技醫療業",
    "close": 133.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.25,
    "dog_ma200_bias": 0.07,
    "vr60": 1.33,
    "rs20": 1.01,
    "rs60": 1.03,
    "shares": 5970,
    "lots": 5,
    "odd_shares": 970,
    "ntd_at_risk": 39999.0,
    "position_cost": 796995.0,
    "constraint": "WEIGHT",
    "atr14": 3.35,
    "low_20d": 125.0,
    "ladder_minus1_pullback": 125.5,
    "ladder_4_base": 120.2,
    "ladder_5_euphoria": 173.6
  },
  {
    "symbol": "1603.TW",
    "name": "華電",
    "sector": "電器電纜業",
    "close": 30.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.43,
    "dog_ma200_bias": 0.046,
    "vr60": 1.44,
    "rs20": 1.03,
    "rs60": 1.02,
    "shares": 18691,
    "lots": 18,
    "odd_shares": 691,
    "ntd_at_risk": 39998.74,
    "position_cost": 571944.6,
    "constraint": "WEIGHT",
    "atr14": 1.07,
    "low_20d": 29.0,
    "ladder_minus1_pullback": 28.8,
    "ladder_4_base": 27.5,
    "ladder_5_euphoria": 39.8
  },
  {
    "symbol": "5209.TWO",
    "name": "新鼎",
    "sector": "其他業",
    "close": 185.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.09,
    "dog_ma200_bias": 0.037,
    "vr60": 1.66,
    "rs20": 1.13,
    "rs60": 0.87,
    "shares": 5555,
    "lots": 5,
    "odd_shares": 555,
    "ntd_at_risk": 39996.0,
    "position_cost": 1027675.0,
    "constraint": "WEIGHT",
    "atr14": 3.6,
    "low_20d": 177.4,
    "ladder_minus1_pullback": 173.9,
    "ladder_4_base": 166.5,
    "ladder_5_euphoria": 240.5
  },
  {
    "symbol": "2440.TW",
    "name": "太空梭",
    "sector": "電子零組件業",
    "close": 14.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.67,
    "dog_ma200_bias": -0.139,
    "vr60": 0.9,
    "rs20": 0.57,
    "rs60": 0.62,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 13.4,
    "ladder_minus1_pullback": 13.6,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 18.9
  },
  {
    "symbol": "7749.TW",
    "name": "意騰-KY",
    "sector": "半導體業",
    "close": 337.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.12,
    "dog_ma200_bias": 0.034,
    "vr60": 1.2,
    "rs20": 1.13,
    "rs60": 0.99,
    "shares": 1843,
    "lots": 1,
    "odd_shares": 843,
    "ntd_at_risk": 39993.1,
    "position_cost": 621091.0,
    "constraint": "WEIGHT",
    "atr14": 10.85,
    "low_20d": 312.9,
    "ladder_minus1_pullback": 316.8,
    "ladder_4_base": 303.3,
    "ladder_5_euphoria": 438.1
  },
  {
    "symbol": "3228.TWO",
    "name": "金麗科",
    "sector": "半導體業",
    "close": 153.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": 0.028,
    "vr60": 1.71,
    "rs20": 1.12,
    "rs60": 0.83,
    "shares": 5882,
    "lots": 5,
    "odd_shares": 882,
    "ntd_at_risk": 39997.6,
    "position_cost": 899946.0,
    "constraint": "WEIGHT",
    "atr14": 3.4,
    "low_20d": 144.8,
    "ladder_minus1_pullback": 143.8,
    "ladder_4_base": 137.7,
    "ladder_5_euphoria": 198.9
  },
  {
    "symbol": "3558.TWO",
    "name": "神準",
    "sector": "通信網路業",
    "close": 135.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.2,
    "dog_ma200_bias": 0.048,
    "vr60": 1.56,
    "rs20": 1.0,
    "rs60": 1.04,
    "shares": 5763,
    "lots": 5,
    "odd_shares": 763,
    "ntd_at_risk": 39995.22,
    "position_cost": 780886.5,
    "constraint": "WEIGHT",
    "atr14": 3.47,
    "low_20d": 127.0,
    "ladder_minus1_pullback": 127.4,
    "ladder_4_base": 122.0,
    "ladder_5_euphoria": 176.2
  },
  {
    "symbol": "6561.TWO",
    "name": "是方",
    "sector": "通信網路業",
    "close": 308.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": 0.198,
    "vr60": 2.13,
    "rs20": 1.49,
    "rs60": 1.13,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.64,
    "low_20d": 284.0,
    "ladder_minus1_pullback": 289.5,
    "ladder_4_base": 277.2,
    "ladder_5_euphoria": 400.4
  },
  {
    "symbol": "2546.TW",
    "name": "根基",
    "sector": "建材營造業",
    "close": 105.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.33,
    "dog_ma200_bias": 0.057,
    "vr60": 1.78,
    "rs20": 0.82,
    "rs60": 0.71,
    "shares": 5952,
    "lots": 5,
    "odd_shares": 952,
    "ntd_at_risk": 39997.44,
    "position_cost": 627936.0,
    "constraint": "WEIGHT",
    "atr14": 3.36,
    "low_20d": 96.5,
    "ladder_minus1_pullback": 99.2,
    "ladder_4_base": 95.0,
    "ladder_5_euphoria": 137.2
  },
  {
    "symbol": "5225.TW",
    "name": "東科-KY",
    "sector": "其他電子業",
    "close": 55.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.71,
    "dog_ma200_bias": 0.018,
    "vr60": 1.37,
    "rs20": 1.03,
    "rs60": 1.01,
    "shares": 10752,
    "lots": 10,
    "odd_shares": 752,
    "ntd_at_risk": 39997.44,
    "position_cost": 591360.0,
    "constraint": "WEIGHT",
    "atr14": 1.86,
    "low_20d": 50.8,
    "ladder_minus1_pullback": 51.7,
    "ladder_4_base": 49.5,
    "ladder_5_euphoria": 71.5
  },
  {
    "symbol": "4560.TW",
    "name": "強信-KY",
    "sector": "電機機械業",
    "close": 29.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.95,
    "dog_ma200_bias": 0.043,
    "vr60": 1.52,
    "rs20": 0.78,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 740000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.7,
    "ladder_minus1_pullback": 27.8,
    "ladder_4_base": 26.6,
    "ladder_5_euphoria": 38.5
  },
  {
    "symbol": "6821.TWO",
    "name": "聯寶",
    "sector": "電子零組件業",
    "close": 44.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.3,
    "dog_ma200_bias": 0.054,
    "vr60": 1.33,
    "rs20": 0.83,
    "rs60": 0.95,
    "shares": 21276,
    "lots": 21,
    "odd_shares": 276,
    "ntd_at_risk": 39998.88,
    "position_cost": 953164.8,
    "constraint": "WEIGHT",
    "atr14": 0.94,
    "low_20d": 40.6,
    "ladder_minus1_pullback": 42.1,
    "ladder_4_base": 40.3,
    "ladder_5_euphoria": 58.2
  },
  {
    "symbol": "3622.TW",
    "name": "洋華",
    "sector": "光電業",
    "close": 45.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.67,
    "dog_ma200_bias": 0.039,
    "vr60": 1.64,
    "rs20": 0.78,
    "rs60": 0.89,
    "shares": 13422,
    "lots": 13,
    "odd_shares": 422,
    "ntd_at_risk": 39997.56,
    "position_cost": 608016.6,
    "constraint": "WEIGHT",
    "atr14": 1.49,
    "low_20d": 42.2,
    "ladder_minus1_pullback": 42.6,
    "ladder_4_base": 40.8,
    "ladder_5_euphoria": 58.9
  },
  {
    "symbol": "6143.TWO",
    "name": "振曜",
    "sector": "通信網路業",
    "close": 77.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.5,
    "dog_ma200_bias": 0.097,
    "vr60": 1.37,
    "rs20": 1.28,
    "rs60": 1.08,
    "shares": 7662,
    "lots": 7,
    "odd_shares": 662,
    "ntd_at_risk": 39995.64,
    "position_cost": 593038.8,
    "constraint": "WEIGHT",
    "atr14": 2.61,
    "low_20d": 74.3,
    "ladder_minus1_pullback": 72.8,
    "ladder_4_base": 69.7,
    "ladder_5_euphoria": 100.6
  },
  {
    "symbol": "6270.TWO",
    "name": "倍微",
    "sector": "電子通路業",
    "close": 28.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.19,
    "dog_ma200_bias": 0.08,
    "vr60": 1.23,
    "rs20": 0.77,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 716250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.0,
    "ladder_minus1_pullback": 26.9,
    "ladder_4_base": 25.8,
    "ladder_5_euphoria": 37.2
  },
  {
    "symbol": "4585.TW",
    "name": "達明",
    "sector": "其他電子業",
    "close": 281.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.12,
    "dog_ma200_bias": -0.016,
    "vr60": 1.31,
    "rs20": 1.07,
    "rs60": 0.93,
    "shares": 2610,
    "lots": 2,
    "odd_shares": 610,
    "ntd_at_risk": 39985.2,
    "position_cost": 733410.0,
    "constraint": "WEIGHT",
    "atr14": 7.66,
    "low_20d": 253.6,
    "ladder_minus1_pullback": 264.1,
    "ladder_4_base": 252.9,
    "ladder_5_euphoria": 365.3
  },
  {
    "symbol": "6645.TW",
    "name": "金萬林-創",
    "sector": "生技醫療業",
    "close": 14.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.11,
    "dog_ma200_bias": 0.026,
    "vr60": 1.81,
    "rs20": 1.1,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 356250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.6,
    "ladder_minus1_pullback": 13.4,
    "ladder_4_base": 12.8,
    "ladder_5_euphoria": 18.5
  },
  {
    "symbol": "3430.TWO",
    "name": "奇鈦科",
    "sector": "化學工業",
    "close": 91.1,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": 0.296,
    "vr60": 2.52,
    "rs20": 1.16,
    "rs60": 1.15,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.76,
    "low_20d": 83.0,
    "ladder_minus1_pullback": 85.6,
    "ladder_4_base": 82.0,
    "ladder_5_euphoria": 118.4
  },
  {
    "symbol": "6957.TW",
    "name": "裕慶-KY",
    "sector": "其他業",
    "close": 463.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.84,
    "dog_ma200_bias": 0.027,
    "vr60": 2.03,
    "rs20": 0.77,
    "rs60": 0.95,
    "shares": 2176,
    "lots": 2,
    "odd_shares": 176,
    "ntd_at_risk": 39994.88,
    "position_cost": 1007488.0,
    "constraint": "WEIGHT",
    "atr14": 9.19,
    "low_20d": 422.6,
    "ladder_minus1_pullback": 435.2,
    "ladder_4_base": 416.7,
    "ladder_5_euphoria": 601.9
  },
  {
    "symbol": "5251.TWO",
    "name": "天鉞電",
    "sector": "光電業",
    "close": 27.6,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.11,
    "dog_ma200_bias": -0.067,
    "vr60": 1.46,
    "rs20": 0.42,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 26.2,
    "ladder_minus1_pullback": 25.9,
    "ladder_4_base": 24.8,
    "ladder_5_euphoria": 35.9
  },
  {
    "symbol": "6642.TWO",
    "name": "富致",
    "sector": "電子零組件業",
    "close": 73.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.07,
    "dog_ma200_bias": 0.026,
    "vr60": 1.35,
    "rs20": 0.99,
    "rs60": 0.99,
    "shares": 16528,
    "lots": 16,
    "odd_shares": 528,
    "ntd_at_risk": 39997.76,
    "position_cost": 1214808.0,
    "constraint": "WEIGHT",
    "atr14": 1.21,
    "low_20d": 66.3,
    "ladder_minus1_pullback": 69.1,
    "ladder_4_base": 66.2,
    "ladder_5_euphoria": 95.5
  },
  {
    "symbol": "8341.TW",
    "name": "日友",
    "sector": "綠能環保",
    "close": 74.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.6,
    "dog_ma200_bias": -0.009,
    "vr60": 1.65,
    "rs20": 1.07,
    "rs60": 0.78,
    "shares": 8230,
    "lots": 8,
    "odd_shares": 230,
    "ntd_at_risk": 39997.8,
    "position_cost": 609843.0,
    "constraint": "WEIGHT",
    "atr14": 2.43,
    "low_20d": 70.6,
    "ladder_minus1_pullback": 69.7,
    "ladder_4_base": 66.7,
    "ladder_5_euphoria": 96.3
  },
  {
    "symbol": "4590.TW",
    "name": "富田-創",
    "sector": "電機機械業",
    "close": 83.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.06,
    "vr60": 1.58,
    "rs20": 1.07,
    "rs60": 1.04,
    "shares": 7042,
    "lots": 7,
    "odd_shares": 42,
    "ntd_at_risk": 39998.56,
    "position_cost": 590823.8,
    "constraint": "WEIGHT",
    "atr14": 2.84,
    "low_20d": 79.8,
    "ladder_minus1_pullback": 78.9,
    "ladder_4_base": 75.5,
    "ladder_5_euphoria": 109.1
  },
  {
    "symbol": "1734.TW",
    "name": "杏輝",
    "sector": "生技醫療業",
    "close": 31.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.5,
    "dog_ma200_bias": 0.048,
    "vr60": 1.49,
    "rs20": 1.14,
    "rs60": 0.9,
    "shares": 22222,
    "lots": 22,
    "odd_shares": 222,
    "ntd_at_risk": 39999.6,
    "position_cost": 702215.2,
    "constraint": "WEIGHT",
    "atr14": 0.9,
    "low_20d": 28.9,
    "ladder_minus1_pullback": 29.7,
    "ladder_4_base": 28.4,
    "ladder_5_euphoria": 41.1
  },
  {
    "symbol": "1466.TW",
    "name": "聚隆",
    "sector": "紡織纖維業",
    "close": 14.35,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.95,
    "dog_ma200_bias": -0.255,
    "vr60": 1.03,
    "rs20": 0.52,
    "rs60": 0.46,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 179375.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.5,
    "ladder_minus1_pullback": 13.5,
    "ladder_4_base": 12.9,
    "ladder_5_euphoria": 18.7
  },
  {
    "symbol": "6894.TWO",
    "name": "衛司特",
    "sector": "綠能環保",
    "close": 393.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.32,
    "dog_ma200_bias": 0.014,
    "vr60": 1.31,
    "rs20": 0.81,
    "rs60": 0.85,
    "shares": 1845,
    "lots": 1,
    "odd_shares": 845,
    "ntd_at_risk": 39999.6,
    "position_cost": 725085.0,
    "constraint": "WEIGHT",
    "atr14": 10.84,
    "low_20d": 366.2,
    "ladder_minus1_pullback": 369.4,
    "ladder_4_base": 353.7,
    "ladder_5_euphoria": 510.9
  },
  {
    "symbol": "6689.TW",
    "name": "伊雲谷",
    "sector": "數位雲端",
    "close": 64.1,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.22,
    "dog_ma200_bias": -0.103,
    "vr60": 0.79,
    "rs20": 0.45,
    "rs60": 0.67,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.34,
    "low_20d": 61.1,
    "ladder_minus1_pullback": 60.3,
    "ladder_4_base": 57.7,
    "ladder_5_euphoria": 83.3
  },
  {
    "symbol": "1219.TW",
    "name": "福壽",
    "sector": "食品工業",
    "close": 11.05,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.25,
    "dog_ma200_bias": -0.194,
    "vr60": 0.63,
    "rs20": 0.6,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 10.6,
    "ladder_minus1_pullback": 10.4,
    "ladder_4_base": 9.9,
    "ladder_5_euphoria": 14.4
  },
  {
    "symbol": "4162.TWO",
    "name": "智擎",
    "sector": "生技醫療業",
    "close": 56.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.46,
    "dog_ma200_bias": 0.058,
    "vr60": 1.21,
    "rs20": 0.94,
    "rs60": 0.7,
    "shares": 10638,
    "lots": 10,
    "odd_shares": 638,
    "ntd_at_risk": 39998.88,
    "position_cost": 602110.8,
    "constraint": "WEIGHT",
    "atr14": 1.88,
    "low_20d": 53.2,
    "ladder_minus1_pullback": 53.2,
    "ladder_4_base": 50.9,
    "ladder_5_euphoria": 73.6
  },
  {
    "symbol": "5315.TWO",
    "name": "光聯",
    "sector": "光電業",
    "close": 18.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.33,
    "dog_ma200_bias": -0.002,
    "vr60": 1.28,
    "rs20": 1.01,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 473750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.8,
    "ladder_minus1_pullback": 17.8,
    "ladder_4_base": 17.1,
    "ladder_5_euphoria": 24.6
  },
  {
    "symbol": "8089.TWO",
    "name": "康全電訊",
    "sector": "通信網路業",
    "close": 20.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.06,
    "dog_ma200_bias": -0.205,
    "vr60": 1.01,
    "rs20": 0.51,
    "rs60": 0.44,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 250000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.6,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 26.0
  },
  {
    "symbol": "4113.TWO",
    "name": "聯上",
    "sector": "建材營造業",
    "close": 14.25,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.5,
    "dog_ma200_bias": 0.308,
    "vr60": 2.12,
    "rs20": 1.29,
    "rs60": 1.43,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 13.1,
    "ladder_minus1_pullback": 13.4,
    "ladder_4_base": 12.8,
    "ladder_5_euphoria": 18.5
  },
  {
    "symbol": "2545.TW",
    "name": "皇翔",
    "sector": "建材營造業",
    "close": 34.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.43,
    "dog_ma200_bias": -0.016,
    "vr60": 1.36,
    "rs20": 0.95,
    "rs60": 1.03,
    "shares": 19047,
    "lots": 19,
    "odd_shares": 47,
    "ntd_at_risk": 39998.7,
    "position_cost": 661883.25,
    "constraint": "WEIGHT",
    "atr14": 1.05,
    "low_20d": 32.9,
    "ladder_minus1_pullback": 32.7,
    "ladder_4_base": 31.3,
    "ladder_5_euphoria": 45.2
  },
  {
    "symbol": "4137.TW",
    "name": "麗豐-KY",
    "sector": "生技醫療業",
    "close": 80.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.29,
    "dog_ma200_bias": 0.043,
    "vr60": 1.9,
    "rs20": 0.89,
    "rs60": 0.7,
    "shares": 7117,
    "lots": 7,
    "odd_shares": 117,
    "ntd_at_risk": 39997.54,
    "position_cost": 572206.8,
    "constraint": "WEIGHT",
    "atr14": 2.81,
    "low_20d": 74.3,
    "ladder_minus1_pullback": 75.6,
    "ladder_4_base": 72.4,
    "ladder_5_euphoria": 104.5
  },
  {
    "symbol": "4171.TWO",
    "name": "瑞基",
    "sector": "農業科技業",
    "close": 17.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.05,
    "dog_ma200_bias": 0.088,
    "vr60": 1.12,
    "rs20": 1.16,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 427500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.5,
    "ladder_minus1_pullback": 16.1,
    "ladder_4_base": 15.4,
    "ladder_5_euphoria": 22.2
  },
  {
    "symbol": "7723.TWO",
    "name": "築間",
    "sector": "觀光餐旅",
    "close": 18.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.05,
    "dog_ma200_bias": 0.016,
    "vr60": 1.89,
    "rs20": 0.97,
    "rs60": 0.78,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 468750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.9,
    "ladder_minus1_pullback": 17.6,
    "ladder_4_base": 16.9,
    "ladder_5_euphoria": 24.4
  },
  {
    "symbol": "8038.TWO",
    "name": "長園科",
    "sector": "電子零組件業",
    "close": 34.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.53,
    "dog_ma200_bias": 0.057,
    "vr60": 1.79,
    "rs20": 0.86,
    "rs60": 0.77,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 718738.5,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 31.3,
    "ladder_minus1_pullback": 32.4,
    "ladder_4_base": 31.1,
    "ladder_5_euphoria": 44.9
  },
  {
    "symbol": "4952.TW",
    "name": "凌通",
    "sector": "半導體業",
    "close": 47.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.37,
    "dog_ma200_bias": 0.06,
    "vr60": 1.82,
    "rs20": 1.14,
    "rs60": 0.87,
    "shares": 14285,
    "lots": 14,
    "odd_shares": 285,
    "ntd_at_risk": 39998.0,
    "position_cost": 677109.0,
    "constraint": "WEIGHT",
    "atr14": 1.4,
    "low_20d": 44.7,
    "ladder_minus1_pullback": 44.6,
    "ladder_4_base": 42.7,
    "ladder_5_euphoria": 61.6
  },
  {
    "symbol": "5907.TW",
    "name": "大洋-KY",
    "sector": "貿易百貨業",
    "close": 4.59,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.64,
    "dog_ma200_bias": -0.002,
    "vr60": 1.8,
    "rs20": 0.77,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 114750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 4.3,
    "ladder_minus1_pullback": 4.3,
    "ladder_4_base": 4.1,
    "ladder_5_euphoria": 6.0
  },
  {
    "symbol": "3284.TWO",
    "name": "太普高",
    "sector": "其他業",
    "close": 19.8,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.42,
    "dog_ma200_bias": 0.237,
    "vr60": 2.03,
    "rs20": 1.27,
    "rs60": 1.38,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 18.9,
    "ladder_minus1_pullback": 18.6,
    "ladder_4_base": 17.8,
    "ladder_5_euphoria": 25.7
  },
  {
    "symbol": "3466.TWO",
    "name": "德晉",
    "sector": "通信網路業",
    "close": 28.6,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.35,
    "dog_ma200_bias": -0.272,
    "vr60": 0.98,
    "rs20": 0.57,
    "rs60": 0.25,
    "shares": 11235,
    "lots": 11,
    "odd_shares": 235,
    "ntd_at_risk": 19998.3,
    "position_cost": 321321.0,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 27.0,
    "ladder_minus1_pullback": 26.9,
    "ladder_4_base": 25.7,
    "ladder_5_euphoria": 37.2
  },
  {
    "symbol": "1713.TW",
    "name": "國化",
    "sector": "化學工業",
    "close": 45.45,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.05,
    "dog_ma200_bias": 0.118,
    "vr60": 1.12,
    "rs20": 1.31,
    "rs60": 1.19,
    "shares": 16393,
    "lots": 16,
    "odd_shares": 393,
    "ntd_at_risk": 39998.92,
    "position_cost": 745061.85,
    "constraint": "WEIGHT",
    "atr14": 1.22,
    "low_20d": 41.8,
    "ladder_minus1_pullback": 42.7,
    "ladder_4_base": 40.9,
    "ladder_5_euphoria": 59.1
  },
  {
    "symbol": "7786.TW",
    "name": "東方風能",
    "sector": "綠能環保",
    "close": 115.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": 0.039,
    "vr60": 1.49,
    "rs20": 0.83,
    "rs60": 0.94,
    "shares": 5649,
    "lots": 5,
    "odd_shares": 649,
    "ntd_at_risk": 39994.92,
    "position_cost": 652459.5,
    "constraint": "WEIGHT",
    "atr14": 3.54,
    "low_20d": 106.0,
    "ladder_minus1_pullback": 108.6,
    "ladder_4_base": 104.0,
    "ladder_5_euphoria": 150.2
  },
  {
    "symbol": "6263.TWO",
    "name": "普萊德",
    "sector": "通信網路業",
    "close": 173.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.05,
    "dog_ma200_bias": 0.013,
    "vr60": 1.9,
    "rs20": 0.88,
    "rs60": 0.73,
    "shares": 3642,
    "lots": 3,
    "odd_shares": 642,
    "ntd_at_risk": 39989.16,
    "position_cost": 630066.0,
    "constraint": "WEIGHT",
    "atr14": 5.49,
    "low_20d": 162.2,
    "ladder_minus1_pullback": 162.6,
    "ladder_4_base": 155.7,
    "ladder_5_euphoria": 224.9
  },
  {
    "symbol": "6499.TWO",
    "name": "益安",
    "sector": "生技醫療業",
    "close": 79.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.24,
    "dog_ma200_bias": 0.054,
    "vr60": 1.98,
    "rs20": 0.9,
    "rs60": 0.78,
    "shares": 7490,
    "lots": 7,
    "odd_shares": 490,
    "ntd_at_risk": 39996.6,
    "position_cost": 596204.0,
    "constraint": "WEIGHT",
    "atr14": 2.67,
    "low_20d": 74.6,
    "ladder_minus1_pullback": 74.8,
    "ladder_4_base": 71.6,
    "ladder_5_euphoria": 103.5
  },
  {
    "symbol": "1587.TW",
    "name": "吉茂",
    "sector": "汽車工業",
    "close": 23.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.07,
    "dog_ma200_bias": 0.027,
    "vr60": 1.64,
    "rs20": 1.11,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 586250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.4,
    "ladder_minus1_pullback": 22.0,
    "ladder_4_base": 21.1,
    "ladder_5_euphoria": 30.5
  },
  {
    "symbol": "3390.TWO",
    "name": "旭軟",
    "sector": "電子零組件業",
    "close": 21.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.08,
    "dog_ma200_bias": 0.073,
    "vr60": 1.61,
    "rs20": 0.9,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 542500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.7,
    "ladder_minus1_pullback": 20.4,
    "ladder_4_base": 19.5,
    "ladder_5_euphoria": 28.2
  },
  {
    "symbol": "1414.TW",
    "name": "東和",
    "sector": "紡織纖維業",
    "close": 17.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.83,
    "dog_ma200_bias": 0.052,
    "vr60": 1.77,
    "rs20": 1.14,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 437500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.1,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.8,
    "ladder_5_euphoria": 22.8
  },
  {
    "symbol": "6679.TWO",
    "name": "鈺太",
    "sector": "半導體業",
    "close": 190.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.05,
    "dog_ma200_bias": 0.075,
    "vr60": 1.47,
    "rs20": 0.97,
    "rs60": 0.95,
    "shares": 4494,
    "lots": 4,
    "odd_shares": 494,
    "ntd_at_risk": 39996.6,
    "position_cost": 853860.0,
    "constraint": "WEIGHT",
    "atr14": 4.45,
    "low_20d": 177.9,
    "ladder_minus1_pullback": 178.6,
    "ladder_4_base": 171.0,
    "ladder_5_euphoria": 247.0
  },
  {
    "symbol": "6170.TWO",
    "name": "統振",
    "sector": "通信網路業",
    "close": 49.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.45,
    "dog_ma200_bias": 0.065,
    "vr60": 1.61,
    "rs20": 0.82,
    "rs60": 0.82,
    "shares": 18518,
    "lots": 18,
    "odd_shares": 518,
    "ntd_at_risk": 39998.88,
    "position_cost": 912011.5,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 45.0,
    "ladder_minus1_pullback": 46.3,
    "ladder_4_base": 44.3,
    "ladder_5_euphoria": 64.0
  },
  {
    "symbol": "6598.TW",
    "name": "ABC-KY",
    "sector": "生技醫療業",
    "close": 28.95,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.36,
    "dog_ma200_bias": 0.009,
    "vr60": 1.84,
    "rs20": 0.68,
    "rs60": 0.67,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 26.9,
    "ladder_minus1_pullback": 27.2,
    "ladder_4_base": 26.1,
    "ladder_5_euphoria": 37.6
  },
  {
    "symbol": "7827.TW",
    "name": "漢康-KY創",
    "sector": "生技醫療業",
    "close": 166.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.25,
    "dog_ma200_bias": -0.003,
    "vr60": 2.07,
    "rs20": 1.09,
    "rs60": 0.73,
    "shares": 3853,
    "lots": 3,
    "odd_shares": 853,
    "ntd_at_risk": 39994.14,
    "position_cost": 639598.0,
    "constraint": "WEIGHT",
    "atr14": 5.19,
    "low_20d": 153.1,
    "ladder_minus1_pullback": 156.0,
    "ladder_4_base": 149.4,
    "ladder_5_euphoria": 215.8
  },
  {
    "symbol": "3508.TWO",
    "name": "位速",
    "sector": "其他電子業",
    "close": 23.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.53,
    "dog_ma200_bias": 0.066,
    "vr60": 1.64,
    "rs20": 1.15,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 595000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.8,
    "ladder_minus1_pullback": 22.4,
    "ladder_4_base": 21.4,
    "ladder_5_euphoria": 30.9
  },
  {
    "symbol": "1806.TW",
    "name": "冠軍",
    "sector": "玻璃陶瓷業",
    "close": 7.99,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.71,
    "dog_ma200_bias": 0.16,
    "vr60": 1.22,
    "rs20": 1.24,
    "rs60": 1.19,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 199750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.2,
    "ladder_minus1_pullback": 7.5,
    "ladder_4_base": 7.2,
    "ladder_5_euphoria": 10.4
  },
  {
    "symbol": "6272.TW",
    "name": "驊陞",
    "sector": "電子零組件業",
    "close": 23.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.55,
    "dog_ma200_bias": 0.09,
    "vr60": 1.25,
    "rs20": 1.18,
    "rs60": 1.26,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 596250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.7,
    "ladder_minus1_pullback": 22.4,
    "ladder_4_base": 21.5,
    "ladder_5_euphoria": 31.0
  },
  {
    "symbol": "3218.TWO",
    "name": "大學光",
    "sector": "生技醫療業",
    "close": 131.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.05,
    "dog_ma200_bias": -0.173,
    "vr60": 0.72,
    "rs20": 0.43,
    "rs60": 0.18,
    "shares": 2375,
    "lots": 2,
    "odd_shares": 375,
    "ntd_at_risk": 19997.5,
    "position_cost": 312312.5,
    "constraint": "WEIGHT",
    "atr14": 4.21,
    "low_20d": 124.2,
    "ladder_minus1_pullback": 123.6,
    "ladder_4_base": 118.4,
    "ladder_5_euphoria": 171.0
  },
  {
    "symbol": "6259.TWO",
    "name": "百徽",
    "sector": "電子零組件業",
    "close": 30.05,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.05,
    "dog_ma200_bias": 0.065,
    "vr60": 1.33,
    "rs20": 1.26,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 751250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.1,
    "ladder_minus1_pullback": 28.2,
    "ladder_4_base": 27.0,
    "ladder_5_euphoria": 39.1
  },
  {
    "symbol": "6841.TWO",
    "name": "長佳智能",
    "sector": "生技醫療業",
    "close": 54.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.2,
    "dog_ma200_bias": -0.126,
    "vr60": 0.77,
    "rs20": 0.58,
    "rs60": 0.64,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.31,
    "low_20d": 52.5,
    "ladder_minus1_pullback": 51.5,
    "ladder_4_base": 49.3,
    "ladder_5_euphoria": 71.2
  },
  {
    "symbol": "9905.TW",
    "name": "大華",
    "sector": "其他業",
    "close": 21.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.95,
    "dog_ma200_bias": -0.199,
    "vr60": 0.76,
    "rs20": 0.42,
    "rs60": 0.18,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 266250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.1,
    "ladder_minus1_pullback": 20.0,
    "ladder_4_base": 19.2,
    "ladder_5_euphoria": 27.7
  },
  {
    "symbol": "1565.TWO",
    "name": "精華",
    "sector": "生技醫療業",
    "close": 89.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.38,
    "dog_ma200_bias": -0.109,
    "vr60": 0.71,
    "rs20": 0.32,
    "rs60": 0.42,
    "shares": 5813,
    "lots": 5,
    "odd_shares": 813,
    "ntd_at_risk": 19996.72,
    "position_cost": 520263.5,
    "constraint": "WEIGHT",
    "atr14": 1.72,
    "low_20d": 81.8,
    "ladder_minus1_pullback": 84.1,
    "ladder_4_base": 80.5,
    "ladder_5_euphoria": 116.4
  },
  {
    "symbol": "6568.TWO",
    "name": "宏觀",
    "sector": "半導體業",
    "close": 135.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.4,
    "dog_ma200_bias": 0.118,
    "vr60": 1.23,
    "rs20": 1.23,
    "rs60": 1.24,
    "shares": 6920,
    "lots": 6,
    "odd_shares": 920,
    "ntd_at_risk": 39997.6,
    "position_cost": 934200.0,
    "constraint": "WEIGHT",
    "atr14": 2.89,
    "low_20d": 126.3,
    "ladder_minus1_pullback": 126.9,
    "ladder_4_base": 121.5,
    "ladder_5_euphoria": 175.5
  },
  {
    "symbol": "6862.TW",
    "name": "三集瑞-KY",
    "sector": "電子零組件業",
    "close": 142.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.2,
    "dog_ma200_bias": 0.055,
    "vr60": 1.22,
    "rs20": 0.93,
    "rs60": 0.97,
    "shares": 4494,
    "lots": 4,
    "odd_shares": 494,
    "ntd_at_risk": 39996.6,
    "position_cost": 638148.0,
    "constraint": "WEIGHT",
    "atr14": 4.45,
    "low_20d": 129.1,
    "ladder_minus1_pullback": 133.5,
    "ladder_4_base": 127.8,
    "ladder_5_euphoria": 184.6
  },
  {
    "symbol": "7825.TWO",
    "name": "和亞智慧",
    "sector": "其他電子業",
    "close": 66.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.23,
    "dog_ma200_bias": 0.165,
    "vr60": 1.29,
    "rs20": 1.27,
    "rs60": 1.05,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 921372.4,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 61.7,
    "ladder_minus1_pullback": 62.8,
    "ladder_4_base": 60.1,
    "ladder_5_euphoria": 86.8
  },
  {
    "symbol": "6902.TW",
    "name": "GOGOLOOK",
    "sector": "數位雲端",
    "close": 131.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.22,
    "dog_ma200_bias": -0.196,
    "vr60": 0.94,
    "rs20": 0.54,
    "rs60": 0.21,
    "shares": 2398,
    "lots": 2,
    "odd_shares": 398,
    "ntd_at_risk": 19999.32,
    "position_cost": 315337.0,
    "constraint": "WEIGHT",
    "atr14": 4.17,
    "low_20d": 124.4,
    "ladder_minus1_pullback": 123.6,
    "ladder_4_base": 118.4,
    "ladder_5_euphoria": 171.0
  },
  {
    "symbol": "4951.TWO",
    "name": "精拓科",
    "sector": "半導體業",
    "close": 87.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.05,
    "dog_ma200_bias": 0.247,
    "vr60": 1.63,
    "rs20": 1.3,
    "rs60": 1.19,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.49,
    "low_20d": 80.2,
    "ladder_minus1_pullback": 82.2,
    "ladder_4_base": 78.8,
    "ladder_5_euphoria": 113.8
  },
  {
    "symbol": "2497.TW",
    "name": "怡利電",
    "sector": "汽車工業",
    "close": 43.75,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.36,
    "dog_ma200_bias": 0.125,
    "vr60": 1.53,
    "rs20": 1.27,
    "rs60": 0.93,
    "shares": 21505,
    "lots": 21,
    "odd_shares": 505,
    "ntd_at_risk": 39999.3,
    "position_cost": 940843.75,
    "constraint": "WEIGHT",
    "atr14": 0.93,
    "low_20d": 40.7,
    "ladder_minus1_pullback": 41.1,
    "ladder_4_base": 39.4,
    "ladder_5_euphoria": 56.9
  },
  {
    "symbol": "2062.TW",
    "name": "橋椿",
    "sector": "居家生活",
    "close": 18.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.4,
    "dog_ma200_bias": 0.166,
    "vr60": 1.49,
    "rs20": 0.97,
    "rs60": 1.28,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 450000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.0,
    "ladder_minus1_pullback": 16.9,
    "ladder_4_base": 16.2,
    "ladder_5_euphoria": 23.4
  },
  {
    "symbol": "2007.TW",
    "name": "燁興",
    "sector": "鋼鐵工業",
    "close": 6.96,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.78,
    "dog_ma200_bias": 0.047,
    "vr60": 2.0,
    "rs20": 0.79,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 174000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 6.3,
    "ladder_minus1_pullback": 6.5,
    "ladder_4_base": 6.3,
    "ladder_5_euphoria": 9.0
  },
  {
    "symbol": "4133.TW",
    "name": "亞諾法",
    "sector": "生技醫療業",
    "close": 21.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": 0.042,
    "vr60": 1.53,
    "rs20": 0.82,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 527500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.0,
    "ladder_minus1_pullback": 19.8,
    "ladder_4_base": 19.0,
    "ladder_5_euphoria": 27.4
  },
  {
    "symbol": "2923.TW",
    "name": "鼎固-KY",
    "sector": "建材營造業",
    "close": 25.3,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.15,
    "dog_ma200_bias": -0.191,
    "vr60": 0.85,
    "rs20": 0.37,
    "rs60": 0.69,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 23.4,
    "ladder_minus1_pullback": 23.8,
    "ladder_4_base": 22.8,
    "ladder_5_euphoria": 32.9
  },
  {
    "symbol": "3444.TWO",
    "name": "利機",
    "sector": "電子通路業",
    "close": 72.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": 0.089,
    "vr60": 1.12,
    "rs20": 1.14,
    "rs60": 1.28,
    "shares": 9569,
    "lots": 9,
    "odd_shares": 569,
    "ntd_at_risk": 39998.42,
    "position_cost": 688968.0,
    "constraint": "WEIGHT",
    "atr14": 2.09,
    "low_20d": 66.7,
    "ladder_minus1_pullback": 67.7,
    "ladder_4_base": 64.8,
    "ladder_5_euphoria": 93.6
  },
  {
    "symbol": "6241.TWO",
    "name": "鑫永洋",
    "sector": "通信網路業",
    "close": 16.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.8,
    "dog_ma200_bias": 0.038,
    "vr60": 2.06,
    "rs20": 0.83,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 415000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.5,
    "ladder_minus1_pullback": 15.6,
    "ladder_4_base": 14.9,
    "ladder_5_euphoria": 21.6
  },
  {
    "symbol": "8109.TWO",
    "name": "博大",
    "sector": "電子零組件業",
    "close": 133.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.05,
    "dog_ma200_bias": 0.003,
    "vr60": 1.52,
    "rs20": 0.86,
    "rs60": 0.94,
    "shares": 7905,
    "lots": 7,
    "odd_shares": 905,
    "ntd_at_risk": 39999.3,
    "position_cost": 1055317.5,
    "constraint": "WEIGHT",
    "atr14": 2.53,
    "low_20d": 127.4,
    "ladder_minus1_pullback": 125.5,
    "ladder_4_base": 120.2,
    "ladder_5_euphoria": 173.6
  },
  {
    "symbol": "5455.TWO",
    "name": "昇益",
    "sector": "建材營造業",
    "close": 30.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.05,
    "dog_ma200_bias": 0.093,
    "vr60": 1.09,
    "rs20": 1.09,
    "rs60": 1.09,
    "shares": 20408,
    "lots": 20,
    "odd_shares": 408,
    "ntd_at_risk": 39999.68,
    "position_cost": 612240.0,
    "constraint": "WEIGHT",
    "atr14": 0.98,
    "low_20d": 28.1,
    "ladder_minus1_pullback": 28.2,
    "ladder_4_base": 27.0,
    "ladder_5_euphoria": 39.0
  },
  {
    "symbol": "8085.TWO",
    "name": "福華",
    "sector": "其他電子業",
    "close": 14.25,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.83,
    "dog_ma200_bias": 0.285,
    "vr60": 1.72,
    "rs20": 1.4,
    "rs60": 1.34,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 13.2,
    "ladder_minus1_pullback": 13.4,
    "ladder_4_base": 12.8,
    "ladder_5_euphoria": 18.5
  },
  {
    "symbol": "5244.TW",
    "name": "弘凱",
    "sector": "光電業",
    "close": 36.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.35,
    "dog_ma200_bias": 0.009,
    "vr60": 1.76,
    "rs20": 1.07,
    "rs60": 1.03,
    "shares": 16260,
    "lots": 16,
    "odd_shares": 260,
    "ntd_at_risk": 39999.6,
    "position_cost": 595929.0,
    "constraint": "WEIGHT",
    "atr14": 1.23,
    "low_20d": 35.0,
    "ladder_minus1_pullback": 34.5,
    "ladder_4_base": 33.0,
    "ladder_5_euphoria": 47.6
  },
  {
    "symbol": "1604.TW",
    "name": "聲寶",
    "sector": "電器電纜業",
    "close": 23.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.4,
    "dog_ma200_bias": 0.157,
    "vr60": 1.61,
    "rs20": 0.98,
    "rs60": 1.26,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 587500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.3,
    "ladder_minus1_pullback": 22.1,
    "ladder_4_base": 21.2,
    "ladder_5_euphoria": 30.6
  },
  {
    "symbol": "7402.TWO",
    "name": "邑錡",
    "sector": "光電業",
    "close": 93.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.05,
    "dog_ma200_bias": 0.026,
    "vr60": 1.27,
    "rs20": 1.11,
    "rs60": 0.8,
    "shares": 8130,
    "lots": 8,
    "odd_shares": 130,
    "ntd_at_risk": 39999.6,
    "position_cost": 756903.0,
    "constraint": "WEIGHT",
    "atr14": 2.46,
    "low_20d": 88.9,
    "ladder_minus1_pullback": 87.5,
    "ladder_4_base": 83.8,
    "ladder_5_euphoria": 121.0
  },
  {
    "symbol": "5487.TWO",
    "name": "通泰",
    "sector": "半導體業",
    "close": 29.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.95,
    "dog_ma200_bias": 0.076,
    "vr60": 1.3,
    "rs20": 0.86,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 746250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.6,
    "ladder_minus1_pullback": 28.1,
    "ladder_4_base": 26.9,
    "ladder_5_euphoria": 38.8
  },
  {
    "symbol": "5306.TW",
    "name": "桂盟",
    "sector": "運動休閒",
    "close": 90.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.27,
    "dog_ma200_bias": 0.03,
    "vr60": 1.99,
    "rs20": 0.96,
    "rs60": 0.92,
    "shares": 7812,
    "lots": 7,
    "odd_shares": 812,
    "ntd_at_risk": 39997.44,
    "position_cost": 705423.6,
    "constraint": "WEIGHT",
    "atr14": 2.56,
    "low_20d": 85.2,
    "ladder_minus1_pullback": 84.9,
    "ladder_4_base": 81.3,
    "ladder_5_euphoria": 117.4
  },
  {
    "symbol": "5014.TWO",
    "name": "建錩",
    "sector": "鋼鐵工業",
    "close": 9.99,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.4,
    "dog_ma200_bias": 0.009,
    "vr60": 2.07,
    "rs20": 0.97,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 249750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 13.0
  },
  {
    "symbol": "3522.TWO",
    "name": "御嵿",
    "sector": "觀光餐旅",
    "close": 11.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.95,
    "dog_ma200_bias": 0.015,
    "vr60": 1.6,
    "rs20": 1.01,
    "rs60": 0.8,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 291250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.7,
    "ladder_minus1_pullback": 11.0,
    "ladder_4_base": 10.5,
    "ladder_5_euphoria": 15.1
  },
  {
    "symbol": "7765.TW",
    "name": "中華資安",
    "sector": "數位雲端",
    "close": 230.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.05,
    "dog_ma200_bias": -0.074,
    "vr60": 2.08,
    "rs20": 0.48,
    "rs60": 0.78,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.51,
    "low_20d": 217.9,
    "ladder_minus1_pullback": 216.7,
    "ladder_4_base": 207.5,
    "ladder_5_euphoria": 299.7
  },
  {
    "symbol": "3004.TW",
    "name": "豐達科",
    "sector": "鋼鐵工業",
    "close": 120.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.67,
    "dog_ma200_bias": 0.021,
    "vr60": 1.51,
    "rs20": 1.01,
    "rs60": 0.81,
    "shares": 6097,
    "lots": 6,
    "odd_shares": 97,
    "ntd_at_risk": 39996.32,
    "position_cost": 734688.5,
    "constraint": "WEIGHT",
    "atr14": 3.28,
    "low_20d": 109.6,
    "ladder_minus1_pullback": 113.3,
    "ladder_4_base": 108.5,
    "ladder_5_euphoria": 156.7
  },
  {
    "symbol": "6613.TWO",
    "name": "朋億*",
    "sector": "其他電子業",
    "close": 270.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.58,
    "dog_ma200_bias": 0.039,
    "vr60": 1.83,
    "rs20": 1.09,
    "rs60": 0.86,
    "shares": 2840,
    "lots": 2,
    "odd_shares": 840,
    "ntd_at_risk": 39987.2,
    "position_cost": 768220.0,
    "constraint": "WEIGHT",
    "atr14": 7.04,
    "low_20d": 250.5,
    "ladder_minus1_pullback": 254.3,
    "ladder_4_base": 243.5,
    "ladder_5_euphoria": 351.7
  },
  {
    "symbol": "7714.TWO",
    "name": "創泓科技",
    "sector": "數位雲端",
    "close": 164.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.05,
    "dog_ma200_bias": 0.01,
    "vr60": 1.32,
    "rs20": 1.07,
    "rs60": 0.76,
    "shares": 3802,
    "lots": 3,
    "odd_shares": 802,
    "ntd_at_risk": 39997.04,
    "position_cost": 625429.0,
    "constraint": "WEIGHT",
    "atr14": 5.26,
    "low_20d": 152.2,
    "ladder_minus1_pullback": 154.6,
    "ladder_4_base": 148.1,
    "ladder_5_euphoria": 213.8
  },
  {
    "symbol": "5484.TW",
    "name": "慧友",
    "sector": "光電業",
    "close": 36.8,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.29,
    "dog_ma200_bias": -0.233,
    "vr60": 0.87,
    "rs20": 0.59,
    "rs60": 0.46,
    "shares": 8264,
    "lots": 8,
    "odd_shares": 264,
    "ntd_at_risk": 19998.88,
    "position_cost": 304115.2,
    "constraint": "WEIGHT",
    "atr14": 1.21,
    "low_20d": 33.2,
    "ladder_minus1_pullback": 34.6,
    "ladder_4_base": 33.1,
    "ladder_5_euphoria": 47.8
  },
  {
    "symbol": "6741.TWO",
    "name": "91APP*-KY",
    "sector": "數位雲端",
    "close": 54.2,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.5,
    "dog_ma200_bias": -0.045,
    "vr60": 1.71,
    "rs20": 0.46,
    "rs60": 0.77,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.58,
    "low_20d": 48.8,
    "ladder_minus1_pullback": 50.9,
    "ladder_4_base": 48.8,
    "ladder_5_euphoria": 70.5
  },
  {
    "symbol": "3669.TW",
    "name": "圓展",
    "sector": "通信網路業",
    "close": 31.75,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.22,
    "dog_ma200_bias": -0.16,
    "vr60": 0.94,
    "rs20": 0.59,
    "rs60": 0.59,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 29.8,
    "ladder_minus1_pullback": 29.8,
    "ladder_4_base": 28.6,
    "ladder_5_euphoria": 41.3
  },
  {
    "symbol": "6914.TW",
    "name": "阜爾運通",
    "sector": "其他業",
    "close": 116.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.4,
    "dog_ma200_bias": 0.047,
    "vr60": 1.34,
    "rs20": 0.85,
    "rs60": 0.71,
    "shares": 5115,
    "lots": 5,
    "odd_shares": 115,
    "ntd_at_risk": 39999.3,
    "position_cost": 593340.0,
    "constraint": "WEIGHT",
    "atr14": 3.91,
    "low_20d": 109.1,
    "ladder_minus1_pullback": 109.0,
    "ladder_4_base": 104.4,
    "ladder_5_euphoria": 150.8
  },
  {
    "symbol": "1446.TW",
    "name": "宏和",
    "sector": "紡織纖維業",
    "close": 13.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.33,
    "dog_ma200_bias": -0.048,
    "vr60": 1.41,
    "rs20": 0.49,
    "rs60": 0.51,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 12.9,
    "ladder_minus1_pullback": 12.7,
    "ladder_4_base": 12.2,
    "ladder_5_euphoria": 17.6
  },
  {
    "symbol": "6690.TWO",
    "name": "安碁資訊",
    "sector": "數位雲端",
    "close": 175.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.07,
    "dog_ma200_bias": -0.017,
    "vr60": 1.49,
    "rs20": 0.89,
    "rs60": 0.83,
    "shares": 3284,
    "lots": 3,
    "odd_shares": 284,
    "ntd_at_risk": 39999.12,
    "position_cost": 576342.0,
    "constraint": "WEIGHT",
    "atr14": 6.09,
    "low_20d": 165.9,
    "ladder_minus1_pullback": 165.0,
    "ladder_4_base": 158.0,
    "ladder_5_euphoria": 228.2
  },
  {
    "symbol": "3447.TW",
    "name": "展達",
    "sector": "通信網路業",
    "close": 27.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.09,
    "dog_ma200_bias": 0.034,
    "vr60": 1.35,
    "rs20": 0.87,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 687500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.8,
    "ladder_minus1_pullback": 25.8,
    "ladder_4_base": 24.8,
    "ladder_5_euphoria": 35.8
  },
  {
    "symbol": "7730.TW",
    "name": "暉盛-創",
    "sector": "半導體業",
    "close": 199.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.67,
    "dog_ma200_bias": 0.02,
    "vr60": 1.65,
    "rs20": 0.81,
    "rs60": 0.86,
    "shares": 4000,
    "lots": 4,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 796000.0,
    "constraint": "WEIGHT",
    "atr14": 5.0,
    "low_20d": 185.4,
    "ladder_minus1_pullback": 187.1,
    "ladder_4_base": 179.1,
    "ladder_5_euphoria": 258.7
  },
  {
    "symbol": "2832.TW",
    "name": "台產",
    "sector": "金融保險業",
    "close": 57.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.67,
    "dog_ma200_bias": -0.222,
    "vr60": 0.65,
    "rs20": 0.5,
    "rs60": 0.54,
    "shares": 5617,
    "lots": 5,
    "odd_shares": 617,
    "ntd_at_risk": 19996.52,
    "position_cost": 321854.1,
    "constraint": "WEIGHT",
    "atr14": 1.78,
    "low_20d": 52.9,
    "ladder_minus1_pullback": 53.9,
    "ladder_4_base": 51.6,
    "ladder_5_euphoria": 74.5
  },
  {
    "symbol": "1799.TWO",
    "name": "易威",
    "sector": "生技醫療業",
    "close": 28.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": 0.145,
    "vr60": 1.33,
    "rs20": 1.07,
    "rs60": 1.28,
    "shares": 24390,
    "lots": 24,
    "odd_shares": 390,
    "ntd_at_risk": 39999.6,
    "position_cost": 685359.0,
    "constraint": "WEIGHT",
    "atr14": 0.82,
    "low_20d": 25.9,
    "ladder_minus1_pullback": 26.4,
    "ladder_4_base": 25.3,
    "ladder_5_euphoria": 36.5
  },
  {
    "symbol": "6208.TWO",
    "name": "日揚",
    "sector": "半導體業",
    "close": 72.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.38,
    "dog_ma200_bias": 0.078,
    "vr60": 1.72,
    "rs20": 0.81,
    "rs60": 0.9,
    "shares": 7936,
    "lots": 7,
    "odd_shares": 936,
    "ntd_at_risk": 39997.44,
    "position_cost": 576947.2,
    "constraint": "WEIGHT",
    "atr14": 2.52,
    "low_20d": 67.8,
    "ladder_minus1_pullback": 68.3,
    "ladder_4_base": 65.4,
    "ladder_5_euphoria": 94.5
  },
  {
    "symbol": "2434.TW",
    "name": "統懋",
    "sector": "半導體業",
    "close": 53.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.05,
    "dog_ma200_bias": 0.071,
    "vr60": 1.6,
    "rs20": 1.03,
    "rs60": 0.96,
    "shares": 23255,
    "lots": 23,
    "odd_shares": 255,
    "ntd_at_risk": 39998.6,
    "position_cost": 1241817.0,
    "constraint": "WEIGHT",
    "atr14": 0.86,
    "low_20d": 49.3,
    "ladder_minus1_pullback": 50.2,
    "ladder_4_base": 48.1,
    "ladder_5_euphoria": 69.4
  },
  {
    "symbol": "9908.TW",
    "name": "大台北",
    "sector": "油電燃氣業",
    "close": 29.1,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.6,
    "dog_ma200_bias": 0.01,
    "vr60": 1.43,
    "rs20": 0.59,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 26.3,
    "ladder_minus1_pullback": 27.4,
    "ladder_4_base": 26.2,
    "ladder_5_euphoria": 37.8
  },
  {
    "symbol": "6558.TW",
    "name": "興能高",
    "sector": "其他電子業",
    "close": 23.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.17,
    "dog_ma200_bias": 0.064,
    "vr60": 1.6,
    "rs20": 0.79,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 587500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.8,
    "ladder_minus1_pullback": 22.1,
    "ladder_4_base": 21.2,
    "ladder_5_euphoria": 30.6
  },
  {
    "symbol": "4108.TW",
    "name": "懷特",
    "sector": "生技醫療業",
    "close": 11.2,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.05,
    "dog_ma200_bias": -0.11,
    "vr60": 0.8,
    "rs20": 0.38,
    "rs60": 0.68,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 10.2,
    "ladder_minus1_pullback": 10.5,
    "ladder_4_base": 10.1,
    "ladder_5_euphoria": 14.6
  },
  {
    "symbol": "2753.TW",
    "name": "八方雲集",
    "sector": "觀光餐旅",
    "close": 184.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.83,
    "dog_ma200_bias": 0.093,
    "vr60": 1.06,
    "rs20": 1.17,
    "rs60": 1.08,
    "shares": 3787,
    "lots": 3,
    "odd_shares": 787,
    "ntd_at_risk": 39990.72,
    "position_cost": 698701.5,
    "constraint": "WEIGHT",
    "atr14": 5.28,
    "low_20d": 176.4,
    "ladder_minus1_pullback": 173.4,
    "ladder_4_base": 166.1,
    "ladder_5_euphoria": 239.8
  },
  {
    "symbol": "1725.TW",
    "name": "元禎",
    "sector": "化學工業",
    "close": 34.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.42,
    "dog_ma200_bias": 0.141,
    "vr60": 1.1,
    "rs20": 1.15,
    "rs60": 0.98,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 757604.15,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 31.5,
    "ladder_minus1_pullback": 32.8,
    "ladder_4_base": 31.4,
    "ladder_5_euphoria": 45.3
  },
  {
    "symbol": "1623.TW",
    "name": "大東電",
    "sector": "電器電纜業",
    "close": 187.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.05,
    "dog_ma200_bias": 0.012,
    "vr60": 1.74,
    "rs20": 1.13,
    "rs60": 1.02,
    "shares": 3656,
    "lots": 3,
    "odd_shares": 656,
    "ntd_at_risk": 39996.64,
    "position_cost": 683672.0,
    "constraint": "WEIGHT",
    "atr14": 5.47,
    "low_20d": 174.0,
    "ladder_minus1_pullback": 175.8,
    "ladder_4_base": 168.3,
    "ladder_5_euphoria": 243.1
  },
  {
    "symbol": "3207.TWO",
    "name": "耀勝",
    "sector": "電子零組件業",
    "close": 37.2,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.05,
    "dog_ma200_bias": 0.252,
    "vr60": 1.75,
    "rs20": 1.45,
    "rs60": 1.23,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.26,
    "low_20d": 33.5,
    "ladder_minus1_pullback": 35.0,
    "ladder_4_base": 33.5,
    "ladder_5_euphoria": 48.4
  },
  {
    "symbol": "6101.TWO",
    "name": "寬魚國際",
    "sector": "文化創意業",
    "close": 37.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.45,
    "dog_ma200_bias": 0.008,
    "vr60": 1.52,
    "rs20": 1.14,
    "rs60": 1.01,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 831427.0,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 34.3,
    "ladder_minus1_pullback": 34.8,
    "ladder_4_base": 33.3,
    "ladder_5_euphoria": 48.1
  },
  {
    "symbol": "2231.TW",
    "name": "為升",
    "sector": "汽車工業",
    "close": 90.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.21,
    "dog_ma200_bias": -0.264,
    "vr60": 0.98,
    "rs20": 0.38,
    "rs60": 0.55,
    "shares": 5128,
    "lots": 5,
    "odd_shares": 128,
    "ntd_at_risk": 19999.2,
    "position_cost": 463058.4,
    "constraint": "WEIGHT",
    "atr14": 1.95,
    "low_20d": 83.6,
    "ladder_minus1_pullback": 84.9,
    "ladder_4_base": 81.3,
    "ladder_5_euphoria": 117.4
  },
  {
    "symbol": "6573.TW",
    "name": "虹揚-KY",
    "sector": "半導體業",
    "close": 15.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.15,
    "dog_ma200_bias": 0.095,
    "vr60": 1.53,
    "rs20": 1.34,
    "rs60": 1.07,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 381250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.5,
    "ladder_minus1_pullback": 14.3,
    "ladder_4_base": 13.7,
    "ladder_5_euphoria": 19.8
  },
  {
    "symbol": "3546.TWO",
    "name": "宇峻",
    "sector": "文化創意業",
    "close": 74.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.56,
    "dog_ma200_bias": 0.07,
    "vr60": 1.33,
    "rs20": 0.98,
    "rs60": 0.73,
    "shares": 9433,
    "lots": 9,
    "odd_shares": 433,
    "ntd_at_risk": 39995.92,
    "position_cost": 698985.3,
    "constraint": "WEIGHT",
    "atr14": 2.12,
    "low_20d": 69.7,
    "ladder_minus1_pullback": 69.7,
    "ladder_4_base": 66.7,
    "ladder_5_euphoria": 96.3
  },
  {
    "symbol": "8927.TWO",
    "name": "北基",
    "sector": "油電燃氣業",
    "close": 17.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.05,
    "dog_ma200_bias": -0.243,
    "vr60": 0.86,
    "rs20": 0.55,
    "rs60": 0.55,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 217500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.0,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.7,
    "ladder_5_euphoria": 22.6
  },
  {
    "symbol": "8942.TWO",
    "name": "森鉅",
    "sector": "其他業",
    "close": 40.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.56,
    "dog_ma200_bias": 0.076,
    "vr60": 1.88,
    "rs20": 0.79,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1002500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.1,
    "ladder_minus1_pullback": 37.7,
    "ladder_4_base": 36.1,
    "ladder_5_euphoria": 52.1
  },
  {
    "symbol": "1342.TW",
    "name": "八貫",
    "sector": "其他業",
    "close": 100.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.33,
    "dog_ma200_bias": 0.071,
    "vr60": 1.57,
    "rs20": 0.97,
    "rs60": 0.95,
    "shares": 7782,
    "lots": 7,
    "odd_shares": 782,
    "ntd_at_risk": 39999.48,
    "position_cost": 782091.0,
    "constraint": "WEIGHT",
    "atr14": 2.57,
    "low_20d": 92.1,
    "ladder_minus1_pullback": 94.5,
    "ladder_4_base": 90.5,
    "ladder_5_euphoria": 130.7
  },
  {
    "symbol": "4430.TWO",
    "name": "耀億",
    "sector": "其他業",
    "close": 22.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.36,
    "dog_ma200_bias": 0.056,
    "vr60": 1.32,
    "rs20": 0.82,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 550000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.3,
    "ladder_minus1_pullback": 20.7,
    "ladder_4_base": 19.8,
    "ladder_5_euphoria": 28.6
  },
  {
    "symbol": "5609.TWO",
    "name": "中菲行",
    "sector": "航運業",
    "close": 79.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.25,
    "dog_ma200_bias": -0.18,
    "vr60": 0.67,
    "rs20": 0.53,
    "rs60": 0.49,
    "shares": 6802,
    "lots": 6,
    "odd_shares": 802,
    "ntd_at_risk": 19997.88,
    "position_cost": 537358.0,
    "constraint": "WEIGHT",
    "atr14": 1.47,
    "low_20d": 75.0,
    "ladder_minus1_pullback": 74.3,
    "ladder_4_base": 71.1,
    "ladder_5_euphoria": 102.7
  },
  {
    "symbol": "6725.TWO",
    "name": "矽科宏晟",
    "sector": "其他電子業",
    "close": 195.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.2,
    "dog_ma200_bias": 0.036,
    "vr60": 1.62,
    "rs20": 0.76,
    "rs60": 0.7,
    "shares": 4115,
    "lots": 4,
    "odd_shares": 115,
    "ntd_at_risk": 39997.8,
    "position_cost": 802425.0,
    "constraint": "WEIGHT",
    "atr14": 4.86,
    "low_20d": 185.8,
    "ladder_minus1_pullback": 183.3,
    "ladder_4_base": 175.5,
    "ladder_5_euphoria": 253.5
  },
  {
    "symbol": "6585.TW",
    "name": "鼎基",
    "sector": "其他業",
    "close": 97.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": 0.006,
    "vr60": 2.06,
    "rs20": 1.08,
    "rs60": 0.87,
    "shares": 6024,
    "lots": 6,
    "odd_shares": 24,
    "ntd_at_risk": 39999.36,
    "position_cost": 589147.2,
    "constraint": "WEIGHT",
    "atr14": 3.32,
    "low_20d": 90.5,
    "ladder_minus1_pullback": 91.9,
    "ladder_4_base": 88.0,
    "ladder_5_euphoria": 127.1
  },
  {
    "symbol": "2929.TW",
    "name": "淘帝-KY",
    "sector": "貿易百貨業",
    "close": 5.74,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.63,
    "dog_ma200_bias": 0.045,
    "vr60": 2.0,
    "rs20": 0.92,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 143500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 5.4,
    "ladder_minus1_pullback": 5.4,
    "ladder_4_base": 5.2,
    "ladder_5_euphoria": 7.5
  },
  {
    "symbol": "3213.TWO",
    "name": "茂訊",
    "sector": "電腦及週邊設備業",
    "close": 122.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.05,
    "dog_ma200_bias": 0.049,
    "vr60": 1.42,
    "rs20": 0.8,
    "rs60": 0.8,
    "shares": 9216,
    "lots": 9,
    "odd_shares": 216,
    "ntd_at_risk": 39997.44,
    "position_cost": 1124352.0,
    "constraint": "WEIGHT",
    "atr14": 2.17,
    "low_20d": 114.6,
    "ladder_minus1_pullback": 114.7,
    "ladder_4_base": 109.8,
    "ladder_5_euphoria": 158.6
  },
  {
    "symbol": "6840.TWO",
    "name": "東研信超",
    "sector": "其他電子業",
    "close": 83.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.29,
    "dog_ma200_bias": 0.079,
    "vr60": 1.26,
    "rs20": 1.05,
    "rs60": 0.9,
    "shares": 10869,
    "lots": 10,
    "odd_shares": 869,
    "ntd_at_risk": 39997.92,
    "position_cost": 905387.7,
    "constraint": "WEIGHT",
    "atr14": 1.84,
    "low_20d": 76.4,
    "ladder_minus1_pullback": 78.3,
    "ladder_4_base": 75.0,
    "ladder_5_euphoria": 108.3
  },
  {
    "symbol": "4536.TW",
    "name": "拓凱",
    "sector": "運動休閒",
    "close": 156.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.5,
    "dog_ma200_bias": 0.037,
    "vr60": 1.98,
    "rs20": 1.0,
    "rs60": 0.87,
    "shares": 5115,
    "lots": 5,
    "odd_shares": 115,
    "ntd_at_risk": 39999.3,
    "position_cost": 800497.5,
    "constraint": "WEIGHT",
    "atr14": 3.91,
    "low_20d": 148.5,
    "ladder_minus1_pullback": 147.1,
    "ladder_4_base": 140.8,
    "ladder_5_euphoria": 203.5
  },
  {
    "symbol": "3548.TWO",
    "name": "兆利",
    "sector": "電子零組件業",
    "close": 71.3,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.58,
    "dog_ma200_bias": -0.011,
    "vr60": 1.41,
    "rs20": 0.58,
    "rs60": 0.65,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.39,
    "low_20d": 64.2,
    "ladder_minus1_pullback": 67.0,
    "ladder_4_base": 64.2,
    "ladder_5_euphoria": 92.7
  },
  {
    "symbol": "7812.TW",
    "name": "稜研科技*-創",
    "sector": "通信網路業",
    "close": 63.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.62,
    "dog_ma200_bias": 0.08,
    "vr60": 1.09,
    "rs20": 1.08,
    "rs60": 1.25,
    "shares": 14492,
    "lots": 14,
    "odd_shares": 492,
    "ntd_at_risk": 39997.92,
    "position_cost": 917343.6,
    "constraint": "WEIGHT",
    "atr14": 1.38,
    "low_20d": 57.9,
    "ladder_minus1_pullback": 59.5,
    "ladder_4_base": 57.0,
    "ladder_5_euphoria": 82.3
  },
  {
    "symbol": "8249.TW",
    "name": "菱光",
    "sector": "電子零組件業",
    "close": 39.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.21,
    "dog_ma200_bias": -0.006,
    "vr60": 1.35,
    "rs20": 0.86,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 990000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.6,
    "ladder_minus1_pullback": 37.2,
    "ladder_4_base": 35.6,
    "ladder_5_euphoria": 51.5
  },
  {
    "symbol": "8467.TW",
    "name": "波力-KY",
    "sector": "運動休閒",
    "close": 100.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.05,
    "dog_ma200_bias": 0.071,
    "vr60": 1.52,
    "rs20": 0.87,
    "rs60": 0.89,
    "shares": 12269,
    "lots": 12,
    "odd_shares": 269,
    "ntd_at_risk": 39996.94,
    "position_cost": 1233034.5,
    "constraint": "WEIGHT",
    "atr14": 1.63,
    "low_20d": 94.2,
    "ladder_minus1_pullback": 94.5,
    "ladder_4_base": 90.5,
    "ladder_5_euphoria": 130.7
  },
  {
    "symbol": "4552.TW",
    "name": "力達-KY",
    "sector": "電機機械業",
    "close": 14.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.5,
    "dog_ma200_bias": 0.074,
    "vr60": 1.66,
    "rs20": 1.06,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 372500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 14.0,
    "ladder_4_base": 13.4,
    "ladder_5_euphoria": 19.4
  },
  {
    "symbol": "6115.TW",
    "name": "鎰勝",
    "sector": "電子零組件業",
    "close": 43.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.25,
    "dog_ma200_bias": -0.011,
    "vr60": 1.88,
    "rs20": 0.97,
    "rs60": 1.01,
    "shares": 20000,
    "lots": 20,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 878000.0,
    "constraint": "WEIGHT",
    "atr14": 1.0,
    "low_20d": 42.1,
    "ladder_minus1_pullback": 41.3,
    "ladder_4_base": 39.5,
    "ladder_5_euphoria": 57.1
  },
  {
    "symbol": "6708.TWO",
    "name": "天擎",
    "sector": "半導體業",
    "close": 58.2,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": 0.003,
    "vr60": 1.92,
    "rs20": 0.51,
    "rs60": 0.69,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.53,
    "low_20d": 52.9,
    "ladder_minus1_pullback": 54.7,
    "ladder_4_base": 52.4,
    "ladder_5_euphoria": 75.7
  },
  {
    "symbol": "4583.TW",
    "name": "台灣精銳",
    "sector": "電機機械業",
    "close": 395.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.19,
    "dog_ma200_bias": -0.01,
    "vr60": 1.72,
    "rs20": 1.08,
    "rs60": 0.7,
    "shares": 2699,
    "lots": 2,
    "odd_shares": 699,
    "ntd_at_risk": 39999.18,
    "position_cost": 1066105.0,
    "constraint": "WEIGHT",
    "atr14": 7.41,
    "low_20d": 364.5,
    "ladder_minus1_pullback": 371.3,
    "ladder_4_base": 355.5,
    "ladder_5_euphoria": 513.5
  },
  {
    "symbol": "3038.TW",
    "name": "全台",
    "sector": "光電業",
    "close": 20.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.33,
    "dog_ma200_bias": 0.032,
    "vr60": 1.54,
    "rs20": 0.94,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 507500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.1,
    "ladder_minus1_pullback": 19.1,
    "ladder_4_base": 18.3,
    "ladder_5_euphoria": 26.4
  },
  {
    "symbol": "5474.TWO",
    "name": "聰泰",
    "sector": "電腦及週邊設備業",
    "close": 149.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.18,
    "dog_ma200_bias": 0.071,
    "vr60": 1.29,
    "rs20": 0.81,
    "rs60": 0.78,
    "shares": 4040,
    "lots": 4,
    "odd_shares": 40,
    "ntd_at_risk": 39996.0,
    "position_cost": 601960.0,
    "constraint": "WEIGHT",
    "atr14": 4.95,
    "low_20d": 137.7,
    "ladder_minus1_pullback": 140.1,
    "ladder_4_base": 134.1,
    "ladder_5_euphoria": 193.7
  },
  {
    "symbol": "7828.TWO",
    "name": "創新服務",
    "sector": "半導體業",
    "close": 1605.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.1,
    "dog_ma200_bias": -0.001,
    "vr60": 2.01,
    "rs20": 1.0,
    "rs60": 0.99,
    "shares": 379,
    "lots": 0,
    "odd_shares": 379,
    "ntd_at_risk": 39939.02,
    "position_cost": 608295.0,
    "constraint": "WEIGHT",
    "atr14": 52.69,
    "low_20d": 1472.8,
    "ladder_minus1_pullback": 1508.7,
    "ladder_4_base": 1444.5,
    "ladder_5_euphoria": 2086.5
  },
  {
    "symbol": "5511.TWO",
    "name": "德昌",
    "sector": "建材營造業",
    "close": 69.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.25,
    "dog_ma200_bias": 0.033,
    "vr60": 1.68,
    "rs20": 0.97,
    "rs60": 0.96,
    "shares": 15503,
    "lots": 15,
    "odd_shares": 503,
    "ntd_at_risk": 39997.74,
    "position_cost": 1080559.1,
    "constraint": "WEIGHT",
    "atr14": 1.29,
    "low_20d": 66.3,
    "ladder_minus1_pullback": 65.5,
    "ladder_4_base": 62.7,
    "ladder_5_euphoria": 90.6
  },
  {
    "symbol": "2415.TW",
    "name": "錩新",
    "sector": "電子零組件業",
    "close": 26.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.31,
    "dog_ma200_bias": -0.009,
    "vr60": 1.61,
    "rs20": 0.78,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 673750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.8,
    "ladder_minus1_pullback": 25.3,
    "ladder_4_base": 24.3,
    "ladder_5_euphoria": 35.0
  },
  {
    "symbol": "6486.TWO",
    "name": "互動",
    "sector": "通信網路業",
    "close": 78.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.57,
    "dog_ma200_bias": 0.072,
    "vr60": 1.63,
    "rs20": 0.87,
    "rs60": 0.83,
    "shares": 7490,
    "lots": 7,
    "odd_shares": 490,
    "ntd_at_risk": 39996.6,
    "position_cost": 585718.0,
    "constraint": "WEIGHT",
    "atr14": 2.67,
    "low_20d": 70.7,
    "ladder_minus1_pullback": 73.5,
    "ladder_4_base": 70.4,
    "ladder_5_euphoria": 101.7
  },
  {
    "symbol": "7768.TW",
    "name": "頌勝科技",
    "sector": "半導體業",
    "close": 286.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.95,
    "dog_ma200_bias": 0.062,
    "vr60": 2.0,
    "rs20": 0.99,
    "rs60": 0.97,
    "shares": 3289,
    "lots": 3,
    "odd_shares": 289,
    "ntd_at_risk": 39994.24,
    "position_cost": 942298.5,
    "constraint": "WEIGHT",
    "atr14": 6.08,
    "low_20d": 270.0,
    "ladder_minus1_pullback": 269.3,
    "ladder_4_base": 257.9,
    "ladder_5_euphoria": 372.4
  },
  {
    "symbol": "5706.TW",
    "name": "鳳凰",
    "sector": "觀光餐旅",
    "close": 43.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.17,
    "dog_ma200_bias": 0.014,
    "vr60": 1.84,
    "rs20": 0.76,
    "rs60": 0.99,
    "shares": 24390,
    "lots": 24,
    "odd_shares": 390,
    "ntd_at_risk": 39999.6,
    "position_cost": 1068282.0,
    "constraint": "WEIGHT",
    "atr14": 0.82,
    "low_20d": 40.7,
    "ladder_minus1_pullback": 41.2,
    "ladder_4_base": 39.4,
    "ladder_5_euphoria": 56.9
  },
  {
    "symbol": "4207.TWO",
    "name": "環泰",
    "sector": "食品工業",
    "close": 19.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.95,
    "dog_ma200_bias": 0.002,
    "vr60": 1.97,
    "rs20": 0.81,
    "rs60": 0.78,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 482500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.8,
    "ladder_minus1_pullback": 18.1,
    "ladder_4_base": 17.4,
    "ladder_5_euphoria": 25.1
  },
  {
    "symbol": "4933.TWO",
    "name": "友輝",
    "sector": "光電業",
    "close": 51.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.67,
    "dog_ma200_bias": -0.007,
    "vr60": 1.32,
    "rs20": 0.78,
    "rs60": 0.94,
    "shares": 11695,
    "lots": 11,
    "odd_shares": 695,
    "ntd_at_risk": 39996.9,
    "position_cost": 598784.0,
    "constraint": "WEIGHT",
    "atr14": 1.71,
    "low_20d": 46.3,
    "ladder_minus1_pullback": 48.1,
    "ladder_4_base": 46.1,
    "ladder_5_euphoria": 66.6
  },
  {
    "symbol": "6151.TWO",
    "name": "晉倫",
    "sector": "其他電子業",
    "close": 33.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.09,
    "dog_ma200_bias": 0.058,
    "vr60": 1.27,
    "rs20": 1.06,
    "rs60": 0.97,
    "shares": 22727,
    "lots": 22,
    "odd_shares": 727,
    "ntd_at_risk": 39999.52,
    "position_cost": 770445.3,
    "constraint": "WEIGHT",
    "atr14": 0.88,
    "low_20d": 31.8,
    "ladder_minus1_pullback": 31.9,
    "ladder_4_base": 30.5,
    "ladder_5_euphoria": 44.1
  },
  {
    "symbol": "6698.TW",
    "name": "旭暉應材",
    "sector": "其他電子業",
    "close": 30.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.19,
    "dog_ma200_bias": -0.016,
    "vr60": 1.3,
    "rs20": 1.07,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 760000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.2,
    "ladder_minus1_pullback": 28.6,
    "ladder_4_base": 27.4,
    "ladder_5_euphoria": 39.5
  },
  {
    "symbol": "5288.TW",
    "name": "豐祥-KY",
    "sector": "電機機械業",
    "close": 184.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.95,
    "dog_ma200_bias": -0.014,
    "vr60": 1.31,
    "rs20": 0.85,
    "rs60": 0.72,
    "shares": 4854,
    "lots": 4,
    "odd_shares": 854,
    "ntd_at_risk": 39996.96,
    "position_cost": 895563.0,
    "constraint": "WEIGHT",
    "atr14": 4.12,
    "low_20d": 174.5,
    "ladder_minus1_pullback": 173.4,
    "ladder_4_base": 166.1,
    "ladder_5_euphoria": 239.8
  },
  {
    "symbol": "8162.TW",
    "name": "微矽電子-創",
    "sector": "半導體業",
    "close": 60.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.12,
    "dog_ma200_bias": 0.047,
    "vr60": 1.88,
    "rs20": 1.06,
    "rs60": 1.02,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 1067249.7,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 56.4,
    "ladder_minus1_pullback": 56.7,
    "ladder_4_base": 54.3,
    "ladder_5_euphoria": 78.4
  },
  {
    "symbol": "6838.TW",
    "name": "台新藥",
    "sector": "生技醫療業",
    "close": 25.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.2,
    "dog_ma200_bias": 0.001,
    "vr60": 2.01,
    "rs20": 0.82,
    "rs60": 0.82,
    "shares": 23809,
    "lots": 23,
    "odd_shares": 809,
    "ntd_at_risk": 39999.12,
    "position_cost": 602367.7,
    "constraint": "WEIGHT",
    "atr14": 0.84,
    "low_20d": 22.9,
    "ladder_minus1_pullback": 23.8,
    "ladder_4_base": 22.8,
    "ladder_5_euphoria": 32.9
  },
  {
    "symbol": "3052.TW",
    "name": "夆典",
    "sector": "建材營造業",
    "close": 10.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.5,
    "dog_ma200_bias": -0.011,
    "vr60": 1.96,
    "rs20": 1.13,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 267500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.8,
    "ladder_minus1_pullback": 10.1,
    "ladder_4_base": 9.6,
    "ladder_5_euphoria": 13.9
  },
  {
    "symbol": "1598.TW",
    "name": "岱宇",
    "sector": "運動休閒",
    "close": 19.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.17,
    "dog_ma200_bias": 0.015,
    "vr60": 1.34,
    "rs20": 0.95,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 493750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.3,
    "ladder_minus1_pullback": 18.6,
    "ladder_4_base": 17.8,
    "ladder_5_euphoria": 25.7
  },
  {
    "symbol": "1456.TW",
    "name": "怡華",
    "sector": "建材營造業",
    "close": 15.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.95,
    "dog_ma200_bias": 0.004,
    "vr60": 1.71,
    "rs20": 0.79,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 387500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.4,
    "ladder_minus1_pullback": 14.6,
    "ladder_4_base": 14.0,
    "ladder_5_euphoria": 20.2
  },
  {
    "symbol": "6111.TWO",
    "name": "光聚晶電",
    "sector": "文化創意業",
    "close": 35.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.77,
    "dog_ma200_bias": -0.019,
    "vr60": 1.4,
    "rs20": 0.83,
    "rs60": 0.8,
    "shares": 21978,
    "lots": 21,
    "odd_shares": 978,
    "ntd_at_risk": 39999.96,
    "position_cost": 780219.0,
    "constraint": "WEIGHT",
    "atr14": 0.91,
    "low_20d": 33.2,
    "ladder_minus1_pullback": 33.4,
    "ladder_4_base": 31.9,
    "ladder_5_euphoria": 46.1
  },
  {
    "symbol": "4441.TW",
    "name": "振大環球",
    "sector": "紡織纖維業",
    "close": 168.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.83,
    "dog_ma200_bias": 0.07,
    "vr60": 1.68,
    "rs20": 1.14,
    "rs60": 0.73,
    "shares": 6250,
    "lots": 6,
    "odd_shares": 250,
    "ntd_at_risk": 40000.0,
    "position_cost": 1050000.0,
    "constraint": "WEIGHT",
    "atr14": 3.2,
    "low_20d": 158.1,
    "ladder_minus1_pullback": 157.9,
    "ladder_4_base": 151.2,
    "ladder_5_euphoria": 218.4
  },
  {
    "symbol": "3257.TW",
    "name": "虹冠電",
    "sector": "半導體業",
    "close": 47.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.29,
    "dog_ma200_bias": 0.001,
    "vr60": 1.65,
    "rs20": 1.03,
    "rs60": 0.83,
    "shares": 21978,
    "lots": 21,
    "odd_shares": 978,
    "ntd_at_risk": 39999.96,
    "position_cost": 1051647.3,
    "constraint": "WEIGHT",
    "atr14": 0.91,
    "low_20d": 43.2,
    "ladder_minus1_pullback": 45.0,
    "ladder_4_base": 43.1,
    "ladder_5_euphoria": 62.2
  },
  {
    "symbol": "1438.TW",
    "name": "三地開發",
    "sector": "建材營造業",
    "close": 21.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.56,
    "dog_ma200_bias": 0.039,
    "vr60": 1.6,
    "rs20": 1.13,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 540000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.6,
    "ladder_minus1_pullback": 20.3,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 28.1
  },
  {
    "symbol": "1735.TW",
    "name": "日勝化",
    "sector": "化學工業",
    "close": 21.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.07,
    "dog_ma200_bias": 0.015,
    "vr60": 1.54,
    "rs20": 0.84,
    "rs60": 0.78,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 542500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.1,
    "ladder_minus1_pullback": 20.4,
    "ladder_4_base": 19.5,
    "ladder_5_euphoria": 28.2
  },
  {
    "symbol": "1591.TWO",
    "name": "駿吉-KY",
    "sector": "電機機械業",
    "close": 38.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.18,
    "dog_ma200_bias": -0.009,
    "vr60": 2.09,
    "rs20": 0.8,
    "rs60": 0.74,
    "shares": 24691,
    "lots": 24,
    "odd_shares": 691,
    "ntd_at_risk": 39999.42,
    "position_cost": 941961.65,
    "constraint": "WEIGHT",
    "atr14": 0.81,
    "low_20d": 34.4,
    "ladder_minus1_pullback": 35.9,
    "ladder_4_base": 34.3,
    "ladder_5_euphoria": 49.6
  },
  {
    "symbol": "1452.TW",
    "name": "宏益",
    "sector": "紡織纖維業",
    "close": 10.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.95,
    "dog_ma200_bias": -0.006,
    "vr60": 1.89,
    "rs20": 1.03,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 268750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.9,
    "ladder_minus1_pullback": 10.1,
    "ladder_4_base": 9.7,
    "ladder_5_euphoria": 14.0
  },
  {
    "symbol": "4807.TW",
    "name": "日成-KY",
    "sector": "貿易百貨業",
    "close": 32.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.34,
    "dog_ma200_bias": 0.065,
    "vr60": 1.25,
    "rs20": 1.0,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 802500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.0,
    "ladder_minus1_pullback": 30.2,
    "ladder_4_base": 28.9,
    "ladder_5_euphoria": 41.7
  },
  {
    "symbol": "2228.TW",
    "name": "劍麟",
    "sector": "汽車工業",
    "close": 73.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.13,
    "dog_ma200_bias": 0.04,
    "vr60": 1.48,
    "rs20": 1.14,
    "rs60": 0.86,
    "shares": 10204,
    "lots": 10,
    "odd_shares": 204,
    "ntd_at_risk": 39999.68,
    "position_cost": 746932.8,
    "constraint": "WEIGHT",
    "atr14": 1.96,
    "low_20d": 66.3,
    "ladder_minus1_pullback": 68.8,
    "ladder_4_base": 65.9,
    "ladder_5_euphoria": 95.2
  },
  {
    "symbol": "1110.TW",
    "name": "東泥",
    "sector": "水泥工業",
    "close": 14.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.67,
    "dog_ma200_bias": 0.035,
    "vr60": 1.46,
    "rs20": 1.09,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 361250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.2,
    "ladder_minus1_pullback": 13.6,
    "ladder_4_base": 13.0,
    "ladder_5_euphoria": 18.8
  },
  {
    "symbol": "6803.TWO",
    "name": "崑鼎",
    "sector": "綠能環保",
    "close": 260.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.05,
    "dog_ma200_bias": -0.013,
    "vr60": 1.96,
    "rs20": 0.94,
    "rs60": 0.94,
    "shares": 4819,
    "lots": 4,
    "odd_shares": 819,
    "ntd_at_risk": 39997.7,
    "position_cost": 1252940.0,
    "constraint": "WEIGHT",
    "atr14": 4.15,
    "low_20d": 244.9,
    "ladder_minus1_pullback": 244.4,
    "ladder_4_base": 234.0,
    "ladder_5_euphoria": 338.0
  },
  {
    "symbol": "4946.TWO",
    "name": "辣椒",
    "sector": "文化創意業",
    "close": 97.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.35,
    "dog_ma200_bias": -0.002,
    "vr60": 2.1,
    "rs20": 0.95,
    "rs60": 0.74,
    "shares": 6006,
    "lots": 6,
    "odd_shares": 6,
    "ntd_at_risk": 39999.96,
    "position_cost": 583182.6,
    "constraint": "WEIGHT",
    "atr14": 3.33,
    "low_20d": 92.9,
    "ladder_minus1_pullback": 91.3,
    "ladder_4_base": 87.4,
    "ladder_5_euphoria": 126.2
  },
  {
    "symbol": "8916.TWO",
    "name": "光隆",
    "sector": "其他業",
    "close": 40.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.22,
    "dog_ma200_bias": 0.024,
    "vr60": 1.79,
    "rs20": 0.78,
    "rs60": 0.75,
    "shares": 15384,
    "lots": 15,
    "odd_shares": 384,
    "ntd_at_risk": 39998.4,
    "position_cost": 616898.4,
    "constraint": "WEIGHT",
    "atr14": 1.3,
    "low_20d": 36.7,
    "ladder_minus1_pullback": 37.7,
    "ladder_4_base": 36.1,
    "ladder_5_euphoria": 52.1
  },
  {
    "symbol": "4563.TWO",
    "name": "百德",
    "sector": "電機機械業",
    "close": 51.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.63,
    "dog_ma200_bias": 0.02,
    "vr60": 1.73,
    "rs20": 0.79,
    "rs60": 1.02,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 1079149.4,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 48.6,
    "ladder_minus1_pullback": 48.7,
    "ladder_4_base": 46.6,
    "ladder_5_euphoria": 67.3
  },
  {
    "symbol": "8176.TWO",
    "name": "智捷",
    "sector": "通信網路業",
    "close": 9.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.87,
    "dog_ma200_bias": 0.177,
    "vr60": 1.09,
    "rs20": 1.34,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 240000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.2,
    "ladder_minus1_pullback": 9.0,
    "ladder_4_base": 8.6,
    "ladder_5_euphoria": 12.5
  },
  {
    "symbol": "2482.TW",
    "name": "連宇",
    "sector": "其他電子業",
    "close": 15.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.33,
    "dog_ma200_bias": 0.039,
    "vr60": 2.09,
    "rs20": 0.8,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 395000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.5,
    "ladder_minus1_pullback": 14.9,
    "ladder_4_base": 14.2,
    "ladder_5_euphoria": 20.5
  },
  {
    "symbol": "2462.TW",
    "name": "良得電",
    "sector": "電子零組件業",
    "close": 19.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.29,
    "dog_ma200_bias": 0.053,
    "vr60": 1.45,
    "rs20": 1.04,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 478750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.1,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.2,
    "ladder_5_euphoria": 24.9
  },
  {
    "symbol": "5299.TWO",
    "name": "杰力",
    "sector": "半導體業",
    "close": 93.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.28,
    "dog_ma200_bias": 0.007,
    "vr60": 1.91,
    "rs20": 1.01,
    "rs60": 0.84,
    "shares": 13986,
    "lots": 13,
    "odd_shares": 986,
    "ntd_at_risk": 39999.96,
    "position_cost": 1307691.0,
    "constraint": "WEIGHT",
    "atr14": 1.43,
    "low_20d": 84.6,
    "ladder_minus1_pullback": 87.9,
    "ladder_4_base": 84.2,
    "ladder_5_euphoria": 121.5
  },
  {
    "symbol": "6735.TWO",
    "name": "美達科技",
    "sector": "其他電子業",
    "close": 58.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.33,
    "dog_ma200_bias": 0.028,
    "vr60": 1.74,
    "rs20": 0.91,
    "rs60": 0.87,
    "shares": 11834,
    "lots": 11,
    "odd_shares": 834,
    "ntd_at_risk": 39998.92,
    "position_cost": 693472.4,
    "constraint": "WEIGHT",
    "atr14": 1.69,
    "low_20d": 53.0,
    "ladder_minus1_pullback": 55.1,
    "ladder_4_base": 52.7,
    "ladder_5_euphoria": 76.2
  },
  {
    "symbol": "8349.TWO",
    "name": "恒耀",
    "sector": "鋼鐵工業",
    "close": 40.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.56,
    "dog_ma200_bias": 0.008,
    "vr60": 1.89,
    "rs20": 0.79,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1000000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.4,
    "ladder_minus1_pullback": 37.6,
    "ladder_4_base": 36.0,
    "ladder_5_euphoria": 52.0
  },
  {
    "symbol": "3276.TWO",
    "name": "宇環",
    "sector": "電子零組件業",
    "close": 14.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.05,
    "dog_ma200_bias": 0.03,
    "vr60": 1.77,
    "rs20": 0.8,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 361250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 13.6,
    "ladder_4_base": 13.0,
    "ladder_5_euphoria": 18.8
  },
  {
    "symbol": "3521.TWO",
    "name": "台鋼建設",
    "sector": "建材營造業",
    "close": 11.85,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.67,
    "dog_ma200_bias": -0.27,
    "vr60": 0.68,
    "rs20": 0.47,
    "rs60": 0.54,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 148125.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.8,
    "ladder_minus1_pullback": 11.1,
    "ladder_4_base": 10.7,
    "ladder_5_euphoria": 15.4
  },
  {
    "symbol": "4127.TWO",
    "name": "天良",
    "sector": "生技醫療業",
    "close": 39.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.34,
    "rs20": 1.0,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 990000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 37.4,
    "ladder_minus1_pullback": 37.2,
    "ladder_4_base": 35.6,
    "ladder_5_euphoria": 51.5
  },
  {
    "symbol": "1234.TW",
    "name": "黑松",
    "sector": "食品工業",
    "close": 32.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.83,
    "dog_ma200_bias": -0.012,
    "vr60": 1.88,
    "rs20": 1.06,
    "rs60": 0.98,
    "shares": 18867,
    "lots": 18,
    "odd_shares": 867,
    "ntd_at_risk": 39998.04,
    "position_cost": 613177.5,
    "constraint": "WEIGHT",
    "atr14": 1.06,
    "low_20d": 30.4,
    "ladder_minus1_pullback": 30.5,
    "ladder_4_base": 29.2,
    "ladder_5_euphoria": 42.2
  },
  {
    "symbol": "4503.TWO",
    "name": "金雨",
    "sector": "電機機械業",
    "close": 24.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.06,
    "dog_ma200_bias": 0.084,
    "vr60": 1.45,
    "rs20": 1.15,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 600000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.1,
    "ladder_minus1_pullback": 22.6,
    "ladder_4_base": 21.6,
    "ladder_5_euphoria": 31.2
  },
  {
    "symbol": "3027.TW",
    "name": "盛達",
    "sector": "通信網路業",
    "close": 18.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.05,
    "dog_ma200_bias": 0.014,
    "vr60": 1.97,
    "rs20": 0.97,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 461250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.9,
    "ladder_minus1_pullback": 17.3,
    "ladder_4_base": 16.6,
    "ladder_5_euphoria": 24.0
  },
  {
    "symbol": "2029.TW",
    "name": "盛餘",
    "sector": "鋼鐵工業",
    "close": 21.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.29,
    "dog_ma200_bias": -0.017,
    "vr60": 1.59,
    "rs20": 1.12,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 546250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.4,
    "ladder_minus1_pullback": 20.5,
    "ladder_4_base": 19.7,
    "ladder_5_euphoria": 28.4
  },
  {
    "symbol": "4173.TWO",
    "name": "久裕",
    "sector": "生技醫療業",
    "close": 17.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.67,
    "dog_ma200_bias": 0.011,
    "vr60": 1.54,
    "rs20": 0.93,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 441250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.0,
    "ladder_minus1_pullback": 16.6,
    "ladder_4_base": 15.9,
    "ladder_5_euphoria": 22.9
  },
  {
    "symbol": "6609.TWO",
    "name": "瀧澤科",
    "sector": "電機機械業",
    "close": 39.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.67,
    "dog_ma200_bias": 0.036,
    "vr60": 1.97,
    "rs20": 0.87,
    "rs60": 0.95,
    "shares": 20202,
    "lots": 20,
    "odd_shares": 202,
    "ntd_at_risk": 39999.96,
    "position_cost": 805049.7,
    "constraint": "WEIGHT",
    "atr14": 0.99,
    "low_20d": 36.8,
    "ladder_minus1_pullback": 37.5,
    "ladder_4_base": 35.9,
    "ladder_5_euphoria": 51.8
  },
  {
    "symbol": "3092.TW",
    "name": "鴻碩",
    "sector": "電子零組件業",
    "close": 22.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.7,
    "dog_ma200_bias": 0.029,
    "vr60": 1.32,
    "rs20": 1.04,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 573750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.1,
    "ladder_minus1_pullback": 21.6,
    "ladder_4_base": 20.7,
    "ladder_5_euphoria": 29.8
  },
  {
    "symbol": "6674.TW",
    "name": "鋐寶科技",
    "sector": "通信網路業",
    "close": 18.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.5,
    "dog_ma200_bias": -0.009,
    "vr60": 1.81,
    "rs20": 1.01,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 457500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.3,
    "ladder_minus1_pullback": 17.2,
    "ladder_4_base": 16.5,
    "ladder_5_euphoria": 23.8
  },
  {
    "symbol": "6192.TW",
    "name": "巨路",
    "sector": "其他電子業",
    "close": 114.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.67,
    "dog_ma200_bias": 0.037,
    "vr60": 1.63,
    "rs20": 1.09,
    "rs60": 0.88,
    "shares": 10101,
    "lots": 10,
    "odd_shares": 101,
    "ntd_at_risk": 39999.96,
    "position_cost": 1156564.5,
    "constraint": "WEIGHT",
    "atr14": 1.98,
    "low_20d": 103.7,
    "ladder_minus1_pullback": 107.6,
    "ladder_4_base": 103.0,
    "ladder_5_euphoria": 148.8
  },
  {
    "symbol": "5355.TWO",
    "name": "佳總",
    "sector": "電子零組件業",
    "close": 6.76,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.05,
    "dog_ma200_bias": 0.258,
    "vr60": 2.09,
    "rs20": 1.49,
    "rs60": 1.32,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 6.4,
    "ladder_minus1_pullback": 6.4,
    "ladder_4_base": 6.1,
    "ladder_5_euphoria": 8.8
  },
  {
    "symbol": "6114.TWO",
    "name": "久威",
    "sector": "電子零組件業",
    "close": 25.45,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.21,
    "dog_ma200_bias": 0.018,
    "vr60": 1.59,
    "rs20": 0.41,
    "rs60": 0.47,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 23.4,
    "ladder_minus1_pullback": 23.9,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.1
  },
  {
    "symbol": "2471.TW",
    "name": "資通",
    "sector": "資訊服務業",
    "close": 50.7,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": -0.217,
    "vr60": 0.98,
    "rs20": 0.21,
    "rs60": 0.51,
    "shares": 8620,
    "lots": 8,
    "odd_shares": 620,
    "ntd_at_risk": 19998.4,
    "position_cost": 437034.0,
    "constraint": "WEIGHT",
    "atr14": 1.16,
    "low_20d": 47.0,
    "ladder_minus1_pullback": 47.7,
    "ladder_4_base": 45.6,
    "ladder_5_euphoria": 65.9
  },
  {
    "symbol": "5292.TW",
    "name": "華懋",
    "sector": "綠能環保",
    "close": 244.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.65,
    "dog_ma200_bias": 0.072,
    "vr60": 1.26,
    "rs20": 1.09,
    "rs60": 1.04,
    "shares": 3105,
    "lots": 3,
    "odd_shares": 105,
    "ntd_at_risk": 39992.4,
    "position_cost": 757620.0,
    "constraint": "WEIGHT",
    "atr14": 6.44,
    "low_20d": 232.7,
    "ladder_minus1_pullback": 229.4,
    "ladder_4_base": 219.6,
    "ladder_5_euphoria": 317.2
  },
  {
    "symbol": "3169.TWO",
    "name": "亞信",
    "sector": "半導體業",
    "close": 101.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.14,
    "dog_ma200_bias": 0.046,
    "vr60": 1.42,
    "rs20": 1.01,
    "rs60": 0.91,
    "shares": 6269,
    "lots": 6,
    "odd_shares": 269,
    "ntd_at_risk": 39996.22,
    "position_cost": 636303.5,
    "constraint": "WEIGHT",
    "atr14": 3.19,
    "low_20d": 92.1,
    "ladder_minus1_pullback": 95.4,
    "ladder_4_base": 91.4,
    "ladder_5_euphoria": 132.0
  },
  {
    "symbol": "5287.TWO",
    "name": "數字",
    "sector": "數位雲端",
    "close": 134.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.33,
    "dog_ma200_bias": 0.362,
    "vr60": 1.67,
    "rs20": 1.26,
    "rs60": 1.22,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.5,
    "low_20d": 124.6,
    "ladder_minus1_pullback": 126.0,
    "ladder_4_base": 120.6,
    "ladder_5_euphoria": 174.2
  },
  {
    "symbol": "2431.TW",
    "name": "聯昌",
    "sector": "電子零組件業",
    "close": 10.1,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.33,
    "dog_ma200_bias": 0.245,
    "vr60": 2.06,
    "rs20": 1.45,
    "rs60": 1.3,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.4,
    "ladder_minus1_pullback": 9.5,
    "ladder_4_base": 9.1,
    "ladder_5_euphoria": 13.1
  },
  {
    "symbol": "6275.TWO",
    "name": "元山",
    "sector": "電子零組件業",
    "close": 45.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.25,
    "dog_ma200_bias": 0.007,
    "vr60": 1.83,
    "rs20": 0.99,
    "rs60": 1.05,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 1021306.95,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 41.4,
    "ladder_minus1_pullback": 42.7,
    "ladder_4_base": 40.9,
    "ladder_5_euphoria": 59.1
  },
  {
    "symbol": "1733.TW",
    "name": "五鼎",
    "sector": "生技醫療業",
    "close": 29.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.1,
    "dog_ma200_bias": 0.105,
    "vr60": 1.28,
    "rs20": 1.18,
    "rs60": 1.22,
    "shares": 22222,
    "lots": 22,
    "odd_shares": 222,
    "ntd_at_risk": 39999.6,
    "position_cost": 663326.7,
    "constraint": "WEIGHT",
    "atr14": 0.9,
    "low_20d": 27.2,
    "ladder_minus1_pullback": 28.1,
    "ladder_4_base": 26.9,
    "ladder_5_euphoria": 38.8
  },
  {
    "symbol": "1451.TW",
    "name": "年興",
    "sector": "紡織纖維業",
    "close": 17.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.4,
    "dog_ma200_bias": 0.072,
    "vr60": 1.46,
    "rs20": 1.08,
    "rs60": 1.1,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 427500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.0,
    "ladder_minus1_pullback": 16.1,
    "ladder_4_base": 15.4,
    "ladder_5_euphoria": 22.2
  },
  {
    "symbol": "6113.TWO",
    "name": "亞矽",
    "sector": "電子通路業",
    "close": 22.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.18,
    "dog_ma200_bias": 0.056,
    "vr60": 1.51,
    "rs20": 1.0,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 570000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.8,
    "ladder_minus1_pullback": 21.4,
    "ladder_4_base": 20.5,
    "ladder_5_euphoria": 29.6
  },
  {
    "symbol": "1527.TW",
    "name": "鑽全",
    "sector": "電機機械業",
    "close": 32.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.17,
    "dog_ma200_bias": 0.024,
    "vr60": 1.65,
    "rs20": 1.09,
    "rs60": 0.98,
    "shares": 20408,
    "lots": 20,
    "odd_shares": 408,
    "ntd_at_risk": 39999.68,
    "position_cost": 661219.2,
    "constraint": "WEIGHT",
    "atr14": 0.98,
    "low_20d": 30.7,
    "ladder_minus1_pullback": 30.5,
    "ladder_4_base": 29.2,
    "ladder_5_euphoria": 42.1
  },
  {
    "symbol": "7689.TW",
    "name": "大鵬科CLMX",
    "sector": "通信網路業",
    "close": 139.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.4,
    "dog_ma200_bias": 0.064,
    "vr60": 1.68,
    "rs20": 0.86,
    "rs60": 0.72,
    "shares": 6734,
    "lots": 6,
    "odd_shares": 734,
    "ntd_at_risk": 39999.96,
    "position_cost": 936026.0,
    "constraint": "WEIGHT",
    "atr14": 2.97,
    "low_20d": 128.7,
    "ladder_minus1_pullback": 130.7,
    "ladder_4_base": 125.1,
    "ladder_5_euphoria": 180.7
  },
  {
    "symbol": "2414.TW",
    "name": "精技",
    "sector": "電子通路業",
    "close": 51.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.25,
    "dog_ma200_bias": 0.08,
    "vr60": 1.56,
    "rs20": 0.84,
    "rs60": 0.96,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 918578.1,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 46.9,
    "ladder_minus1_pullback": 48.8,
    "ladder_4_base": 46.7,
    "ladder_5_euphoria": 67.5
  },
  {
    "symbol": "4438.TW",
    "name": "廣越",
    "sector": "紡織纖維業",
    "close": 57.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.71,
    "dog_ma200_bias": -0.011,
    "vr60": 1.96,
    "rs20": 0.79,
    "rs60": 0.82,
    "shares": 15748,
    "lots": 15,
    "odd_shares": 748,
    "ntd_at_risk": 39999.92,
    "position_cost": 907084.8,
    "constraint": "WEIGHT",
    "atr14": 1.27,
    "low_20d": 54.6,
    "ladder_minus1_pullback": 54.1,
    "ladder_4_base": 51.8,
    "ladder_5_euphoria": 74.9
  },
  {
    "symbol": "6969.TW",
    "name": "成信實業*-創",
    "sector": "綠能環保",
    "close": 28.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": -0.013,
    "vr60": 1.92,
    "rs20": 0.94,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 713750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.1,
    "ladder_minus1_pullback": 26.8,
    "ladder_4_base": 25.7,
    "ladder_5_euphoria": 37.1
  },
  {
    "symbol": "3178.TWO",
    "name": "公準",
    "sector": "半導體業",
    "close": 63.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.24,
    "dog_ma200_bias": 0.06,
    "vr60": 1.79,
    "rs20": 0.87,
    "rs60": 0.98,
    "shares": 19417,
    "lots": 19,
    "odd_shares": 417,
    "ntd_at_risk": 39999.02,
    "position_cost": 1232979.5,
    "constraint": "WEIGHT",
    "atr14": 1.03,
    "low_20d": 60.3,
    "ladder_minus1_pullback": 59.7,
    "ladder_4_base": 57.1,
    "ladder_5_euphoria": 82.5
  },
  {
    "symbol": "6591.TW",
    "name": "動力-KY",
    "sector": "電腦及週邊設備業",
    "close": 42.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.06,
    "dog_ma200_bias": 0.112,
    "vr60": 1.37,
    "rs20": 1.03,
    "rs60": 1.06,
    "shares": 16806,
    "lots": 16,
    "odd_shares": 806,
    "ntd_at_risk": 39998.28,
    "position_cost": 710053.5,
    "constraint": "WEIGHT",
    "atr14": 1.19,
    "low_20d": 39.4,
    "ladder_minus1_pullback": 39.7,
    "ladder_4_base": 38.0,
    "ladder_5_euphoria": 54.9
  },
  {
    "symbol": "8072.TW",
    "name": "陞泰",
    "sector": "電子通路業",
    "close": 26.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.91,
    "dog_ma200_bias": 0.042,
    "vr60": 1.61,
    "rs20": 1.06,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 663750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.1,
    "ladder_minus1_pullback": 25.0,
    "ladder_4_base": 23.9,
    "ladder_5_euphoria": 34.5
  },
  {
    "symbol": "6240.TWO",
    "name": "松崗",
    "sector": "資訊服務業",
    "close": 30.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.8,
    "dog_ma200_bias": 0.062,
    "vr60": 1.47,
    "rs20": 1.3,
    "rs60": 1.13,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 752500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.6,
    "ladder_minus1_pullback": 28.3,
    "ladder_4_base": 27.1,
    "ladder_5_euphoria": 39.1
  },
  {
    "symbol": "6184.TW",
    "name": "大豐電",
    "sector": "其他業",
    "close": 39.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.7,
    "dog_ma200_bias": 0.001,
    "vr60": 2.07,
    "rs20": 1.05,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 996250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.6,
    "ladder_minus1_pullback": 37.5,
    "ladder_4_base": 35.9,
    "ladder_5_euphoria": 51.8
  },
  {
    "symbol": "2450.TW",
    "name": "神腦",
    "sector": "通信網路業",
    "close": 28.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.33,
    "dog_ma200_bias": 0.074,
    "vr60": 1.68,
    "rs20": 1.0,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 706250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.1,
    "ladder_minus1_pullback": 26.6,
    "ladder_4_base": 25.4,
    "ladder_5_euphoria": 36.7
  },
  {
    "symbol": "2906.TW",
    "name": "高林",
    "sector": "貿易百貨業",
    "close": 13.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.25,
    "dog_ma200_bias": 0.023,
    "vr60": 1.71,
    "rs20": 1.0,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 346250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 13.0,
    "ladder_4_base": 12.5,
    "ladder_5_euphoria": 18.0
  },
  {
    "symbol": "4561.TWO",
    "name": "健椿",
    "sector": "電機機械業",
    "close": 41.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.05,
    "dog_ma200_bias": -0.044,
    "vr60": 1.43,
    "rs20": 0.45,
    "rs60": 0.69,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 38.8,
    "ladder_minus1_pullback": 38.5,
    "ladder_4_base": 36.9,
    "ladder_5_euphoria": 53.3
  },
  {
    "symbol": "4568.TWO",
    "name": "科際精密",
    "sector": "電機機械業",
    "close": 41.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.52,
    "dog_ma200_bias": 0.112,
    "vr60": 1.24,
    "rs20": 1.28,
    "rs60": 0.93,
    "shares": 18181,
    "lots": 18,
    "odd_shares": 181,
    "ntd_at_risk": 39998.2,
    "position_cost": 761783.9,
    "constraint": "WEIGHT",
    "atr14": 1.1,
    "low_20d": 38.2,
    "ladder_minus1_pullback": 39.4,
    "ladder_4_base": 37.7,
    "ladder_5_euphoria": 54.5
  },
  {
    "symbol": "9935.TW",
    "name": "慶豐富",
    "sector": "居家生活",
    "close": 18.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.5,
    "dog_ma200_bias": 0.0,
    "vr60": 1.57,
    "rs20": 1.08,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 466250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.7,
    "ladder_minus1_pullback": 17.5,
    "ladder_4_base": 16.8,
    "ladder_5_euphoria": 24.2
  },
  {
    "symbol": "6596.TWO",
    "name": "寬宏藝術",
    "sector": "文化創意業",
    "close": 95.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.45,
    "dog_ma200_bias": 0.006,
    "vr60": 1.74,
    "rs20": 0.91,
    "rs60": 0.74,
    "shares": 8000,
    "lots": 8,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 762400.0,
    "constraint": "WEIGHT",
    "atr14": 2.5,
    "low_20d": 91.1,
    "ladder_minus1_pullback": 89.6,
    "ladder_4_base": 85.8,
    "ladder_5_euphoria": 123.9
  },
  {
    "symbol": "6535.TWO",
    "name": "順藥",
    "sector": "生技醫療業",
    "close": 75.6,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.1,
    "dog_ma200_bias": -0.245,
    "vr60": 0.76,
    "rs20": 0.53,
    "rs60": 0.35,
    "shares": 3984,
    "lots": 3,
    "odd_shares": 984,
    "ntd_at_risk": 19999.68,
    "position_cost": 301190.4,
    "constraint": "WEIGHT",
    "atr14": 2.51,
    "low_20d": 68.3,
    "ladder_minus1_pullback": 71.1,
    "ladder_4_base": 68.0,
    "ladder_5_euphoria": 98.3
  },
  {
    "symbol": "8908.TWO",
    "name": "欣雄",
    "sector": "油電燃氣業",
    "close": 39.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.95,
    "dog_ma200_bias": 0.024,
    "vr60": 1.78,
    "rs20": 0.76,
    "rs60": 0.76,
    "shares": 24390,
    "lots": 24,
    "odd_shares": 390,
    "ntd_at_risk": 39999.6,
    "position_cost": 970722.0,
    "constraint": "WEIGHT",
    "atr14": 0.82,
    "low_20d": 36.7,
    "ladder_minus1_pullback": 37.4,
    "ladder_4_base": 35.8,
    "ladder_5_euphoria": 51.7
  },
  {
    "symbol": "2237.TW",
    "name": "華德動能-創",
    "sector": "汽車工業",
    "close": 25.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.4,
    "dog_ma200_bias": -0.006,
    "vr60": 1.43,
    "rs20": 1.07,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 627500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.1,
    "ladder_minus1_pullback": 23.6,
    "ladder_4_base": 22.6,
    "ladder_5_euphoria": 32.6
  },
  {
    "symbol": "5203.TW",
    "name": "訊連",
    "sector": "資訊服務業",
    "close": 59.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.54,
    "dog_ma200_bias": -0.002,
    "vr60": 1.97,
    "rs20": 1.14,
    "rs60": 0.87,
    "shares": 15267,
    "lots": 15,
    "odd_shares": 267,
    "ntd_at_risk": 39999.54,
    "position_cost": 909913.2,
    "constraint": "WEIGHT",
    "atr14": 1.31,
    "low_20d": 53.7,
    "ladder_minus1_pullback": 56.0,
    "ladder_4_base": 53.6,
    "ladder_5_euphoria": 77.5
  },
  {
    "symbol": "7740.TW",
    "name": "熙特爾-創",
    "sector": "綠能環保",
    "close": 102.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.4,
    "dog_ma200_bias": -0.018,
    "vr60": 1.97,
    "rs20": 0.78,
    "rs60": 0.91,
    "shares": 5847,
    "lots": 5,
    "odd_shares": 847,
    "ntd_at_risk": 39993.48,
    "position_cost": 599317.5,
    "constraint": "WEIGHT",
    "atr14": 3.42,
    "low_20d": 97.5,
    "ladder_minus1_pullback": 96.3,
    "ladder_4_base": 92.2,
    "ladder_5_euphoria": 133.2
  },
  {
    "symbol": "3484.TWO",
    "name": "崧騰",
    "sector": "電子零組件業",
    "close": 49.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.33,
    "dog_ma200_bias": 0.067,
    "vr60": 2.01,
    "rs20": 0.91,
    "rs60": 0.83,
    "shares": 18181,
    "lots": 18,
    "odd_shares": 181,
    "ntd_at_risk": 39998.2,
    "position_cost": 901777.6,
    "constraint": "WEIGHT",
    "atr14": 1.1,
    "low_20d": 47.2,
    "ladder_minus1_pullback": 46.6,
    "ladder_4_base": 44.6,
    "ladder_5_euphoria": 64.5
  },
  {
    "symbol": "4562.TW",
    "name": "穎漢",
    "sector": "電機機械業",
    "close": 29.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.9,
    "cpr": 0.16,
    "dog_ma200_bias": 0.139,
    "vr60": 1.1,
    "rs20": 1.33,
    "rs60": 1.19,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 742500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.8,
    "ladder_minus1_pullback": 27.9,
    "ladder_4_base": 26.7,
    "ladder_5_euphoria": 38.6
  },
  {
    "symbol": "8478.TW",
    "name": "東哥遊艇",
    "sector": "運動休閒",
    "close": 138.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.25,
    "dog_ma200_bias": -0.006,
    "vr60": 1.3,
    "rs20": 1.04,
    "rs60": 1.03,
    "shares": 4444,
    "lots": 4,
    "odd_shares": 444,
    "ntd_at_risk": 39996.0,
    "position_cost": 613272.0,
    "constraint": "WEIGHT",
    "atr14": 4.5,
    "low_20d": 129.4,
    "ladder_minus1_pullback": 129.7,
    "ladder_4_base": 124.2,
    "ladder_5_euphoria": 179.4
  },
  {
    "symbol": "4711.TWO",
    "name": "永純",
    "sector": "化學工業",
    "close": 16.75,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.05,
    "dog_ma200_bias": -0.028,
    "vr60": 2.05,
    "rs20": 0.73,
    "rs60": 0.78,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 15.9,
    "ladder_minus1_pullback": 15.7,
    "ladder_4_base": 15.1,
    "ladder_5_euphoria": 21.8
  },
  {
    "symbol": "4119.TW",
    "name": "旭富",
    "sector": "生技醫療業",
    "close": 53.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.05,
    "dog_ma200_bias": 0.068,
    "vr60": 1.41,
    "rs20": 0.8,
    "rs60": 0.98,
    "shares": 12820,
    "lots": 12,
    "odd_shares": 820,
    "ntd_at_risk": 39998.4,
    "position_cost": 684588.0,
    "constraint": "WEIGHT",
    "atr14": 1.56,
    "low_20d": 49.5,
    "ladder_minus1_pullback": 50.2,
    "ladder_4_base": 48.1,
    "ladder_5_euphoria": 69.4
  },
  {
    "symbol": "1540.TW",
    "name": "喬福",
    "sector": "電機機械業",
    "close": 18.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.38,
    "cpr": 0.5,
    "dog_ma200_bias": 0.1,
    "vr60": 1.4,
    "rs20": 1.11,
    "rs60": 1.2,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 466250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.0,
    "ladder_minus1_pullback": 17.5,
    "ladder_4_base": 16.8,
    "ladder_5_euphoria": 24.2
  },
  {
    "symbol": "3511.TWO",
    "name": "矽瑪",
    "sector": "電子零組件業",
    "close": 19.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.37,
    "dog_ma200_bias": 0.004,
    "vr60": 1.58,
    "rs20": 0.81,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 478750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.9,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.2,
    "ladder_5_euphoria": 24.9
  },
  {
    "symbol": "5468.TWO",
    "name": "凱鈺",
    "sector": "半導體業",
    "close": 21.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.45,
    "dog_ma200_bias": 0.176,
    "vr60": 1.31,
    "rs20": 1.05,
    "rs60": 1.14,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 545000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.3,
    "ladder_minus1_pullback": 20.5,
    "ladder_4_base": 19.6,
    "ladder_5_euphoria": 28.3
  },
  {
    "symbol": "6733.TWO",
    "name": "博晟生醫",
    "sector": "生技醫療業",
    "close": 24.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.4,
    "dog_ma200_bias": 0.029,
    "vr60": 1.54,
    "rs20": 1.13,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 605000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.8,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.8,
    "ladder_5_euphoria": 31.5
  },
  {
    "symbol": "3501.TW",
    "name": "維熹",
    "sector": "電子零組件業",
    "close": 38.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.43,
    "dog_ma200_bias": 0.022,
    "vr60": 1.81,
    "rs20": 1.14,
    "rs60": 1.01,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 681411.5,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 36.5,
    "ladder_minus1_pullback": 36.2,
    "ladder_4_base": 34.6,
    "ladder_5_euphoria": 50.1
  },
  {
    "symbol": "3713.TWO",
    "name": "新晶投控",
    "sector": "綠能環保",
    "close": 14.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.29,
    "dog_ma200_bias": 0.074,
    "vr60": 1.53,
    "rs20": 1.04,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 362500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 13.6,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 18.9
  },
  {
    "symbol": "5450.TWO",
    "name": "南良",
    "sector": "其他業",
    "close": 14.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.95,
    "dog_ma200_bias": -0.018,
    "vr60": 2.07,
    "rs20": 0.99,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 373750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.4
  },
  {
    "symbol": "6203.TWO",
    "name": "海韻電",
    "sector": "電子零組件業",
    "close": 58.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.1,
    "dog_ma200_bias": 0.046,
    "vr60": 2.05,
    "rs20": 1.03,
    "rs60": 0.98,
    "shares": 13245,
    "lots": 13,
    "odd_shares": 245,
    "ntd_at_risk": 39999.9,
    "position_cost": 768210.0,
    "constraint": "WEIGHT",
    "atr14": 1.51,
    "low_20d": 53.0,
    "ladder_minus1_pullback": 54.5,
    "ladder_4_base": 52.2,
    "ladder_5_euphoria": 75.4
  },
  {
    "symbol": "2509.TW",
    "name": "全坤建",
    "sector": "建材營造業",
    "close": 13.25,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.05,
    "dog_ma200_bias": -0.166,
    "vr60": 0.79,
    "rs20": 0.41,
    "rs60": 0.69,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 12.6,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 11.9,
    "ladder_5_euphoria": 17.2
  },
  {
    "symbol": "5529.TWO",
    "name": "鉅陞",
    "sector": "建材營造業",
    "close": 23.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.05,
    "dog_ma200_bias": 0.104,
    "vr60": 1.54,
    "rs20": 1.0,
    "rs60": 1.25,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 592500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.8,
    "ladder_minus1_pullback": 22.3,
    "ladder_4_base": 21.3,
    "ladder_5_euphoria": 30.8
  },
  {
    "symbol": "6523.TWO",
    "name": "達爾膚",
    "sector": "生技醫療業",
    "close": 86.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.43,
    "dog_ma200_bias": 0.163,
    "vr60": 1.28,
    "rs20": 1.31,
    "rs60": 1.06,
    "shares": 7299,
    "lots": 7,
    "odd_shares": 299,
    "ntd_at_risk": 39998.52,
    "position_cost": 632093.4,
    "constraint": "WEIGHT",
    "atr14": 2.74,
    "low_20d": 79.1,
    "ladder_minus1_pullback": 81.4,
    "ladder_4_base": 77.9,
    "ladder_5_euphoria": 112.6
  },
  {
    "symbol": "6958.TW",
    "name": "日盛台駿",
    "sector": "其他業",
    "close": 17.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.71,
    "dog_ma200_bias": 0.078,
    "vr60": 1.43,
    "rs20": 0.79,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 430000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.3,
    "ladder_minus1_pullback": 16.2,
    "ladder_4_base": 15.5,
    "ladder_5_euphoria": 22.4
  },
  {
    "symbol": "1760.TW",
    "name": "寶齡富錦",
    "sector": "生技醫療業",
    "close": 53.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.3,
    "dog_ma200_bias": 0.004,
    "vr60": 1.39,
    "rs20": 1.11,
    "rs60": 1.02,
    "shares": 20408,
    "lots": 20,
    "odd_shares": 408,
    "ntd_at_risk": 39999.68,
    "position_cost": 1097950.4,
    "constraint": "WEIGHT",
    "atr14": 0.98,
    "low_20d": 50.4,
    "ladder_minus1_pullback": 50.6,
    "ladder_4_base": 48.4,
    "ladder_5_euphoria": 69.9
  },
  {
    "symbol": "5263.TWO",
    "name": "智崴",
    "sector": "文化創意業",
    "close": 89.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.56,
    "dog_ma200_bias": 0.043,
    "vr60": 1.99,
    "rs20": 1.06,
    "rs60": 0.84,
    "shares": 11976,
    "lots": 11,
    "odd_shares": 976,
    "ntd_at_risk": 39999.84,
    "position_cost": 1073049.6,
    "constraint": "WEIGHT",
    "atr14": 1.67,
    "low_20d": 83.6,
    "ladder_minus1_pullback": 84.2,
    "ladder_4_base": 80.6,
    "ladder_5_euphoria": 116.5
  },
  {
    "symbol": "4555.TW",
    "name": "氣立",
    "sector": "電機機械業",
    "close": 42.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.31,
    "dog_ma200_bias": -0.017,
    "vr60": 1.98,
    "rs20": 1.08,
    "rs60": 1.03,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 879152.6,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 38.8,
    "ladder_minus1_pullback": 39.7,
    "ladder_4_base": 38.0,
    "ladder_5_euphoria": 54.9
  },
  {
    "symbol": "7821.TW",
    "name": "神數",
    "sector": "汽車工業",
    "close": 35.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.14,
    "dog_ma200_bias": 0.027,
    "vr60": 1.57,
    "rs20": 1.09,
    "rs60": 0.95,
    "shares": 18518,
    "lots": 18,
    "odd_shares": 518,
    "ntd_at_risk": 39998.88,
    "position_cost": 665722.1,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 33.3,
    "ladder_minus1_pullback": 33.8,
    "ladder_4_base": 32.4,
    "ladder_5_euphoria": 46.7
  },
  {
    "symbol": "1533.TW",
    "name": "車王電",
    "sector": "汽車工業",
    "close": 29.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.1,
    "dog_ma200_bias": 0.068,
    "vr60": 1.94,
    "rs20": 1.08,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 728750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.6,
    "ladder_minus1_pullback": 27.4,
    "ladder_4_base": 26.2,
    "ladder_5_euphoria": 37.9
  },
  {
    "symbol": "1457.TW",
    "name": "宜進",
    "sector": "紡織纖維業",
    "close": 14.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.25,
    "dog_ma200_bias": -0.189,
    "vr60": 0.81,
    "rs20": 0.44,
    "rs60": 0.48,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 178750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.3,
    "ladder_minus1_pullback": 13.4,
    "ladder_4_base": 12.9,
    "ladder_5_euphoria": 18.6
  },
  {
    "symbol": "6739.TWO",
    "name": "竹陞科技",
    "sector": "其他電子業",
    "close": 956.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.57,
    "dog_ma200_bias": 0.114,
    "vr60": 1.07,
    "rs20": 0.97,
    "rs60": 1.16,
    "shares": 1187,
    "lots": 1,
    "odd_shares": 187,
    "ntd_at_risk": 39978.16,
    "position_cost": 1134772.0,
    "constraint": "WEIGHT",
    "atr14": 16.84,
    "low_20d": 864.3,
    "ladder_minus1_pullback": 898.6,
    "ladder_4_base": 860.4,
    "ladder_5_euphoria": 1242.8
  },
  {
    "symbol": "3652.TW",
    "name": "精聯",
    "sector": "電腦及週邊設備業",
    "close": 33.75,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.05,
    "dog_ma200_bias": 0.136,
    "vr60": 1.52,
    "rs20": 1.0,
    "rs60": 1.06,
    "shares": 17543,
    "lots": 17,
    "odd_shares": 543,
    "ntd_at_risk": 39998.04,
    "position_cost": 592076.25,
    "constraint": "WEIGHT",
    "atr14": 1.14,
    "low_20d": 31.2,
    "ladder_minus1_pullback": 31.7,
    "ladder_4_base": 30.4,
    "ladder_5_euphoria": 43.9
  },
  {
    "symbol": "4558.TWO",
    "name": "寶緯",
    "sector": "電機機械業",
    "close": 17.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.11,
    "dog_ma200_bias": 0.043,
    "vr60": 1.48,
    "rs20": 0.78,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 440000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.2,
    "ladder_minus1_pullback": 16.5,
    "ladder_4_base": 15.8,
    "ladder_5_euphoria": 22.9
  },
  {
    "symbol": "3043.TW",
    "name": "科風",
    "sector": "其他電子業",
    "close": 19.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.05,
    "dog_ma200_bias": 0.122,
    "vr60": 1.63,
    "rs20": 1.28,
    "rs60": 1.21,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 487500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.7,
    "ladder_minus1_pullback": 18.3,
    "ladder_4_base": 17.6,
    "ladder_5_euphoria": 25.4
  },
  {
    "symbol": "6506.TWO",
    "name": "雙邦",
    "sector": "紡織纖維業",
    "close": 18.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": 0.162,
    "vr60": 1.46,
    "rs20": 1.27,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 466250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.9,
    "ladder_minus1_pullback": 17.5,
    "ladder_4_base": 16.8,
    "ladder_5_euphoria": 24.2
  },
  {
    "symbol": "4726.TWO",
    "name": "永昕",
    "sector": "生技醫療業",
    "close": 23.2,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.5,
    "dog_ma200_bias": -0.032,
    "vr60": 1.96,
    "rs20": 0.49,
    "rs60": 0.69,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 22.0,
    "ladder_minus1_pullback": 21.8,
    "ladder_4_base": 20.9,
    "ladder_5_euphoria": 30.2
  },
  {
    "symbol": "6570.TWO",
    "name": "維田",
    "sector": "電腦及週邊設備業",
    "close": 46.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.95,
    "dog_ma200_bias": 0.156,
    "vr60": 1.17,
    "rs20": 1.12,
    "rs60": 0.97,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 1038160.2,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 42.0,
    "ladder_minus1_pullback": 43.4,
    "ladder_4_base": 41.6,
    "ladder_5_euphoria": 60.1
  },
  {
    "symbol": "6651.TWO",
    "name": "全宇昕",
    "sector": "半導體業",
    "close": 141.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.25,
    "dog_ma200_bias": 0.068,
    "vr60": 2.05,
    "rs20": 1.1,
    "rs60": 0.78,
    "shares": 4273,
    "lots": 4,
    "odd_shares": 273,
    "ntd_at_risk": 39995.28,
    "position_cost": 602493.0,
    "constraint": "WEIGHT",
    "atr14": 4.68,
    "low_20d": 130.4,
    "ladder_minus1_pullback": 132.5,
    "ladder_4_base": 126.9,
    "ladder_5_euphoria": 183.3
  },
  {
    "symbol": "7556.TWO",
    "name": "意德士",
    "sector": "半導體業",
    "close": 286.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.52,
    "dog_ma200_bias": 0.174,
    "vr60": 1.6,
    "rs20": 1.21,
    "rs60": 1.15,
    "shares": 2849,
    "lots": 2,
    "odd_shares": 849,
    "ntd_at_risk": 39999.96,
    "position_cost": 816238.5,
    "constraint": "WEIGHT",
    "atr14": 7.02,
    "low_20d": 262.9,
    "ladder_minus1_pullback": 269.3,
    "ladder_4_base": 257.9,
    "ladder_5_euphoria": 372.4
  },
  {
    "symbol": "1512.TW",
    "name": "瑞利",
    "sector": "汽車工業",
    "close": 6.23,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.52,
    "dog_ma200_bias": 0.071,
    "vr60": 2.08,
    "rs20": 0.83,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 155750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 5.8,
    "ladder_minus1_pullback": 5.9,
    "ladder_4_base": 5.6,
    "ladder_5_euphoria": 8.1
  },
  {
    "symbol": "1417.TW",
    "name": "嘉裕",
    "sector": "紡織纖維業",
    "close": 8.13,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.75,
    "dog_ma200_bias": 0.08,
    "vr60": 1.29,
    "rs20": 1.12,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 203250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.6,
    "ladder_minus1_pullback": 7.6,
    "ladder_4_base": 7.3,
    "ladder_5_euphoria": 10.6
  },
  {
    "symbol": "5236.TW",
    "name": "凌陽創新",
    "sector": "半導體業",
    "close": 123.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": -0.011,
    "vr60": 1.53,
    "rs20": 1.13,
    "rs60": 0.74,
    "shares": 5934,
    "lots": 5,
    "odd_shares": 934,
    "ntd_at_risk": 39995.16,
    "position_cost": 729882.0,
    "constraint": "WEIGHT",
    "atr14": 3.37,
    "low_20d": 116.9,
    "ladder_minus1_pullback": 115.6,
    "ladder_4_base": 110.7,
    "ladder_5_euphoria": 159.9
  },
  {
    "symbol": "1472.TW",
    "name": "三洋實業",
    "sector": "建材營造業",
    "close": 88.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.23,
    "dog_ma200_bias": 0.052,
    "vr60": 1.59,
    "rs20": 1.12,
    "rs60": 0.86,
    "shares": 9302,
    "lots": 9,
    "odd_shares": 302,
    "ntd_at_risk": 39998.6,
    "position_cost": 821366.6,
    "constraint": "WEIGHT",
    "atr14": 2.15,
    "low_20d": 79.6,
    "ladder_minus1_pullback": 83.0,
    "ladder_4_base": 79.5,
    "ladder_5_euphoria": 114.8
  },
  {
    "symbol": "6118.TWO",
    "name": "建達",
    "sector": "電子通路業",
    "close": 15.7,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.33,
    "dog_ma200_bias": -0.013,
    "vr60": 1.41,
    "rs20": 0.65,
    "rs60": 0.52,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 14.2,
    "ladder_minus1_pullback": 14.8,
    "ladder_4_base": 14.1,
    "ladder_5_euphoria": 20.4
  },
  {
    "symbol": "6657.TW",
    "name": "華安",
    "sector": "生技醫療業",
    "close": 32.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.07,
    "dog_ma200_bias": 0.058,
    "vr60": 1.46,
    "rs20": 0.95,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 807500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.1,
    "ladder_minus1_pullback": 30.4,
    "ladder_4_base": 29.1,
    "ladder_5_euphoria": 42.0
  },
  {
    "symbol": "1436.TW",
    "name": "華友聯",
    "sector": "建材營造業",
    "close": 36.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.5,
    "dog_ma200_bias": -0.126,
    "vr60": 0.92,
    "rs20": 0.6,
    "rs60": 0.28,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 456250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 34.2,
    "ladder_minus1_pullback": 34.3,
    "ladder_4_base": 32.9,
    "ladder_5_euphoria": 47.5
  },
  {
    "symbol": "1558.TW",
    "name": "伸興",
    "sector": "電機機械業",
    "close": 116.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.33,
    "dog_ma200_bias": 0.11,
    "vr60": 1.3,
    "rs20": 1.01,
    "rs60": 1.02,
    "shares": 9345,
    "lots": 9,
    "odd_shares": 345,
    "ntd_at_risk": 39996.6,
    "position_cost": 1084020.0,
    "constraint": "WEIGHT",
    "atr14": 2.14,
    "low_20d": 111.2,
    "ladder_minus1_pullback": 109.0,
    "ladder_4_base": 104.4,
    "ladder_5_euphoria": 150.8
  },
  {
    "symbol": "6875.TWO",
    "name": "國邑*",
    "sector": "生技醫療業",
    "close": 26.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.05,
    "dog_ma200_bias": 0.006,
    "vr60": 1.76,
    "rs20": 1.11,
    "rs60": 0.83,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 637339.2,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 23.9,
    "ladder_minus1_pullback": 24.9,
    "ladder_4_base": 23.8,
    "ladder_5_euphoria": 34.4
  },
  {
    "symbol": "7791.TW",
    "name": "皇家可口",
    "sector": "食品工業",
    "close": 50.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.48,
    "dog_ma200_bias": 0.317,
    "vr60": 2.06,
    "rs20": 1.15,
    "rs60": 1.15,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.93,
    "low_20d": 45.3,
    "ladder_minus1_pullback": 47.0,
    "ladder_4_base": 45.0,
    "ladder_5_euphoria": 65.0
  },
  {
    "symbol": "3520.TWO",
    "name": "華盈",
    "sector": "電子零組件業",
    "close": 17.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.71,
    "dog_ma200_bias": 0.143,
    "vr60": 1.46,
    "rs20": 1.24,
    "rs60": 1.18,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 447500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.6,
    "ladder_minus1_pullback": 16.8,
    "ladder_4_base": 16.1,
    "ladder_5_euphoria": 23.3
  },
  {
    "symbol": "6924.TW",
    "name": "榮惠-KY創",
    "sector": "電子零組件業",
    "close": 145.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.18,
    "dog_ma200_bias": 0.327,
    "vr60": 1.86,
    "rs20": 1.18,
    "rs60": 1.12,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.06,
    "low_20d": 131.9,
    "ladder_minus1_pullback": 136.8,
    "ladder_4_base": 131.0,
    "ladder_5_euphoria": 189.2
  },
  {
    "symbol": "1731.TW",
    "name": "美吾華",
    "sector": "生技醫療業",
    "close": 21.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.5,
    "dog_ma200_bias": -0.238,
    "vr60": 1.06,
    "rs20": 0.6,
    "rs60": 0.53,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 262500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.8,
    "ladder_minus1_pullback": 19.7,
    "ladder_4_base": 18.9,
    "ladder_5_euphoria": 27.3
  },
  {
    "symbol": "8059.TWO",
    "name": "凱碩",
    "sector": "通信網路業",
    "close": 17.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": 0.04,
    "vr60": 1.87,
    "rs20": 0.77,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 425000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.3,
    "ladder_minus1_pullback": 16.0,
    "ladder_4_base": 15.3,
    "ladder_5_euphoria": 22.1
  },
  {
    "symbol": "2239.TW",
    "name": "英利-KY",
    "sector": "汽車工業",
    "close": 17.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.67,
    "dog_ma200_bias": 0.134,
    "vr60": 1.23,
    "rs20": 1.11,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 431250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.6,
    "ladder_minus1_pullback": 16.2,
    "ladder_4_base": 15.5,
    "ladder_5_euphoria": 22.4
  },
  {
    "symbol": "2063.TWO",
    "name": "世鎧",
    "sector": "鋼鐵工業",
    "close": 23.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.57,
    "dog_ma200_bias": 0.077,
    "vr60": 1.7,
    "rs20": 0.98,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 592500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.4,
    "ladder_minus1_pullback": 22.3,
    "ladder_4_base": 21.3,
    "ladder_5_euphoria": 30.8
  },
  {
    "symbol": "3188.TWO",
    "name": "鑫龍騰",
    "sector": "建材營造業",
    "close": 22.85,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.5,
    "dog_ma200_bias": -0.03,
    "vr60": 2.14,
    "rs20": 0.71,
    "rs60": 0.5,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 20.8,
    "ladder_minus1_pullback": 21.5,
    "ladder_4_base": 20.6,
    "ladder_5_euphoria": 29.7
  },
  {
    "symbol": "1467.TW",
    "name": "南緯",
    "sector": "紡織纖維業",
    "close": 8.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.25,
    "dog_ma200_bias": 0.033,
    "vr60": 1.33,
    "rs20": 0.8,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 202500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.6,
    "ladder_minus1_pullback": 7.6,
    "ladder_4_base": 7.3,
    "ladder_5_euphoria": 10.5
  },
  {
    "symbol": "4557.TW",
    "name": "永新-KY",
    "sector": "汽車工業",
    "close": 52.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.94,
    "dog_ma200_bias": -0.007,
    "vr60": 1.98,
    "rs20": 1.08,
    "rs60": 0.96,
    "shares": 11834,
    "lots": 11,
    "odd_shares": 834,
    "ntd_at_risk": 39998.92,
    "position_cost": 626018.6,
    "constraint": "WEIGHT",
    "atr14": 1.69,
    "low_20d": 50.2,
    "ladder_minus1_pullback": 49.7,
    "ladder_4_base": 47.6,
    "ladder_5_euphoria": 68.8
  },
  {
    "symbol": "5493.TWO",
    "name": "三聯",
    "sector": "其他電子業",
    "close": 88.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.39,
    "dog_ma200_bias": -0.07,
    "vr60": 0.7,
    "rs20": 0.61,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.24,
    "low_20d": 79.6,
    "ladder_minus1_pullback": 82.7,
    "ladder_4_base": 79.2,
    "ladder_5_euphoria": 114.4
  },
  {
    "symbol": "6922.TWO",
    "name": "宸曜",
    "sector": "電腦及週邊設備業",
    "close": 194.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.14,
    "dog_ma200_bias": -0.093,
    "vr60": 0.69,
    "rs20": 0.41,
    "rs60": 0.66,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 6.42,
    "low_20d": 185.6,
    "ladder_minus1_pullback": 182.4,
    "ladder_4_base": 174.6,
    "ladder_5_euphoria": 252.2
  },
  {
    "symbol": "1784.TWO",
    "name": "訊聯",
    "sector": "生技醫療業",
    "close": 56.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.012,
    "vr60": 2.1,
    "rs20": 1.06,
    "rs60": 0.75,
    "shares": 16806,
    "lots": 16,
    "odd_shares": 806,
    "ntd_at_risk": 39998.28,
    "position_cost": 946177.8,
    "constraint": "WEIGHT",
    "atr14": 1.19,
    "low_20d": 52.5,
    "ladder_minus1_pullback": 52.9,
    "ladder_4_base": 50.7,
    "ladder_5_euphoria": 73.2
  },
  {
    "symbol": "2736.TWO",
    "name": "富野",
    "sector": "觀光餐旅",
    "close": 10.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": 0.065,
    "vr60": 1.79,
    "rs20": 1.07,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 263750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.7,
    "ladder_minus1_pullback": 9.9,
    "ladder_4_base": 9.5,
    "ladder_5_euphoria": 13.7
  },
  {
    "symbol": "3628.TWO",
    "name": "盈正",
    "sector": "其他電子業",
    "close": 70.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": -0.005,
    "vr60": 1.41,
    "rs20": 0.76,
    "rs60": 0.79,
    "shares": 11834,
    "lots": 11,
    "odd_shares": 834,
    "ntd_at_risk": 39998.92,
    "position_cost": 829563.4,
    "constraint": "WEIGHT",
    "atr14": 1.69,
    "low_20d": 67.0,
    "ladder_minus1_pullback": 65.9,
    "ladder_4_base": 63.1,
    "ladder_5_euphoria": 91.1
  },
  {
    "symbol": "6654.TWO",
    "name": "天正國際",
    "sector": "其他電子業",
    "close": 200.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.22,
    "dog_ma200_bias": -0.153,
    "vr60": 0.85,
    "rs20": 0.6,
    "rs60": 0.52,
    "shares": 2840,
    "lots": 2,
    "odd_shares": 840,
    "ntd_at_risk": 19993.6,
    "position_cost": 568000.0,
    "constraint": "WEIGHT",
    "atr14": 3.52,
    "low_20d": 180.3,
    "ladder_minus1_pullback": 188.0,
    "ladder_4_base": 180.0,
    "ladder_5_euphoria": 260.0
  },
  {
    "symbol": "9928.TW",
    "name": "中視",
    "sector": "其他業",
    "close": 17.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.95,
    "dog_ma200_bias": 0.016,
    "vr60": 1.84,
    "rs20": 0.94,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 442500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.0,
    "ladder_minus1_pullback": 16.6,
    "ladder_4_base": 15.9,
    "ladder_5_euphoria": 23.0
  },
  {
    "symbol": "3716.TW",
    "name": "中化控股",
    "sector": "生技醫療業",
    "close": 34.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.5,
    "dog_ma200_bias": -0.082,
    "vr60": 0.9,
    "rs20": 0.34,
    "rs60": 0.38,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.13,
    "low_20d": 31.9,
    "ladder_minus1_pullback": 32.0,
    "ladder_4_base": 30.6,
    "ladder_5_euphoria": 44.2
  },
  {
    "symbol": "5283.TW",
    "name": "禾聯碩",
    "sector": "電器電纜業",
    "close": 51.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.5,
    "dog_ma200_bias": 0.067,
    "vr60": 1.36,
    "rs20": 0.82,
    "rs60": 0.88,
    "shares": 13605,
    "lots": 13,
    "odd_shares": 605,
    "ntd_at_risk": 39998.7,
    "position_cost": 703378.5,
    "constraint": "WEIGHT",
    "atr14": 1.47,
    "low_20d": 47.5,
    "ladder_minus1_pullback": 48.6,
    "ladder_4_base": 46.5,
    "ladder_5_euphoria": 67.2
  },
  {
    "symbol": "6431.TW",
    "name": "光麗-KY",
    "sector": "生技醫療業",
    "close": 16.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.24,
    "dog_ma200_bias": 0.007,
    "vr60": 2.0,
    "rs20": 0.98,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 418750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.2,
    "ladder_minus1_pullback": 15.7,
    "ladder_4_base": 15.1,
    "ladder_5_euphoria": 21.8
  },
  {
    "symbol": "9924.TW",
    "name": "福興",
    "sector": "居家生活",
    "close": 38.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.05,
    "dog_ma200_bias": 0.077,
    "vr60": 1.67,
    "rs20": 0.98,
    "rs60": 0.85,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 860639.3,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 36.0,
    "ladder_minus1_pullback": 36.0,
    "ladder_4_base": 34.5,
    "ladder_5_euphoria": 49.8
  },
  {
    "symbol": "4188.TWO",
    "name": "安克",
    "sector": "生技醫療業",
    "close": 13.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.95,
    "dog_ma200_bias": -0.012,
    "vr60": 1.89,
    "rs20": 1.02,
    "rs60": 1.01,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 327500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.1,
    "ladder_minus1_pullback": 12.3,
    "ladder_4_base": 11.8,
    "ladder_5_euphoria": 17.0
  },
  {
    "symbol": "6576.TWO",
    "name": "逸達",
    "sector": "生技醫療業",
    "close": 77.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.93,
    "dog_ma200_bias": -0.017,
    "vr60": 1.81,
    "rs20": 1.02,
    "rs60": 0.84,
    "shares": 12738,
    "lots": 12,
    "odd_shares": 738,
    "ntd_at_risk": 39997.32,
    "position_cost": 983373.6,
    "constraint": "WEIGHT",
    "atr14": 1.57,
    "low_20d": 69.9,
    "ladder_minus1_pullback": 72.6,
    "ladder_4_base": 69.5,
    "ladder_5_euphoria": 100.4
  },
  {
    "symbol": "8938.TWO",
    "name": "明安",
    "sector": "運動休閒",
    "close": 50.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.2,
    "dog_ma200_bias": 0.039,
    "vr60": 2.06,
    "rs20": 1.08,
    "rs60": 0.75,
    "shares": 23809,
    "lots": 23,
    "odd_shares": 809,
    "ntd_at_risk": 39999.12,
    "position_cost": 1202354.5,
    "constraint": "WEIGHT",
    "atr14": 0.84,
    "low_20d": 46.5,
    "ladder_minus1_pullback": 47.5,
    "ladder_4_base": 45.5,
    "ladder_5_euphoria": 65.7
  },
  {
    "symbol": "1315.TW",
    "name": "達新",
    "sector": "塑膠工業",
    "close": 74.4,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.38,
    "dog_ma200_bias": -0.265,
    "vr60": 1.02,
    "rs20": 0.46,
    "rs60": 0.35,
    "shares": 5347,
    "lots": 5,
    "odd_shares": 347,
    "ntd_at_risk": 19997.78,
    "position_cost": 397816.8,
    "constraint": "WEIGHT",
    "atr14": 1.87,
    "low_20d": 70.9,
    "ladder_minus1_pullback": 69.9,
    "ladder_4_base": 67.0,
    "ladder_5_euphoria": 96.7
  },
  {
    "symbol": "2477.TW",
    "name": "美隆電",
    "sector": "其他電子業",
    "close": 22.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.83,
    "dog_ma200_bias": 0.039,
    "vr60": 1.21,
    "rs20": 1.14,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 568750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.7,
    "ladder_minus1_pullback": 21.4,
    "ladder_4_base": 20.5,
    "ladder_5_euphoria": 29.6
  },
  {
    "symbol": "5478.TWO",
    "name": "智冠",
    "sector": "文化創意業",
    "close": 98.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.15,
    "dog_ma200_bias": 0.075,
    "vr60": 1.49,
    "rs20": 1.04,
    "rs60": 0.96,
    "shares": 9090,
    "lots": 9,
    "odd_shares": 90,
    "ntd_at_risk": 39996.0,
    "position_cost": 890820.0,
    "constraint": "WEIGHT",
    "atr14": 2.2,
    "low_20d": 93.2,
    "ladder_minus1_pullback": 92.1,
    "ladder_4_base": 88.2,
    "ladder_5_euphoria": 127.4
  },
  {
    "symbol": "9943.TW",
    "name": "好樂迪",
    "sector": "觀光餐旅",
    "close": 50.9,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.95,
    "dog_ma200_bias": -0.066,
    "vr60": 0.8,
    "rs20": 0.37,
    "rs60": 0.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.56,
    "low_20d": 46.2,
    "ladder_minus1_pullback": 47.8,
    "ladder_4_base": 45.8,
    "ladder_5_euphoria": 66.2
  },
  {
    "symbol": "3313.TWO",
    "name": "斐成",
    "sector": "建材營造業",
    "close": 10.25,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.25,
    "dog_ma200_bias": -0.016,
    "vr60": 1.59,
    "rs20": 0.42,
    "rs60": 0.47,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.3,
    "ladder_minus1_pullback": 9.6,
    "ladder_4_base": 9.2,
    "ladder_5_euphoria": 13.3
  },
  {
    "symbol": "4741.TWO",
    "name": "泓瀚",
    "sector": "化學工業",
    "close": 38.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.17,
    "dog_ma200_bias": 0.018,
    "vr60": 1.56,
    "rs20": 0.82,
    "rs60": 1.04,
    "shares": 19047,
    "lots": 19,
    "odd_shares": 47,
    "ntd_at_risk": 39998.7,
    "position_cost": 733309.5,
    "constraint": "WEIGHT",
    "atr14": 1.05,
    "low_20d": 36.6,
    "ladder_minus1_pullback": 36.2,
    "ladder_4_base": 34.6,
    "ladder_5_euphoria": 50.1
  },
  {
    "symbol": "8354.TWO",
    "name": "冠好",
    "sector": "其他業",
    "close": 17.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.25,
    "dog_ma200_bias": 0.067,
    "vr60": 1.28,
    "rs20": 1.09,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 430000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.0,
    "ladder_minus1_pullback": 16.2,
    "ladder_4_base": 15.5,
    "ladder_5_euphoria": 22.4
  },
  {
    "symbol": "2748.TW",
    "name": "雲品",
    "sector": "觀光餐旅",
    "close": 38.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.13,
    "dog_ma200_bias": 0.058,
    "vr60": 1.46,
    "rs20": 1.05,
    "rs60": 0.93,
    "shares": 16949,
    "lots": 16,
    "odd_shares": 949,
    "ntd_at_risk": 39999.64,
    "position_cost": 651689.05,
    "constraint": "WEIGHT",
    "atr14": 1.18,
    "low_20d": 36.7,
    "ladder_minus1_pullback": 36.1,
    "ladder_4_base": 34.6,
    "ladder_5_euphoria": 50.0
  },
  {
    "symbol": "6552.TW",
    "name": "易華電",
    "sector": "半導體業",
    "close": 23.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.05,
    "dog_ma200_bias": -0.008,
    "vr60": 1.64,
    "rs20": 0.92,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 582500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.1,
    "ladder_minus1_pullback": 21.9,
    "ladder_4_base": 21.0,
    "ladder_5_euphoria": 30.3
  },
  {
    "symbol": "1539.TW",
    "name": "巨庭",
    "sector": "電機機械業",
    "close": 15.55,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.95,
    "dog_ma200_bias": -0.224,
    "vr60": 0.96,
    "rs20": 0.25,
    "rs60": 0.43,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 194375.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.8,
    "ladder_minus1_pullback": 14.6,
    "ladder_4_base": 14.0,
    "ladder_5_euphoria": 20.2
  },
  {
    "symbol": "3555.TWO",
    "name": "博士旺",
    "sector": "半導體業",
    "close": 141.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.36,
    "dog_ma200_bias": 0.031,
    "vr60": 1.64,
    "rs20": 1.1,
    "rs60": 0.87,
    "shares": 9389,
    "lots": 9,
    "odd_shares": 389,
    "ntd_at_risk": 39997.14,
    "position_cost": 1328543.5,
    "constraint": "WEIGHT",
    "atr14": 2.13,
    "low_20d": 129.1,
    "ladder_minus1_pullback": 133.0,
    "ladder_4_base": 127.4,
    "ladder_5_euphoria": 184.0
  },
  {
    "symbol": "5438.TWO",
    "name": "東友",
    "sector": "電腦及週邊設備業",
    "close": 16.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.05,
    "dog_ma200_bias": 0.036,
    "vr60": 1.58,
    "rs20": 1.05,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 417500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.0,
    "ladder_minus1_pullback": 15.7,
    "ladder_4_base": 15.0,
    "ladder_5_euphoria": 21.7
  },
  {
    "symbol": "1531.TW",
    "name": "高林股",
    "sector": "電機機械業",
    "close": 11.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.33,
    "dog_ma200_bias": 0.041,
    "vr60": 1.59,
    "rs20": 0.92,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 290000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.8,
    "ladder_minus1_pullback": 10.9,
    "ladder_4_base": 10.4,
    "ladder_5_euphoria": 15.1
  },
  {
    "symbol": "6790.TW",
    "name": "永豐實",
    "sector": "造紙工業",
    "close": 37.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.67,
    "dog_ma200_bias": 0.101,
    "vr60": 1.33,
    "rs20": 1.04,
    "rs60": 1.17,
    "shares": 15151,
    "lots": 15,
    "odd_shares": 151,
    "ntd_at_risk": 39998.64,
    "position_cost": 573465.35,
    "constraint": "WEIGHT",
    "atr14": 1.32,
    "low_20d": 35.0,
    "ladder_minus1_pullback": 35.6,
    "ladder_4_base": 34.1,
    "ladder_5_euphoria": 49.2
  },
  {
    "symbol": "1432.TW",
    "name": "大魯閣",
    "sector": "運動休閒",
    "close": 15.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.95,
    "dog_ma200_bias": -0.004,
    "vr60": 1.65,
    "rs20": 1.0,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 375000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.5
  },
  {
    "symbol": "3419.TW",
    "name": "譁裕",
    "sector": "通信網路業",
    "close": 11.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.8,
    "dog_ma200_bias": 0.095,
    "vr60": 1.31,
    "rs20": 1.31,
    "rs60": 1.09,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 292500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.1,
    "ladder_minus1_pullback": 11.0,
    "ladder_4_base": 10.5,
    "ladder_5_euphoria": 15.2
  },
  {
    "symbol": "9930.TW",
    "name": "中聯資源",
    "sector": "綠能環保",
    "close": 59.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.33,
    "dog_ma200_bias": 0.078,
    "vr60": 1.13,
    "rs20": 1.31,
    "rs60": 1.24,
    "shares": 18018,
    "lots": 18,
    "odd_shares": 18,
    "ntd_at_risk": 39999.96,
    "position_cost": 1077476.4,
    "constraint": "WEIGHT",
    "atr14": 1.11,
    "low_20d": 56.7,
    "ladder_minus1_pullback": 56.2,
    "ladder_4_base": 53.8,
    "ladder_5_euphoria": 77.7
  },
  {
    "symbol": "2070.TWO",
    "name": "精湛",
    "sector": "電機機械業",
    "close": 59.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.05,
    "dog_ma200_bias": 0.032,
    "vr60": 1.47,
    "rs20": 0.77,
    "rs60": 0.73,
    "shares": 13071,
    "lots": 13,
    "odd_shares": 71,
    "ntd_at_risk": 39997.26,
    "position_cost": 773803.2,
    "constraint": "WEIGHT",
    "atr14": 1.53,
    "low_20d": 53.4,
    "ladder_minus1_pullback": 55.6,
    "ladder_4_base": 53.3,
    "ladder_5_euphoria": 77.0
  },
  {
    "symbol": "6494.TWO",
    "name": "九齊",
    "sector": "半導體業",
    "close": 47.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.33,
    "dog_ma200_bias": -0.015,
    "vr60": 1.3,
    "rs20": 0.92,
    "rs60": 0.73,
    "shares": 14492,
    "lots": 14,
    "odd_shares": 492,
    "ntd_at_risk": 39997.92,
    "position_cost": 688370.0,
    "constraint": "WEIGHT",
    "atr14": 1.38,
    "low_20d": 45.4,
    "ladder_minus1_pullback": 44.6,
    "ladder_4_base": 42.8,
    "ladder_5_euphoria": 61.8
  },
  {
    "symbol": "4195.TW",
    "name": "基米-創",
    "sector": "生技醫療業",
    "close": 15.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.05,
    "dog_ma200_bias": 0.046,
    "vr60": 1.71,
    "rs20": 0.85,
    "rs60": 0.79,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 390000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.0,
    "ladder_minus1_pullback": 14.7,
    "ladder_4_base": 14.0,
    "ladder_5_euphoria": 20.3
  },
  {
    "symbol": "2706.TW",
    "name": "第一店",
    "sector": "觀光餐旅",
    "close": 12.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.5,
    "dog_ma200_bias": 0.07,
    "vr60": 1.35,
    "rs20": 1.0,
    "rs60": 1.16,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 305000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.3,
    "ladder_minus1_pullback": 11.5,
    "ladder_4_base": 11.0,
    "ladder_5_euphoria": 15.9
  },
  {
    "symbol": "7631.TW",
    "name": "聚賢研發-創",
    "sector": "其他電子業",
    "close": 134.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.22,
    "dog_ma200_bias": -0.002,
    "vr60": 1.36,
    "rs20": 0.91,
    "rs60": 0.73,
    "shares": 5934,
    "lots": 5,
    "odd_shares": 934,
    "ntd_at_risk": 39995.16,
    "position_cost": 795156.0,
    "constraint": "WEIGHT",
    "atr14": 3.37,
    "low_20d": 126.3,
    "ladder_minus1_pullback": 126.0,
    "ladder_4_base": 120.6,
    "ladder_5_euphoria": 174.2
  },
  {
    "symbol": "3152.TWO",
    "name": "璟德",
    "sector": "通信網路業",
    "close": 227.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.1,
    "dog_ma200_bias": 0.068,
    "vr60": 1.47,
    "rs20": 0.98,
    "rs60": 0.86,
    "shares": 2797,
    "lots": 2,
    "odd_shares": 797,
    "ntd_at_risk": 39997.1,
    "position_cost": 634919.0,
    "constraint": "WEIGHT",
    "atr14": 7.15,
    "low_20d": 207.9,
    "ladder_minus1_pullback": 213.4,
    "ladder_4_base": 204.3,
    "ladder_5_euphoria": 295.1
  },
  {
    "symbol": "2524.TW",
    "name": "京城",
    "sector": "建材營造業",
    "close": 33.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.16,
    "dog_ma200_bias": 0.14,
    "vr60": 1.42,
    "rs20": 1.06,
    "rs60": 1.29,
    "shares": 21052,
    "lots": 21,
    "odd_shares": 52,
    "ntd_at_risk": 39998.8,
    "position_cost": 708399.8,
    "constraint": "WEIGHT",
    "atr14": 0.95,
    "low_20d": 30.3,
    "ladder_minus1_pullback": 31.6,
    "ladder_4_base": 30.3,
    "ladder_5_euphoria": 43.7
  },
  {
    "symbol": "3494.TW",
    "name": "誠研",
    "sector": "電腦及週邊設備業",
    "close": 7.06,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.78,
    "dog_ma200_bias": 0.067,
    "vr60": 1.37,
    "rs20": 0.82,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 176500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 6.8,
    "ladder_minus1_pullback": 6.6,
    "ladder_4_base": 6.4,
    "ladder_5_euphoria": 9.2
  },
  {
    "symbol": "6534.TW",
    "name": "正瀚-創",
    "sector": "生技醫療業",
    "close": 93.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.05,
    "dog_ma200_bias": 0.04,
    "vr60": 1.98,
    "rs20": 0.79,
    "rs60": 0.89,
    "shares": 9803,
    "lots": 9,
    "odd_shares": 803,
    "ntd_at_risk": 39996.24,
    "position_cost": 915600.2,
    "constraint": "WEIGHT",
    "atr14": 2.04,
    "low_20d": 85.6,
    "ladder_minus1_pullback": 87.8,
    "ladder_4_base": 84.1,
    "ladder_5_euphoria": 121.4
  },
  {
    "symbol": "2028.TW",
    "name": "威致",
    "sector": "鋼鐵工業",
    "close": 16.55,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": -0.279,
    "vr60": 0.7,
    "rs20": 0.27,
    "rs60": 0.36,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 206875.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.8,
    "ladder_minus1_pullback": 15.6,
    "ladder_4_base": 14.9,
    "ladder_5_euphoria": 21.5
  },
  {
    "symbol": "3686.TW",
    "name": "達能",
    "sector": "半導體業",
    "close": 15.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.44,
    "dog_ma200_bias": 0.067,
    "vr60": 2.07,
    "rs20": 0.99,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 380000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.6,
    "ladder_minus1_pullback": 14.3,
    "ladder_4_base": 13.7,
    "ladder_5_euphoria": 19.8
  },
  {
    "symbol": "8462.TW",
    "name": "柏文",
    "sector": "運動休閒",
    "close": 155.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.95,
    "dog_ma200_bias": 0.042,
    "vr60": 2.08,
    "rs20": 0.89,
    "rs60": 0.94,
    "shares": 7692,
    "lots": 7,
    "odd_shares": 692,
    "ntd_at_risk": 39998.4,
    "position_cost": 1192260.0,
    "constraint": "WEIGHT",
    "atr14": 2.6,
    "low_20d": 143.3,
    "ladder_minus1_pullback": 145.7,
    "ladder_4_base": 139.5,
    "ladder_5_euphoria": 201.5
  },
  {
    "symbol": "1614.TW",
    "name": "三洋電",
    "sector": "電器電纜業",
    "close": 31.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.5,
    "dog_ma200_bias": 0.049,
    "vr60": 1.56,
    "rs20": 0.87,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 788750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.0,
    "ladder_minus1_pullback": 29.7,
    "ladder_4_base": 28.4,
    "ladder_5_euphoria": 41.0
  },
  {
    "symbol": "3224.TWO",
    "name": "三顧",
    "sector": "電子通路業",
    "close": 30.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.77,
    "cpr": 0.36,
    "dog_ma200_bias": -0.019,
    "vr60": 1.3,
    "rs20": 0.76,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 758750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.7,
    "ladder_minus1_pullback": 28.5,
    "ladder_4_base": 27.3,
    "ladder_5_euphoria": 39.5
  },
  {
    "symbol": "4543.TWO",
    "name": "萬在",
    "sector": "電機機械業",
    "close": 29.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.21,
    "dog_ma200_bias": 0.066,
    "vr60": 1.39,
    "rs20": 1.01,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 741250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.1,
    "ladder_minus1_pullback": 27.9,
    "ladder_4_base": 26.7,
    "ladder_5_euphoria": 38.5
  },
  {
    "symbol": "6229.TWO",
    "name": "研通",
    "sector": "半導體業",
    "close": 22.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.14,
    "dog_ma200_bias": 0.112,
    "vr60": 1.43,
    "rs20": 1.27,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 571250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.9,
    "ladder_minus1_pullback": 21.5,
    "ladder_4_base": 20.6,
    "ladder_5_euphoria": 29.7
  },
  {
    "symbol": "7738.TWO",
    "name": "東聯互動",
    "sector": "數位雲端",
    "close": 161.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.67,
    "dog_ma200_bias": -0.226,
    "vr60": 0.86,
    "rs20": 0.39,
    "rs60": 0.19,
    "shares": 1769,
    "lots": 1,
    "odd_shares": 769,
    "ntd_at_risk": 19989.7,
    "position_cost": 285693.5,
    "constraint": "WEIGHT",
    "atr14": 5.65,
    "low_20d": 153.2,
    "ladder_minus1_pullback": 151.8,
    "ladder_4_base": 145.3,
    "ladder_5_euphoria": 210.0
  },
  {
    "symbol": "1776.TW",
    "name": "展宇",
    "sector": "化學工業",
    "close": 18.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.38,
    "dog_ma200_bias": -0.005,
    "vr60": 1.83,
    "rs20": 1.14,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 467500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.6,
    "ladder_minus1_pullback": 17.6,
    "ladder_4_base": 16.8,
    "ladder_5_euphoria": 24.3
  },
  {
    "symbol": "2506.TW",
    "name": "太設",
    "sector": "建材營造業",
    "close": 8.39,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.33,
    "dog_ma200_bias": 0.066,
    "vr60": 1.73,
    "rs20": 0.83,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 209750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.6,
    "ladder_minus1_pullback": 7.9,
    "ladder_4_base": 7.6,
    "ladder_5_euphoria": 10.9
  },
  {
    "symbol": "1463.TW",
    "name": "強盛新",
    "sector": "紡織纖維業",
    "close": 17.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.95,
    "dog_ma200_bias": 0.16,
    "vr60": 1.08,
    "rs20": 0.95,
    "rs60": 1.15,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 447500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.7,
    "ladder_minus1_pullback": 16.8,
    "ladder_4_base": 16.1,
    "ladder_5_euphoria": 23.3
  },
  {
    "symbol": "1580.TWO",
    "name": "新麥",
    "sector": "電機機械業",
    "close": 96.1,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.2,
    "dog_ma200_bias": 0.323,
    "vr60": 2.58,
    "rs20": 1.45,
    "rs60": 1.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.31,
    "low_20d": 91.4,
    "ladder_minus1_pullback": 90.3,
    "ladder_4_base": 86.5,
    "ladder_5_euphoria": 124.9
  },
  {
    "symbol": "3122.TWO",
    "name": "笙泉",
    "sector": "半導體業",
    "close": 23.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.17,
    "dog_ma200_bias": 0.127,
    "vr60": 1.22,
    "rs20": 1.14,
    "rs60": 1.09,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 587500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.5,
    "ladder_minus1_pullback": 22.1,
    "ladder_4_base": 21.2,
    "ladder_5_euphoria": 30.6
  },
  {
    "symbol": "5310.TWO",
    "name": "天剛",
    "sector": "資訊服務業",
    "close": 26.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.05,
    "dog_ma200_bias": 0.039,
    "vr60": 1.75,
    "rs20": 1.02,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 666250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.0,
    "ladder_minus1_pullback": 25.1,
    "ladder_4_base": 24.0,
    "ladder_5_euphoria": 34.6
  },
  {
    "symbol": "1225.TW",
    "name": "福懋油",
    "sector": "食品工業",
    "close": 24.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.56,
    "dog_ma200_bias": 0.029,
    "vr60": 1.84,
    "rs20": 0.96,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 618750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.7,
    "ladder_minus1_pullback": 23.3,
    "ladder_4_base": 22.3,
    "ladder_5_euphoria": 32.2
  },
  {
    "symbol": "1338.TW",
    "name": "廣華-KY",
    "sector": "汽車工業",
    "close": 14.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.17,
    "dog_ma200_bias": 0.012,
    "vr60": 1.26,
    "rs20": 1.11,
    "rs60": 0.85,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 363750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 13.7,
    "ladder_4_base": 13.1,
    "ladder_5_euphoria": 18.9
  },
  {
    "symbol": "4545.TW",
    "name": "銘鈺",
    "sector": "電子零組件業",
    "close": 37.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.65,
    "dog_ma200_bias": 0.027,
    "vr60": 1.65,
    "rs20": 1.13,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 926250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 35.4,
    "ladder_minus1_pullback": 34.8,
    "ladder_4_base": 33.3,
    "ladder_5_euphoria": 48.2
  },
  {
    "symbol": "3086.TWO",
    "name": "華義*",
    "sector": "文化創意業",
    "close": 26.55,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.08,
    "dog_ma200_bias": -0.01,
    "vr60": 1.32,
    "rs20": 0.5,
    "rs60": 0.52,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 25.0,
    "ladder_minus1_pullback": 25.0,
    "ladder_4_base": 23.9,
    "ladder_5_euphoria": 34.5
  },
  {
    "symbol": "5481.TWO",
    "name": "新華",
    "sector": "其他業",
    "close": 20.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.73,
    "dog_ma200_bias": 0.003,
    "vr60": 1.4,
    "rs20": 1.11,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 516250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.4,
    "ladder_minus1_pullback": 19.4,
    "ladder_4_base": 18.6,
    "ladder_5_euphoria": 26.8
  },
  {
    "symbol": "6109.TWO",
    "name": "亞元",
    "sector": "通信網路業",
    "close": 10.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.5,
    "dog_ma200_bias": 0.132,
    "vr60": 1.56,
    "rs20": 1.21,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 252500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.6,
    "ladder_minus1_pullback": 9.5,
    "ladder_4_base": 9.1,
    "ladder_5_euphoria": 13.1
  },
  {
    "symbol": "6863.TW",
    "name": "永道-KY",
    "sector": "通信網路業",
    "close": 101.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.2,
    "dog_ma200_bias": 0.009,
    "vr60": 1.84,
    "rs20": 1.13,
    "rs60": 0.99,
    "shares": 6711,
    "lots": 6,
    "odd_shares": 711,
    "ntd_at_risk": 39997.56,
    "position_cost": 677811.0,
    "constraint": "WEIGHT",
    "atr14": 2.98,
    "low_20d": 94.3,
    "ladder_minus1_pullback": 94.9,
    "ladder_4_base": 90.9,
    "ladder_5_euphoria": 131.3
  },
  {
    "symbol": "4169.TW",
    "name": "泰宗",
    "sector": "生技醫療業",
    "close": 145.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.62,
    "dog_ma200_bias": 0.047,
    "vr60": 1.86,
    "rs20": 1.07,
    "rs60": 0.98,
    "shares": 7547,
    "lots": 7,
    "odd_shares": 547,
    "ntd_at_risk": 39999.1,
    "position_cost": 1098088.5,
    "constraint": "WEIGHT",
    "atr14": 2.65,
    "low_20d": 131.2,
    "ladder_minus1_pullback": 136.8,
    "ladder_4_base": 131.0,
    "ladder_5_euphoria": 189.2
  },
  {
    "symbol": "8403.TWO",
    "name": "盛弘",
    "sector": "生技醫療業",
    "close": 19.05,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.33,
    "dog_ma200_bias": -0.128,
    "vr60": 0.93,
    "rs20": 0.31,
    "rs60": 0.46,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 238125.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.2,
    "ladder_minus1_pullback": 17.9,
    "ladder_4_base": 17.1,
    "ladder_5_euphoria": 24.8
  },
  {
    "symbol": "1537.TW",
    "name": "廣隆",
    "sector": "電機機械業",
    "close": 115.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.5,
    "dog_ma200_bias": -0.257,
    "vr60": 0.74,
    "rs20": 0.44,
    "rs60": 0.22,
    "shares": 3546,
    "lots": 3,
    "odd_shares": 546,
    "ntd_at_risk": 19999.44,
    "position_cost": 407790.0,
    "constraint": "WEIGHT",
    "atr14": 2.82,
    "low_20d": 108.4,
    "ladder_minus1_pullback": 108.1,
    "ladder_4_base": 103.5,
    "ladder_5_euphoria": 149.5
  },
  {
    "symbol": "1109.TW",
    "name": "信大",
    "sector": "水泥工業",
    "close": 13.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.05,
    "dog_ma200_bias": 0.079,
    "vr60": 1.47,
    "rs20": 0.83,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 327500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.9,
    "ladder_minus1_pullback": 12.3,
    "ladder_4_base": 11.8,
    "ladder_5_euphoria": 17.0
  },
  {
    "symbol": "4168.TWO",
    "name": "醣聯",
    "sector": "生技醫療業",
    "close": 21.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.6,
    "dog_ma200_bias": 0.062,
    "vr60": 1.58,
    "rs20": 1.09,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 542500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.4,
    "ladder_minus1_pullback": 20.4,
    "ladder_4_base": 19.5,
    "ladder_5_euphoria": 28.2
  },
  {
    "symbol": "8432.TWO",
    "name": "東生華",
    "sector": "生技醫療業",
    "close": 54.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.46,
    "dog_ma200_bias": 0.159,
    "vr60": 1.59,
    "rs20": 0.96,
    "rs60": 0.93,
    "shares": 13245,
    "lots": 13,
    "odd_shares": 245,
    "ntd_at_risk": 39999.9,
    "position_cost": 724501.5,
    "constraint": "WEIGHT",
    "atr14": 1.51,
    "low_20d": 50.3,
    "ladder_minus1_pullback": 51.4,
    "ladder_4_base": 49.2,
    "ladder_5_euphoria": 71.1
  },
  {
    "symbol": "2115.TW",
    "name": "六暉-KY",
    "sector": "汽車工業",
    "close": 24.85,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.36,
    "dog_ma200_bias": -0.14,
    "vr60": 0.82,
    "rs20": 0.34,
    "rs60": 0.43,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 23.7,
    "ladder_minus1_pullback": 23.4,
    "ladder_4_base": 22.4,
    "ladder_5_euphoria": 32.3
  },
  {
    "symbol": "1762.TW",
    "name": "中化生",
    "sector": "生技醫療業",
    "close": 34.7,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.82,
    "dog_ma200_bias": -0.234,
    "vr60": 0.8,
    "rs20": 0.34,
    "rs60": 0.2,
    "shares": 9803,
    "lots": 9,
    "odd_shares": 803,
    "ntd_at_risk": 19998.12,
    "position_cost": 340164.1,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 31.6,
    "ladder_minus1_pullback": 32.6,
    "ladder_4_base": 31.2,
    "ladder_5_euphoria": 45.1
  },
  {
    "symbol": "3266.TW",
    "name": "昇陽",
    "sector": "建材營造業",
    "close": 13.7,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.05,
    "dog_ma200_bias": -0.053,
    "vr60": 1.44,
    "rs20": 0.64,
    "rs60": 0.63,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 12.4,
    "ladder_minus1_pullback": 12.9,
    "ladder_4_base": 12.3,
    "ladder_5_euphoria": 17.8
  },
  {
    "symbol": "1474.TW",
    "name": "弘裕",
    "sector": "紡織纖維業",
    "close": 9.99,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.65,
    "dog_ma200_bias": 0.321,
    "vr60": 2.53,
    "rs20": 1.3,
    "rs60": 1.26,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.3,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 13.0
  },
  {
    "symbol": "8045.TW",
    "name": "達運光電",
    "sector": "通信網路業",
    "close": 54.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.13,
    "dog_ma200_bias": -0.009,
    "vr60": 1.3,
    "rs20": 0.99,
    "rs60": 0.97,
    "shares": 16949,
    "lots": 16,
    "odd_shares": 949,
    "ntd_at_risk": 39999.64,
    "position_cost": 925415.4,
    "constraint": "WEIGHT",
    "atr14": 1.18,
    "low_20d": 51.7,
    "ladder_minus1_pullback": 51.3,
    "ladder_4_base": 49.1,
    "ladder_5_euphoria": 71.0
  },
  {
    "symbol": "4974.TWO",
    "name": "亞泰",
    "sector": "電子零組件業",
    "close": 68.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.05,
    "dog_ma200_bias": 0.075,
    "vr60": 1.94,
    "rs20": 0.77,
    "rs60": 0.74,
    "shares": 13698,
    "lots": 13,
    "odd_shares": 698,
    "ntd_at_risk": 39998.16,
    "position_cost": 938313.0,
    "constraint": "WEIGHT",
    "atr14": 1.46,
    "low_20d": 62.0,
    "ladder_minus1_pullback": 64.4,
    "ladder_4_base": 61.6,
    "ladder_5_euphoria": 89.0
  },
  {
    "symbol": "7709.TWO",
    "name": "榮田",
    "sector": "電機機械業",
    "close": 73.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.05,
    "dog_ma200_bias": 0.136,
    "vr60": 1.57,
    "rs20": 1.31,
    "rs60": 0.96,
    "shares": 8849,
    "lots": 8,
    "odd_shares": 849,
    "ntd_at_risk": 39997.48,
    "position_cost": 649516.6,
    "constraint": "WEIGHT",
    "atr14": 2.26,
    "low_20d": 68.0,
    "ladder_minus1_pullback": 69.0,
    "ladder_4_base": 66.1,
    "ladder_5_euphoria": 95.4
  },
  {
    "symbol": "4935.TW",
    "name": "茂林-KY",
    "sector": "光電業",
    "close": 33.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.21,
    "dog_ma200_bias": 0.009,
    "vr60": 1.6,
    "rs20": 0.95,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 840000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 31.9,
    "ladder_minus1_pullback": 31.6,
    "ladder_4_base": 30.2,
    "ladder_5_euphoria": 43.7
  },
  {
    "symbol": "4942.TW",
    "name": "嘉彰",
    "sector": "光電業",
    "close": 31.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.67,
    "dog_ma200_bias": -0.01,
    "vr60": 1.78,
    "rs20": 0.88,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 792500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.2,
    "ladder_minus1_pullback": 29.8,
    "ladder_4_base": 28.5,
    "ladder_5_euphoria": 41.2
  },
  {
    "symbol": "4401.TWO",
    "name": "東隆興",
    "sector": "紡織纖維業",
    "close": 13.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.2,
    "dog_ma200_bias": 0.065,
    "vr60": 1.6,
    "rs20": 0.92,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 338750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.5,
    "ladder_minus1_pullback": 12.7,
    "ladder_4_base": 12.2,
    "ladder_5_euphoria": 17.6
  },
  {
    "symbol": "7810.TWO",
    "name": "捷創科技",
    "sector": "半導體業",
    "close": 232.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.95,
    "dog_ma200_bias": 0.089,
    "vr60": 1.54,
    "rs20": 1.09,
    "rs60": 1.1,
    "shares": 2747,
    "lots": 2,
    "odd_shares": 747,
    "ntd_at_risk": 39996.32,
    "position_cost": 637304.0,
    "constraint": "WEIGHT",
    "atr14": 7.28,
    "low_20d": 215.9,
    "ladder_minus1_pullback": 218.1,
    "ladder_4_base": 208.8,
    "ladder_5_euphoria": 301.6
  },
  {
    "symbol": "2250.TW",
    "name": "IKKA-KY",
    "sector": "汽車工業",
    "close": 51.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.18,
    "dog_ma200_bias": -0.011,
    "vr60": 1.54,
    "rs20": 1.05,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1295000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 48.1,
    "ladder_minus1_pullback": 48.7,
    "ladder_4_base": 46.6,
    "ladder_5_euphoria": 67.3
  },
  {
    "symbol": "1437.TW",
    "name": "勤益控",
    "sector": "其他業",
    "close": 31.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.37,
    "dog_ma200_bias": 0.046,
    "vr60": 1.34,
    "rs20": 1.05,
    "rs60": 0.85,
    "shares": 21505,
    "lots": 21,
    "odd_shares": 505,
    "ntd_at_risk": 39999.3,
    "position_cost": 666655.0,
    "constraint": "WEIGHT",
    "atr14": 0.93,
    "low_20d": 28.6,
    "ladder_minus1_pullback": 29.1,
    "ladder_4_base": 27.9,
    "ladder_5_euphoria": 40.3
  },
  {
    "symbol": "8429.TW",
    "name": "金麗-KY",
    "sector": "貿易百貨業",
    "close": 5.88,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.86,
    "dog_ma200_bias": -0.168,
    "vr60": 0.88,
    "rs20": 0.44,
    "rs60": 0.49,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 5.4,
    "ladder_minus1_pullback": 5.5,
    "ladder_4_base": 5.3,
    "ladder_5_euphoria": 7.6
  },
  {
    "symbol": "4729.TWO",
    "name": "熒茂",
    "sector": "光電業",
    "close": 19.2,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.25,
    "dog_ma200_bias": -0.034,
    "vr60": 2.07,
    "rs20": 0.68,
    "rs60": 0.58,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 18.1,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.3,
    "ladder_5_euphoria": 25.0
  },
  {
    "symbol": "2705.TW",
    "name": "六福",
    "sector": "觀光餐旅",
    "close": 15.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.95,
    "dog_ma200_bias": -0.005,
    "vr60": 1.21,
    "rs20": 1.07,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 377500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 14.2,
    "ladder_4_base": 13.6,
    "ladder_5_euphoria": 19.6
  },
  {
    "symbol": "1268.TWO",
    "name": "漢來美食",
    "sector": "觀光餐旅",
    "close": 179.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.5,
    "dog_ma200_bias": -0.012,
    "vr60": 1.48,
    "rs20": 1.14,
    "rs60": 0.76,
    "shares": 6230,
    "lots": 6,
    "odd_shares": 230,
    "ntd_at_risk": 39996.6,
    "position_cost": 1118285.0,
    "constraint": "WEIGHT",
    "atr14": 3.21,
    "low_20d": 163.2,
    "ladder_minus1_pullback": 168.7,
    "ladder_4_base": 161.6,
    "ladder_5_euphoria": 233.3
  },
  {
    "symbol": "1780.TWO",
    "name": "立弘",
    "sector": "食品工業",
    "close": 24.7,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.91,
    "dog_ma200_bias": -0.191,
    "vr60": 0.87,
    "rs20": 0.53,
    "rs60": 0.57,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 22.8,
    "ladder_minus1_pullback": 23.2,
    "ladder_4_base": 22.2,
    "ladder_5_euphoria": 32.1
  },
  {
    "symbol": "3128.TWO",
    "name": "昇銳",
    "sector": "光電業",
    "close": 20.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.95,
    "dog_ma200_bias": 0.07,
    "vr60": 1.25,
    "rs20": 1.0,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 502500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.7,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.1
  },
  {
    "symbol": "6219.TWO",
    "name": "富旺",
    "sector": "建材營造業",
    "close": 12.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.95,
    "dog_ma200_bias": 0.046,
    "vr60": 1.67,
    "rs20": 0.87,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 300000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.3,
    "ladder_minus1_pullback": 11.3,
    "ladder_4_base": 10.8,
    "ladder_5_euphoria": 15.6
  },
  {
    "symbol": "6928.TW",
    "name": "攸泰科技",
    "sector": "電腦及週邊設備業",
    "close": 45.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.9,
    "dog_ma200_bias": 0.048,
    "vr60": 1.7,
    "rs20": 0.87,
    "rs60": 0.96,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 737901.75,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 42.4,
    "ladder_minus1_pullback": 43.0,
    "ladder_4_base": 41.2,
    "ladder_5_euphoria": 59.5
  },
  {
    "symbol": "2514.TW",
    "name": "龍邦",
    "sector": "其他業",
    "close": 11.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.05,
    "dog_ma200_bias": 0.071,
    "vr60": 1.21,
    "rs20": 0.86,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 280000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.1,
    "ladder_minus1_pullback": 10.5,
    "ladder_4_base": 10.1,
    "ladder_5_euphoria": 14.6
  },
  {
    "symbol": "4569.TW",
    "name": "六方科-KY",
    "sector": "汽車工業",
    "close": 153.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.33,
    "dog_ma200_bias": -0.114,
    "vr60": 0.97,
    "rs20": 0.38,
    "rs60": 0.26,
    "shares": 3745,
    "lots": 3,
    "odd_shares": 745,
    "ntd_at_risk": 19998.3,
    "position_cost": 574857.5,
    "constraint": "WEIGHT",
    "atr14": 2.67,
    "low_20d": 140.6,
    "ladder_minus1_pullback": 144.3,
    "ladder_4_base": 138.2,
    "ladder_5_euphoria": 199.6
  },
  {
    "symbol": "2916.TWO",
    "name": "滿心",
    "sector": "居家生活",
    "close": 39.9,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.11,
    "dog_ma200_bias": -0.001,
    "vr60": 1.89,
    "rs20": 0.64,
    "rs60": 0.76,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 36.4,
    "ladder_minus1_pullback": 37.5,
    "ladder_4_base": 35.9,
    "ladder_5_euphoria": 51.9
  },
  {
    "symbol": "3666.TWO",
    "name": "光耀",
    "sector": "光電業",
    "close": 27.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.59,
    "dog_ma200_bias": 0.109,
    "vr60": 1.17,
    "rs20": 1.07,
    "rs60": 0.91,
    "shares": 23255,
    "lots": 23,
    "odd_shares": 255,
    "ntd_at_risk": 39998.6,
    "position_cost": 647651.75,
    "constraint": "WEIGHT",
    "atr14": 0.86,
    "low_20d": 26.0,
    "ladder_minus1_pullback": 26.2,
    "ladder_4_base": 25.1,
    "ladder_5_euphoria": 36.2
  },
  {
    "symbol": "6872.TWO",
    "name": "浩宇生醫",
    "sector": "生技醫療業",
    "close": 19.95,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.37,
    "dog_ma200_bias": 0.1,
    "vr60": 1.49,
    "rs20": 1.25,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 498750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.8,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 25.9
  },
  {
    "symbol": "6953.TWO",
    "name": "家碩",
    "sector": "半導體業",
    "close": 234.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.21,
    "dog_ma200_bias": 0.079,
    "vr60": 1.46,
    "rs20": 0.79,
    "rs60": 0.89,
    "shares": 5509,
    "lots": 5,
    "odd_shares": 509,
    "ntd_at_risk": 39995.34,
    "position_cost": 1289106.0,
    "constraint": "WEIGHT",
    "atr14": 3.63,
    "low_20d": 215.5,
    "ladder_minus1_pullback": 220.0,
    "ladder_4_base": 210.6,
    "ladder_5_euphoria": 304.2
  },
  {
    "symbol": "8924.TWO",
    "name": "大田",
    "sector": "運動休閒",
    "close": 48.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.2,
    "dog_ma200_bias": 0.032,
    "vr60": 1.88,
    "rs20": 0.81,
    "rs60": 0.71,
    "shares": 24691,
    "lots": 24,
    "odd_shares": 691,
    "ntd_at_risk": 39999.42,
    "position_cost": 1204920.8,
    "constraint": "WEIGHT",
    "atr14": 0.81,
    "low_20d": 45.5,
    "ladder_minus1_pullback": 45.9,
    "ladder_4_base": 43.9,
    "ladder_5_euphoria": 63.4
  },
  {
    "symbol": "1726.TW",
    "name": "永記",
    "sector": "化學工業",
    "close": 75.9,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.2,
    "dog_ma200_bias": 0.339,
    "vr60": 2.19,
    "rs20": 1.23,
    "rs60": 1.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.36,
    "low_20d": 70.0,
    "ladder_minus1_pullback": 71.3,
    "ladder_4_base": 68.3,
    "ladder_5_euphoria": 98.7
  },
  {
    "symbol": "9902.TW",
    "name": "台火",
    "sector": "其他業",
    "close": 13.1,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.25,
    "dog_ma200_bias": 0.377,
    "vr60": 1.71,
    "rs20": 1.17,
    "rs60": 1.23,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 12.0,
    "ladder_minus1_pullback": 12.3,
    "ladder_4_base": 11.8,
    "ladder_5_euphoria": 17.0
  },
  {
    "symbol": "3379.TWO",
    "name": "彬台",
    "sector": "電機機械業",
    "close": 26.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.35,
    "dog_ma200_bias": 0.015,
    "vr60": 1.24,
    "rs20": 1.01,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 650000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.5,
    "ladder_minus1_pullback": 24.4,
    "ladder_4_base": 23.4,
    "ladder_5_euphoria": 33.8
  },
  {
    "symbol": "6996.TWO",
    "name": "力領科技",
    "sector": "半導體業",
    "close": 164.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.5,
    "dog_ma200_bias": 0.01,
    "vr60": 1.86,
    "rs20": 0.93,
    "rs60": 1.04,
    "shares": 5050,
    "lots": 5,
    "odd_shares": 50,
    "ntd_at_risk": 39996.0,
    "position_cost": 830725.0,
    "constraint": "WEIGHT",
    "atr14": 3.96,
    "low_20d": 156.3,
    "ladder_minus1_pullback": 154.6,
    "ladder_4_base": 148.1,
    "ladder_5_euphoria": 213.8
  },
  {
    "symbol": "5538.TW",
    "name": "東明-KY",
    "sector": "鋼鐵工業",
    "close": 36.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.31,
    "dog_ma200_bias": 0.061,
    "vr60": 2.09,
    "rs20": 0.98,
    "rs60": 1.01,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 587095.6,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 34.7,
    "ladder_minus1_pullback": 34.2,
    "ladder_4_base": 32.8,
    "ladder_5_euphoria": 47.3
  },
  {
    "symbol": "2704.TW",
    "name": "國賓",
    "sector": "觀光餐旅",
    "close": 45.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.17,
    "dog_ma200_bias": 0.135,
    "vr60": 1.37,
    "rs20": 1.19,
    "rs60": 1.04,
    "shares": 17094,
    "lots": 17,
    "odd_shares": 94,
    "ntd_at_risk": 39999.96,
    "position_cost": 769230.0,
    "constraint": "WEIGHT",
    "atr14": 1.17,
    "low_20d": 42.2,
    "ladder_minus1_pullback": 42.3,
    "ladder_4_base": 40.5,
    "ladder_5_euphoria": 58.5
  },
  {
    "symbol": "3438.TWO",
    "name": "類比科",
    "sector": "半導體業",
    "close": 58.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.06,
    "dog_ma200_bias": 0.008,
    "vr60": 1.91,
    "rs20": 1.04,
    "rs60": 0.94,
    "shares": 11695,
    "lots": 11,
    "odd_shares": 695,
    "ntd_at_risk": 39996.9,
    "position_cost": 679479.5,
    "constraint": "WEIGHT",
    "atr14": 1.71,
    "low_20d": 53.9,
    "ladder_minus1_pullback": 54.6,
    "ladder_4_base": 52.3,
    "ladder_5_euphoria": 75.5
  },
  {
    "symbol": "4166.TWO",
    "name": "友霖",
    "sector": "生技醫療業",
    "close": 24.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.22,
    "dog_ma200_bias": 0.051,
    "vr60": 1.67,
    "rs20": 0.85,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 605000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.7,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.8,
    "ladder_5_euphoria": 31.5
  },
  {
    "symbol": "6986.TWO",
    "name": "和迅",
    "sector": "生技醫療業",
    "close": 44.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": 0.13,
    "vr60": 1.54,
    "rs20": 1.09,
    "rs60": 0.94,
    "shares": 14285,
    "lots": 14,
    "odd_shares": 285,
    "ntd_at_risk": 39998.0,
    "position_cost": 628540.0,
    "constraint": "WEIGHT",
    "atr14": 1.4,
    "low_20d": 42.1,
    "ladder_minus1_pullback": 41.4,
    "ladder_4_base": 39.6,
    "ladder_5_euphoria": 57.2
  },
  {
    "symbol": "4588.TW",
    "name": "玖鼎電力",
    "sector": "其他電子業",
    "close": 56.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.95,
    "dog_ma200_bias": 0.051,
    "vr60": 1.95,
    "rs20": 0.78,
    "rs60": 0.72,
    "shares": 13422,
    "lots": 13,
    "odd_shares": 422,
    "ntd_at_risk": 39997.56,
    "position_cost": 758343.0,
    "constraint": "WEIGHT",
    "atr14": 1.49,
    "low_20d": 52.3,
    "ladder_minus1_pullback": 53.1,
    "ladder_4_base": 50.9,
    "ladder_5_euphoria": 73.5
  },
  {
    "symbol": "9906.TW",
    "name": "欣巴巴",
    "sector": "建材營造業",
    "close": 39.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.8,
    "dog_ma200_bias": 0.069,
    "vr60": 1.63,
    "rs20": 0.93,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 995000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.5,
    "ladder_minus1_pullback": 37.4,
    "ladder_4_base": 35.8,
    "ladder_5_euphoria": 51.7
  },
  {
    "symbol": "1903.TW",
    "name": "士紙",
    "sector": "造紙工業",
    "close": 48.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.4,
    "dog_ma200_bias": 0.033,
    "vr60": 1.73,
    "rs20": 0.96,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1201250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 45.9,
    "ladder_minus1_pullback": 45.2,
    "ladder_4_base": 43.2,
    "ladder_5_euphoria": 62.5
  },
  {
    "symbol": "9942.TW",
    "name": "茂順",
    "sector": "其他業",
    "close": 114.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.67,
    "dog_ma200_bias": 0.006,
    "vr60": 1.65,
    "rs20": 0.92,
    "rs60": 0.85,
    "shares": 6896,
    "lots": 6,
    "odd_shares": 896,
    "ntd_at_risk": 39996.8,
    "position_cost": 786144.0,
    "constraint": "WEIGHT",
    "atr14": 2.9,
    "low_20d": 103.0,
    "ladder_minus1_pullback": 107.2,
    "ladder_4_base": 102.6,
    "ladder_5_euphoria": 148.2
  },
  {
    "symbol": "7818.TW",
    "name": "溢泰實業",
    "sector": "綠能環保",
    "close": 59.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.8,
    "dog_ma200_bias": 0.073,
    "vr60": 1.64,
    "rs20": 1.14,
    "rs60": 0.99,
    "shares": 11111,
    "lots": 11,
    "odd_shares": 111,
    "ntd_at_risk": 39999.6,
    "position_cost": 664437.8,
    "constraint": "WEIGHT",
    "atr14": 1.8,
    "low_20d": 53.9,
    "ladder_minus1_pullback": 56.2,
    "ladder_4_base": 53.8,
    "ladder_5_euphoria": 77.7
  },
  {
    "symbol": "1410.TW",
    "name": "南染",
    "sector": "紡織纖維業",
    "close": 23.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.05,
    "dog_ma200_bias": -0.006,
    "vr60": 1.31,
    "rs20": 1.03,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 583750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.4,
    "ladder_minus1_pullback": 21.9,
    "ladder_4_base": 21.0,
    "ladder_5_euphoria": 30.4
  },
  {
    "symbol": "2616.TW",
    "name": "山隆",
    "sector": "油電燃氣業",
    "close": 13.15,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.5,
    "dog_ma200_bias": 0.145,
    "vr60": 1.57,
    "rs20": 1.0,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 328750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.2,
    "ladder_minus1_pullback": 12.4,
    "ladder_4_base": 11.8,
    "ladder_5_euphoria": 17.1
  },
  {
    "symbol": "2230.TWO",
    "name": "泰茂",
    "sector": "居家生活",
    "close": 22.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.73,
    "dog_ma200_bias": 0.027,
    "vr60": 1.87,
    "rs20": 1.13,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 552500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.0,
    "ladder_minus1_pullback": 20.8,
    "ladder_4_base": 19.9,
    "ladder_5_euphoria": 28.7
  },
  {
    "symbol": "3306.TWO",
    "name": "鼎天",
    "sector": "通信網路業",
    "close": 45.15,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.05,
    "dog_ma200_bias": -0.109,
    "vr60": 0.92,
    "rs20": 0.36,
    "rs60": 0.22,
    "shares": 7092,
    "lots": 7,
    "odd_shares": 92,
    "ntd_at_risk": 19999.44,
    "position_cost": 320203.8,
    "constraint": "WEIGHT",
    "atr14": 1.41,
    "low_20d": 42.1,
    "ladder_minus1_pullback": 42.4,
    "ladder_4_base": 40.6,
    "ladder_5_euphoria": 58.7
  },
  {
    "symbol": "6461.TWO",
    "name": "益得",
    "sector": "生技醫療業",
    "close": 28.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.87,
    "dog_ma200_bias": -0.016,
    "vr60": 1.34,
    "rs20": 0.9,
    "rs60": 1.05,
    "shares": 21505,
    "lots": 21,
    "odd_shares": 505,
    "ntd_at_risk": 39999.3,
    "position_cost": 602140.0,
    "constraint": "WEIGHT",
    "atr14": 0.93,
    "low_20d": 26.4,
    "ladder_minus1_pullback": 26.3,
    "ladder_4_base": 25.2,
    "ladder_5_euphoria": 36.4
  },
  {
    "symbol": "6498.TWO",
    "name": "久禾光",
    "sector": "光電業",
    "close": 68.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.32,
    "dog_ma200_bias": 0.096,
    "vr60": 1.34,
    "rs20": 1.27,
    "rs60": 0.96,
    "shares": 10526,
    "lots": 10,
    "odd_shares": 526,
    "ntd_at_risk": 39998.8,
    "position_cost": 716820.6,
    "constraint": "WEIGHT",
    "atr14": 1.9,
    "low_20d": 63.1,
    "ladder_minus1_pullback": 64.0,
    "ladder_4_base": 61.3,
    "ladder_5_euphoria": 88.5
  },
  {
    "symbol": "6684.TWO",
    "name": "安格",
    "sector": "半導體業",
    "close": 45.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.2,
    "dog_ma200_bias": 0.039,
    "vr60": 1.24,
    "rs20": 1.11,
    "rs60": 1.01,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 628271.15,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 43.1,
    "ladder_minus1_pullback": 42.8,
    "ladder_4_base": 41.0,
    "ladder_5_euphoria": 59.2
  },
  {
    "symbol": "1526.TW",
    "name": "日馳",
    "sector": "電機機械業",
    "close": 14.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.8,
    "dog_ma200_bias": 0.002,
    "vr60": 1.94,
    "rs20": 0.95,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 373750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.1,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.4
  },
  {
    "symbol": "1473.TW",
    "name": "台南",
    "sector": "紡織纖維業",
    "close": 18.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.17,
    "dog_ma200_bias": 0.102,
    "vr60": 1.57,
    "rs20": 1.12,
    "rs60": 1.13,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 471250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.5,
    "ladder_minus1_pullback": 17.7,
    "ladder_4_base": 17.0,
    "ladder_5_euphoria": 24.5
  },
  {
    "symbol": "2745.TWO",
    "name": "五福",
    "sector": "觀光餐旅",
    "close": 85.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.36,
    "dog_ma200_bias": 0.293,
    "vr60": 2.5,
    "rs20": 1.42,
    "rs60": 1.27,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.58,
    "low_20d": 78.6,
    "ladder_minus1_pullback": 80.4,
    "ladder_4_base": 77.0,
    "ladder_5_euphoria": 111.2
  },
  {
    "symbol": "5245.TWO",
    "name": "智晶",
    "sector": "光電業",
    "close": 19.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.11,
    "dog_ma200_bias": 0.041,
    "vr60": 1.89,
    "rs20": 0.95,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 480000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.9,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.3,
    "ladder_5_euphoria": 25.0
  },
  {
    "symbol": "1906.TW",
    "name": "寶隆",
    "sector": "造紙工業",
    "close": 10.95,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.33,
    "dog_ma200_bias": -0.035,
    "vr60": 1.7,
    "rs20": 0.7,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 10.2,
    "ladder_minus1_pullback": 10.3,
    "ladder_4_base": 9.9,
    "ladder_5_euphoria": 14.2
  },
  {
    "symbol": "3530.TW",
    "name": "晶相光",
    "sector": "半導體業",
    "close": 56.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.22,
    "dog_ma200_bias": -0.107,
    "vr60": 0.74,
    "rs20": 0.38,
    "rs60": 0.49,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.52,
    "low_20d": 53.8,
    "ladder_minus1_pullback": 53.4,
    "ladder_4_base": 51.1,
    "ladder_5_euphoria": 73.8
  },
  {
    "symbol": "4121.TWO",
    "name": "優盛",
    "sector": "生技醫療業",
    "close": 12.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.05,
    "dog_ma200_bias": 0.034,
    "vr60": 2.06,
    "rs20": 1.11,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 322500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.8,
    "ladder_minus1_pullback": 12.1,
    "ladder_4_base": 11.6,
    "ladder_5_euphoria": 16.8
  },
  {
    "symbol": "4549.TWO",
    "name": "桓達",
    "sector": "電機機械業",
    "close": 93.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.31,
    "dog_ma200_bias": 0.045,
    "vr60": 1.98,
    "rs20": 1.03,
    "rs60": 0.9,
    "shares": 9615,
    "lots": 9,
    "odd_shares": 615,
    "ntd_at_risk": 39998.4,
    "position_cost": 894195.0,
    "constraint": "WEIGHT",
    "atr14": 2.08,
    "low_20d": 84.3,
    "ladder_minus1_pullback": 87.4,
    "ladder_4_base": 83.7,
    "ladder_5_euphoria": 120.9
  },
  {
    "symbol": "5398.TWO",
    "name": "慕康生醫",
    "sector": "其他業",
    "close": 15.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.07,
    "dog_ma200_bias": 0.156,
    "vr60": 1.47,
    "rs20": 1.17,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 381250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.1,
    "ladder_minus1_pullback": 14.3,
    "ladder_4_base": 13.7,
    "ladder_5_euphoria": 19.8
  },
  {
    "symbol": "3527.TWO",
    "name": "聚積",
    "sector": "半導體業",
    "close": 48.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.27,
    "dog_ma200_bias": 0.036,
    "vr60": 1.37,
    "rs20": 1.0,
    "rs60": 0.9,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 668960.5,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 45.7,
    "ladder_minus1_pullback": 45.6,
    "ladder_4_base": 43.6,
    "ladder_5_euphoria": 63.1
  },
  {
    "symbol": "6130.TWO",
    "name": "上亞科技",
    "sector": "生技醫療業",
    "close": 22.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": -0.015,
    "vr60": 1.71,
    "rs20": 0.83,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 553750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.1,
    "ladder_minus1_pullback": 20.8,
    "ladder_4_base": 19.9,
    "ladder_5_euphoria": 28.8
  },
  {
    "symbol": "6785.TWO",
    "name": "昱展新藥",
    "sector": "生技醫療業",
    "close": 83.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.5,
    "dog_ma200_bias": 0.07,
    "vr60": 1.31,
    "rs20": 1.12,
    "rs60": 0.76,
    "shares": 8849,
    "lots": 8,
    "odd_shares": 849,
    "ntd_at_risk": 39997.48,
    "position_cost": 735351.9,
    "constraint": "WEIGHT",
    "atr14": 2.26,
    "low_20d": 78.1,
    "ladder_minus1_pullback": 78.1,
    "ladder_4_base": 74.8,
    "ladder_5_euphoria": 108.0
  },
  {
    "symbol": "6776.TW",
    "name": "展碁國際",
    "sector": "電子通路業",
    "close": 52.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.14,
    "dog_ma200_bias": -0.018,
    "vr60": 1.91,
    "rs20": 0.85,
    "rs60": 0.95,
    "shares": 18867,
    "lots": 18,
    "odd_shares": 867,
    "ntd_at_risk": 39998.04,
    "position_cost": 986744.1,
    "constraint": "WEIGHT",
    "atr14": 1.06,
    "low_20d": 49.8,
    "ladder_minus1_pullback": 49.2,
    "ladder_4_base": 47.1,
    "ladder_5_euphoria": 68.0
  },
  {
    "symbol": "6965.TW",
    "name": "中傑-KY",
    "sector": "運動休閒",
    "close": 66.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.95,
    "dog_ma200_bias": 0.069,
    "vr60": 1.6,
    "rs20": 1.07,
    "rs60": 0.91,
    "shares": 19230,
    "lots": 19,
    "odd_shares": 230,
    "ntd_at_risk": 39998.4,
    "position_cost": 1282641.0,
    "constraint": "WEIGHT",
    "atr14": 1.04,
    "low_20d": 61.6,
    "ladder_minus1_pullback": 62.7,
    "ladder_4_base": 60.0,
    "ladder_5_euphoria": 86.7
  },
  {
    "symbol": "6967.TWO",
    "name": "汎瑋材料",
    "sector": "電子零組件業",
    "close": 70.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.44,
    "dog_ma200_bias": -0.04,
    "vr60": 1.34,
    "rs20": 0.7,
    "rs60": 0.46,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.77,
    "low_20d": 65.5,
    "ladder_minus1_pullback": 65.8,
    "ladder_4_base": 63.0,
    "ladder_5_euphoria": 91.0
  },
  {
    "symbol": "4580.TWO",
    "name": "捷流閥業",
    "sector": "電機機械業",
    "close": 81.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.21,
    "dog_ma200_bias": 0.11,
    "vr60": 1.57,
    "rs20": 1.08,
    "rs60": 1.0,
    "shares": 15503,
    "lots": 15,
    "odd_shares": 503,
    "ntd_at_risk": 39997.74,
    "position_cost": 1265044.8,
    "constraint": "WEIGHT",
    "atr14": 1.29,
    "low_20d": 74.4,
    "ladder_minus1_pullback": 76.7,
    "ladder_4_base": 73.4,
    "ladder_5_euphoria": 106.1
  },
  {
    "symbol": "4702.TWO",
    "name": "中美實",
    "sector": "居家生活",
    "close": 9.34,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.46,
    "dog_ma200_bias": -0.009,
    "vr60": 1.29,
    "rs20": 0.82,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 233500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.9,
    "ladder_minus1_pullback": 8.8,
    "ladder_4_base": 8.4,
    "ladder_5_euphoria": 12.1
  },
  {
    "symbol": "6441.TWO",
    "name": "廣錠",
    "sector": "電腦及週邊設備業",
    "close": 21.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.6,
    "dog_ma200_bias": 0.006,
    "vr60": 1.28,
    "rs20": 0.87,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 532500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.4,
    "ladder_minus1_pullback": 20.0,
    "ladder_4_base": 19.2,
    "ladder_5_euphoria": 27.7
  },
  {
    "symbol": "8048.TWO",
    "name": "德勝",
    "sector": "通信網路業",
    "close": 51.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.95,
    "dog_ma200_bias": 0.08,
    "vr60": 1.42,
    "rs20": 1.08,
    "rs60": 0.91,
    "shares": 11764,
    "lots": 11,
    "odd_shares": 764,
    "ntd_at_risk": 39997.6,
    "position_cost": 610551.6,
    "constraint": "WEIGHT",
    "atr14": 1.7,
    "low_20d": 47.3,
    "ladder_minus1_pullback": 48.8,
    "ladder_4_base": 46.7,
    "ladder_5_euphoria": 67.5
  },
  {
    "symbol": "2438.TW",
    "name": "翔耀",
    "sector": "光電業",
    "close": 19.15,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.64,
    "dog_ma200_bias": -0.269,
    "vr60": 0.83,
    "rs20": 0.33,
    "rs60": 0.33,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 239375.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.7,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.2,
    "ladder_5_euphoria": 24.9
  },
  {
    "symbol": "1323.TW",
    "name": "永裕",
    "sector": "塑膠工業",
    "close": 21.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.25,
    "dog_ma200_bias": 0.018,
    "vr60": 1.94,
    "rs20": 0.8,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 545000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.6,
    "ladder_minus1_pullback": 20.5,
    "ladder_4_base": 19.6,
    "ladder_5_euphoria": 28.3
  },
  {
    "symbol": "5603.TWO",
    "name": "陸海",
    "sector": "航運業",
    "close": 14.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.83,
    "dog_ma200_bias": 0.055,
    "vr60": 1.73,
    "rs20": 0.95,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 355000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.4,
    "ladder_minus1_pullback": 13.3,
    "ladder_4_base": 12.8,
    "ladder_5_euphoria": 18.5
  },
  {
    "symbol": "6732.TWO",
    "name": "昇佳電子",
    "sector": "半導體業",
    "close": 151.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.5,
    "dog_ma200_bias": 0.019,
    "vr60": 1.3,
    "rs20": 0.77,
    "rs60": 0.86,
    "shares": 6116,
    "lots": 6,
    "odd_shares": 116,
    "ntd_at_risk": 39998.64,
    "position_cost": 923516.0,
    "constraint": "WEIGHT",
    "atr14": 3.27,
    "low_20d": 140.4,
    "ladder_minus1_pullback": 141.9,
    "ladder_4_base": 135.9,
    "ladder_5_euphoria": 196.3
  },
  {
    "symbol": "8097.TWO",
    "name": "常珵",
    "sector": "通信網路業",
    "close": 48.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.77,
    "dog_ma200_bias": 0.021,
    "vr60": 1.64,
    "rs20": 0.91,
    "rs60": 0.78,
    "shares": 14084,
    "lots": 14,
    "odd_shares": 84,
    "ntd_at_risk": 39998.56,
    "position_cost": 678144.6,
    "constraint": "WEIGHT",
    "atr14": 1.42,
    "low_20d": 44.9,
    "ladder_minus1_pullback": 45.3,
    "ladder_4_base": 43.3,
    "ladder_5_euphoria": 62.6
  },
  {
    "symbol": "1419.TW",
    "name": "新紡",
    "sector": "紡織纖維業",
    "close": 65.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.05,
    "dog_ma200_bias": 0.069,
    "vr60": 1.44,
    "rs20": 1.14,
    "rs60": 0.94,
    "shares": 10204,
    "lots": 10,
    "odd_shares": 204,
    "ntd_at_risk": 39999.68,
    "position_cost": 666321.2,
    "constraint": "WEIGHT",
    "atr14": 1.96,
    "low_20d": 59.1,
    "ladder_minus1_pullback": 61.4,
    "ladder_4_base": 58.8,
    "ladder_5_euphoria": 84.9
  },
  {
    "symbol": "6128.TW",
    "name": "上福",
    "sector": "電腦及週邊設備業",
    "close": 19.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.05,
    "dog_ma200_bias": 0.005,
    "vr60": 1.7,
    "rs20": 1.06,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 477500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.4,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.2,
    "ladder_5_euphoria": 24.8
  },
  {
    "symbol": "2012.TW",
    "name": "春雨",
    "sector": "鋼鐵工業",
    "close": 14.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.05,
    "dog_ma200_bias": 0.021,
    "vr60": 1.28,
    "rs20": 1.0,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 353750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.5,
    "ladder_minus1_pullback": 13.3,
    "ladder_4_base": 12.7,
    "ladder_5_euphoria": 18.4
  },
  {
    "symbol": "3288.TWO",
    "name": "點晶",
    "sector": "電子零組件業",
    "close": 21.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.4,
    "dog_ma200_bias": 0.176,
    "vr60": 1.27,
    "rs20": 1.34,
    "rs60": 1.21,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 542500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.8,
    "ladder_minus1_pullback": 20.4,
    "ladder_4_base": 19.5,
    "ladder_5_euphoria": 28.2
  },
  {
    "symbol": "4160.TWO",
    "name": "訊聯基因",
    "sector": "生技醫療業",
    "close": 38.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.4,
    "dog_ma200_bias": 0.034,
    "vr60": 1.58,
    "rs20": 1.11,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 957500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.1,
    "ladder_minus1_pullback": 36.0,
    "ladder_4_base": 34.5,
    "ladder_5_euphoria": 49.8
  },
  {
    "symbol": "6194.TWO",
    "name": "育富",
    "sector": "電子零組件業",
    "close": 32.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.05,
    "dog_ma200_bias": -0.02,
    "vr60": 1.62,
    "rs20": 1.08,
    "rs60": 0.8,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 812500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.8,
    "ladder_minus1_pullback": 30.5,
    "ladder_4_base": 29.2,
    "ladder_5_euphoria": 42.2
  },
  {
    "symbol": "1256.TW",
    "name": "鮮活果汁-KY",
    "sector": "食品工業",
    "close": 167.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.82,
    "dog_ma200_bias": 0.077,
    "vr60": 1.2,
    "rs20": 1.12,
    "rs60": 0.87,
    "shares": 7042,
    "lots": 7,
    "odd_shares": 42,
    "ntd_at_risk": 39998.56,
    "position_cost": 1179535.0,
    "constraint": "WEIGHT",
    "atr14": 2.84,
    "low_20d": 157.1,
    "ladder_minus1_pullback": 157.4,
    "ladder_4_base": 150.8,
    "ladder_5_euphoria": 217.8
  },
  {
    "symbol": "2726.TWO",
    "name": "雅茗-KY",
    "sector": "觀光餐旅",
    "close": 7.92,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.81,
    "dog_ma200_bias": 0.04,
    "vr60": 1.96,
    "rs20": 0.9,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 198000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 7.3,
    "ladder_minus1_pullback": 7.4,
    "ladder_4_base": 7.1,
    "ladder_5_euphoria": 10.3
  },
  {
    "symbol": "4506.TWO",
    "name": "崇友",
    "sector": "電機機械業",
    "close": 117.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.5,
    "dog_ma200_bias": 0.043,
    "vr60": 1.73,
    "rs20": 0.95,
    "rs60": 0.72,
    "shares": 8298,
    "lots": 8,
    "odd_shares": 298,
    "ntd_at_risk": 39996.36,
    "position_cost": 970866.0,
    "constraint": "WEIGHT",
    "atr14": 2.41,
    "low_20d": 107.7,
    "ladder_minus1_pullback": 110.0,
    "ladder_4_base": 105.3,
    "ladder_5_euphoria": 152.1
  },
  {
    "symbol": "5016.TWO",
    "name": "松和",
    "sector": "鋼鐵工業",
    "close": 25.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.05,
    "dog_ma200_bias": 0.054,
    "vr60": 1.71,
    "rs20": 0.87,
    "rs60": 0.84,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 635000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.2,
    "ladder_minus1_pullback": 23.9,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.0
  },
  {
    "symbol": "7703.TWO",
    "name": "銳澤",
    "sector": "其他電子業",
    "close": 185.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.4,
    "dog_ma200_bias": -0.258,
    "vr60": 0.71,
    "rs20": 0.42,
    "rs60": 0.28,
    "shares": 2237,
    "lots": 2,
    "odd_shares": 237,
    "ntd_at_risk": 19998.78,
    "position_cost": 413845.0,
    "constraint": "WEIGHT",
    "atr14": 4.47,
    "low_20d": 167.3,
    "ladder_minus1_pullback": 173.9,
    "ladder_4_base": 166.5,
    "ladder_5_euphoria": 240.5
  },
  {
    "symbol": "4999.TW",
    "name": "鑫禾",
    "sector": "電子零組件業",
    "close": 17.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.6,
    "dog_ma200_bias": 0.041,
    "vr60": 2.06,
    "rs20": 0.88,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 440000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.8,
    "ladder_minus1_pullback": 16.5,
    "ladder_4_base": 15.8,
    "ladder_5_euphoria": 22.9
  },
  {
    "symbol": "1468.TW",
    "name": "昶和",
    "sector": "紡織纖維業",
    "close": 13.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.95,
    "dog_ma200_bias": 0.014,
    "vr60": 1.44,
    "rs20": 1.05,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 330000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.0,
    "ladder_minus1_pullback": 12.4,
    "ladder_4_base": 11.9,
    "ladder_5_euphoria": 17.2
  },
  {
    "symbol": "4582.TW",
    "name": "聚恆-創",
    "sector": "綠能環保",
    "close": 20.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.05,
    "dog_ma200_bias": 0.005,
    "vr60": 2.08,
    "rs20": 0.89,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 503750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.1,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.2
  },
  {
    "symbol": "3054.TW",
    "name": "立萬利",
    "sector": "電子通路業",
    "close": 56.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.56,
    "dog_ma200_bias": 0.04,
    "vr60": 1.21,
    "rs20": 1.03,
    "rs60": 0.93,
    "shares": 12121,
    "lots": 12,
    "odd_shares": 121,
    "ntd_at_risk": 39999.3,
    "position_cost": 679988.1,
    "constraint": "WEIGHT",
    "atr14": 1.65,
    "low_20d": 52.3,
    "ladder_minus1_pullback": 52.7,
    "ladder_4_base": 50.5,
    "ladder_5_euphoria": 72.9
  },
  {
    "symbol": "1530.TW",
    "name": "亞崴",
    "sector": "電機機械業",
    "close": 27.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.05,
    "dog_ma200_bias": -0.02,
    "vr60": 1.63,
    "rs20": 1.11,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 680000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.7,
    "ladder_minus1_pullback": 25.6,
    "ladder_4_base": 24.5,
    "ladder_5_euphoria": 35.4
  },
  {
    "symbol": "2459.TW",
    "name": "敦吉",
    "sector": "其他電子業",
    "close": 65.2,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.5,
    "dog_ma200_bias": -0.206,
    "vr60": 1.05,
    "rs20": 0.48,
    "rs60": 0.46,
    "shares": 5847,
    "lots": 5,
    "odd_shares": 847,
    "ntd_at_risk": 19996.74,
    "position_cost": 381224.4,
    "constraint": "WEIGHT",
    "atr14": 1.71,
    "low_20d": 62.3,
    "ladder_minus1_pullback": 61.3,
    "ladder_4_base": 58.7,
    "ladder_5_euphoria": 84.8
  },
  {
    "symbol": "9912.TW",
    "name": "偉聯",
    "sector": "電腦及週邊設備業",
    "close": 12.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.67,
    "dog_ma200_bias": -0.138,
    "vr60": 0.94,
    "rs20": 0.23,
    "rs60": 0.19,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 161250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.1,
    "ladder_minus1_pullback": 12.1,
    "ladder_4_base": 11.6,
    "ladder_5_euphoria": 16.8
  },
  {
    "symbol": "4529.TWO",
    "name": "淳紳",
    "sector": "其他業",
    "close": 3.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.95,
    "dog_ma200_bias": 0.047,
    "vr60": 1.81,
    "rs20": 0.89,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 83750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 3.1,
    "ladder_minus1_pullback": 3.1,
    "ladder_4_base": 3.0,
    "ladder_5_euphoria": 4.4
  },
  {
    "symbol": "6423.TWO",
    "name": "億而得",
    "sector": "半導體業",
    "close": 83.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.74,
    "dog_ma200_bias": 0.345,
    "vr60": 1.96,
    "rs20": 1.21,
    "rs60": 1.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.54,
    "low_20d": 80.1,
    "ladder_minus1_pullback": 78.5,
    "ladder_4_base": 75.2,
    "ladder_5_euphoria": 108.5
  },
  {
    "symbol": "5525.TW",
    "name": "順天",
    "sector": "建材營造業",
    "close": 21.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.5,
    "dog_ma200_bias": -0.019,
    "vr60": 1.62,
    "rs20": 1.12,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 546250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.7,
    "ladder_minus1_pullback": 20.5,
    "ladder_4_base": 19.7,
    "ladder_5_euphoria": 28.4
  },
  {
    "symbol": "7835.TW",
    "name": "永悅健康-創",
    "sector": "數位雲端",
    "close": 21.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.95,
    "dog_ma200_bias": 0.002,
    "vr60": 1.22,
    "rs20": 0.86,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 537500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.7,
    "ladder_minus1_pullback": 20.2,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 27.9
  },
  {
    "symbol": "2013.TW",
    "name": "中鋼構",
    "sector": "鋼鐵工業",
    "close": 41.45,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.56,
    "dog_ma200_bias": -0.216,
    "vr60": 0.69,
    "rs20": 0.45,
    "rs60": 0.29,
    "shares": 11904,
    "lots": 11,
    "odd_shares": 904,
    "ntd_at_risk": 19998.72,
    "position_cost": 493420.8,
    "constraint": "WEIGHT",
    "atr14": 0.84,
    "low_20d": 38.1,
    "ladder_minus1_pullback": 39.0,
    "ladder_4_base": 37.3,
    "ladder_5_euphoria": 53.9
  },
  {
    "symbol": "3687.TWO",
    "name": "歐買尬",
    "sector": "數位雲端",
    "close": 60.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.17,
    "dog_ma200_bias": 0.003,
    "vr60": 1.64,
    "rs20": 0.9,
    "rs60": 0.8,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 1061940.0,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 55.1,
    "ladder_minus1_pullback": 56.4,
    "ladder_4_base": 54.0,
    "ladder_5_euphoria": 78.0
  },
  {
    "symbol": "8277.TWO",
    "name": "商丞",
    "sector": "半導體業",
    "close": 15.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.83,
    "dog_ma200_bias": 0.07,
    "vr60": 1.84,
    "rs20": 0.83,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 385000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.7,
    "ladder_minus1_pullback": 14.5,
    "ladder_4_base": 13.9,
    "ladder_5_euphoria": 20.0
  },
  {
    "symbol": "8937.TWO",
    "name": "合騏*",
    "sector": "其他業",
    "close": 24.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.34,
    "dog_ma200_bias": 0.062,
    "vr60": 1.56,
    "rs20": 1.1,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 615000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.8,
    "ladder_minus1_pullback": 23.1,
    "ladder_4_base": 22.1,
    "ladder_5_euphoria": 32.0
  },
  {
    "symbol": "3296.TW",
    "name": "勝德",
    "sector": "電子零組件業",
    "close": 27.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.44,
    "dog_ma200_bias": 0.029,
    "vr60": 1.7,
    "rs20": 1.01,
    "rs60": 0.9,
    "shares": 23529,
    "lots": 23,
    "odd_shares": 529,
    "ntd_at_risk": 39999.3,
    "position_cost": 649400.4,
    "constraint": "WEIGHT",
    "atr14": 0.85,
    "low_20d": 25.3,
    "ladder_minus1_pullback": 25.9,
    "ladder_4_base": 24.8,
    "ladder_5_euphoria": 35.9
  },
  {
    "symbol": "2227.TW",
    "name": "裕日車",
    "sector": "汽車工業",
    "close": 44.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.1,
    "dog_ma200_bias": 0.048,
    "vr60": 1.71,
    "rs20": 0.78,
    "rs60": 0.74,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 964124.65,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 42.3,
    "ladder_minus1_pullback": 41.7,
    "ladder_4_base": 39.9,
    "ladder_5_euphoria": 57.7
  },
  {
    "symbol": "2248.TW",
    "name": "華勝-KY",
    "sector": "汽車工業",
    "close": 59.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.31,
    "dog_ma200_bias": 0.068,
    "vr60": 1.21,
    "rs20": 1.18,
    "rs60": 0.99,
    "shares": 10810,
    "lots": 10,
    "odd_shares": 810,
    "ntd_at_risk": 39997.0,
    "position_cost": 637790.0,
    "constraint": "WEIGHT",
    "atr14": 1.85,
    "low_20d": 54.7,
    "ladder_minus1_pullback": 55.5,
    "ladder_4_base": 53.1,
    "ladder_5_euphoria": 76.7
  },
  {
    "symbol": "4706.TWO",
    "name": "大恭",
    "sector": "化學工業",
    "close": 39.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.3,
    "dog_ma200_bias": 0.032,
    "vr60": 1.9,
    "rs20": 0.83,
    "rs60": 0.94,
    "shares": 15384,
    "lots": 15,
    "odd_shares": 384,
    "ntd_at_risk": 39998.4,
    "position_cost": 603822.0,
    "constraint": "WEIGHT",
    "atr14": 1.3,
    "low_20d": 36.0,
    "ladder_minus1_pullback": 36.9,
    "ladder_4_base": 35.3,
    "ladder_5_euphoria": 51.0
  },
  {
    "symbol": "3130.TW",
    "name": "一零四",
    "sector": "數位雲端",
    "close": 208.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.67,
    "dog_ma200_bias": 0.179,
    "vr60": 1.47,
    "rs20": 1.16,
    "rs60": 1.0,
    "shares": 4494,
    "lots": 4,
    "odd_shares": 494,
    "ntd_at_risk": 39996.6,
    "position_cost": 934752.0,
    "constraint": "WEIGHT",
    "atr14": 4.45,
    "low_20d": 191.7,
    "ladder_minus1_pullback": 195.5,
    "ladder_4_base": 187.2,
    "ladder_5_euphoria": 270.4
  },
  {
    "symbol": "2911.TW",
    "name": "麗嬰房",
    "sector": "貿易百貨業",
    "close": 5.93,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.95,
    "dog_ma200_bias": 0.292,
    "vr60": 2.05,
    "rs20": 1.48,
    "rs60": 1.32,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 5.6,
    "ladder_minus1_pullback": 5.6,
    "ladder_4_base": 5.3,
    "ladder_5_euphoria": 7.7
  },
  {
    "symbol": "6283.TW",
    "name": "淳安",
    "sector": "其他電子業",
    "close": 18.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.83,
    "dog_ma200_bias": -0.015,
    "vr60": 2.04,
    "rs20": 0.92,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 466250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.7,
    "ladder_minus1_pullback": 17.5,
    "ladder_4_base": 16.8,
    "ladder_5_euphoria": 24.2
  },
  {
    "symbol": "7722.TW",
    "name": "LINEPAY",
    "sector": "數位雲端",
    "close": 258.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.05,
    "dog_ma200_bias": 0.007,
    "vr60": 1.81,
    "rs20": 0.94,
    "rs60": 0.83,
    "shares": 2364,
    "lots": 2,
    "odd_shares": 364,
    "ntd_at_risk": 39998.88,
    "position_cost": 609912.0,
    "constraint": "WEIGHT",
    "atr14": 8.46,
    "low_20d": 237.2,
    "ladder_minus1_pullback": 242.5,
    "ladder_4_base": 232.2,
    "ladder_5_euphoria": 335.4
  },
  {
    "symbol": "2947.TWO",
    "name": "振宇五金",
    "sector": "居家生活",
    "close": 59.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.88,
    "dog_ma200_bias": 0.056,
    "vr60": 2.0,
    "rs20": 0.84,
    "rs60": 0.8,
    "shares": 9852,
    "lots": 9,
    "odd_shares": 852,
    "ntd_at_risk": 39999.12,
    "position_cost": 584223.6,
    "constraint": "WEIGHT",
    "atr14": 2.03,
    "low_20d": 56.6,
    "ladder_minus1_pullback": 55.7,
    "ladder_4_base": 53.4,
    "ladder_5_euphoria": 77.1
  },
  {
    "symbol": "3489.TWO",
    "name": "森寶",
    "sector": "建材營造業",
    "close": 22.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.95,
    "dog_ma200_bias": 0.022,
    "vr60": 1.6,
    "rs20": 0.75,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 570000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.6,
    "ladder_minus1_pullback": 21.4,
    "ladder_4_base": 20.5,
    "ladder_5_euphoria": 29.6
  },
  {
    "symbol": "6578.TWO",
    "name": "達邦蛋白",
    "sector": "農業科技業",
    "close": 16.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.64,
    "cpr": 0.5,
    "dog_ma200_bias": -0.265,
    "vr60": 0.91,
    "rs20": 0.21,
    "rs60": 0.45,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 206250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.3,
    "ladder_minus1_pullback": 15.5,
    "ladder_4_base": 14.8,
    "ladder_5_euphoria": 21.4
  },
  {
    "symbol": "2739.TW",
    "name": "寒舍",
    "sector": "觀光餐旅",
    "close": 36.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.4,
    "dog_ma200_bias": 0.022,
    "vr60": 1.27,
    "rs20": 0.85,
    "rs60": 0.76,
    "shares": 16806,
    "lots": 16,
    "odd_shares": 806,
    "ntd_at_risk": 39998.28,
    "position_cost": 607536.9,
    "constraint": "WEIGHT",
    "atr14": 1.19,
    "low_20d": 34.0,
    "ladder_minus1_pullback": 34.0,
    "ladder_4_base": 32.5,
    "ladder_5_euphoria": 47.0
  },
  {
    "symbol": "1805.TW",
    "name": "寶徠",
    "sector": "建材營造業",
    "close": 9.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.05,
    "dog_ma200_bias": 0.011,
    "vr60": 1.76,
    "rs20": 0.79,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 248750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.5,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 12.9
  },
  {
    "symbol": "7823.TW",
    "name": "奧義賽博-KY創",
    "sector": "數位雲端",
    "close": 75.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.05,
    "dog_ma200_bias": 0.157,
    "vr60": 1.41,
    "rs20": 1.2,
    "rs60": 1.03,
    "shares": 9661,
    "lots": 9,
    "odd_shares": 661,
    "ntd_at_risk": 39996.54,
    "position_cost": 724575.0,
    "constraint": "WEIGHT",
    "atr14": 2.07,
    "low_20d": 68.6,
    "ladder_minus1_pullback": 70.5,
    "ladder_4_base": 67.5,
    "ladder_5_euphoria": 97.5
  },
  {
    "symbol": "6516.TWO",
    "name": "勤崴國際",
    "sector": "資訊服務業",
    "close": 55.4,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.5,
    "dog_ma200_bias": -0.055,
    "vr60": 1.4,
    "rs20": 0.48,
    "rs60": 0.57,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.47,
    "low_20d": 49.9,
    "ladder_minus1_pullback": 52.1,
    "ladder_4_base": 49.9,
    "ladder_5_euphoria": 72.0
  },
  {
    "symbol": "1465.TW",
    "name": "偉全",
    "sector": "紡織纖維業",
    "close": 11.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.75,
    "dog_ma200_bias": 0.013,
    "vr60": 1.91,
    "rs20": 1.13,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 296250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.1,
    "ladder_minus1_pullback": 11.1,
    "ladder_4_base": 10.7,
    "ladder_5_euphoria": 15.4
  },
  {
    "symbol": "2423.TW",
    "name": "固緯",
    "sector": "其他電子業",
    "close": 71.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.42,
    "dog_ma200_bias": 0.042,
    "vr60": 1.89,
    "rs20": 1.0,
    "rs60": 0.9,
    "shares": 8620,
    "lots": 8,
    "odd_shares": 620,
    "ntd_at_risk": 39996.8,
    "position_cost": 613744.0,
    "constraint": "WEIGHT",
    "atr14": 2.32,
    "low_20d": 64.1,
    "ladder_minus1_pullback": 66.9,
    "ladder_4_base": 64.1,
    "ladder_5_euphoria": 92.6
  },
  {
    "symbol": "1777.TWO",
    "name": "生泰",
    "sector": "生技醫療業",
    "close": 76.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.71,
    "dog_ma200_bias": 0.07,
    "vr60": 1.09,
    "rs20": 0.96,
    "rs60": 1.03,
    "shares": 10362,
    "lots": 10,
    "odd_shares": 362,
    "ntd_at_risk": 39997.32,
    "position_cost": 788548.2,
    "constraint": "WEIGHT",
    "atr14": 1.93,
    "low_20d": 70.4,
    "ladder_minus1_pullback": 71.5,
    "ladder_4_base": 68.5,
    "ladder_5_euphoria": 98.9
  },
  {
    "symbol": "1535.TW",
    "name": "中宇",
    "sector": "電機機械業",
    "close": 45.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.36,
    "dog_ma200_bias": 0.065,
    "vr60": 1.26,
    "rs20": 0.8,
    "rs60": 1.02,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 765802.7,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 41.5,
    "ladder_minus1_pullback": 43.2,
    "ladder_4_base": 41.4,
    "ladder_5_euphoria": 59.7
  },
  {
    "symbol": "4111.TWO",
    "name": "濟生",
    "sector": "生技醫療業",
    "close": 28.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.05,
    "dog_ma200_bias": 0.024,
    "vr60": 1.47,
    "rs20": 1.0,
    "rs60": 0.72,
    "shares": 24390,
    "lots": 24,
    "odd_shares": 390,
    "ntd_at_risk": 39999.6,
    "position_cost": 698773.5,
    "constraint": "WEIGHT",
    "atr14": 0.82,
    "low_20d": 26.1,
    "ladder_minus1_pullback": 26.9,
    "ladder_4_base": 25.8,
    "ladder_5_euphoria": 37.2
  },
  {
    "symbol": "5220.TWO",
    "name": "萬達光電",
    "sector": "光電業",
    "close": 21.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.7,
    "rs20": 0.87,
    "rs60": 0.83,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 542500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.7,
    "ladder_minus1_pullback": 20.4,
    "ladder_4_base": 19.5,
    "ladder_5_euphoria": 28.2
  },
  {
    "symbol": "5356.TWO",
    "name": "協益",
    "sector": "電腦及週邊設備業",
    "close": 25.55,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.05,
    "dog_ma200_bias": -0.187,
    "vr60": 0.86,
    "rs20": 0.38,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.86,
    "low_20d": 23.7,
    "ladder_minus1_pullback": 24.0,
    "ladder_4_base": 23.0,
    "ladder_5_euphoria": 33.2
  },
  {
    "symbol": "7744.TWO",
    "name": "崴寶",
    "sector": "電子零組件業",
    "close": 481.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.21,
    "dog_ma200_bias": -0.161,
    "vr60": 0.65,
    "rs20": 0.35,
    "rs60": 0.47,
    "shares": 1071,
    "lots": 1,
    "odd_shares": 71,
    "ntd_at_risk": 19984.86,
    "position_cost": 515686.5,
    "constraint": "WEIGHT",
    "atr14": 9.33,
    "low_20d": 452.1,
    "ladder_minus1_pullback": 452.6,
    "ladder_4_base": 433.4,
    "ladder_5_euphoria": 626.0
  },
  {
    "symbol": "8093.TWO",
    "name": "保銳",
    "sector": "電子零組件業",
    "close": 27.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.69,
    "dog_ma200_bias": 0.042,
    "vr60": 1.51,
    "rs20": 1.13,
    "rs60": 0.97,
    "shares": 24390,
    "lots": 24,
    "odd_shares": 390,
    "ntd_at_risk": 39999.6,
    "position_cost": 669505.5,
    "constraint": "WEIGHT",
    "atr14": 0.82,
    "low_20d": 26.2,
    "ladder_minus1_pullback": 25.8,
    "ladder_4_base": 24.7,
    "ladder_5_euphoria": 35.7
  },
  {
    "symbol": "4737.TW",
    "name": "華廣",
    "sector": "生技醫療業",
    "close": 55.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.83,
    "dog_ma200_bias": 0.114,
    "vr60": 1.25,
    "rs20": 1.03,
    "rs60": 0.94,
    "shares": 15037,
    "lots": 15,
    "odd_shares": 37,
    "ntd_at_risk": 39998.42,
    "position_cost": 833049.8,
    "constraint": "WEIGHT",
    "atr14": 1.33,
    "low_20d": 50.4,
    "ladder_minus1_pullback": 52.1,
    "ladder_4_base": 49.9,
    "ladder_5_euphoria": 72.0
  },
  {
    "symbol": "1730.TW",
    "name": "花仙子",
    "sector": "化學工業",
    "close": 51.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": -0.173,
    "vr60": 0.68,
    "rs20": 0.52,
    "rs60": 0.25,
    "shares": 10416,
    "lots": 10,
    "odd_shares": 416,
    "ntd_at_risk": 19998.72,
    "position_cost": 531216.0,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 49.0,
    "ladder_minus1_pullback": 47.9,
    "ladder_4_base": 45.9,
    "ladder_5_euphoria": 66.3
  },
  {
    "symbol": "5902.TWO",
    "name": "德記",
    "sector": "居家生活",
    "close": 34.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.95,
    "dog_ma200_bias": 0.044,
    "vr60": 1.43,
    "rs20": 0.92,
    "rs60": 0.95,
    "shares": 23255,
    "lots": 23,
    "odd_shares": 255,
    "ntd_at_risk": 39998.6,
    "position_cost": 794158.25,
    "constraint": "WEIGHT",
    "atr14": 0.86,
    "low_20d": 32.6,
    "ladder_minus1_pullback": 32.1,
    "ladder_4_base": 30.7,
    "ladder_5_euphoria": 44.4
  },
  {
    "symbol": "7704.TWO",
    "name": "明遠精密",
    "sector": "半導體業",
    "close": 60.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.2,
    "dog_ma200_bias": 0.024,
    "vr60": 1.42,
    "rs20": 1.07,
    "rs60": 0.72,
    "shares": 20202,
    "lots": 20,
    "odd_shares": 202,
    "ntd_at_risk": 39999.96,
    "position_cost": 1218180.6,
    "constraint": "WEIGHT",
    "atr14": 0.99,
    "low_20d": 54.5,
    "ladder_minus1_pullback": 56.7,
    "ladder_4_base": 54.3,
    "ladder_5_euphoria": 78.4
  },
  {
    "symbol": "8080.TWO",
    "name": "泰霖",
    "sector": "建材營造業",
    "close": 27.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.38,
    "dog_ma200_bias": 0.011,
    "vr60": 1.59,
    "rs20": 1.13,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 687500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.0,
    "ladder_minus1_pullback": 25.8,
    "ladder_4_base": 24.8,
    "ladder_5_euphoria": 35.8
  },
  {
    "symbol": "4572.TW",
    "name": "駐龍",
    "sector": "電機機械業",
    "close": 133.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.2,
    "dog_ma200_bias": 0.011,
    "vr60": 2.0,
    "rs20": 1.06,
    "rs60": 0.75,
    "shares": 8888,
    "lots": 8,
    "odd_shares": 888,
    "ntd_at_risk": 39996.0,
    "position_cost": 1182104.0,
    "constraint": "WEIGHT",
    "atr14": 2.25,
    "low_20d": 121.2,
    "ladder_minus1_pullback": 125.0,
    "ladder_4_base": 119.7,
    "ladder_5_euphoria": 172.9
  },
  {
    "symbol": "4406.TWO",
    "name": "新昕纖",
    "sector": "紡織纖維業",
    "close": 10.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.05,
    "dog_ma200_bias": 0.011,
    "vr60": 1.51,
    "rs20": 0.9,
    "rs60": 0.7,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 257500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.8,
    "ladder_minus1_pullback": 9.7,
    "ladder_4_base": 9.3,
    "ladder_5_euphoria": 13.4
  },
  {
    "symbol": "4417.TWO",
    "name": "金洲",
    "sector": "紡織纖維業",
    "close": 47.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.05,
    "dog_ma200_bias": 0.039,
    "vr60": 1.81,
    "rs20": 0.77,
    "rs60": 0.88,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 653788.2,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 45.3,
    "ladder_minus1_pullback": 44.6,
    "ladder_4_base": 42.7,
    "ladder_5_euphoria": 61.6
  },
  {
    "symbol": "6703.TWO",
    "name": "軒郁",
    "sector": "生技醫療業",
    "close": 99.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.11,
    "dog_ma200_bias": 0.16,
    "vr60": 1.57,
    "rs20": 1.12,
    "rs60": 0.98,
    "shares": 5934,
    "lots": 5,
    "odd_shares": 934,
    "ntd_at_risk": 39995.16,
    "position_cost": 588059.4,
    "constraint": "WEIGHT",
    "atr14": 3.37,
    "low_20d": 92.6,
    "ladder_minus1_pullback": 93.2,
    "ladder_4_base": 89.2,
    "ladder_5_euphoria": 128.8
  },
  {
    "symbol": "6951.TW",
    "name": "青新-創",
    "sector": "綠能環保",
    "close": 67.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.2,
    "dog_ma200_bias": 0.0,
    "vr60": 2.02,
    "rs20": 1.06,
    "rs60": 0.82,
    "shares": 12820,
    "lots": 12,
    "odd_shares": 820,
    "ntd_at_risk": 39998.4,
    "position_cost": 865350.0,
    "constraint": "WEIGHT",
    "atr14": 1.56,
    "low_20d": 62.0,
    "ladder_minus1_pullback": 63.4,
    "ladder_4_base": 60.8,
    "ladder_5_euphoria": 87.8
  },
  {
    "symbol": "5007.TW",
    "name": "三星",
    "sector": "鋼鐵工業",
    "close": 55.7,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.14,
    "dog_ma200_bias": -0.013,
    "vr60": 1.93,
    "rs20": 0.74,
    "rs60": 0.66,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.27,
    "low_20d": 52.8,
    "ladder_minus1_pullback": 52.4,
    "ladder_4_base": 50.1,
    "ladder_5_euphoria": 72.4
  },
  {
    "symbol": "5403.TWO",
    "name": "中菲",
    "sector": "資訊服務業",
    "close": 91.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": 0.038,
    "vr60": 2.07,
    "rs20": 1.0,
    "rs60": 0.85,
    "shares": 8163,
    "lots": 8,
    "odd_shares": 163,
    "ntd_at_risk": 39998.7,
    "position_cost": 745281.9,
    "constraint": "WEIGHT",
    "atr14": 2.45,
    "low_20d": 85.0,
    "ladder_minus1_pullback": 85.8,
    "ladder_4_base": 82.2,
    "ladder_5_euphoria": 118.7
  },
  {
    "symbol": "6574.TWO",
    "name": "霈方",
    "sector": "生技醫療業",
    "close": 117.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.67,
    "dog_ma200_bias": -0.004,
    "vr60": 1.61,
    "rs20": 1.07,
    "rs60": 0.71,
    "shares": 10810,
    "lots": 10,
    "odd_shares": 810,
    "ntd_at_risk": 39997.0,
    "position_cost": 1264770.0,
    "constraint": "WEIGHT",
    "atr14": 1.85,
    "low_20d": 108.9,
    "ladder_minus1_pullback": 110.0,
    "ladder_4_base": 105.3,
    "ladder_5_euphoria": 152.1
  },
  {
    "symbol": "4106.TW",
    "name": "雃博",
    "sector": "生技醫療業",
    "close": 24.15,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.95,
    "dog_ma200_bias": -0.169,
    "vr60": 0.6,
    "rs20": 0.38,
    "rs60": 0.43,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 23.1,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.7,
    "ladder_5_euphoria": 31.4
  },
  {
    "symbol": "3567.TWO",
    "name": "逸昌",
    "sector": "半導體業",
    "close": 25.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.33,
    "dog_ma200_bias": 0.135,
    "vr60": 1.19,
    "rs20": 1.24,
    "rs60": 1.28,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 619267.2,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 24.1,
    "ladder_minus1_pullback": 24.2,
    "ladder_4_base": 23.1,
    "ladder_5_euphoria": 33.4
  },
  {
    "symbol": "4116.TWO",
    "name": "明基醫",
    "sector": "生技醫療業",
    "close": 39.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.6,
    "cpr": 0.13,
    "dog_ma200_bias": 0.013,
    "vr60": 1.87,
    "rs20": 0.83,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 992500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 36.5,
    "ladder_minus1_pullback": 37.3,
    "ladder_4_base": 35.7,
    "ladder_5_euphoria": 51.6
  },
  {
    "symbol": "6123.TWO",
    "name": "上奇",
    "sector": "資訊服務業",
    "close": 42.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.95,
    "dog_ma200_bias": 0.079,
    "vr60": 1.53,
    "rs20": 0.78,
    "rs60": 0.71,
    "shares": 21276,
    "lots": 21,
    "odd_shares": 276,
    "ntd_at_risk": 39998.88,
    "position_cost": 912740.4,
    "constraint": "WEIGHT",
    "atr14": 0.94,
    "low_20d": 38.7,
    "ladder_minus1_pullback": 40.3,
    "ladder_4_base": 38.6,
    "ladder_5_euphoria": 55.8
  },
  {
    "symbol": "6230.TW",
    "name": "尼得科超眾",
    "sector": "電腦及週邊設備業",
    "close": 111.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.38,
    "dog_ma200_bias": -0.008,
    "vr60": 1.46,
    "rs20": 0.83,
    "rs60": 0.9,
    "shares": 11560,
    "lots": 11,
    "odd_shares": 560,
    "ntd_at_risk": 39997.6,
    "position_cost": 1288940.0,
    "constraint": "WEIGHT",
    "atr14": 1.73,
    "low_20d": 106.8,
    "ladder_minus1_pullback": 104.8,
    "ladder_4_base": 100.4,
    "ladder_5_euphoria": 145.0
  },
  {
    "symbol": "7743.TWO",
    "name": "金利食安",
    "sector": "食品工業",
    "close": 24.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.1,
    "dog_ma200_bias": 0.057,
    "vr60": 1.24,
    "rs20": 0.76,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 601250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.4,
    "ladder_minus1_pullback": 22.6,
    "ladder_4_base": 21.6,
    "ladder_5_euphoria": 31.3
  },
  {
    "symbol": "8032.TWO",
    "name": "光菱",
    "sector": "電子通路業",
    "close": 34.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.41,
    "dog_ma200_bias": -0.003,
    "vr60": 2.0,
    "rs20": 1.04,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 858750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 31.5,
    "ladder_minus1_pullback": 32.3,
    "ladder_4_base": 30.9,
    "ladder_5_euphoria": 44.7
  },
  {
    "symbol": "5546.TW",
    "name": "永固-KY",
    "sector": "建材營造業",
    "close": 13.3,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.71,
    "dog_ma200_bias": -0.18,
    "vr60": 0.73,
    "rs20": 0.21,
    "rs60": 0.49,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 166250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.4,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 12.0,
    "ladder_5_euphoria": 17.3
  },
  {
    "symbol": "6666.TW",
    "name": "羅麗芬-KY",
    "sector": "生技醫療業",
    "close": 42.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.95,
    "dog_ma200_bias": -0.018,
    "vr60": 1.81,
    "rs20": 0.9,
    "rs60": 0.98,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 1012032.0,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 37.8,
    "ladder_minus1_pullback": 39.5,
    "ladder_4_base": 37.8,
    "ladder_5_euphoria": 54.6
  },
  {
    "symbol": "6474.TWO",
    "name": "華豫寧",
    "sector": "電子通路業",
    "close": 35.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.12,
    "dog_ma200_bias": 0.073,
    "vr60": 1.61,
    "rs20": 1.07,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 882500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 32.2,
    "ladder_minus1_pullback": 33.2,
    "ladder_4_base": 31.8,
    "ladder_5_euphoria": 45.9
  },
  {
    "symbol": "6870.TWO",
    "name": "騰雲",
    "sector": "數位雲端",
    "close": 294.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.05,
    "dog_ma200_bias": 0.157,
    "vr60": 1.45,
    "rs20": 1.33,
    "rs60": 1.29,
    "shares": 3514,
    "lots": 3,
    "odd_shares": 514,
    "ntd_at_risk": 39989.32,
    "position_cost": 1034873.0,
    "constraint": "WEIGHT",
    "atr14": 5.69,
    "low_20d": 275.5,
    "ladder_minus1_pullback": 276.8,
    "ladder_4_base": 265.1,
    "ladder_5_euphoria": 382.9
  },
  {
    "symbol": "7772.TWO",
    "name": "耀穎",
    "sector": "半導體業",
    "close": 127.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.12,
    "dog_ma200_bias": 0.18,
    "vr60": 1.58,
    "rs20": 1.3,
    "rs60": 0.93,
    "shares": 8968,
    "lots": 8,
    "odd_shares": 968,
    "ntd_at_risk": 39997.28,
    "position_cost": 1138936.0,
    "constraint": "WEIGHT",
    "atr14": 2.23,
    "low_20d": 115.3,
    "ladder_minus1_pullback": 119.4,
    "ladder_4_base": 114.3,
    "ladder_5_euphoria": 165.1
  },
  {
    "symbol": "8426.TWO",
    "name": "紅木-KY",
    "sector": "其他業",
    "close": 20.6,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.95,
    "dog_ma200_bias": -0.254,
    "vr60": 1.07,
    "rs20": 0.52,
    "rs60": 0.25,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 257500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.2,
    "ladder_minus1_pullback": 19.4,
    "ladder_4_base": 18.5,
    "ladder_5_euphoria": 26.8
  },
  {
    "symbol": "6931.TW",
    "name": "青松健康",
    "sector": "生技醫療業",
    "close": 38.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.25,
    "dog_ma200_bias": 0.017,
    "vr60": 1.74,
    "rs20": 1.14,
    "rs60": 0.79,
    "shares": 21505,
    "lots": 21,
    "odd_shares": 505,
    "ntd_at_risk": 39999.3,
    "position_cost": 820415.75,
    "constraint": "WEIGHT",
    "atr14": 0.93,
    "low_20d": 35.0,
    "ladder_minus1_pullback": 35.9,
    "ladder_4_base": 34.3,
    "ladder_5_euphoria": 49.6
  },
  {
    "symbol": "7753.TWO",
    "name": "星亞",
    "sector": "光電業",
    "close": 35.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.05,
    "dog_ma200_bias": -0.015,
    "vr60": 1.75,
    "rs20": 0.83,
    "rs60": 0.89,
    "shares": 16806,
    "lots": 16,
    "odd_shares": 806,
    "ntd_at_risk": 39998.28,
    "position_cost": 599133.9,
    "constraint": "WEIGHT",
    "atr14": 1.19,
    "low_20d": 32.8,
    "ladder_minus1_pullback": 33.5,
    "ladder_4_base": 32.1,
    "ladder_5_euphoria": 46.3
  },
  {
    "symbol": "7805.TWO",
    "name": "威聯通",
    "sector": "數位雲端",
    "close": 468.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.06,
    "dog_ma200_bias": 0.059,
    "vr60": 1.49,
    "rs20": 0.77,
    "rs60": 0.98,
    "shares": 1597,
    "lots": 1,
    "odd_shares": 597,
    "ntd_at_risk": 39988.88,
    "position_cost": 748194.5,
    "constraint": "WEIGHT",
    "atr14": 12.52,
    "low_20d": 430.1,
    "ladder_minus1_pullback": 440.4,
    "ladder_4_base": 421.7,
    "ladder_5_euphoria": 609.1
  },
  {
    "symbol": "9931.TW",
    "name": "欣高",
    "sector": "油電燃氣業",
    "close": 34.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.95,
    "dog_ma200_bias": 0.067,
    "vr60": 1.97,
    "rs20": 1.14,
    "rs60": 1.01,
    "shares": 17699,
    "lots": 17,
    "odd_shares": 699,
    "ntd_at_risk": 39999.74,
    "position_cost": 604420.85,
    "constraint": "WEIGHT",
    "atr14": 1.13,
    "low_20d": 32.2,
    "ladder_minus1_pullback": 32.1,
    "ladder_4_base": 30.7,
    "ladder_5_euphoria": 44.4
  },
  {
    "symbol": "3168.TW",
    "name": "眾福科",
    "sector": "光電業",
    "close": 42.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.64,
    "dog_ma200_bias": 0.001,
    "vr60": 1.27,
    "rs20": 0.94,
    "rs60": 0.93,
    "shares": 22727,
    "lots": 22,
    "odd_shares": 727,
    "ntd_at_risk": 39999.52,
    "position_cost": 962488.45,
    "constraint": "WEIGHT",
    "atr14": 0.88,
    "low_20d": 39.8,
    "ladder_minus1_pullback": 39.8,
    "ladder_4_base": 38.1,
    "ladder_5_euphoria": 55.1
  },
  {
    "symbol": "2756.TWO",
    "name": "聯發國際",
    "sector": "觀光餐旅",
    "close": 60.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.95,
    "dog_ma200_bias": 0.068,
    "vr60": 1.36,
    "rs20": 1.25,
    "rs60": 1.16,
    "shares": 18348,
    "lots": 18,
    "odd_shares": 348,
    "ntd_at_risk": 39998.64,
    "position_cost": 1106384.4,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 54.9,
    "ladder_minus1_pullback": 56.7,
    "ladder_4_base": 54.3,
    "ladder_5_euphoria": 78.4
  },
  {
    "symbol": "3259.TWO",
    "name": "鑫創",
    "sector": "半導體業",
    "close": 10.35,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.05,
    "dog_ma200_bias": -0.129,
    "vr60": 0.77,
    "rs20": 0.46,
    "rs60": 0.46,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.9,
    "ladder_minus1_pullback": 9.7,
    "ladder_4_base": 9.3,
    "ladder_5_euphoria": 13.5
  },
  {
    "symbol": "6248.TWO",
    "name": "沛波",
    "sector": "鋼鐵工業",
    "close": 16.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.95,
    "dog_ma200_bias": 0.017,
    "vr60": 1.83,
    "rs20": 1.04,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 420000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.2,
    "ladder_minus1_pullback": 15.8,
    "ladder_4_base": 15.1,
    "ladder_5_euphoria": 21.8
  },
  {
    "symbol": "7642.TWO",
    "name": "昶瑞機電",
    "sector": "電機機械業",
    "close": 64.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.37,
    "cpr": 0.36,
    "dog_ma200_bias": 0.007,
    "vr60": 1.56,
    "rs20": 1.12,
    "rs60": 0.9,
    "shares": 19607,
    "lots": 19,
    "odd_shares": 607,
    "ntd_at_risk": 39998.28,
    "position_cost": 1258769.4,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 60.9,
    "ladder_minus1_pullback": 60.3,
    "ladder_4_base": 57.8,
    "ladder_5_euphoria": 83.5
  },
  {
    "symbol": "8446.TWO",
    "name": "華研",
    "sector": "文化創意業",
    "close": 85.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.6,
    "dog_ma200_bias": -0.016,
    "vr60": 1.4,
    "rs20": 0.83,
    "rs60": 1.0,
    "shares": 8130,
    "lots": 8,
    "odd_shares": 130,
    "ntd_at_risk": 39999.6,
    "position_cost": 698367.0,
    "constraint": "WEIGHT",
    "atr14": 2.46,
    "low_20d": 78.1,
    "ladder_minus1_pullback": 80.7,
    "ladder_4_base": 77.3,
    "ladder_5_euphoria": 111.7
  },
  {
    "symbol": "6655.TW",
    "name": "科定",
    "sector": "其他業",
    "close": 133.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.65,
    "dog_ma200_bias": 0.108,
    "vr60": 1.23,
    "rs20": 1.31,
    "rs60": 1.13,
    "shares": 6269,
    "lots": 6,
    "odd_shares": 269,
    "ntd_at_risk": 39996.22,
    "position_cost": 836911.5,
    "constraint": "WEIGHT",
    "atr14": 3.19,
    "low_20d": 122.5,
    "ladder_minus1_pullback": 125.5,
    "ladder_4_base": 120.2,
    "ladder_5_euphoria": 173.6
  },
  {
    "symbol": "6923.TW",
    "name": "中台",
    "sector": "綠能環保",
    "close": 73.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.27,
    "dog_ma200_bias": 0.074,
    "vr60": 1.54,
    "rs20": 0.97,
    "rs60": 0.75,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 1179029.9,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 69.6,
    "ladder_minus1_pullback": 68.7,
    "ladder_4_base": 65.8,
    "ladder_5_euphoria": 95.0
  },
  {
    "symbol": "2701.TW",
    "name": "萬企",
    "sector": "觀光餐旅",
    "close": 10.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": -0.012,
    "vr60": 1.6,
    "rs20": 0.89,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 257500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.5,
    "ladder_minus1_pullback": 9.7,
    "ladder_4_base": 9.3,
    "ladder_5_euphoria": 13.4
  },
  {
    "symbol": "5215.TW",
    "name": "科嘉-KY",
    "sector": "電腦及週邊設備業",
    "close": 36.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.54,
    "dog_ma200_bias": 0.027,
    "vr60": 1.76,
    "rs20": 0.92,
    "rs60": 0.86,
    "shares": 24691,
    "lots": 24,
    "odd_shares": 691,
    "ntd_at_risk": 39999.42,
    "position_cost": 897517.85,
    "constraint": "WEIGHT",
    "atr14": 0.81,
    "low_20d": 33.4,
    "ladder_minus1_pullback": 34.2,
    "ladder_4_base": 32.7,
    "ladder_5_euphoria": 47.3
  },
  {
    "symbol": "2488.TW",
    "name": "漢平",
    "sector": "其他電子業",
    "close": 50.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.5,
    "dog_ma200_bias": 0.021,
    "vr60": 1.92,
    "rs20": 0.88,
    "rs60": 0.83,
    "shares": 15625,
    "lots": 15,
    "odd_shares": 625,
    "ntd_at_risk": 40000.0,
    "position_cost": 784375.0,
    "constraint": "WEIGHT",
    "atr14": 1.28,
    "low_20d": 46.1,
    "ladder_minus1_pullback": 47.2,
    "ladder_4_base": 45.2,
    "ladder_5_euphoria": 65.3
  },
  {
    "symbol": "2722.TW",
    "name": "夏都",
    "sector": "觀光餐旅",
    "close": 20.9,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.29,
    "dog_ma200_bias": 0.082,
    "vr60": 1.19,
    "rs20": 1.21,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 522500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.5,
    "ladder_minus1_pullback": 19.6,
    "ladder_4_base": 18.8,
    "ladder_5_euphoria": 27.2
  },
  {
    "symbol": "4523.TWO",
    "name": "永彰",
    "sector": "電機機械業",
    "close": 24.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.95,
    "dog_ma200_bias": -0.012,
    "vr60": 1.96,
    "rs20": 0.96,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 608750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.8,
    "ladder_minus1_pullback": 22.9,
    "ladder_4_base": 21.9,
    "ladder_5_euphoria": 31.7
  },
  {
    "symbol": "8024.TWO",
    "name": "佑華",
    "sector": "半導體業",
    "close": 12.35,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.62,
    "dog_ma200_bias": 0.337,
    "vr60": 2.53,
    "rs20": 1.18,
    "rs60": 1.12,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 11.2,
    "ladder_minus1_pullback": 11.6,
    "ladder_4_base": 11.1,
    "ladder_5_euphoria": 16.1
  },
  {
    "symbol": "8034.TWO",
    "name": "榮群",
    "sector": "通信網路業",
    "close": 19.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.95,
    "dog_ma200_bias": 0.0,
    "vr60": 1.38,
    "rs20": 0.88,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 480000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.4,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.3,
    "ladder_5_euphoria": 25.0
  },
  {
    "symbol": "1324.TW",
    "name": "地球",
    "sector": "塑膠工業",
    "close": 9.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.05,
    "dog_ma200_bias": 0.062,
    "vr60": 1.82,
    "rs20": 0.86,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 247500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.4,
    "ladder_minus1_pullback": 9.3,
    "ladder_4_base": 8.9,
    "ladder_5_euphoria": 12.9
  },
  {
    "symbol": "3557.TW",
    "name": "嘉威",
    "sector": "居家生活",
    "close": 23.75,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.91,
    "dog_ma200_bias": 0.18,
    "vr60": 1.65,
    "rs20": 1.25,
    "rs60": 1.2,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 593750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.9,
    "ladder_minus1_pullback": 22.3,
    "ladder_4_base": 21.4,
    "ladder_5_euphoria": 30.9
  },
  {
    "symbol": "1783.TW",
    "name": "和康生",
    "sector": "生技醫療業",
    "close": 37.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.12,
    "dog_ma200_bias": 0.071,
    "vr60": 1.21,
    "rs20": 0.87,
    "rs60": 0.99,
    "shares": 15267,
    "lots": 15,
    "odd_shares": 267,
    "ntd_at_risk": 39999.54,
    "position_cost": 570985.8,
    "constraint": "WEIGHT",
    "atr14": 1.31,
    "low_20d": 35.1,
    "ladder_minus1_pullback": 35.2,
    "ladder_4_base": 33.7,
    "ladder_5_euphoria": 48.6
  },
  {
    "symbol": "1220.TW",
    "name": "台榮",
    "sector": "食品工業",
    "close": 10.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.5,
    "dog_ma200_bias": 0.058,
    "vr60": 1.56,
    "rs20": 0.91,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 272500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.9,
    "ladder_minus1_pullback": 10.2,
    "ladder_4_base": 9.8,
    "ladder_5_euphoria": 14.2
  },
  {
    "symbol": "4735.TWO",
    "name": "豪展",
    "sector": "生技醫療業",
    "close": 36.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.13,
    "dog_ma200_bias": 0.046,
    "vr60": 1.62,
    "rs20": 0.96,
    "rs60": 0.97,
    "shares": 23529,
    "lots": 23,
    "odd_shares": 529,
    "ntd_at_risk": 39999.3,
    "position_cost": 856455.6,
    "constraint": "WEIGHT",
    "atr14": 0.85,
    "low_20d": 33.7,
    "ladder_minus1_pullback": 34.2,
    "ladder_4_base": 32.8,
    "ladder_5_euphoria": 47.3
  },
  {
    "symbol": "9950.TWO",
    "name": "萬國通",
    "sector": "塑膠工業",
    "close": 10.4,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.38,
    "dog_ma200_bias": -0.179,
    "vr60": 0.74,
    "rs20": 0.38,
    "rs60": 0.61,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.9,
    "ladder_minus1_pullback": 9.8,
    "ladder_4_base": 9.4,
    "ladder_5_euphoria": 13.5
  },
  {
    "symbol": "3432.TW",
    "name": "台端",
    "sector": "電子零組件業",
    "close": 14.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.06,
    "dog_ma200_bias": 0.027,
    "vr60": 1.66,
    "rs20": 1.06,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 355000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.6,
    "ladder_minus1_pullback": 13.3,
    "ladder_4_base": 12.8,
    "ladder_5_euphoria": 18.5
  },
  {
    "symbol": "2762.TW",
    "name": "世界健身-KY",
    "sector": "運動休閒",
    "close": 78.2,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.25,
    "dog_ma200_bias": -0.15,
    "vr60": 0.86,
    "rs20": 0.52,
    "rs60": 0.3,
    "shares": 7407,
    "lots": 7,
    "odd_shares": 407,
    "ntd_at_risk": 19998.9,
    "position_cost": 579227.4,
    "constraint": "WEIGHT",
    "atr14": 1.35,
    "low_20d": 71.9,
    "ladder_minus1_pullback": 73.5,
    "ladder_4_base": 70.4,
    "ladder_5_euphoria": 101.7
  },
  {
    "symbol": "2642.TW",
    "name": "宅配通",
    "sector": "航運業",
    "close": 20.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.6,
    "dog_ma200_bias": 0.057,
    "vr60": 1.83,
    "rs20": 0.83,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 507500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.4,
    "ladder_minus1_pullback": 19.1,
    "ladder_4_base": 18.3,
    "ladder_5_euphoria": 26.4
  },
  {
    "symbol": "2732.TWO",
    "name": "六角",
    "sector": "觀光餐旅",
    "close": 62.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.25,
    "dog_ma200_bias": 0.036,
    "vr60": 1.54,
    "rs20": 0.98,
    "rs60": 0.74,
    "shares": 9661,
    "lots": 9,
    "odd_shares": 661,
    "ntd_at_risk": 39996.54,
    "position_cost": 598982.0,
    "constraint": "WEIGHT",
    "atr14": 2.07,
    "low_20d": 56.3,
    "ladder_minus1_pullback": 58.3,
    "ladder_4_base": 55.8,
    "ladder_5_euphoria": 80.6
  },
  {
    "symbol": "2755.TWO",
    "name": "揚秦",
    "sector": "觀光餐旅",
    "close": 95.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.83,
    "dog_ma200_bias": -0.11,
    "vr60": 0.65,
    "rs20": 0.52,
    "rs60": 0.49,
    "shares": 5586,
    "lots": 5,
    "odd_shares": 586,
    "ntd_at_risk": 19997.88,
    "position_cost": 533463.0,
    "constraint": "WEIGHT",
    "atr14": 1.79,
    "low_20d": 89.0,
    "ladder_minus1_pullback": 89.8,
    "ladder_4_base": 86.0,
    "ladder_5_euphoria": 124.2
  },
  {
    "symbol": "3206.TWO",
    "name": "志豐",
    "sector": "電子零組件業",
    "close": 33.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.21,
    "dog_ma200_bias": 0.11,
    "vr60": 1.46,
    "rs20": 1.11,
    "rs60": 1.21,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 845000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 31.7,
    "ladder_minus1_pullback": 31.8,
    "ladder_4_base": 30.4,
    "ladder_5_euphoria": 43.9
  },
  {
    "symbol": "3664.TWO",
    "name": "安瑞-KY",
    "sector": "通信網路業",
    "close": 8.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.95,
    "dog_ma200_bias": 0.125,
    "vr60": 1.25,
    "rs20": 0.96,
    "rs60": 1.21,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 220000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.0,
    "ladder_minus1_pullback": 8.3,
    "ladder_4_base": 7.9,
    "ladder_5_euphoria": 11.4
  },
  {
    "symbol": "6028.TWO",
    "name": "公勝保經",
    "sector": "金融保險業",
    "close": 112.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.38,
    "dog_ma200_bias": 0.072,
    "vr60": 1.34,
    "rs20": 1.13,
    "rs60": 0.82,
    "shares": 10152,
    "lots": 10,
    "odd_shares": 152,
    "ntd_at_risk": 39998.88,
    "position_cost": 1142100.0,
    "constraint": "WEIGHT",
    "atr14": 1.97,
    "low_20d": 104.6,
    "ladder_minus1_pullback": 105.8,
    "ladder_4_base": 101.2,
    "ladder_5_euphoria": 146.2
  },
  {
    "symbol": "6154.TWO",
    "name": "順發",
    "sector": "電子通路業",
    "close": 14.1,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.95,
    "dog_ma200_bias": -0.167,
    "vr60": 0.92,
    "rs20": 0.44,
    "rs60": 0.5,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 176250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.1,
    "ladder_minus1_pullback": 13.3,
    "ladder_4_base": 12.7,
    "ladder_5_euphoria": 18.3
  },
  {
    "symbol": "8489.TWO",
    "name": "三貝德",
    "sector": "其他業",
    "close": 21.95,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.95,
    "dog_ma200_bias": -0.171,
    "vr60": 0.74,
    "rs20": 0.49,
    "rs60": 0.42,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 20.7,
    "ladder_minus1_pullback": 20.6,
    "ladder_4_base": 19.8,
    "ladder_5_euphoria": 28.5
  },
  {
    "symbol": "8930.TWO",
    "name": "青鋼",
    "sector": "鋼鐵工業",
    "close": 28.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.75,
    "dog_ma200_bias": -0.009,
    "vr60": 1.71,
    "rs20": 0.93,
    "rs60": 1.01,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 630311.55,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 26.3,
    "ladder_minus1_pullback": 26.4,
    "ladder_4_base": 25.2,
    "ladder_5_euphoria": 36.5
  },
  {
    "symbol": "8931.TWO",
    "name": "大汽電",
    "sector": "油電燃氣業",
    "close": 43.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.47,
    "dog_ma200_bias": -0.011,
    "vr60": 1.29,
    "rs20": 0.97,
    "rs60": 0.71,
    "shares": 22988,
    "lots": 22,
    "odd_shares": 988,
    "ntd_at_risk": 39999.12,
    "position_cost": 988484.0,
    "constraint": "WEIGHT",
    "atr14": 0.87,
    "low_20d": 41.1,
    "ladder_minus1_pullback": 40.4,
    "ladder_4_base": 38.7,
    "ladder_5_euphoria": 55.9
  },
  {
    "symbol": "1339.TW",
    "name": "昭輝",
    "sector": "汽車工業",
    "close": 42.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.11,
    "dog_ma200_bias": 0.049,
    "vr60": 1.64,
    "rs20": 0.82,
    "rs60": 0.72,
    "shares": 14598,
    "lots": 14,
    "odd_shares": 598,
    "ntd_at_risk": 39998.52,
    "position_cost": 617495.4,
    "constraint": "WEIGHT",
    "atr14": 1.37,
    "low_20d": 38.6,
    "ladder_minus1_pullback": 39.8,
    "ladder_4_base": 38.1,
    "ladder_5_euphoria": 55.0
  },
  {
    "symbol": "7721.TW",
    "name": "微程式",
    "sector": "數位雲端",
    "close": 60.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.56,
    "dog_ma200_bias": 0.076,
    "vr60": 1.46,
    "rs20": 0.84,
    "rs60": 0.93,
    "shares": 11627,
    "lots": 11,
    "odd_shares": 627,
    "ntd_at_risk": 39996.88,
    "position_cost": 704596.2,
    "constraint": "WEIGHT",
    "atr14": 1.72,
    "low_20d": 54.8,
    "ladder_minus1_pullback": 57.0,
    "ladder_4_base": 54.5,
    "ladder_5_euphoria": 78.8
  },
  {
    "symbol": "6625.TW",
    "name": "必應",
    "sector": "其他業",
    "close": 72.8,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.25,
    "dog_ma200_bias": -0.267,
    "vr60": 0.68,
    "rs20": 0.41,
    "rs60": 0.24,
    "shares": 5076,
    "lots": 5,
    "odd_shares": 76,
    "ntd_at_risk": 19999.44,
    "position_cost": 369532.8,
    "constraint": "WEIGHT",
    "atr14": 1.97,
    "low_20d": 66.1,
    "ladder_minus1_pullback": 68.4,
    "ladder_4_base": 65.5,
    "ladder_5_euphoria": 94.6
  },
  {
    "symbol": "2743.TWO",
    "name": "山富",
    "sector": "觀光餐旅",
    "close": 50.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": 0.021,
    "vr60": 1.34,
    "rs20": 0.79,
    "rs60": 0.89,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 1137032.6,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 46.7,
    "ladder_minus1_pullback": 47.6,
    "ladder_4_base": 45.5,
    "ladder_5_euphoria": 65.8
  },
  {
    "symbol": "3434.TWO",
    "name": "哲固",
    "sector": "光電業",
    "close": 31.0,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.46,
    "dog_ma200_bias": -0.194,
    "vr60": 0.68,
    "rs20": 0.58,
    "rs60": 0.5,
    "shares": 9803,
    "lots": 9,
    "odd_shares": 803,
    "ntd_at_risk": 19998.12,
    "position_cost": 303893.0,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 28.6,
    "ladder_minus1_pullback": 29.1,
    "ladder_4_base": 27.9,
    "ladder_5_euphoria": 40.3
  },
  {
    "symbol": "5272.TWO",
    "name": "笙科",
    "sector": "半導體業",
    "close": 17.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": 0.001,
    "vr60": 1.59,
    "rs20": 1.03,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 426250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.8,
    "ladder_minus1_pullback": 16.0,
    "ladder_4_base": 15.3,
    "ladder_5_euphoria": 22.2
  },
  {
    "symbol": "5344.TWO",
    "name": "立衛",
    "sector": "半導體業",
    "close": 13.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.67,
    "dog_ma200_bias": 0.04,
    "vr60": 2.05,
    "rs20": 0.98,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 341250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.7,
    "ladder_minus1_pullback": 12.8,
    "ladder_4_base": 12.3,
    "ladder_5_euphoria": 17.7
  },
  {
    "symbol": "7705.TW",
    "name": "三商餐飲",
    "sector": "觀光餐旅",
    "close": 29.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.25,
    "dog_ma200_bias": 0.048,
    "vr60": 1.45,
    "rs20": 0.75,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 738750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.2,
    "ladder_minus1_pullback": 27.8,
    "ladder_4_base": 26.6,
    "ladder_5_euphoria": 38.4
  },
  {
    "symbol": "6908.TW",
    "name": "宏碁遊戲-創",
    "sector": "電子通路業",
    "close": 25.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.25,
    "dog_ma200_bias": -0.014,
    "vr60": 1.56,
    "rs20": 1.07,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 630000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.2,
    "ladder_minus1_pullback": 23.7,
    "ladder_4_base": 22.7,
    "ladder_5_euphoria": 32.8
  },
  {
    "symbol": "6934.TW",
    "name": "心誠鎂",
    "sector": "生技醫療業",
    "close": 80.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.24,
    "dog_ma200_bias": 0.071,
    "vr60": 1.99,
    "rs20": 0.93,
    "rs60": 0.9,
    "shares": 10928,
    "lots": 10,
    "odd_shares": 928,
    "ntd_at_risk": 39996.48,
    "position_cost": 876425.6,
    "constraint": "WEIGHT",
    "atr14": 1.83,
    "low_20d": 74.8,
    "ladder_minus1_pullback": 75.4,
    "ladder_4_base": 72.2,
    "ladder_5_euphoria": 104.3
  },
  {
    "symbol": "6804.TWO",
    "name": "明係",
    "sector": "運動休閒",
    "close": 16.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.57,
    "dog_ma200_bias": 0.054,
    "vr60": 1.46,
    "rs20": 1.1,
    "rs60": 0.86,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 423750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.0,
    "ladder_minus1_pullback": 15.9,
    "ladder_4_base": 15.3,
    "ladder_5_euphoria": 22.0
  },
  {
    "symbol": "8087.TWO",
    "name": "麗升能源",
    "sector": "綠能環保",
    "close": 23.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.43,
    "dog_ma200_bias": 0.05,
    "vr60": 1.84,
    "rs20": 0.87,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 577500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.7,
    "ladder_minus1_pullback": 21.7,
    "ladder_4_base": 20.8,
    "ladder_5_euphoria": 30.0
  },
  {
    "symbol": "2247.TW",
    "name": "汎德永業",
    "sector": "汽車工業",
    "close": 224.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.8,
    "cpr": 0.1,
    "dog_ma200_bias": -0.087,
    "vr60": 0.66,
    "rs20": 0.39,
    "rs60": 0.66,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 5.66,
    "low_20d": 210.3,
    "ladder_minus1_pullback": 211.0,
    "ladder_4_base": 202.1,
    "ladder_5_euphoria": 291.9
  },
  {
    "symbol": "4205.TWO",
    "name": "中華食",
    "sector": "食品工業",
    "close": 67.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.75,
    "dog_ma200_bias": 0.148,
    "vr60": 1.32,
    "rs20": 1.31,
    "rs60": 0.97,
    "shares": 10362,
    "lots": 10,
    "odd_shares": 362,
    "ntd_at_risk": 39997.32,
    "position_cost": 694254.0,
    "constraint": "WEIGHT",
    "atr14": 1.93,
    "low_20d": 61.5,
    "ladder_minus1_pullback": 63.0,
    "ladder_4_base": 60.3,
    "ladder_5_euphoria": 87.1
  },
  {
    "symbol": "6246.TWO",
    "name": "臺龍",
    "sector": "光電業",
    "close": 12.5,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.22,
    "dog_ma200_bias": -0.023,
    "vr60": 1.65,
    "rs20": 0.73,
    "rs60": 0.53,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 11.5,
    "ladder_minus1_pullback": 11.8,
    "ladder_4_base": 11.2,
    "ladder_5_euphoria": 16.2
  },
  {
    "symbol": "6470.TWO",
    "name": "宇智",
    "sector": "通信網路業",
    "close": 45.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.33,
    "dog_ma200_bias": 0.007,
    "vr60": 1.77,
    "rs20": 0.87,
    "rs60": 1.02,
    "shares": 18181,
    "lots": 18,
    "odd_shares": 181,
    "ntd_at_risk": 39998.2,
    "position_cost": 818145.0,
    "constraint": "WEIGHT",
    "atr14": 1.1,
    "low_20d": 43.0,
    "ladder_minus1_pullback": 42.3,
    "ladder_4_base": 40.5,
    "ladder_5_euphoria": 58.5
  },
  {
    "symbol": "2373.TW",
    "name": "震旦行",
    "sector": "其他電子業",
    "close": 52.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.25,
    "dog_ma200_bias": 0.144,
    "vr60": 1.48,
    "rs20": 1.04,
    "rs60": 1.1,
    "shares": 17543,
    "lots": 17,
    "odd_shares": 543,
    "ntd_at_risk": 39998.04,
    "position_cost": 917498.9,
    "constraint": "WEIGHT",
    "atr14": 1.14,
    "low_20d": 48.6,
    "ladder_minus1_pullback": 49.2,
    "ladder_4_base": 47.1,
    "ladder_5_euphoria": 68.0
  },
  {
    "symbol": "4439.TW",
    "name": "冠星-KY",
    "sector": "紡織纖維業",
    "close": 98.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.6,
    "dog_ma200_bias": 0.079,
    "vr60": 1.7,
    "rs20": 1.15,
    "rs60": 0.73,
    "shares": 10101,
    "lots": 10,
    "odd_shares": 101,
    "ntd_at_risk": 39999.96,
    "position_cost": 996968.7,
    "constraint": "WEIGHT",
    "atr14": 1.98,
    "low_20d": 93.2,
    "ladder_minus1_pullback": 92.8,
    "ladder_4_base": 88.8,
    "ladder_5_euphoria": 128.3
  },
  {
    "symbol": "8463.TW",
    "name": "潤泰材",
    "sector": "其他業",
    "close": 21.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.95,
    "dog_ma200_bias": 0.073,
    "vr60": 1.51,
    "rs20": 1.08,
    "rs60": 1.08,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 535000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.9,
    "ladder_minus1_pullback": 20.1,
    "ladder_4_base": 19.3,
    "ladder_5_euphoria": 27.8
  },
  {
    "symbol": "2433.TW",
    "name": "互盛電",
    "sector": "其他電子業",
    "close": 39.45,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.4,
    "dog_ma200_bias": -0.165,
    "vr60": 0.78,
    "rs20": 0.46,
    "rs60": 0.38,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.31,
    "low_20d": 35.7,
    "ladder_minus1_pullback": 37.1,
    "ladder_4_base": 35.5,
    "ladder_5_euphoria": 51.3
  },
  {
    "symbol": "2734.TWO",
    "name": "易飛網",
    "sector": "觀光餐旅",
    "close": 14.65,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.76,
    "cpr": 0.8,
    "dog_ma200_bias": 0.319,
    "vr60": 2.35,
    "rs20": 1.28,
    "rs60": 1.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 13.8,
    "ladder_4_base": 13.2,
    "ladder_5_euphoria": 19.0
  },
  {
    "symbol": "3499.TWO",
    "name": "環天科",
    "sector": "通信網路業",
    "close": 13.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.5,
    "dog_ma200_bias": 0.02,
    "vr60": 1.21,
    "rs20": 0.8,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 326250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.2,
    "ladder_minus1_pullback": 12.3,
    "ladder_4_base": 11.7,
    "ladder_5_euphoria": 17.0
  },
  {
    "symbol": "3611.TWO",
    "name": "鼎翰",
    "sector": "電腦及週邊設備業",
    "close": 183.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.05,
    "dog_ma200_bias": 0.013,
    "vr60": 1.87,
    "rs20": 0.94,
    "rs60": 0.72,
    "shares": 4651,
    "lots": 4,
    "odd_shares": 651,
    "ntd_at_risk": 39998.6,
    "position_cost": 851133.0,
    "constraint": "WEIGHT",
    "atr14": 4.3,
    "low_20d": 168.4,
    "ladder_minus1_pullback": 172.0,
    "ladder_4_base": 164.7,
    "ladder_5_euphoria": 237.9
  },
  {
    "symbol": "4744.TWO",
    "name": "皇將",
    "sector": "生技醫療業",
    "close": 26.65,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.12,
    "dog_ma200_bias": 0.126,
    "vr60": 1.2,
    "rs20": 1.33,
    "rs60": 0.96,
    "shares": 22988,
    "lots": 22,
    "odd_shares": 988,
    "ntd_at_risk": 39999.12,
    "position_cost": 612630.2,
    "constraint": "WEIGHT",
    "atr14": 0.87,
    "low_20d": 25.4,
    "ladder_minus1_pullback": 25.1,
    "ladder_4_base": 24.0,
    "ladder_5_euphoria": 34.6
  },
  {
    "symbol": "7794.TWO",
    "name": "宏碁智新",
    "sector": "居家生活",
    "close": 28.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.05,
    "dog_ma200_bias": 0.062,
    "vr60": 1.96,
    "rs20": 0.82,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 717500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.4,
    "ladder_minus1_pullback": 27.0,
    "ladder_4_base": 25.8,
    "ladder_5_euphoria": 37.3
  },
  {
    "symbol": "4107.TWO",
    "name": "邦特",
    "sector": "生技醫療業",
    "close": 109.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.5,
    "dog_ma200_bias": -0.07,
    "vr60": 1.56,
    "rs20": 0.59,
    "rs60": 0.59,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.82,
    "low_20d": 102.5,
    "ladder_minus1_pullback": 102.5,
    "ladder_4_base": 98.1,
    "ladder_5_euphoria": 141.7
  },
  {
    "symbol": "4907.TWO",
    "name": "富宇",
    "sector": "建材營造業",
    "close": 41.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.29,
    "dog_ma200_bias": 0.056,
    "vr60": 1.81,
    "rs20": 0.81,
    "rs60": 0.83,
    "shares": 18018,
    "lots": 18,
    "odd_shares": 18,
    "ntd_at_risk": 39999.96,
    "position_cost": 754053.3,
    "constraint": "WEIGHT",
    "atr14": 1.11,
    "low_20d": 39.7,
    "ladder_minus1_pullback": 39.3,
    "ladder_4_base": 37.7,
    "ladder_5_euphoria": 54.4
  },
  {
    "symbol": "6983.TWO",
    "name": "華洋精機",
    "sector": "其他電子業",
    "close": 352.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.95,
    "dog_ma200_bias": 0.002,
    "vr60": 1.23,
    "rs20": 1.02,
    "rs60": 0.78,
    "shares": 1746,
    "lots": 1,
    "odd_shares": 746,
    "ntd_at_risk": 39983.4,
    "position_cost": 614592.0,
    "constraint": "WEIGHT",
    "atr14": 11.45,
    "low_20d": 324.4,
    "ladder_minus1_pullback": 330.9,
    "ladder_4_base": 316.8,
    "ladder_5_euphoria": 457.6
  },
  {
    "symbol": "8092.TWO",
    "name": "建暐",
    "sector": "其他電子業",
    "close": 12.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.05,
    "dog_ma200_bias": 0.05,
    "vr60": 1.95,
    "rs20": 1.07,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 310000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.3,
    "ladder_minus1_pullback": 11.7,
    "ladder_4_base": 11.2,
    "ladder_5_euphoria": 16.1
  },
  {
    "symbol": "8440.TWO",
    "name": "綠電",
    "sector": "綠能環保",
    "close": 19.95,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.3,
    "cpr": 0.25,
    "dog_ma200_bias": 0.146,
    "vr60": 1.59,
    "rs20": 1.11,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 498750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.6,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 25.9
  },
  {
    "symbol": "6606.TW",
    "name": "建德工業",
    "sector": "電機機械業",
    "close": 24.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.38,
    "dog_ma200_bias": -0.015,
    "vr60": 1.2,
    "rs20": 1.06,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 612500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.1,
    "ladder_minus1_pullback": 23.0,
    "ladder_4_base": 22.1,
    "ladder_5_euphoria": 31.9
  },
  {
    "symbol": "1418.TW",
    "name": "東華",
    "sector": "紡織纖維業",
    "close": 18.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.6,
    "dog_ma200_bias": 0.073,
    "vr60": 1.54,
    "rs20": 0.85,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 465000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.7,
    "ladder_minus1_pullback": 17.5,
    "ladder_4_base": 16.7,
    "ladder_5_euphoria": 24.2
  },
  {
    "symbol": "3541.TWO",
    "name": "西柏",
    "sector": "其他電子業",
    "close": 24.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.13,
    "dog_ma200_bias": 0.022,
    "vr60": 2.09,
    "rs20": 0.88,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 600000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.6,
    "ladder_minus1_pullback": 22.6,
    "ladder_4_base": 21.6,
    "ladder_5_euphoria": 31.2
  },
  {
    "symbol": "3646.TWO",
    "name": "艾恩特",
    "sector": "電子零組件業",
    "close": 24.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.75,
    "dog_ma200_bias": 0.047,
    "vr60": 1.4,
    "rs20": 1.1,
    "rs60": 0.98,
    "shares": 23255,
    "lots": 23,
    "odd_shares": 255,
    "ntd_at_risk": 39998.6,
    "position_cost": 579049.5,
    "constraint": "WEIGHT",
    "atr14": 0.86,
    "low_20d": 23.9,
    "ladder_minus1_pullback": 23.4,
    "ladder_4_base": 22.4,
    "ladder_5_euphoria": 32.4
  },
  {
    "symbol": "6161.TWO",
    "name": "捷波",
    "sector": "電腦及週邊設備業",
    "close": 48.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.46,
    "cpr": 0.6,
    "dog_ma200_bias": 0.063,
    "vr60": 1.35,
    "rs20": 0.82,
    "rs60": 0.85,
    "shares": 12269,
    "lots": 12,
    "odd_shares": 269,
    "ntd_at_risk": 39996.94,
    "position_cost": 593206.15,
    "constraint": "WEIGHT",
    "atr14": 1.63,
    "low_20d": 43.7,
    "ladder_minus1_pullback": 45.4,
    "ladder_4_base": 43.5,
    "ladder_5_euphoria": 62.9
  },
  {
    "symbol": "6264.TWO",
    "name": "富裔",
    "sector": "建材營造業",
    "close": 6.03,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.87,
    "dog_ma200_bias": 0.073,
    "vr60": 1.25,
    "rs20": 1.17,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 150750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 5.6,
    "ladder_minus1_pullback": 5.7,
    "ladder_4_base": 5.4,
    "ladder_5_euphoria": 7.8
  },
  {
    "symbol": "2430.TW",
    "name": "燦坤",
    "sector": "電子通路業",
    "close": 17.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.95,
    "dog_ma200_bias": 0.001,
    "vr60": 1.69,
    "rs20": 1.13,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 437500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.6,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.8,
    "ladder_5_euphoria": 22.8
  },
  {
    "symbol": "1445.TW",
    "name": "大宇",
    "sector": "紡織纖維業",
    "close": 10.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.05,
    "dog_ma200_bias": -0.17,
    "vr60": 0.72,
    "rs20": 0.36,
    "rs60": 0.49,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 13.0
  },
  {
    "symbol": "6906.TW",
    "name": "現觀科",
    "sector": "數位雲端",
    "close": 78.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.19,
    "dog_ma200_bias": -0.156,
    "vr60": 0.74,
    "rs20": 0.46,
    "rs60": 0.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.93,
    "low_20d": 73.8,
    "ladder_minus1_pullback": 74.1,
    "ladder_4_base": 70.9,
    "ladder_5_euphoria": 102.4
  },
  {
    "symbol": "4161.TWO",
    "name": "聿新科",
    "sector": "生技醫療業",
    "close": 21.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.05,
    "dog_ma200_bias": 0.062,
    "vr60": 1.78,
    "rs20": 0.9,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 528750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.8,
    "ladder_minus1_pullback": 19.9,
    "ladder_4_base": 19.0,
    "ladder_5_euphoria": 27.5
  },
  {
    "symbol": "4905.TWO",
    "name": "台聯電",
    "sector": "生技醫療業",
    "close": 84.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.58,
    "dog_ma200_bias": -0.241,
    "vr60": 0.79,
    "rs20": 0.44,
    "rs60": 0.54,
    "shares": 7299,
    "lots": 7,
    "odd_shares": 299,
    "ntd_at_risk": 19999.26,
    "position_cost": 619685.1,
    "constraint": "WEIGHT",
    "atr14": 1.37,
    "low_20d": 77.2,
    "ladder_minus1_pullback": 79.8,
    "ladder_4_base": 76.4,
    "ladder_5_euphoria": 110.4
  },
  {
    "symbol": "6418.TWO",
    "name": "詠昇",
    "sector": "電子零組件業",
    "close": 33.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.05,
    "dog_ma200_bias": 0.034,
    "vr60": 2.09,
    "rs20": 1.09,
    "rs60": 0.76,
    "shares": 23255,
    "lots": 23,
    "odd_shares": 255,
    "ntd_at_risk": 39998.6,
    "position_cost": 769740.5,
    "constraint": "WEIGHT",
    "atr14": 0.86,
    "low_20d": 31.2,
    "ladder_minus1_pullback": 31.1,
    "ladder_4_base": 29.8,
    "ladder_5_euphoria": 43.0
  },
  {
    "symbol": "4943.TW",
    "name": "康控-KY",
    "sector": "電子零組件業",
    "close": 6.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.35,
    "dog_ma200_bias": 0.076,
    "vr60": 1.74,
    "rs20": 1.14,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 166250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 6.1,
    "ladder_minus1_pullback": 6.3,
    "ladder_4_base": 6.0,
    "ladder_5_euphoria": 8.6
  },
  {
    "symbol": "6582.TW",
    "name": "申豐",
    "sector": "橡膠工業",
    "close": 31.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.11,
    "cpr": 0.95,
    "dog_ma200_bias": 0.048,
    "vr60": 2.08,
    "rs20": 1.03,
    "rs60": 0.82,
    "shares": 19047,
    "lots": 19,
    "odd_shares": 47,
    "ntd_at_risk": 39998.7,
    "position_cost": 606646.95,
    "constraint": "WEIGHT",
    "atr14": 1.05,
    "low_20d": 29.5,
    "ladder_minus1_pullback": 29.9,
    "ladder_4_base": 28.7,
    "ladder_5_euphoria": 41.4
  },
  {
    "symbol": "3018.TW",
    "name": "隆銘綠能",
    "sector": "其他電子業",
    "close": 10.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.95,
    "dog_ma200_bias": 0.044,
    "vr60": 2.0,
    "rs20": 0.88,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 267500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.9,
    "ladder_minus1_pullback": 10.1,
    "ladder_4_base": 9.6,
    "ladder_5_euphoria": 13.9
  },
  {
    "symbol": "3684.TWO",
    "name": "榮昌",
    "sector": "通信網路業",
    "close": 55.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": -0.193,
    "vr60": 0.8,
    "rs20": 0.44,
    "rs60": 0.4,
    "shares": 7633,
    "lots": 7,
    "odd_shares": 633,
    "ntd_at_risk": 19998.46,
    "position_cost": 423631.5,
    "constraint": "WEIGHT",
    "atr14": 1.31,
    "low_20d": 52.5,
    "ladder_minus1_pullback": 52.2,
    "ladder_4_base": 50.0,
    "ladder_5_euphoria": 72.2
  },
  {
    "symbol": "5201.TWO",
    "name": "凱衛",
    "sector": "資訊服務業",
    "close": 27.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": 0.044,
    "vr60": 1.41,
    "rs20": 0.98,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 681250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.7,
    "ladder_minus1_pullback": 25.6,
    "ladder_4_base": 24.5,
    "ladder_5_euphoria": 35.4
  },
  {
    "symbol": "6577.TWO",
    "name": "勁豐",
    "sector": "電腦及週邊設備業",
    "close": 79.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.06,
    "dog_ma200_bias": 0.003,
    "vr60": 1.75,
    "rs20": 1.11,
    "rs60": 0.81,
    "shares": 7905,
    "lots": 7,
    "odd_shares": 905,
    "ntd_at_risk": 39999.3,
    "position_cost": 629238.0,
    "constraint": "WEIGHT",
    "atr14": 2.53,
    "low_20d": 75.7,
    "ladder_minus1_pullback": 74.8,
    "ladder_4_base": 71.6,
    "ladder_5_euphoria": 103.5
  },
  {
    "symbol": "8940.TW",
    "name": "新天地",
    "sector": "觀光餐旅",
    "close": 14.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.11,
    "dog_ma200_bias": 0.054,
    "vr60": 1.88,
    "rs20": 1.0,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 371250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 14.1,
    "ladder_minus1_pullback": 14.0,
    "ladder_4_base": 13.4,
    "ladder_5_euphoria": 19.3
  },
  {
    "symbol": "3095.TWO",
    "name": "及成",
    "sector": "通信網路業",
    "close": 32.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.05,
    "dog_ma200_bias": -0.213,
    "vr60": 0.78,
    "rs20": 0.26,
    "rs60": 0.26,
    "shares": 9803,
    "lots": 9,
    "odd_shares": 803,
    "ntd_at_risk": 19998.12,
    "position_cost": 318597.5,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 30.8,
    "ladder_minus1_pullback": 30.5,
    "ladder_4_base": 29.2,
    "ladder_5_euphoria": 42.2
  },
  {
    "symbol": "5015.TWO",
    "name": "華祺",
    "sector": "鋼鐵工業",
    "close": 22.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.69,
    "cpr": 0.95,
    "dog_ma200_bias": 0.072,
    "vr60": 1.74,
    "rs20": 1.13,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 555000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.2,
    "ladder_minus1_pullback": 20.9,
    "ladder_4_base": 20.0,
    "ladder_5_euphoria": 28.9
  },
  {
    "symbol": "5548.TWO",
    "name": "安倉",
    "sector": "建材營造業",
    "close": 19.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.5,
    "dog_ma200_bias": 0.013,
    "vr60": 1.45,
    "rs20": 1.01,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 498750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.8,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 25.9
  },
  {
    "symbol": "3679.TW",
    "name": "新至陞",
    "sector": "電子零組件業",
    "close": 108.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.5,
    "dog_ma200_bias": 0.032,
    "vr60": 2.08,
    "rs20": 1.01,
    "rs60": 0.8,
    "shares": 10869,
    "lots": 10,
    "odd_shares": 869,
    "ntd_at_risk": 39997.92,
    "position_cost": 1179286.5,
    "constraint": "WEIGHT",
    "atr14": 1.84,
    "low_20d": 98.7,
    "ladder_minus1_pullback": 102.0,
    "ladder_4_base": 97.7,
    "ladder_5_euphoria": 141.1
  },
  {
    "symbol": "4930.TW",
    "name": "燦星網",
    "sector": "電器電纜業",
    "close": 15.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.25,
    "dog_ma200_bias": 0.185,
    "vr60": 2.45,
    "rs20": 1.27,
    "rs60": 1.18,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 14.7,
    "ladder_minus1_pullback": 14.6,
    "ladder_4_base": 14.0,
    "ladder_5_euphoria": 20.2
  },
  {
    "symbol": "7803.TW",
    "name": "雲象科技-創",
    "sector": "生技醫療業",
    "close": 17.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.93,
    "dog_ma200_bias": 0.071,
    "vr60": 1.8,
    "rs20": 0.85,
    "rs60": 0.94,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 436250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.6,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.7,
    "ladder_5_euphoria": 22.7
  },
  {
    "symbol": "2939.TW",
    "name": "永邑-KY",
    "sector": "貿易百貨業",
    "close": 24.2,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.05,
    "dog_ma200_bias": -0.008,
    "vr60": 1.85,
    "rs20": 0.53,
    "rs60": 0.56,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 22.4,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.8,
    "ladder_5_euphoria": 31.5
  },
  {
    "symbol": "2729.TWO",
    "name": "瓦城",
    "sector": "觀光餐旅",
    "close": 154.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.2,
    "dog_ma200_bias": -0.199,
    "vr60": 0.9,
    "rs20": 0.32,
    "rs60": 0.42,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.5,
    "low_20d": 145.9,
    "ladder_minus1_pullback": 144.8,
    "ladder_4_base": 138.6,
    "ladder_5_euphoria": 200.2
  },
  {
    "symbol": "3205.TWO",
    "name": "佰研",
    "sector": "生技醫療業",
    "close": 46.0,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": -0.017,
    "vr60": 1.43,
    "rs20": 0.47,
    "rs60": 0.48,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 42.2,
    "ladder_minus1_pullback": 43.2,
    "ladder_4_base": 41.4,
    "ladder_5_euphoria": 59.8
  },
  {
    "symbol": "3285.TWO",
    "name": "微端",
    "sector": "其他電子業",
    "close": 41.8,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.5,
    "dog_ma200_bias": 0.346,
    "vr60": 2.53,
    "rs20": 1.23,
    "rs60": 1.13,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.24,
    "low_20d": 39.2,
    "ladder_minus1_pullback": 39.3,
    "ladder_4_base": 37.6,
    "ladder_5_euphoria": 54.3
  },
  {
    "symbol": "4126.TWO",
    "name": "太醫",
    "sector": "生技醫療業",
    "close": 77.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.33,
    "dog_ma200_bias": 0.097,
    "vr60": 1.48,
    "rs20": 1.05,
    "rs60": 0.97,
    "shares": 11494,
    "lots": 11,
    "odd_shares": 494,
    "ntd_at_risk": 39999.12,
    "position_cost": 886187.4,
    "constraint": "WEIGHT",
    "atr14": 1.74,
    "low_20d": 71.5,
    "ladder_minus1_pullback": 72.5,
    "ladder_4_base": 69.4,
    "ladder_5_euphoria": 100.2
  },
  {
    "symbol": "6276.TWO",
    "name": "安鈦克",
    "sector": "電腦及週邊設備業",
    "close": 18.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.35,
    "dog_ma200_bias": 0.005,
    "vr60": 1.46,
    "rs20": 0.93,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 460000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.1,
    "ladder_minus1_pullback": 17.3,
    "ladder_4_base": 16.6,
    "ladder_5_euphoria": 23.9
  },
  {
    "symbol": "6417.TWO",
    "name": "韋僑",
    "sector": "通信網路業",
    "close": 103.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.2,
    "dog_ma200_bias": 0.093,
    "vr60": 1.52,
    "rs20": 0.98,
    "rs60": 1.29,
    "shares": 7575,
    "lots": 7,
    "odd_shares": 575,
    "ntd_at_risk": 39996.0,
    "position_cost": 784012.5,
    "constraint": "WEIGHT",
    "atr14": 2.64,
    "low_20d": 97.4,
    "ladder_minus1_pullback": 97.3,
    "ladder_4_base": 93.2,
    "ladder_5_euphoria": 134.6
  },
  {
    "symbol": "6751.TWO",
    "name": "智聯服務",
    "sector": "資訊服務業",
    "close": 49.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.95,
    "dog_ma200_bias": 0.02,
    "vr60": 1.35,
    "rs20": 0.93,
    "rs60": 0.88,
    "shares": 14814,
    "lots": 14,
    "odd_shares": 814,
    "ntd_at_risk": 39997.8,
    "position_cost": 734774.4,
    "constraint": "WEIGHT",
    "atr14": 1.35,
    "low_20d": 45.1,
    "ladder_minus1_pullback": 46.6,
    "ladder_4_base": 44.6,
    "ladder_5_euphoria": 64.5
  },
  {
    "symbol": "6895.TWO",
    "name": "宏碩系統",
    "sector": "半導體業",
    "close": 147.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.45,
    "dog_ma200_bias": 0.053,
    "vr60": 1.88,
    "rs20": 1.08,
    "rs60": 0.98,
    "shares": 6042,
    "lots": 6,
    "odd_shares": 42,
    "ntd_at_risk": 39998.04,
    "position_cost": 891195.0,
    "constraint": "WEIGHT",
    "atr14": 3.31,
    "low_20d": 135.4,
    "ladder_minus1_pullback": 138.7,
    "ladder_4_base": 132.8,
    "ladder_5_euphoria": 191.8
  },
  {
    "symbol": "6183.TW",
    "name": "關貿",
    "sector": "資訊服務業",
    "close": 91.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.89,
    "dog_ma200_bias": -0.018,
    "vr60": 1.54,
    "rs20": 1.09,
    "rs60": 0.97,
    "shares": 7518,
    "lots": 7,
    "odd_shares": 518,
    "ntd_at_risk": 39995.76,
    "position_cost": 690904.2,
    "constraint": "WEIGHT",
    "atr14": 2.66,
    "low_20d": 86.1,
    "ladder_minus1_pullback": 86.4,
    "ladder_4_base": 82.7,
    "ladder_5_euphoria": 119.5
  },
  {
    "symbol": "9937.TW",
    "name": "全國",
    "sector": "油電燃氣業",
    "close": 55.1,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.71,
    "dog_ma200_bias": 0.364,
    "vr60": 2.2,
    "rs20": 1.2,
    "rs60": 1.35,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.05,
    "low_20d": 51.9,
    "ladder_minus1_pullback": 51.8,
    "ladder_4_base": 49.6,
    "ladder_5_euphoria": 71.6
  },
  {
    "symbol": "2596.TWO",
    "name": "綠意",
    "sector": "建材營造業",
    "close": 33.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.31,
    "dog_ma200_bias": 0.026,
    "vr60": 1.61,
    "rs20": 0.9,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 832500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 31.4,
    "ladder_minus1_pullback": 31.3,
    "ladder_4_base": 30.0,
    "ladder_5_euphoria": 43.3
  },
  {
    "symbol": "3272.TWO",
    "name": "東碩",
    "sector": "電腦及週邊設備業",
    "close": 13.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.95,
    "dog_ma200_bias": -0.013,
    "vr60": 1.32,
    "rs20": 0.94,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 347500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.0,
    "ladder_minus1_pullback": 13.1,
    "ladder_4_base": 12.5,
    "ladder_5_euphoria": 18.1
  },
  {
    "symbol": "4911.TWO",
    "name": "德英",
    "sector": "生技醫療業",
    "close": 27.2,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.95,
    "dog_ma200_bias": 0.083,
    "vr60": 1.06,
    "rs20": 1.15,
    "rs60": 1.19,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 591300.8,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 25.7,
    "ladder_minus1_pullback": 25.6,
    "ladder_4_base": 24.5,
    "ladder_5_euphoria": 35.4
  },
  {
    "symbol": "4995.TWO",
    "name": "晶達",
    "sector": "光電業",
    "close": 45.45,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.08,
    "dog_ma200_bias": 0.119,
    "vr60": 1.61,
    "rs20": 1.33,
    "rs60": 1.29,
    "shares": 18348,
    "lots": 18,
    "odd_shares": 348,
    "ntd_at_risk": 39998.64,
    "position_cost": 833916.6,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 41.5,
    "ladder_minus1_pullback": 42.7,
    "ladder_4_base": 40.9,
    "ladder_5_euphoria": 59.1
  },
  {
    "symbol": "6201.TW",
    "name": "亞弘電",
    "sector": "其他電子業",
    "close": 46.05,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.79,
    "dog_ma200_bias": -0.213,
    "vr60": 0.87,
    "rs20": 0.46,
    "rs60": 0.4,
    "shares": 9900,
    "lots": 9,
    "odd_shares": 900,
    "ntd_at_risk": 19998.0,
    "position_cost": 455895.0,
    "constraint": "WEIGHT",
    "atr14": 1.01,
    "low_20d": 43.2,
    "ladder_minus1_pullback": 43.3,
    "ladder_4_base": 41.4,
    "ladder_5_euphoria": 59.9
  },
  {
    "symbol": "1203.TW",
    "name": "味王",
    "sector": "食品工業",
    "close": 43.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.5,
    "dog_ma200_bias": -0.016,
    "vr60": 2.03,
    "rs20": 0.9,
    "rs60": 0.9,
    "shares": 15625,
    "lots": 15,
    "odd_shares": 625,
    "ntd_at_risk": 40000.0,
    "position_cost": 676562.5,
    "constraint": "WEIGHT",
    "atr14": 1.28,
    "low_20d": 39.2,
    "ladder_minus1_pullback": 40.7,
    "ladder_4_base": 39.0,
    "ladder_5_euphoria": 56.3
  },
  {
    "symbol": "6887.TW",
    "name": "寶綠特-KY",
    "sector": "綠能環保",
    "close": 34.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.39,
    "cpr": 0.24,
    "dog_ma200_bias": -0.001,
    "vr60": 1.59,
    "rs20": 0.85,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 867500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 32.8,
    "ladder_minus1_pullback": 32.6,
    "ladder_4_base": 31.2,
    "ladder_5_euphoria": 45.1
  },
  {
    "symbol": "1593.TWO",
    "name": "祺驊",
    "sector": "運動休閒",
    "close": 31.35,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.81,
    "dog_ma200_bias": 0.052,
    "vr60": 1.66,
    "rs20": 0.95,
    "rs60": 0.94,
    "shares": 18181,
    "lots": 18,
    "odd_shares": 181,
    "ntd_at_risk": 39998.2,
    "position_cost": 569974.35,
    "constraint": "WEIGHT",
    "atr14": 1.1,
    "low_20d": 29.2,
    "ladder_minus1_pullback": 29.5,
    "ladder_4_base": 28.2,
    "ladder_5_euphoria": 40.8
  },
  {
    "symbol": "4138.TWO",
    "name": "曜亞",
    "sector": "生技醫療業",
    "close": 53.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.2,
    "dog_ma200_bias": 0.05,
    "vr60": 1.79,
    "rs20": 1.12,
    "rs60": 0.96,
    "shares": 11560,
    "lots": 11,
    "odd_shares": 560,
    "ntd_at_risk": 39997.6,
    "position_cost": 623084.0,
    "constraint": "WEIGHT",
    "atr14": 1.73,
    "low_20d": 49.7,
    "ladder_minus1_pullback": 50.7,
    "ladder_4_base": 48.5,
    "ladder_5_euphoria": 70.1
  },
  {
    "symbol": "6859.TWO",
    "name": "伯特光",
    "sector": "光電業",
    "close": 115.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.29,
    "dog_ma200_bias": -0.166,
    "vr60": 0.61,
    "rs20": 0.58,
    "rs60": 0.57,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 3.6,
    "low_20d": 105.0,
    "ladder_minus1_pullback": 108.6,
    "ladder_4_base": 104.0,
    "ladder_5_euphoria": 150.2
  },
  {
    "symbol": "1817.TW",
    "name": "凱撒衛",
    "sector": "玻璃陶瓷業",
    "close": 39.8,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.6,
    "dog_ma200_bias": -0.105,
    "vr60": 0.84,
    "rs20": 0.53,
    "rs60": 0.44,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.89,
    "low_20d": 36.4,
    "ladder_minus1_pullback": 37.4,
    "ladder_4_base": 35.8,
    "ladder_5_euphoria": 51.7
  },
  {
    "symbol": "2901.TW",
    "name": "欣欣",
    "sector": "貿易百貨業",
    "close": 24.4,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.25,
    "dog_ma200_bias": 0.115,
    "vr60": 1.46,
    "rs20": 1.05,
    "rs60": 1.14,
    "shares": 24691,
    "lots": 24,
    "odd_shares": 691,
    "ntd_at_risk": 39999.42,
    "position_cost": 602460.4,
    "constraint": "WEIGHT",
    "atr14": 0.81,
    "low_20d": 23.3,
    "ladder_minus1_pullback": 22.9,
    "ladder_4_base": 22.0,
    "ladder_5_euphoria": 31.7
  },
  {
    "symbol": "6281.TW",
    "name": "全國電",
    "sector": "電子通路業",
    "close": 51.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.75,
    "dog_ma200_bias": 0.37,
    "vr60": 2.44,
    "rs20": 1.15,
    "rs60": 1.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.82,
    "low_20d": 48.7,
    "ladder_minus1_pullback": 47.9,
    "ladder_4_base": 45.9,
    "ladder_5_euphoria": 66.3
  },
  {
    "symbol": "3492.TWO",
    "name": "長盛",
    "sector": "電子零組件業",
    "close": 19.6,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.86,
    "dog_ma200_bias": -0.072,
    "vr60": 0.74,
    "rs20": 0.51,
    "rs60": 0.67,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 18.5,
    "ladder_minus1_pullback": 18.4,
    "ladder_4_base": 17.6,
    "ladder_5_euphoria": 25.5
  },
  {
    "symbol": "3512.TWO",
    "name": "皇龍",
    "sector": "建材營造業",
    "close": 18.9,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.95,
    "dog_ma200_bias": 0.284,
    "vr60": 1.79,
    "rs20": 1.3,
    "rs60": 1.39,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 17.1,
    "ladder_minus1_pullback": 17.8,
    "ladder_4_base": 17.0,
    "ladder_5_euphoria": 24.6
  },
  {
    "symbol": "4442.TWO",
    "name": "竣邦-KY",
    "sector": "紡織纖維業",
    "close": 54.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.67,
    "dog_ma200_bias": 0.01,
    "vr60": 2.07,
    "rs20": 1.01,
    "rs60": 0.83,
    "shares": 17094,
    "lots": 17,
    "odd_shares": 94,
    "ntd_at_risk": 39999.96,
    "position_cost": 938460.6,
    "constraint": "WEIGHT",
    "atr14": 1.17,
    "low_20d": 51.0,
    "ladder_minus1_pullback": 51.6,
    "ladder_4_base": 49.4,
    "ladder_5_euphoria": 71.4
  },
  {
    "symbol": "5489.TWO",
    "name": "彩富",
    "sector": "其他電子業",
    "close": 40.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.05,
    "dog_ma200_bias": 0.097,
    "vr60": 1.3,
    "rs20": 1.3,
    "rs60": 1.19,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1007500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 38.6,
    "ladder_minus1_pullback": 37.9,
    "ladder_4_base": 36.3,
    "ladder_5_euphoria": 52.4
  },
  {
    "symbol": "6616.TWO",
    "name": "特昇-KY",
    "sector": "居家生活",
    "close": 8.84,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.94,
    "dog_ma200_bias": -0.011,
    "vr60": 1.77,
    "rs20": 1.06,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 221000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.0,
    "ladder_minus1_pullback": 8.3,
    "ladder_4_base": 8.0,
    "ladder_5_euphoria": 11.5
  },
  {
    "symbol": "6968.TWO",
    "name": "萬達寵物",
    "sector": "居家生活",
    "close": 41.15,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.43,
    "dog_ma200_bias": 0.077,
    "vr60": 1.5,
    "rs20": 1.32,
    "rs60": 1.06,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1028750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 38.2,
    "ladder_minus1_pullback": 38.7,
    "ladder_4_base": 37.0,
    "ladder_5_euphoria": 53.5
  },
  {
    "symbol": "8906.TWO",
    "name": "花王",
    "sector": "其他業",
    "close": 28.15,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.95,
    "dog_ma200_bias": -0.049,
    "vr60": 2.19,
    "rs20": 0.69,
    "rs60": 0.45,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.93,
    "low_20d": 26.6,
    "ladder_minus1_pullback": 26.5,
    "ladder_4_base": 25.3,
    "ladder_5_euphoria": 36.6
  },
  {
    "symbol": "9944.TW",
    "name": "新麗",
    "sector": "其他業",
    "close": 17.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.95,
    "dog_ma200_bias": -0.155,
    "vr60": 0.89,
    "rs20": 0.46,
    "rs60": 0.45,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 218750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.1,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.8,
    "ladder_5_euphoria": 22.8
  },
  {
    "symbol": "8442.TW",
    "name": "威宏-KY",
    "sector": "其他業",
    "close": 48.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.25,
    "dog_ma200_bias": 0.017,
    "vr60": 1.83,
    "rs20": 0.83,
    "rs60": 0.76,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 1171065.6,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 44.3,
    "ladder_minus1_pullback": 45.7,
    "ladder_4_base": 43.7,
    "ladder_5_euphoria": 63.2
  },
  {
    "symbol": "7760.TW",
    "name": "享溫馨",
    "sector": "觀光餐旅",
    "close": 32.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.73,
    "dog_ma200_bias": 0.075,
    "vr60": 1.61,
    "rs20": 1.08,
    "rs60": 0.76,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 815000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.4,
    "ladder_minus1_pullback": 30.6,
    "ladder_4_base": 29.3,
    "ladder_5_euphoria": 42.4
  },
  {
    "symbol": "6955.TW",
    "name": "邦睿生技-創",
    "sector": "生技醫療業",
    "close": 91.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.76,
    "dog_ma200_bias": -0.014,
    "vr60": 1.36,
    "rs20": 1.05,
    "rs60": 0.79,
    "shares": 7407,
    "lots": 7,
    "odd_shares": 407,
    "ntd_at_risk": 39997.8,
    "position_cost": 679962.6,
    "constraint": "WEIGHT",
    "atr14": 2.7,
    "low_20d": 87.3,
    "ladder_minus1_pullback": 86.3,
    "ladder_4_base": 82.6,
    "ladder_5_euphoria": 119.3
  },
  {
    "symbol": "1541.TW",
    "name": "錩泰",
    "sector": "電機機械業",
    "close": 19.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.95,
    "dog_ma200_bias": 0.07,
    "vr60": 1.57,
    "rs20": 1.0,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 495000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.0,
    "ladder_minus1_pullback": 18.6,
    "ladder_4_base": 17.8,
    "ladder_5_euphoria": 25.7
  },
  {
    "symbol": "4163.TWO",
    "name": "鐿鈦",
    "sector": "生技醫療業",
    "close": 126.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.5,
    "dog_ma200_bias": 0.067,
    "vr60": 1.35,
    "rs20": 0.87,
    "rs60": 0.83,
    "shares": 5235,
    "lots": 5,
    "odd_shares": 235,
    "ntd_at_risk": 39995.4,
    "position_cost": 659610.0,
    "constraint": "WEIGHT",
    "atr14": 3.82,
    "low_20d": 117.1,
    "ladder_minus1_pullback": 118.4,
    "ladder_4_base": 113.4,
    "ladder_5_euphoria": 163.8
  },
  {
    "symbol": "5516.TWO",
    "name": "雙喜",
    "sector": "建材營造業",
    "close": 12.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.95,
    "dog_ma200_bias": 0.008,
    "vr60": 1.51,
    "rs20": 0.98,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 317500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.1,
    "ladder_minus1_pullback": 11.9,
    "ladder_4_base": 11.4,
    "ladder_5_euphoria": 16.5
  },
  {
    "symbol": "5701.TWO",
    "name": "劍湖山",
    "sector": "觀光餐旅",
    "close": 4.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.5,
    "dog_ma200_bias": 0.047,
    "vr60": 1.29,
    "rs20": 0.77,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 100000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 3.8,
    "ladder_minus1_pullback": 3.8,
    "ladder_4_base": 3.6,
    "ladder_5_euphoria": 5.2
  },
  {
    "symbol": "6160.TWO",
    "name": "欣技",
    "sector": "電腦及週邊設備業",
    "close": 13.8,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.29,
    "dog_ma200_bias": -0.279,
    "vr60": 0.91,
    "rs20": 0.6,
    "rs60": 0.22,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 172500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.6,
    "ladder_minus1_pullback": 13.0,
    "ladder_4_base": 12.4,
    "ladder_5_euphoria": 17.9
  },
  {
    "symbol": "6560.TWO",
    "name": "欣普羅",
    "sector": "光電業",
    "close": 31.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.24,
    "cpr": 0.56,
    "dog_ma200_bias": -0.019,
    "vr60": 1.74,
    "rs20": 1.14,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 793750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.0,
    "ladder_minus1_pullback": 29.8,
    "ladder_4_base": 28.6,
    "ladder_5_euphoria": 41.3
  },
  {
    "symbol": "7728.TWO",
    "name": "光焱科技",
    "sector": "其他電子業",
    "close": 603.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.89,
    "dog_ma200_bias": -0.07,
    "vr60": 0.77,
    "rs20": 0.42,
    "rs60": 0.5,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 10.37,
    "low_20d": 569.9,
    "ladder_minus1_pullback": 566.8,
    "ladder_4_base": 542.7,
    "ladder_5_euphoria": 783.9
  },
  {
    "symbol": "8107.TWO",
    "name": "大億金茂",
    "sector": "電機機械業",
    "close": 11.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.05,
    "dog_ma200_bias": 0.104,
    "vr60": 1.58,
    "rs20": 1.35,
    "rs60": 1.23,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 292500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.2,
    "ladder_minus1_pullback": 11.0,
    "ladder_4_base": 10.5,
    "ladder_5_euphoria": 15.2
  },
  {
    "symbol": "8933.TWO",
    "name": "愛地雅",
    "sector": "運動休閒",
    "close": 4.51,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.1,
    "dog_ma200_bias": 0.074,
    "vr60": 1.8,
    "rs20": 0.9,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 112750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 4.2,
    "ladder_minus1_pullback": 4.2,
    "ladder_4_base": 4.1,
    "ladder_5_euphoria": 5.9
  },
  {
    "symbol": "2702.TW",
    "name": "華園",
    "sector": "觀光餐旅",
    "close": 12.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.05,
    "dog_ma200_bias": 0.103,
    "vr60": 1.25,
    "rs20": 0.99,
    "rs60": 1.08,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 302500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.3,
    "ladder_minus1_pullback": 11.4,
    "ladder_4_base": 10.9,
    "ladder_5_euphoria": 15.7
  },
  {
    "symbol": "3308.TW",
    "name": "聯德",
    "sector": "電子零組件業",
    "close": 21.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.05,
    "dog_ma200_bias": 0.05,
    "vr60": 1.85,
    "rs20": 1.11,
    "rs60": 0.75,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 537500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.0,
    "ladder_minus1_pullback": 20.2,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 27.9
  },
  {
    "symbol": "4554.TWO",
    "name": "橙的",
    "sector": "其他電子業",
    "close": 27.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.4,
    "dog_ma200_bias": 0.04,
    "vr60": 1.98,
    "rs20": 0.86,
    "rs60": 0.94,
    "shares": 21739,
    "lots": 21,
    "odd_shares": 739,
    "ntd_at_risk": 39999.76,
    "position_cost": 589126.9,
    "constraint": "WEIGHT",
    "atr14": 0.92,
    "low_20d": 25.4,
    "ladder_minus1_pullback": 25.5,
    "ladder_4_base": 24.4,
    "ladder_5_euphoria": 35.2
  },
  {
    "symbol": "6103.TWO",
    "name": "合邦",
    "sector": "半導體業",
    "close": 36.65,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.18,
    "dog_ma200_bias": -0.133,
    "vr60": 0.82,
    "rs20": 0.45,
    "rs60": 0.42,
    "shares": 9259,
    "lots": 9,
    "odd_shares": 259,
    "ntd_at_risk": 19999.44,
    "position_cost": 339342.35,
    "constraint": "WEIGHT",
    "atr14": 1.08,
    "low_20d": 33.5,
    "ladder_minus1_pullback": 34.5,
    "ladder_4_base": 33.0,
    "ladder_5_euphoria": 47.6
  },
  {
    "symbol": "6171.TWO",
    "name": "大城地產",
    "sector": "建材營造業",
    "close": 23.5,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.3,
    "dog_ma200_bias": 0.263,
    "vr60": 1.79,
    "rs20": 1.5,
    "rs60": 1.44,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 22.0,
    "ladder_minus1_pullback": 22.1,
    "ladder_4_base": 21.2,
    "ladder_5_euphoria": 30.6
  },
  {
    "symbol": "6823.TWO",
    "name": "濾能",
    "sector": "半導體業",
    "close": 59.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.55,
    "dog_ma200_bias": -0.018,
    "vr60": 1.52,
    "rs20": 0.77,
    "rs60": 0.98,
    "shares": 13422,
    "lots": 13,
    "odd_shares": 422,
    "ntd_at_risk": 39997.56,
    "position_cost": 799951.2,
    "constraint": "WEIGHT",
    "atr14": 1.49,
    "low_20d": 54.3,
    "ladder_minus1_pullback": 56.0,
    "ladder_4_base": 53.6,
    "ladder_5_euphoria": 77.5
  },
  {
    "symbol": "9918.TW",
    "name": "欣天然",
    "sector": "油電燃氣業",
    "close": 43.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.5,
    "dog_ma200_bias": 0.013,
    "vr60": 1.6,
    "rs20": 0.99,
    "rs60": 0.84,
    "shares": 17241,
    "lots": 17,
    "odd_shares": 241,
    "ntd_at_risk": 39999.12,
    "position_cost": 742225.05,
    "constraint": "WEIGHT",
    "atr14": 1.16,
    "low_20d": 40.4,
    "ladder_minus1_pullback": 40.5,
    "ladder_4_base": 38.7,
    "ladder_5_euphoria": 56.0
  },
  {
    "symbol": "6464.TW",
    "name": "台數科",
    "sector": "其他業",
    "close": 76.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.4,
    "cpr": 0.33,
    "dog_ma200_bias": 0.041,
    "vr60": 1.27,
    "rs20": 0.92,
    "rs60": 1.03,
    "shares": 9615,
    "lots": 9,
    "odd_shares": 615,
    "ntd_at_risk": 39998.4,
    "position_cost": 737470.5,
    "constraint": "WEIGHT",
    "atr14": 2.08,
    "low_20d": 71.7,
    "ladder_minus1_pullback": 72.1,
    "ladder_4_base": 69.0,
    "ladder_5_euphoria": 99.7
  },
  {
    "symbol": "1236.TW",
    "name": "宏亞",
    "sector": "食品工業",
    "close": 25.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.56,
    "dog_ma200_bias": 0.073,
    "vr60": 2.09,
    "rs20": 1.09,
    "rs60": 1.02,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 637500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.0,
    "ladder_minus1_pullback": 24.0,
    "ladder_4_base": 22.9,
    "ladder_5_euphoria": 33.1
  },
  {
    "symbol": "4502.TWO",
    "name": "健信",
    "sector": "電機機械業",
    "close": 15.95,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.95,
    "dog_ma200_bias": -0.007,
    "vr60": 1.56,
    "rs20": 0.47,
    "rs60": 0.5,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 14.9,
    "ladder_minus1_pullback": 15.0,
    "ladder_4_base": 14.4,
    "ladder_5_euphoria": 20.7
  },
  {
    "symbol": "6794.TW",
    "name": "向榮生技",
    "sector": "生技醫療業",
    "close": 69.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.95,
    "dog_ma200_bias": 0.037,
    "vr60": 1.97,
    "rs20": 0.95,
    "rs60": 0.74,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 1116126.8,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 62.8,
    "ladder_minus1_pullback": 65.0,
    "ladder_4_base": 62.3,
    "ladder_5_euphoria": 90.0
  },
  {
    "symbol": "8101.TW",
    "name": "華冠",
    "sector": "通信網路業",
    "close": 9.62,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.4,
    "dog_ma200_bias": 0.06,
    "vr60": 1.47,
    "rs20": 1.02,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 240500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.9,
    "ladder_minus1_pullback": 9.0,
    "ladder_4_base": 8.7,
    "ladder_5_euphoria": 12.5
  },
  {
    "symbol": "6835.TW",
    "name": "圓裕",
    "sector": "電子零組件業",
    "close": 32.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.71,
    "dog_ma200_bias": 0.067,
    "vr60": 1.35,
    "rs20": 0.93,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 801250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 30.7,
    "ladder_minus1_pullback": 30.1,
    "ladder_4_base": 28.8,
    "ladder_5_euphoria": 41.7
  },
  {
    "symbol": "2066.TWO",
    "name": "世德",
    "sector": "電機機械業",
    "close": 52.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.4,
    "dog_ma200_bias": 0.046,
    "vr60": 1.42,
    "rs20": 0.83,
    "rs60": 0.96,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 841933.8,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 48.6,
    "ladder_minus1_pullback": 49.1,
    "ladder_4_base": 47.0,
    "ladder_5_euphoria": 67.9
  },
  {
    "symbol": "6158.TWO",
    "name": "禾昌",
    "sector": "電子零組件業",
    "close": 17.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.86,
    "dog_ma200_bias": 0.046,
    "vr60": 1.28,
    "rs20": 0.92,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 447500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.2,
    "ladder_minus1_pullback": 16.8,
    "ladder_4_base": 16.1,
    "ladder_5_euphoria": 23.3
  },
  {
    "symbol": "6612.TWO",
    "name": "奈米醫材",
    "sector": "生技醫療業",
    "close": 69.7,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.57,
    "dog_ma200_bias": 0.212,
    "vr60": 2.53,
    "rs20": 1.47,
    "rs60": 1.37,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.63,
    "low_20d": 66.7,
    "ladder_minus1_pullback": 65.5,
    "ladder_4_base": 62.7,
    "ladder_5_euphoria": 90.6
  },
  {
    "symbol": "6982.TWO",
    "name": "大井泵浦",
    "sector": "電機機械業",
    "close": 44.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.31,
    "dog_ma200_bias": 0.006,
    "vr60": 1.63,
    "rs20": 1.11,
    "rs60": 0.74,
    "shares": 13793,
    "lots": 13,
    "odd_shares": 793,
    "ntd_at_risk": 39999.7,
    "position_cost": 606892.0,
    "constraint": "WEIGHT",
    "atr14": 1.45,
    "low_20d": 39.8,
    "ladder_minus1_pullback": 41.4,
    "ladder_4_base": 39.6,
    "ladder_5_euphoria": 57.2
  },
  {
    "symbol": "6988.TW",
    "name": "威力暘-創",
    "sector": "汽車工業",
    "close": 12.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.71,
    "dog_ma200_bias": -0.006,
    "vr60": 1.68,
    "rs20": 1.04,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 317500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 11.8,
    "ladder_minus1_pullback": 11.9,
    "ladder_4_base": 11.4,
    "ladder_5_euphoria": 16.5
  },
  {
    "symbol": "1813.TWO",
    "name": "寶利徠",
    "sector": "生技醫療業",
    "close": 11.05,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.05,
    "dog_ma200_bias": -0.103,
    "vr60": 0.91,
    "rs20": 0.63,
    "rs60": 0.62,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 10.3,
    "ladder_minus1_pullback": 10.4,
    "ladder_4_base": 9.9,
    "ladder_5_euphoria": 14.4
  },
  {
    "symbol": "4767.TWO",
    "name": "誠泰科技",
    "sector": "化學工業",
    "close": 27.9,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.55,
    "dog_ma200_bias": 0.3,
    "vr60": 2.24,
    "rs20": 1.28,
    "rs60": 1.35,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 25.9,
    "ladder_minus1_pullback": 26.2,
    "ladder_4_base": 25.1,
    "ladder_5_euphoria": 36.3
  },
  {
    "symbol": "5903.TWO",
    "name": "全家",
    "sector": "居家生活",
    "close": 186.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.5,
    "dog_ma200_bias": 0.018,
    "vr60": 1.78,
    "rs20": 0.97,
    "rs60": 1.0,
    "shares": 3194,
    "lots": 3,
    "odd_shares": 194,
    "ntd_at_risk": 39988.88,
    "position_cost": 594084.0,
    "constraint": "WEIGHT",
    "atr14": 6.26,
    "low_20d": 168.9,
    "ladder_minus1_pullback": 174.8,
    "ladder_4_base": 167.4,
    "ladder_5_euphoria": 241.8
  },
  {
    "symbol": "6527.TWO",
    "name": "明達醫",
    "sector": "生技醫療業",
    "close": 72.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.05,
    "dog_ma200_bias": -0.087,
    "vr60": 0.68,
    "rs20": 0.34,
    "rs60": 0.38,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.6,
    "low_20d": 68.8,
    "ladder_minus1_pullback": 68.1,
    "ladder_4_base": 65.2,
    "ladder_5_euphoria": 94.2
  },
  {
    "symbol": "6791.TWO",
    "name": "虎門科技",
    "sector": "資訊服務業",
    "close": 97.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.95,
    "dog_ma200_bias": -0.011,
    "vr60": 1.87,
    "rs20": 1.12,
    "rs60": 0.96,
    "shares": 11235,
    "lots": 11,
    "odd_shares": 235,
    "ntd_at_risk": 39996.6,
    "position_cost": 1089795.0,
    "constraint": "WEIGHT",
    "atr14": 1.78,
    "low_20d": 87.3,
    "ladder_minus1_pullback": 91.2,
    "ladder_4_base": 87.3,
    "ladder_5_euphoria": 126.1
  },
  {
    "symbol": "6910.TWO",
    "name": "德鴻",
    "sector": "數位雲端",
    "close": 25.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.22,
    "dog_ma200_bias": -0.008,
    "vr60": 1.53,
    "rs20": 1.09,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 625000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.6,
    "ladder_minus1_pullback": 23.5,
    "ladder_4_base": 22.5,
    "ladder_5_euphoria": 32.5
  },
  {
    "symbol": "1413.TW",
    "name": "宏洲",
    "sector": "紡織纖維業",
    "close": 9.44,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.12,
    "cpr": 0.93,
    "dog_ma200_bias": 0.038,
    "vr60": 1.2,
    "rs20": 0.77,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 236000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 8.8,
    "ladder_minus1_pullback": 8.9,
    "ladder_4_base": 8.5,
    "ladder_5_euphoria": 12.3
  },
  {
    "symbol": "6792.TW",
    "name": "詠業",
    "sector": "通信網路業",
    "close": 59.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.63,
    "dog_ma200_bias": 0.162,
    "vr60": 1.64,
    "rs20": 1.08,
    "rs60": 1.05,
    "shares": 14492,
    "lots": 14,
    "odd_shares": 492,
    "ntd_at_risk": 39997.92,
    "position_cost": 865172.4,
    "constraint": "WEIGHT",
    "atr14": 1.38,
    "low_20d": 54.5,
    "ladder_minus1_pullback": 56.1,
    "ladder_4_base": 53.7,
    "ladder_5_euphoria": 77.6
  },
  {
    "symbol": "1781.TWO",
    "name": "合世",
    "sector": "生技醫療業",
    "close": 9.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.17,
    "dog_ma200_bias": 0.048,
    "vr60": 1.92,
    "rs20": 0.96,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 248750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.4,
    "ladder_minus1_pullback": 9.4,
    "ladder_4_base": 9.0,
    "ladder_5_euphoria": 12.9
  },
  {
    "symbol": "2640.TWO",
    "name": "大車隊",
    "sector": "數位雲端",
    "close": 157.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.002,
    "vr60": 1.56,
    "rs20": 0.97,
    "rs60": 0.86,
    "shares": 5025,
    "lots": 5,
    "odd_shares": 25,
    "ntd_at_risk": 39999.0,
    "position_cost": 788925.0,
    "constraint": "WEIGHT",
    "atr14": 3.98,
    "low_20d": 149.6,
    "ladder_minus1_pullback": 147.6,
    "ladder_4_base": 141.3,
    "ladder_5_euphoria": 204.1
  },
  {
    "symbol": "4304.TWO",
    "name": "勝昱",
    "sector": "塑膠工業",
    "close": 16.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.67,
    "dog_ma200_bias": 0.077,
    "vr60": 1.62,
    "rs20": 1.28,
    "rs60": 1.1,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 420000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.4,
    "ladder_minus1_pullback": 15.8,
    "ladder_4_base": 15.1,
    "ladder_5_euphoria": 21.8
  },
  {
    "symbol": "7715.TWO",
    "name": "裕山",
    "sector": "綠能環保",
    "close": 26.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": 0.026,
    "vr60": 1.74,
    "rs20": 0.81,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 656250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 24.1,
    "ladder_minus1_pullback": 24.7,
    "ladder_4_base": 23.6,
    "ladder_5_euphoria": 34.1
  },
  {
    "symbol": "7718.TWO",
    "name": "友鋮",
    "sector": "電機機械業",
    "close": 45.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.85,
    "cpr": 0.05,
    "dog_ma200_bias": 0.06,
    "vr60": 1.83,
    "rs20": 0.99,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 1146250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 41.4,
    "ladder_minus1_pullback": 43.1,
    "ladder_4_base": 41.3,
    "ladder_5_euphoria": 59.6
  },
  {
    "symbol": "1435.TW",
    "name": "中福",
    "sector": "其他業",
    "close": 20.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.05,
    "dog_ma200_bias": 0.179,
    "vr60": 1.12,
    "rs20": 1.35,
    "rs60": 1.18,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 500000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.4,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 26.0
  },
  {
    "symbol": "6671.TW",
    "name": "三能-KY",
    "sector": "居家生活",
    "close": 23.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.05,
    "dog_ma200_bias": 0.028,
    "vr60": 1.95,
    "rs20": 0.95,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 575000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.7,
    "ladder_minus1_pullback": 21.6,
    "ladder_4_base": 20.7,
    "ladder_5_euphoria": 29.9
  },
  {
    "symbol": "1240.TWO",
    "name": "茂生農經",
    "sector": "農業科技業",
    "close": 54.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.17,
    "dog_ma200_bias": 0.018,
    "vr60": 2.08,
    "rs20": 0.88,
    "rs60": 0.99,
    "shares": 11111,
    "lots": 11,
    "odd_shares": 111,
    "ntd_at_risk": 39999.6,
    "position_cost": 599994.0,
    "constraint": "WEIGHT",
    "atr14": 1.8,
    "low_20d": 51.5,
    "ladder_minus1_pullback": 50.8,
    "ladder_4_base": 48.6,
    "ladder_5_euphoria": 70.2
  },
  {
    "symbol": "6210.TWO",
    "name": "慶生",
    "sector": "電子零組件業",
    "close": 18.65,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.64,
    "dog_ma200_bias": -0.242,
    "vr60": 0.98,
    "rs20": 0.52,
    "rs60": 0.44,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 233125.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.9,
    "ladder_minus1_pullback": 17.5,
    "ladder_4_base": 16.8,
    "ladder_5_euphoria": 24.2
  },
  {
    "symbol": "8272.TWO",
    "name": "全景軟體",
    "sector": "資訊服務業",
    "close": 61.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.25,
    "dog_ma200_bias": 0.067,
    "vr60": 1.36,
    "rs20": 0.95,
    "rs60": 0.84,
    "shares": 9523,
    "lots": 9,
    "odd_shares": 523,
    "ntd_at_risk": 39996.6,
    "position_cost": 586616.8,
    "constraint": "WEIGHT",
    "atr14": 2.1,
    "low_20d": 58.4,
    "ladder_minus1_pullback": 57.9,
    "ladder_4_base": 55.4,
    "ladder_5_euphoria": 80.1
  },
  {
    "symbol": "8935.TWO",
    "name": "邦泰",
    "sector": "其他業",
    "close": 18.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.22,
    "cpr": 0.95,
    "dog_ma200_bias": 0.078,
    "vr60": 1.79,
    "rs20": 1.09,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 460000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.8,
    "ladder_minus1_pullback": 17.3,
    "ladder_4_base": 16.6,
    "ladder_5_euphoria": 23.9
  },
  {
    "symbol": "8499.TW",
    "name": "鼎炫-KY",
    "sector": "其他電子業",
    "close": 240.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.47,
    "dog_ma200_bias": 0.035,
    "vr60": 1.5,
    "rs20": 1.02,
    "rs60": 1.05,
    "shares": 3205,
    "lots": 3,
    "odd_shares": 205,
    "ntd_at_risk": 39998.4,
    "position_cost": 770802.5,
    "constraint": "WEIGHT",
    "atr14": 6.24,
    "low_20d": 227.2,
    "ladder_minus1_pullback": 226.1,
    "ladder_4_base": 216.5,
    "ladder_5_euphoria": 312.7
  },
  {
    "symbol": "1583.TW",
    "name": "程泰",
    "sector": "電機機械業",
    "close": 48.2,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.79,
    "cpr": 0.11,
    "dog_ma200_bias": -0.004,
    "vr60": 1.65,
    "rs20": 0.58,
    "rs60": 0.55,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 46.1,
    "ladder_minus1_pullback": 45.3,
    "ladder_4_base": 43.4,
    "ladder_5_euphoria": 62.7
  },
  {
    "symbol": "7736.TW",
    "name": "虎山",
    "sector": "汽車工業",
    "close": 68.5,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.05,
    "dog_ma200_bias": -0.173,
    "vr60": 0.9,
    "rs20": 0.44,
    "rs60": 0.4,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.39,
    "low_20d": 63.8,
    "ladder_minus1_pullback": 64.4,
    "ladder_4_base": 61.6,
    "ladder_5_euphoria": 89.0
  },
  {
    "symbol": "3465.TWO",
    "name": "進泰電子",
    "sector": "其他電子業",
    "close": 27.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.84,
    "cpr": 0.05,
    "dog_ma200_bias": 0.055,
    "vr60": 1.72,
    "rs20": 1.07,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 692500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.0,
    "ladder_minus1_pullback": 26.0,
    "ladder_4_base": 24.9,
    "ladder_5_euphoria": 36.0
  },
  {
    "symbol": "4527.TWO",
    "name": "方土霖",
    "sector": "電機機械業",
    "close": 44.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.95,
    "dog_ma200_bias": -0.152,
    "vr60": 0.86,
    "rs20": 0.27,
    "rs60": 0.23,
    "shares": 8928,
    "lots": 8,
    "odd_shares": 928,
    "ntd_at_risk": 19998.72,
    "position_cost": 400867.2,
    "constraint": "WEIGHT",
    "atr14": 1.12,
    "low_20d": 42.9,
    "ladder_minus1_pullback": 42.2,
    "ladder_4_base": 40.4,
    "ladder_5_euphoria": 58.4
  },
  {
    "symbol": "4745.TWO",
    "name": "合富-KY",
    "sector": "生技醫療業",
    "close": 11.95,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.75,
    "dog_ma200_bias": 0.238,
    "vr60": 1.74,
    "rs20": 1.23,
    "rs60": 1.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 11.0,
    "ladder_minus1_pullback": 11.2,
    "ladder_4_base": 10.8,
    "ladder_5_euphoria": 15.5
  },
  {
    "symbol": "6721.TWO",
    "name": "信實",
    "sector": "其他業",
    "close": 48.0,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.75,
    "dog_ma200_bias": 0.182,
    "vr60": 2.33,
    "rs20": 1.35,
    "rs60": 1.34,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.54,
    "low_20d": 43.3,
    "ladder_minus1_pullback": 45.1,
    "ladder_4_base": 43.2,
    "ladder_5_euphoria": 62.4
  },
  {
    "symbol": "8487.TW",
    "name": "愛爾達-創",
    "sector": "數位雲端",
    "close": 68.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.75,
    "cpr": 0.15,
    "dog_ma200_bias": -0.005,
    "vr60": 2.06,
    "rs20": 0.92,
    "rs60": 0.99,
    "shares": 11111,
    "lots": 11,
    "odd_shares": 111,
    "ntd_at_risk": 39999.6,
    "position_cost": 763325.7,
    "constraint": "WEIGHT",
    "atr14": 1.8,
    "low_20d": 62.3,
    "ladder_minus1_pullback": 64.6,
    "ladder_4_base": 61.8,
    "ladder_5_euphoria": 89.3
  },
  {
    "symbol": "2712.TW",
    "name": "遠雄來",
    "sector": "觀光餐旅",
    "close": 13.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.86,
    "dog_ma200_bias": 0.171,
    "vr60": 1.11,
    "rs20": 1.34,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 332500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.2,
    "ladder_minus1_pullback": 12.5,
    "ladder_4_base": 12.0,
    "ladder_5_euphoria": 17.3
  },
  {
    "symbol": "9926.TW",
    "name": "新海",
    "sector": "油電燃氣業",
    "close": 49.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.57,
    "cpr": 0.5,
    "dog_ma200_bias": -0.015,
    "vr60": 2.08,
    "rs20": 1.01,
    "rs60": 0.91,
    "shares": 14388,
    "lots": 14,
    "odd_shares": 388,
    "ntd_at_risk": 39998.64,
    "position_cost": 705012.0,
    "constraint": "WEIGHT",
    "atr14": 1.39,
    "low_20d": 44.6,
    "ladder_minus1_pullback": 46.1,
    "ladder_4_base": 44.1,
    "ladder_5_euphoria": 63.7
  },
  {
    "symbol": "1788.TWO",
    "name": "杏昌",
    "sector": "生技醫療業",
    "close": 128.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.72,
    "cpr": 0.5,
    "dog_ma200_bias": 0.077,
    "vr60": 1.76,
    "rs20": 0.91,
    "rs60": 0.71,
    "shares": 5449,
    "lots": 5,
    "odd_shares": 449,
    "ntd_at_risk": 39995.66,
    "position_cost": 697472.0,
    "constraint": "WEIGHT",
    "atr14": 3.67,
    "low_20d": 116.7,
    "ladder_minus1_pullback": 120.3,
    "ladder_4_base": 115.2,
    "ladder_5_euphoria": 166.4
  },
  {
    "symbol": "2065.TWO",
    "name": "世豐",
    "sector": "鋼鐵工業",
    "close": 35.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.5,
    "dog_ma200_bias": 0.089,
    "vr60": 1.34,
    "rs20": 1.23,
    "rs60": 1.28,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 890000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 32.4,
    "ladder_minus1_pullback": 33.5,
    "ladder_4_base": 32.0,
    "ladder_5_euphoria": 46.3
  },
  {
    "symbol": "2432.TW",
    "name": "倚天酷碁-創",
    "sector": "電腦及週邊設備業",
    "close": 28.3,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.95,
    "dog_ma200_bias": 0.138,
    "vr60": 1.28,
    "rs20": 1.23,
    "rs60": 1.22,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 707500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.6,
    "ladder_minus1_pullback": 26.6,
    "ladder_4_base": 25.5,
    "ladder_5_euphoria": 36.8
  },
  {
    "symbol": "3672.TWO",
    "name": "康聯訊",
    "sector": "通信網路業",
    "close": 11.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.14,
    "cpr": 0.95,
    "dog_ma200_bias": 0.046,
    "vr60": 1.9,
    "rs20": 1.1,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 292500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.5,
    "ladder_minus1_pullback": 11.0,
    "ladder_4_base": 10.5,
    "ladder_5_euphoria": 15.2
  },
  {
    "symbol": "4102.TWO",
    "name": "永日",
    "sector": "生技醫療業",
    "close": 18.75,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.5,
    "dog_ma200_bias": 0.008,
    "vr60": 1.79,
    "rs20": 0.9,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 468750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.1,
    "ladder_minus1_pullback": 17.6,
    "ladder_4_base": 16.9,
    "ladder_5_euphoria": 24.4
  },
  {
    "symbol": "4433.TWO",
    "name": "興采",
    "sector": "紡織纖維業",
    "close": 17.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.78,
    "cpr": 0.5,
    "dog_ma200_bias": -0.012,
    "vr60": 1.64,
    "rs20": 1.02,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 442500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.4,
    "ladder_minus1_pullback": 16.6,
    "ladder_4_base": 15.9,
    "ladder_5_euphoria": 23.0
  },
  {
    "symbol": "4747.TWO",
    "name": "強生*",
    "sector": "生技醫療業",
    "close": 23.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.47,
    "cpr": 0.95,
    "dog_ma200_bias": -0.018,
    "vr60": 1.72,
    "rs20": 0.98,
    "rs60": 0.8,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 580000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.9,
    "ladder_minus1_pullback": 21.8,
    "ladder_4_base": 20.9,
    "ladder_5_euphoria": 30.2
  },
  {
    "symbol": "5312.TWO",
    "name": "寶島科",
    "sector": "生技醫療業",
    "close": 90.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.95,
    "dog_ma200_bias": -0.096,
    "vr60": 0.88,
    "rs20": 0.36,
    "rs60": 0.52,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.63,
    "low_20d": 85.9,
    "ladder_minus1_pullback": 84.6,
    "ladder_4_base": 81.0,
    "ladder_5_euphoria": 117.0
  },
  {
    "symbol": "6754.TW",
    "name": "匯僑設計",
    "sector": "居家生活",
    "close": 40.75,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.14,
    "dog_ma200_bias": 0.137,
    "vr60": 1.31,
    "rs20": 1.18,
    "rs60": 0.94,
    "shares": 21978,
    "lots": 21,
    "odd_shares": 978,
    "ntd_at_risk": 39999.96,
    "position_cost": 895603.5,
    "constraint": "WEIGHT",
    "atr14": 0.91,
    "low_20d": 37.3,
    "ladder_minus1_pullback": 38.3,
    "ladder_4_base": 36.7,
    "ladder_5_euphoria": 53.0
  },
  {
    "symbol": "6961.TWO",
    "name": "旅天下",
    "sector": "觀光餐旅",
    "close": 45.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.05,
    "dog_ma200_bias": -0.014,
    "vr60": 2.02,
    "rs20": 1.07,
    "rs60": 0.76,
    "shares": 20408,
    "lots": 20,
    "odd_shares": 408,
    "ntd_at_risk": 39999.68,
    "position_cost": 924482.4,
    "constraint": "WEIGHT",
    "atr14": 0.98,
    "low_20d": 43.3,
    "ladder_minus1_pullback": 42.6,
    "ladder_4_base": 40.8,
    "ladder_5_euphoria": 58.9
  },
  {
    "symbol": "8279.TWO",
    "name": "生展",
    "sector": "生技醫療業",
    "close": 80.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.15,
    "cpr": 0.95,
    "dog_ma200_bias": 0.061,
    "vr60": 1.22,
    "rs20": 0.97,
    "rs60": 0.89,
    "shares": 10050,
    "lots": 10,
    "odd_shares": 50,
    "ntd_at_risk": 39999.0,
    "position_cost": 813045.0,
    "constraint": "WEIGHT",
    "atr14": 1.99,
    "low_20d": 73.2,
    "ladder_minus1_pullback": 76.0,
    "ladder_4_base": 72.8,
    "ladder_5_euphoria": 105.2
  },
  {
    "symbol": "8450.TWO",
    "name": "霹靂",
    "sector": "文化創意業",
    "close": 14.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.45,
    "cpr": 0.8,
    "dog_ma200_bias": 0.157,
    "vr60": 1.34,
    "rs20": 1.16,
    "rs60": 1.13,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 350000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.7,
    "ladder_minus1_pullback": 13.2,
    "ladder_4_base": 12.6,
    "ladder_5_euphoria": 18.2
  },
  {
    "symbol": "8477.TWO",
    "name": "創業家",
    "sector": "數位雲端",
    "close": 13.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.95,
    "dog_ma200_bias": 0.146,
    "vr60": 1.52,
    "rs20": 1.0,
    "rs60": 1.2,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 346250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.2,
    "ladder_minus1_pullback": 13.0,
    "ladder_4_base": 12.5,
    "ladder_5_euphoria": 18.0
  },
  {
    "symbol": "8928.TWO",
    "name": "鉅明",
    "sector": "運動休閒",
    "close": 21.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.83,
    "dog_ma200_bias": 0.077,
    "vr60": 2.01,
    "rs20": 0.82,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 538750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.5,
    "ladder_minus1_pullback": 20.3,
    "ladder_4_base": 19.4,
    "ladder_5_euphoria": 28.0
  },
  {
    "symbol": "1439.TW",
    "name": "雋揚",
    "sector": "建材營造業",
    "close": 28.95,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.95,
    "dog_ma200_bias": 0.082,
    "vr60": 1.38,
    "rs20": 1.27,
    "rs60": 0.95,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 723750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 26.3,
    "ladder_minus1_pullback": 27.2,
    "ladder_4_base": 26.1,
    "ladder_5_euphoria": 37.6
  },
  {
    "symbol": "6614.TW",
    "name": "資拓宏宇",
    "sector": "數位雲端",
    "close": 35.15,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.05,
    "dog_ma200_bias": 0.075,
    "vr60": 1.17,
    "rs20": 1.01,
    "rs60": 1.12,
    "shares": 16666,
    "lots": 16,
    "odd_shares": 666,
    "ntd_at_risk": 39998.4,
    "position_cost": 585809.9,
    "constraint": "WEIGHT",
    "atr14": 1.2,
    "low_20d": 32.5,
    "ladder_minus1_pullback": 33.0,
    "ladder_4_base": 31.6,
    "ladder_5_euphoria": 45.7
  },
  {
    "symbol": "4148.TW",
    "name": "全宇生技-KY",
    "sector": "生技醫療業",
    "close": 31.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.5,
    "dog_ma200_bias": 0.162,
    "vr60": 1.07,
    "rs20": 1.34,
    "rs60": 1.1,
    "shares": 19607,
    "lots": 19,
    "odd_shares": 607,
    "ntd_at_risk": 39998.28,
    "position_cost": 623502.6,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 30.0,
    "ladder_minus1_pullback": 29.9,
    "ladder_4_base": 28.6,
    "ladder_5_euphoria": 41.3
  },
  {
    "symbol": "6722.TW",
    "name": "輝創",
    "sector": "其他電子業",
    "close": 32.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.57,
    "dog_ma200_bias": 0.016,
    "vr60": 1.69,
    "rs20": 0.92,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 822500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 31.3,
    "ladder_minus1_pullback": 30.9,
    "ladder_4_base": 29.6,
    "ladder_5_euphoria": 42.8
  },
  {
    "symbol": "1264.TWO",
    "name": "德麥",
    "sector": "食品工業",
    "close": 246.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.43,
    "dog_ma200_bias": 0.06,
    "vr60": 1.23,
    "rs20": 1.33,
    "rs60": 1.11,
    "shares": 3610,
    "lots": 3,
    "odd_shares": 610,
    "ntd_at_risk": 39998.8,
    "position_cost": 888060.0,
    "constraint": "WEIGHT",
    "atr14": 5.54,
    "low_20d": 234.9,
    "ladder_minus1_pullback": 231.2,
    "ladder_4_base": 221.4,
    "ladder_5_euphoria": 319.8
  },
  {
    "symbol": "2718.TWO",
    "name": "全心投控",
    "sector": "建材營造業",
    "close": 39.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.6,
    "dog_ma200_bias": 0.058,
    "vr60": 1.79,
    "rs20": 0.93,
    "rs60": 0.9,
    "shares": 16393,
    "lots": 16,
    "odd_shares": 393,
    "ntd_at_risk": 39998.92,
    "position_cost": 645884.2,
    "constraint": "WEIGHT",
    "atr14": 1.22,
    "low_20d": 37.8,
    "ladder_minus1_pullback": 37.0,
    "ladder_4_base": 35.5,
    "ladder_5_euphoria": 51.2
  },
  {
    "symbol": "3310.TWO",
    "name": "佳穎",
    "sector": "電子零組件業",
    "close": 68.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.56,
    "dog_ma200_bias": 0.05,
    "vr60": 1.67,
    "rs20": 1.14,
    "rs60": 0.82,
    "shares": 11834,
    "lots": 11,
    "odd_shares": 834,
    "ntd_at_risk": 39998.92,
    "position_cost": 804712.0,
    "constraint": "WEIGHT",
    "atr14": 1.69,
    "low_20d": 64.9,
    "ladder_minus1_pullback": 63.9,
    "ladder_4_base": 61.2,
    "ladder_5_euphoria": 88.4
  },
  {
    "symbol": "5878.TWO",
    "name": "台名",
    "sector": "金融保險業",
    "close": 37.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.05,
    "dog_ma200_bias": 0.034,
    "vr60": 1.39,
    "rs20": 0.79,
    "rs60": 0.99,
    "shares": 17391,
    "lots": 17,
    "odd_shares": 391,
    "ntd_at_risk": 39999.3,
    "position_cost": 643467.0,
    "constraint": "WEIGHT",
    "atr14": 1.15,
    "low_20d": 34.1,
    "ladder_minus1_pullback": 34.8,
    "ladder_4_base": 33.3,
    "ladder_5_euphoria": 48.1
  },
  {
    "symbol": "6637.TWO",
    "name": "醫影",
    "sector": "生技醫療業",
    "close": 54.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.4,
    "dog_ma200_bias": 0.004,
    "vr60": 1.37,
    "rs20": 0.87,
    "rs60": 0.99,
    "shares": 24390,
    "lots": 24,
    "odd_shares": 390,
    "ntd_at_risk": 39999.6,
    "position_cost": 1326816.0,
    "constraint": "WEIGHT",
    "atr14": 0.82,
    "low_20d": 51.6,
    "ladder_minus1_pullback": 51.1,
    "ladder_4_base": 49.0,
    "ladder_5_euphoria": 70.7
  },
  {
    "symbol": "8435.TWO",
    "name": "鉅邁",
    "sector": "其他業",
    "close": 53.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.95,
    "dog_ma200_bias": 0.076,
    "vr60": 1.74,
    "rs20": 0.84,
    "rs60": 0.83,
    "shares": 10869,
    "lots": 10,
    "odd_shares": 869,
    "ntd_at_risk": 39997.92,
    "position_cost": 576057.0,
    "constraint": "WEIGHT",
    "atr14": 1.84,
    "low_20d": 49.7,
    "ladder_minus1_pullback": 49.8,
    "ladder_4_base": 47.7,
    "ladder_5_euphoria": 68.9
  },
  {
    "symbol": "9962.TWO",
    "name": "有益",
    "sector": "鋼鐵工業",
    "close": 10.15,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.67,
    "dog_ma200_bias": 0.075,
    "vr60": 1.42,
    "rs20": 0.98,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 253750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.5,
    "ladder_minus1_pullback": 9.5,
    "ladder_4_base": 9.1,
    "ladder_5_euphoria": 13.2
  },
  {
    "symbol": "2008.TW",
    "name": "高興昌",
    "sector": "鋼鐵工業",
    "close": 30.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.36,
    "cpr": 0.44,
    "dog_ma200_bias": 0.018,
    "vr60": 2.01,
    "rs20": 0.91,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 770000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.9,
    "ladder_minus1_pullback": 29.0,
    "ladder_4_base": 27.7,
    "ladder_5_euphoria": 40.0
  },
  {
    "symbol": "1423.TW",
    "name": "利華",
    "sector": "紡織纖維業",
    "close": 36.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.61,
    "dog_ma200_bias": -0.164,
    "vr60": 0.75,
    "rs20": 0.54,
    "rs60": 0.54,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 33.3,
    "ladder_minus1_pullback": 33.8,
    "ladder_4_base": 32.4,
    "ladder_5_euphoria": 46.8
  },
  {
    "symbol": "1570.TWO",
    "name": "力肯",
    "sector": "電機機械業",
    "close": 32.45,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.95,
    "dog_ma200_bias": -0.19,
    "vr60": 0.86,
    "rs20": 0.65,
    "rs60": 0.59,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.89,
    "low_20d": 29.6,
    "ladder_minus1_pullback": 30.5,
    "ladder_4_base": 29.2,
    "ladder_5_euphoria": 42.2
  },
  {
    "symbol": "3516.TWO",
    "name": "亞帝歐",
    "sector": "光電業",
    "close": 25.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.05,
    "dog_ma200_bias": -0.001,
    "vr60": 1.53,
    "rs20": 1.01,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 628750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.6,
    "ladder_minus1_pullback": 23.6,
    "ladder_4_base": 22.6,
    "ladder_5_euphoria": 32.7
  },
  {
    "symbol": "4432.TWO",
    "name": "銘旺實",
    "sector": "紡織纖維業",
    "close": 15.35,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.6,
    "dog_ma200_bias": -0.115,
    "vr60": 0.75,
    "rs20": 0.35,
    "rs60": 0.7,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 14.2,
    "ladder_minus1_pullback": 14.4,
    "ladder_4_base": 13.8,
    "ladder_5_euphoria": 20.0
  },
  {
    "symbol": "6195.TWO",
    "name": "詩肯",
    "sector": "居家生活",
    "close": 27.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.33,
    "cpr": 0.05,
    "dog_ma200_bias": 0.023,
    "vr60": 1.22,
    "rs20": 0.99,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 695000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.3,
    "ladder_minus1_pullback": 26.1,
    "ladder_4_base": 25.0,
    "ladder_5_euphoria": 36.1
  },
  {
    "symbol": "7814.TWO",
    "name": "海昌生技",
    "sector": "生技醫療業",
    "close": 27.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.05,
    "dog_ma200_bias": -0.008,
    "vr60": 1.3,
    "rs20": 0.97,
    "rs60": 0.72,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 697500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 25.8,
    "ladder_minus1_pullback": 26.2,
    "ladder_4_base": 25.1,
    "ladder_5_euphoria": 36.3
  },
  {
    "symbol": "1626.TW",
    "name": "艾美特-KY",
    "sector": "電器電纜業",
    "close": 9.75,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.85,
    "dog_ma200_bias": 0.308,
    "vr60": 1.96,
    "rs20": 1.27,
    "rs60": 1.2,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 9.2,
    "ladder_4_base": 8.8,
    "ladder_5_euphoria": 12.7
  },
  {
    "symbol": "6581.TW",
    "name": "鋼聯",
    "sector": "綠能環保",
    "close": 108.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.5,
    "dog_ma200_bias": 0.003,
    "vr60": 1.21,
    "rs20": 0.9,
    "rs60": 1.04,
    "shares": 6802,
    "lots": 6,
    "odd_shares": 802,
    "ntd_at_risk": 39995.76,
    "position_cost": 738017.0,
    "constraint": "WEIGHT",
    "atr14": 2.94,
    "low_20d": 99.7,
    "ladder_minus1_pullback": 102.0,
    "ladder_4_base": 97.7,
    "ladder_5_euphoria": 141.1
  },
  {
    "symbol": "8367.TW",
    "name": "建新國際",
    "sector": "航運業",
    "close": 41.45,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.66,
    "cpr": 0.67,
    "dog_ma200_bias": 0.105,
    "vr60": 1.11,
    "rs20": 1.32,
    "rs60": 0.97,
    "shares": 15037,
    "lots": 15,
    "odd_shares": 37,
    "ntd_at_risk": 39998.42,
    "position_cost": 623283.65,
    "constraint": "WEIGHT",
    "atr14": 1.33,
    "low_20d": 38.1,
    "ladder_minus1_pullback": 39.0,
    "ladder_4_base": 37.3,
    "ladder_5_euphoria": 53.9
  },
  {
    "symbol": "3164.TW",
    "name": "景岳",
    "sector": "生技醫療業",
    "close": 16.95,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.95,
    "dog_ma200_bias": -0.149,
    "vr60": 0.79,
    "rs20": 0.53,
    "rs60": 0.36,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 211875.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 15.9,
    "ladder_minus1_pullback": 15.9,
    "ladder_4_base": 15.3,
    "ladder_5_euphoria": 22.0
  },
  {
    "symbol": "1295.TWO",
    "name": "生合",
    "sector": "食品工業",
    "close": 47.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.17,
    "dog_ma200_bias": 0.05,
    "vr60": 1.98,
    "rs20": 0.97,
    "rs60": 0.91,
    "shares": 20202,
    "lots": 20,
    "odd_shares": 202,
    "ntd_at_risk": 39999.96,
    "position_cost": 961615.2,
    "constraint": "WEIGHT",
    "atr14": 0.99,
    "low_20d": 43.7,
    "ladder_minus1_pullback": 44.7,
    "ladder_4_base": 42.8,
    "ladder_5_euphoria": 61.9
  },
  {
    "symbol": "2924.TWO",
    "name": "宏太-KY",
    "sector": "居家生活",
    "close": 18.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.81,
    "dog_ma200_bias": 0.168,
    "vr60": 1.15,
    "rs20": 1.33,
    "rs60": 1.06,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 462500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.5,
    "ladder_minus1_pullback": 17.4,
    "ladder_4_base": 16.7,
    "ladder_5_euphoria": 24.1
  },
  {
    "symbol": "3083.TWO",
    "name": "網龍",
    "sector": "文化創意業",
    "close": 22.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.29,
    "cpr": 0.33,
    "dog_ma200_bias": 0.015,
    "vr60": 1.87,
    "rs20": 1.14,
    "rs60": 0.89,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 572500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.5,
    "ladder_minus1_pullback": 21.5,
    "ladder_4_base": 20.6,
    "ladder_5_euphoria": 29.8
  },
  {
    "symbol": "3531.TWO",
    "name": "先益",
    "sector": "光電業",
    "close": 21.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.14,
    "dog_ma200_bias": 0.039,
    "vr60": 1.96,
    "rs20": 0.94,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 532500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.2,
    "ladder_minus1_pullback": 20.0,
    "ladder_4_base": 19.2,
    "ladder_5_euphoria": 27.7
  },
  {
    "symbol": "4420.TWO",
    "name": "光明",
    "sector": "紡織纖維業",
    "close": 35.4,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.43,
    "dog_ma200_bias": -0.019,
    "vr60": 1.66,
    "rs20": 0.81,
    "rs60": 0.74,
    "shares": 21052,
    "lots": 21,
    "odd_shares": 52,
    "ntd_at_risk": 39998.8,
    "position_cost": 745240.8,
    "constraint": "WEIGHT",
    "atr14": 0.95,
    "low_20d": 33.7,
    "ladder_minus1_pullback": 33.3,
    "ladder_4_base": 31.9,
    "ladder_5_euphoria": 46.0
  },
  {
    "symbol": "7547.TWO",
    "name": "碩網",
    "sector": "數位雲端",
    "close": 58.5,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.16,
    "cpr": 0.05,
    "dog_ma200_bias": 0.105,
    "vr60": 1.49,
    "rs20": 0.97,
    "rs60": 1.19,
    "shares": 14285,
    "lots": 14,
    "odd_shares": 285,
    "ntd_at_risk": 39998.0,
    "position_cost": 835672.5,
    "constraint": "WEIGHT",
    "atr14": 1.4,
    "low_20d": 55.6,
    "ladder_minus1_pullback": 55.0,
    "ladder_4_base": 52.6,
    "ladder_5_euphoria": 76.0
  },
  {
    "symbol": "7767.TWO",
    "name": "仁大資訊",
    "sector": "資訊服務業",
    "close": 45.95,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.56,
    "cpr": 0.95,
    "dog_ma200_bias": 0.177,
    "vr60": 1.47,
    "rs20": 1.05,
    "rs60": 1.14,
    "shares": 14285,
    "lots": 14,
    "odd_shares": 285,
    "ntd_at_risk": 39998.0,
    "position_cost": 656395.75,
    "constraint": "WEIGHT",
    "atr14": 1.4,
    "low_20d": 42.2,
    "ladder_minus1_pullback": 43.2,
    "ladder_4_base": 41.4,
    "ladder_5_euphoria": 59.7
  },
  {
    "symbol": "7820.TWO",
    "name": "立盈",
    "sector": "綠能環保",
    "close": 101.0,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.95,
    "dog_ma200_bias": -0.101,
    "vr60": 0.66,
    "rs20": 0.65,
    "rs60": 0.63,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 2.97,
    "low_20d": 94.3,
    "ladder_minus1_pullback": 94.9,
    "ladder_4_base": 90.9,
    "ladder_5_euphoria": 131.3
  },
  {
    "symbol": "1453.TW",
    "name": "大將",
    "sector": "建材營造業",
    "close": 10.85,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.54,
    "cpr": 0.05,
    "dog_ma200_bias": 0.03,
    "vr60": 1.45,
    "rs20": 0.92,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 271250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.8,
    "ladder_minus1_pullback": 10.2,
    "ladder_4_base": 9.8,
    "ladder_5_euphoria": 14.1
  },
  {
    "symbol": "4190.TW",
    "name": "佐登-KY",
    "sector": "生技醫療業",
    "close": 24.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.43,
    "dog_ma200_bias": 0.068,
    "vr60": 1.93,
    "rs20": 0.87,
    "rs60": 1.0,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 605000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.9,
    "ladder_minus1_pullback": 22.7,
    "ladder_4_base": 21.8,
    "ladder_5_euphoria": 31.5
  },
  {
    "symbol": "6921.TW",
    "name": "嘉雨思-創",
    "sector": "半導體業",
    "close": 64.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.5,
    "dog_ma200_bias": 0.075,
    "vr60": 1.57,
    "rs20": 0.88,
    "rs60": 0.73,
    "shares": 12658,
    "lots": 12,
    "odd_shares": 658,
    "ntd_at_risk": 39999.28,
    "position_cost": 816441.0,
    "constraint": "WEIGHT",
    "atr14": 1.58,
    "low_20d": 61.8,
    "ladder_minus1_pullback": 60.6,
    "ladder_4_base": 58.1,
    "ladder_5_euphoria": 83.9
  },
  {
    "symbol": "2752.TWO",
    "name": "豆府",
    "sector": "觀光餐旅",
    "close": 178.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.13,
    "cpr": 0.05,
    "dog_ma200_bias": -0.012,
    "vr60": 1.86,
    "rs20": 1.13,
    "rs60": 0.76,
    "shares": 5970,
    "lots": 5,
    "odd_shares": 970,
    "ntd_at_risk": 39999.0,
    "position_cost": 1062660.0,
    "constraint": "WEIGHT",
    "atr14": 3.35,
    "low_20d": 170.2,
    "ladder_minus1_pullback": 167.3,
    "ladder_4_base": 160.2,
    "ladder_5_euphoria": 231.4
  },
  {
    "symbol": "2938.TWO",
    "name": "床的世界",
    "sector": "居家生活",
    "close": 17.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.67,
    "dog_ma200_bias": -0.014,
    "vr60": 1.87,
    "rs20": 0.97,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 448750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 17.0,
    "ladder_minus1_pullback": 16.9,
    "ladder_4_base": 16.2,
    "ladder_5_euphoria": 23.3
  },
  {
    "symbol": "4550.TWO",
    "name": "長佳",
    "sector": "電機機械業",
    "close": 24.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.42,
    "cpr": 0.05,
    "dog_ma200_bias": 0.067,
    "vr60": 2.07,
    "rs20": 0.92,
    "rs60": 0.88,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 600000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 22.1,
    "ladder_minus1_pullback": 22.6,
    "ladder_4_base": 21.6,
    "ladder_5_euphoria": 31.2
  },
  {
    "symbol": "4754.TWO",
    "name": "國碳科",
    "sector": "化學工業",
    "close": 37.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.21,
    "cpr": 0.95,
    "dog_ma200_bias": 0.053,
    "vr60": 1.63,
    "rs20": 0.96,
    "rs60": 1.05,
    "shares": 18348,
    "lots": 18,
    "odd_shares": 348,
    "ntd_at_risk": 39998.64,
    "position_cost": 684380.4,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 35.1,
    "ladder_minus1_pullback": 35.1,
    "ladder_4_base": 33.6,
    "ladder_5_euphoria": 48.5
  },
  {
    "symbol": "6692.TWO",
    "name": "進能服",
    "sector": "綠能環保",
    "close": 22.25,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.37,
    "dog_ma200_bias": 0.167,
    "vr60": 1.47,
    "rs20": 1.11,
    "rs60": 1.15,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 556250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 20.1,
    "ladder_minus1_pullback": 20.9,
    "ladder_4_base": 20.0,
    "ladder_5_euphoria": 28.9
  },
  {
    "symbol": "6884.TWO",
    "name": "海柏特",
    "sector": "資訊服務業",
    "close": 32.5,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.95,
    "dog_ma200_bias": -0.116,
    "vr60": 0.99,
    "rs20": 0.49,
    "rs60": 0.44,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 406250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.4,
    "ladder_minus1_pullback": 30.5,
    "ladder_4_base": 29.2,
    "ladder_5_euphoria": 42.2
  },
  {
    "symbol": "6899.TWO",
    "name": "創為精密",
    "sector": "光電業",
    "close": 48.75,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.73,
    "cpr": 0.2,
    "dog_ma200_bias": -0.056,
    "vr60": 1.97,
    "rs20": 0.73,
    "rs60": 0.74,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.41,
    "low_20d": 46.8,
    "ladder_minus1_pullback": 45.8,
    "ladder_4_base": 43.9,
    "ladder_5_euphoria": 63.4
  },
  {
    "symbol": "6916.TW",
    "name": "華凌",
    "sector": "光電業",
    "close": 19.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.49,
    "cpr": 0.57,
    "dog_ma200_bias": 0.033,
    "vr60": 1.75,
    "rs20": 0.99,
    "rs60": 1.04,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 480000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.0,
    "ladder_minus1_pullback": 18.0,
    "ladder_4_base": 17.3,
    "ladder_5_euphoria": 25.0
  },
  {
    "symbol": "6918.TW",
    "name": "愛派司",
    "sector": "生技醫療業",
    "close": 74.8,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.81,
    "cpr": 0.8,
    "dog_ma200_bias": 0.141,
    "vr60": 1.58,
    "rs20": 1.16,
    "rs60": 0.99,
    "shares": 7692,
    "lots": 7,
    "odd_shares": 692,
    "ntd_at_risk": 39998.4,
    "position_cost": 575361.6,
    "constraint": "WEIGHT",
    "atr14": 2.6,
    "low_20d": 71.1,
    "ladder_minus1_pullback": 70.3,
    "ladder_4_base": 67.3,
    "ladder_5_euphoria": 97.2
  },
  {
    "symbol": "9929.TW",
    "name": "秋雨",
    "sector": "其他業",
    "close": 11.1,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.87,
    "cpr": 0.5,
    "dog_ma200_bias": -0.012,
    "vr60": 1.96,
    "rs20": 0.96,
    "rs60": 1.03,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 277500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.3,
    "ladder_minus1_pullback": 10.4,
    "ladder_4_base": 10.0,
    "ladder_5_euphoria": 14.4
  },
  {
    "symbol": "1796.TWO",
    "name": "金穎生技",
    "sector": "食品工業",
    "close": 29.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.38,
    "dog_ma200_bias": 0.022,
    "vr60": 1.54,
    "rs20": 0.9,
    "rs60": 0.74,
    "shares": 20618,
    "lots": 20,
    "odd_shares": 618,
    "ntd_at_risk": 39998.92,
    "position_cost": 604107.4,
    "constraint": "WEIGHT",
    "atr14": 0.97,
    "low_20d": 26.9,
    "ladder_minus1_pullback": 27.5,
    "ladder_4_base": 26.4,
    "ladder_5_euphoria": 38.1
  },
  {
    "symbol": "3073.TWO",
    "name": "天方能源",
    "sector": "綠能環保",
    "close": 21.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.67,
    "cpr": 0.7,
    "dog_ma200_bias": 0.071,
    "vr60": 1.42,
    "rs20": 0.97,
    "rs60": 0.97,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 531250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.6,
    "ladder_minus1_pullback": 20.0,
    "ladder_4_base": 19.1,
    "ladder_5_euphoria": 27.6
  },
  {
    "symbol": "4538.TWO",
    "name": "大詠城",
    "sector": "電機機械業",
    "close": 17.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.95,
    "dog_ma200_bias": -0.008,
    "vr60": 1.47,
    "rs20": 0.87,
    "rs60": 0.77,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 437500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.4,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.8,
    "ladder_5_euphoria": 22.8
  },
  {
    "symbol": "5604.TWO",
    "name": "中連",
    "sector": "其他業",
    "close": 31.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.33,
    "dog_ma200_bias": 0.054,
    "vr60": 1.71,
    "rs20": 0.84,
    "rs60": 0.81,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 786250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 28.6,
    "ladder_minus1_pullback": 29.6,
    "ladder_4_base": 28.3,
    "ladder_5_euphoria": 40.9
  },
  {
    "symbol": "6752.TWO",
    "name": "叡揚",
    "sector": "資訊服務業",
    "close": 95.2,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.17,
    "dog_ma200_bias": -0.069,
    "vr60": 0.83,
    "rs20": 0.59,
    "rs60": 0.36,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.83,
    "low_20d": 89.5,
    "ladder_minus1_pullback": 89.5,
    "ladder_4_base": 85.7,
    "ladder_5_euphoria": 123.8
  },
  {
    "symbol": "6843.TWO",
    "name": "進典",
    "sector": "電機機械業",
    "close": 37.45,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.52,
    "cpr": 0.95,
    "dog_ma200_bias": 0.026,
    "vr60": 1.76,
    "rs20": 0.95,
    "rs60": 0.82,
    "shares": 18018,
    "lots": 18,
    "odd_shares": 18,
    "ntd_at_risk": 39999.96,
    "position_cost": 674774.1,
    "constraint": "WEIGHT",
    "atr14": 1.11,
    "low_20d": 34.8,
    "ladder_minus1_pullback": 35.2,
    "ladder_4_base": 33.7,
    "ladder_5_euphoria": 48.7
  },
  {
    "symbol": "7770.TWO",
    "name": "君曜",
    "sector": "半導體業",
    "close": 38.65,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.59,
    "cpr": 0.3,
    "dog_ma200_bias": 0.303,
    "vr60": 1.93,
    "rs20": 1.27,
    "rs60": 1.1,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.27,
    "low_20d": 34.8,
    "ladder_minus1_pullback": 36.3,
    "ladder_4_base": 34.8,
    "ladder_5_euphoria": 50.2
  },
  {
    "symbol": "8291.TWO",
    "name": "尚茂",
    "sector": "電子零組件業",
    "close": 23.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.05,
    "dog_ma200_bias": -0.001,
    "vr60": 1.52,
    "rs20": 0.79,
    "rs60": 0.87,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 578750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.6,
    "ladder_minus1_pullback": 21.8,
    "ladder_4_base": 20.8,
    "ladder_5_euphoria": 30.1
  },
  {
    "symbol": "8401.TWO",
    "name": "白紗科",
    "sector": "其他業",
    "close": 22.7,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.25,
    "dog_ma200_bias": -0.012,
    "vr60": 1.66,
    "rs20": 0.81,
    "rs60": 0.74,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 567500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.2,
    "ladder_minus1_pullback": 21.3,
    "ladder_4_base": 20.4,
    "ladder_5_euphoria": 29.5
  },
  {
    "symbol": "1454.TW",
    "name": "台富",
    "sector": "紡織纖維業",
    "close": 12.85,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.05,
    "dog_ma200_bias": -0.132,
    "vr60": 0.65,
    "rs20": 0.53,
    "rs60": 0.43,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 11.9,
    "ladder_minus1_pullback": 12.1,
    "ladder_4_base": 11.6,
    "ladder_5_euphoria": 16.7
  },
  {
    "symbol": "2496.TW",
    "name": "卓越",
    "sector": "其他業",
    "close": 54.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.33,
    "dog_ma200_bias": 0.02,
    "vr60": 1.47,
    "rs20": 0.92,
    "rs60": 0.76,
    "shares": 22988,
    "lots": 22,
    "odd_shares": 988,
    "ntd_at_risk": 39999.12,
    "position_cost": 1255144.8,
    "constraint": "WEIGHT",
    "atr14": 0.87,
    "low_20d": 51.3,
    "ladder_minus1_pullback": 51.3,
    "ladder_4_base": 49.1,
    "ladder_5_euphoria": 71.0
  },
  {
    "symbol": "8466.TW",
    "name": "美吉吉-KY",
    "sector": "其他業",
    "close": 14.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.48,
    "cpr": 0.05,
    "dog_ma200_bias": 0.061,
    "vr60": 1.3,
    "rs20": 0.93,
    "rs60": 0.99,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 373750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.6,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.4
  },
  {
    "symbol": "1525.TW",
    "name": "江申",
    "sector": "汽車工業",
    "close": 62.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.83,
    "cpr": 0.95,
    "dog_ma200_bias": 0.079,
    "vr60": 1.26,
    "rs20": 1.12,
    "rs60": 1.04,
    "shares": 9803,
    "lots": 9,
    "odd_shares": 803,
    "ntd_at_risk": 39996.24,
    "position_cost": 613667.8,
    "constraint": "WEIGHT",
    "atr14": 2.04,
    "low_20d": 56.6,
    "ladder_minus1_pullback": 58.8,
    "ladder_4_base": 56.3,
    "ladder_5_euphoria": 81.4
  },
  {
    "symbol": "4440.TW",
    "name": "宜新實業",
    "sector": "紡織纖維業",
    "close": 17.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.35,
    "cpr": 0.05,
    "dog_ma200_bias": 0.067,
    "vr60": 1.38,
    "rs20": 0.83,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 437500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 16.6,
    "ladder_minus1_pullback": 16.4,
    "ladder_4_base": 15.8,
    "ladder_5_euphoria": 22.8
  },
  {
    "symbol": "5223.TWO",
    "name": "安力-KY",
    "sector": "電腦及週邊設備業",
    "close": 22.8,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "AGGRESSIVE_SELL",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.34,
    "cpr": 0.47,
    "dog_ma200_bias": -0.041,
    "vr60": 1.97,
    "rs20": 0.72,
    "rs60": 0.51,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 21.3,
    "ladder_minus1_pullback": 21.4,
    "ladder_4_base": 20.5,
    "ladder_5_euphoria": 29.6
  },
  {
    "symbol": "6730.TWO",
    "name": "常廣",
    "sector": "生技醫療業",
    "close": 31.9,
    "phase": "A3",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "OVERHEATING_ALERT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.95,
    "dog_ma200_bias": 0.276,
    "vr60": 2.27,
    "rs20": 1.24,
    "rs60": 1.25,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.89,
    "low_20d": 30.5,
    "ladder_minus1_pullback": 30.0,
    "ladder_4_base": 28.7,
    "ladder_5_euphoria": 41.5
  },
  {
    "symbol": "7819.TWO",
    "name": "精誠金融",
    "sector": "資訊服務業",
    "close": 32.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.31,
    "cpr": 0.29,
    "dog_ma200_bias": -0.136,
    "vr60": 0.97,
    "rs20": 0.33,
    "rs60": 0.46,
    "shares": 9174,
    "lots": 9,
    "odd_shares": 174,
    "ntd_at_risk": 19999.32,
    "position_cost": 301824.6,
    "constraint": "WEIGHT",
    "atr14": 1.09,
    "low_20d": 31.1,
    "ladder_minus1_pullback": 30.9,
    "ladder_4_base": 29.6,
    "ladder_5_euphoria": 42.8
  },
  {
    "symbol": "8424.TWO",
    "name": "惠普",
    "sector": "建材營造業",
    "close": 68.8,
    "phase": "B1",
    "macro_phase": "A2",
    "resonance_signal": "CAUTION",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "BREAKDOWN_WARNING",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.86,
    "cpr": 0.95,
    "dog_ma200_bias": -0.03,
    "vr60": 2.13,
    "rs20": 0.7,
    "rs60": 0.59,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 1.76,
    "low_20d": 65.9,
    "ladder_minus1_pullback": 64.7,
    "ladder_4_base": 61.9,
    "ladder_5_euphoria": 89.4
  },
  {
    "symbol": "8433.TWO",
    "name": "弘帆",
    "sector": "居家生活",
    "close": 51.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.44,
    "cpr": 0.95,
    "dog_ma200_bias": -0.009,
    "vr60": 1.22,
    "rs20": 0.81,
    "rs60": 0.88,
    "shares": 16129,
    "lots": 16,
    "odd_shares": 129,
    "ntd_at_risk": 39999.92,
    "position_cost": 837095.1,
    "constraint": "WEIGHT",
    "atr14": 1.24,
    "low_20d": 48.6,
    "ladder_minus1_pullback": 48.8,
    "ladder_4_base": 46.7,
    "ladder_5_euphoria": 67.5
  },
  {
    "symbol": "8443.TW",
    "name": "阿瘦",
    "sector": "貿易百貨業",
    "close": 11.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.32,
    "cpr": 0.95,
    "dog_ma200_bias": 0.057,
    "vr60": 1.41,
    "rs20": 1.02,
    "rs60": 0.82,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 278750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.2,
    "ladder_minus1_pullback": 10.5,
    "ladder_4_base": 10.0,
    "ladder_5_euphoria": 14.5
  },
  {
    "symbol": "6796.TW",
    "name": "晉弘",
    "sector": "生技醫療業",
    "close": 54.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.43,
    "cpr": 0.33,
    "dog_ma200_bias": 0.078,
    "vr60": 1.86,
    "rs20": 0.92,
    "rs60": 0.8,
    "shares": 11695,
    "lots": 11,
    "odd_shares": 695,
    "ntd_at_risk": 39996.9,
    "position_cost": 638547.0,
    "constraint": "WEIGHT",
    "atr14": 1.71,
    "low_20d": 50.6,
    "ladder_minus1_pullback": 51.3,
    "ladder_4_base": 49.1,
    "ladder_5_euphoria": 71.0
  },
  {
    "symbol": "1259.TWO",
    "name": "安心",
    "sector": "觀光餐旅",
    "close": 64.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.95,
    "dog_ma200_bias": 0.029,
    "vr60": 1.88,
    "rs20": 0.85,
    "rs60": 0.75,
    "shares": 12345,
    "lots": 12,
    "odd_shares": 345,
    "ntd_at_risk": 39997.8,
    "position_cost": 799956.0,
    "constraint": "WEIGHT",
    "atr14": 1.62,
    "low_20d": 58.5,
    "ladder_minus1_pullback": 60.9,
    "ladder_4_base": 58.3,
    "ladder_5_euphoria": 84.2
  },
  {
    "symbol": "4139.TWO",
    "name": "馬光-KY",
    "sector": "生技醫療業",
    "close": 43.95,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.58,
    "cpr": 0.95,
    "dog_ma200_bias": 0.031,
    "vr60": 1.42,
    "rs20": 1.06,
    "rs60": 1.0,
    "shares": 16393,
    "lots": 16,
    "odd_shares": 393,
    "ntd_at_risk": 39998.92,
    "position_cost": 720472.35,
    "constraint": "WEIGHT",
    "atr14": 1.22,
    "low_20d": 41.4,
    "ladder_minus1_pullback": 41.3,
    "ladder_4_base": 39.6,
    "ladder_5_euphoria": 57.1
  },
  {
    "symbol": "5704.TWO",
    "name": "老爺知",
    "sector": "觀光餐旅",
    "close": 22.15,
    "phase": "B2",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.27,
    "cpr": 0.05,
    "dog_ma200_bias": -0.061,
    "vr60": 0.69,
    "rs20": 0.59,
    "rs60": 0.42,
    "shares": 0,
    "lots": 0,
    "odd_shares": 0,
    "ntd_at_risk": 0.0,
    "position_cost": 0.0,
    "constraint": "ZERO_MULTIPLIER",
    "atr14": 0.8,
    "low_20d": 19.9,
    "ladder_minus1_pullback": 20.8,
    "ladder_4_base": 19.9,
    "ladder_5_euphoria": 28.8
  },
  {
    "symbol": "6846.TWO",
    "name": "綠茵",
    "sector": "食品工業",
    "close": 57.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.63,
    "dog_ma200_bias": 0.145,
    "vr60": 1.54,
    "rs20": 1.23,
    "rs60": 1.1,
    "shares": 12269,
    "lots": 12,
    "odd_shares": 269,
    "ntd_at_risk": 39996.94,
    "position_cost": 706694.4,
    "constraint": "WEIGHT",
    "atr14": 1.63,
    "low_20d": 54.3,
    "ladder_minus1_pullback": 54.1,
    "ladder_4_base": 51.8,
    "ladder_5_euphoria": 74.9
  },
  {
    "symbol": "6874.TWO",
    "name": "倍力",
    "sector": "資訊服務業",
    "close": 69.0,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.55,
    "cpr": 0.05,
    "dog_ma200_bias": 0.082,
    "vr60": 1.65,
    "rs20": 1.19,
    "rs60": 1.15,
    "shares": 14705,
    "lots": 14,
    "odd_shares": 705,
    "ntd_at_risk": 39997.6,
    "position_cost": 1014645.0,
    "constraint": "WEIGHT",
    "atr14": 1.36,
    "low_20d": 62.1,
    "ladder_minus1_pullback": 64.9,
    "ladder_4_base": 62.1,
    "ladder_5_euphoria": 89.7
  },
  {
    "symbol": "1475.TW",
    "name": "業旺",
    "sector": "紡織纖維業",
    "close": 25.6,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.26,
    "cpr": 0.05,
    "dog_ma200_bias": 0.088,
    "vr60": 1.13,
    "rs20": 0.97,
    "rs60": 1.3,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 640000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.7,
    "ladder_minus1_pullback": 24.1,
    "ladder_4_base": 23.0,
    "ladder_5_euphoria": 33.3
  },
  {
    "symbol": "1443.TW",
    "name": "立益物流",
    "sector": "其他業",
    "close": 22.55,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.62,
    "cpr": 0.4,
    "dog_ma200_bias": 0.073,
    "vr60": 1.58,
    "rs20": 1.0,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 563750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 21.5,
    "ladder_minus1_pullback": 21.2,
    "ladder_4_base": 20.3,
    "ladder_5_euphoria": 29.3
  },
  {
    "symbol": "1441.TW",
    "name": "大東",
    "sector": "紡織纖維業",
    "close": 9.62,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.05,
    "dog_ma200_bias": -0.015,
    "vr60": 1.57,
    "rs20": 0.87,
    "rs60": 0.92,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 240500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.2,
    "ladder_minus1_pullback": 9.0,
    "ladder_4_base": 8.7,
    "ladder_5_euphoria": 12.5
  },
  {
    "symbol": "8488.TW",
    "name": "吉源-KY",
    "sector": "其他業",
    "close": 9.55,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.63,
    "cpr": 0.45,
    "dog_ma200_bias": -0.238,
    "vr60": 0.8,
    "rs20": 0.39,
    "rs60": 0.37,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 119375.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 9.0,
    "ladder_minus1_pullback": 9.0,
    "ladder_4_base": 8.6,
    "ladder_5_euphoria": 12.4
  },
  {
    "symbol": "2754.TWO",
    "name": "亞洲藏壽司",
    "sector": "觀光餐旅",
    "close": 66.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.82,
    "cpr": 0.67,
    "dog_ma200_bias": 0.01,
    "vr60": 1.44,
    "rs20": 0.86,
    "rs60": 0.82,
    "shares": 10526,
    "lots": 10,
    "odd_shares": 526,
    "ntd_at_risk": 39998.8,
    "position_cost": 703136.8,
    "constraint": "WEIGHT",
    "atr14": 1.9,
    "low_20d": 62.5,
    "ladder_minus1_pullback": 62.8,
    "ladder_4_base": 60.1,
    "ladder_5_euphoria": 86.8
  },
  {
    "symbol": "3232.TWO",
    "name": "昱捷",
    "sector": "電子通路業",
    "close": 20.0,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.18,
    "cpr": 0.95,
    "dog_ma200_bias": 0.022,
    "vr60": 1.49,
    "rs20": 0.77,
    "rs60": 0.71,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 500000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 19.0,
    "ladder_minus1_pullback": 18.8,
    "ladder_4_base": 18.0,
    "ladder_5_euphoria": 26.0
  },
  {
    "symbol": "6971.TWO",
    "name": "惠民實業",
    "sector": "綠能環保",
    "close": 24.6,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.53,
    "cpr": 0.56,
    "dog_ma200_bias": -0.015,
    "vr60": 1.87,
    "rs20": 0.83,
    "rs60": 0.87,
    "shares": 24096,
    "lots": 24,
    "odd_shares": 96,
    "ntd_at_risk": 39999.36,
    "position_cost": 592761.6,
    "constraint": "WEIGHT",
    "atr14": 0.83,
    "low_20d": 23.2,
    "ladder_minus1_pullback": 23.1,
    "ladder_4_base": 22.1,
    "ladder_5_euphoria": 32.0
  },
  {
    "symbol": "6952.TW",
    "name": "大武山",
    "sector": "其他業",
    "close": 39.3,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.89,
    "cpr": 0.84,
    "dog_ma200_bias": 0.071,
    "vr60": 1.29,
    "rs20": 0.82,
    "rs60": 1.03,
    "shares": 19607,
    "lots": 19,
    "odd_shares": 607,
    "ntd_at_risk": 39998.28,
    "position_cost": 770555.1,
    "constraint": "WEIGHT",
    "atr14": 1.02,
    "low_20d": 37.6,
    "ladder_minus1_pullback": 36.9,
    "ladder_4_base": 35.4,
    "ladder_5_euphoria": 51.1
  },
  {
    "symbol": "3150.TW",
    "name": "鈺寶-創",
    "sector": "半導體業",
    "close": 15.05,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.1,
    "cpr": 0.6,
    "dog_ma200_bias": 0.016,
    "vr60": 1.47,
    "rs20": 0.79,
    "rs60": 0.7,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 376250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.7,
    "ladder_minus1_pullback": 14.1,
    "ladder_4_base": 13.5,
    "ladder_5_euphoria": 19.6
  },
  {
    "symbol": "1294.TWO",
    "name": "漢田生技",
    "sector": "食品工業",
    "close": 49.35,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.74,
    "cpr": 0.33,
    "dog_ma200_bias": -0.181,
    "vr60": 1.04,
    "rs20": 0.33,
    "rs60": 0.45,
    "shares": 10204,
    "lots": 10,
    "odd_shares": 204,
    "ntd_at_risk": 19999.84,
    "position_cost": 503567.4,
    "constraint": "WEIGHT",
    "atr14": 0.98,
    "low_20d": 45.1,
    "ladder_minus1_pullback": 46.4,
    "ladder_4_base": 44.4,
    "ladder_5_euphoria": 64.2
  },
  {
    "symbol": "4153.TWO",
    "name": "鈺緯",
    "sector": "生技醫療業",
    "close": 30.55,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "CONTRARIAN_BUY",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.19,
    "cpr": 0.05,
    "dog_ma200_bias": -0.14,
    "vr60": 0.89,
    "rs20": 0.35,
    "rs60": 0.42,
    "shares": 9615,
    "lots": 9,
    "odd_shares": 615,
    "ntd_at_risk": 19999.2,
    "position_cost": 293738.25,
    "constraint": "WEIGHT",
    "atr14": 1.04,
    "low_20d": 27.6,
    "ladder_minus1_pullback": 28.7,
    "ladder_4_base": 27.5,
    "ladder_5_euphoria": 39.7
  },
  {
    "symbol": "4402.TWO",
    "name": "郡都開發",
    "sector": "紡織纖維業",
    "close": 12.65,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.4,
    "dog_ma200_bias": 0.018,
    "vr60": 2.0,
    "rs20": 0.8,
    "rs60": 0.96,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 316250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 12.1,
    "ladder_minus1_pullback": 11.9,
    "ladder_4_base": 11.4,
    "ladder_5_euphoria": 16.4
  },
  {
    "symbol": "4528.TWO",
    "name": "江興鍛",
    "sector": "電機機械業",
    "close": 14.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.2,
    "cpr": 0.05,
    "dog_ma200_bias": -0.008,
    "vr60": 1.73,
    "rs20": 1.11,
    "rs60": 0.93,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 370000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.8,
    "ladder_minus1_pullback": 13.9,
    "ladder_4_base": 13.3,
    "ladder_5_euphoria": 19.2
  },
  {
    "symbol": "4806.TWO",
    "name": "桂田文創",
    "sector": "文化創意業",
    "close": 10.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.17,
    "cpr": 0.05,
    "dog_ma200_bias": -0.001,
    "vr60": 1.83,
    "rs20": 1.12,
    "rs60": 0.73,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 270000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.2,
    "ladder_minus1_pullback": 10.2,
    "ladder_4_base": 9.7,
    "ladder_5_euphoria": 14.0
  },
  {
    "symbol": "5211.TWO",
    "name": "蒙恬",
    "sector": "資訊服務業",
    "close": 20.15,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.15,
    "dog_ma200_bias": 0.035,
    "vr60": 1.51,
    "rs20": 1.04,
    "rs60": 1.05,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 503750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 18.9,
    "ladder_minus1_pullback": 18.9,
    "ladder_4_base": 18.1,
    "ladder_5_euphoria": 26.2
  },
  {
    "symbol": "6124.TWO",
    "name": "業強",
    "sector": "電子零組件業",
    "close": 26.35,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.68,
    "cpr": 0.63,
    "dog_ma200_bias": 0.084,
    "vr60": 1.48,
    "rs20": 0.97,
    "rs60": 0.98,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 658750.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.8,
    "ladder_minus1_pullback": 24.8,
    "ladder_4_base": 23.7,
    "ladder_5_euphoria": 34.3
  },
  {
    "symbol": "6508.TWO",
    "name": "惠光",
    "sector": "農業科技業",
    "close": 26.7,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.88,
    "cpr": 0.95,
    "dog_ma200_bias": 0.126,
    "vr60": 1.2,
    "rs20": 1.3,
    "rs60": 1.24,
    "shares": 22471,
    "lots": 22,
    "odd_shares": 471,
    "ntd_at_risk": 39998.38,
    "position_cost": 599975.7,
    "constraint": "WEIGHT",
    "atr14": 0.89,
    "low_20d": 24.6,
    "ladder_minus1_pullback": 25.1,
    "ladder_4_base": 24.0,
    "ladder_5_euphoria": 34.7
  },
  {
    "symbol": "6593.TWO",
    "name": "台灣銘板",
    "sector": "資訊服務業",
    "close": 31.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.23,
    "cpr": 0.05,
    "dog_ma200_bias": 0.071,
    "vr60": 2.08,
    "rs20": 1.11,
    "rs60": 0.86,
    "shares": 20833,
    "lots": 20,
    "odd_shares": 833,
    "ntd_at_risk": 39999.36,
    "position_cost": 662489.4,
    "constraint": "WEIGHT",
    "atr14": 0.96,
    "low_20d": 28.6,
    "ladder_minus1_pullback": 29.9,
    "ladder_4_base": 28.6,
    "ladder_5_euphoria": 41.3
  },
  {
    "symbol": "8067.TWO",
    "name": "志旭",
    "sector": "電子通路業",
    "close": 11.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.65,
    "cpr": 0.5,
    "dog_ma200_bias": 0.146,
    "vr60": 1.6,
    "rs20": 0.98,
    "rs60": 1.07,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 277500.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 10.3,
    "ladder_minus1_pullback": 10.4,
    "ladder_4_base": 10.0,
    "ladder_5_euphoria": 14.4
  },
  {
    "symbol": "6936.TW",
    "name": "永鴻生技",
    "sector": "生技醫療業",
    "close": 32.25,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.71,
    "cpr": 0.95,
    "dog_ma200_bias": 0.073,
    "vr60": 1.65,
    "rs20": 0.76,
    "rs60": 0.91,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 806250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 29.0,
    "ladder_minus1_pullback": 30.3,
    "ladder_4_base": 29.0,
    "ladder_5_euphoria": 41.9
  },
  {
    "symbol": "1470.TW",
    "name": "大統新創",
    "sector": "紡織纖維業",
    "close": 24.8,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.41,
    "cpr": 0.4,
    "dog_ma200_bias": 0.05,
    "vr60": 1.32,
    "rs20": 0.77,
    "rs60": 0.9,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 620000.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 23.3,
    "ladder_minus1_pullback": 23.3,
    "ladder_4_base": 22.3,
    "ladder_5_euphoria": 32.2
  },
  {
    "symbol": "1233.TW",
    "name": "天仁",
    "sector": "食品工業",
    "close": 28.2,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.51,
    "cpr": 0.95,
    "dog_ma200_bias": 0.059,
    "vr60": 1.82,
    "rs20": 1.05,
    "rs60": 0.84,
    "shares": 23529,
    "lots": 23,
    "odd_shares": 529,
    "ntd_at_risk": 39999.3,
    "position_cost": 663517.8,
    "constraint": "WEIGHT",
    "atr14": 0.85,
    "low_20d": 26.9,
    "ladder_minus1_pullback": 26.5,
    "ladder_4_base": 25.4,
    "ladder_5_euphoria": 36.7
  },
  {
    "symbol": "6771.TW",
    "name": "平和環保-創",
    "sector": "綠能環保",
    "close": 40.9,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.25,
    "cpr": 0.05,
    "dog_ma200_bias": 0.048,
    "vr60": 1.98,
    "rs20": 1.14,
    "rs60": 0.76,
    "shares": 15625,
    "lots": 15,
    "odd_shares": 625,
    "ntd_at_risk": 40000.0,
    "position_cost": 639062.5,
    "constraint": "WEIGHT",
    "atr14": 1.28,
    "low_20d": 38.7,
    "ladder_minus1_pullback": 38.4,
    "ladder_4_base": 36.8,
    "ladder_5_euphoria": 53.2
  },
  {
    "symbol": "2114.TW",
    "name": "鑫永銓",
    "sector": "橡膠工業",
    "close": 90.1,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.7,
    "cpr": 0.95,
    "dog_ma200_bias": 0.15,
    "vr60": 1.28,
    "rs20": 1.26,
    "rs60": 1.06,
    "shares": 8000,
    "lots": 8,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 720800.0,
    "constraint": "WEIGHT",
    "atr14": 2.5,
    "low_20d": 82.3,
    "ladder_minus1_pullback": 84.7,
    "ladder_4_base": 81.1,
    "ladder_5_euphoria": 117.1
  },
  {
    "symbol": "3118.TWO",
    "name": "進階",
    "sector": "生技醫療業",
    "close": 30.9,
    "phase": "B3",
    "macro_phase": "A2",
    "resonance_signal": "WATCHLIST",
    "matrix_multiplier": 0.5,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.28,
    "cpr": 0.05,
    "dog_ma200_bias": -0.231,
    "vr60": 0.73,
    "rs20": 0.26,
    "rs60": 0.26,
    "shares": 12500,
    "lots": 12,
    "odd_shares": 500,
    "ntd_at_risk": 20000.0,
    "position_cost": 386250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 27.8,
    "ladder_minus1_pullback": 29.0,
    "ladder_4_base": 27.8,
    "ladder_5_euphoria": 40.2
  },
  {
    "symbol": "3570.TWO",
    "name": "大塚",
    "sector": "資訊服務業",
    "close": 165.5,
    "phase": "A1",
    "macro_phase": "A2",
    "resonance_signal": "STRONG_BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": "IGNITION_BREAKOUT",
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.5,
    "cpr": 0.8,
    "dog_ma200_bias": 0.068,
    "vr60": 1.91,
    "rs20": 0.93,
    "rs60": 0.95,
    "shares": 4291,
    "lots": 4,
    "odd_shares": 291,
    "ntd_at_risk": 39992.12,
    "position_cost": 710160.5,
    "constraint": "WEIGHT",
    "atr14": 4.66,
    "low_20d": 149.8,
    "ladder_minus1_pullback": 155.6,
    "ladder_4_base": 149.0,
    "ladder_5_euphoria": 215.2
  },
  {
    "symbol": "5514.TWO",
    "name": "三豐",
    "sector": "建材營造業",
    "close": 14.85,
    "phase": "A2",
    "macro_phase": "A2",
    "resonance_signal": "BUY",
    "matrix_multiplier": 1.0,
    "macro_sizing_multiplier": 1.0,
    "migration_bucket": null,
    "is_disposition": false,
    "is_attention": false,
    "is_limit_locked": false,
    "ladder_position_pct": 0.61,
    "cpr": 0.95,
    "dog_ma200_bias": 0.123,
    "vr60": 1.23,
    "rs20": 1.04,
    "rs60": 1.18,
    "shares": 25000,
    "lots": 25,
    "odd_shares": 0,
    "ntd_at_risk": 40000.0,
    "position_cost": 371250.0,
    "constraint": "WEIGHT",
    "atr14": 0.8,
    "low_20d": 13.9,
    "ladder_minus1_pullback": 14.0,
    "ladder_4_base": 13.4,
    "ladder_5_euphoria": 19.3
  }
];
